import * as t from "react";
import { forwardRef as h } from "react";
const o = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 5h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m-5.5 1h-1a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3m1 9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Zm8.1-6a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9" })
), Lc = h(o), n = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 5h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m-7 4v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3m5 0v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1m5.6 0a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9M7 7v10a1 1 0 0 0 2 0V7a1 1 0 0 0-2 0" })
), Zc = h(n), w = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 9a1 1 0 0 0 2 0 1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2h-4v-2a1 1 0 0 1 1-1h1a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3m7-4h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2M7 7v10a1 1 0 0 0 2 0V7a1 1 0 0 0-2 0m14.6 2a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9" })
), Bc = h(w), v = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 5h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m-7 4a1 1 0 0 0 2 0 1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.5a1 1 0 0 0 0 2h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1 1 1 0 0 0-2 0 3 3 0 0 0 3 3h1a3 3 0 0 0 3-3v-1a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2V9a3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3M7 7v10a1 1 0 0 0 2 0V7a1 1 0 0 0-2 0m14.6 2a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9" })
), Fc = h(v), m = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 5h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m3.6 4a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9M7 7v10a1 1 0 0 0 2 0V7a1 1 0 0 0-2 0m4 2v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3v-1a3 3 0 0 0-3-3h-2V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3m4 4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-2Z" })
), Rc = h(m), c = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 7v2a1 1 0 0 0 2 0V8h2.78L14 16.8a1 1 0 0 0 .8 1.2h.2a1 1 0 0 0 1-.8l2-10a1 1 0 0 0-.21-.83A1 1 0 0 0 17 6h-5a1 1 0 0 0-1 1m7-2h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2M7 7v10a1 1 0 0 0 2 0V7a1 1 0 0 0-2 0m14.6 2a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9" })
), Uc = h(c), s = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 5h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2M7 7v10a1 1 0 0 0 2 0V7a1 1 0 0 0-2 0m14.6 2a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9M11 9v1a3 3 0 0 0 .78 2 3 3 0 0 0-.78 2v1a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3v-1a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2V9a3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3m5 6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Zm0-6v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1" })
), $c = h(s), g = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 18a1 1 0 0 0 1-1V7a1 1 0 0 0-2 0v10a1 1 0 0 0 1 1m1-13h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m3.6 4a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9M10 13h1a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3 1 1 0 0 0 2 0 1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2H9v-2a1 1 0 0 1 1-1" })
), yc = h(g), i = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 5h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m-2.5 4a3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3 1 1 0 0 0 2 0 1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H12a1 1 0 0 0 0 2h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1 1 1 0 0 0-2 0 3 3 0 0 0 3 3h1a3 3 0 0 0 3-3v-1a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2Zm6.1 0a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9" })
), kc = h(i), d = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 15.14a1.4 1.4 0 0 0 .17.44 6.3 6.3 0 0 0 1.39 2.08 6.7 6.7 0 0 0 2.09 1.4 6.2 6.2 0 0 0 2.54.52 6.3 6.3 0 0 0 2.55-.52 6.6 6.6 0 0 0 2.08-1.4 6.4 6.4 0 0 0 1.41-2.08 6.55 6.55 0 0 0 .46-2.58 6.8 6.8 0 0 0-.51-2.56 6.4 6.4 0 0 0-1.41-2.07 6.46 6.46 0 0 0-4.63-1.92 6.6 6.6 0 0 0-2.58.55 7 7 0 0 0-1.2.68 7 7 0 0 0-1.14.94V3.23h9.05c.22 0 .34-.21.34-.62S17.48 2 17.26 2H7.47a.37.37 0 0 0-.3.13.4.4 0 0 0-.12.29V10a.39.39 0 0 0 .17.3 1.1 1.1 0 0 0 .41.18.73.73 0 0 0 .43 0 1 1 0 0 0 .24-.11 1 1 0 0 0 .14-.17 7 7 0 0 1 .86-1 5.15 5.15 0 0 1 3.79-1.56 5.15 5.15 0 0 1 3.81 1.61A5.17 5.17 0 0 1 18.48 13a5.3 5.3 0 0 1-.41 2 5.36 5.36 0 0 1-2.9 3 5.4 5.4 0 0 1-2.06.4 5.1 5.1 0 0 1-2.7-.75V13a2.66 2.66 0 0 1 .71-1.79 2.53 2.53 0 0 1 2-.89 2.65 2.65 0 0 1 2 .79 2.55 2.55 0 0 1 .75 1.89 2.73 2.73 0 0 1-2.77 2.74h-.34l-.37-.07h-.15c-.21-.06-.37.1-.49.48s-.07.6.14.68a4.3 4.3 0 0 0 1.25.18 3.84 3.84 0 0 0 2.8-1.16A3.8 3.8 0 0 0 17.1 13a3.73 3.73 0 0 0-1.16-2.78 3.8 3.8 0 0 0-2.8-1.15 3.86 3.86 0 0 0-2.82 1.15 3.57 3.57 0 0 0-1.14 2.59v3.8a5.6 5.6 0 0 1-1.08-1.86c-.08-.21-.3-.25-.67-.13s-.55.29-.48.49Zm6.25-11a8.2 8.2 0 0 0-3.34.64.25.25 0 0 0-.23.22 1.3 1.3 0 0 0 .09.43c.14.35.3.48.5.41a8.1 8.1 0 0 1 2.93-.55 7.5 7.5 0 0 1 3.08.63 8.7 8.7 0 0 1 2.31 1.48.25.25 0 0 0 .18.08c.09 0 .24-.1.43-.29l.19-.19a.37.37 0 0 0 .06-.21.3.3 0 0 0-.1-.2 8.6 8.6 0 0 0-2.62-1.69 9 9 0 0 0-3.53-.76Zm-1.61 9.91a.46.46 0 0 0 .2.33.52.52 0 0 0 .35.18.24.24 0 0 0 .17-.06l.73-.73.7.68a.28.28 0 0 0 .21.11.58.58 0 0 0 .36-.19c.2-.21.23-.39.07-.55l-.7-.7.74-.74c.12-.12.08-.29-.13-.49s-.4-.27-.53-.14l-.73.72-.72-.74a.3.3 0 0 0-.15-.05.56.56 0 0 0-.34.2c-.23.22-.28.38-.16.5l.74.74-.74.72a.35.35 0 0 0-.12.21Zm7.93 4.57a1.2 1.2 0 0 0-.37-.25.28.28 0 0 0-.28.07l-.07.07a8 8 0 0 1-2.51 1.69 7.94 7.94 0 0 1-8.68-1.69A7.5 7.5 0 0 1 5.91 16a9.3 9.3 0 0 1-.51-1.77c0-.21-.25-.29-.63-.23s-.56.2-.53.4a8.5 8.5 0 0 0 .6 2.11 8.8 8.8 0 0 0 2 2.88 9 9 0 0 0 2.89 2 9.1 9.1 0 0 0 3.54.71 9.3 9.3 0 0 0 3.54-.71 9 9 0 0 0 2.89-2l.06-.06c.09-.22.02-.44-.24-.71Z" })
), bc = h(d), p = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 5h1v1a1 1 0 0 0 2 0V5h1a1 1 0 0 0 0-2h-1V2a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m-6.5 3h1a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3v-1a3 3 0 0 0-3-3h-2V9a1 1 0 0 1 1-1m1 5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-2Zm9.1-4a1 1 0 0 0-.78 1.18 9 9 0 1 1-7-7 1 1 0 1 0 .4-2A10.8 10.8 0 0 0 12 1a11 11 0 1 0 11 11 10.8 10.8 0 0 0-.22-2.2A1 1 0 0 0 21.6 9" })
), Tc = h(p), f = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2a1 1 0 0 0-1 1v3h-4V5a1 1 0 0 0-2 0v1h-2V5a1 1 0 0 0-2 0v1H8V5a1 1 0 0 0-2 0v1H4V3a1 1 0 0 0-2 0v16a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V3a1 1 0 0 0-1-1m-1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3h2v1a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1h4v1a1 1 0 0 0 2 0v-1h2Zm0-5h-2v-1a1 1 0 0 0-2 0v1h-4v-1a1 1 0 0 0-2 0v1H8v-1a1 1 0 0 0-2 0v1H4V8h2v1a1 1 0 0 0 2 0V8h2v1a1 1 0 0 0 2 0V8h2v1a1 1 0 0 0 2 0V8h4Z" })
), Pc = h(f), E = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 7a2 2 0 1 0-2-2 2 2 0 0 0 2 2m-3.3 11.4A4 4 0 1 1 9.05 12a1 1 0 1 0-.22-2 6 6 0 0 0 .67 12 6 6 0 0 0 4.8-2.4 1 1 0 0 0-1.6-1.2m6.8 1.6h-1v-5a1 1 0 0 0-1-1h-4.57l1.69-4.66v-.31a1 1 0 0 0 0-.18 1 1 0 0 0 0-.19 1.4 1.4 0 0 0-.09-.17.7.7 0 0 0-.11-.15.6.6 0 0 0-.15-.13s0-.06-.08-.08L9.71 5.55h-.12a1 1 0 0 0-.19-.06H9a.8.8 0 0 0-.2.07h-.11L6 7.13A1 1 0 0 0 6.48 9 1 1 0 0 0 7 8.87l2.23-1.3 3.24 1.88-1.89 5.21a1 1 0 0 0 0 .16.6.6 0 0 0 0 .18 3 3 0 0 0 .08.38l.11.15a.6.6 0 0 0 .11.16.7.7 0 0 0 .14.09 1.2 1.2 0 0 0 .19.12 1 1 0 0 0 .34.06h5v5a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2Z" })
), Dc = h(E), x = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.83 7.32a.2.2 0 0 0 0-.08 10 10 0 0 0-3.38-3.65A9.9 9.9 0 0 0 12 2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h.28a10 10 0 0 0 8.55-14.68M13 4.06a8 8 0 0 1 2.49.74L13 9.12Zm0 9.06 4.17-7.22a7.9 7.9 0 0 1 1.58 1.83L13 17.69Zm1.16 6.57L19.75 10a8.4 8.4 0 0 1 .25 2 7.94 7.94 0 0 1-5.84 7.69" })
), qc = h(x), A = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 7A7.74 7.74 0 1 0 7 17 7.74 7.74 0 1 0 17 7m-1.6 1.6a6 6 0 0 1 .11 1.14 6 6 0 0 1-.16 1.34l-2.44-2.42a6 6 0 0 1 1.34-.16 6 6 0 0 1 1.14.11Zm-.94 4.4A6 6 0 0 1 13 14.46L9.54 11A6 6 0 0 1 11 9.54Zm-8 1.46a5.75 5.75 0 1 1 8-8h-.25a7.76 7.76 0 0 0-7.71 7.79c0 .08.01.17.01.25Zm2.1.89a6 6 0 0 1-.11-1.14 6 6 0 0 1 .16-1.34l2.43 2.43a6 6 0 0 1-1.34.16 6 6 0 0 1-1.09-.07ZM14.25 20a5.77 5.77 0 0 1-4.75-2.51h.25a7.76 7.76 0 0 0 7.75-7.74V9.5A5.75 5.75 0 0 1 14.25 20" })
), Ic = h(A), M = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.83 7.32a10.1 10.1 0 0 0-3.44-3.73A10 10 0 1 0 12 22h.29a10 10 0 0 0 8.54-14.68M11 19.93a8 8 0 0 1 0-15.86Zm2-15.86a8 8 0 0 1 2.49.74L13 9.12Zm0 9 4.17-7.17a8.1 8.1 0 0 1 1.58 1.83L13 17.69Zm1.15 6.58L19.74 10a8.2 8.2 0 0 1 .26 2 8 8 0 0 1-5.85 7.7Z" })
), Wc = h(M), H = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m-1 17.93a8 8 0 0 1 0-15.86Zm2 0V4.07a8 8 0 0 1 0 15.86" })
), Gc = h(H), C = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.247 2.403a1 1 0 0 0-.83-.444H1.992a1 1 0 0 0-1 1v18.082a1 1 0 0 0 1.925.38L10.342 3.34a1 1 0 0 0-.095-.936m-7.255 13.57V3.96h4.933Zm19-14.014h-7.518a1 1 0 0 0-.921 1.388l7.517 17.85a1 1 0 0 0 .921.612 1 1 0 0 0 .198-.02 1 1 0 0 0 .803-.98V2.959a1 1 0 0 0-1-1m-1 13.899L15.98 3.959h5.012ZM12.949 9.52a1 1 0 0 0-.926-.646h-.01a1 1 0 0 0-.928.627l-3.059 7.631a1 1 0 0 0 .929 1.372h2.254l1.522 2.99a1 1 0 0 0 .892.547h2.612a1 1 0 0 0 .936-1.353Zm1.287 10.521-1.523-2.99a1 1 0 0 0-.89-.547h-1.39l1.553-3.875 2.802 7.412Z" })
), Oc = h(C), u = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.07 17.28h2.78l1.75 3.44h2.54L12 9.87ZM2 3v18L9.42 3Zm12.48 0L22 20.81V3Z" })
), Nc = h(u), V = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.83 13.45a1 1 0 0 0-1.66 0l-4 6a1 1 0 0 0 0 1A1 1 0 0 0 8 21h8a1 1 0 0 0 .88-.53 1 1 0 0 0-.05-1ZM9.87 19 12 15.8l2.13 3.2ZM19 3H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h.85a1 1 0 1 0 0-2H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-.85a1 1 0 0 0 0 2H19a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3" })
), Qc = h(V), S = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 11H3a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2m0 8H3a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2m4-14h7a1 1 0 0 0 0-2h-7a1 1 0 0 0 0 2m-4 2H3a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2m0 8H3a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2m0-12H7a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2m11 4h-7a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2m0 4h-7a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2m-4 8h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2m4-4h-7a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2" })
), Kc = h(S), L = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 8h14a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2m16 3H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-2 5H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" })
), jc = h(L), Z = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.92 11.62a1 1 0 0 0-.21-.33l-2.5-2.5a1 1 0 0 0-1.42 1.42l.8.79H16a1 1 0 0 0 0 2h2.59l-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.5-2.5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76M8 11H5.41l.8-.79a1 1 0 0 0-1.42-1.42l-2.5 2.5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2.5 2.5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.8-.79H8a1 1 0 0 0 0-2m4-4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1" })
), Jc = h(Z), B = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 15H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2M3 5h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m14 14H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m4-12H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0 4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), Yc = h(B), F = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m10.21 6.21.79-.8V8a1 1 0 0 0 2 0V5.41l.79.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.5-2.5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.5 2.5a1 1 0 0 0 1.42 1.42M16 11H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2m-2.21 6.79-.79.8V16a1 1 0 0 0-2 0v2.59l-.79-.8a1 1 0 0 0-1.42 1.42l2.5 2.5a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2.5-2.5a1 1 0 0 0-1.42-1.42" })
), Xc = h(F), R = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m4 2a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Zm14 4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-4 4H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2" })
), _c = h(R), U = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 10H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), zc = h(U), $ = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 5h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m12 14H3a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2m6-8H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0 8H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), as = h($), y = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m0 4h14a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-4 4H3a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" })
), ts = h(y), k = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 4h11a1 1 0 0 0 0-2H10a1 1 0 0 0 0 2m11 16H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-14H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0 10H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m0-6H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), es = h(k), b = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 5h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 14H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m0-8H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0 4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-8H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), ls = h(b), T = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 10H7a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2m0-8H7a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2m0 4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), rs = h(T), P = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 15h10a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m0-4h10a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m0-4h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 10H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-1.36-7.43a1 1 0 1 0-1.28 1.53l1.08.9-1.08.9a1 1 0 0 0-.13 1.41 1 1 0 0 0 .77.36 1 1 0 0 0 .64-.24l2-1.66a1 1 0 0 0 0-1.54Z" })
), hs = h(P), D = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M1.04 17.52q.1-.16.32-.02a21.3 21.3 0 0 0 10.88 2.9 21.5 21.5 0 0 0 7.74-1.46q.1-.04.29-.12t.27-.12a.356.356 0 0 1 .47.12q.17.24-.11.44-.36.26-.92.6a15 15 0 0 1-3.84 1.58A16.2 16.2 0 0 1 12 22a16 16 0 0 1-5.9-1.09 16.3 16.3 0 0 1-4.98-3.07.27.27 0 0 1-.12-.2.2.2 0 0 1 .04-.12m6.02-5.7a4.04 4.04 0 0 1 .68-2.36A4.2 4.2 0 0 1 9.6 7.98a10 10 0 0 1 2.66-.66q.54-.06 1.76-.16v-.34a3.56 3.56 0 0 0-.28-1.72 1.5 1.5 0 0 0-1.32-.6h-.16a2.2 2.2 0 0 0-1.14.42 1.64 1.64 0 0 0-.62 1 .51.51 0 0 1-.4.46L7.8 6.1q-.34-.08-.34-.36a.6.6 0 0 1 .02-.14 3.83 3.83 0 0 1 1.67-2.64A6.27 6.27 0 0 1 12.26 2h.5a5.05 5.05 0 0 1 3.56 1.18 4 4 0 0 1 .37.43 4 4 0 0 1 .27.41 2 2 0 0 1 .18.52q.08.34.12.47a3 3 0 0 1 .06.56q.02.43.02.51v4.84a2.9 2.9 0 0 0 .15.95 2.5 2.5 0 0 0 .29.62q.14.19.46.61a.6.6 0 0 1 .12.32.35.35 0 0 1-.16.28q-1.66 1.44-1.8 1.56a.56.56 0 0 1-.58.04q-.28-.24-.49-.46t-.3-.32a5 5 0 0 1-.29-.39q-.2-.29-.28-.39a4.9 4.9 0 0 1-2.2 1.52 6 6 0 0 1-1.68.2 3.5 3.5 0 0 1-2.53-.95 3.55 3.55 0 0 1-.99-2.69m3.44-.4a1.9 1.9 0 0 0 .39 1.25 1.3 1.3 0 0 0 1.05.47 1 1 0 0 0 .17-.02 1 1 0 0 1 .15-.02 2.03 2.03 0 0 0 1.3-1.08 3.1 3.1 0 0 0 .33-.83 4 4 0 0 0 .12-.73q.01-.28.01-.92v-.5a7.3 7.3 0 0 0-1.76.16 2.144 2.144 0 0 0-1.76 2.22m8.4 6.44a.6.6 0 0 1 .12-.16 3.1 3.1 0 0 1 .96-.46 6.5 6.5 0 0 1 1.48-.22 1.2 1.2 0 0 1 .38.02q.9.08 1.08.3a.66.66 0 0 1 .08.36v.14a4.6 4.6 0 0 1-.38 1.65 3.84 3.84 0 0 1-1.06 1.53.3.3 0 0 1-.18.08.2.2 0 0 1-.08-.02q-.12-.06-.06-.22a7.6 7.6 0 0 0 .74-2.42.5.5 0 0 0-.08-.32q-.2-.24-1.12-.24-.34 0-.8.04-.5.06-.92.12a.23.23 0 0 1-.16-.04.065.065 0 0 1-.02-.08.2.2 0 0 1 .02-.06" })
), os = h(D), q = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.5 9.5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m12.43 2.15-.06-.11a.6.6 0 0 0-.07-.14l-2.4-3.2A3 3 0 0 0 18 7h-2V6a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v11a1 1 0 0 0 1 1h1a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-.07-.35M6 19a1 1 0 1 1 1-1 1 1 0 0 1-1 1m8-3H8.22a3 3 0 0 0-4.44 0H3V6a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1Zm2-7h2a1 1 0 0 1 .8.4L20 11h-4Zm2 10a1 1 0 1 1 1-1 1 1 0 0 1-1 1m3-3h-.78a3 3 0 0 0-4.22-.22V13h5Z" })
), ns = h(q), I = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 7.29a1 1 0 0 0-1.42 0L14 13.59l-4.29-4.3a1 1 0 0 0-1.42 0l-6 6a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L9 11.41l4.29 4.3a1 1 0 0 0 1.42 0l7-7a1 1 0 0 0 0-1.42" })
), ws = h(I), W = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 12a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0-1-1m5-10a1 1 0 0 0-1 1v18a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1m10 14a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m-5-8a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1" })
), vs = h(W), G = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 13h-2a1 1 0 0 0 0 2h.91A6 6 0 0 1 13 19.91V11h1a1 1 0 0 0 0-2h-1V7.82a3 3 0 1 0-2 0V9h-1a1 1 0 0 0 0 2h1v8.91A6 6 0 0 1 6.09 15H7a1 1 0 0 0 0-2H5a1 1 0 0 0-1 1 8 8 0 0 0 16 0 1 1 0 0 0-1-1m-7-7a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), ms = h(G), O = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M2.992 9a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m18 0a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m-4.135-5.5a1 1 0 1 0-1.731-1l-.614 1.063a5.93 5.93 0 0 0-5.04 0L8.857 2.5a1 1 0 1 0-1.731 1l.692 1.198A5.98 5.98 0 0 0 5.992 9v8a1 1 0 0 0 1 1h2v3a1 1 0 0 0 2 0v-3h2v3a1 1 0 0 0 2 0v-3h2a1 1 0 0 0 1-1V9a5.98 5.98 0 0 0-1.827-4.302ZM15.992 16h-8v-5h8Zm-8-7a4 4 0 0 1 8 0Z" })
), cs = h(O), N = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 17.71a1 1 0 0 0 1.42 0 1.2 1.2 0 0 0 .21-.33.94.94 0 0 0 0-.76 1.2 1.2 0 0 0-.21-.33 1 1 0 0 0-1.42 0 1.2 1.2 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.33M8.66 4H16a1 1 0 0 1 1 1v7.34a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3H8.66a1 1 0 0 0 0 2m13.05 16.29-18-18a1 1 0 0 0-1.42 1.42L5 6.41V19a3 3 0 0 0 3 3h8a3 3 0 0 0 2.76-1.83l1.53 1.54a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M17 19a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8.41l10 10Z" })
), ss = h(N), Q = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m14.975 3.019.96-1.732a.193.193 0 0 0-.338-.187l-.97 1.75a6.54 6.54 0 0 0-5.253 0l-.97-1.75a.193.193 0 0 0-.34.187l.96 1.732a5.55 5.55 0 0 0-3.092 4.876h12.137a5.55 5.55 0 0 0-3.094-4.876M9.2 5.674a.507.507 0 1 1 .507-.506.507.507 0 0 1-.507.506m5.602 0a.507.507 0 1 1 .507-.506.507.507 0 0 1-.507.506M5.93 17.171A1.467 1.467 0 0 0 7.4 18.64h.973v3a1.36 1.36 0 1 0 2.721 0v-3h1.814v3a1.36 1.36 0 1 0 2.72 0v-3h.974a1.467 1.467 0 0 0 1.468-1.468V8.375H5.93Zm-1.867-9.03a1.36 1.36 0 0 0-1.36 1.361v5.669a1.36 1.36 0 1 0 2.72 0V9.502a1.36 1.36 0 0 0-1.36-1.36m15.872 0a1.36 1.36 0 0 0-1.36 1.361v5.669a1.36 1.36 0 1 0 2.72 0V9.502a1.36 1.36 0 0 0-1.36-1.36" })
), gs = h(Q), K = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 11.46a1 1 0 0 0 1.42 0l3-3A1 1 0 1 0 14.29 7L12 9.34 9.71 7a1 1 0 1 0-1.42 1.46Zm3 1.08L12 14.84l-2.29-2.3A1 1 0 0 0 8.29 14l3 3a1 1 0 0 0 1.42 0l3-3a1 1 0 0 0-1.42-1.42Z" })
), is = h(K), j = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.46 8.29a1 1 0 0 0-1.42 0l-3 3a1 1 0 0 0 0 1.42l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L9.16 12l2.3-2.29a1 1 0 0 0 0-1.42m3.2 3.71L17 9.71a1 1 0 0 0-1.42-1.42l-3 3a1 1 0 0 0 0 1.42l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), ds = h(j), J = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.46 8.29A1 1 0 1 0 7 9.71L9.34 12 7 14.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 0-1.42Zm8.5 3-3-3a1 1 0 0 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 .04-1.42Z" })
), ps = h(J), Y = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.71 12.54a1 1 0 0 0-1.42 0l-3 3A1 1 0 0 0 9.71 17L12 14.66 14.29 17a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm-3-1.08L12 9.16l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-3-3a1 1 0 0 0-1.42 0l-3 3a1 1 0 0 0 1.42 1.42" })
), fs = h(Y), X = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42" })
), Es = h(X), _ = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m8.5 12.8 5.7 5.6c.4.4 1 .4 1.4 0s.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3s-.5.1-.7.3l-5.7 5.6c-.4.5-.4 1.1 0 1.6q0-.15 0 0" })
), xs = h(_), z = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m11.29 12 3.54-3.54a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0l-4.24 4.24a1 1 0 0 0 0 1.42L13.41 17a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41Z" })
), As = h(z), a0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.54 11.29 9.88 5.64a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l4.95 5L8.46 17a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l5.66-5.65a1 1 0 0 0 0-1.47" })
), Ms = h(a0), t0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m14.83 11.29-4.24-4.24a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41L12.71 12l-3.54 3.54a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l4.24-4.24a1 1 0 0 0 0-1.42" })
), Hs = h(t0), e0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m17 13.41-4.29-4.24a1 1 0 0 0-1.42 0l-4.24 4.24a1 1 0 0 0 0 1.42 1 1 0 0 0 1.41 0L12 11.29l3.54 3.54a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 .05-1.42" })
), Cs = h(e0), l0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 11a1 1 0 0 0 .89-.55 1 1 0 0 0-.44-1.34l-2-1a1 1 0 1 0-.9 1.78l2 1A.93.93 0 0 0 10 11m2-9a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m-3.64-4.67a1 1 0 0 0-.13 1.4 1 1 0 0 0 1.41.13 3.76 3.76 0 0 1 4.72 0 1 1 0 0 0 .64.23 1 1 0 0 0 .64-1.76 5.81 5.81 0 0 0-7.28 0m7.19-7.22-2 1a1 1 0 0 0-.44 1.34A1 1 0 0 0 14 11a.93.93 0 0 0 .45-.11l2-1a1 1 0 0 0-.9-1.78" })
), us = h(l0), r0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 12h-3.09A7.23 7.23 0 0 0 17 7 5 5 0 0 0 7 7a7.23 7.23 0 0 0 2.09 5H6a1 1 0 0 0 0 2h5v7a1 1 0 0 0 2 0v-7h5a1 1 0 0 0 0-2m-6-.16c-.93-.62-3-2.26-3-4.84a3 3 0 0 1 6 0c0 2.58-2.07 4.23-3 4.84" })
), Vs = h(r0), h0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m14.66 13.56-4.19 1.5A1 1 0 0 0 10.8 17a1 1 0 0 0 .34-.06l4.2-1.5a1 1 0 1 0-.68-1.88m-4-5a1 1 0 0 0-1.41 0 1 1 0 0 1-1.42 0 1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42 3 3 0 0 0 4.24 0 1 1 0 0 0-.04-1.44Zm7 0a1 1 0 0 0-1.41 0 1 1 0 0 1-1.42 0 1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42 3 3 0 0 0 4.24 0 1 1 0 0 0-.04-1.44ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), Ss = h(h0), o0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m6 4a5 5 0 0 0-4.37 2.57 1 1 0 0 0 .37 1.36 1 1 0 0 0 .49.13 1 1 0 0 0 .87-.51A3 3 0 0 1 15 15a1 1 0 0 0 0-2m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), Ls = h(o0), n0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.504 15.744a3.39 3.39 0 0 1-2.054-3.127 3.5 3.5 0 0 1 1.687-2.947 1 1 0 0 0 .3-1.415 5.57 5.57 0 0 0-4.016-2.385 6.42 6.42 0 0 0 .965-3.977.984.984 0 0 0-1.033-.892 6.7 6.7 0 0 0-4.444 2.261 6.84 6.84 0 0 0-1.48 2.9 5.3 5.3 0 0 0-1.62-.278 5.93 5.93 0 0 0-4.99 3.008C1.93 12.169 3.086 17.08 5.13 20.037c.82 1.184 2.051 2.962 3.908 2.962q.056 0 .11-.002a4.7 4.7 0 0 0 1.793-.463 3.3 3.3 0 0 1 1.446-.354 3.05 3.05 0 0 1 1.357.338 4.75 4.75 0 0 0 1.962.456c1.913-.036 3.043-1.687 3.868-2.893a12 12 0 0 0 1.513-3.108 1.003 1.003 0 0 0-.584-1.23m-7.08-11.176a4.94 4.94 0 0 1 1.919-1.322 4.86 4.86 0 0 1-1.037 2.15 4.4 4.4 0 0 1-1.264 1.041l-.003.001-.085.034c-.186.073-.417.164-.595.223a4.8 4.8 0 0 1 1.064-2.127m4.5 14.385c-.803 1.173-1.435 2.006-2.254 2.021a2.37 2.37 0 0 1-1.13-.292 5 5 0 0 0-2.152-.502 5.2 5.2 0 0 0-2.229.513 2.9 2.9 0 0 1-1.086.306h-.03c-.813 0-1.687-1.262-2.268-2.101-1.452-2.1-2.792-6.283-1.223-9.008a3.92 3.92 0 0 1 3.29-2.006h.034a4.8 4.8 0 0 1 1.642.444q.195.078.389.15.049.022.1.038a3.3 3.3 0 0 0 1.118.237 4.4 4.4 0 0 0 1.564-.42 4.96 4.96 0 0 1 2.222-.498 3.8 3.8 0 0 1 2.25.854 5.3 5.3 0 0 0-1.711 3.945v.001a5.3 5.3 0 0 0 2.45 4.503 10.2 10.2 0 0 1-.975 1.815" })
), Zs = h(n0), w0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.94 5.19A4.38 4.38 0 0 0 16 2a4.44 4.44 0 0 0-3 1.52 4.17 4.17 0 0 0-1 3.09 3.69 3.69 0 0 0 2.94-1.42m2.52 7.44a4.51 4.51 0 0 1 2.16-3.81 4.66 4.66 0 0 0-3.66-2c-1.56-.16-3 .91-3.83.91s-2-.89-3.3-.87a4.92 4.92 0 0 0-4.14 2.53C2.93 12.45 4.24 17 6 19.47c.8 1.21 1.8 2.58 3.12 2.53s1.75-.82 3.28-.82 2 .82 3.3.79 2.22-1.24 3.06-2.45a11 11 0 0 0 1.38-2.85 4.41 4.41 0 0 1-2.68-4.04" })
), Bs = h(w0), v0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 13H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1m-1 7H4v-5h5ZM21 2h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 7h-5V4h5Zm1 4h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1m-1 7h-5v-5h5ZM10 2H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M9 9H4V4h5Z" })
), Fs = h(v0), m0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 13h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2m9-10H5a3 3 0 0 0-1 5.82V18a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.82A3 3 0 0 0 19 3m-1 15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h12Zm1-11H5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2" })
), Rs = h(m0), c0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 14h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2m9-11H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1h1v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-8h1a1 1 0 0 0 1-1V6a3 3 0 0 0-3-3m-1 15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8h12Zm2-10H4V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), Us = h(c0), s0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 20h-1V8h1a1 1 0 0 0 0-2h-1V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v3H2a1 1 0 0 0 0 2h1v12H2a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2m-7 0H9v-3.53a6.21 6.21 0 0 1 3-5.33 6.21 6.21 0 0 1 3 5.33Zm4 0h-2v-3.53a8.17 8.17 0 0 0-4.55-7.36 1 1 0 0 0-.9 0A8.17 8.17 0 0 0 7 16.47V20H5V8h14Zm0-14H5V4h14Z" })
), $s = h(s0), g0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 11h10a1 1 0 0 0 0-2h-4V5.41l.79.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.5-2.5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.5 2.5a1 1 0 0 0 1.42 1.42l.79-.8V9H7a1 1 0 0 0 0 2m10 2H7a1 1 0 0 0 0 2h4v3.59l-.79-.8a1 1 0 0 0-1.42 1.42l2.5 2.5a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2.5-2.5a1 1 0 0 0-1.42-1.42l-.79.8V15h4a1 1 0 0 0 0-2" })
), ys = h(g0), i0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 15.71a1 1 0 0 0 .33.21 1 1 0 0 0 .76 0 1 1 0 0 0 .33-.21l3-3a1 1 0 0 0-1.42-1.42L13 12.59V9a1 1 0 0 0-2 0v3.59l-1.29-1.3a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.42ZM12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10m0-18a8 8 0 1 1-8 8 8 8 0 0 1 8-8" })
), ks = h(i0), d0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.29 11.29a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l3 3a1 1 0 0 0 1.42-1.42L11.41 13H15a1 1 0 0 0 0-2h-3.59l1.3-1.29a1 1 0 0 0 0-1.42 1 1 0 0 0-1.42 0ZM2 12A10 10 0 1 0 12 2 10 10 0 0 0 2 12m18 0a8 8 0 1 1-8-8 8 8 0 0 1 8 8" })
), bs = h(d0), p0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.71 12.71a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42l1.3 1.29H9a1 1 0 0 0 0 2h3.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0ZM22 12a10 10 0 1 0-10 10 10 10 0 0 0 10-10M4 12a8 8 0 1 1 8 8 8 8 0 0 1-8-8" })
), Ts = h(p0), f0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.71 8.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-3 3a1 1 0 0 0 1.42 1.42l1.29-1.3V15a1 1 0 0 0 2 0v-3.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), Ps = h(f0), E0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 5a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1m-1.29 6.29-2.5-2.5a1 1 0 1 0-1.42 1.42l.8.79H3a1 1 0 0 0 0 2h4.59l-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.5-2.5a1 1 0 0 0 .21-.33.94.94 0 0 0 0-.76 1 1 0 0 0-.21-.33M21 11h-4.59l.8-.79a1 1 0 0 0-1.42-1.42l-2.5 2.5a1 1 0 0 0 0 1.42l2.5 2.5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.8-.79H21a1 1 0 0 0 0-2" })
), Ds = h(E0), x0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 16H9.41l8.3-8.29a1 1 0 1 0-1.42-1.42L8 14.59V7a1 1 0 0 0-2 0v10a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 7 18h10a1 1 0 0 0 0-2" })
), qs = h(x0), A0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 6a1 1 0 0 0-1 1v7.59l-8.29-8.3a1 1 0 0 0-1.42 1.42l8.3 8.29H7a1 1 0 0 0 0 2h10a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 18 17V7a1 1 0 0 0-1-1" })
), Is = h(A0), M0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.71 11.29a1 1 0 0 0-1.42 0L13 14.59V7a1 1 0 0 0-2 0v7.59l-3.29-3.3a1 1 0 0 0-1.42 1.42l5 5a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l5-5a1 1 0 0 0 0-1.42" })
), Ws = h(M0), H0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 4a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1m18.92 7.62a1 1 0 0 0-.21-.33l-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H7a1 1 0 0 0 0 2h11.59l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
), Gs = h(H0), C0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.29 16.29 13 18.59V7a1 1 0 0 0-2 0v11.59l-2.29-2.3a1 1 0 1 0-1.42 1.42l4 4a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1 1 0 0 0-1.42-1.42M19 2H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" })
), Os = h(C0), u0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.92 6.62a1 1 0 0 0-.54-.54A1 1 0 0 0 21 6h-5a1 1 0 0 0 0 2h2.59L13 13.59l-3.29-3.3a1 1 0 0 0-1.42 0l-6 6a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L9 12.41l3.29 3.3a1 1 0 0 0 1.42 0L20 9.41V12a1 1 0 0 0 2 0V7a1 1 0 0 0-.08-.38" })
), Ns = h(u0), V0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 11H9.41l3.3-3.29a1 1 0 1 0-1.42-1.42l-5 5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l5 5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L9.41 13H17a1 1 0 0 0 0-2" })
), Qs = h(V0), S0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.7 10a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41l-6.27-6.3a1 1 0 0 0-1.42 1.42ZM21 14a1 1 0 0 0-1 1v3.59L15.44 14A1 1 0 0 0 14 15.44L18.59 20H15a1 1 0 0 0 0 2h6a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 21v-6a1 1 0 0 0-1-1m.92-11.38a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-6a1 1 0 0 0 0 2h3.59L2.29 20.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L20 5.41V9a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38" })
), Ks = h(S0), L0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.92 2.62a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-6a1 1 0 0 0 0 2h3.59L4 18.59V15a1 1 0 0 0-2 0v6a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 3 22h6a1 1 0 0 0 0-2H5.41L20 5.41V9a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38" })
), js = h(L0), Z0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.92 11.62a1 1 0 0 0-.21-.33l-5-5a1 1 0 0 0-1.42 1.42l3.3 3.29H7a1 1 0 0 0 0 2h7.59l-3.3 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l5-5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
), Js = h(Z0), B0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 20H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2m-7.71-2.29a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1 1 0 0 0-1.42-1.42L13 14.59V3a1 1 0 0 0-2 0v11.59l-2.29-2.3a1 1 0 1 0-1.42 1.42Z" })
), Ys = h(B0), F0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m17.71 11.29-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H3a1 1 0 0 0 0 2h11.59l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33M21 4a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1" })
), Xs = h(F0), R0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.41 8H17a1 1 0 0 0 0-2H7a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 6 7v10a1 1 0 0 0 2 0V9.41l8.29 8.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), _s = h(R0), U0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.92 6.62a1 1 0 0 0-.54-.54A1 1 0 0 0 17 6H7a1 1 0 0 0 0 2h7.59l-8.3 8.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L16 9.41V17a1 1 0 0 0 2 0V7a1 1 0 0 0-.08-.38" })
), zs = h(U0), $0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m17.71 11.29-5-5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-5 5a1 1 0 0 0 1.42 1.42L11 9.41V17a1 1 0 0 0 2 0V9.41l3.29 3.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42" })
), ag = h($0), y0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.71 6.29a1 1 0 0 0-1.42 0l-5 5a1 1 0 0 0 0 1.42l5 5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.41 12l4.3-4.29a1 1 0 0 0 0-1.42m11 5-5-5a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l5-5a1 1 0 0 0 0-1.42" })
), tg = h(y0), k0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.92 11.62a1 1 0 0 0-.21-.33l-2.5-2.5a1 1 0 0 0-1.42 1.42l.8.79H14a1 1 0 0 0 0 2h4.59l-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.5-2.5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76M10 11H5.41l.8-.79a1 1 0 0 0-1.42-1.42l-2.5 2.5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2.5 2.5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.8-.79H10a1 1 0 0 0 0-2" })
), eg = h(k0), b0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.92 11.62a1 1 0 0 0-.21-.33l-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H5.41l2.3-2.29a1 1 0 1 0-1.42-1.42l-4 4a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.41 13h13.18l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
), lg = h(b0), T0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 16.29a1 1 0 0 0-1.42 0L18 18.59V9a3 3 0 0 0-3-3H5.41l2.3-2.29a1 1 0 0 0-1.42-1.42l-4 4a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.41 8H15a1 1 0 0 1 1 1v9.59l-2.29-2.3a1 1 0 0 0-1.42 1.42l4 4a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1 1 0 0 0 0-1.42" })
), rg = h(T0), P0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 14a1 1 0 0 0-1 1v3.59L5.41 4H9a1 1 0 0 0 0-2H3a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 2 3v6a1 1 0 0 0 2 0V5.41L18.59 20H15a1 1 0 0 0 0 2h6a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 21v-6a1 1 0 0 0-1-1" })
), hg = h(P0), D0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m10.71 11.29-2.5-2.5a1 1 0 1 0-1.42 1.42l.8.79H4V7a1 1 0 0 0-2 0v10a1 1 0 0 0 2 0v-4h3.59l-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.5-2.5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33M21 6a1 1 0 0 0-1 1v4h-3.59l.8-.79a1 1 0 0 0-1.42-1.42l-2.5 2.5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2.5 2.5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.8-.79H20v4a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1" })
), og = h(D0), q0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 6a1 1 0 0 0-1 1v4H5.41l.8-.79a1 1 0 0 0-1.42-1.42l-2.5 2.5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2.5 2.5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.8-.79H9v4a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m11.92 5.62a1 1 0 0 0-.21-.33l-2.5-2.5a1 1 0 0 0-1.42 1.42l.8.79H15V7a1 1 0 0 0-2 0v10a1 1 0 0 0 2 0v-4h3.59l-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.5-2.5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
), ng = h(q0), I0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 11h-3V5.41l.79.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.5-2.5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.5 2.5a1 1 0 0 0 1.42 1.42l.79-.8V11H8a1 1 0 0 0 0 2h3v5.59l-.79-.8a1 1 0 0 0-1.42 1.42l2.5 2.5a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2.5-2.5a1 1 0 0 0-1.42-1.42l-.79.8V13h3a1 1 0 0 0 0-2" })
), wg = h(I0), W0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.92 11.62a1 1 0 0 0-.21-.33l-2.5-2.5a1 1 0 0 0-1.42 1.42l.8.79H13V8a1 1 0 0 0-2 0v3H5.41l.8-.79a1 1 0 0 0-1.42-1.42l-2.5 2.5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2.5 2.5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.8-.79H11v3a1 1 0 0 0 2 0v-3h5.59l-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.5-2.5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
), vg = h(W0), G0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.92 6.62a1 1 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42L17.59 6H9a3 3 0 0 0-3 3v8.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l3 3a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l3-3a1 1 0 0 0-1.42-1.42L8 17.59V9a1 1 0 0 1 1-1h8.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
), mg = h(G0), O0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m17.71 11.29-2.5-2.5a1 1 0 0 0-1.42 1.42l.8.79H9.41l.8-.79a1 1 0 0 0-1.42-1.42l-2.5 2.5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2.5 2.5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.8-.79h5.18l-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.5-2.5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33M3 6a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m18 0a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1" })
), cg = h(O0), N0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.79 10.21a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.5-2.5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.5 2.5a1 1 0 0 0 1.42 1.42l.79-.8v5.18l-.79-.8a1 1 0 0 0-1.42 1.42l2.5 2.5a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2.5-2.5a1 1 0 0 0-1.42-1.42l-.79.8V9.41ZM7 4h10a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m10 16H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2" })
), sg = h(N0), Q0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.92 16.62a1 1 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42l1.3 1.29H9a1 1 0 0 1-1-1V6.41l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-3-3a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-3 3a1 1 0 0 0 1.42 1.42L6 6.41V15a3 3 0 0 0 3 3h8.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
), gg = h(Q0), K0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m10.21 6.21.79-.8V10a1 1 0 0 0 2 0V5.41l.79.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.5-2.5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.5 2.5a1 1 0 0 0 1.42 1.42m3.58 11.58-.79.8V14a1 1 0 0 0-2 0v4.59l-.79-.8a1 1 0 0 0-1.42 1.42l2.5 2.5a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2.5-2.5a1 1 0 0 0-1.42-1.42" })
), ig = h(K0), j0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.29 16.29 13 18.59V5.41l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-4-4a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-4 4a1 1 0 1 0 1.42 1.42L11 5.41v13.18l-2.29-2.3a1 1 0 1 0-1.42 1.42l4 4a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1 1 0 0 0-1.42-1.42" })
), dg = h(j0), J0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 3a7 7 0 0 0-7 7 1 1 0 0 0 2 0 5 5 0 0 1 10 0 5.07 5.07 0 0 1-.71 2.57L11.73 20A2 2 0 0 1 10 21a2 2 0 0 1-2-2 1 1 0 0 0-2 0 4 4 0 0 0 4 4 4 4 0 0 0 3.5-2.07l3.56-7.43A6.93 6.93 0 0 0 18 10a7 7 0 0 0-7-7M4 15a1 1 0 1 0 1 1 1 1 0 0 0-1-1M17.59 1.2a1 1 0 1 0-1.2 1.6A9 9 0 0 1 20 10a1 1 0 0 0 2 0 11.06 11.06 0 0 0-4.41-8.8M11 9a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-6 0 3 3 0 0 0 .51 1.68 3.5 3.5 0 0 0 .47.54l.2.22a1 1 0 0 1 0 1.11 1 1 0 0 0 .25 1.39 1 1 0 0 0 .57.18 1 1 0 0 0 .82-.43 3 3 0 0 0 0-3.39 3.4 3.4 0 0 0-.35-.42l-.14-.14a1.4 1.4 0 0 1-.16-.18A1 1 0 0 1 10 10a1 1 0 0 1 1-1m-4 6a1 1 0 1 0-1-1 1 1 0 0 0 1 1" })
), pg = h(J0), Y0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.562 14.634 14 12l4.562-2.634a1 1 0 0 0-1-1.732L13 10.268V5a1 1 0 0 0-2 0v5.268L6.438 7.634a1 1 0 0 0-1 1.732L10 12l-4.562 2.634a1 1 0 0 0 1 1.732L11 13.732V19a1 1 0 0 0 2 0v-5.268l4.562 2.634a1 1 0 0 0 1-1.732" })
), fg = h(Y0), X0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 5 18.66 1 1 0 1 0-1-1.73A8 8 0 1 1 20 12v.75a1.75 1.75 0 0 1-3.5 0V8.5a1 1 0 0 0-1-1 1 1 0 0 0-1 .79A4.45 4.45 0 0 0 12 7.5a4.5 4.5 0 1 0 3.3 7.5 3.74 3.74 0 0 0 6.7-2.25V12A10 10 0 0 0 12 2m0 12.5a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5" })
), Eg = h(X0), _0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m7.62 1 .11-.14C21.08 10 21.4 8.29 20.66 7S18.26 5.14 16 5.37h-.18C14.91 3.3 13.56 2 12 2S9.09 3.3 8.19 5.4L8 5.37C5.74 5.14 4.08 5.71 3.34 7s-.42 3 .93 4.86l.11.14-.11.14C2.92 14 2.6 15.71 3.34 17 4 18.1 5.27 18.68 7 18.68c.31 0 .63 0 1-.05h.18C9.09 20.7 10.44 22 12 22s2.91-1.3 3.81-3.4h.18c.34 0 .66.05 1 .05 1.77 0 3.07-.58 3.7-1.68.74-1.29.42-3-.93-4.86ZM5.07 8c.25-.44 1-.68 2-.68h.49a15 15 0 0 0-.35 1.87 15 15 0 0 0-1.45 1.25C5 9.44 4.78 8.5 5.07 8m0 8c-.29-.5 0-1.44.67-2.47a15 15 0 0 0 1.45 1.25 15 15 0 0 0 .35 1.88c-1.24.08-2.18-.16-2.47-.66M12 4c.56 0 1.23.66 1.8 1.83a18 18 0 0 0-1.8.63 18 18 0 0 0-1.8-.63C10.77 4.66 11.44 4 12 4m0 16c-.56 0-1.23-.66-1.8-1.83a18 18 0 0 0 1.8-.63 18 18 0 0 0 1.8.63C13.23 19.34 12.56 20 12 20m2.93-6.31c-.46.32-.93.62-1.43.91s-1 .55-1.5.78q-.75-.35-1.5-.78c-.5-.29-1-.59-1.43-.91C9 13.15 9 12.59 9 12s0-1.15.07-1.69c.46-.32.93-.62 1.43-.91s1-.55 1.5-.78q.75.35 1.5.78c.5.29 1 .59 1.43.91 0 .54.07 1.1.07 1.69s0 1.15-.07 1.69m4 2.31c-.29.5-1.23.75-2.47.66a15 15 0 0 0 .35-1.88 15 15 0 0 0 1.45-1.25c.74 1.03.96 1.97.67 2.47m-.67-5.53a15 15 0 0 0-1.45-1.25 15 15 0 0 0-.35-1.87h.49c1 0 1.73.24 2 .68s.05 1.41-.69 2.44" })
), xg = h(_0), z0 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.87 8.6A1 1 0 0 0 17 8h-4.58l1.27-4.74a1 1 0 0 0-.17-.87 1 1 0 0 0-.8-.39h-7a1 1 0 0 0-1 .74l-2.68 10a1 1 0 0 0 1 1.26h3.85l-1.81 6.74a1 1 0 0 0 1.71.93l10.9-12a1 1 0 0 0 .18-1.07m-9.79 8.68 1.08-4a1 1 0 0 0-.16-.89 1 1 0 0 0-.81-.39H4.35l2.14-8h4.93l-1.27 4.74a1 1 0 0 0 1 1.26h3.57ZM19 13h-1a3 3 0 0 0-3 3v5a1 1 0 0 0 2 0v-2h3v2a1 1 0 0 0 2 0v-5a3 3 0 0 0-3-3m1 4h-3v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Z" })
), Ag = h(z0), a1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 1a7 7 0 0 0-5 11.89V22a1 1 0 0 0 1.45.89L12 21.12l3.55 1.77A1 1 0 0 0 16 23a1 1 0 0 0 .53-.15A1 1 0 0 0 17 22v-9.11A7 7 0 0 0 12 1m3 19.38-2.55-1.27a1 1 0 0 0-.9 0L9 20.38v-6.06a7 7 0 0 0 2 .6V16a1 1 0 0 0 2 0v-1.08a7 7 0 0 0 2-.6ZM12 13a5 5 0 1 1 5-5 5 5 0 0 1-5 5" })
), Mg = h(a1), t1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20.87 17.25-2.71-4.68A6.9 6.9 0 0 0 19 9.25a7 7 0 0 0-14 0 6.9 6.9 0 0 0 .84 3.32l-2.71 4.68a1 1 0 0 0 .87 1.5h2.87l1.46 2.46a1 1 0 0 0 .18.22 1 1 0 0 0 .69.28h.14a1 1 0 0 0 .73-.49L12 17.9l1.93 3.35a1 1 0 0 0 .73.48h.14a1 1 0 0 0 .7-.28.9.9 0 0 0 .17-.21l1.46-2.46H20a1 1 0 0 0 .87-.5 1 1 0 0 0 0-1.03M9.19 18.78l-.89-1.49a1 1 0 0 0-.85-.49H5.72l1.43-2.48a7 7 0 0 0 3.57 1.84ZM12 14.25a5 5 0 1 1 5-5 5 5 0 0 1-5 5m4.55 2.55a1 1 0 0 0-.85.49l-.89 1.49-1.52-2.65a7.06 7.06 0 0 0 3.56-1.84l1.43 2.48Z" })
), Hg = h(t1), e1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1M9 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1M22 8.5A6.51 6.51 0 0 0 15.5 2H15a1 1 0 0 0-1 1v5H7.52L6.27 4.65A1 1 0 0 0 5.33 4H3a1 1 0 0 0 0 2h1.64l1.25 3.37.51 1.37v.09A6.44 6.44 0 0 0 12.5 15h3A6.49 6.49 0 0 0 22 8.5m-3.32 3.18A4.47 4.47 0 0 1 15.5 13h-3a4.47 4.47 0 0 1-4.16-2.8.14.14 0 0 1 0-.06L8.26 10h11.48a4.3 4.3 0 0 1-1.06 1.68M16 8V4a4.49 4.49 0 0 1 4 4Z" })
), Cg = h(e1), l1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 10h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m5 0a4 4 0 0 0-3-3.86V5a3 3 0 0 0-6 0v1.14A4 4 0 0 0 6 10a4 4 0 0 0-4 4v3a3 3 0 0 0 3 3h1.18A3 3 0 0 0 9 22h6a3 3 0 0 0 2.82-2H19a3 3 0 0 0 3-3v-3a4 4 0 0 0-4-4M6 18H5a1 1 0 0 1-1-1v-3a2 2 0 0 1 2-2Zm5-13a1 1 0 0 1 2 0v1h-2Zm5 14a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Zm0-4.44a3.9 3.9 0 0 0-2-.56h-4a3.9 3.9 0 0 0-2 .56V10a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2ZM20 17a1 1 0 0 1-1 1h-1v-6a2 2 0 0 1 2 2Z" })
), ug = h(l1), r1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 5H9.83a3 3 0 0 0-2.12.88l-5.42 5.41a1 1 0 0 0 0 1.42l5.42 5.41a3 3 0 0 0 2.12.88H19a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H9.83a1.05 1.05 0 0 1-.71-.29L4.41 12l4.71-4.71A1.05 1.05 0 0 1 9.83 7H19a1 1 0 0 1 1 1Zm-3.29-6.71a1 1 0 0 0-1.42 0L14 10.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l1.3 1.29-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L15.41 12l1.3-1.29a1 1 0 0 0 0-1.42" })
), Vg = h(r1), h1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.67 5.85a2.63 2.63 0 0 0-2.67 0l-4 2.3a2.67 2.67 0 0 0-4-2.31L3.33 9.69a2.67 2.67 0 0 0 0 4.62L10 18.16a2.66 2.66 0 0 0 2.67 0A2.65 2.65 0 0 0 14 15.85l4 2.31a2.7 2.7 0 0 0 1.33.36 2.6 2.6 0 0 0 1.34-.37 2.63 2.63 0 0 0 1.33-2.3v-7.7a2.63 2.63 0 0 0-1.33-2.3m-8.67 10a.66.66 0 0 1-.33.58.69.69 0 0 1-.67 0l-6.67-3.85a.67.67 0 0 1 0-1.16L11 7.57a.67.67 0 0 1 .67 0 .66.66 0 0 1 .33.58Zm8 0a.67.67 0 0 1-1 .57l-5-2.88v-3.08l5-2.88a.67.67 0 0 1 1 .57Z" })
), Sg = h(h1), o1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6.5h-3v-1a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3m-9-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm10 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V13a21.7 21.7 0 0 0 8 1.53A21.8 21.8 0 0 0 20 13Zm0-7.69a19.9 19.9 0 0 1-16 0V9.5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), Lg = h(o1), n1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6h-3V5a2 2 0 0 0-2-2h-4a1.9 1.9 0 0 0-.61.1 1 1 0 0 0-.64 1.27A1 1 0 0 0 10 5h4v1h-1.34a1 1 0 0 0 0 2H19a1 1 0 0 1 1 1v1.28l-2.57.86a1 1 0 0 0-.63 1.27 1 1 0 0 0 .95.68 1.2 1.2 0 0 0 .32-.05l1.93-.65v2.95a1 1 0 1 0 2 0V9a3 3 0 0 0-3-3M3.71 2.29a1 1 0 0 0-1.42 1.42L4.62 6A3 3 0 0 0 2 9v9a3 3 0 0 0 3 3h14a3 3 0 0 0 .53-.06l.76.77a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM4 9a1 1 0 0 1 1-1h1.59l4 4H9.16L4 10.28Zm1 10a1 1 0 0 1-1-1v-5.61L8.68 14A1.2 1.2 0 0 0 9 14h3.59l5 5Z" })
), Zg = h(n1), w1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6h-3V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3m-9-1h4v1h-4Zm10 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5.61L8.68 14A1.2 1.2 0 0 0 9 14h6a1.2 1.2 0 0 0 .32-.05L20 12.39Zm0-7.72L14.84 12H9.16L4 10.28V9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), Bg = h(w1), v1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.964 13.823a1 1 0 0 0-.028-.175l-2.305-6.137A3 3 0 0 0 22 5a1 1 0 0 0-2 0 1 1 0 0 1-1.882.473A2.89 2.89 0 0 0 15.54 4H13V3a1 1 0 0 0-2 0v1H8.46a2.89 2.89 0 0 0-2.578 1.473A1 1 0 0 1 4 5a1 1 0 0 0-2 0 3 3 0 0 0 1.369 2.511l-2.305 6.137a1 1 0 0 0-.028.175A1 1 0 0 0 1 14q.001.014.003.027.001.019.004.039a3.994 3.994 0 0 0 7.986 0q.003-.02.004-.039.001-.014.003-.027a1 1 0 0 0-.036-.177 1 1 0 0 0-.028-.175L6.629 7.504A3 3 0 0 0 7.643 6.42.92.92 0 0 1 8.46 6H11v14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2h-3V6h2.54a.92.92 0 0 1 .817.42 3 3 0 0 0 1.014 1.084l-2.307 6.144a1 1 0 0 0-.028.175A1 1 0 0 0 15 14q.002.014.003.027.001.019.004.039a3.994 3.994 0 0 0 7.986 0q.003-.02.004-.039Q23 14.013 23 14a1 1 0 0 0-.036-.177M5 8.856 6.556 13H3.444ZM6.723 15A2.02 2.02 0 0 1 5 16a2 2 0 0 1-1.731-1ZM19 8.856 20.556 13h-3.112ZM19 16a2 2 0 0 1-1.731-1h3.454A2.02 2.02 0 0 1 19 16" })
), Fg = h(v1), m1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8 7.92 7.92 0 0 1 1.69-4.9L16.9 18.31A7.92 7.92 0 0 1 12 20m6.31-3.1L7.1 5.69A7.92 7.92 0 0 1 12 4a8 8 0 0 1 8 8 7.92 7.92 0 0 1-1.69 4.9" })
), Rg = h(m1), c1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.82 11.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0m2.47 2.48a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0m9-10A6 6 0 0 0 12 3.55a6 6 0 0 0-8.24.2A6 6 0 0 0 3.57 12 6 6 0 0 0 8 22a5.92 5.92 0 0 0 4-1.55 6 6 0 0 0 8.25-.2 6 6 0 0 0 .18-8.25 6 6 0 0 0-.18-8.25Zm-1.46 1.4a4 4 0 0 1 .17 5.39L13.44 5a4.07 4.07 0 0 1 5.39.17M5.17 18.83A4 4 0 0 1 5 13.44l5.6 5.6a4.08 4.08 0 0 1-5.43-.21m13.66 0a4.08 4.08 0 0 1-5.64 0l-8-8a4 4 0 0 1 0-5.64 4 4 0 0 1 5.64 0l8 8a4 4 0 0 1 0 5.64m-5.06-7.54a1 1 0 0 0 0 1.42 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0m-2.48-2.47a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0" })
), Ug = h(c1), s1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 8h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 8H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-5H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), $g = h(s1), g1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.922 6.44a1 1 0 0 0-1.703 1.05q.265.428.565.843a1 1 0 0 0 1.62-1.174q-.257-.353-.482-.719m-2.73 9.222a1 1 0 1 0-1.609 1.188q.254.345.476.709a1 1 0 1 0 1.705-1.047q-.267-.436-.572-.85m-3.707-3.429a1 1 0 0 0-1.045 1.705q.364.223.713.479A1 1 0 1 0 8.331 12.8q-.414-.302-.846-.567m10.06-2.167q-.364-.224-.715-.48a1 1 0 0 0-1.178 1.618q.415.302.847.567a1 1 0 1 0 1.047-1.705m1.447-5.065a9.9 9.9 0 1 0 0 14.001 9.913 9.913 0 0 0 0-14.001M17.72 17.729a8.03 8.03 0 0 1-4.516 2.273.97.97 0 0 0-1.746.074 8.06 8.06 0 0 1-7.535-7.532.975.975 0 0 0 .073-1.747 8.04 8.04 0 0 1 6.784-6.792 1 1 0 0 0 .857.498 1 1 0 0 0 .23-.026.98.98 0 0 0 .658-.546 8.054 8.054 0 0 1 7.538 7.538.972.972 0 0 0-.074 1.741 8.05 8.05 0 0 1-2.27 4.519" })
), yg = h(g1), i1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 10H6a1 1 0 0 0 0 2h1v9a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 2 0v-9h1a1 1 0 0 0 0-2m-7 8H9v-2h2Zm0-4H9v-2h2Zm4 4h-2v-2h2Zm0-4h-2v-2h2Zm5-12H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3 1 1 0 0 0 0-2 1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1 1 1 0 0 0 0 2 3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-6 6a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2Z" })
), kg = h(i1), d1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 0 0-8.4 4.59 10 10 0 0 0 14.66 13.2A10 10 0 0 0 12 2m2 2.26A8 8 0 0 1 19.74 10 9.8 9.8 0 0 0 15 11.38a15.7 15.7 0 0 0-2.4-2.21A10.06 10.06 0 0 0 14 4.26M12 4a7.9 7.9 0 0 1-1.14 4.07c-.15-.08-.29-.17-.44-.24a15.5 15.5 0 0 0-4.09-1.47A8 8 0 0 1 12 4M5 8.16A13.8 13.8 0 0 1 9.49 9.6l.13.08A7.93 7.93 0 0 1 4 12a8 8 0 0 1 1-3.84m5 11.58A8 8 0 0 1 4.26 14a9.9 9.9 0 0 0 7.08-3.21 14 14 0 0 1 2 1.8A10 10 0 0 0 10 19.74m2 .26a8 8 0 0 1 2.56-5.85c.06.08.12.15.17.23a14 14 0 0 1 1.84 4.18A7.93 7.93 0 0 1 12 20m6.21-3a16 16 0 0 0-1.8-3.75L16.2 13a7.9 7.9 0 0 1 3.8-1 8 8 0 0 1-1.79 5" })
), bg = h(d1), p1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 12H5V6.41a1.98 1.98 0 0 1 1.04-1.759 2 2 0 0 1 1.148-.23 3.49 3.49 0 0 0 .837 3.554l1.06 1.06a1 1 0 0 0 1.415 0L14.035 5.5a1 1 0 0 0 0-1.414l-1.06-1.06a3.494 3.494 0 0 0-4.53-.343A3.992 3.992 0 0 0 3 6.41V12H2a1 1 0 0 0 0 2h1v3a2.995 2.995 0 0 0 2 2.816V21a1 1 0 0 0 2 0v-1h10v1a1 1 0 0 0 2 0v-1.184A2.995 2.995 0 0 0 21 17v-3h1a1 1 0 0 0 0-2M9.44 4.44a1.5 1.5 0 0 1 2.12 0l.354.353-2.121 2.121-.354-.353a1.5 1.5 0 0 1 0-2.122ZM19 17a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3h14Z" })
), Tg = h(p1), f1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.69 15H4V9h2.31a1 1 0 0 0 0-2H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2.69a1 1 0 1 0 0-2m7.2-2.56a1 1 0 0 0 .06-.18 1.4 1.4 0 0 0 0-.2v-.18a.7.7 0 0 0-.05-.2 1 1 0 0 0-.08-.17 1 1 0 0 0-.1-.16l-.16-.13-.09-.09h-.06l-.18-.06h-3.5l1.45-2.5a1 1 0 1 0-1.74-1l-2.31 4v.06a1 1 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2S7 12 7 12v.12a.7.7 0 0 0 .05.2 1 1 0 0 0 .08.17 1 1 0 0 0 .1.16l.16.13a1 1 0 0 0 .09.09h.16A1 1 0 0 0 8 13h3.27l-1.45 2.5a1 1 0 0 0 1.74 1l2.31-4s.01-.04.02-.06M21 10a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m-4-3h-2.69a1 1 0 0 0 0 2H17v6h-2.31a1 1 0 1 0 0 2H17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2" })
), Pg = h(f1), E1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2m0 8H4V9h13Zm4-5a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1" })
), Dg = h(E1), x1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 3.5H4a3 3 0 0 0-3 3v13a1 1 0 0 0 1 1h4a1 1 0 0 0 .83-.45l1.71-2.55h6.92l1.71 2.55a1 1 0 0 0 .83.45h4a1 1 0 0 0 1-1v-13a3 3 0 0 0-3-3m1 15h-2.46L16.83 16a1 1 0 0 0-.83-.5H8a1 1 0 0 0-.83.45L5.46 18.5H3v-5h18Zm-14-7v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1Zm6 0v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1Zm8 0h-2v-1a3 3 0 0 0-3-3h-2a3 3 0 0 0-2 .78 3 3 0 0 0-2-.78H8a3 3 0 0 0-3 3v1H3v-5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Z" })
), qg = h(x1), A1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 12.5a3 3 0 1 0-3-3 3 3 0 0 0 3 3m0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1m13-2h-8a1 1 0 0 0-1 1v6H3v-8a1 1 0 0 0-2 0v13a1 1 0 0 0 2 0v-3h18v3a1 1 0 0 0 2 0v-9a3 3 0 0 0-3-3m1 7h-8v-5h7a1 1 0 0 1 1 1Z" })
), Ig = h(A1), M1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.108 15.032a.997.997 0 0 0-1.215.722A2.998 2.998 0 0 1 14.992 15v-1h7a1 1 0 0 0 1-1 5 5 0 1 0-10 0v2a4.998 4.998 0 0 0 9.839 1.247 1 1 0 0 0-.723-1.215M17.992 10a3 3 0 0 1 2.118.873A3.04 3.04 0 0 1 20.809 12h-5.633a2.995 2.995 0 0 1 2.816-2m-2-3h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2M9.91 11.718A3.987 3.987 0 0 0 6.992 5h-5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h5.5a4.492 4.492 0 0 0 2.418-8.282M2.992 7h4a2 2 0 1 1 0 4h-4Zm4.5 11h-4.5v-5h4.5a2.5 2.5 0 0 1 0 5" })
), Wg = h(M1), H1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.07 6.35H15v1.41h5.09ZM19 16.05a2.23 2.23 0 0 1-1.3.37 2.23 2.23 0 0 1-1.7-.54 2.5 2.5 0 0 1-.62-1.76H22a6.5 6.5 0 0 0-.17-2 5.1 5.1 0 0 0-.8-1.73 4.2 4.2 0 0 0-1.42-1.21 4.4 4.4 0 0 0-2-.45 4.9 4.9 0 0 0-1.9.37 4.5 4.5 0 0 0-1.47 1 4.4 4.4 0 0 0-.95 1.52 5.4 5.4 0 0 0-.33 1.91 5.5 5.5 0 0 0 .32 1.94 4.5 4.5 0 0 0 .88 1.53 4 4 0 0 0 1.46 1 5.2 5.2 0 0 0 1.94.34 4.77 4.77 0 0 0 2.64-.7 4.2 4.2 0 0 0 1.63-2.35h-2.21a1.54 1.54 0 0 1-.62.76m-3.43-4.12a1.87 1.87 0 0 1 1-1.14 2.3 2.3 0 0 1 1-.2 1.73 1.73 0 0 1 1.36.49 2.9 2.9 0 0 1 .63 1.45h-4.15a3 3 0 0 1 .11-.6Zm-5.29-.48a3.06 3.06 0 0 0 1.28-1 2.7 2.7 0 0 0 .43-1.58 3.3 3.3 0 0 0-.29-1.48 2.4 2.4 0 0 0-.82-1 3.2 3.2 0 0 0-1.27-.52 7.5 7.5 0 0 0-1.64-.16H2v12.58h6.1a6.6 6.6 0 0 0 1.65-.21 4.6 4.6 0 0 0 1.43-.65 3.1 3.1 0 0 0 1-1.14 3.4 3.4 0 0 0 .37-1.65 3.47 3.47 0 0 0-.57-2 3 3 0 0 0-1.75-1.19ZM4.77 7.86h2.59a4 4 0 0 1 .71.06 1.6 1.6 0 0 1 .61.22 1.05 1.05 0 0 1 .42.44 1.4 1.4 0 0 1 .16.72 1.36 1.36 0 0 1-.47 1.15 2 2 0 0 1-1.22.35h-2.8Zm4.84 7.44a1.3 1.3 0 0 1-.45.5 2 2 0 0 1-.65.26 3.3 3.3 0 0 1-.78.08h-3v-3.45h3a2.4 2.4 0 0 1 1.45.41 1.65 1.65 0 0 1 .54 1.39 1.8 1.8 0 0 1-.11.81" })
), Gg = h(H1), C1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 8a2 2 0 1 0-2.27 2 4.49 4.49 0 0 1-3 5.85 3 3 0 0 0-1.3-1.43 7 7 0 1 0-10.9 0A3 3 0 0 0 2 17v1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-.19a6.47 6.47 0 0 0 4.58-8.59A2 2 0 0 0 21 8m-7 10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.41a6.94 6.94 0 0 0 7.18 0H13a1 1 0 0 1 1 1Zm-5-3a5 5 0 1 1 5-5 5 5 0 0 1-5 5m0-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), Og = h(C1), u1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.07 6.12A3.5 3.5 0 0 1 12 6a4 4 0 0 1 4 4v1.34a1 1 0 0 0 2 0V10a6 6 0 0 0-5-5.91V3a1 1 0 0 0-2 0v1.1l-.45.08a1 1 0 0 0 .52 1.94m10.64 14.17-18-18a1 1 0 0 0-1.42 1.42l4.12 4.11A6 6 0 0 0 6 10v3.18A3 3 0 0 0 4 16v2a1 1 0 0 0 1 1h3.14a4 4 0 0 0 7.72 0h1.73l2.7 2.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M8 10a3.3 3.3 0 0 1 0-.55L11.59 13H8Zm4 10a2 2 0 0 1-1.72-1h3.44A2 2 0 0 1 12 20m-6-3v-1a1 1 0 0 1 1-1h6.59l2 2Z" })
), Ng = h(u1), V1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 13.18V10a6 6 0 0 0-5-5.91V3a1 1 0 0 0-2 0v1.09A6 6 0 0 0 6 10v3.18A3 3 0 0 0 4 16v2a1 1 0 0 0 1 1h3.14a4 4 0 0 0 7.72 0H19a1 1 0 0 0 1-1v-2a3 3 0 0 0-2-2.82M8 10a4 4 0 0 1 8 0v3H8Zm4 10a2 2 0 0 1-1.72-1h3.44A2 2 0 0 1 12 20m6-3H6v-1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z" })
), Qg = h(V1), S1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.5 10.5H12a1 1 0 0 0 0-2h-1V8a1 1 0 0 0-2 0v.55a2.5 2.5 0 0 0 .5 4.95h1a.5.5 0 0 1 0 1H8a1 1 0 0 0 0 2h1v.5a1 1 0 0 0 2 0v-.55a2.5 2.5 0 0 0-.5-4.95h-1a.5.5 0 0 1 0-1M21 12h-3V3a1 1 0 0 0-.5-.87 1 1 0 0 0-1 0l-3 1.72-3-1.72a1 1 0 0 0-1 0l-3 1.72-3-1.72a1 1 0 0 0-1 0A1 1 0 0 0 2 3v16a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1V4.73l2 1.14a1.08 1.08 0 0 0 1 0l3-1.72 3 1.72a1.08 1.08 0 0 0 1 0l2-1.14V19a3 3 0 0 0 .18 1Zm15-1a1 1 0 0 1-2 0v-5h2Z" })
), Kg = h(S1), L1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m10.1 8.6 1.7 4.3 2.8 1.3L9 17.5V3.4L5 2v17.8L9 22l10-5.8v-4.5z" })
), jg = h(L1), Z1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.304 11.241a3.998 3.998 0 0 0-3.312-6.239v-1a1 1 0 1 0-2 0v1h-2v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0 0 2h1v10h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1h2a3.99 3.99 0 0 0 1.312-7.76M8.992 7.002h4a2 2 0 0 1 0 4h-4Zm6 10h-6v-4h6a2 2 0 1 1 0 4" })
), Jg = h(Z1), B1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1m0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9m2-14V6a1 1 0 0 0-2 0v1h-1V6a1 1 0 0 0-2 0v1H8a1 1 0 0 0 0 2h1v6H8a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1v1a1 1 0 0 0 2 0v-1a3 3 0 0 0 3-3 3 3 0 0 0-.77-2 3 3 0 0 0 .77-2 3 3 0 0 0-3-3m0 8h-3v-2h3a1 1 0 0 1 0 2m0-4h-3V9h3a1 1 0 0 1 0 2" })
), Yg = h(B1), F1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 9a4 4 0 0 0-4-4V3a1 1 0 0 0-2 0v2h-2V3a1 1 0 0 0-2 0v2H6a1 1 0 0 0 0 2h1v10H6a1 1 0 0 0 0 2h3v2a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0v-2a4 4 0 0 0 2.62-7A4 4 0 0 0 19 9m-4 8H9v-4h6a2 2 0 0 1 0 4m0-6H9V7h6a2 2 0 0 1 0 4" })
), Xg = h(F1), R1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m11.136 12.117-.596 2.415c.736.185 3.004.921 3.34-.441.35-1.421-2.009-1.789-2.744-1.974m.813-3.297-.54 2.191c.612.154 2.5.784 2.806-.455.318-1.293-1.654-1.581-2.266-1.736M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m4.358 8.575a1.74 1.74 0 0 1-1.385 1.611 1.933 1.933 0 0 1 .997 2.661c-.586 1.692-1.977 1.835-3.827 1.481l-.449 1.82-1.085-.274.443-1.795q-.42-.105-.864-.227l-.445 1.804-1.084-.273.45-1.824c-.254-.065-.511-.135-.774-.201l-1.412-.356.539-1.256s.8.215.788.199a.394.394 0 0 0 .498-.26l1.217-4.939a.583.583 0 0 0-.505-.638c.016-.011-.789-.198-.789-.198l.29-1.172 1.495.378-.001.006q.338.083.693.164l.444-1.801 1.085.273-.436 1.766c.291.068.584.135.87.207l.432-1.755 1.085.274-.445 1.802c1.37.477 2.372 1.193 2.175 2.523" })
), _g = h(R1), U1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2M7.19 13.35H5.27l.52-2.41h1.84c1.2 0 1.48.58 1.48 1.05 0 .65-.43 1.36-1.92 1.36m.66-3.64H5.94l.52-2.41H8.3c1.19 0 1.47.59 1.47 1 0 .7-.42 1.41-1.92 1.41m3.75 7.43H9.68l.53-2.42h1.84c1.19 0 1.47.59 1.47 1.06 0 .65-.42 1.36-1.92 1.36m.71-3.79H10.4l.52-2.41h1.84c1.19 0 1.47.58 1.47 1.05 0 .65-.42 1.36-1.92 1.36M13 9.71h-1.94l.52-2.41h1.84c1.2 0 1.48.59 1.48 1 0 .7-.43 1.41-1.9 1.41m3.74 5.61h-1.93l.52-2.42h1.84c1.19 0 1.48.59 1.48 1.06 0 .65-.43 1.36-1.93 1.36Zm.72-3.44h-1.94L16 9.46h1.84c1.2 0 1.48.59 1.48 1 .04.71-.39 1.42-1.88 1.42Z" })
), zg = h(U1), $1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.991 13h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-4-2h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m6-1V9a4.004 4.004 0 0 0-4-4h-2a5.006 5.006 0 0 0-5 5v4a5.006 5.006 0 0 0 5 5h4a5.006 5.006 0 0 0 5-5v-1a3.005 3.005 0 0 0-3-3m0 0v.001h-1Zm1 4a3.003 3.003 0 0 1-3 3h-4a3.003 3.003 0 0 1-3-3v-4a3.003 3.003 0 0 1 3-3h2a2.003 2.003 0 0 1 2 2v1a2.003 2.003 0 0 0 2 2 1 1 0 0 1 1 1Zm3-13h-16a3.003 3.003 0 0 0-3 3v16a3.003 3.003 0 0 0 3 3h16a3.003 3.003 0 0 0 3-3V4a3.003 3.003 0 0 0-3-3m1 19a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Z" })
), ai = h($1), y1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.71 10.46h2.239a.77.77 0 1 0 0-1.542H9.71a.77.77 0 1 0 0 1.542m9.718-8.458H4.555a2.573 2.573 0 0 0-2.563 2.563v14.873a2.573 2.573 0 0 0 2.563 2.564h14.873a2.573 2.573 0 0 0 2.564-2.564V4.565a2.573 2.573 0 0 0-2.564-2.563m-1.072 9.678-.02 2.675a4.05 4.05 0 0 1-4.038 4.022h-4.64a4.05 4.05 0 0 1-4.041-4.025V9.657a4.053 4.053 0 0 1 4.042-4.03h2.823a4.46 4.46 0 0 1 3.12 2.2 3.16 3.16 0 0 1 .362 1.367c.068.506.103.881.33 1.09.32.289 1.508.094 1.743.278l.178.14.11.221.035.178Zm-4.097 1.863H9.71a.75.75 0 1 0 0 1.5h4.549a.75.75 0 1 0 0-1.5" })
), ti = h(y1), k1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m13.41 12 3.8-3.79a1 1 0 0 0 0-1.42l-4.5-4.5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.54.54A1 1 0 0 0 11 3v6.59l-2.79-2.8a1 1 0 1 0-1.42 1.42l3.8 3.79-3.8 3.79a1 1 0 1 0 1.42 1.42l2.79-2.8V21a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4.5-4.5a1 1 0 0 0 0-1.42ZM13 5.41l2.09 2.09L13 9.59Zm0 13.18v-4.18l2.09 2.09Z" })
), ei = h(k1), b1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.5 9.5A3.5 3.5 0 0 0 13 6H8.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1H13a3.49 3.49 0 0 0 2.44-6 3.5 3.5 0 0 0 1.06-2.5M13 16H9.5v-3H13a1.5 1.5 0 0 1 0 3m0-5H9.5V8H13a1.5 1.5 0 0 1 0 3" })
), li = h(b1), T1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.89 9.55A1 1 0 0 0 19 9h-5V3a1 1 0 0 0-.69-1 1 1 0 0 0-1.12.36l-8 11a1 1 0 0 0-.08 1A1 1 0 0 0 5 15h5v6a1 1 0 0 0 .69.95A1.1 1.1 0 0 0 11 22a1 1 0 0 0 .81-.41l8-11a1 1 0 0 0 .08-1.04M12 17.92V14a1 1 0 0 0-1-1H7l5-6.92V10a1 1 0 0 0 1 1h4Z" })
), ri = h(T1), P1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.67 4.23A1 1 0 0 0 9.6 4h5.1l-1.27 4.74a1 1 0 0 0 .17.87 1 1 0 0 0 .79.39H18l-1.13 1.24a1 1 0 0 0 .07 1.41 1 1 0 0 0 .67.26 1 1 0 0 0 .74-.33L21 9.67A1 1 0 0 0 20.23 8h-4.54L17 3.26a1 1 0 0 0-.18-.87A1 1 0 0 0 16 2H9a1 1 0 0 0-1 .74V3a1 1 0 0 0 .67 1.23m13 16.06-18-18a1 1 0 0 0-1.38 1.42L6.61 8l-1.26 4.74a1 1 0 0 0 .18.87 1 1 0 0 0 .79.39h3.84l-1.81 6.74a1 1 0 0 0 .49 1.14 1 1 0 0 0 .48.12 1 1 0 0 0 .74-.33l4.85-5.34 5.38 5.38a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM7.62 12l.63-2.34L10.59 12Zm3.73 5.28 1-3.56 1.2 1.19Z" })
), hi = h(P1), D1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.87 8.6A1 1 0 0 0 19 8h-4.58l1.27-4.74a1 1 0 0 0-.17-.87 1 1 0 0 0-.79-.39h-7a1 1 0 0 0-1 .74l-2.68 10a1 1 0 0 0 .17.87 1 1 0 0 0 .8.39h3.87l-1.81 6.74a1 1 0 0 0 1.71.93l10.9-12a1 1 0 0 0 .18-1.07m-9.79 8.68 1.07-4a1 1 0 0 0-.17-.87 1 1 0 0 0-.79-.39H6.35L8.49 4h4.93l-1.27 4.74a1 1 0 0 0 1 1.26h3.57Z" })
), oi = h(D1), q1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 2H8a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M6 6a2 2 0 0 1 2-2h10v10H8a3.9 3.9 0 0 0-2 .56Zm2 14a2 2 0 0 1 0-4h10v4Zm2-12h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2" })
), ni = h(q1), I1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 9h-2V7a1 1 0 0 0-2 0v2H7a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2m5 6V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3M4 15V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1m17-9a1 1 0 0 0-1 1v10a3 3 0 0 1-3 3H7a1 1 0 0 0 0 2h10a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1" })
), wi = h(I1), W1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.17 2.06A13 13 0 0 0 19 1.87a12.94 12.94 0 0 0-7 2.05 12.94 12.94 0 0 0-7-2 13 13 0 0 0-2.17.19 1 1 0 0 0-.83 1v12a1 1 0 0 0 1.17 1 10.9 10.9 0 0 1 8.25 1.91l.12.07h.11a.9.9 0 0 0 .7 0h.11l.12-.07A10.9 10.9 0 0 1 20.83 16 1 1 0 0 0 22 15V3a1 1 0 0 0-.83-.94M11 15.35a12.9 12.9 0 0 0-6-1.48H4v-10a9 9 0 0 1 1 0 10.86 10.86 0 0 1 6 1.8Zm9-1.44h-1a12.9 12.9 0 0 0-6 1.48V5.67a10.86 10.86 0 0 1 6-1.8 9 9 0 0 1 1 0Zm1.17 4.15a13 13 0 0 0-2.17-.19 12.94 12.94 0 0 0-7 2.05 12.94 12.94 0 0 0-7-2.05 13 13 0 0 0-2.17.19A1 1 0 0 0 2 19.21a1 1 0 0 0 1.17.79 10.9 10.9 0 0 1 8.25 1.91 1 1 0 0 0 1.16 0A10.9 10.9 0 0 1 20.83 20a1 1 0 0 0 1.17-.79 1 1 0 0 0-.83-1.15" })
), vi = h(W1), G1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.18 10.19A12 12 0 0 0 18 10c-.42 0-.83 0-1.24.08a5.9 5.9 0 0 0-1.91-1.65 3.8 3.8 0 0 0 1-2.57 3.86 3.86 0 0 0-7.72 0 3.8 3.8 0 0 0 1 2.57 6.1 6.1 0 0 0-1.91 1.64C6.83 10 6.42 10 6 10a12 12 0 0 0-2.18.21 1 1 0 0 0-.82 1v8.25a1 1 0 0 0 .36.77 1 1 0 0 0 .82.22A9.8 9.8 0 0 1 6 20.23a9.9 9.9 0 0 1 5.45 1.63l.13.05A1.1 1.1 0 0 0 12 22a.9.9 0 0 0 .28-.05h.07l.13-.05A9.9 9.9 0 0 1 18 20.23a9.8 9.8 0 0 1 1.82.18 1 1 0 0 0 .82-.22 1 1 0 0 0 .36-.77v-8.25a1 1 0 0 0-.82-.98M12 4a1.86 1.86 0 0 1 0 3.71A1.86 1.86 0 0 1 12 4m-1 15.33a11.9 11.9 0 0 0-5-1.1c-.33 0-.66 0-1 .05V12a9.6 9.6 0 0 1 2.52.05h.11A10 10 0 0 1 11 13.33Zm1-7.73a12 12 0 0 0-1.38-.68h-.06c-.33-.13-.66-.26-1-.36A4 4 0 0 1 12 9.69a4 4 0 0 1 2.44.85A12.4 12.4 0 0 0 12 11.6m7 6.68a11.6 11.6 0 0 0-6 1v-6a9.8 9.8 0 0 1 3.37-1.22h.2A9.4 9.4 0 0 1 19 12Z" })
), mi = h(G1), O1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 6H9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m-1 4h-4V8h4Zm3-8H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h12a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H6V4h11a1 1 0 0 1 1 1Z" })
), ci = h(O1), N1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 2H6a1 1 0 0 0-1 1v18a1 1 0 0 0 1.65.76L12 17.27l5.29 4.44A1 1 0 0 0 18 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 19 21V3a1 1 0 0 0-1-1m-1 16.86-4.36-3.66a1 1 0 0 0-1.28 0L7 18.86V4h10Z" })
), si = h(N1), Q1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 2H8a3 3 0 0 0-3 3v16a1 1 0 0 0 .5.87 1 1 0 0 0 1 0l5.5-3.18 5.5 3.18a1 1 0 0 0 .5.13 1 1 0 0 0 .5-.13A1 1 0 0 0 19 21V5a3 3 0 0 0-3-3m1 17.27-4.5-2.6a1 1 0 0 0-1 0L7 19.27V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Z" })
), gi = h(Q1), K1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m22.47 18.82-1-3.86-3.15-11.59a1 1 0 0 0-1.22-.71l-3.87 1a1 1 0 0 0-.73-.33h-10a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-8l2.2 8.22a1 1 0 0 0 1 .74 1.2 1.2 0 0 0 .26 0L21.79 20a1 1 0 0 0 .61-.47 1.05 1.05 0 0 0 .07-.71m-16 .55h-3v-2h3Zm0-4h-3v-6h3Zm0-8h-3v-2h3Zm5 12h-3v-2h3Zm0-4h-3v-6h3Zm0-8h-3v-2h3Zm2.25-1.74 2.9-.78.52 1.93-2.9.78Zm2.59 9.66-1.55-5.8 2.9-.78 1.55 5.8Zm1 3.86-.52-1.93 2.9-.78.52 1.93Z" })
), ii = h(K1), j1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.62-8.2A3 3 0 0 0 15 9a3 3 0 0 0-6 0 3 3 0 0 0 .62 1.8 4 4 0 1 0 4.76 0M12 8a1 1 0 1 1-1 1 1 1 0 0 1 1-1m0 8a2 2 0 1 1 2-2 2 2 0 0 1-2 2" })
), di = h(j1), J1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.5 18.5a1 1 0 1 0 1 1 1 1 0 0 0-1-1m9-15a1 1 0 0 0-1-1h-16a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0v-15h15a1 1 0 0 0 1-1m-5 15a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-8 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), pi = h(J1), Y1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 13.5a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0 4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0-8a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-4-4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0 8a1 1 0 1 0-1-1 1 1 0 0 0 1 1m12-8a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-4 8a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-4-8a1 1 0 1 0-1-1 1 1 0 0 0 1 1m4 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m4 10a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2m0-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-16 6a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0-4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0 8a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0-12a1 1 0 1 0-1-1 1 1 0 0 0 1 1" })
), fi = h(Y1), X1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1M4 3a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m16-6a1 1 0 1 0-1-1 1 1 0 0 0 1 1M4 19a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-8 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12 12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-8 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), Ei = h(X1), _1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 5a1 1 0 1 0-1-1 1 1 0 0 0 1 1M4 9a1 1 0 1 0-1-1 1 1 0 0 0 1 1m8 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1M4 5a1 1 0 1 0-1-1 1 1 0 0 0 1 1m12 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-4 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m8 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1M4 19a1 1 0 1 0 1 1 1 1 0 0 0-1-1m16 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2m-4 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1M4 15a1 1 0 1 0 1 1 1 1 0 0 0-1-1m16-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1M8 19a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), xi = h(_1), z1 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 5a1 1 0 1 0-1-1 1 1 0 0 0 1 1M4 9a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0-4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0 14a1 1 0 1 0 1 1 1 1 0 0 0-1-1M20 5a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0 4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-4-4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m4 14a1 1 0 1 0 1 1 1 1 0 0 0-1-1M4 15a1 1 0 1 0 1 1 1 1 0 0 0-1-1m16 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m5-7a1 1 0 0 0-1-1h-7V4a1 1 0 0 0-2 0v7H4a1 1 0 0 0 0 2h7v7a1 1 0 0 0 2 0v-7h7a1 1 0 0 0 1-1M8 19a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), Ai = h(z1), a2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.5 19a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-8-8a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1m16 2a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-8 2a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-16a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-8-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8 16a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 16a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), Mi = h(a2), t2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 9a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0 4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m4 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-4 4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m8-14H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m-1 16H5V5h14ZM8 13a1 1 0 1 0-1-1 1 1 0 0 0 1 1" })
), Hi = h(t2), e2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.5 7a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 16a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-16a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8 0a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1m-4 16a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), Ci = h(e2), l2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 18.5a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-8-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-14h16a1 1 0 0 0 0-2H4a1 1 0 0 0 0 2m0 10a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-8-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-8 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), ui = h(l2), r2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 3a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m16-2a1 1 0 1 0-1-1 1 1 0 0 0 1 1M7 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1M7 3a1 1 0 1 0 1 1 1 1 0 0 0-1-1M3 15a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m16-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 0a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1m4 16a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), Vi = h(r2), h2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.992 8.002a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4-6a10 10 0 1 0 10 10 10.01 10.01 0 0 0-10-10m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8m-1-10a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), Si = h(h2), o2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.49 7.52a.2.2 0 0 1 0-.08.2.2 0 0 1 0-.07v-.09l-.06-.15a.5.5 0 0 0-.09-.11l-.09-.08h-.05l-3.94-2.49-3.72-2.3a.9.9 0 0 0-.29-.15h-.08a.8.8 0 0 0-.27 0h-.1a1.1 1.1 0 0 0-.33.13L4 6.78l-.09.07-.09.08-.1.07-.05.06-.06.15v.15a.7.7 0 0 0 0 .2v8.73a1 1 0 0 0 .47.85l7.5 4.64.15.06h.08a.86.86 0 0 0 .52 0h.08l.15-.06L20 17.21a1 1 0 0 0 .47-.85V7.63s.02-.07.02-.11M12 4.17l1.78 1.1-5.59 3.46-1.79-1.1Zm-1 15-5.5-3.36V9.42l5.5 3.4Zm1-8.11-1.91-1.15 5.59-3.47 1.92 1.19Zm6.5 4.72L13 19.2v-6.38l5.5-3.4Z" })
), Li = h(o2), n2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6 6a2 2 0 0 1 2-2 1 1 0 0 0 0-2 4 4 0 0 0-4 4v3a2 2 0 0 1-2 2 1 1 0 0 0 0 2 2 2 0 0 1 2 2v3a4 4 0 0 0 4 4 1 1 0 0 0 0-2 2 2 0 0 1-2-2v-3a4 4 0 0 0-1.38-3A4 4 0 0 0 6 9Zm16 5a2 2 0 0 1-2-2V6a4 4 0 0 0-4-4 1 1 0 0 0 0 2 2 2 0 0 1 2 2v3a4 4 0 0 0 1.38 3A4 4 0 0 0 18 15v3a2 2 0 0 1-2 2 1 1 0 0 0 0 2 4 4 0 0 0 4-4v-3a2 2 0 0 1 2-2 1 1 0 0 0 0-2" })
), Zi = h(n2), w2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 11a4 4 0 0 0-2-3.48A3 3 0 0 0 20 7a3 3 0 0 0-3-3h-.18A3 3 0 0 0 12 2.78 3 3 0 0 0 7.18 4H7a3 3 0 0 0-3 3 3 3 0 0 0 0 .52 4 4 0 0 0-.55 6.59A4 4 0 0 0 7 20h.18A3 3 0 0 0 12 21.22 3 3 0 0 0 16.82 20H17a4 4 0 0 0 3.5-5.89A4 4 0 0 0 22 11M11 8.55a5 5 0 0 0-.68-.32 1 1 0 0 0-.64 1.9A2 2 0 0 1 11 12v1.55a5 5 0 0 0-.68-.32 1 1 0 0 0-.64 1.9A2 2 0 0 1 11 17v2a1 1 0 0 1-1 1 1 1 0 0 1-.91-.6 4 4 0 0 0 .48-.33 1 1 0 1 0-1.28-1.54A2 2 0 0 1 7 18a2 2 0 0 1-2-2 2 2 0 0 1 .32-1.06A4 4 0 0 0 6 15a1 1 0 0 0 0-2 1.8 1.8 0 0 1-.69-.13A2 2 0 0 1 5 9.25a3 3 0 0 0 .46.35 1 1 0 1 0 1-1.74.9.9 0 0 1-.34-.33A.9.9 0 0 1 6 7a1 1 0 0 1 1-1 .8.8 0 0 1 .21 0 4 4 0 0 0 .19.47 1 1 0 0 0 1.37.37 1 1 0 0 0 .36-1.34A1.06 1.06 0 0 1 9 5a1 1 0 0 1 2 0Zm7.69 4.32A1.8 1.8 0 0 1 18 13a1 1 0 0 0 0 2 4 4 0 0 0 .68-.06A2 2 0 0 1 19 16a2 2 0 0 1-2 2 2 2 0 0 1-1.29-.47 1 1 0 0 0-1.28 1.54 4 4 0 0 0 .48.33 1 1 0 0 1-.91.6 1 1 0 0 1-1-1v-2a2 2 0 0 1 1.32-1.87 1 1 0 0 0-.64-1.9 5 5 0 0 0-.68.32V12a2 2 0 0 1 1.32-1.87 1 1 0 0 0-.64-1.9 5 5 0 0 0-.68.32V5a1 1 0 0 1 2 0 1.06 1.06 0 0 1-.13.5 1 1 0 0 0 .36 1.37 1 1 0 0 0 1.37-.37 4 4 0 0 0 .19-.5.8.8 0 0 1 .21 0 1 1 0 0 1 1 1 1 1 0 0 1-.17.55.9.9 0 0 1-.33.31 1 1 0 0 0 1 1.74 2.7 2.7 0 0 0 .5-.35 2 2 0 0 1-.27 3.62Z" })
), Bi = h(w2), v2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6.5h-3v-1a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3m-9-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm10 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V13a21 21 0 0 0 3 .94v.59a1 1 0 0 0 2 0v-.21a23 23 0 0 0 3 .21 23 23 0 0 0 3-.21v.21a1 1 0 0 0 2 0v-.59a21 21 0 0 0 3-.94Zm0-7.69a20.4 20.4 0 0 1-3 1v-.31a1 1 0 0 0-2 0v.74a20.1 20.1 0 0 1-6 0v-.74a1 1 0 0 0-2 0v.33a20.4 20.4 0 0 1-3-1V9.5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), Fi = h(v2), m2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 6h-4V5a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v1H3a1 1 0 0 0-1 1v4a3 3 0 0 0 1 2.22V19a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5.78A3 3 0 0 0 22 11V7a1 1 0 0 0-1-1M9 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1H9Zm10 14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-5h2v1a1 1 0 0 0 2 0v-1h6v1a1 1 0 0 0 2 0v-1h2Zm1-8a1 1 0 0 1-1 1h-2v-1a1 1 0 0 0-2 0v1H9v-1a1 1 0 0 0-2 0v1H5a1 1 0 0 1-1-1V8h16Z" })
), Ri = h(m2), c2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2m9.71-2.71L19.36 9V5.64a1 1 0 0 0-1-1h-3.31l-2.34-2.35a1 1 0 0 0-1.42 0L9 4.64H5.64a1 1 0 0 0-1 1V9l-2.35 2.29a1 1 0 0 0 0 1.42l2.35 2.34v3.31a1 1 0 0 0 1 1H9l2.34 2.35a1 1 0 0 0 1.42 0l2.34-2.35h3.31a1 1 0 0 0 1-1v-3.31l2.35-2.34a1 1 0 0 0-.05-1.42m-4.05 2.64a1 1 0 0 0-.3.71v2.72h-2.72a1 1 0 0 0-.71.3L12 19.59l-1.93-1.93a1 1 0 0 0-.71-.3H6.64v-2.72a1 1 0 0 0-.3-.71L4.41 12l1.93-1.93a1 1 0 0 0 .3-.71V6.64h2.72a1 1 0 0 0 .71-.3L12 4.41l1.93 1.93a1 1 0 0 0 .71.3h2.72v2.72a1 1 0 0 0 .3.71L19.59 12Z" })
), Ui = h(c2), s2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 11.29 19.36 9V5.64a1 1 0 0 0-1-1h-3.31l-2.34-2.35a1 1 0 0 0-1.42 0L9 4.64H5.64a1 1 0 0 0-1 1V9l-2.35 2.29a1 1 0 0 0 0 1.42l2.35 2.34v3.31a1 1 0 0 0 1 1H9l2.34 2.35a1 1 0 0 0 1.42 0l2.34-2.35h3.31a1 1 0 0 0 1-1v-3.31l2.35-2.34a1 1 0 0 0-.05-1.42m-4.05 2.64a1 1 0 0 0-.3.71v2.72h-2.72a1 1 0 0 0-.71.3L12 19.59l-1.93-1.93a1 1 0 0 0-.71-.3H6.64v-2.72a1 1 0 0 0-.3-.71L4.41 12l1.93-1.93a1 1 0 0 0 .3-.71V6.64h2.72a1 1 0 0 0 .71-.3L12 4.41l1.93 1.93a1 1 0 0 0 .71.3h2.72v2.72a1 1 0 0 0 .3.71L19.59 12Z" })
), $i = h(s2), g2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 8a1 1 0 0 0 0 2 2 2 0 0 1 0 4 1 1 0 0 0 0 2 4 4 0 0 0 0-8m9.71 3.29L19.36 9V5.64a1 1 0 0 0-1-1h-3.31l-2.34-2.35a1 1 0 0 0-1.42 0L9 4.64H5.64a1 1 0 0 0-1 1V9l-2.35 2.29a1 1 0 0 0 0 1.42l2.35 2.34v3.31a1 1 0 0 0 1 1H9l2.34 2.35a1 1 0 0 0 1.42 0l2.34-2.35h3.31a1 1 0 0 0 1-1v-3.31l2.35-2.34a1 1 0 0 0-.05-1.42m-4.05 2.64a1 1 0 0 0-.3.71v2.72h-2.72a1 1 0 0 0-.71.3L12 19.59l-1.93-1.93a1 1 0 0 0-.71-.3H6.64v-2.72a1 1 0 0 0-.3-.71L4.41 12l1.93-1.93a1 1 0 0 0 .3-.71V6.64h2.72a1 1 0 0 0 .71-.3L12 4.41l1.93 1.93a1 1 0 0 0 .71.3h2.72v2.72a1 1 0 0 0 .3.71L19.59 12Z" })
), yi = h(g2), i2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m1.93 6.66a1 1 0 1 0 1.41 0 1 1 0 0 0-1.41 0M6.34 6.34a1 1 0 1 0-1.41 0 1 1 0 0 0 1.41 0M12 4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m5.66 13.66a1 1 0 1 0 1.41 0 1 1 0 0 0-1.41 0M21 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3.34-6.07a1 1 0 1 0 1.41 0 1 1 0 0 0-1.41 0M12 20a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6m0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4" })
), ki = h(i2), d2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 11h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m7.71.29L19.36 9V5.64a1 1 0 0 0-1-1h-3.31l-2.34-2.35a1 1 0 0 0-1.42 0L9 4.64H5.64a1 1 0 0 0-1 1V9l-2.35 2.29a1 1 0 0 0 0 1.42l2.35 2.34v3.31a1 1 0 0 0 1 1H9l2.34 2.35a1 1 0 0 0 1.42 0l2.34-2.35h3.31a1 1 0 0 0 1-1v-3.31l2.35-2.34a1 1 0 0 0-.05-1.42m-4.05 2.64a1 1 0 0 0-.3.71v2.72h-2.72a1 1 0 0 0-.71.3L12 19.59l-1.93-1.93a1 1 0 0 0-.71-.3H6.64v-2.72a1 1 0 0 0-.3-.71L4.41 12l1.93-1.93a1 1 0 0 0 .3-.71V6.64h2.72a1 1 0 0 0 .71-.3L12 4.41l1.93 1.93a1 1 0 0 0 .71.3h2.72v2.72a1 1 0 0 0 .3.71L19.59 12Z" })
), bi = h(d2), p2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 11h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m7.71.29L19.36 9V5.64a1 1 0 0 0-1-1h-3.31l-2.34-2.35a1 1 0 0 0-1.42 0L9 4.64H5.64a1 1 0 0 0-1 1V9l-2.35 2.29a1 1 0 0 0 0 1.42l2.35 2.34v3.31a1 1 0 0 0 1 1H9l2.34 2.35a1 1 0 0 0 1.42 0l2.34-2.35h3.31a1 1 0 0 0 1-1v-3.31l2.35-2.34a1 1 0 0 0-.05-1.42m-4.05 2.64a1 1 0 0 0-.3.71v2.72h-2.72a1 1 0 0 0-.71.3L12 19.59l-1.93-1.93a1 1 0 0 0-.71-.3H6.64v-2.72a1 1 0 0 0-.3-.71L4.41 12l1.93-1.93a1 1 0 0 0 .3-.71V6.64h2.72a1 1 0 0 0 .71-.3L12 4.41l1.93 1.93a1 1 0 0 0 .71.3h2.72v2.72a1 1 0 0 0 .3.71L19.59 12Z" })
), Ti = h(p2), f2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 12a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1m.64 5-.71.71a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l.71-.71A1 1 0 0 0 5.64 17M12 5a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1m5.66 2.34a1 1 0 0 0 .7-.29l.71-.71a1 1 0 1 0-1.41-1.41l-.66.71a1 1 0 0 0 0 1.41 1 1 0 0 0 .66.29m-12-.29a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.43 1.41ZM21 11h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m-2.64 6A1 1 0 0 0 17 18.36l.71.71a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41ZM12 6.5a5.5 5.5 0 1 0 5.5 5.5A5.51 5.51 0 0 0 12 6.5m0 9a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5m0 3.5a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1" })
), Pi = h(f2), E2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 14h-2a1 1 0 1 0 0 2h1v4H4v-4h7a1 1 0 0 0 0-2h-1V9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M4 10h4v4H4Zm8.71-3.3L14 5.41V17a1 1 0 1 0 2 0V5.41l1.29 1.29A1 1 0 0 0 18 7a1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-3-3a1 1 0 0 0-1.42 0l-3 3a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42-.01" })
), Di = h(E2), x2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 17.3 10 18.59V7a1 1 0 0 0-2 0v11.6l-1.29-1.3a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l3 3a1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0M22 3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2H4V4h16v4h-7a1 1 0 0 0 0 2h1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9Zm-2 11h-4v-4h4Z" })
), qi = h(x2), A2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H9a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1h1a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-3 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7h12Zm0-9H4V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm4 5a1 1 0 0 1-1 1h-1V9a3 3 0 0 0-.18-1H20Zm0-9H8V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z" })
), Ii = h(A2), M2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 18a1 1 0 1 0 1 1 1 1 0 0 0-1-1m6-17H6a1 1 0 0 0-1 1v9a3 3 0 0 0 3 3h1v2.37a4 4 0 1 0 6 0V14h1a3 3 0 0 0 3-3V2a1 1 0 0 0-1-1m-6 20a2 2 0 0 1-1.33-3.48 1 1 0 0 0 .33-.74V14h2v2.78a1 1 0 0 0 .33.74A2 2 0 0 1 12 21m5-10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1h10Zm0-3H7V3h10Z" })
), Wi = h(M2), H2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 14h2a1 1 0 0 0 0-2h-2v-1a5.2 5.2 0 0 0-.21-1.36A5 5 0 0 0 22 5a1 1 0 0 0-2 0 3 3 0 0 1-2.14 2.87A5 5 0 0 0 16 6.4a2.6 2.6 0 0 0 0-.4 4 4 0 0 0-8 0 2.6 2.6 0 0 0 0 .4 5 5 0 0 0-1.9 1.47A3 3 0 0 1 4 5a1 1 0 0 0-2 0 5 5 0 0 0 3.21 4.64A5.2 5.2 0 0 0 5 11v1H3a1 1 0 0 0 0 2h2v1a7 7 0 0 0 .14 1.38A5 5 0 0 0 2 21a1 1 0 0 0 2 0 3 3 0 0 1 1.81-2.74 7 7 0 0 0 12.38 0A3 3 0 0 1 20 21a1 1 0 0 0 2 0 5 5 0 0 0-3.14-4.62A7 7 0 0 0 19 15Zm-8 5.9A5 5 0 0 1 7 15v-4a3 3 0 0 1 3-3h1ZM10 6a2 2 0 0 1 4 0Zm7 9a5 5 0 0 1-4 4.9V8h1a3 3 0 0 1 3 3Z" })
), Gi = h(H2), C2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 8h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m0 4h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2M9 8h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m0 4h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m12 8h-1V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v17H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-8 0h-2v-4h2Zm5 0h-3v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5H6V4h12Z" })
), Oi = h(C2), u2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 5a7 7 0 1 0 7 7 7 7 0 0 0-7-7m0 12a5 5 0 1 1 5-5 5 5 0 0 1-5 5m0-8a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m0-12a11 11 0 1 0 11 11A11 11 0 0 0 12 1m0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9" })
), Ni = h(u2), V2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.5 2h-12a3 3 0 0 0-3 3v12a3 3 0 0 0 2 2.82V21a1 1 0 0 0 2 0v-1h10v1a1 1 0 0 0 2 0v-1.18a3 3 0 0 0 2-2.82V5a3 3 0 0 0-3-3m-13 6h6v4h-6Zm14 9a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-3h14Zm0-5h-6V8h6Zm0-6h-14V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Zm-3.38 10.92a1 1 0 0 0 .38.08 1 1 0 0 0 1-1 1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.06-.18.8.8 0 0 0-.09-.18 2 2 0 0 0-.12-.15l-.15-.12a.8.8 0 0 0-.18-.09.6.6 0 0 0-.2-.08 1 1 0 0 0-.91.27 2 2 0 0 0-.12.15.8.8 0 0 0-.09.18.6.6 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 .29.7 1 1 0 0 0 .31.24m-8 0a1 1 0 0 0 .38.08 1 1 0 0 0 1-1 1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.06-.18.8.8 0 0 0-.09-.18 2 2 0 0 0-.12-.15l-.15-.12-.18-.09-.2-.08a1 1 0 0 0-.91.27 2 2 0 0 0-.12.15.8.8 0 0 0-.09.18.6.6 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 .29.7 1 1 0 0 0 .31.24" })
), Qi = h(V2), S2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M1 12.5v4a1 1 0 0 0 1 1h1a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h1a1 1 0 0 0 1-1v-10a3 3 0 0 0-3-3H8.44A3 3 0 0 0 5.6 5.55L4.16 9.86l-2.71 1.81a1 1 0 0 0-.45.83m20-3h-2v-4h1a1 1 0 0 1 1 1Zm-4 8a1 1 0 1 1 1 1 1 1 0 0 1-1-1m-2-6h6v4h-.78a3 3 0 0 0-4.44 0H15Zm0-6h2v4h-2Zm-4 6h2v4h-2Zm0-6h2v4h-2Zm-2 4H6.39l1.1-3.32a1 1 0 0 1 .95-.68H9Zm-4 8a1 1 0 1 1 1 1 1 1 0 0 1-1-1M3 13l2.3-1.5H9v4h-.78a3 3 0 0 0-4.44 0H3Z" })
), Ki = h(S2), L2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 17a1 1 0 0 0 1-1 1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.06-.18.8.8 0 0 0-.09-.18l-.12-.15a1 1 0 0 0-.33-.21 1 1 0 0 0-.6-.08l-.18.06-.18.09a2 2 0 0 0-.15.12l-.12.15a.8.8 0 0 0-.09.18.6.6 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 1 1Zm8 0a1 1 0 0 0 1-1 1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.06-.18.8.8 0 0 0-.09-.18l-.12-.15a1.2 1.2 0 0 0-.33-.21 1 1 0 0 0-.76 0 1.2 1.2 0 0 0-.33.21l-.12.15a.8.8 0 0 0-.09.18.6.6 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 .29.7 1 1 0 0 0 .67.3m-3-12h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m5-3h-12a3 3 0 0 0-3 3v12a3 3 0 0 0 2 2.82V21a1 1 0 0 0 2 0v-1h10v1a1 1 0 0 0 2 0v-1.18a3 3 0 0 0 2-2.82V5a3 3 0 0 0-3-3m1 15a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-3h14Zm0-5h-14V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Z" })
), ji = h(L2), Z2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5.5 8H6v.5a1 1 0 0 0 2 0V8h.5a1 1 0 0 0 0-2H8v-.5a1 1 0 0 0-2 0V6h-.5a1 1 0 0 0 0 2m-.62 11.12a1 1 0 0 0 1.41 0l.71-.71.71.71a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41L8.41 17l.71-.71a1 1 0 0 0-1.41-1.41l-.71.71-.71-.71a1 1 0 0 0-1.41 1.41l.71.71-.71.71a1 1 0 0 0 0 1.41M20 1H4a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3m-9 20H4a1 1 0 0 1-1-1v-7h8Zm0-10H3V4a1 1 0 0 1 1-1h7Zm10 9a1 1 0 0 1-1 1h-7v-8h8Zm0-9h-8V3h7a1 1 0 0 1 1 1Zm-5.5 5.5h3a1 1 0 0 0 0-2h-3a1 1 0 0 0 0 2m3-10.5h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2m-3 13.5h3a1 1 0 0 0 0-2h-3a1 1 0 0 0 0 2" })
), Ji = h(Z2), B2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.71 17.29a1 1 0 0 0-.16-.12.6.6 0 0 0-.17-.09.6.6 0 0 0-.19-.06.93.93 0 0 0-.57.06.9.9 0 0 0-.54.54.84.84 0 0 0-.08.38 1 1 0 0 0 .07.38 1.5 1.5 0 0 0 .22.33A1 1 0 0 0 12 19a.84.84 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21A1 1 0 0 0 13 18a1 1 0 0 0-.08-.38 1 1 0 0 0-.21-.33m-4.16-4.12a.6.6 0 0 0-.17-.09.6.6 0 0 0-.19-.08.86.86 0 0 0-.39 0l-.18.06-.18.09-.15.12A1.05 1.05 0 0 0 7 14a1 1 0 0 0 .29.71 1.2 1.2 0 0 0 .33.21A1 1 0 0 0 9 14a1.05 1.05 0 0 0-.29-.71Zm.16 4.12a1 1 0 0 0-.33-.21A1 1 0 0 0 7.8 17l-.18.06a.8.8 0 0 0-.18.09 2 2 0 0 0-.15.12 1 1 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.33A1 1 0 0 0 8 19a.84.84 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21 1.2 1.2 0 0 0 .21-.33.94.94 0 0 0 0-.76 1 1 0 0 0-.21-.33m2.91-4.21a1 1 0 0 0-.33.21A1.05 1.05 0 0 0 11 14a1 1 0 0 0 1.38.92 1.2 1.2 0 0 0 .33-.21A1 1 0 0 0 13 14a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21m5.09 4.21a1.2 1.2 0 0 0-.33-.21 1 1 0 0 0-1.09.21 1 1 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.33A1 1 0 0 0 16 19a.84.84 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .21-1.09 1 1 0 0 0-.21-.33M16 5H8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1m-1 4H9V7h6Zm3-8H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3m1 19a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Zm-2.45-6.83a.6.6 0 0 0-.17-.09.6.6 0 0 0-.19-.06.86.86 0 0 0-.39 0l-.18.06-.18.09-.15.12A1.05 1.05 0 0 0 15 14a1 1 0 0 0 1.38.92 1.2 1.2 0 0 0 .33-.21A1 1 0 0 0 17 14a1.05 1.05 0 0 0-.29-.71Z" })
), Yi = h(B2), F2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 19a1 1 0 1 0-1-1 1 1 0 0 0 1 1m5 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0-4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-5 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m7-12h-1V2a1 1 0 0 0-2 0v1H8V2a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16Zm0-11H4V6a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V5h8v1a1 1 0 0 0 2 0V5h1a1 1 0 0 1 1 1ZM7 15a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0 4a1 1 0 1 0-1-1 1 1 0 0 0 1 1" })
), Xi = h(F2), R2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.66 7H15v1a1 1 0 0 0 2 0V7h1a1 1 0 0 1 1 1v3h-1.34a1 1 0 0 0 0 2H19v1.34a1 1 0 1 0 2 0V8a3 3 0 0 0-3-3h-1V4a1 1 0 0 0-2 0v1h-3.34a1 1 0 0 0 0 2m10.05 13.29-1.6-1.6-16.4-16.4a1 1 0 0 0-1.42 1.42l1.91 1.9A3 3 0 0 0 3 8v10a3 3 0 0 0 3 3h12a3 3 0 0 0 1.29-.3l1 1a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41M5 8a1 1 0 0 1 .66-.93L9.59 11H5Zm1 11a1 1 0 0 1-1-1v-5h6.59l6 6Z" })
), _i = h(R2), U2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 4h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7h16Zm0-9H4V7a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V6h6v1a1 1 0 0 0 2 0V6h2a1 1 0 0 1 1 1Z" })
), zi = h(U2), $2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.47 9a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-3 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-3 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m4.44 4c-.22 0-.45-.07-.67-.12a9.4 9.4 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.5 12.5 0 0 1-2.67-2 12.8 12.8 0 0 1-2-2.66L10 9a2 2 0 0 0 1-2.48 10 10 0 0 1-.39-1.31c-.05-.23-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-2.24 1 3 3 0 0 0-.73 2.39A19 19 0 0 0 18 21.91a2.6 2.6 0 0 0 .39 0 3 3 0 0 0 3-3v-3A3 3 0 0 0 18.91 13m.49 6a1 1 0 0 1-1.15 1 17.12 17.12 0 0 1-9.87-4.85 17.14 17.14 0 0 1-4.84-9.93 1 1 0 0 1 .25-.82 1 1 0 0 1 .74-.34h3a1 1 0 0 1 1 .79q.06.41.15.81a11 11 0 0 0 .46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.5 14.5 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .56-.52l.63-1.4a14 14 0 0 0 1.58.46c.26.06.54.11.81.15a1 1 0 0 1 .78 1Z" })
), ad = h($2), y2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m12.29 5.21 1.5 1.5a1 1 0 0 0 1.42 0 1 1 0 0 0 .13-1.21H19a1 1 0 0 0 0-2h-3.66a1 1 0 0 0-.13-1.21 1 1 0 0 0-1.42 0l-1.5 1.5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33m10.63 3.91a1 1 0 0 0-.21-.33l-1.5-1.5a1 1 0 0 0-1.42 0 1 1 0 0 0-.13 1.21H16a1 1 0 0 0 0 2h3.66a1 1 0 0 0 .13 1.21 1 1 0 0 0 1.42 0l1.5-1.5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76M11 10a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2m9-3a1 1 0 0 0-1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h2a1 1 0 0 0 1-.69l.54-1.62a1 1 0 0 1 .9-.69H10a1 1 0 0 0 0-2H8.44a3 3 0 0 0-2.85 2.06L5.28 8H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1" })
), td = h(y2), k2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 10.5a1 1 0 0 0-1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h2a1 1 0 0 0 1-.68l.54-1.64a1 1 0 0 1 .95-.68H14a1 1 0 0 0 0-2H8.44A3 3 0 0 0 5.6 6.55l-.32 1H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a1 1 0 0 0-1-1.05m-9-1a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2m11-11h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2" })
), ed = h(k2), b2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3.71 2.29a1 1 0 0 0-1.42 1.42l2.8 2.79H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14.08l1.21 1.22a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm6.49 9.33 2.68 2.68a2 2 0 0 1-.88.2 2 2 0 0 1-2-2 2 2 0 0 1 .2-.88M5 18.5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h2.07l1.7 1.69A3.92 3.92 0 0 0 8 12.5a4 4 0 0 0 4 4 3.92 3.92 0 0 0 2.32-.77l2.77 2.77Zm14-12h-1.28l-.31-1a3 3 0 0 0-2.85-2h-4.4a1 1 0 0 0 0 2h4.4a1 1 0 0 1 .95.68l.54 1.63a1 1 0 0 0 .95.69h2a1 1 0 0 1 1 1v5.84a1 1 0 1 0 2 0V9.5a3 3 0 0 0-3-3" })
), ld = h(b2), T2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6.5h-1.28l-.32-1a3 3 0 0 0-2.84-2H9.44A3 3 0 0 0 6.6 5.55l-.32 1H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3.05m1 11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h2a1 1 0 0 0 1-.68l.54-1.64a1 1 0 0 1 .95-.68h5.12a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .9.68h2a1 1 0 0 1 1 1Zm-8-9a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2" })
), rd = h(T2), P2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.77 11.36-5-6A1 1 0 0 0 16 5H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h11a1 1 0 0 0 .77-.36l5-6a1 1 0 0 0 0-1.28M15.53 17H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h10.53l4.17 5Zm-2.82-7.71a1 1 0 0 0-1.42 0L10 10.59l-1.29-1.3a1 1 0 1 0-1.42 1.42L8.59 12l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L11.41 12l1.3-1.29a1 1 0 0 0 0-1.42" })
), hd = h(P2), D2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.5 4.5a5.12 5.12 0 0 0-7.24 0L4.5 12.26a5.12 5.12 0 1 0 7.24 7.24l7.76-7.76a5.12 5.12 0 0 0 0-7.24m-9.18 13.59a3.21 3.21 0 0 1-4.41 0 3.13 3.13 0 0 1 0-4.41l3.18-3.18 4.41 4.41Zm7.77-7.77-3.18 3.18-4.41-4.41 3.18-3.18a3.12 3.12 0 0 1 4.41 4.41" })
), od = h(D2), q2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 9a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1m5 11H5a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h3a1 1 0 0 0 0-2m4-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2m7-12h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3m2 13a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 0 0 2h3a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1" })
), nd = h(q2), I2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 9.5h-.32l-1.25-3.12a3 3 0 0 0-2.78-1.88h-6A3 3 0 0 0 5.7 6.91L5.18 9.5H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1h1a3 3 0 0 0 6 0h4a3 3 0 0 0 6 0h1a1 1 0 0 0 1-1v-3a3 3 0 0 0-3-3m-6-3h1.65a1 1 0 0 1 .92.63l.95 2.37H13Zm-5.34.8a1 1 0 0 1 1-.8H11v3H7.22ZM7 17.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1m10 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1m3-3h-.78a3 3 0 0 0-4.44 0H9.22a3 3 0 0 0-4.44 0H4v-2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), wd = h(I2), W2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 13a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12.76-3.89-1.35-4.06a3 3 0 0 0-2.85-2h-5.9a1 1 0 0 0 0 2h5.9a1 1 0 0 1 1 .69L17.61 9h-1.95a1 1 0 0 0 0 2H19a1 1 0 0 1 1 1v3.34a1 1 0 1 0 2 0V12a3 3 0 0 0-2.24-2.89m-16-6.82a1 1 0 0 0-1.47 1.42l2.82 2.81-.87 2.59A3 3 0 0 0 2 12v4a3 3 0 0 0 2 2.82V20a1 1 0 0 0 2 0v-1h11.59l.41.41V20a1 1 0 0 0 1 1 .9.9 0 0 0 .46-.13l.83.84a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm3 5.81.9.9H6.39ZM5 17a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4.59l2 2H11a1 1 0 0 0 0 2h2a.9.9 0 0 0 .46-.13L15.59 17Z" })
), vd = h(W2), G2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.5 4a1 1 0 0 0 .71-.29l1-1a1 1 0 0 0-1.42-1.42l-1 1a1 1 0 0 0 0 1.42A1 1 0 0 0 7.5 4m4 0a1 1 0 0 0 .71-.29l1-1a1 1 0 1 0-1.42-1.42l-1 1a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29m4 0a1 1 0 0 0 .71-.29l1-1a1 1 0 1 0-1.42-1.42l-1 1a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29m2.42 11.62a.8.8 0 0 0-.09-.18l-.12-.15-.15-.12a.8.8 0 0 0-.18-.09.6.6 0 0 0-.19-.06 1 1 0 0 0-.9.27 2 2 0 0 0-.12.15.8.8 0 0 0-.09.18.6.6 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 .29.7.9.9 0 0 0 .33.22A1 1 0 0 0 17 17a1 1 0 0 0 1-1 1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.08-.18m1.84-4.51L18.4 7.05a3 3 0 0 0-2.84-2H8.44a3 3 0 0 0-2.84 2l-1.36 4.06A3 3 0 0 0 2 14v4a3 3 0 0 0 2 2.82V22a1 1 0 0 0 2 0v-1h12v1a1 1 0 0 0 2 0v-1.18A3 3 0 0 0 22 18v-4a3 3 0 0 0-2.24-2.89M7.49 7.68A1 1 0 0 1 8.44 7h7.12a1 1 0 0 1 1 .68L17.61 11H6.39ZM20 18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm-7-3h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m-5.08.62a.8.8 0 0 0-.09-.18l-.12-.15a1 1 0 0 0-1.09-.21 1 1 0 0 0-.33.21 2 2 0 0 0-.12.15.8.8 0 0 0-.09.18.6.6 0 0 0-.08.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 1.71.7A1 1 0 0 0 8 16a1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.08-.18" })
), md = h(G2), O2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.62 13.08a.9.9 0 0 0-.54.54 1 1 0 0 0 1.3 1.3 1.2 1.2 0 0 0 .33-.21 1.2 1.2 0 0 0 .21-.33A.84.84 0 0 0 8 14a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21m13.14-4L18.4 5.05a3 3 0 0 0-2.84-2H8.44a3 3 0 0 0-2.84 2L4.24 9.11A3 3 0 0 0 2 12v4a3 3 0 0 0 2 2.82V20a1 1 0 0 0 2 0v-1h12v1a1 1 0 0 0 2 0v-1.18A3 3 0 0 0 22 16v-4a3 3 0 0 0-2.24-2.89ZM7.49 5.68A1 1 0 0 1 8.44 5h7.12a1 1 0 0 1 1 .68L17.61 9H6.39ZM20 16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm-3.38-2.92a.9.9 0 0 0-.54.54 1 1 0 0 0 1.3 1.3.9.9 0 0 0 .54-.54A.84.84 0 0 0 18 14a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21M13 13h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2" })
), cd = h(O2), N2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 4.5H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3m1 12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm-4-6a3 3 0 0 0-1.51.42 3 3 0 1 0 0 5.16A3 3 0 1 0 16 10.5m-2.83 4a1 1 0 0 1-.17 0 1 1 0 0 1 0-2 1 1 0 0 1 .17 0 2.8 2.8 0 0 0 0 1.92Zm2.83 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), sd = h(N2), Q2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m19.5 11.13-14-8.08a1 1 0 0 0-1 0 1 1 0 0 0-.5.87v16.16a1 1 0 0 0 .5.87 1 1 0 0 0 1 0l14-8.08a1 1 0 0 0 0-1.74M6 18.35V5.65L17 12Z" })
), gd = h(Q2), K2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.49 4.73 17 2.17a1 1 0 0 0-1 0l-4 2.28-4-2.28a1 1 0 0 0-1 0L2.51 4.73A1 1 0 0 0 2 5.6v5.12a1 1 0 0 0 .51.87l4 2.27v4.54a1 1 0 0 0 .51.87l4.5 2.56a1 1 0 0 0 1 0L17 19.27a1 1 0 0 0 .51-.87v-4.54l4-2.27a1 1 0 0 0 .51-.87V5.6a1 1 0 0 0-.53-.87M4 10.14v-4l3.5-2 3.5 2v4l-3.5 2Zm11.5 7.68-3.5 2-3.5-2v-4l3.5-2 3.5 2Zm4.5-7.68-3.5 2-3.5-2v-4l3.5-2 3.5 2Z" })
), id = h(K2), j2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 19h-6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h6a1 1 0 0 0 0-2h-6a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h6a1 1 0 0 0 0-2M5 3a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), dd = h(j2), J2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 7h1v1a1 1 0 0 0 2 0V7h1a1 1 0 0 0 0-2h-1V4a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m2 9a3 3 0 0 0-1.73.56l-2.45-1.45A3.7 3.7 0 0 0 16 14a4 4 0 0 0-3-3.86V7.82a3 3 0 1 0-2 0v2.32A4 4 0 0 0 8 14a3.7 3.7 0 0 0 .18 1.11l-2.45 1.45A3 3 0 0 0 4 16a3 3 0 1 0 3 3 3 3 0 0 0-.12-.8l2.3-1.37a4 4 0 0 0 5.64 0l2.3 1.37A3 3 0 1 0 20 16M4 20a1 1 0 1 1 1-1 1 1 0 0 1-1 1m8-16a1 1 0 1 1-1 1 1 1 0 0 1 1-1m0 12a2 2 0 1 1 2-2 2 2 0 0 1-2 2m8 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), pd = h(J2), Y2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 16a3 3 0 0 0-1.73.56l-2.45-1.45A3.7 3.7 0 0 0 16 14a4 4 0 0 0-3-3.86V7.82a3 3 0 1 0-2 0v2.32A4 4 0 0 0 8 14a3.7 3.7 0 0 0 .18 1.11l-2.45 1.45A3 3 0 0 0 4 16a3 3 0 1 0 3 3 3 3 0 0 0-.12-.8l2.3-1.37a4 4 0 0 0 5.64 0l2.3 1.37A3 3 0 1 0 20 16M4 20a1 1 0 1 1 1-1 1 1 0 0 1-1 1m8-16a1 1 0 1 1-1 1 1 1 0 0 1 1-1m0 12a2 2 0 1 1 2-2 2 2 0 0 1-2 2m8 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), fd = h(Y2), X2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 20H4v-2h3a1 1 0 0 0 0-2H4v-2h11a1 1 0 0 0 0-2H4v-2h7a1 1 0 0 0 0-2H4V6h15a1 1 0 0 0 0-2H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2" })
), Ed = h(X2), _2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 20h-1V5a1 1 0 0 0-2 0v15h-2v-7a1 1 0 0 0-2 0v7h-2V9a1 1 0 0 0-2 0v11H8v-3a1 1 0 0 0-2 0v3H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2" })
), xd = h(_2), z2 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11a1 1 0 0 0-1 1v2.59l-6.29-6.3a1 1 0 0 0-1.42 0L9 11.59l-5.29-5.3a1 1 0 0 0-1.42 1.42l6 6a1 1 0 0 0 1.42 0l3.29-3.3L18.59 16H16a1 1 0 0 0 0 2h5a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 17v-5a1 1 0 0 0-1-1" })
), Ad = h(z2), a3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 20H4v-2h3a1 1 0 0 0 0-2H4v-2h7a1 1 0 0 0 0-2H4v-2h11a1 1 0 0 0 0-2H4V6h15a1 1 0 0 0 0-2H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2" })
), Md = h(a3), t3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 20h-1V5a1 1 0 0 0-2 0v15h-2V9a1 1 0 0 0-2 0v11h-2v-7a1 1 0 0 0-2 0v7H8v-3a1 1 0 0 0-2 0v3H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2" })
), Hd = h(t3), e3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 16a1.5 1.5 0 0 0 1.5-1.5 1 1 0 0 0 0-.15l2.79-2.79h.46l1.61 1.61v.08a1.5 1.5 0 1 0 3 0v-.08L20 9.5A1.5 1.5 0 1 0 18.5 8a1 1 0 0 0 0 .15l-3.61 3.61h-.16L13 10a1.49 1.49 0 0 0-3 0l-3 3a1.5 1.5 0 0 0 0 3m13.5 4h-17V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2" })
), Cd = h(e3), l3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 12h-7V5c0-.6-.4-1-1-1-5 0-9 4-9 9s4 9 9 9 9-4 9-9c0-.6-.4-1-1-1m-7 7.9c-3.8.6-7.4-2.1-7.9-5.9-.6-3.8 2.1-7.4 5.9-7.9V13c0 .6.4 1 1 1h6.9c-.4 3.1-2.8 5.5-5.9 5.9M15 2c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1 0-3.9-3.1-7-7-7m1 6V4.1c2 .4 3.5 1.9 3.9 3.9z" })
), ud = h(l3), r3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 4.93 18.69h.12A10 10 0 0 0 12 2m1 2.07A8 8 0 0 1 19.93 11H13ZM12 20a8 8 0 0 1-1-15.93V12a1.1 1.1 0 0 0 .07.35v.15l4 6.87A7.8 7.8 0 0 1 12 20m4.83-1.64L13.73 13h6.2a8 8 0 0 1-3.1 5.36" })
), Vd = h(r3), h3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 6a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m-5 6a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m10-2a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m2-8H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), Sd = h(h3), o3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.58 11.3a3.24 3.24 0 0 0 .71-2 3.29 3.29 0 0 0-6.58 0 3.24 3.24 0 0 0 .71 2 5 5 0 0 0-2 2.31 1 1 0 1 0 1.84.78A3 3 0 0 1 12 12.57a3 3 0 0 1 2.75 1.82 1 1 0 0 0 .92.61 1.1 1.1 0 0 0 .39-.08 1 1 0 0 0 .53-1.31 5 5 0 0 0-2.01-2.31M12 10.57a1.29 1.29 0 1 1 1.29-1.28A1.29 1.29 0 0 1 12 10.57M18 2H6a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h2.59l2.7 2.71A1 1 0 0 0 12 22a1 1 0 0 0 .65-.24L15.87 19H18a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 14a1 1 0 0 1-1 1h-2.5a1 1 0 0 0-.65.24l-2.8 2.4-2.34-2.35A1 1 0 0 0 9 17H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Z" })
), Ld = h(o3), n3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.29 3.71a1 1 0 0 0 1.42 0 1.2 1.2 0 0 0 .21-.33A1 1 0 0 0 21 3a1 1 0 0 0-.29-.71l-.15-.12a.8.8 0 0 0-.18-.09 1 1 0 0 0-1.09.21A1 1 0 0 0 19 3a1 1 0 0 0 .08.38 1.2 1.2 0 0 0 .21.33M20 5a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1m.06 8a1 1 0 0 0-1.11.87A7 7 0 0 1 12 20H6.41l.64-.63a1 1 0 0 0 0-1.41A7 7 0 0 1 12 6a6.9 6.9 0 0 1 3.49.94 1 1 0 0 0 1-1.72A8.84 8.84 0 0 0 12 4a9 9 0 0 0-7 14.62l-1.71 1.67a1 1 0 0 0-.21 1.09A1 1 0 0 0 4 22h8a9 9 0 0 0 8.93-7.88 1 1 0 0 0-.87-1.12" })
), Zd = h(n3), w3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 2H6a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h2.59l2.7 2.71A1 1 0 0 0 12 22a1 1 0 0 0 .65-.24L15.87 19H18a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 14a1 1 0 0 1-1 1h-2.5a1 1 0 0 0-.65.24l-2.8 2.4-2.34-2.35A1 1 0 0 0 9 17H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Z" })
), Bd = h(w3), v3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m14.72 8.79-4.29 4.3-1.65-1.65a1 1 0 1 0-1.41 1.41l2.35 2.36a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29l5-5a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), Fd = h(v3), m3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.21 14.75a1 1 0 0 0 1.42 0l4.08-4.08a1 1 0 0 0-1.42-1.42l-3.37 3.38-1.21-1.22a1 1 0 0 0-1.42 1.42ZM21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 18H4V4h16Z" })
), Rd = h(m3), c3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.71 7.21a1 1 0 0 0-1.42 0l-7.45 7.46-3.13-3.14A1 1 0 1 0 5.29 13l3.84 3.84a1 1 0 0 0 1.42 0l8.16-8.16a1 1 0 0 0 0-1.47" })
), Ud = h(c3), s3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 2a7 7 0 0 0-6.88 5.74A6 6 0 0 0 5 12.41 5 5 0 1 0 11.59 19a6 6 0 0 0 4.67-3.09A7 7 0 0 0 15 2m-5 15.43c0 .1 0 .2-.07.31a3 3 0 1 1-3.64-3.64l.28-.1A2.94 2.94 0 0 1 10 17.43m5-3.67a2 2 0 0 1-.05.19 4 4 0 0 1-.17.54 4 4 0 0 1-2.7 2.4c0-.18 0-.35-.06-.53s0-.27 0-.4-.12-.38-.18-.57-.07-.24-.12-.36a4 4 0 0 0-.3-.55c0-.09-.09-.19-.15-.28a5.3 5.3 0 0 0-.6-.73l-.2-.17a6 6 0 0 0-.53-.43 3 3 0 0 0-.34-.19 4 4 0 0 0-.5-.27 2.3 2.3 0 0 0-.4-.13 3 3 0 0 0-.52-.16c-.14 0-.29 0-.44-.06L7.13 12a4 4 0 0 1 2.39-2.7 3.3 3.3 0 0 1 .53-.17l.2-.05A3.7 3.7 0 0 1 11 9a4 4 0 0 1 4 4 4 4 0 0 1-.08.76Zm2-.16V13a6 6 0 0 0-6-6h-.6a5 5 0 1 1 6.6 6.6" })
), $d = h(s3), g3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), yd = h(g3), i3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 13a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m7 4a1 1 0 0 0 0-2h-2V9h2a1 1 0 0 0 0-2h-2.18A3 3 0 0 0 17 5.18V3a1 1 0 0 0-2 0v2h-2V3a1 1 0 0 0-2 0v2H9V3a1 1 0 0 0-2 0v2.18A3 3 0 0 0 5.18 7H3a1 1 0 0 0 0 2h2v2H3a1 1 0 0 0 0 2h2v2H3a1 1 0 0 0 0 2h2.18A3 3 0 0 0 7 18.82V21a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0v-2.18A3 3 0 0 0 18.82 17H21a1 1 0 0 0 0-2h-2v-2Zm-4 3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Zm-3-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), kd = h(i3), d3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-2.91 2-4 4H7.91l4-4ZM4 5a1 1 0 0 1 1-1h4.09l-4 4H4Zm16 14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16Zm0-11h-5.09l4-4H19a1 1 0 0 1 1 1Z" })
), bd = h(d3), p3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 12v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1v-1a1 1 0 0 0-2 0m10.664-1.748-9-8a1 1 0 0 0-1.328 0l-9 8a1 1 0 0 0 1.328 1.496L4 11.449V21a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9.551l.336.299a1 1 0 0 0 1.328-1.496M18 20H6V9.671l6-5.333 6 5.333Z" })
), Td = h(p3), f3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 14H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m0-4h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m2-6h-1.18A3 3 0 0 0 13 2h-2a3 3 0 0 0-2.82 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m-7 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm8 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h1a1 1 0 0 1 1 1Z" })
), Pd = h(f3), E3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 4h-1a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m-7 0h4v2h-4zm8 15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2h1a1 1 0 0 1 1 1Z" })
), Dd = h(E3), x3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 14H9a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m4-10h-1.18A3 3 0 0 0 13 2h-2a3 3 0 0 0-2.82 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m-7 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm8 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h1a1 1 0 0 1 1 1Zm-3-9H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" })
), qd = h(x3), A3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 4h-1.18A3 3 0 0 0 13 2h-2a3 3 0 0 0-2.82 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m-7 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm8 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h1a1 1 0 0 1 1 1Z" })
), Id = h(A3), M3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 6a1 1 0 0 0-1 1v4.384l-2.43 1.223a1 1 0 1 0 .898 1.786l2.981-1.5A1 1 0 0 0 13 12V7a1 1 0 0 0-1-1m0-4a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8" })
), Wd = h(M3), H3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8m1-8.251V7a1 1 0 0 0-2 0v5a1 1 0 0 0 .118.472l1.5 2.799a1 1 0 0 0 1.764-.944Z" })
), Gd = h(H3), C3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 6a1 1 0 0 0-1 1v4H9a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m0-4a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8" })
), Od = h(C3), u3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8m0-14a1 1 0 0 0-1 1v4.749l-1.382 2.578a1 1 0 0 0 1.764.944l1.5-2.799A1 1 0 0 0 13 12V7a1 1 0 0 0-1-1" })
), Nd = h(u3), V3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 6a1 1 0 0 0-1 1v3.268l-1.098-.634a1 1 0 0 0-1 1.732l2.598 1.5A1 1 0 0 0 13 12V7a1 1 0 0 0-1-1m0-4a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8" })
), Qd = h(V3), S3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 11h-2V7a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2m-3-9a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8" })
), Kd = h(S3), L3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8m2.098-10.366L13 10.268V7a1 1 0 0 0-2 0v5a1 1 0 0 0 1.5.866l2.598-1.5a1 1 0 1 0-1-1.732" })
), jd = h(L3), Z3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.098 12.634 13 11.423V7a1 1 0 0 0-2 0v5a1 1 0 0 0 .5.866l2.598 1.5a1 1 0 1 0 1-1.732M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8" })
), Jd = h(Z3), B3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8 7.92 7.92 0 0 1 1.69-4.9L7.2 8.61A3 3 0 0 0 6 11v2a3 3 0 0 0 5.59 1.5 1 1 0 1 0-1.72-1 1 1 0 0 1-1.58.19A.93.93 0 0 1 8 13v-2a1 1 0 0 1 .67-.92L12 13.46A3 3 0 0 0 14.54 16l2.36 2.36A7.92 7.92 0 0 1 12 20m6.31-3.1-1.52-1.52a2.9 2.9 0 0 0 .8-.88 1 1 0 1 0-1.72-1 1 1 0 0 1-.55.41L14 12.59V11a1 1 0 0 1 1.88-.48 1 1 0 0 0 1.37.34 1 1 0 0 0 .34-1.38 3 3 0 0 0-.46-.59A3 3 0 0 0 12 10.62l-.35-.35a1 1 0 0 0-.1-.79 3 3 0 0 0-.46-.59 2.94 2.94 0 0 0-1.67-.84L7.1 5.69A7.92 7.92 0 0 1 12 4a8 8 0 0 1 8 8 7.92 7.92 0 0 1-1.69 4.9" })
), Yd = h(B3), F3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.24 13.14a1 1 0 0 0-1.37.36 1 1 0 0 1-1.58.19A.93.93 0 0 1 8 13v-2a1 1 0 0 1 1.88-.48 1 1 0 0 0 1.37.34 1 1 0 0 0 .34-1.38 3 3 0 0 0-.46-.59A3 3 0 0 0 9 8a3 3 0 0 0-3 3v2a3 3 0 0 0 5.59 1.5 1 1 0 0 0-.35-1.36m6 0a1 1 0 0 0-1.37.36 1 1 0 0 1-1.58.19A.93.93 0 0 1 14 13v-2a1 1 0 0 1 1.88-.48 1 1 0 0 0 1.37.34 1 1 0 0 0 .34-1.38 3 3 0 0 0-.46-.59A3 3 0 0 0 15 8a3 3 0 0 0-3 3v2a3 3 0 0 0 5.59 1.5 1 1 0 0 0-.35-1.36M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), Xd = h(F3), R3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.42 7.72A7 7 0 0 0 5.06 9.61a4 4 0 0 0-.38 7.66 1.1 1.1 0 0 0 .32.05 1 1 0 0 0 .32-2A2 2 0 0 1 4 13.5a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 1 5.53 1 1 0 1 0 1 1.74A5 5 0 0 0 22 12.5a5 5 0 0 0-3.58-4.78m-9.25 6a4 4 0 1 0 5.66 0 4.1 4.1 0 0 0-5.66-.05ZM10 16.5a2 2 0 0 1 2-2 2 2 0 0 1 .51.07L10.07 17a2 2 0 0 1-.07-.5m3.41 1.41a2 2 0 0 1-1.91.5L13.93 16a2 2 0 0 1 .07.51 2 2 0 0 1-.59 1.4" })
), _d = h(R3), U3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 11h-5a1 1 0 0 0-1 1v8a1 1 0 0 0 1.56.83l1.94-1.3 1.89 1.26A1 1 0 0 0 15 21a1 1 0 0 0 .44-.1A1 1 0 0 0 16 20v-8a1 1 0 0 0-1-1m-1 7.12-.94-.63a1 1 0 0 0-1.12 0l-.94.64V13h3Zm4.42-10.9A7 7 0 0 0 5.06 9.11 4 4 0 0 0 6 17a1 1 0 0 0 0-2 2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 1 5.53 1 1 0 1 0 1 1.74A5 5 0 0 0 22 12a5 5 0 0 0-3.58-4.78" })
), zd = h(U3), $3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.29 14.19 11 17.48l-1.29-1.29a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l2 2a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0m4.13-5.87a7 7 0 0 0-13.36 1.9 4 4 0 0 0-.38 7.65A1 1 0 1 0 5.32 16 2 2 0 0 1 4 14.1a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.6 1 1 0 0 0 .78.66 3 3 0 0 1 .24 5.84 1 1 0 0 0 .25 2h.25a5 5 0 0 0 .17-9.62Z" })
), ap = h($3), y3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 20h-3a1 1 0 0 1-1-1v-3a5 5 0 0 0 1.42-9.78A7 7 0 0 0 5.06 8.11 4 4 0 0 0 6 16h1v3a1 1 0 0 1-1 1H3a1 1 0 0 0 0 2h3a3 3 0 0 0 3-3v-3h2v5a1 1 0 0 0 2 0v-5h2v3a3 3 0 0 0 3 3h3a1 1 0 0 0 0-2M6 14a2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67A3 3 0 0 1 20 11a3 3 0 0 1-3 3Z" })
), tp = h(y3), k3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 18.5h-6.18A3 3 0 0 0 13 16.68V13.5h3.17a4.33 4.33 0 0 0 1.3-8.5A6 6 0 0 0 6.06 6.63 3.5 3.5 0 0 0 7 13.5h4v3.18a3 3 0 0 0-1.82 1.82H3a1 1 0 0 0 0 2h6.18a3 3 0 0 0 5.64 0H21a1 1 0 0 0 0-2m-14-7a1.5 1.5 0 0 1 0-3 1 1 0 0 0 1-1 4 4 0 0 1 7.79-1.29 1 1 0 0 0 .78.67 2.31 2.31 0 0 1 1.93 2.29 2.34 2.34 0 0 1-2.33 2.33Zm5 9a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), ep = h(k3), b3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.5 14.5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2h-3v-3h2.33A3.66 3.66 0 0 0 13 4.37a5 5 0 0 0-9.43 1.28 3 3 0 0 0 .93 5.85h3v8a1 1 0 0 0 1 1h4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a2 2 0 0 0-.28-1 2 2 0 0 0 .28-1Zm-18-5a1 1 0 0 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 5.84-1 1 1 0 0 0 .78.66 1.65 1.65 0 0 1 1.38 1.67 1.67 1.67 0 0 1-1.67 1.67Zm8 9h-3v-2h3a2 2 0 0 0 .28 1 2 2 0 0 0-.28 1m2 2v-2h6v2Zm0-4v-2h6v2Z" })
), lp = h(b3), T3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.29 17.29 13 18.59V13a1 1 0 0 0-2 0v5.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l3 3a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l3-3a1 1 0 0 0-1.42-1.42m4.13-11.07A7 7 0 0 0 5.06 8.11 4 4 0 0 0 6 16a1 1 0 0 0 0-2 2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 .24 5.84 1 1 0 1 0 .5 1.94 5 5 0 0 0 .17-9.62" })
), rp = h(T3), P3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 19a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m-4-8a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m0 5a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m4-2a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m6.42-7.78A7 7 0 0 0 5.06 8.11 4 4 0 0 0 2 12a4 4 0 0 0 1.34 3 1 1 0 1 0 1.32-1.5A2 2 0 0 1 4 12a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67A3 3 0 0 1 20 11a2.9 2.9 0 0 1-.74 2 1 1 0 0 0 1.48 1.34 5 5 0 0 0-2.32-8.08ZM16 11a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m0 5a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m-4-7a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1" })
), hp = h(P3), D3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.71 18.79a1.2 1.2 0 0 0-.33-.21 1 1 0 0 0-1.09.21 1.05 1.05 0 0 0-.29.71 1 1 0 0 0 .29.71 1.2 1.2 0 0 0 .33.21 1 1 0 0 0 1.3-1.3 1 1 0 0 0-.21-.33M12 12.5a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m6.42-4.79a7 7 0 0 0-13.36 1.9A4 4 0 0 0 6 17.5h2a1 1 0 0 0 0-2H6a2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.66A3 3 0 0 1 17 15.5h-1a1 1 0 0 0 0 2h1a5 5 0 0 0 1.42-9.79" })
), op = h(D3), q3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 17a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 2a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 2a1 1 0 1 0 1 1 1 1 0 0 0-1-1m2.42-4.78A7 7 0 0 0 5.06 8.11 4 4 0 0 0 2 12a4 4 0 0 0 1.34 3 1 1 0 1 0 1.32-1.5A2 2 0 0 1 4 12a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67A3 3 0 0 1 20 11a2.9 2.9 0 0 1-.74 2 1 1 0 0 0 1.48 1.34 5 5 0 0 0-2.32-8.08ZM16 19a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), np = h(q3), I3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.42 7.72A7 7 0 0 0 5.06 9.61a4 4 0 0 0-.38 7.66 1.1 1.1 0 0 0 .32.05 1 1 0 0 0 .32-2A2 2 0 0 1 4 13.5a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 1 5.53 1 1 0 1 0 1 1.74A5 5 0 0 0 22 12.5a5 5 0 0 0-3.58-4.78M12 12.83a2.94 2.94 0 0 0-3.43.53 2.93 2.93 0 0 0 0 4.13l2.72 2.72a1 1 0 0 0 1.42 0l2.72-2.72a2.93 2.93 0 0 0 0-4.13 2.94 2.94 0 0 0-3.43-.53m2 3.24-2 2-2-2a.88.88 0 0 1-.27-.65.9.9 0 0 1 .27-.65.92.92 0 0 1 1.3 0 1 1 0 0 0 1.42 0 .94.94 0 0 1 1.3 0 .9.9 0 0 1 .27.65.88.88 0 0 1-.29.65" })
), wp = h(I3), W3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 12.29A1 1 0 0 0 12 14h.19a.6.6 0 0 0 .19-.06.6.6 0 0 0 .17-.09l.15-.12a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41-.02M12 15a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m6.42-6.78a7 7 0 0 0-13.36 1.89A4 4 0 0 0 6 18h2a1 1 0 0 0 0-2H6a2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67A3 3 0 0 1 20 13a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5 5 0 0 0 1.42-9.78" })
), vp = h(W3), G3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.42 6.72A7 7 0 0 0 5.06 8.61a4 4 0 0 0-.38 7.66 1.1 1.1 0 0 0 .32.05 1 1 0 0 0 .32-2A2 2 0 0 1 4 12.5a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 1 5.53 1 1 0 1 0 1 1.74A5 5 0 0 0 22 11.5a5 5 0 0 0-3.58-4.78m-3.42 9V14.5a3 3 0 0 0-6 0v1.18a3 3 0 0 0 1 5.82h4a3 3 0 0 0 1-5.82Zm-4-1.22a1 1 0 0 1 2 0v1h-2Zm3 5h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2" })
), mp = h(G3), O3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.5 15.92h-.77l.39-.67a1 1 0 0 0-1.74-1l-.38.67-.38-.67a1 1 0 0 0-1.74 1l.39.67H9.5a1 1 0 0 0 0 2h.77l-.39.66a1 1 0 0 0 1.74 1l.38-.66.38.66a1 1 0 0 0 1.74-1l-.39-.66h.77a1 1 0 0 0 0-2m3.92-7.79A7 7 0 0 0 5.06 10 4 4 0 0 0 2 13.92a4 4 0 0 0 3.34 3.93h.16a1 1 0 0 0 .16-2 2 2 0 0 1-1.66-2 2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.66 3 3 0 0 1 .62 5.72 1 1 0 1 0 .74 1.85 5 5 0 0 0-.45-9.41Z" })
), cp = h(O3), N3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.21 16.29a1 1 0 0 0-.33-.21 1 1 0 0 0-1.09.21 1.2 1.2 0 0 0-.21.33.84.84 0 0 0-.08.38 1 1 0 0 0 1.38.92 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .21-1.09 1.2 1.2 0 0 0-.21-.33m0 4a1.2 1.2 0 0 0-.33-.21 1 1 0 0 0-1.09.21 1.2 1.2 0 0 0-.21.33 1 1 0 1 0 1.84 0 1.2 1.2 0 0 0-.21-.33m3.85-6.12-.18-.09-.18-.08a1 1 0 0 0-.58.06.9.9 0 0 0-.33.21 1 1 0 0 0-.29.71 1 1 0 0 0 .29.71 1.2 1.2 0 0 0 .33.21.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .29-.69 1.05 1.05 0 0 0-.29-.71Zm.15 4.12a1 1 0 0 0-1.09-.21.9.9 0 0 0-.54.54 1 1 0 0 0 .21 1.09 1.2 1.2 0 0 0 .33.21.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .21-1.09 1.2 1.2 0 0 0-.21-.33M21.7 7.07a1 1 0 0 0-.94-.26 3 3 0 0 1-.65.08 3 3 0 0 1-3-3 3 3 0 0 1 .08-.65A1 1 0 0 0 16 2a4.93 4.93 0 0 0-3.83 4.21A6.2 6.2 0 0 0 10.5 6a6 6 0 0 0-5.94 5.13 3.5 3.5 0 0 0-.46 6.58 1.1 1.1 0 0 0 .4.08 1 1 0 0 0 .4-1.92A1.48 1.48 0 0 1 4 14.5 1.5 1.5 0 0 1 5.5 13a1 1 0 0 0 1-1 4 4 0 0 1 4-4 4.06 4.06 0 0 1 2.19.66 4 4 0 0 1 1.58 2 1 1 0 0 0 .78.67 2.32 2.32 0 0 1 .95 4.28 1 1 0 0 0 1.1 1.68 4.34 4.34 0 0 0 1.9-3.62 4.2 4.2 0 0 0-.49-2A4.94 4.94 0 0 0 22 8a1 1 0 0 0-.3-.93m-4.59 2.82a3 3 0 0 1-.42 0 4.6 4.6 0 0 0-.69-.35 6.06 6.06 0 0 0-1.82-2.28v-.37a3 3 0 0 1 1.05-2.28 5 5 0 0 0 4.23 4.23 3 3 0 0 1-2.35 1.05" })
), sp = h(N3), Q3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.7 8a1 1 0 0 0-.94-.26 3 3 0 0 1-.65.08 3 3 0 0 1-3-3 3 3 0 0 1 .08-.66 1 1 0 0 0-.26-.94 1 1 0 0 0-.93-.28 5 5 0 0 0-3.83 4.22 5.9 5.9 0 0 0-1.67-.24A6 6 0 0 0 4.56 12 3.52 3.52 0 0 0 2 15.42a3.47 3.47 0 0 0 1.41 2.79 1 1 0 1 0 1.18-1.61A1.46 1.46 0 0 1 4 15.42a1.5 1.5 0 0 1 1.5-1.5 1 1 0 0 0 1-1 4 4 0 0 1 6.17-3.35 3.9 3.9 0 0 1 1.57 2 1 1 0 0 0 .78.66 2.33 2.33 0 0 1 .54 4.44 1 1 0 0 0-.52 1.32 1 1 0 0 0 .92.6 1 1 0 0 0 .4-.09 4.33 4.33 0 0 0 2.6-4 4.2 4.2 0 0 0-.49-2A4.94 4.94 0 0 0 22 8.92a1 1 0 0 0-.3-.92m-4.59 2.82a3 3 0 0 1-.42 0 4.6 4.6 0 0 0-.72-.31 5.9 5.9 0 0 0-1.82-2.28v-.37a3 3 0 0 1 1.05-2.28 5 5 0 0 0 4.23 4.22 3 3 0 0 1-2.32 1.01Zm-4.61 6.1h-.77l.39-.67a1 1 0 0 0-1.74-1l-.38.67-.38-.67a1 1 0 0 0-1.74 1l.39.67H7.5a1 1 0 0 0 0 2h.77l-.39.66a1 1 0 0 0 1.74 1l.38-.66.38.66a1 1 0 1 0 1.74-1l-.39-.66h.77a1 1 0 0 0 0-2" })
), gp = h(Q3), K3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 14a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m0 5a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1M21.7 7.07a1 1 0 0 0-.94-.26 3 3 0 0 1-.65.08 3 3 0 0 1-3-3 3 3 0 0 1 .08-.66 1 1 0 0 0-.26-.93A1 1 0 0 0 16 2a4.93 4.93 0 0 0-3.83 4.21A6.2 6.2 0 0 0 10.5 6a6 6 0 0 0-5.94 5.13 3.5 3.5 0 0 0-.46 6.58 1.1 1.1 0 0 0 .4.08 1 1 0 0 0 .4-1.92A1.48 1.48 0 0 1 4 14.5 1.5 1.5 0 0 1 5.5 13a1 1 0 0 0 1-1 4 4 0 0 1 4-4 3.9 3.9 0 0 1 2.17.66 3.94 3.94 0 0 1 1.57 2 1 1 0 0 0 .78.67 2.32 2.32 0 0 1 .98 4.28 1 1 0 0 0 1.1 1.68 4.32 4.32 0 0 0 1.9-3.62 4.2 4.2 0 0 0-.49-2A4.94 4.94 0 0 0 22 8a1 1 0 0 0-.3-.93m-4.59 2.82a3 3 0 0 1-.42 0 4.6 4.6 0 0 0-.69-.35 6.06 6.06 0 0 0-1.82-2.28v-.37a3 3 0 0 1 1.05-2.28 5 5 0 0 0 4.23 4.23 3 3 0 0 1-2.35 1.05M12.5 13a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m0 5a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1" })
), ip = h(K3), j3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 14a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m4-1a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m9.2-5.93a1 1 0 0 0-.94-.26 3 3 0 0 1-.65.08 3 3 0 0 1-3-3 3 3 0 0 1 .08-.66 1 1 0 0 0-.26-.93A1 1 0 0 0 16 2a4.93 4.93 0 0 0-3.83 4.21A6.2 6.2 0 0 0 10.5 6a6 6 0 0 0-5.94 5.13 3.5 3.5 0 0 0-.46 6.58 1.1 1.1 0 0 0 .4.08 1 1 0 0 0 .4-1.92A1.48 1.48 0 0 1 4 14.5 1.5 1.5 0 0 1 5.5 13a1 1 0 0 0 1-1 4 4 0 0 1 4-4 3.9 3.9 0 0 1 2.17.66 3.94 3.94 0 0 1 1.57 2 1 1 0 0 0 .78.67 2.32 2.32 0 0 1 .98 4.28 1 1 0 0 0 1.1 1.68 4.32 4.32 0 0 0 1.9-3.62 4.2 4.2 0 0 0-.49-2A4.94 4.94 0 0 0 22 8a1 1 0 0 0-.3-.93m-4.59 2.82a3 3 0 0 1-.42 0 4.6 4.6 0 0 0-.69-.35 6.06 6.06 0 0 0-1.82-2.28v-.37a3 3 0 0 1 1.05-2.28 5 5 0 0 0 4.23 4.23 3 3 0 0 1-2.35 1.05" })
), dp = h(j3), J3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.7 9.07a1 1 0 0 0-.93-.26 3 3 0 0 1-.66.08 3 3 0 0 1-3-3 3 3 0 0 1 .08-.66 1 1 0 0 0-.26-.93A1 1 0 0 0 16 4a4.93 4.93 0 0 0-3.83 4.21A6.2 6.2 0 0 0 10.5 8a6 6 0 0 0-5.94 5.13A3.5 3.5 0 0 0 5.5 20h9.17A4.33 4.33 0 0 0 19 15.67a4.2 4.2 0 0 0-.49-2A4.94 4.94 0 0 0 22 10a1 1 0 0 0-.3-.93m-7 8.93H5.5a1.5 1.5 0 0 1 0-3 1 1 0 0 0 1-1 4 4 0 0 1 6.18-3.34 3.94 3.94 0 0 1 1.57 2 1 1 0 0 0 .78.67 2.33 2.33 0 0 1-.36 4.67Zm2.44-6.11a2.6 2.6 0 0 1-.42 0 4.6 4.6 0 0 0-.72-.31 6.06 6.06 0 0 0-1.82-2.28v-.37a3 3 0 0 1 1.05-2.28 5 5 0 0 0 4.23 4.23 3 3 0 0 1-2.35 1.01Z" })
), pp = h(J3), Y3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.42 8.22a7 7 0 0 0-13.36 1.89A4 4 0 0 0 6 18h2a1 1 0 0 0 0-2H6a2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67A3 3 0 0 1 20 13a3 3 0 0 1-3 3 1 1 0 0 0 0 2 5 5 0 0 0 1.42-9.78m-5.5 10.4a.6.6 0 0 0-.09-.17l-.12-.16a1.2 1.2 0 0 0-.33-.21 1 1 0 0 0-1.09.21l-.12.16a.6.6 0 0 0-.09.17.6.6 0 0 0-.06.18 2 2 0 0 0 0 .2 1 1 0 0 0 0 .19.6.6 0 0 0 .06.19.6.6 0 0 0 .09.17l.12.16A1.05 1.05 0 0 0 12 20a1 1 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21l.12-.16a.6.6 0 0 0 .09-.17.6.6 0 0 0 .06-.19A1 1 0 0 0 13 19a2 2 0 0 0 0-.2.6.6 0 0 0-.08-.18M12 11a3 3 0 0 0-2.6 1.5 1 1 0 0 0 .37 1.37 1 1 0 0 0 1.36-.37A1 1 0 0 1 12 13a1 1 0 0 1 0 2 1 1 0 0 0 0 2 3 3 0 0 0 0-6" })
), fp = h(Y3), X3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 7h-.8a4.3 4.3 0 0 0-.52-1.27l.56-.56a1 1 0 0 0-1.41-1.41l-.56.56A4.3 4.3 0 0 0 17 3.8V3a1 1 0 0 0-2 0v.8a4.1 4.1 0 0 0-1.26.52l-.57-.56a1 1 0 0 0-1.41 1.41l.56.57c-.09.15-.16.32-.24.48A5.9 5.9 0 0 0 10.5 6a6 6 0 0 0-5.94 5.13 3.5 3.5 0 0 0-.46 6.58 1.1 1.1 0 0 0 .4.08 1 1 0 0 0 .4-1.92A1.48 1.48 0 0 1 4 14.5 1.5 1.5 0 0 1 5.5 13a1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.67 2.32 2.32 0 0 1 .94 4.23 1 1 0 0 0 1.1 1.68 4.34 4.34 0 0 0 1.9-3.62 4.2 4.2 0 0 0-.3-1.55l.13.12a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-.56-.56A4.3 4.3 0 0 0 20.2 9h.8a1 1 0 0 0 0-2m-3.34 2.65a2.1 2.1 0 0 1-.6.42A4.2 4.2 0 0 0 16 9.54a6.1 6.1 0 0 0-2.09-2.49 2.4 2.4 0 0 1 .46-.7 2.43 2.43 0 0 1 3.3 0 2.37 2.37 0 0 1 0 3.3ZM8.5 14a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m4-1a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1" })
), Ep = h(X3), _3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.56 12.67a1 1 0 0 0-1.12 0c-.11.08-2.69 1.86-2.69 4.58a3.25 3.25 0 0 0 6.5 0c0-2.75-2.58-4.51-2.69-4.58M12 18.5a1.25 1.25 0 0 1-1.25-1.25A3.66 3.66 0 0 1 12 14.8a3.6 3.6 0 0 1 1.25 2.45A1.25 1.25 0 0 1 12 18.5m6.42-10.78A7 7 0 0 0 5.06 9.61a4 4 0 0 0 .61 7.87h.08a1 1 0 0 0 1-.92 1 1 0 0 0-.92-1.08A2 2 0 0 1 4 13.5a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 .43 5.79 1 1 0 0 0 .62 1.9 5 5 0 0 0-.14-9.53" })
), xp = h(_3), z3 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 12.5a1 1 0 0 0-.91.6 4 4 0 1 0 .55 6.4 1 1 0 1 0-1.32-1.5 2 2 0 0 1-1.32.5 2 2 0 1 1 1-3.75h-.22a1 1 0 0 0 0 2H15a1 1 0 0 0 1-1V13.5a1 1 0 0 0-1-1m3.42-4.78A7 7 0 0 0 5.06 9.61a4 4 0 0 0-.38 7.66 1.1 1.1 0 0 0 .32.05 1 1 0 0 0 .32-2A2 2 0 0 1 4 13.5a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 1 5.53 1 1 0 1 0 1 1.74A5 5 0 0 0 22 12.5a5 5 0 0 0-3.58-4.78" })
), Ap = h(z3), aa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.5 15a2 2 0 1 0-2-2l-1.9.87a2 2 0 0 0-1.1-.33 2 2 0 0 0 0 4 1.9 1.9 0 0 0 .92-.24l2.1 1a2 2 0 1 0 .8-1.84l-1.75-.8 1.91-.88a2 2 0 0 0 1.02.22m3.92-7.78A7 7 0 0 0 5.06 9.11a4 4 0 0 0-.38 7.66 1.1 1.1 0 0 0 .32.05 1 1 0 0 0 .32-2A2 2 0 0 1 4 13a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 1 5.53 1 1 0 1 0 1 1.74A5 5 0 0 0 22 12a5 5 0 0 0-3.58-4.78" })
), Mp = h(aa), ta = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.42 7.22A7 7 0 0 0 5.06 9.11a4 4 0 0 0-.38 7.66 1.1 1.1 0 0 0 .32.05 1 1 0 0 0 .32-2A2 2 0 0 1 4 13a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 1 5.53 1 1 0 1 0 1 1.74A5 5 0 0 0 22 12a5 5 0 0 0-3.58-4.78m-3.63 4.44a2.73 2.73 0 0 1-2.2-.47 1 1 0 0 0-1.18 0 2.72 2.72 0 0 1-2.2.47 1 1 0 0 0-.84.2 1 1 0 0 0-.37.77V16a4.63 4.63 0 0 0 1.84 3.7l1.57 1.15a1 1 0 0 0 1.18 0l1.57-1.16A4.6 4.6 0 0 0 16 16v-3.37a1 1 0 0 0-.37-.77 1 1 0 0 0-.84-.2M14 16a2.62 2.62 0 0 1-1 2l-1 .72-1-.72a2.62 2.62 0 0 1-1-2v-2.28a4.7 4.7 0 0 0 2-.55 4.7 4.7 0 0 0 2 .55Z" })
), Hp = h(ta), ea = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 13a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m4-2a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0v-9a1 1 0 0 0-1-1m6.42-4.78A7 7 0 0 0 5.06 8.11 4 4 0 0 0 2 12a4 4 0 0 0 1.34 3 1 1 0 1 0 1.32-1.5A2 2 0 0 1 4 12a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67A3 3 0 0 1 20 11a2.9 2.9 0 0 1-.74 2 1 1 0 0 0 1.48 1.34 5 5 0 0 0-2.32-8.08ZM16 13a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1" })
), Cp = h(ea), la = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.89 18.06a1 1 0 0 0-1.28.6l-.73 2a1 1 0 0 0 .6 1.28 1 1 0 0 0 .34.06 1 1 0 0 0 .94-.66l.73-2a1 1 0 0 0-.6-1.28m-4 0a1 1 0 0 0-1.28.6l-.73 2a1 1 0 0 0 .6 1.28 1 1 0 0 0 .34.06 1 1 0 0 0 .94-.66l.73-2a1 1 0 0 0-.6-1.28m0-7a1 1 0 0 0-1.28.6l-1.1 3A1 1 0 0 0 7.45 16a1 1 0 0 0 .94-.66l1.1-3a1 1 0 0 0-.6-1.28m4 0a1 1 0 0 0-1.28.6l-1.1 3a1 1 0 0 0 .94 1.34 1 1 0 0 0 .94-.66l1.1-3a1 1 0 0 0-.6-1.28m5.53-4.84A7 7 0 0 0 5.06 8.11 4 4 0 0 0 2 12a4 4 0 0 0 1.34 3 1 1 0 1 0 1.32-1.5A2 2 0 0 1 4 12a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67A3 3 0 0 1 20 11a2.9 2.9 0 0 1-.74 2 1 1 0 0 0 1.48 1.34 5 5 0 0 0-2.32-8.08Zm-1.53 11.84a1 1 0 0 0-1.28.6l-.73 2a1 1 0 0 0 .6 1.28 1 1 0 0 0 .34.06 1 1 0 0 0 .94-.66l.73-2a1 1 0 0 0-.6-1.28m0-7a1 1 0 0 0-1.28.6l-1.1 3a1 1 0 0 0 .94 1.34 1 1 0 0 0 .94-.66l1.1-3a1 1 0 0 0-.6-1.28" })
), up = h(la), ra = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 11a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m4 6a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m-4 0a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1M18.42 6.22A7 7 0 0 0 5.06 8.11 4 4 0 0 0 2 12a4 4 0 0 0 1.34 3 1 1 0 1 0 1.32-1.5A2 2 0 0 1 4 12a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67A3 3 0 0 1 20 11a2.9 2.9 0 0 1-.74 2 1 1 0 0 0 1.48 1.34 5 5 0 0 0-2.32-8.08ZM12 11a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m4 0a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m0 6a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1" })
), Vp = h(ra), ha = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m16.71 16.29-13-13a1 1 0 0 0-1.42 1.42l3.36 3.35a7 7 0 0 0-.59 2A4 4 0 0 0 6 18h9.59l2.7 2.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM6 16a2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 .2-1.39L13.59 16Zm12.42-7.78A7 7 0 0 0 12 4a6.7 6.7 0 0 0-2.32.4 1 1 0 0 0 .66 1.88A4.9 4.9 0 0 1 12 6a5 5 0 0 1 4.73 3.39 1 1 0 0 0 .78.67 3 3 0 0 1 1.85 4.79 1 1 0 0 0 .16 1.4 1 1 0 0 0 .62.22 1 1 0 0 0 .78-.38 5 5 0 0 0-2.5-7.87" })
), Sp = h(ha), oa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.21 20.29a1 1 0 0 0-1.09-.21.9.9 0 0 0-.33.21 1.2 1.2 0 0 0-.21.33.94.94 0 0 0 0 .76.9.9 0 0 0 .54.54.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21A1 1 0 0 0 9.5 21a.84.84 0 0 0-.08-.38 1.2 1.2 0 0 0-.21-.33m4-2a.9.9 0 0 0-.33-.21 1 1 0 0 0-1.09.21 1.2 1.2 0 0 0-.21.33 1 1 0 0 0 1.3 1.3 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .21-1.09 1.2 1.2 0 0 0-.21-.33m-4-2a1 1 0 0 0-1.09-.21 1 1 0 0 0-.33.21 1.2 1.2 0 0 0-.21.33 1 1 0 0 0 .21 1.09 1.2 1.2 0 0 0 .33.21.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21A1 1 0 0 0 9.5 17a.84.84 0 0 0-.08-.38 1.2 1.2 0 0 0-.21-.33m2.91-2.21a1 1 0 0 0-.33.21 1.05 1.05 0 0 0-.29.71 1 1 0 0 0 .29.71 1.2 1.2 0 0 0 .33.21.84.84 0 0 0 .38.08 1 1 0 0 0 1-1 1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21M21 7h-.8a4.3 4.3 0 0 0-.52-1.27l.56-.56a1 1 0 0 0-1.41-1.41l-.56.56A4.3 4.3 0 0 0 17 3.8V3a1 1 0 0 0-2 0v.8a4.1 4.1 0 0 0-1.26.52l-.57-.56a1 1 0 0 0-1.41 1.41l.56.57c-.09.15-.16.32-.24.48A5.9 5.9 0 0 0 10.5 6a6 6 0 0 0-5.94 5.13 3.5 3.5 0 0 0-.46 6.58 1.1 1.1 0 0 0 .4.08 1 1 0 0 0 .4-1.92A1.48 1.48 0 0 1 4 14.5 1.5 1.5 0 0 1 5.5 13a1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.67 2.32 2.32 0 0 1 .94 4.23 1 1 0 0 0 1.1 1.68 4.34 4.34 0 0 0 1.9-3.62 4.2 4.2 0 0 0-.3-1.55l.13.12a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-.56-.56A4.3 4.3 0 0 0 20.2 9h.8a1 1 0 0 0 0-2m-3.34 2.65a2.1 2.1 0 0 1-.6.42A4.2 4.2 0 0 0 16 9.54a6.1 6.1 0 0 0-2.09-2.49 2.4 2.4 0 0 1 .46-.7 2.43 2.43 0 0 1 3.3 0 2.37 2.37 0 0 1 0 3.3Z" })
), Lp = h(oa), na = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.5 16.92h-.77l.39-.67a1 1 0 0 0-1.74-1l-.38.67-.38-.67a1 1 0 0 0-1.74 1l.39.67H7.5a1 1 0 0 0 0 2h.77l-.39.66a1 1 0 0 0 1.74 1l.38-.66.38.66a1 1 0 1 0 1.74-1l-.39-.66h.77a1 1 0 0 0 0-2m8.5-9h-.8a4.3 4.3 0 0 0-.52-1.27l.56-.56a1 1 0 0 0-1.41-1.41l-.56.56A4.3 4.3 0 0 0 17 4.72v-.8a1 1 0 0 0-2 0v.8a4.1 4.1 0 0 0-1.26.52l-.57-.56a1 1 0 0 0-1.41 1.41l.56.56c-.09.16-.16.33-.24.49a5.9 5.9 0 0 0-1.58-.22A6 6 0 0 0 4.56 12 3.52 3.52 0 0 0 2 15.42a3.47 3.47 0 0 0 1.41 2.79 1 1 0 1 0 1.18-1.61A1.46 1.46 0 0 1 4 15.42a1.5 1.5 0 0 1 1.5-1.5 1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.66 2.33 2.33 0 0 1 .54 4.44 1 1 0 0 0-.52 1.32 1 1 0 0 0 .92.6.9.9 0 0 0 .4-.09 4.33 4.33 0 0 0 2.6-4 4.3 4.3 0 0 0-.3-1.56l.13.13a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-.56-.56a4.2 4.2 0 0 0 .52-1.26h.8a1 1 0 0 0 0-2Zm-3.34 2.64a1.9 1.9 0 0 1-.6.41 4.2 4.2 0 0 0-1.06-.51A6 6 0 0 0 13.88 8a2.2 2.2 0 0 1 .46-.7 2.42 2.42 0 0 1 3.3 0 2.34 2.34 0 0 1 0 3.29Z" })
), Zp = h(na), wa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 19a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m0-5a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1M21 7h-.8a4.3 4.3 0 0 0-.52-1.27l.56-.56a1 1 0 0 0-1.41-1.41l-.56.56A4.3 4.3 0 0 0 17 3.8V3a1 1 0 0 0-2 0v.8a4.1 4.1 0 0 0-1.26.52l-.57-.56a1 1 0 0 0-1.41 1.41l.56.57c-.09.15-.16.32-.24.48A5.9 5.9 0 0 0 10.5 6a6 6 0 0 0-5.94 5.13 3.5 3.5 0 0 0-.46 6.58 1.1 1.1 0 0 0 .4.08 1 1 0 0 0 .4-1.92A1.48 1.48 0 0 1 4 14.5 1.5 1.5 0 0 1 5.5 13a1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.67 2.32 2.32 0 0 1 .94 4.23 1 1 0 0 0 1.1 1.68 4.34 4.34 0 0 0 1.9-3.62 4.2 4.2 0 0 0-.3-1.55l.13.12a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-.56-.56A4.3 4.3 0 0 0 20.2 9h.8a1 1 0 0 0 0-2m-3.34 2.65a2.1 2.1 0 0 1-.6.42A4.2 4.2 0 0 0 16 9.54a6.1 6.1 0 0 0-2.09-2.49 2.4 2.4 0 0 1 .46-.7 2.43 2.43 0 0 1 3.3 0 2.37 2.37 0 0 1 0 3.3ZM12.5 18a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m0-5a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1" })
), Bp = h(wa), va = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.5 15a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1M22 7h-1.1a5.2 5.2 0 0 0-.73-1.76l.83-.77a1 1 0 1 0-1.42-1.42l-.77.78A5 5 0 0 0 17 3.1V2a1 1 0 0 0-2 0v1.1a5.2 5.2 0 0 0-1.76.73l-.77-.78a1 1 0 0 0-1.42 1.42l.78.77a5.1 5.1 0 0 0-.77 2A5.8 5.8 0 0 0 9.5 7a6 6 0 0 0-5.94 5.13 3.5 3.5 0 0 0-.46 6.58 1.1 1.1 0 0 0 .4.08 1 1 0 0 0 .4-1.92A1.48 1.48 0 0 1 3 15.5 1.5 1.5 0 0 1 4.5 14a1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.67 2.32 2.32 0 0 1 .94 4.23 1 1 0 0 0 1.1 1.68 4.34 4.34 0 0 0 1.9-3.62 4.4 4.4 0 0 0-.45-1.92 5.2 5.2 0 0 0 1.21-.58l.77.78A1 1 0 0 0 21 13a1 1 0 0 0 0-1.42l-.78-.77A5 5 0 0 0 20.9 9H22a1 1 0 0 0 0-2m-3.87 3.12A3 3 0 0 1 16 11h-.06a4.1 4.1 0 0 0-1-.46 5.93 5.93 0 0 0-2-2.38V8a3 3 0 0 1 .87-2.12 3.1 3.1 0 0 1 4.25 0 3 3 0 0 1 0 4.25ZM7.5 20a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m4-1a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m0-5a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1" })
), Fp = h(va), ma = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.05 14.33a1 1 0 0 0-1.11 0c-.1.08-2.44 1.67-2.44 4.17a3 3 0 0 0 6 0c0-2.5-2.34-4.1-2.45-4.17m-.55 5.17a1 1 0 0 1-1-1 3 3 0 0 1 1-2 3 3 0 0 1 1 2 1 1 0 0 1-1 1M21 7.5h-.8a4.3 4.3 0 0 0-.52-1.27l.56-.56a1 1 0 0 0-1.41-1.41l-.56.56A4.3 4.3 0 0 0 17 4.3v-.8a1 1 0 0 0-2 0v.8a4.1 4.1 0 0 0-1.26.52l-.57-.56a1 1 0 0 0-1.41 1.41l.56.57c-.09.15-.16.32-.24.48a5.9 5.9 0 0 0-1.58-.22 6 6 0 0 0-5.94 5.13 3.5 3.5 0 0 0-.46 6.58 1.1 1.1 0 0 0 .4.08 1 1 0 0 0 .4-1.92A1.48 1.48 0 0 1 4 15a1.5 1.5 0 0 1 1.5-1.5 1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.67 2.32 2.32 0 0 1 .94 4.23 1 1 0 0 0 1.1 1.68 4.3 4.3 0 0 0 1.65-5.18l.13.13a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-.56-.56a4.3 4.3 0 0 0 .47-1.27h.8a1 1 0 0 0 0-2m-3.34 2.65a2.5 2.5 0 0 1-.6.41A4.2 4.2 0 0 0 16 10a6.1 6.1 0 0 0-2.09-2.49 2.3 2.3 0 0 1 .46-.69 2.42 2.42 0 0 1 3.29 0 2.37 2.37 0 0 1 0 3.3Z" })
), Rp = h(ma), ca = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 9h-.8a4.3 4.3 0 0 0-.52-1.27l.56-.56a1 1 0 0 0-1.41-1.41l-.56.56A4.3 4.3 0 0 0 17 5.8V5a1 1 0 0 0-2 0v.8a4.1 4.1 0 0 0-1.26.52l-.57-.56a1 1 0 0 0-1.41 1.41l.56.57c-.09.15-.16.32-.24.48A5.9 5.9 0 0 0 10.5 8a6 6 0 0 0-5.94 5.13A3.5 3.5 0 0 0 5.5 20h9.17A4.33 4.33 0 0 0 19 15.67a4.2 4.2 0 0 0-.3-1.55l.13.12a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-.56-.56A4.3 4.3 0 0 0 20.2 11h.8a1 1 0 0 0 0-2m-6.33 9H5.5a1.5 1.5 0 0 1 0-3 1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.67 2.33 2.33 0 0 1-.39 4.62m3-6.35a2.2 2.2 0 0 1-.6.4 4.5 4.5 0 0 0-1.07-.51 6.1 6.1 0 0 0-2.09-2.49 2.3 2.3 0 0 1 .46-.69 2.42 2.42 0 0 1 3.29 0 2.37 2.37 0 0 1 0 3.3Z" })
), Up = h(ca), sa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.42 8.22a7 7 0 0 0-13.36 1.89A4 4 0 0 0 6 18a1 1 0 0 0 0-2 2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 .24 5.84 1 1 0 0 0 .5 1.94 5 5 0 0 0 .17-9.62m-3.71 6.07a1 1 0 0 0-1.42 0L12 15.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l1.3 1.29-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 17l1.3-1.29a1 1 0 0 0 0-1.42" })
), $p = h(sa), ga = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 15.5h-3v-1a1 1 0 0 1 1.88-.5 1 1 0 0 0 1.37.34 1 1 0 0 0 .34-1.34 3 3 0 0 0-.46-.59A3 3 0 0 0 12 11.5a3 3 0 0 0-3 3v1.18a3 3 0 0 0 1 5.82h4a3 3 0 0 0 0-6m0 4h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2m4.42-12.78A7 7 0 0 0 5.06 8.61a4 4 0 0 0-.38 7.66 1.1 1.1 0 0 0 .32.05 1 1 0 0 0 .32-2A2 2 0 0 1 4 12.5a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 1 5.53 1 1 0 1 0 1 1.74A5 5 0 0 0 22 11.5a5 5 0 0 0-3.58-4.78" })
), yp = h(ga), ia = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.42 8.22a7 7 0 0 0-13.36 1.89A4 4 0 0 0 6 18a1 1 0 0 0 0-2 2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 .24 5.84 1 1 0 0 0 .5 1.94 5 5 0 0 0 .17-9.62m-5.71 2.07a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-3 3a1 1 0 0 0 1.42 1.42l1.29-1.3V19a1 1 0 0 0 2 0v-5.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), kp = h(ia), da = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 5.94a7.1 7.1 0 0 1 7 0 1 1 0 0 0 1.37-.37 1 1 0 0 0-.37-1.36 9.14 9.14 0 0 0-9 0 1 1 0 0 0-.37 1.36 1 1 0 0 0 1.37.37m9.92 5.27a6 6 0 0 0-.36-.71 1 1 0 0 0-1.38-.33 1 1 0 0 0-.33 1.37 4.6 4.6 0 0 1 .38.84 1 1 0 0 0 .78.67A3 3 0 0 1 20 16a3 3 0 0 1-3 3H5.66A2 2 0 0 1 4 17.4 2 2 0 0 1 6 15a1 1 0 0 0 1-1 4.9 4.9 0 0 1 .67-2.49 1 1 0 0 0-.37-1.37 1 1 0 0 0-1.36.37 6.75 6.75 0 0 0-.88 2.6 4 4 0 0 0-2.13 1.33A4 4 0 0 0 5.46 21H17a5 5 0 0 0 1.42-9.79M14.87 9v-.06a1 1 0 0 0 .13-.2 1 1 0 0 0-.57-1.29 6.4 6.4 0 0 0-1.74-.38h-.3a5.5 5.5 0 0 0-.81 0 3 3 0 0 0-.31 0 6.4 6.4 0 0 0-1.74.38A1 1 0 0 0 9 8.74a1.2 1.2 0 0 0 .12.19 1 1 0 0 0 0 .11 1 1 0 0 0 1.37.36 3.08 3.08 0 0 1 3 0 1 1 0 0 0 1.38-.4M11 12a1 1 0 1 0 1-1 1 1 0 0 0-1 1" })
), bp = h(da), pa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 18a1 1 0 1 0 1 1 1 1 0 0 0-1-1m14-4h-7a1 1 0 0 0 0 2h7a1 1 0 0 1 0 2 1 1 0 0 0 0 2 3 3 0 0 0 0-6m-5-3a1 1 0 0 0 1 1h4a3 3 0 0 0 3-3 1 1 0 0 0-2 0 1 1 0 0 1-1 1h-4a1 1 0 0 0-1 1m-4 4a1 1 0 0 0-1-1H6a2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 1 0 1.9-.64A7 7 0 0 0 5.06 8.11 4 4 0 0 0 6 16h3a1 1 0 0 0 1-1m0-4a1 1 0 1 0 1-1 1 1 0 0 0-1 1m4 7H9a1 1 0 0 0 0 2h5a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3" })
), Tp = h(pa), fa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.42 9.21a7 7 0 0 0-13.36 1.9A4 4 0 0 0 6 19h11a5 5 0 0 0 1.42-9.79M17 17H6a2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.66A3 3 0 0 1 17 17" })
), Pp = h(fa), Ea = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.47 10.54A6 6 0 0 0 14 7a5.8 5.8 0 0 0-1.39.18 5 5 0 0 0-9 2A3 3 0 0 0 4.5 15h1a4 4 0 0 0 0 .5A3.5 3.5 0 0 0 9 19h9.17a4.33 4.33 0 0 0 1.3-8.46M4.5 13a1 1 0 0 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 3-3 3 3 0 0 1 2.22 1 6 6 0 0 0-2.66 4.13 3.5 3.5 0 0 0-1.5.87Zm13.67 4H9a1.5 1.5 0 0 1 0-3 1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.67 2.33 2.33 0 0 1-.39 4.62" })
), Dp = h(Ea), xa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 12.5a5.52 5.52 0 0 0-3.51-5.12 5.49 5.49 0 0 0-11 0A5.5 5.5 0 0 0 8.5 18h.2a6.9 6.9 0 0 1-1.24 2.39A1 1 0 0 0 8.24 22h7.52a1 1 0 0 0 .78-1.63A6.9 6.9 0 0 1 15.3 18h.2a5.51 5.51 0 0 0 5.5-5.5M10.06 20a8.9 8.9 0 0 0 .81-2.56 5.5 5.5 0 0 0 1.13-.7 5.5 5.5 0 0 0 1.13.7 8.9 8.9 0 0 0 .81 2.56Zm2.72-5.3-.08-.08-.08-.08h-.07l-.18-.09-.18-.06h-.38l-.18.06a.6.6 0 0 0-.17.09h-.08l-.08.08-.08.08a3.5 3.5 0 1 1-3.47-5.62A1 1 0 0 0 7.91 9a1.4 1.4 0 0 0 .18-.08 1 1 0 0 0 .14-.13.62.62 0 0 0 .21-.31.6.6 0 0 0 .07-.17.7.7 0 0 0 0-.2 1 1 0 0 0 0-.17 3 3 0 0 1 0-.45 3.5 3.5 0 0 1 7 0 3 3 0 0 1 0 .45 1 1 0 0 0 0 .16.7.7 0 0 0 0 .21.6.6 0 0 0 .07.17.62.62 0 0 0 .21.31 1 1 0 0 0 .14.13 1.4 1.4 0 0 0 .18.08 1 1 0 0 0 .16.07 3.5 3.5 0 1 1-3.47 5.62Z" })
), qp = h(xa), Aa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 6.06a3 3 0 0 0-1.15 5.77A2 2 0 0 1 14 13.06h-4a3.9 3.9 0 0 0-2 .56V7.88a3 3 0 1 0-2 0v8.36a3 3 0 1 0 2.16.05A2 2 0 0 1 10 15.06h4a4 4 0 0 0 3.91-3.16A3 3 0 0 0 17 6.06m-10-2a1 1 0 1 1-1 1 1 1 0 0 1 1-1m0 16a1 1 0 1 1 1-1 1 1 0 0 1-1 1m10-10a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), Ip = h(Aa), Ma = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 17h4a5 5 0 0 0 5-5v-1h1a3 3 0 0 0 0-6h-1V4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a5 5 0 0 0 5 5m9-10h1a1 1 0 0 1 0 2h-1ZM6 5h10v7a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3Zm15 14H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), Wp = h(Ma), Ha = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.32 9.55-1.89-.63.89-1.78A1 1 0 0 0 20.13 6L18 3.87a1 1 0 0 0-1.15-.19l-1.78.89-.63-1.89A1 1 0 0 0 13.5 2h-3a1 1 0 0 0-.95.68l-.63 1.89-1.78-.89A1 1 0 0 0 6 3.87L3.87 6a1 1 0 0 0-.19 1.15l.89 1.78-1.89.63a1 1 0 0 0-.68.94v3a1 1 0 0 0 .68.95l1.89.63-.89 1.78A1 1 0 0 0 3.87 18L6 20.13a1 1 0 0 0 1.15.19l1.78-.89.63 1.89a1 1 0 0 0 .95.68h3a1 1 0 0 0 .95-.68l.63-1.89 1.78.89a1 1 0 0 0 1.13-.19L20.13 18a1 1 0 0 0 .19-1.15l-.89-1.78 1.89-.63a1 1 0 0 0 .68-.94v-3a1 1 0 0 0-.68-.95M20 12.78l-1.2.4A2 2 0 0 0 17.64 16l.57 1.14-1.1 1.1-1.11-.6a2 2 0 0 0-2.79 1.16l-.4 1.2h-1.59l-.4-1.2A2 2 0 0 0 8 17.64l-1.14.57-1.1-1.1.6-1.11a2 2 0 0 0-1.16-2.82l-1.2-.4v-1.56l1.2-.4A2 2 0 0 0 6.36 8l-.57-1.11 1.1-1.1L8 6.36a2 2 0 0 0 2.82-1.16l.4-1.2h1.56l.4 1.2A2 2 0 0 0 16 6.36l1.14-.57 1.1 1.1-.6 1.11a2 2 0 0 0 1.16 2.79l1.2.4ZM12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2" })
), Gp = h(Ha), Ca = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.22 12a3 3 0 0 0 .78-2 3 3 0 0 0-3-3h-5.18A3 3 0 0 0 11 3H5a3 3 0 0 0-3 3 3 3 0 0 0 .78 2 3 3 0 0 0 0 4 3 3 0 0 0 0 4A3 3 0 0 0 2 18a3 3 0 0 0 3 3h14a3 3 0 0 0 2.22-5 3 3 0 0 0 0-4M11 19H5a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2m0-4H5a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2m0-4H5a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2m0-4H5a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2m8.69 11.71A.93.93 0 0 1 19 19h-5.18a2.87 2.87 0 0 0 0-2H19a1 1 0 0 1 1 1 1 1 0 0 1-.31.71m0-4A.93.93 0 0 1 19 15h-5.18a2.87 2.87 0 0 0 0-2H19a1 1 0 0 1 1 1 1 1 0 0 1-.31.71m0-4A.93.93 0 0 1 19 11h-5.18a2.87 2.87 0 0 0 0-2H19a1 1 0 0 1 1 1 1 1 0 0 1-.31.71" })
), Op = h(Ca), ua = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M11 20H4V4h7Zm9 0h-7V4h7Z" })
), Np = h(ua), Va = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 8a1 1 0 0 0 2 0V7h1a1 1 0 0 0 0-2H7V4a1 1 0 0 0-2 0v1H4a1 1 0 0 0 0 2h1Zm13-3h-6a1 1 0 0 0 0 2h6a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H8a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h8.36l3 2.73A1 1 0 0 0 20 21a1.1 1.1 0 0 0 .4-.08A1 1 0 0 0 21 20V8a3 3 0 0 0-3-3" })
), Qp = h(Va), Sa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H9a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73A1 1 0 0 0 21 22a1.1 1.1 0 0 0 .4-.08A1 1 0 0 0 22 21V9a3 3 0 0 0-3-3m-8.46 4.54A5 5 0 1 0 7 12a5 5 0 0 0 3.54-1.46M4 7a3 3 0 0 1 3-3 3 3 0 0 1 1.28.3l-4 4A3 3 0 0 1 4 7m5.7-1.29A3 3 0 0 1 10 7a3 3 0 0 1-4.28 2.7Z" })
), Kp = h(Sa), La = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 3a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m11-9H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM16 6a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1" })
), jp = h(La), Za = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m6.77 9.15 5.44-5.44a1 1 0 1 0-1.42-1.42L6.06 7 4.21 5.17a1 1 0 0 0-1.42 1.42l2.56 2.56a1 1 0 0 0 1.42 0M18.5 6H13a1 1 0 0 0 0 2h5.5a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H8.5a1 1 0 0 1-1-1v-3.5a1 1 0 0 0-2 0V16a3 3 0 0 0 3 3h8.36l3 2.73a1 1 0 0 0 .68.27 1.1 1.1 0 0 0 .4-.08 1 1 0 0 0 .6-.92V9a3 3 0 0 0-3.04-3" })
), Jp = h(Za), Ba = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m7-7H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM8 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), Yp = h(Ba), Fa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.12 11.92a.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l3-3a1 1 0 1 0-1.42-1.42L7.5 8.59V3a1 1 0 0 0-2 0v5.59l-1.29-1.3a1 1 0 1 0-1.42 1.42l3 3a1 1 0 0 0 .33.21M18.5 6h-5a1 1 0 0 0 0 2h5a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H8.5a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73a1 1 0 0 0 .68.27 1.1 1.1 0 0 0 .4-.08 1 1 0 0 0 .6-.92V9a3 3 0 0 0-3.04-3" })
), Xp = h(Fa), Ra = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.5 5.5h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H8.5a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73a1 1 0 0 0 .68.27 1.1 1.1 0 0 0 .4-.08 1 1 0 0 0 .6-.92v-12a3 3 0 0 0-3.04-3m-9.42 7h2.42a1 1 0 0 0 1-1V9.08a1 1 0 0 0-.29-.71L6.63 2.79a1 1 0 0 0-1.41 0L2.79 5.22a1 1 0 0 0 0 1.41l5.58 5.58a1 1 0 0 0 .71.29M5.92 4.91l4.58 4.58v1h-1L4.91 5.92Z" })
), _p = h(Ra), Ua = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM12 12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-6a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1" })
), zp = h(Ua), $a = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 6.35a3.07 3.07 0 0 0-3.54.53 3 3 0 0 0 0 4.24L11.29 14a1 1 0 0 0 1.42 0l2.83-2.83a3 3 0 0 0 0-4.24A3.07 3.07 0 0 0 12 6.35m2.12 3.36L12 11.83 9.88 9.71a1 1 0 0 1 0-1.42 1 1 0 0 1 1.41 0 1 1 0 0 0 1.42 0 1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.42M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), af = h($a), ya = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3M5.77 16H5a1 1 0 0 1-1-1v-.42l3.3-3.29a1 1 0 0 1 1.41 0l.87.87ZM20 18.59l-2.29-2.3A1 1 0 0 0 17 16H8.59l6.71-6.71a1 1 0 0 1 1.4 0l3.3 3.29Zm0-8.83-1.88-1.87a3 3 0 0 0-4.24 0L11 10.76l-.88-.87a3.06 3.06 0 0 0-4.24 0L4 11.76V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), tf = h(ya), ka = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 11a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1m-.71-7.29a1 1 0 0 0 1.09.21 1.2 1.2 0 0 0 .33-.21 1.2 1.2 0 0 0 .21-.33A.84.84 0 0 0 6 3a1 1 0 0 0-.29-.71 1 1 0 0 0-1.09-.21 1 1 0 0 0-.33.21A1 1 0 0 0 4 3a1 1 0 0 0 .08.38 1.2 1.2 0 0 0 .21.33M17 6H9a1 1 0 0 0 0 2h8a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H7a1 1 0 0 1-1-1v-2a1 1 0 0 0-2 0v2a3 3 0 0 0 3 3h8.36l3 2.73A1 1 0 0 0 19 22a1.1 1.1 0 0 0 .4-.08A1 1 0 0 0 20 21V9a3 3 0 0 0-3-3" })
), ef = h(ka), ba = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 11H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m4-4H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m2-5H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), lf = h(ba), Ta = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 10V8a3 3 0 0 0-2-2.82V4a3 3 0 0 0-6 0v1.18A3 3 0 0 0 2 8v2a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3M6 4a1 1 0 0 1 2 0v1H6Zm-2 6V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1m15-3h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H9a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73A1 1 0 0 0 21 23a1.1 1.1 0 0 0 .4-.08A1 1 0 0 0 22 22V10a3 3 0 0 0-3-3" })
), rf = h(Ta), Pa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 9h-1V8a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m5-7H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), hf = h(Pa), Da = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 7H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m0 4H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m2-9H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), of = h(Da), qa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 7a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m10 0h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m2-5H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), nf = h(qa), Ia = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 9h-2V7a1 1 0 0 0-2 0v2H9a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2m4-7H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), wf = h(Ia), Wa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.29 10.3a1 1 0 0 0 1.09 1.63 1.2 1.2 0 0 0 .33-.22 1 1 0 0 0 .21-.32A.85.85 0 0 0 8 11a1 1 0 0 0-.29-.7 1 1 0 0 0-1.42 0M7 5a1 1 0 0 1 0 2 1 1 0 0 0 0 2 3 3 0 1 0-2.6-4.5 1 1 0 0 0 .37 1.37 1 1 0 0 0 1.36-.37A1 1 0 0 1 7 5m12 1h-6a1 1 0 0 0 0 2h6a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H9a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73A1 1 0 0 0 21 22a1.1 1.1 0 0 0 .4-.08A1 1 0 0 0 22 21V9a3 3 0 0 0-3-3" })
), vf = h(Wa), Ga = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.3 10.75A1 1 0 1 0 9 9.25 3 3 0 1 1 7 4a3 3 0 0 1 2.23 1H8a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0 5 5 0 1 0 .3 7.75M19 6h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H9a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73A1 1 0 0 0 21 22a1.1 1.1 0 0 0 .4-.08A1 1 0 0 0 22 21V9a3 3 0 0 0-3-3" })
), mf = h(Ga), Oa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6h-5a1 1 0 0 0 0 2h5a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H9a1 1 0 0 1-1-1v-2a1 1 0 0 0-2 0v2a3 3 0 0 0 3 3h8.36l3 2.73A1 1 0 0 0 21 22a1.1 1.1 0 0 0 .4-.08A1 1 0 0 0 22 21V9a3 3 0 0 0-3-3M8.57 10l1.72 1.73a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L10 8.57a4.37 4.37 0 0 0 .65-2.26 4.32 4.32 0 1 0-8.65 0 4.32 4.32 0 0 0 4.31 4.32A4.35 4.35 0 0 0 8.57 10M4 6.31a2.3 2.3 0 0 1 .68-1.63 2.32 2.32 0 0 1 3.32 0A2.31 2.31 0 0 1 8 8a2.32 2.32 0 0 1-4-1.69" })
), cf = h(Oa), Na = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.5 6.5h-5a1 1 0 0 0 0 2h5a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H9.5a1 1 0 0 1-1-1v-2a1 1 0 0 0-2 0v2a3 3 0 0 0 3 3h8.36l3 2.73a1 1 0 0 0 .68.27 1.1 1.1 0 0 0 .4-.08 1 1 0 0 0 .6-.92v-12a3 3 0 0 0-3.04-3m-10 5a2 2 0 1 0-1.18-3.61l-1.75-.8 1.91-.88a2 2 0 0 0 1 .29 2 2 0 1 0-2-2l-1.9.87A2 2 0 0 0 4.5 5a2 2 0 0 0 0 4 2 2 0 0 0 .93-.24l2.09 1A2 2 0 0 0 9.5 11.5" })
), sf = h(Na), Qa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.57 12a1 1 0 0 0 .58-.19l1.62-1.16A4.56 4.56 0 0 0 10.68 7V3.63a1 1 0 0 0-.37-.77 1 1 0 0 0-.84-.2 3 3 0 0 1-2.33-.48 1 1 0 0 0-1.14 0 3 3 0 0 1-2.33.48 1 1 0 0 0-1.2 1V7a4.55 4.55 0 0 0 1.9 3.7L6 11.81a.94.94 0 0 0 .57.19M4.46 7V4.72a5.2 5.2 0 0 0 2.11-.55 5.1 5.1 0 0 0 2.11.55V7a2.57 2.57 0 0 1-1.07 2l-1 .74L5.53 9a2.57 2.57 0 0 1-1.07-2m14.08-1h-5a1 1 0 0 0 0 2h5a1 1 0 0 1 1 1v9.72L18 17.27a.94.94 0 0 0-.68-.27H8.54a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73a1 1 0 0 0 .67.27 1.2 1.2 0 0 0 .41-.08 1 1 0 0 0 .59-.92V9a3 3 0 0 0-3.03-3" })
), gf = h(Qa), Ka = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.66 6H17a1 1 0 0 1 1 1v6.34a1 1 0 1 0 2 0V7a3 3 0 0 0-3-3h-6.34a1 1 0 0 0 0 2m11.05 14.29-18-18a1 1 0 0 0-1.42 1.42l2 2A3 3 0 0 0 4 7v12a1 1 0 0 0 .62.92A.84.84 0 0 0 5 20a1 1 0 0 0 .71-.29L8.41 17h7.18l4.7 4.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M8 15a1 1 0 0 0-.71.29L6 16.59V7.41L13.59 15Z" })
), df = h(Ka), ja = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5.5 11a1 1 0 0 0 2 0V5.41l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-3-3a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-3 3a1 1 0 0 0 1.42 1.42l1.29-1.3Zm13-5h-5a1 1 0 0 0 0 2h5a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H8.5a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73a1 1 0 0 0 .68.27 1.1 1.1 0 0 0 .4-.08 1 1 0 0 0 .6-.92V9a3 3 0 0 0-3.04-3" })
), pf = h(ja), Ja = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m15.71 6.29-5.3 5.3-2.12-2.12a1 1 0 1 0-1.41 1.41l2.83 2.83a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29l6-6a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), ff = h(Ja), Ya = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), Ef = h(Ya), Xa = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 14a1 1 0 0 0-1.22.72A7 7 0 0 1 11 20H5.41l.64-.63a1 1 0 0 0 0-1.41 7 7 0 0 1 3.2-11.74 1 1 0 0 0-.5-1.94A9 9 0 0 0 4 18.62l-1.71 1.67a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h8a9 9 0 0 0 8.72-6.75A1 1 0 0 0 19 14m1.54-10.54A5 5 0 1 0 22 7a5 5 0 0 0-1.46-3.54M14 7a3 3 0 0 1 3-3 3 3 0 0 1 1.29.3l-4 4A3 3 0 0 1 14 7m5.12 2.12a3.08 3.08 0 0 1-3.4.57l4-4A3 3 0 0 1 20 7a3 3 0 0 1-.88 2.12" })
), xf = h(Xa), _a = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 10a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m-4 3a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m4-11A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.7A8 8 0 1 1 12 20m4-12a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1" })
), Af = h(_a), za = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.29 7.13a1 1 0 0 0 0 1.42l1.92 1.92a1 1 0 0 0 1.42 0l4.08-4.08A1 1 0 1 0 19.29 5l-3.37 3.35-1.21-1.22a1 1 0 0 0-1.42 0m6.62 3.51a1 1 0 0 0-.91 1.08 3 3 0 0 1 0 .28 7 7 0 0 1-7 7H6.41l.64-.63a1 1 0 0 0 0-1.41 7 7 0 0 1 3.48-11.81 7.1 7.1 0 0 1 2.8 0 1 1 0 1 0 .4-2 9.2 9.2 0 0 0-3.61 0A9.05 9.05 0 0 0 3 12a9 9 0 0 0 2 5.62l-1.71 1.67a1 1 0 0 0-.21 1.09A1 1 0 0 0 4 21h8a9 9 0 0 0 9-9v-.44a1 1 0 0 0-1.09-.92" })
), Mf = h(za), a4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4-9A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.7A8 8 0 1 1 12 20" })
), Hf = h(a4), t4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 14a1 1 0 0 0-1.22.72A7 7 0 0 1 11 20H5.41l.64-.63a1 1 0 0 0 0-1.41A7 7 0 0 1 11 6a9 9 0 0 1 .88 0 1 1 0 1 0 .24-2A8 8 0 0 0 11 4a9 9 0 0 0-7 14.62l-1.71 1.67a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h8a9 9 0 0 0 8.72-6.75A1 1 0 0 0 19 14m2.71-6.74a1 1 0 0 0-1.42 0L19 8.59V3a1 1 0 0 0-2 0v5.59l-1.29-1.3a1 1 0 1 0-1.42 1.42l3 3a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l3-3a1 1 0 0 0 0-1.42Z" })
), Cf = h(t4), e4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 4.72-2.43-2.43a1 1 0 0 0-1.41 0l-5.58 5.58a1 1 0 0 0-.29.71V11a1 1 0 0 0 1 1h2.42a1 1 0 0 0 .71-.29l5.58-5.58a1 1 0 0 0 0-1.41M15 10h-1V9l4.58-4.58 1 1Zm4 2a1 1 0 0 0-1 1 7 7 0 0 1-7 7H5.41l.64-.63a1 1 0 0 0 0-1.42A7 7 0 0 1 11 6a1 1 0 0 0 0-2 9 9 0 0 0-7 14.62l-1.71 1.67a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h8a9 9 0 0 0 9-9 1 1 0 0 0-1-1" })
), uf = h(e4), l4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 14a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-12A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.7A8 8 0 1 1 12 20m0-12a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1" })
), Vf = h(l4), r4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 8.35a3.07 3.07 0 0 0-3.54.53 3 3 0 0 0 0 4.24L11.29 16a1 1 0 0 0 1.42 0l2.83-2.83a3 3 0 0 0 0-4.24A3.07 3.07 0 0 0 12 8.35m2.12 3.36L12 13.83l-2.12-2.12a1 1 0 0 1 0-1.42 1 1 0 0 1 1.41 0 1 1 0 0 0 1.42 0 1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.42M12 2A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20" })
), Sf = h(r4), h4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 0 0-9.56 12.91.3.3 0 0 0 0 .1 9.8 9.8 0 0 0 1.79 3.32l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 9.46-6.78v-.08A9.9 9.9 0 0 0 22 12 10 10 0 0 0 12 2m0 18H5.41l.3-.29 8.41-8.42a1 1 0 0 1 1.4 0l3.62 3.6.23.22A8 8 0 0 1 12 20m-7.46-5.13 1.58-1.58a1 1 0 0 1 1.41 0l.87.87-2.72 2.74a7.7 7.7 0 0 1-1.14-2.03m15.41-2-3-3a3 3 0 0 0-4.24 0l-2.89 2.89-.88-.87a3 3 0 0 0-4.23 0l-.71.67A5 5 0 0 1 4 12a8 8 0 0 1 16 0 8 8 0 0 1 0 .86Z" })
), Lf = h(h4), o4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 9a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m7-7H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM12 6a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), Zf = h(o4), n4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 11a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m0-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-6A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.7A8 8 0 1 1 12 20" })
), Bf = h(n4), w4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 9H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m-4 4H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2M12 2A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20" })
), Ff = h(w4), v4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.92 16.13a1 1 0 0 0-1.37.37A7 7 0 0 1 11.5 20H5.91l.64-.63a1 1 0 0 0 0-1.41 7 7 0 0 1 4.07-11.91 1 1 0 1 0-.24-2 9 9 0 0 0-5.91 14.57l-1.68 1.67a1 1 0 0 0-.21 1.09 1 1 0 0 0 .92.62h8a9 9 0 0 0 7.79-4.5 1 1 0 0 0-.37-1.37m.58-9.95V5a3 3 0 0 0-6 0v1.18a3 3 0 0 0-2 2.82v2a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3V9a3 3 0 0 0-2-2.82M15.5 5a1 1 0 0 1 2 0v1h-2Zm4 6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Z" })
), Rf = h(v4), m4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20m2-9h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2" })
), Uf = h(m4), c4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20m5-9H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m-2 4H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2M9 9h6a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2" })
), $f = h(c4), s4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 11h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2M7 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m5-11A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.7A8 8 0 1 1 12 20m5-7h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" })
), yf = h(s4), g4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20m3-9h-2V9a1 1 0 0 0-2 0v2H9a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2" })
), kf = h(g4), i4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.77 5.87a1 1 0 0 0 1.36-.37A1 1 0 0 1 18 6a1 1 0 0 1-1 1 1 1 0 0 0 0 2 3 3 0 1 0-2.6-4.5 1 1 0 0 0 .37 1.37m4.3 7.13a1 1 0 0 0-1.12.86A7 7 0 0 1 11 20H5.41l.65-.65a1 1 0 0 0 0-1.41A7 7 0 0 1 11 6a1 1 0 0 0 0-2 9 9 0 0 0-7 14.61l-1.71 1.68a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h8a9 9 0 0 0 8.93-7.87 1 1 0 0 0-.86-1.13m-1.69-2.93a1 1 0 0 0-.58-.07l-.18.06-.18.09-.15.13a1 1 0 0 0-.21.32.84.84 0 0 0-.08.4 1 1 0 0 0 .07.39 1 1 0 0 0 .22.32A1 1 0 0 0 17 12a1 1 0 0 0 1-1 .84.84 0 0 0-.08-.38 1.07 1.07 0 0 0-.54-.54Z" })
), bf = h(i4), d4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 14a1 1 0 0 0-1.22.72A7 7 0 0 1 11 20H5.41l.64-.63a1 1 0 0 0 0-1.41 7 7 0 0 1 3.2-11.74 1 1 0 0 0-.5-1.94A9 9 0 0 0 4 18.62l-1.71 1.67a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h8a9 9 0 0 0 8.72-6.75A1 1 0 0 0 19 14m2-12a1 1 0 0 0-1 1 5 5 0 1 0 .3 7.75 1 1 0 1 0-1.3-1.5A3 3 0 1 1 17 4a3 3 0 0 1 2.23 1H18a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1" })
), Tf = h(d4), p4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.21 10.29-1.73-1.72a4.37 4.37 0 0 0 .65-2.26 4.31 4.31 0 1 0-4.32 4.32 4.35 4.35 0 0 0 2.26-.63l1.72 1.73a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.44M17.45 8a2.32 2.32 0 0 1-3.95-1.69 2.3 2.3 0 0 1 .68-1.63 2.32 2.32 0 0 1 3.27 0 2.31 2.31 0 0 1 0 3.27Zm2.05 6a1 1 0 0 0-1.22.72A7 7 0 0 1 11.5 20H5.91l.64-.63a1 1 0 0 0 0-1.41 7 7 0 0 1-2-5 7 7 0 0 1 4.32-6.44 1 1 0 1 0-.74-1.86 9 9 0 0 0-3.66 14l-1.68 1.63a1 1 0 0 0-.21 1.09 1 1 0 0 0 .92.62h8a9 9 0 0 0 8.72-6.75A1 1 0 0 0 19.5 14" })
), Pf = h(p4), f4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.06 13.51a1 1 0 0 0-1.11.87A7 7 0 0 1 11 20.5H5.41l.64-.63a1 1 0 0 0 0-1.41 7 7 0 0 1 3.2-11.74 1 1 0 0 0-.5-1.94A9 9 0 0 0 4 19.12l-1.71 1.67a1 1 0 0 0-.21 1.09 1 1 0 0 0 .92.62h8a9 9 0 0 0 8.93-7.88 1 1 0 0 0-.87-1.11M19 7.5a2 2 0 0 0-1.18.39l-1.75-.8L18 6.21a2 2 0 0 0 1 .29 2 2 0 1 0-2-2l-1.9.87A2 2 0 0 0 14 5a2 2 0 0 0 0 4 2 2 0 0 0 .93-.24l2.09 1A2 2 0 1 0 19 7.5" })
), Df = h(f4), E4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.7 2.86a1 1 0 0 0-.84-.2 3 3 0 0 1-2.33-.48 1 1 0 0 0-1.15 0 3 3 0 0 1-2.33.48 1 1 0 0 0-.84.2 1 1 0 0 0-.37.77V7a4.56 4.56 0 0 0 1.91 3.7l1.62 1.16a1 1 0 0 0 1.17 0l1.62-1.16A4.56 4.56 0 0 0 22.07 7V3.63a1 1 0 0 0-.37-.77M20.07 7A2.57 2.57 0 0 1 19 9l-1 .74L16.91 9a2.57 2.57 0 0 1-1.07-2V4.72A5.2 5.2 0 0 0 18 4.17a5.1 5.1 0 0 0 2.11.55Zm-1.14 7a1 1 0 0 0-1.21.72A7 7 0 0 1 10.93 20H5.35l.65-.63A1 1 0 0 0 6 18a7 7 0 0 1 4.93-12 1 1 0 0 0 0-2 9 9 0 0 0-7 14.62l-1.7 1.67a1 1 0 0 0 .7 1.71h8a9 9 0 0 0 8.72-6.75 1 1 0 0 0-.72-1.25" })
), qf = h(E4), x4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.19 5.23A7.1 7.1 0 0 1 12 5a7 7 0 0 1 7 7 7.1 7.1 0 0 1-.23 1.81 1 1 0 0 0 .7 1.23 1.2 1.2 0 0 0 .26 0 1 1 0 0 0 1-.74A9 9 0 0 0 21 12a9 9 0 0 0-9-9 9 9 0 0 0-2.33.3A1 1 0 0 0 9 4.53a1 1 0 0 0 1.19.7m11.52 15.06-18-18a1 1 0 0 0-1.42 1.42L5 6.38a9 9 0 0 0 0 11.24l-1.71 1.67a1 1 0 0 0-.21 1.09A1 1 0 0 0 4 21h8a9 9 0 0 0 5.62-2l2.67 2.68a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.39M12 19H6.41l.64-.63a1 1 0 0 0 0-1.41 7 7 0 0 1-.65-9.15l9.79 9.79A7 7 0 0 1 12 19" })
), If = h(x4), A4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 14a1 1 0 0 0-1.22.72A7 7 0 0 1 11 20H5.41l.64-.63a1 1 0 0 0 0-1.41A7 7 0 0 1 11 6a1 1 0 0 0 0-2 9 9 0 0 0-7 14.62l-1.71 1.67a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h8a9 9 0 0 0 8.72-6.75A1 1 0 0 0 19 14m2.71-8.74-3-3a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-3 3a1 1 0 0 0 1.42 1.42L17 5.41V11a1 1 0 0 0 2 0V5.41l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), Wf = h(A4), M4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m15.29 8.85-4.73 4.74-1.85-1.86a1 1 0 0 0-1.42 1.42l2.56 2.56a1 1 0 0 0 1.42 0l5.44-5.44a1 1 0 1 0-1.42-1.42M12 2A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20" })
), Gf = h(M4), H4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20" })
), Of = h(H4), C4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 8h-1V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v12a1 1 0 0 0 .62.92A.84.84 0 0 0 3 18a1 1 0 0 0 .71-.29l2.81-2.82H8v1.44a3 3 0 0 0 3 3h6.92l2.37 2.38A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V11a3 3 0 0 0-3-3M8 11v1.89H6.11a1 1 0 0 0-.71.29L4 14.59V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3h-5a3 3 0 0 0-3 3m12 7.59-1-1a1 1 0 0 0-.71-.3H11a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Z" })
), Nf = h(C4), u4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.61 19.19a7 7 0 0 0-2.74-10.57 8 8 0 1 0-14.19 6.29l-1.39 1.38a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 18h5.69A7 7 0 0 0 15 22h6a1 1 0 0 0 .92-.62 1 1 0 0 0-.21-1.09ZM8 15a6.6 6.6 0 0 0 .08 1H5.41l.35-.34a1 1 0 0 0 0-1.42A5.93 5.93 0 0 1 4 10a6 6 0 0 1 6-6 5.94 5.94 0 0 1 5.65 4H15a7 7 0 0 0-7 7m10.54 5 .05.05H15a5 5 0 1 1 3.54-1.46 1 1 0 0 0-.3.7 1 1 0 0 0 .3.71" })
), Qf = h(u4), V4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m0-11a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), Kf = h(V4), S4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 20H4v-.54l5-5 3.8 3.8a1 1 0 0 0 1.41 0l7.5-7.5a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0l-6.8 6.8-3.79-3.8a1 1 0 0 0-1.41 0L4 16.63v-5.17l5-5 2.8 2.8a1 1 0 0 0 1.41 0L18 4.47l2.19 2.19a1 1 0 0 0 1.41-1.42l-2.91-2.89a1 1 0 0 0-1.41 0l-4.8 4.8-2.79-2.8a1 1 0 0 0-1.41 0L4 8.63V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2" })
), jf = h(S4), L4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m1 17.93V19a1 1 0 0 0-2 0v.93A8 8 0 0 1 4.07 13H5a1 1 0 0 0 0-2h-.93A8 8 0 0 1 11 4.07V5a1 1 0 0 0 2 0v-.93A8 8 0 0 1 19.93 11H19a1 1 0 0 0 0 2h.93A8 8 0 0 1 13 19.93m2.14-12.38-5 2.12a1 1 0 0 0-.52.52l-2.12 5a1 1 0 0 0 .21 1.1 1 1 0 0 0 .7.3.9.9 0 0 0 .4-.09l5-2.12a1 1 0 0 0 .52-.52l2.12-5a1 1 0 0 0-1.31-1.31m-2.49 5.1-2.28 1 1-2.28 2.28-1Z" })
), Jf = h(L4), Z4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.5 5.5a1 1 0 0 0-1 1v1.59l-5.79-5.8a1 1 0 0 0-1.42 1.42l5.8 5.79H6.5a1 1 0 0 0 0 2h4a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54 1 1 0 0 0 .08-.38v-4a1 1 0 0 0-1-1m11.21 14.79-5.8-5.79h1.59a1 1 0 0 0 0-2h-4a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54 1 1 0 0 0-.08.38v4a1 1 0 0 0 2 0v-1.59l5.79 5.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42" })
), Yf = h(Z4), B4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 2.29a1 1 0 0 0-1.42 0l-5.79 5.8V6.5a1 1 0 0 0-2 0v4a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54 1 1 0 0 0 .38.08h4a1 1 0 0 0 0-2h-1.59l5.8-5.79a1 1 0 0 0 0-1.42M10.88 12.58a1 1 0 0 0-.38-.08h-4a1 1 0 0 0 0 2h1.59l-5.8 5.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l5.79-5.8v1.59a1 1 0 0 0 2 0v-4a1 1 0 0 0-.08-.38 1 1 0 0 0-.54-.54" })
), Xf = h(B4), F4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.38 13.08A1 1 0 0 0 10 13H6a1 1 0 0 0 0 2h1.59l-5.3 5.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L9 16.41V18a1 1 0 0 0 2 0v-4a1 1 0 0 0-.08-.38 1 1 0 0 0-.54-.54M10 5a1 1 0 0 0-1 1v1.59l-5.29-5.3a1 1 0 0 0-1.42 1.42L7.59 9H6a1 1 0 0 0 0 2h4a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 11 10V6a1 1 0 0 0-1-1m3.62 5.92A1 1 0 0 0 14 11h4a1 1 0 0 0 0-2h-1.59l5.3-5.29a1 1 0 1 0-1.42-1.42L15 7.59V6a1 1 0 0 0-2 0v4a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54M16.41 15H18a1 1 0 0 0 0-2h-4a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 13 14v4a1 1 0 0 0 2 0v-1.59l5.29 5.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), _f = h(F4), R4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 20h-4v-3.59l.79.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.5-2.5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.5 2.5a1 1 0 0 0 1.42 1.42l.79-.8V20H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2M7 4h4v3.59l-.79-.8a1 1 0 1 0-1.42 1.42l2.5 2.5a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2.5-2.5a1 1 0 1 0-1.42-1.42l-.79.8V4h4a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2" })
), zf = h(R4), U4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 20.29 15.41 14H17a1 1 0 0 0 0-2h-3.59l5.66-5.66a1 1 0 1 0-1.41-1.41L12 10.59V7a1 1 0 0 0-2 0v1.59l-6.29-6.3a1 1 0 0 0-1.42 1.42L8.59 10H7a1 1 0 0 0 0 2h3.59l-5.66 5.66a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0L12 13.41V17a1 1 0 0 0 2 0v-1.59l6.29 6.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42" })
), aE = h(U4), $4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.71 13.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.5 2.5a1 1 0 0 0 1.42 1.42l.79-.8V21a1 1 0 0 0 2 0v-4.59l.79.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm-1.42-2.58a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2.5-2.5a1 1 0 1 0-1.42-1.42l-.79.8V3a1 1 0 0 0-2 0v4.59l-.79-.8a1 1 0 1 0-1.42 1.42Z" })
), tE = h($4), y4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 9h5a1 1 0 0 0 0-2h-4V3a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1m-8 6H3a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1M8 2a1 1 0 0 0-1 1v4H3a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m13 13h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2" })
), eE = h(y4), k4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m5.66 4.56-4.19 1.5A1 1 0 0 0 10.8 17a1 1 0 0 0 .34-.06l4.2-1.5a1 1 0 1 0-.68-1.88M15 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), lE = h(k4), b4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 9.67V9.5a7.95 7.95 0 0 0-5.59-7.62h-.06a8.3 8.3 0 0 0-2.59-.36A8.21 8.21 0 0 0 4 9.67a3 3 0 0 0 0 5.66 8 8 0 0 0 8 7.17h.23a8.13 8.13 0 0 0 7.68-7.16A3 3 0 0 0 20 9.67M12.18 20.5a6 6 0 0 1-6.09-5h11.77a6.09 6.09 0 0 1-5.68 5m6.82-7H5a1 1 0 0 1 0-2h2a1 1 0 0 0 0-2H6a6.4 6.4 0 0 1 3-5.15V7.5a1 1 0 0 0 2 0V3.59a7 7 0 0 1 .82-.09H12a7 7 0 0 1 1 .09V7.5a1 1 0 0 0 2 0V4.32a6.7 6.7 0 0 1 1.18.87A6 6 0 0 1 18 9.5h-1a1 1 0 0 0 0 2h2a1 1 0 0 1 0 2" })
), rE = h(b4), T4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 20H8a3 3 0 0 1-3-3V7a1 1 0 0 0-2 0v10a5 5 0 0 0 5 5h8a1 1 0 0 0 0-2m5-11.06a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09L14.06 2H10a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8.94m-6-3.53L17.59 8H16a1 1 0 0 1-1-1ZM19 15a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a3 3 0 0 0 3 3h3Z" })
), hE = h(T4), P4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 19H6a3 3 0 0 1-3-3V8a1 1 0 0 0-2 0v8a5 5 0 0 0 5 5h12a1 1 0 0 0 0-2m5-9.06a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09L16.06 3H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V9.94m-6-3.53L19.59 9H18a1 1 0 0 1-1-1ZM21 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7v3a3 3 0 0 0 3 3h3Z" })
), oE = h(P4), D4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H10a3 3 0 0 0-3 3v1H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h1a3 3 0 0 0 3-3V8.94m-6-3.53L17.59 8H16a1 1 0 0 1-1-1ZM15 19a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1v7a3 3 0 0 0 3 3h5Zm4-4a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a3 3 0 0 0 3 3h3Z" })
), nE = h(D4), q4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 9h2a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 1 1 0 0 0-2 0 1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m1-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), wE = h(q4), I4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.69 2a1 1 0 0 0-1 1v10.37a2 2 0 0 1-2 2h-8l2.92-2.92A1 1 0 0 0 9.24 11l-4.63 4.66a1.2 1.2 0 0 0-.22.33 1 1 0 0 0 0 .76 1 1 0 0 0 .22.33l4.63 4.63a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-2.92-2.92h8a4 4 0 0 0 4-4V3a1 1 0 0 0-1.04-1" })
), vE = h(I4), W4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.92 12.62a1 1 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42l1.3 1.29H8a1 1 0 0 1-1-1V7a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h9.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
), mE = h(W4), G4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.61 16a1.2 1.2 0 0 0-.22-.33L14.76 11a1 1 0 0 0-1.41 1.41l2.92 2.92h-7a3 3 0 0 1-3-3V3a1 1 0 1 0-2 0v9.37a5 5 0 0 0 5 5h7l-2.92 2.92a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29l4.63-4.63a1 1 0 0 0 .22-.33 1 1 0 0 0 0-.75" })
), cE = h(G4), O4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 4.31h-9.37a5 5 0 0 0-5 5v7l-2.92-2.96a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l4.63 4.63a1 1 0 0 0 .33.22.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.22L13 14.76a1 1 0 0 0-1.41-1.41l-2.96 2.92v-7a3 3 0 0 1 3-3H21a1 1 0 0 0 0-2Z" })
), sE = h(O4), N4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 13.35a1 1 0 0 0-1.42 0l-2.92 2.92v-8a4 4 0 0 0-4-4H3a1 1 0 1 0 0 2h10.37a2 2 0 0 1 2 2v8l-2.92-2.92A1 1 0 0 0 11 14.76l4.62 4.63a1.2 1.2 0 0 0 .33.22.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.22l4.63-4.63a1 1 0 0 0 .04-1.41" })
), gE = h(N4), Q4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 9.5H7.41l1.3-1.29a1 1 0 0 0-1.42-1.42l-3 3a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-1.3-1.29H17a1 1 0 0 1 1 1v4a1 1 0 0 0 2 0v-4a3 3 0 0 0-3-3" })
), iE = h(Q4), K4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.69 6.63h-7l2.92-2.92a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0L4.61 6.92a1 1 0 0 0-.22.33 1 1 0 0 0 0 .76 1.2 1.2 0 0 0 .22.33L9.24 13a1 1 0 0 0 .7.3 1 1 0 0 0 .71-1.71L7.73 8.63h7a3 3 0 0 1 3 3V21a1 1 0 0 0 2 0v-9.37a5 5 0 0 0-5.04-5" })
), dE = h(K4), j4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.92 10.12a1 1 0 0 0-.21-.33l-3-3a1 1 0 1 0-1.42 1.42l1.3 1.29H7a3 3 0 0 0-3 3v4a1 1 0 0 0 2 0v-4a1 1 0 0 1 1-1h9.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76" })
), pE = h(j4), J4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.61 7.25a1 1 0 0 0-.22-.33l-4.63-4.63a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42l2.92 2.92h-8a4 4 0 0 0-4 4V21a1 1 0 0 0 2 0V10.63a2 2 0 0 1 2-2h8l-2.92 2.92a1 1 0 0 0 .71 1.71 1 1 0 0 0 .7-.3l4.63-4.62a1.2 1.2 0 0 0 .22-.34 1 1 0 0 0 0-.75" })
), fE = h(J4), Y4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.5 9a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 9.5 9M9 14a1 1 0 1 0 1 1 1 1 0 0 0-1-1m6-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-.5 4a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5m7.5-1h-1.059a8.95 8.95 0 0 0-1.916-4.61l.753-.754a1 1 0 0 0-1.414-1.414l-.753.753A8.95 8.95 0 0 0 13 3.059V2a1 1 0 0 0-2 0v1.059a8.95 8.95 0 0 0-4.61 1.916l-.754-.753a1 1 0 0 0-1.414 1.414l.753.753A8.95 8.95 0 0 0 3.059 11H2a1 1 0 0 0 0 2h1.059a8.95 8.95 0 0 0 1.916 4.61l-.753.754a1 1 0 1 0 1.414 1.414l.753-.753A8.95 8.95 0 0 0 11 20.941V22a1 1 0 0 0 2 0v-1.059a8.95 8.95 0 0 0 4.61-1.916l.754.753a1 1 0 0 0 1.414-1.414l-.753-.753A8.95 8.95 0 0 0 20.941 13H22a1 1 0 0 0 0-2m-4 2h.92A7 7 0 0 1 13 18.92V17a1 1 0 0 0-2 0v1.92A7 7 0 0 1 5.08 13H6a1 1 0 0 0 0-2h-.92A7 7 0 0 1 11 5.08V7a1 1 0 0 0 2 0V5.08A7 7 0 0 1 18.92 11H18a1 1 0 0 0 0 2" })
), EE = h(Y4), X4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 13H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m-1 6H5v-4h4ZM20 3h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m-1 6h-4V5h4Zm1 7h-2v-2a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M9 9H5V5h4Z" })
), xE = h(X4), _4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8 7.92 7.92 0 0 1 1.69-4.9l2.36 2.37A3 3 0 0 0 8 10v4a3 3 0 0 0 3 3h2a3 3 0 0 0 1.89-.69l2 2A7.92 7.92 0 0 1 12 20m-2-6v-2.59l3.46 3.46A.9.9 0 0 1 13 15h-2a1 1 0 0 1-1-1m8.31 2.9L16 14.53a3 3 0 0 0 0-.53 1 1 0 0 0-1-1 .9.9 0 0 0-.46.13l-4-4A.9.9 0 0 1 11 9h2a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3h-2a3 3 0 0 0-1.89.69l-2-2A7.92 7.92 0 0 1 12 4a8 8 0 0 1 8 8 7.92 7.92 0 0 1-1.69 4.9" })
), AE = h(_4), z4 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 17.57a4.3 4.3 0 1 0-3.67 2.06 4.37 4.37 0 0 0 2.24-.63l1.72 1.73a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM18 17a2.37 2.37 0 0 1-3.27 0 2.32 2.32 0 0 1 0-3.27 2.31 2.31 0 0 1 3.27 0A2.32 2.32 0 0 1 18 17m1-14H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h4a1 1 0 0 0 0-2H5a1 1 0 0 1-1-1V9h16v1a1 1 0 0 0 2 0V6a3 3 0 0 0-3-3m1 4H4V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm-10 4H7a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2" })
), ME = h(z4), at = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 15h3a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2M19 5H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3m1 12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6h16Zm0-8H4V8a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), HE = h(at), tt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 12.15V3a1 1 0 0 0-2 0v9.15a4.16 4.16 0 0 0-3 4c0 2.05 1.52 5.8 4 5.8s4-3.75 4-5.8a4.16 4.16 0 0 0-3-4M17 20c-.8 0-2-2.27-2-3.8a2.11 2.11 0 0 1 2-2.2 2.11 2.11 0 0 1 2 2.2c0 1.53-1.2 3.8-2 3.8M10 2a1 1 0 0 0-1 1v5.46l-1 .67V3a1 1 0 0 0-2 0v6.13l-1-.67V3a1 1 0 0 0-2 0v6a1 1 0 0 0 .45.83L6 11.54V21a1 1 0 0 0 2 0v-9.46l2.55-1.71A1 1 0 0 0 11 9V3a1 1 0 0 0-1-1" })
), CE = h(tt), et = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.71 16.29a1 1 0 0 0-1.42 1.42l.3.29H8a3 3 0 0 1-3-3v-2a1 1 0 0 0-2 0v2a5 5 0 0 0 5 5h.59l-.3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2-2a1 1 0 0 0 0-1.42ZM20 12h-1V5a1 1 0 0 0-1-1h-7V3a1 1 0 0 0-2 0v1H8a1 1 0 0 0 0 2h1v7a1 1 0 0 0 1 1h7v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m-3 0h-6V6h6Z" })
), uE = h(et), lt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 4h-.59l.3-.29a1 1 0 1 0-1.42-1.42l-2 2a1 1 0 0 0 0 1.42l2 2a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29H16a3 3 0 0 1 3 3v2a1 1 0 0 0 2 0V9a5 5 0 0 0-5-5m0 14h-1v-7a1 1 0 0 0-1-1H7V9a1 1 0 0 0-2 0v1H4a1 1 0 0 0 0 2h1v7a1 1 0 0 0 1 1h7v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m-3 0H7v-6h6Z" })
), VE = h(lt), rt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 16h-1V7a1 1 0 0 0-1-1H8V5a1 1 0 0 0-2 0v1H5a1 1 0 0 0 0 2h1v9a1 1 0 0 0 1 1h9v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m-3 0H8V8h8Z" })
), SE = h(rt), ht = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-9a10 10 0 1 0 10 10A10 10 0 0 0 12 2m1 17.93V17a1 1 0 0 0-2 0v2.93A8 8 0 0 1 4.07 13H7a1 1 0 0 0 0-2H4.07A8 8 0 0 1 11 4.07V7a1 1 0 0 0 2 0V4.07A8 8 0 0 1 19.93 11H17a1 1 0 0 0 0 2h2.93A8 8 0 0 1 13 19.93" })
), LE = h(ht), ot = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11h-1.07A8 8 0 0 0 13 4.07V3a1 1 0 0 0-2 0v1.07A8 8 0 0 0 4.07 11H3a1 1 0 0 0 0 2h1.07A8 8 0 0 0 11 19.93V21a1 1 0 0 0 2 0v-1.07A8 8 0 0 0 19.93 13H21a1 1 0 0 0 0-2m-4 2h.91A6 6 0 0 1 13 17.91V17a1 1 0 0 0-2 0v.91A6 6 0 0 1 6.09 13H7a1 1 0 0 0 0-2h-.91A6 6 0 0 1 11 6.09V7a1 1 0 0 0 2 0v-.91A6 6 0 0 1 17.91 11H17a1 1 0 0 0 0 2m-5-2a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), ZE = h(ot), nt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11h-1.07A8 8 0 0 0 13 4.07V3a1 1 0 0 0-2 0v1.07A8 8 0 0 0 4.07 11H3a1 1 0 0 0 0 2h1.07A8 8 0 0 0 11 19.93V21a1 1 0 0 0 2 0v-1.07A8 8 0 0 0 19.93 13H21a1 1 0 0 0 0-2m-9 7a6 6 0 1 1 6-6 6 6 0 0 1-6 6m0-9a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), BE = h(nt), wt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.772 3.364A1 1 0 0 0 20 3H6a1 1 0 0 0 0 2h12.786l-.78 4H5a1 1 0 0 0 0 2h12.615l-1.163 5.955-6.323 1.997-5.41-1.7.203-1.064a1 1 0 0 0-1.964-.375l-.37 1.94a1 1 0 0 0 .682 1.141l6.56 2.06a1 1 0 0 0 .601 0l7.19-2.27a1 1 0 0 0 .68-.763l2.68-13.73a1 1 0 0 0-.209-.827" })
), FE = h(wt), vt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.47 7.37v-.08l-.06-.15a1 1 0 0 0-.07-.09 1 1 0 0 0-.09-.12l-.09-.07-.16-.08-7.5-4.63a1 1 0 0 0-1.06 0L4 6.78l-.09.08-.09.07a1 1 0 0 0-.09.12 1 1 0 0 0-.07.09l-.06.15v.08a1.2 1.2 0 0 0 0 .26v8.74a1 1 0 0 0 .47.85l7.5 4.63a.5.5 0 0 0 .15.06s.05 0 .08 0a.86.86 0 0 0 .52 0h.08a.5.5 0 0 0 .15-.06L20 17.22a1 1 0 0 0 .47-.85V7.63a1.2 1.2 0 0 0 0-.26M11 19.21l-5.5-3.4V9.43l5.5 3.39Zm1-8.12L6.4 7.63 12 4.18l5.6 3.45Zm6.5 4.72-5.5 3.4v-6.39l5.5-3.39Z" })
), RE = h(vt), mt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.088 4.955c-.007-.008-.01-.019-.017-.026s-.018-.01-.026-.018a9.98 9.98 0 0 0-14.09 0c-.008.008-.018.01-.026.018s-.01.018-.017.026a10 10 0 1 0 14.176 0M12 20a7.99 7.99 0 0 1-6.235-3H9.78a2.964 2.964 0 0 0 4.44 0h4.015A7.99 7.99 0 0 1 12 20m-1-5a1 1 0 1 1 1 1 1 1 0 0 1-1-1m8.41.002L19.4 15H15a2.995 2.995 0 0 0-2-2.816V9a1 1 0 0 0-2 0v3.184A2.995 2.995 0 0 0 9 15H4.6l-.01.002A8 8 0 0 1 4.07 13H5a1 1 0 0 0 0-2h-.93a7.95 7.95 0 0 1 1.619-3.898l.654.655a1 1 0 1 0 1.414-1.414l-.654-.655A7.95 7.95 0 0 1 11 4.07V5a1 1 0 0 0 2 0v-.93a7.95 7.95 0 0 1 3.897 1.618l-.654.655a1 1 0 1 0 1.414 1.414l.654-.655A7.95 7.95 0 0 1 19.931 11H19a1 1 0 0 0 0 2h.93a8 8 0 0 1-.52 2.002" })
), UE = h(mt), ct = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.52 3.87a5 5 0 0 0-9.08.13H7a3 3 0 0 0-3 3v4a1 1 0 0 0 2 0V7a1 1 0 0 1 1-1h2.78A3 3 0 0 0 9 8a3 3 0 0 0 3 3h7.33a3.66 3.66 0 0 0 1.19-7.13M19.33 9H12a1 1 0 0 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 5.84-1 1 1 0 0 0 .78.67A1.65 1.65 0 0 1 21 7.33 1.67 1.67 0 0 1 19.33 9M19 13a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-2.26a3.66 3.66 0 0 0-2.22-2.13 5 5 0 0 0-9.45 1.28A3 3 0 0 0 4 23h7.33a3.66 3.66 0 0 0 3.6-3H17a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1m-7.67 8H4a1 1 0 0 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 5.84-1 1 1 0 0 0 .78.67A1.65 1.65 0 0 1 13 19.33 1.67 1.67 0 0 1 11.33 21" })
), $E = h(ct), st = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 17a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8-9H8a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4m2 16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2.56A3.9 3.9 0 0 0 8 16h8a3.9 3.9 0 0 0 2-.56Zm0-6a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9.44A3.9 3.9 0 0 0 8 10h8a3.9 3.9 0 0 0 2-.56Zm-2-4H8a2 2 0 0 1 0-4h8a2 2 0 0 1 0 4" })
), yE = h(st), gt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 16.5a1 1 0 1 0 1 1 1 1 0 0 0-1-1M12 2C8 2 4 3.37 4 6v12c0 2.63 4 4 8 4s8-1.37 8-4V6c0-2.63-4-4-8-4m6 16c0 .71-2.28 2-6 2s-6-1.29-6-2v-3.27A13.16 13.16 0 0 0 12 16a13.16 13.16 0 0 0 6-1.27Zm0-6c0 .71-2.28 2-6 2s-6-1.29-6-2V8.73A13.16 13.16 0 0 0 12 10a13.16 13.16 0 0 0 6-1.27Zm-6-4C8.28 8 6 6.71 6 6s2.28-2 6-2 6 1.29 6 2-2.28 2-6 2m-4 2.5a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), kE = h(gt), it = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 2a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2m-3 12h-2v-2a1 1 0 0 0-2 0v2H9v-3.38l3.45-1.73A1 1 0 0 0 13 14v-4a1 1 0 0 0-2 0v3.38l-2 1V8a1 1 0 0 0-2 0v8.38l-2-1V13a1 1 0 0 0-2 0v3a1 1 0 0 0 .55.89L7 18.62V20H3a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2" })
), bE = h(it), dt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 20.29-18-18a1 1 0 0 0-1.42 1.42l1 1A3 3 0 0 0 3 6v8a3 3 0 0 0 3 3h3v2H6a1 1 0 0 0 0 2h12a1 1 0 0 0 .93-.66l1.36 1.37a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M5 6.41 9.59 11H5ZM13 19h-2v-2h2Zm-7-4a1 1 0 0 1-1-1v-1h6.59l2 2Zm9 4v-2h.59l2 2ZM9.66 5H18a1 1 0 0 1 1 1v5h-1.34a1 1 0 0 0 0 2H19v1a.4.4 0 0 1 0 .11 1 1 0 0 0 .78 1.18h.2a1 1 0 0 0 1-.8A3 3 0 0 0 21 14V6a3 3 0 0 0-3-3H9.66a1 1 0 0 0 0 2" })
), TE = h(dt), pt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h3v2H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2h-3v-2h3a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-5 18h-4v-2h4Zm6-5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1h16Zm0-3H4V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), PE = h(pt), ft = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.5 10H10a3 3 0 0 0 1.07-5.8 4 4 0 0 0-7.48 1A2.5 2.5 0 0 0 4.5 10m0-3a1 1 0 0 0 1-1 2 2 0 0 1 3.89-.64 1 1 0 0 0 .78.66A1 1 0 0 1 11 7a1 1 0 0 1-1 1H4.5a.5.5 0 0 1 0-1M19 2h-5a1 1 0 0 0 0 2h5a1 1 0 0 1 1 1v7H3a1 1 0 0 0-1 1v2a3 3 0 0 0 3 3h3v2H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2h-3v-2h3a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-5 18h-4v-2h4Zm6-5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1h16Z" })
), DE = h(ft), Et = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.66 6H18a1 1 0 0 1 1 1v6a.94.94 0 0 1-.14.5 1 1 0 0 0 .31 1.38.94.94 0 0 0 .53.16 1 1 0 0 0 .84-.46A2.94 2.94 0 0 0 21 13V7a3 3 0 0 0-3-3h-7.34a1 1 0 0 0 0 2m11.05 14.29L5.86 4.45 3.71 2.29a1 1 0 0 0-1.42 1.42l1.4 1.39A3 3 0 0 0 3 7v6a3 3 0 0 0 3 3h5v2H7a1 1 0 0 0 0 2h10a1 1 0 0 0 .93-.66l2.36 2.37a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M6 14a1 1 0 0 1-1-1V7a1 1 0 0 1 .12-.46L12.59 14Zm7 4v-2h1.59l2 2Z" })
), qE = h(Et), xt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 3H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h6v2H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2h-4v-2h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), IE = h(xt), At = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 9.25A2.75 2.75 0 1 0 7.75 12 2.75 2.75 0 0 0 5 9.25m0 4A1.25 1.25 0 1 1 6.25 12 1.25 1.25 0 0 1 5 13.25m7-4A2.75 2.75 0 1 0 14.75 12 2.75 2.75 0 0 0 12 9.25m0 4A1.25 1.25 0 1 1 13.25 12 1.25 1.25 0 0 1 12 13.25m7-5.5A2.75 2.75 0 1 0 16.25 5 2.75 2.75 0 0 0 19 7.75m0-4A1.25 1.25 0 1 1 17.75 5 1.25 1.25 0 0 1 19 3.75m0 5.5A2.75 2.75 0 1 0 21.75 12 2.75 2.75 0 0 0 19 9.25m0 4A1.25 1.25 0 1 1 20.25 12 1.25 1.25 0 0 1 19 13.25m-14-11A2.75 2.75 0 1 0 7.75 5 2.75 2.75 0 0 0 5 2.25m0 4A1.25 1.25 0 1 1 6.25 5 1.25 1.25 0 0 1 5 6.25m7 10A2.75 2.75 0 1 0 14.75 19 2.75 2.75 0 0 0 12 16.25m0 4A1.25 1.25 0 1 1 13.25 19 1.25 1.25 0 0 1 12 20.25m0-18A2.75 2.75 0 1 0 14.75 5 2.75 2.75 0 0 0 12 2.25m0 4A1.25 1.25 0 1 1 13.25 5 1.25 1.25 0 0 1 12 6.25" })
), WE = h(At), Mt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 2.25H3a.76.76 0 0 0-.75.75v4a.76.76 0 0 0 .75.75h4A.76.76 0 0 0 7.75 7V3A.76.76 0 0 0 7 2.25m-.75 4h-2.5v-2.5h2.5Zm14.75-4h-4a.76.76 0 0 0-.75.75v4a.76.76 0 0 0 .75.75h4a.76.76 0 0 0 .75-.75V3a.76.76 0 0 0-.75-.75m-.75 4h-2.5v-2.5h2.5Zm-6.25-4h-4a.76.76 0 0 0-.75.75v4a.76.76 0 0 0 .75.75h4a.76.76 0 0 0 .75-.75V3a.76.76 0 0 0-.75-.75m-.75 4h-2.5v-2.5h2.5ZM7 9.25H3a.76.76 0 0 0-.75.75v4a.76.76 0 0 0 .75.75h4a.76.76 0 0 0 .75-.75v-4A.76.76 0 0 0 7 9.25m-.75 4h-2.5v-2.5h2.5Zm7.75-4h-4a.76.76 0 0 0-.75.75v4a.76.76 0 0 0 .75.75h4a.76.76 0 0 0 .75-.75v-4a.76.76 0 0 0-.75-.75m-.75 4h-2.5v-2.5h2.5Zm7.75-4h-4a.76.76 0 0 0-.75.75v4a.76.76 0 0 0 .75.75h4a.76.76 0 0 0 .75-.75v-4a.76.76 0 0 0-.75-.75m-.75 4h-2.5v-2.5h2.5Zm-6.25 3h-4a.76.76 0 0 0-.75.75v4a.76.76 0 0 0 .75.75h4a.76.76 0 0 0 .75-.75v-4a.76.76 0 0 0-.75-.75m-.75 4h-2.5v-2.5h2.5Z" })
), GE = h(Mt), Ht = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20 10.35-5.78-7.41A3.06 3.06 0 0 0 9.75 3L4 10.35A3.05 3.05 0 0 0 3.51 12 3.1 3.1 0 0 0 4 13.58l.06.07 5.74 7.41A3 3 0 0 0 12 22a3.06 3.06 0 0 0 2.26-1L20 13.65a3 3 0 0 0-.06-3.3Zm-1.57 2.14-5.67 7.22a1.11 1.11 0 0 1-1.42.07l-5.69-7.31a1 1 0 0 1-.14-.47 1.1 1.1 0 0 1 .1-.45l5.67-7.22a1.11 1.11 0 0 1 1.42-.07l5.63 7.28a1 1 0 0 1 .16.54 1.1 1.1 0 0 1-.1.41Z" })
), OE = h(Ht), Ct = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 2H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h12a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3M8 20H6V4h2Zm10-1a1 1 0 0 1-1 1h-7V4h7a1 1 0 0 1 1 1Z" })
), NE = h(Ct), ut = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 2H5a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-1h9a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-3 16H6V4h8Zm4-1a1 1 0 0 1-1 1h-1V4h1a1 1 0 0 1 1 1Z" })
), QE = h(ut), Vt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 2H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5m3 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3ZM8 15a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1M8 7a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), KE = h(Vt), St = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 14a1 1 0 1 0 1 1 1 1 0 0 0-1-1M9 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m6-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m2-6H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5m3 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3Z" })
), jE = h(St), Lt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 2H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5m3 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3Zm-8-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), JE = h(Lt), Zt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m6 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m2-5H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5m3 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3Zm-5-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), YE = h(Zt), Bt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1M8 7a1 1 0 1 0 1 1 1 1 0 0 0-1-1m9-5H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5m3 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3Zm-4-2a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), XE = h(Bt), Ft = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8-9H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5m3 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3Zm-5-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), _E = h(Ft), Rt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.71 10.21 12 7.91l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-3-3a1 1 0 0 0-1.42 0l-3 3a1 1 0 0 0 1.42 1.42m4.58 4.58L12 17.09l-2.29-2.3a1 1 0 0 0-1.42 1.42l3 3a1 1 0 0 0 1.42 0l3-3a1 1 0 0 0-1.42-1.42" })
), zE = h(Rt), Ut = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.12 9.88-7-7a3.08 3.08 0 0 0-4.24 0l-7 7a3 3 0 0 0 0 4.24l7 7a3 3 0 0 0 4.24 0l7-7a3 3 0 0 0 0-4.24m-1.41 2.83-7 7a1 1 0 0 1-1.42 0l-7-7a1 1 0 0 1 0-1.42l7-7a1 1 0 0 1 1.42 0l7 7a1 1 0 0 1 0 1.42m-5.5-3.42a1 1 0 0 0-1.42 1.42l.3.29H9.5a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-1h2.59l-.3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2-2a1 1 0 0 0 0-1.42Z" })
), ax = h(Ut), $t = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.893 10.63a1.146 1.146 0 1 0 1.049 1.141 1.096 1.096 0 0 0-1.05-1.141M18.89 2H5.11A2.114 2.114 0 0 0 3 4.12v13.906a2.114 2.114 0 0 0 2.109 2.12h11.664l-.546-1.904 1.317 1.224 1.245 1.152L21 22.572V4.119A2.114 2.114 0 0 0 18.891 2m-3.97 13.433s-.37-.442-.679-.833a3.25 3.25 0 0 0 1.862-1.224 6 6 0 0 1-1.183.607 6.8 6.8 0 0 1-1.491.442 7.2 7.2 0 0 1-2.664-.01 8.7 8.7 0 0 1-1.512-.442 6 6 0 0 1-.751-.35c-.031-.02-.062-.03-.093-.051a.1.1 0 0 1-.04-.031c-.186-.103-.289-.175-.289-.175a3.2 3.2 0 0 0 1.8 1.214c-.308.39-.689.853-.689.853a3.73 3.73 0 0 1-3.137-1.563 13.8 13.8 0 0 1 1.481-5.997 5.1 5.1 0 0 1 2.89-1.08l.103.124a6.9 6.9 0 0 0-2.705 1.347s.226-.123.607-.298a7.7 7.7 0 0 1 2.335-.648 1 1 0 0 1 .175-.02 8.7 8.7 0 0 1 2.077-.021 8.4 8.4 0 0 1 3.096.987 6.85 6.85 0 0 0-2.56-1.306l.143-.165a5.1 5.1 0 0 1 2.89 1.08 13.8 13.8 0 0 1 1.482 5.997 3.76 3.76 0 0 1-3.148 1.563" })
), tx = h($t), yt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m9 11.71.29-.3.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29.3-.29a1 1 0 0 0-1.46-1.42l-.29.3-.25-.3a1 1 0 1 0-1.46 1.42l.3.29-.3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0ZM15 14H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m5-11.71a1 1 0 0 0-1.42 0l-.29.3-.29-.3a1 1 0 0 0-1.42 1.42l.3.29-.3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l.29-.3.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29.3-.29a1 1 0 0 0 0-1.42" })
), ex = h(yt), kt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.2 13.73a1 1 0 0 0-1.41-.05A11.18 11.18 0 0 0 4 22a1 1 0 0 0 2 0 9.15 9.15 0 0 1 3.15-6.86 1 1 0 0 0 .05-1.41m10.17 4.64a10.9 10.9 0 0 0-1.6-3A14.3 14.3 0 0 0 14.06 12C16.3 10.57 20 7.4 20 2a1 1 0 0 0-2 0c0 5.4-4.59 8.17-6 8.89A13.4 13.4 0 0 1 9.31 9H12a1 1 0 0 0 0-2H7.55a9.4 9.4 0 0 1-1-2H15a1 1 0 0 0 0-2H6.06A8 8 0 0 1 6 2a1 1 0 0 0-2 0c0 7.57 7.3 10.79 7.61 10.92A13 13 0 0 1 14.7 15H12a1 1 0 0 0 0 2h4.43a9 9 0 0 1 1 2H9a1 1 0 0 0 0 2h8.94a8 8 0 0 1 .06 1 1 1 0 0 0 2 0 10.5 10.5 0 0 0-.22-2.19 9 9 0 0 0-.41-1.44" })
), lx = h(kt), bt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.8 8.8h1.8c.1 0 .2-.1.2-.2V7.1c0-.1-.1-.2-.2-.2H8.8c-.1 0-.2.1-.2.2v1.6s.1.1.2.1m2.4 2.3H13c.1 0 .2-.1.2-.2V9.3c0-.1-.1-.2-.2-.2h-1.8c-.1 0-.2.1-.2.2v1.6c0 .1.1.2.2.2m0-2.3H13c.1 0 .2-.1.2-.2V7.1l-.2-.2h-1.8c-.1 0-.2.1-.2.2v1.6s.1.1.2.1m2.5 2.3h1.8c.1 0 .2-.1.2-.2V9.3c0-.1-.1-.2-.2-.2h-1.8c-.1 0-.2.1-.2.2v1.6c0 .1.1.2.2.2m-2.5-4.6H13c.1 0 .2-.1.2-.2V4.8c0-.1-.1-.2-.2-.2h-1.8c-.1 0-.2.1-.2.2v1.6c0 .1.1.1.2.1m-7.4 4.6h1.8c.1 0 .2-.1.2-.2V9.3c0-.1-.1-.2-.2-.2H3.8c-.1 0-.2.1-.2.2v1.6zm18-1c-.5-.3-1.1-.5-1.6-.4-.3 0-.6 0-.8.1-.2-.9-.7-1.7-1.4-2.1l-.3-.2-.2.3c-.3.2-.5.6-.6 1.1-.2.8-.1 1.6.3 2.2-.5.2-1 .3-1.5.4H2.6c-.3 0-.6.3-.6.6 0 1.2.2 2.3.6 3.4s1.1 2 2 2.6c1.4.7 2.9 1 4.4.9.8 0 1.6-.1 2.4-.2 1.1-.2 2.2-.6 3.2-1.2.8-.5 1.5-1.1 2.2-1.8.9-1.1 1.6-2.3 2.1-3.7h.2c.8 0 1.6-.3 2.2-.8q.45-.3.6-.9l.1-.2zm-15.5 1H8c.1 0 .2-.1.2-.2V9.3c0-.1-.1-.2-.2-.2H6.3c-.1 0-.2.1-.2.2v1.6c0 .1.1.2.2.2m0-2.3H8c.1 0 .2-.1.2-.2V7.1c0-.1-.1-.2-.2-.2H6.3c-.1 0-.2.1-.2.2v1.6s.1.1.2.1m2.5 2.3h1.8c.1 0 .2-.1.2-.2V9.3c0-.1-.1-.2-.2-.2H8.8c-.1 0-.2.1-.2.2v1.6c0 .1.1.2.2.2" })
), rx = h(bt), Tt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 14a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m.38-2.92a1 1 0 0 0-.58-.08l-.18.06-.18.09-.15.12A1 1 0 0 0 11 12a1 1 0 0 0 .29.71 1 1 0 0 0 .33.21.84.84 0 0 0 .38.08 1 1 0 0 0 .71-.29A1 1 0 0 0 13 12a1 1 0 0 0-.29-.71 1.2 1.2 0 0 0-.33-.21M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.31-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Z" })
), hx = h(Tt), Pt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 12h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m1-6h4v4h-4Zm11 4h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m-2-2h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2M3 8h2a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m0 4h2a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-8 4H3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2" })
), ox = h(Pt), Dt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 12h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m1-6h4v4H4Zm9 2h8a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2m0 10H3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m8-4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-4h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2" })
), nx = h(Dt), qt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 18H3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2M3 8h8a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m0 4h8a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m0-10h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 6h-4V6h4Z" })
), wx = h(qt), It = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 11h-1V7h2a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3h-2V3a1 1 0 0 0-2 0v2h-1a4 4 0 0 0 0 8h1v4H9a1 1 0 0 1-1-1 1 1 0 0 0-2 0 3 3 0 0 0 3 3h2v2a1 1 0 0 0 2 0v-2h1a4 4 0 0 0 0-8m-3 0h-1a2 2 0 0 1 0-4h1Zm3 6h-1v-4h1a2 2 0 0 1 0 4" })
), vx = h(It), Wt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 11h-4a2 2 0 0 1 0-4h5a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3h-2V3a1 1 0 0 0-2 0v2h-1a4 4 0 0 0 0 8h4a2 2 0 0 1 0 4H9a1 1 0 0 1-1-1 1 1 0 0 0-2 0 3 3 0 0 0 3 3h2v2a1 1 0 0 0 2 0v-2h1a4 4 0 0 0 0-8" })
), mx = h(Wt), Gt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 11h-4a2 2 0 0 1 0-4h5a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3h-2V3a1 1 0 0 0-2 0v2h-1a4 4 0 0 0 0 8h4a2 2 0 0 1 0 4H9a1 1 0 0 1-1-1 1 1 0 0 0-2 0 3 3 0 0 0 3 3h2v2a1 1 0 0 0 2 0v-2h1a4 4 0 0 0 0-8" })
), cx = h(Gt), Ot = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.29 13.29a1 1 0 0 0 0 1.42l3 3a1 1 0 0 0 1.42 0l3-3a1 1 0 0 0-1.42-1.42L13 14.59V3a1 1 0 0 0-2 0v11.59l-1.29-1.3a1 1 0 0 0-1.42 0M18 9h-2a1 1 0 0 0 0 2h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3" })
), sx = h(Ot), Nt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 10a2 2 0 1 0 2 2 2 2 0 0 0-2-2m0 7a2 2 0 1 0 2 2 2 2 0 0 0-2-2m7-10a2 2 0 1 0-2-2 2 2 0 0 0 2 2m-7-4a2 2 0 1 0 2 2 2 2 0 0 0-2-2m7 14a2 2 0 1 0 2 2 2 2 0 0 0-2-2m0-7a2 2 0 1 0 2 2 2 2 0 0 0-2-2" })
), gx = h(Nt), Qt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 2a7.94 7.94 0 0 1 5.51 2.22 25 25 0 0 1-4.83 2.18 29 29 0 0 0-2.87-4.09A8 8 0 0 1 12 4M7.89 5.15A27 27 0 0 1 10.7 9a25 25 0 0 1-6 .74h-.36a8 8 0 0 1 3.55-4.59M6 17.31A7.9 7.9 0 0 1 4 12v-.29h.68a26.7 26.7 0 0 0 7-1c.32.61.62 1.24.91 1.89a14.3 14.3 0 0 0-4.29 2.41l-.3.24a21 21 0 0 0-2 2.06M12 20a7.9 7.9 0 0 1-4.47-1.37 18 18 0 0 1 1.56-1.58l.32-.27a12.6 12.6 0 0 1 4-2.27 32 32 0 0 1 1.4 5A8.1 8.1 0 0 1 12 20m4.63-1.49a35 35 0 0 0-1.28-4.46h.34a.25.25 0 0 1 .12 0h.69a9.4 9.4 0 0 1 3.09.53 7.94 7.94 0 0 1-2.96 3.93M16.5 12h-.62a1.6 1.6 0 0 0-.39 0 7 7 0 0 0-.81.1h-.1c-.29-.67-.59-1.32-.92-2a26.6 26.6 0 0 0 5.13-2.4A8 8 0 0 1 20 12v.51a11.5 11.5 0 0 0-3.5-.51" })
), ix = h(Qt), Kt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 4H9a1 1 0 0 0-1 1v2H3a1 1 0 0 0 0 2h5v4a1 1 0 0 0 2 0v-1h4v7a1 1 0 0 0 1 1h2a3 3 0 0 0 3-3v-5.18A3 3 0 0 0 22 9V7a3 3 0 0 0-3-3m-1 13a1 1 0 0 1-1 1h-1v-6h2Zm2-8a1 1 0 0 1-1 1h-9V6h6v1a1 1 0 0 0 2 0V6h1a1 1 0 0 1 1 1Z" })
), dx = h(Kt), jt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.61 11.81-3.25-2.53 3.26-2.56a1 1 0 0 0 .38-.86 1.06 1.06 0 0 0-.5-.8l-5.14-2.93a1 1 0 0 0-1.15.12L12 5.05l-3.21-2.8a1 1 0 0 0-1.15-.12L2.5 5.06a1.06 1.06 0 0 0-.5.8 1 1 0 0 0 .38.86l3.26 2.56-3.25 2.49a1 1 0 0 0-.39.86 1 1 0 0 0 .5.8l3.41 2v2.47a1 1 0 0 0 .48.85l5.09 3.13a1 1 0 0 0 1 0l5.09-3.13a1 1 0 0 0 .48-.85v-2.48l3.41-1.95a1 1 0 0 0 .5-.8 1 1 0 0 0-.35-.86M16 4.22l3.23 1.84-2.55 2-3-1.84Zm-1.09 5.12-2.91 2-2.91-2L12 7.55ZM4.79 6.06 8 4.22l2.31 2-3 1.84Zm0 6.39 2.5-1.92 3 2.08-2.22 1.73Zm11.29 4.86L12 19.83l-4.09-2.52v-.8a1 1 0 0 0 .85-.18l3.24-2.5 3.24 2.5a1 1 0 0 0 .61.21 1 1 0 0 0 .24 0Zm-.15-3-2.23-1.7 3-2.08 2.51 1.94Z" })
), px = h(jt), Jt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m17.48 6.55-2.84-2.84a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l2.12 2.12-8.1 8.1-2.12-2.12a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42l2.81 2.81 2.81 2.81a1 1 0 0 0 .71.3 1 1 0 0 0 .71-1.71l-2.09-2.09 8.1-8.1 2.12 2.12a1 1 0 1 0 1.41-1.42ZM3.71 17.46a1 1 0 0 0-1.42 1.42l2.83 2.83a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42Zm18-12.34-2.83-2.83a1 1 0 0 0-1.42 1.42l2.83 2.83a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42" })
), fx = h(Jt), Yt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 8a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 1 0-5.018 2.22c.01.01.162.17.194.216a.99.99 0 0 1 0 1.119 1 1 0 1 0 1.648 1.13 2.98 2.98 0 0 0-.005-3.388 7 7 0 0 0-.49-.557 1 1 0 0 1-.16-.181A1 1 0 0 1 12 8m0-6a7 7 0 0 0-6.762 8.812 1 1 0 0 0 1.932-.518A5 5 0 1 1 17 9a5.1 5.1 0 0 1-.705 2.567L12.73 19A2 2 0 0 1 11 20a2.027 2.027 0 0 1-2-2 2 2 0 0 1 .269-.999 1 1 0 0 0-1.733-1.002 3.999 3.999 0 1 0 6.963 3.934l3.563-7.433A7 7 0 0 0 12 2" })
), Ex = h(Yt), Xt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 18h4.24a1 1 0 0 0 .71-.29l6.92-6.93L19.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1 1 0 0 0-.29.71V17a1 1 0 0 0 1 1m9.76-13.59 2.83 2.83-1.42 1.42-2.83-2.83ZM6 13.17l5.93-5.93 2.83 2.83L8.83 16H6ZM21 20H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), xx = h(Xt), _t = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 12a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1m-15 .76V17a1 1 0 0 0 1 1h4.24a1 1 0 0 0 .71-.29l6.92-6.93L21.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1 1 0 0 0-.29.71m10.76-8.35 2.83 2.83-1.42 1.42-2.83-2.83ZM8 13.17l5.93-5.93 2.83 2.83L10.83 16H8Z" })
), Ax = h(_t), zt = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 17c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m7-10c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m-7 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-7-14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2" })
), Mx = h(zt), ae = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 10a2 2 0 1 0 2 2 2 2 0 0 0-2-2m-7 0a2 2 0 1 0 2 2 2 2 0 0 0-2-2m14 0a2 2 0 1 0 2 2 2 2 0 0 0-2-2" })
), Hx = h(ae), te = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 7a2 2 0 1 0-2-2 2 2 0 0 0 2 2m0 10a2 2 0 1 0 2 2 2 2 0 0 0-2-2m0-7a2 2 0 1 0 2 2 2 2 0 0 0-2-2" })
), Cx = h(te), ee = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-6 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m3-9a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m4.28-7.12a1 1 0 0 0-1.4-.16A2.8 2.8 0 0 0 14 14h-3.65a2.8 2.8 0 0 0-.88-1.31 1 1 0 0 0-1.36.2 1 1 0 0 0 .14 1.39 1 1 0 0 1 .25.72 1.1 1.1 0 0 1-.25.72 1 1 0 1 0 1.25 1.56 2.9 2.9 0 0 0 .84-1.28H14a2.7 2.7 0 0 0 .89 1.31 1 1 0 0 0 .57.18 1 1 0 0 0 .78-.38 1 1 0 0 0-.14-1.39 1 1 0 0 1-.25-.72 1.1 1.1 0 0 1 .25-.72 1 1 0 0 0 .18-1.4" })
), ux = h(ee), le = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.022 7h1a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V8a3.003 3.003 0 0 0-3-3h-1a1 1 0 0 0 0 2m-4 9h-1a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3.003 3.003 0 0 0 3 3h1a1 1 0 0 0 0-2m11-1a1 1 0 0 0 0-2h-3v-.5a1 1 0 0 0-2 0v.5h-3a1 1 0 0 0 0 2h5.184a6.7 6.7 0 0 1-1.225 2.527 6.7 6.7 0 0 1-.63-.983 1 1 0 1 0-1.779.912 8.7 8.7 0 0 0 .96 1.468 6.6 6.6 0 0 1-2.426 1.099 1 1 0 0 0 .427 1.954 8.6 8.6 0 0 0 3.445-1.622 8.7 8.7 0 0 0 3.469 1.622 1 1 0 1 0 .43-1.954 6.7 6.7 0 0 1-2.446-1.09A8.74 8.74 0 0 0 20.244 15Zm-11.97-3.757a1 1 0 0 0 1.94-.486l-1.757-7.03a2.281 2.281 0 0 0-4.426 0l-1.757 7.03a1 1 0 0 0 1.94.486L5.552 9h2.94ZM6.052 7l.698-2.787a.291.291 0 0 1 .544 0L7.991 7Z" })
), Vx = h(le), re = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H7.41l1.3-1.29a1 1 0 0 0-1.42-1.42l-3 3a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L7.41 14H17a3 3 0 0 0 3-3V7a1 1 0 0 0-1-1" })
), Sx = h(re), he = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 7h1v1a1 1 0 0 0 2 0V7h1a1 1 0 0 0 0-2h-1V4a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m4 4a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.41l5.88 5.89a3 3 0 0 0 4.24 0l2.47-2.47a1 1 0 0 0-1.42-1.42l-2.47 2.47a1 1 0 0 1-1.4 0L5.41 7H13a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1" })
), Lx = h(he), oe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3M5 6h14a1 1 0 0 1 1 1l-8 4.88L4 7a1 1 0 0 1 1-1m15 11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9.28l7.48 4.57a1 1 0 0 0 1 0L20 9.28Z" })
), Zx = h(oe), ne = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.5 13.26a5 5 0 1 0-3.5-1.47 5 5 0 0 0 3.5 1.47m2.12-2.88a3 3 0 0 1-3.4.58l4-4a3 3 0 0 1-.6 3.42m-4.24-4.24a3 3 0 0 1 2.12-.88 3 3 0 0 1 1.28.3l-4 4a3 3 0 0 1 .6-3.42m5.12 8.12a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V9.67l5.88 5.88a3 3 0 0 0 2.11.88 3 3 0 0 0 2.16-.91 1 1 0 0 0 0-1.39 1 1 0 0 0-1.43 0 1 1 0 0 1-1.4 0L4.91 8.26H9.5a1 1 0 0 0 0-2h-5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1" })
), Bx = h(ne), we = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 15.26a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9.67l5.88 5.89a3 3 0 0 0 2.1.87 3 3 0 0 0 1.43-.36 1 1 0 0 0 .4-1.36 1 1 0 0 0-1.36-.4 1 1 0 0 1-1.15-.17L5.41 8.26H12a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1m0-12h-5a1 1 0 0 0-1 1v8a1 1 0 0 0 1.57.82l1.93-1.29 1.91 1.28a1.06 1.06 0 0 0 .59.19 1 1 0 0 0 .41-.09 1 1 0 0 0 .59-.91v-8a1 1 0 0 0-1-1m-1 7.12-.94-.63a1 1 0 0 0-1.12 0l-.94.63V5.26h3Z" })
), Fx = h(we), ve = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.29 8.71a1 1 0 0 0 1.42 0l4-4a1 1 0 1 0-1.42-1.42L17 6.59l-1.29-1.3a1 1 0 0 0-1.42 1.42ZM21 8a1 1 0 0 0-1 1v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.41l5.88 5.89a3 3 0 0 0 2.11.87 3.08 3.08 0 0 0 2.16-.9l1.72-1.72a1 1 0 1 0-1.42-1.42l-1.75 1.75a1 1 0 0 1-1.4 0L5.41 7H11a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a1 1 0 0 0-1-1" })
), Rx = h(ve), me = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 8.79a1 1 0 0 0 1.42 0l2-2a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0l-.29.29V2.92a1 1 0 0 0-2 0v2.75l-.29-.29a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41ZM16 11.08H8a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3m-.42 2L12.7 16a1 1 0 0 1-1.4 0l-2.88-2.92Zm1.42 6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-4.59l2.88 2.88a3 3 0 0 0 4.24 0L17 14.49Z" })
), Ux = h(me), ce = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.5 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V9.41l5.88 5.89a3 3 0 0 0 4.24 0l1.64-1.64a1 1 0 1 0-1.42-1.42l-1.64 1.64a1 1 0 0 1-1.4 0L4.91 8h6.59a1 1 0 0 0 0-2h-7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m1.71-6.71a1 1 0 0 0-1.42 0l-1.29 1.3V3a1 1 0 0 0-2 0v5.59l-1.29-1.3a1 1 0 1 0-1.42 1.42l3 3a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l3-3a1 1 0 0 0 0-1.42" })
), $x = h(ce), se = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 11.51h2.42a1 1 0 0 0 .71-.29l4.58-4.58a1 1 0 0 0 0-1.42L19.29 2.8a1 1 0 0 0-1.42 0l-4.58 4.58a1.05 1.05 0 0 0-.29.71v2.42a1 1 0 0 0 1 1m1-3 3.58-3.58 1 1L16 9.51h-1Zm6 2a1 1 0 0 0-1 1v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.9l5.88 5.89a3 3 0 0 0 4.27 0 1 1 0 0 0 0-1.4 1 1 0 0 0-1.43 0 1 1 0 0 1-1.4 0l-5.91-5.9H10a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a1 1 0 0 0-1-1Z" })
), yx = h(se), ge = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 13.5a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.91l5.88 5.88a3 3 0 0 0 4.24 0l3.59-3.58a1 1 0 0 0-1.42-1.42l-3.58 3.59a1 1 0 0 1-1.42 0L5.41 7.5H17a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m0-11a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m-.2 7a.6.6 0 0 0-.18.06.8.8 0 0 0-.18.09l-.15.12a1.05 1.05 0 0 0-.29.71 1 1 0 0 0 0 .19.6.6 0 0 0 .06.19.8.8 0 0 0 .09.18 2 2 0 0 0 .12.15 1 1 0 0 0 1.42 0l.12-.15a.8.8 0 0 0 .09-.18.6.6 0 0 0 .06-.19 1 1 0 0 0 0-.19 1 1 0 0 0-1.2-1Z" })
), kx = h(ge), ie = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.5 13a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V8.41l5.88 5.89a3 3 0 0 0 2.11.87 3 3 0 0 0 2.15-.9l.89-.88a1 1 0 0 0-1.4-1.39l-.93.91a1 1 0 0 1-1.4 0L4.91 7H9.5a1 1 0 0 0 0-2h-5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m1.05-9a3.33 3.33 0 0 0-3.88-.54 3.25 3.25 0 0 0-3.88 5.13L17 11.71a1.05 1.05 0 0 0 .71.29 1 1 0 0 0 .71-.29l3.17-3.17A3.26 3.26 0 0 0 21.55 4m-1.41 3.12-2.47 2.47-2.46-2.47A1.24 1.24 0 0 1 17 5.36a1 1 0 0 0 1.42 0 1.28 1.28 0 0 1 1.76 0 1.26 1.26 0 0 1-.04 1.76" })
), bx = h(ie), de = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 13.5a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.91l5.88 5.88a3 3 0 0 0 4.24 0l3.59-3.58a1 1 0 0 0-1.42-1.42l-3.58 3.59a1 1 0 0 1-1.42 0L5.41 7.5H17a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m0-9a1.05 1.05 0 0 0 .71-.29l.12-.16a.6.6 0 0 0 .09-.17.6.6 0 0 0 .08-.18 1.4 1.4 0 0 0 0-.2 1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.42 1.05 1.05 0 0 0 .71.29m0 1a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1" })
), Tx = h(de), pe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.5 7.44V6.26a3 3 0 1 0-6 0v1.18a3 3 0 0 0-2 2.82v2a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3v-2a3 3 0 0 0-2-2.82m-4-1.18a1 1 0 1 1 2 0v1h-2Zm4 6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Zm0 5a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V9.67l5.88 5.88a1 1 0 0 0 1.42-1.41L4.91 8.26h5.59a1 1 0 0 0 0-2h-6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1" })
), Px = h(pe), fe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 8a1 1 0 0 0-1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.41l5.88 5.88a3 3 0 0 0 4.24 0l3.59-3.58a1 1 0 0 0-1.42-1.42l-3.58 3.59a1 1 0 0 1-1.42 0L5.41 6H13a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a1 1 0 0 0-1-1m-4-2h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2" })
), Dx = h(fe), Ee = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.21 8.82 14 2.78a2.83 2.83 0 0 0-3.9 0l-6.21 6A2.6 2.6 0 0 0 3 10.71v8.58A2.75 2.75 0 0 0 5.78 22h12.44A2.75 2.75 0 0 0 21 19.29v-8.58a2.67 2.67 0 0 0-.79-1.89m-8.77-4.6a.83.83 0 0 1 1.12 0L18 9.5l-5.47 5.28a.83.83 0 0 1-1.12 0L6 9.5ZM19 19.29a.76.76 0 0 1-.78.71H5.78a.76.76 0 0 1-.78-.71v-7.94l4.05 3.9-1.66 1.6a1 1 0 0 0 0 1.41 1 1 0 0 0 .72.31 1 1 0 0 0 .69-.28l1.77-1.7a2.8 2.8 0 0 0 2.92 0l1.77 1.7a1 1 0 0 0 .69.28 1 1 0 0 0 .72-.31 1 1 0 0 0 0-1.41L15 15.25l4-3.9Z" })
), qx = h(Ee), xe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.77 5.37A1 1 0 0 0 18.13 5a1 1 0 0 1 .87-.5 1 1 0 0 1 0 2 1 1 0 0 0 0 2A3 3 0 1 0 16.4 4a1 1 0 0 0 .37 1.37M21 13.5a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.91l5.88 5.89a3 3 0 0 0 4.24 0l1.64-1.64a1 1 0 1 0-1.42-1.42l-1.64 1.64a1 1 0 0 1-1.4 0L5.41 7.5H13a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m-2.71-3.71a1 1 0 0 0 0 1.42l.15.12a.8.8 0 0 0 .18.09.6.6 0 0 0 .18.06h.2a1 1 0 0 0 .71-1.71 1 1 0 0 0-1.42.02" })
), Ix = h(xe), Ae = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m8.29 6.21 2 2a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29H15a1 1 0 0 0 0-2h-3.59l.3-.29a1 1 0 1 0-1.42-1.42l-2 2a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33M16 10.5H8a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3m-.42 2-2.88 2.88a1 1 0 0 1-1.4 0L8.42 12.5Zm1.42 6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-4.59l2.88 2.87a2.94 2.94 0 0 0 2.12.89 3 3 0 0 0 2.12-.88L17 13.91Z" })
), Wx = h(Ae), Me = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.5 14.26a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V9.67l5.88 5.88a3 3 0 0 0 2.11.88 3 3 0 0 0 2.16-.91 1 1 0 0 0 0-1.39 1 1 0 0 0-1.43 0 1 1 0 0 1-1.4 0L4.91 8.26H9.5a1 1 0 0 0 0-2h-5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m1-11a1 1 0 0 0-1 1 5 5 0 1 0-3 9A5 5 0 0 0 20.8 12a1 1 0 0 0-1.32-1.51 3 3 0 1 1 .25-4.24H18.5a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-.99" })
), Gx = h(Me), He = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m22.21 10.29-1.73-1.72a4.37 4.37 0 0 0 .65-2.26 4.31 4.31 0 1 0-4.32 4.32 4.37 4.37 0 0 0 2.26-.63l1.72 1.73a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.44M18.45 8a2.37 2.37 0 0 1-3.27 0 2.3 2.3 0 0 1-.68-1.64A2.32 2.32 0 0 1 16.81 4a2.3 2.3 0 0 1 1.64.68 2.28 2.28 0 0 1 .68 1.63A2.3 2.3 0 0 1 18.45 8m2.05 6a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V9.41l5.88 5.89a3 3 0 0 0 4.24 0L15 13.88a1 1 0 0 0-1.42-1.42l-1.38 1.42a1 1 0 0 1-1.4 0L4.91 8H9.5a1 1 0 0 0 0-2h-5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1" })
), Ox = h(He), Ce = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 10.5H8a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3m-.42 2-2.88 2.88a1 1 0 0 1-1.4 0L8.42 12.5Zm1.42 6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-4.59l2.88 2.87a2.94 2.94 0 0 0 2.12.89 3 3 0 0 0 2.12-.88L17 13.91Zm-8-12h3.59l-.3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2-2a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-2-2a1 1 0 0 0-1.42 1.42l.3.29H9a1 1 0 0 0 0 2" })
), Nx = h(Ce), ue = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.41l5.88 5.89a3 3 0 0 0 2.11.87 3.08 3.08 0 0 0 2.16-.9l1.72-1.72a1 1 0 1 0-1.42-1.42l-1.75 1.75a1 1 0 0 1-1.4 0L4.41 8H10a1 1 0 0 0 0-2H4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m0-6a2 2 0 0 0-1.18.39l-1.75-.8L19 6.71A2 2 0 0 0 20 7a2 2 0 1 0-2-2l-1.9.87A2 2 0 0 0 15 5.5a2 2 0 0 0 0 4 1.9 1.9 0 0 0 .92-.24l2.1 1A2 2 0 1 0 20 8" })
), Qx = h(ue), Ve = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.63 5.12a1 1 0 0 0-.84-.2 2.74 2.74 0 0 1-2.2-.46 1 1 0 0 0-1.18 0 2.74 2.74 0 0 1-2.2.46A1 1 0 0 0 14 5.9v3.31a4.62 4.62 0 0 0 1.84 3.7l1.57 1.16a1 1 0 0 0 1.18 0l1.57-1.16A4.62 4.62 0 0 0 22 9.21V5.9a1 1 0 0 0-.37-.78M20 9.21a2.61 2.61 0 0 1-1 2.09l-1 .7-1-.72a2.61 2.61 0 0 1-1-2.09V7a4.7 4.7 0 0 0 2-.54A4.7 4.7 0 0 0 20 7Zm1 6a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9.67l5.88 5.88a3 3 0 0 0 2.11.88 3 3 0 0 0 2.15-.9l-.7-.71-.74-.68a1 1 0 0 1-1.4 0L5.41 8.26H11a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1Z" })
), Kx = h(Ve), Se = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m13.64 9.74-.29 1.73A1.55 1.55 0 0 0 14 13a1.46 1.46 0 0 0 1.58.09l1.42-.81 1.44.79A1.46 1.46 0 0 0 20 13a1.55 1.55 0 0 0 .63-1.51l-.29-1.73 1.2-1.22a1.54 1.54 0 0 0-.85-2.6l-1.62-.24-.73-1.55a1.5 1.5 0 0 0-2.72 0l-.73 1.55-1.62.24a1.54 1.54 0 0 0-.85 2.6Zm1.83-2.13a1.51 1.51 0 0 0 1.14-.85l.39-.83.39.83a1.55 1.55 0 0 0 1.14.86l1 .14-.73.74a1.57 1.57 0 0 0-.42 1.34l.16 1-.79-.43a1.48 1.48 0 0 0-1.44 0l-.79.43.16-1a1.54 1.54 0 0 0-.42-1.33l-.73-.75ZM21 15.26a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9.67l5.88 5.88a2.94 2.94 0 0 0 2.1.88h.27a1 1 0 0 0 .91-1.08 1 1 0 0 0-1.09-.91.94.94 0 0 1-.77-.28l-5.89-5.9H9a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1" })
), jx = h(Se), Le = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.41l5.88 5.89a3 3 0 0 0 2.11.87 3.08 3.08 0 0 0 2.16-.9l1.72-1.72a1 1 0 1 0-1.42-1.42l-1.75 1.75a1 1 0 0 1-1.4 0L5.41 7H13a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1m-.59-5 1.3-1.29a1 1 0 1 0-1.42-1.42L19 4.59l-1.29-1.3a1 1 0 0 0-1.42 1.42L17.59 6l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L19 7.41l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), Jx = h(Le), Ze = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 11.08H8a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3m-.42 2L12.7 16a1 1 0 0 1-1.4 0l-2.88-2.92Zm1.42 6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-4.59l2.88 2.88a3 3 0 0 0 4.24 0L17 14.49ZM10.71 5.62l.29-.29v2.75a1 1 0 0 0 2 0V5.33l.29.29a1 1 0 1 0 1.42-1.41l-2-2a1 1 0 0 0-1.42 0l-2 2a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0" })
), Yx = h(Ze), Be = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.5 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V9.41l5.88 5.89a3 3 0 0 0 4.24 0l1.64-1.64a1 1 0 1 0-1.42-1.42l-1.64 1.64a1 1 0 0 1-1.4 0L4.91 8h6.59a1 1 0 0 0 0-2h-7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m1.71-8.71-3-3a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-3 3a1 1 0 0 0 1.42 1.42l1.29-1.3V11a1 1 0 0 0 2 0V5.41l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42" })
), Xx = h(Be), Fe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m-.41 2-5.88 5.88a1 1 0 0 1-1.42 0L5.41 6ZM20 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.41l5.88 5.88a3 3 0 0 0 4.24 0L20 7.41Z" })
), _x = h(Fe), Re = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 21.63H5a3 3 0 0 1-3-3v-8a1 1 0 0 0-2 0v8a5 5 0 0 0 5 5h12a1 1 0 0 0 0-2m4-18H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m-.41 2-5.88 5.88a1 1 0 0 1-1.42 0L7.41 5.63Zm1.41 11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7l5.88 5.88a3 3 0 0 0 4.24 0L22 7Z" })
), zx = h(Re), Ue = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 13H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m0-4H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), aA = h(Ue), $e = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20 8-6-5.26a3 3 0 0 0-4 0L4 8a3 3 0 0 0-1 2.26V19a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8.75A3 3 0 0 0 20 8m-6 12h-4v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm5-1a1 1 0 0 1-1 1h-2v-5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1v-8.75a1 1 0 0 1 .34-.75l6-5.25a1 1 0 0 1 1.32 0l6 5.25a1 1 0 0 1 .34.75Z" })
), tA = h($e), ye = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1m0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9m.59-13.33a3.34 3.34 0 0 1 2.62 1.38 1 1 0 0 0 1.4.19 1 1 0 0 0 .18-1.41 5.32 5.32 0 0 0-4.2-2.16A5.57 5.57 0 0 0 7.46 9.5H6a1 1 0 0 0 0 2h1v1H6a1 1 0 0 0 0 2h1.46a5.57 5.57 0 0 0 5.13 3.83 5.32 5.32 0 0 0 4.2-2.16A1 1 0 1 0 15.21 15a3.34 3.34 0 0 1-2.62 1.38 3.42 3.42 0 0 1-2.92-1.88H12a1 1 0 0 0 0-2H9.05A4 4 0 0 1 9 12a4 4 0 0 1 .05-.5H12a1 1 0 0 0 0-2H9.67a3.42 3.42 0 0 1 2.92-1.83" })
), eA = h(ye), ke = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.2 17.41A6 6 0 0 1 14.46 20c-2.68 0-5-2-6-5H14a1 1 0 0 0 0-2H8.05c0-.33-.05-.67-.05-1s0-.67.05-1H14a1 1 0 0 0 0-2H8.47c1-3 3.31-5 6-5a6 6 0 0 1 4.73 2.59 1 1 0 1 0 1.6-1.18A7.92 7.92 0 0 0 14.46 2c-3.76 0-7 2.84-8.07 7H4a1 1 0 0 0 0 2h2.05v2H4a1 1 0 0 0 0 2h2.39c1.09 4.16 4.31 7 8.07 7a7.92 7.92 0 0 0 6.34-3.41 1 1 0 0 0-1.6-1.18" })
), lA = h(ke), be = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 9.29-4-4a1 1 0 0 0-1.42 1.42L18.59 9H7a1 1 0 0 0 0 2h14a1 1 0 0 0 .92-.62 1 1 0 0 0-.21-1.09M17 13H3a1 1 0 0 0-.92.62 1 1 0 0 0 .21 1.09l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.41 15H17a1 1 0 0 0 0-2" })
), rA = h(be), Te = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 10a1 1 0 0 0-1-1H5.41l2.3-2.29a1 1 0 0 0-1.42-1.42l-4 4a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 11h14a1 1 0 0 0 1-1m3.92 3.62A1 1 0 0 0 21 13H7a1 1 0 0 0 0 2h11.59l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-1.09" })
), hA = h(Te), Pe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 14a1.25 1.25 0 1 0 1.25 1.25A1.25 1.25 0 0 0 12 14m0-1.5a1 1 0 0 0 1-1v-3a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8" })
), oA = h(Pe), De = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 7a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1m0 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m9.71-7.44-5.27-5.27a1.05 1.05 0 0 0-.71-.29H8.27a1.05 1.05 0 0 0-.71.29L2.29 7.56a1.05 1.05 0 0 0-.29.71v7.46a1.05 1.05 0 0 0 .29.71l5.27 5.27a1.05 1.05 0 0 0 .71.29h7.46a1.05 1.05 0 0 0 .71-.29l5.27-5.27a1.05 1.05 0 0 0 .29-.71V8.27a1.05 1.05 0 0 0-.29-.71M20 15.31 15.31 20H8.69L4 15.31V8.69L8.69 4h6.62L20 8.69Z" })
), nA = h(De), qe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 16a1 1 0 1 0 1 1 1 1 0 0 0-1-1m10.67 1.47-8.05-14a3 3 0 0 0-5.24 0l-8 14A3 3 0 0 0 3.94 22h16.12a3 3 0 0 0 2.61-4.53m-1.73 2a1 1 0 0 1-.88.51H3.94a1 1 0 0 1-.88-.51 1 1 0 0 1 0-1l8-14a1 1 0 0 1 1.78 0l8.05 14a1 1 0 0 1 .05 1.02ZM12 8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1" })
), wA = h(qe), Ie = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 14a1 1 0 0 0 1-1V7a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1m0 4a1.25 1.25 0 1 0-1.25-1.25A1.25 1.25 0 0 0 12 18" })
), vA = h(Ie), We = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.54 7.54h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0 1 1 0 1 0 0-2m5.92 5.92a1 1 0 0 0-1 1 1 1 0 0 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1M21 7.54h-4.54V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12.46a1 1 0 0 0 1 1h4.54V21a1 1 0 0 0 1 1H21a1 1 0 0 0 1-1V8.54a1 1 0 0 0-1-1M20 20H9.54v-3.54a1 1 0 0 0 0-2 1 1 0 0 0-2 0H4V4h10.46v3.54a1 1 0 0 0 0 2 1 1 0 0 0 2 0H20Z" })
), mA = h(We), Ge = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4 12a1 1 0 0 0 1 1h7.59l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H5a1 1 0 0 0-1 1M17 2H7a3 3 0 0 0-3 3v3a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3" })
), cA = h(Ge), Oe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.79 12.79 4 18.59V17a1 1 0 0 0-2 0v4a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 3 22h4a1 1 0 0 0 0-2H5.41l5.8-5.79a1 1 0 0 0-1.42-1.42M21.92 2.62a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-4a1 1 0 0 0 0 2h1.59l-5.8 5.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L20 5.41V7a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38" })
), sA = h(Oe), Ne = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.29 13.29 4 18.59V17a1 1 0 0 0-2 0v4a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 3 22h4a1 1 0 0 0 0-2H5.41l5.3-5.29a1 1 0 0 0-1.42-1.42M5.41 4H7a1 1 0 0 0 0-2H3a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 2 3v4a1 1 0 0 0 2 0V5.41l5.29 5.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM21 16a1 1 0 0 0-1 1v1.59l-5.29-5.3a1 1 0 0 0-1.42 1.42l5.3 5.29H17a1 1 0 0 0 0 2h4a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 21v-4a1 1 0 0 0-1-1m.92-13.38a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-4a1 1 0 0 0 0 2h1.59l-5.3 5.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L20 5.41V7a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38" })
), gA = h(Ne), Qe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 8a1 1 0 0 0 1-1V3a1 1 0 0 0-.08-.38 1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-4a1 1 0 0 0 0 2h1.59L12 10.59 5.41 4H7a1 1 0 0 0 0-2H3a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 2 3v4a1 1 0 0 0 2 0V5.41L10.59 12 4 18.59V17a1 1 0 0 0-2 0v4a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 3 22h4a1 1 0 0 0 0-2H5.41L12 13.41 18.59 20H17a1 1 0 0 0 0 2h4a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 21v-4a1 1 0 0 0-2 0v1.59L13.41 12 20 5.41V7a1 1 0 0 0 1 1" })
), iA = h(Qe), Ke = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 12H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1m-1 8H4v-6h6ZM21.92 2.62a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-6a1 1 0 0 0 0 2h3.59l-5.3 5.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L20 5.41V9a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38" })
), dA = h(Ke), je = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.17 10.17a1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42L5.41 4H7a1 1 0 0 0 0-2H3a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 2 3v4a1 1 0 0 0 2 0V5.41l4.46 4.47a1 1 0 0 0 .71.29m6.37-1.71a1 1 0 0 0-1.42 0l-5.66 5.66a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l5.66-5.66a1 1 0 0 0 0-1.42M21 16a1 1 0 0 0-1 1v1.59l-4.46-4.47a1 1 0 1 0-1.42 1.42L18.59 20H17a1 1 0 0 0 0 2h4a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 21v-4a1 1 0 0 0-1-1" })
), pA = h(je), Je = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 14.1 4 18.6V17c0-.6-.4-1-1-1s-1 .4-1 1v4c0 .1 0 .3.1.4.1.2.3.4.5.5.1.1.3.1.4.1h4c.6 0 1-.4 1-1s-.4-1-1-1H5.4l4.5-4.5c.4-.4.4-1 0-1.4s-1-.4-1.4 0M21.7 2.3c-.2-.2-.5-.3-.7-.3h-4c-.6 0-1 .4-1 1s.4 1 1 1h1.6l-4.5 4.5c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L20 5.4V7c0 .6.4 1 1 1s1-.4 1-1V3c0-.2-.1-.5-.3-.7m-6.2 11.8L9.9 8.5c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l5.7 5.7c.2.2.4.3.7.3s.5-.1.7-.3c.3-.4.3-1.1-.1-1.5" })
), fA = h(Je), Ye = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.71 7.71 11 5.41V15a1 1 0 0 0 2 0V5.41l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-4-4a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-4 4a1 1 0 1 0 1.42 1.42M21 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1" })
), EA = h(Ye), Xe = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 6H7a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m8-4H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3M4 18.59V5a1 1 0 0 1 1-1h13.59ZM20 19a1 1 0 0 1-1 1H5.41L20 5.41Zm-7-2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2" })
), xA = h(Xe), _e = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 7h-1V6a1 1 0 0 0-2 0v1H7a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0V9h1a1 1 0 0 0 0-2m2 11h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2m6-16H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3M4 18.59V5a1 1 0 0 1 1-1h13.59ZM20 19a1 1 0 0 1-1 1H5.41L20 5.41Z" })
), AA = h(_e), ze = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 10.82a1 1 0 0 0-1 1V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h7.18a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-7.18a1 1 0 0 0-1-1m3.92-8.2a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-6a1 1 0 0 0 0 2h3.59L8.29 14.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L20 5.41V9a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38" })
), MA = h(ze), a5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.94 6.08A7 7 0 0 1 12 6c3.18 0 6.17 2.29 7.91 6a15 15 0 0 1-.9 1.64 1 1 0 0 0-.16.55 1 1 0 0 0 1.86.5 16 16 0 0 0 1.21-2.3 1 1 0 0 0 0-.79C19.9 6.91 16.1 4 12 4a8 8 0 0 0-1.4.12 1 1 0 1 0 .34 2ZM3.71 2.29a1 1 0 0 0-1.42 1.42l3.1 3.09a14.6 14.6 0 0 0-3.31 4.8 1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20a9.26 9.26 0 0 0 5.05-1.54l3.24 3.25a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm6.36 9.19 2.45 2.45A1.8 1.8 0 0 1 12 14a2 2 0 0 1-2-2 1.8 1.8 0 0 1 .07-.52M12 18c-3.18 0-6.17-2.29-7.9-6a12.1 12.1 0 0 1 2.7-3.79L8.57 10A4 4 0 0 0 14 15.43L15.59 17A7.24 7.24 0 0 1 12 18" })
), HA = h(a5), t5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8M12 18c-3.17 0-6.17-2.29-7.9-6C5.83 8.29 8.83 6 12 6s6.17 2.29 7.9 6c-1.73 3.71-4.73 6-7.9 6m0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2" })
), CA = h(t5), e5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.12 5.32H17V2.14A26 26 0 0 0 14.26 2c-2.72 0-4.58 1.66-4.58 4.7v2.62H6.61v3.56h3.07V22h3.68v-9.12h3.06l.46-3.56h-3.52V7.05c0-1.05.28-1.73 1.76-1.73" })
), uA = h(e5), l5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.991 1a10.614 10.614 0 0 0-11 10.7 10.46 10.46 0 0 0 3.414 7.866l.052 1.69A1.8 1.8 0 0 0 6.256 23a1.8 1.8 0 0 0 .726-.152L8.903 22a12 12 0 0 0 3.088.4 10.615 10.615 0 0 0 11.001-10.7 10.615 10.615 0 0 0-11-10.7m0 19.4a9.9 9.9 0 0 1-2.635-.35 1.8 1.8 0 0 0-1.196.092l-1.714.756-.045-1.493A1.8 1.8 0 0 0 5.8 18.13 8.49 8.49 0 0 1 2.99 11.7a8.66 8.66 0 0 1 9-8.7 8.705 8.705 0 1 1 0 17.4m3.735-11.815-2.313 2.755-3.347-2.056a1 1 0 0 0-1.289.21L5.726 13.13a1 1 0 1 0 1.53 1.285l2.499-2.975 3.347 2.056a1 1 0 0 0 1.289-.21l2.866-3.415a1 1 0 1 0-1.531-1.286" })
), VA = h(l5), r5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a9.65 9.65 0 0 0-10 9.7 9.5 9.5 0 0 0 3.14 7.18.8.8 0 0 1 .27.56v1.78a.81.81 0 0 0 1.13.71l2-.87a.75.75 0 0 1 .53 0 11 11 0 0 0 2.9.38A9.7 9.7 0 1 0 12 2m6 7.46-2.93 4.66a1.5 1.5 0 0 1-2.17.4l-2.34-1.75a.6.6 0 0 0-.72 0l-3.16 2.4a.47.47 0 0 1-.68-.63l2.93-4.66a1.5 1.5 0 0 1 2.17-.4l2.34 1.75a.6.6 0 0 0 .72 0l3.16-2.4a.47.47 0 0 1 .68.63" })
), SA = h(r5), h5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.9 2H3.1A1.1 1.1 0 0 0 2 3.1v17.8A1.1 1.1 0 0 0 3.1 22h9.58v-7.75h-2.6v-3h2.6V9a3.64 3.64 0 0 1 3.88-4 20 20 0 0 1 2.33.12v2.7H17.3c-1.26 0-1.5.6-1.5 1.47v1.93h3l-.39 3H15.8V22h5.1a1.1 1.1 0 0 0 1.1-1.1V3.1A1.1 1.1 0 0 0 20.9 2" })
), LA = h(h5), o5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.5 3h-7a3 3 0 0 0-3 3v14a1 1 0 0 0 2 0v-7h6a1 1 0 0 0 0-2h-6V6a1 1 0 0 1 1-1h7a1 1 0 0 0 0-2m-15 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), ZA = h(o5), n5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.69 9a2.93 2.93 0 0 0-1-1.71 3 3 0 0 0-2-.74H4.8a3 3 0 0 0-2.3 1.02v.06A3 3 0 0 0 1.84 10l.88 5a3 3 0 0 0 3 2.48h7.94a3 3 0 0 0 2.29-1.07 3 3 0 0 0 .62-2.41Zm-3.41-.5-2.34 2.64a1 1 0 0 1-1.38.11L5.17 8.5Zm2.1 6.64a1 1 0 0 1-.76.36H5.68a1 1 0 0 1-1-.83L3.87 10l3.43 2.8a3 3 0 0 0 4.14-.34L13.8 9.8l.8 4.53a1 1 0 0 1-.22.81m6.83-4.64h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m0-2a1 1 0 0 0 0-2h-3a1 1 0 0 0 0 2Z" })
), BA = h(n5), w5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.79 10.5h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2m16.78-2.84V7.6a3 3 0 0 0-2.37-1.1h-7.93a3 3 0 0 0-2 .74A2.93 2.93 0 0 0 8.31 9l-.88 5a3 3 0 0 0 .66 2.45 3 3 0 0 0 2.29 1.07h7.94a3 3 0 0 0 3-2.48l.88-5a3 3 0 0 0-.63-2.38m-2.74.84-3.4 2.76a1 1 0 0 1-1.38-.12L11.72 8.5Zm.48 6.17a1 1 0 0 1-1 .83h-7.93a1 1 0 0 1-.76-.36 1 1 0 0 1-.22-.81l.8-4.53 2.35 2.66a3 3 0 0 0 4.14.35L20.13 10ZM5.79 6.5h-3a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2" })
), FA = h(w5), v5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 9.67a1 1 0 0 0-.86-.67l-5.69-.83L12.9 3a1 1 0 0 0-1.8 0L8.55 8.16 2.86 9a1 1 0 0 0-.81.68 1 1 0 0 0 .25 1l4.13 4-1 5.68a1 1 0 0 0 1.47 1.08l5.1-2.67 5.1 2.67a.93.93 0 0 0 .46.12 1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1l-1-5.68 4.13-4A1 1 0 0 0 22 9.67m-6.15 4a1 1 0 0 0-.29.88l.72 4.2-3.76-2a1.06 1.06 0 0 0-.94 0l-3.76 2 .72-4.2a1 1 0 0 0-.29-.88l-3-3 4.21-.61a1 1 0 0 0 .76-.55L12 5.7l1.88 3.82a1 1 0 0 0 .76.55l4.21.61Z" })
), RA = h(v5), m5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 1h-7a2.44 2.44 0 0 0-2.41 2l-.92 5.05a2.44 2.44 0 0 0 .53 2 2.47 2.47 0 0 0 1.88.88H17l-.25.66a3.26 3.26 0 0 0 3 4.41 1 1 0 0 0 .92-.59l2.24-5.06A1 1 0 0 0 23 10V2a1 1 0 0 0-1-1m-1 8.73-1.83 4.13a1.3 1.3 0 0 1-.45-.4 1.23 1.23 0 0 1-.14-1.16l.38-1a1.68 1.68 0 0 0-.2-1.58A1.7 1.7 0 0 0 17.35 9h-3.29a.46.46 0 0 1-.35-.16.5.5 0 0 1-.09-.37l.92-5A.44.44 0 0 1 15 3h6ZM9.94 13.05H7.05l.25-.66A3.26 3.26 0 0 0 4.25 8a1 1 0 0 0-.92.59l-2.24 5.06a1 1 0 0 0-.09.4v8a1 1 0 0 0 1 1h7a2.44 2.44 0 0 0 2.41-2l.92-5a2.44 2.44 0 0 0-.53-2 2.47 2.47 0 0 0-1.86-1m-.48 7.58A.44.44 0 0 1 9 21H3v-6.73l1.83-4.13a1.3 1.3 0 0 1 .45.4 1.23 1.23 0 0 1 .14 1.16l-.38 1a1.68 1.68 0 0 0 .2 1.58 1.7 1.7 0 0 0 1.41.74h3.29a.46.46 0 0 1 .35.16.5.5 0 0 1 .09.37Z" })
), UA = h(m5), c5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 7a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-5.696 9.134a1 1 0 1 0 1.366.366 1 1 0 0 0-1.366-.366m11.392 0a1 1 0 1 0 .366 1.366 1 1 0 0 0-.366-1.366m2.914-2.791a4.92 4.92 0 0 0-4.526-1.197l-.419-.763a4.99 4.99 0 0 0-2.503-8.251 5.04 5.04 0 0 0-4.279.958A4.98 4.98 0 0 0 7 8a4.93 4.93 0 0 0 1.352 3.392l-.419.75a4.99 4.99 0 0 0-5.926 6.286 5.03 5.03 0 0 0 2.97 3.226 4.97 4.97 0 0 0 6.588-3.19l.867.014a4.98 4.98 0 0 0 4.76 3.524 5.02 5.02 0 0 0 4.8-3.573 4.95 4.95 0 0 0-1.382-5.086m-.528 4.495a3.006 3.006 0 0 1-4.386 1.76 2.97 2.97 0 0 1-1.352-1.705 1.99 1.99 0 0 0-1.91-1.43h-.869a1.995 1.995 0 0 0-1.91 1.43 2.98 2.98 0 0 1-3.948 1.899 2.993 2.993 0 0 1 1.767-5.704 1.97 1.97 0 0 0 2.173-.942l.436-.754a1.995 1.995 0 0 0-.281-2.369 2.98 2.98 0 0 1 .329-4.37 2.993 2.993 0 0 1 4.069 4.369 2 2 0 0 0-.283 2.37l.435.753a1.974 1.974 0 0 0 2.174.943 2.988 2.988 0 0 1 3.556 3.75" })
), $A = h(c5), s5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 10h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm11-3.06a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Zm-3-3H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" })
), yA = h(s5), g5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09a.9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Z" })
), kA = h(g5), i5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm5 12H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v1a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0L11.06 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2m0-14.59L14.59 8H13a1 1 0 0 1-1-1Zm8.83 9.76a4.1 4.1 0 0 0-5.66 0 4 4 0 1 0 5.66 0M16 18a2 2 0 0 1 2-2 2 2 0 0 1 .51.07l-2.44 2.44A2 2 0 0 1 16 18m3.41 1.41a2 2 0 0 1-1.91.5l2.43-2.42A2 2 0 0 1 20 18a2 2 0 0 1-.59 1.41M11 18a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2Zm2-6H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" })
), bA = h(i5), d5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.5 10h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m4 6h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m0-4h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m6.92-2.62a1 1 0 0 0-.21-1.09l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0l-.28-.1H5.5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6a1 1 0 0 0 0-2h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h4a1 1 0 0 0 .92-.62M13.5 8a1 1 0 0 1-1-1V5.41L15.09 8Zm7 4h-5a1 1 0 0 0-1 1v8a1 1 0 0 0 .53.88 1 1 0 0 0 1-.05l1.97-1.3 2 1.3a1 1 0 0 0 1.5-.83v-8a1 1 0 0 0-1-1m-1 7.12-.94-.63a1 1 0 0 0-1.12 0l-.94.63V14h3Z" })
), TA = h(d5), p5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.5 20h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v5a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.1 0 1.1 1.1 0 0 0-.31-.11H5.5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6a1 1 0 0 0 0-2m1-14.59L15.09 8H13.5a1 1 0 0 1-1-1ZM7.5 14h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2m4 2h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-4-6h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m13.71 6.29a1 1 0 0 0-1.42 0l-3.29 3.3-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 0-1.42" })
), PA = h(p5), f5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Zm-3.71-6.71L11 15.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0-1.42-1.42" })
), DA = h(f5), E5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 20.29 20 18.56v-.31a2.75 2.75 0 0 0-2.75-2.75h-.34l-1.44-1.44a.7.7 0 0 1 .28-.06H19a1 1 0 0 0 0-2h-1.5v-1a1 1 0 0 0-2 0v1a2.74 2.74 0 0 0-1.47.59l-1.32-1.33a1 1 0 0 0-1.42 1.42L13 14.44v.31a2.75 2.75 0 0 0 2.75 2.75h.34l1.44 1.44a.7.7 0 0 1-.28.06H14a1 1 0 0 0 0 2h1.5v1a1 1 0 0 0 2 0v-1a2.74 2.74 0 0 0 1.5-.62l1.32 1.33a1 1 0 0 0 1.42 0 1 1 0 0 0-.03-1.42M10 19H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6v4a1 1 0 0 0 1 1h5a1 1 0 0 0 .92-.62 1 1 0 0 0-.21-1.09l-5-5a1 1 0 0 0-.28-.19h-.09a1.3 1.3 0 0 0-.28-.1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h5a1 1 0 0 0 0-2m3-14.59L14.59 6H13Z" })
), qA = h(E5), x5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.2 15c-.2.1-.4.1-.6.2-.1-.2-.2-.4-.3-.5-.8-.7-2-.8-3-.2C8.5 15 8 16 8 17c0 .5.5 1 1 .9.5 0 1-.5 1-1 0-.3.1-.5.3-.7.1 0 .2-.1.3-.1-.3.6-.1 1.3.5 1.7.2.1.3.1.5.1.4 0 .8-.2 1.1-.5.1-.1.3-.2.5-.3.1.4.5.8 1 .8h.8c.6 0 1-.4 1-1 0-.5-.4-.9-.9-1-.1-.2-.1-.3-.3-.5-.3-.3-1-.5-1.6-.4M20 8.9c0-.1 0-.2-.1-.3v-.1c0-.1-.1-.2-.2-.3l-6-6c-.1-.1-.2-.1-.3-.2h-.1c-.1 0-.2 0-.3-.1H7C5.3 2 4 3.3 4 5v14c0 1.7 1.3 3 3 3h10c1.7 0 3-1.3 3-3zq0 .15 0 0m-6-3.5L16.6 8H15c-.6 0-1-.4-1-1zM18 19c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h5v3c0 1.7 1.3 3 3 3h3zm-9-9h1c.6 0 1-.4 1-1s-.4-1-1-1H9c-.6 0-1 .4-1 1s.4 1 1 1" })
), IA = h(x5), A5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 20H8a3 3 0 0 1-3-3V7a1 1 0 0 0-2 0v10a5 5 0 0 0 5 5h8a1 1 0 0 0 0-2m-6-7a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2h-5a1 1 0 0 0-1 1m11-4.06a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H10a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8.94m-6-3.53L17.59 8H16a1 1 0 0 1-1-1ZM19 15a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a3 3 0 0 0 .18 1H11a1 1 0 0 0 0 2h8Z" })
), WA = h(A5), M5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm5 12H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v2a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.1 0 1.1 1.1 0 0 0-.31-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2m0-14.59L15.59 8H14a1 1 0 0 1-1-1ZM14 12H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m6.71 6.29a1 1 0 0 0-1.42 0l-.29.3V16a1 1 0 0 0-2 0v2.59l-.29-.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2-2a1 1 0 0 0 0-1.42M12 18a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2Z" })
), GA = h(M5), H5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.31-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Zm-4.71-4.71-.29.3V12a1 1 0 0 0-2 0v2.59l-.29-.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2-2a1 1 0 0 0-1.42-1.42" })
), OA = h(H5), C5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20.71 16.71-2.42-2.42a1 1 0 0 0-1.42 0l-3.58 3.58a1 1 0 0 0-.29.71V21a1 1 0 0 0 1 1h2.42a1 1 0 0 0 .71-.29l3.58-3.58a1 1 0 0 0 0-1.42M16 20h-1v-1l2.58-2.58 1 1Zm-6 0H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v1a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0L12.06 2H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h4a1 1 0 0 0 0-2m3-14.59L15.59 8H14a1 1 0 0 1-1-1ZM8 14h6a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2m0-4h1a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2m2 6H8a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2" })
), NA = h(C5), u5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 10h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m6 2H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m0 4H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m4.71 4.29a2 2 0 0 0-.15-.12.8.8 0 0 0-.18-.09L19.2 20a1 1 0 0 0-.58.06.9.9 0 0 0-.54.54.84.84 0 0 0-.08.4 1 1 0 1 0 1.92-.38 1.2 1.2 0 0 0-.21-.33M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a1 1 0 0 0 0-2H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v2a1 1 0 0 0 2 0V8.94M15 8a1 1 0 0 1-1-1V5.41L16.59 8Zm4 7a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1" })
), QA = h(u5), V5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.92 16.62a.8.8 0 0 0-.09-.18 2 2 0 0 0-.12-.15 1 1 0 0 0-1.09-.21 1 1 0 0 0-.33.21 2 2 0 0 0-.12.15.8.8 0 0 0-.09.18.6.6 0 0 0-.06.18 2 2 0 0 0 0 .2.84.84 0 0 0 .08.38 1.2 1.2 0 0 0 .21.33A1 1 0 0 0 12 18a.84.84 0 0 0 .38-.08.9.9 0 0 0 .54-.54A.84.84 0 0 0 13 17a2 2 0 0 0 0-.2.6.6 0 0 0-.08-.18M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09a.9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Zm-6-8a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1" })
), KA = h(V5), S5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.92 15.62a1.2 1.2 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42l1.3 1.29H12a1 1 0 0 0 0 2h5.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a.9.9 0 0 0 .21-.33 1 1 0 0 0 0-.76M14 20H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h4a1 1 0 0 0 .92-.62 1 1 0 0 0-.21-1.09l-6-6a1 1 0 0 0-.28-.19h-.09l-.28-.1H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a1 1 0 0 0 0-2M13 5.41 15.59 8H14a1 1 0 0 1-1-1Z" })
), jA = h(S5), L5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 10h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m5.21 2.386-1.673 2.152-.868-.781a1 1 0 0 0-1.45.118l-2 2.5a1 1 0 1 0 1.562 1.25l1.338-1.673.879.791a1 1 0 0 0 1.458-.13l2.334-3a1 1 0 0 0-1.58-1.227m5.778-3.448a1 1 0 0 0-.28-.643l-.001-.002-6-6-.001-.001a1 1 0 0 0-.287-.193c-.03-.014-.06-.022-.092-.033a1 1 0 0 0-.267-.054C13.04 2.011 13.021 2 13 2H7a3.003 3.003 0 0 0-3 3v14a3.003 3.003 0 0 0 3 3h10a3.003 3.003 0 0 0 3-3V9c0-.022-.011-.04-.012-.062M14 5.414 16.586 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3.003 3.003 0 0 0 3 3h3Z" })
), JA = h(L5), Z5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.31-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Zm-6-7.66A2.92 2.92 0 0 0 8.57 16l2.72 2.72a1 1 0 0 0 1.42 0L15.43 16A2.92 2.92 0 0 0 12 11.34m2 1.93a.92.92 0 0 1 0 1.3l-2 2-2-2a.92.92 0 0 1 0-1.3.92.92 0 0 1 1.3 0 1 1 0 0 0 1.42 0 .92.92 0 0 1 1.28 0" })
), YA = h(Z5), B5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 20H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v2a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1.3 1.3 0 0 0-.19-.29l-6-6a1.3 1.3 0 0 0-.29-.19.3.3 0 0 0-.09 0l-.31-.1H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h5a1 1 0 0 0 0-2m2-14.59L15.59 8H14a1 1 0 0 1-1-1ZM19 15h-5.59l1.3-1.29a1 1 0 0 0-1.42-1.42l-3 3a1.2 1.2 0 0 0-.21.33 1 1 0 0 0 0 .76.9.9 0 0 0 .21.33l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 17H19a1 1 0 0 0 0-2" })
), XA = h(B5), F5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 16H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m-6-6h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m6 2H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m4.71 3.29a1 1 0 0 0-.33-.21.92.92 0 0 0-.76 0 1 1 0 0 0-.33.21 1.2 1.2 0 0 0-.21.33 1 1 0 0 0 .21 1.09A1 1 0 0 0 19 17a1 1 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .21-1.09 1.2 1.2 0 0 0-.21-.33M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a1 1 0 0 0 0-2H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v2a1 1 0 0 0 2 0V8.94M15 8a1 1 0 0 1-1-1V5.41L16.59 8Zm4 10a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1" })
), _A = h(F5), R5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 10.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.31-.11H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6.06m-6-3.53L18.59 10H17a1 1 0 0 1-1-1ZM20 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h9v3a3 3 0 0 0 3 3h3ZM7 12h4a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m0 2a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z" })
), zA = h(R5), U5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 10.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.31-.11H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6.06m-6-3.53L18.59 10H17a1 1 0 0 1-1-1ZM20 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h9v3a3 3 0 0 0 3 3h3Z" })
), aM = h(U5), $5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 10.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09a.9.9 0 0 0-.33-.11h-4.39a1 1 0 0 0 0 2H14v3a3 3 0 0 0 3 3h3v3.34a1 1 0 1 0 2 0v-4.4M17 10a1 1 0 0 1-1-1V7.41L18.59 10ZM3.71 2.29a1 1 0 0 0-1.42 1.42l.91.9A3 3 0 0 0 2 7v10a3 3 0 0 0 3 3h13.59l1.7 1.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM5 18a1 1 0 0 1-1-1V7a1 1 0 0 1 .66-.93L16.59 18Z" })
), tM = h($5), y5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 20H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h4a1 1 0 0 0 .92-.62 1 1 0 0 0-.21-1.09l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0l-.28-.1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h5a1 1 0 0 0 0-2m2-14.59L14.59 8H13a1 1 0 0 1-1-1ZM13 13a1 1 0 0 0-1-1H7a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1m-6-3h1a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m0 6a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2Zm13-.82V15a3 3 0 0 0-6 0v.18A3 3 0 0 0 12 18v1a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3v-1a3 3 0 0 0-2-2.82M17 14a1 1 0 0 1 1 1h-2a1 1 0 0 1 1-1m3 5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Z" })
), eM = h(y5), k5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 18a1 1 0 0 0-1 1 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v1a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27.3.3 0 0 0 0-.09 1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.3-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3 1 1 0 0 0-1-1M13 5.41 15.59 8H14a1 1 0 0 1-1-1ZM20 14h-2.5a1 1 0 0 0-.71.29l-1.24 1.25-2.8-3.2a1 1 0 0 0-1.46-.05L9.59 14H8a1 1 0 0 0 0 2h2a1 1 0 0 0 .71-.29L12 14.46l2.8 3.2a1 1 0 0 0 .72.34 1 1 0 0 0 .71-.29L17.91 16H20a1 1 0 0 0 0-2" })
), lM = h(k5), b5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 14h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m6-5.06a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09a.9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Z" })
), rM = h(b5), T5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm5 12H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v5a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.1 0 1.1 1.1 0 0 0-.31-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2m0-14.59L15.59 8H14a1 1 0 0 1-1-1ZM20 18h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-7-2H8a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2m1-4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" })
), hM = h(T5), P5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 14h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m6-5.06a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09a.9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Z" })
), oM = h(P5), D5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 19h-6.18A3 3 0 0 0 13 17.18V15h3a3 3 0 0 0 3-3V7.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3v2.18A3 3 0 0 0 9.18 19H3a1 1 0 0 0 0 2h6.18a3 3 0 0 0 5.64 0H21a1 1 0 0 0 0-2M13 4.41 15.59 7H14a1 1 0 0 1-1-1ZM8 13a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3v3a3 3 0 0 0 3 3h3v3a1 1 0 0 1-1 1Zm4 8a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), nM = h(D5), q5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 18h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m-7 2H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v3a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.1 0 1.1 1.1 0 0 0-.31-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2m0-14.59L15.59 8H14a1 1 0 0 1-1-1ZM8 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm5 8H8a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2m1-4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" })
), wM = h(q5), I5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Zm-4-5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2" })
), vM = h(I5), W5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.07 12h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2m1 8h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v1a1 1 0 0 0 2 0V9a.14.14 0 0 0 0-.06.9.9 0 0 0-.07-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.29-.19s-.05 0-.08 0a.9.9 0 0 0-.32-.11h-6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a1 1 0 0 0 0-2Zm-1-14.59L15.65 8h-1.58a1 1 0 0 1-1-1Zm5.57 14.88a2 2 0 0 0-.15-.12 1.1 1.1 0 0 0-.36-.15 1 1 0 0 0-.9.27 1 1 0 0 0 0 1.42 1 1 0 0 0 .7.29 1 1 0 0 0 .93-1.38 1.2 1.2 0 0 0-.22-.33M13.07 16h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2m4.86-3a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.74 1 1 1 0 1 1 .86 1.5 1 1 0 0 0 0 2 3 3 0 0 0 0-6m-9.86-3h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2" })
), mM = h(W5), G5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.57 17.29a1 1 0 0 0-1.41 0 1.1 1.1 0 0 0-.22.33 1.07 1.07 0 0 0 0 .76 1.2 1.2 0 0 0 .22.33 1 1 0 0 0 .32.21 1 1 0 0 0 .39.08 1 1 0 0 0 .92-1.38.9.9 0 0 0-.22-.33M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09a.9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Zm-6.13-9a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.73 1 1 1 0 0 1 .87-.5 1 1 0 0 1 0 2 1 1 0 1 0 0 2 3 3 0 0 0 0-6" })
), cM = h(G5), O5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 13a1 1 0 0 0-1-1H8a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1m-3 7H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v1a1 1 0 0 0 2 0V8.94a1.2 1.2 0 0 0-.06-.27v-.09a.9.9 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09a.9.9 0 0 0-.32-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h5a1 1 0 0 0 0-2m2-14.59L15.59 8H14a1 1 0 0 1-1-1ZM20 14a1 1 0 0 0-.91.6A4.07 4.07 0 0 0 17 14a4 4 0 1 0 2.64 7 1 1 0 0 0-1.32-1.51A2 2 0 0 1 17 20a2 2 0 1 1 1-3.75h-.22a1 1 0 0 0 0 2H20a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1M8 10h1a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2m0 6a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2Z" })
), sM = h(O5), N5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 20H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v1a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2m0-14.59L14.59 8H13a1 1 0 0 1-1-1ZM7 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm14.71 12.29-1.17-1.16A3.44 3.44 0 0 0 20 15a3.49 3.49 0 0 0-6 2.49 3.46 3.46 0 0 0 5.13 3.05l1.16 1.17a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42m-3.17-1.75a1.54 1.54 0 0 1-2.11 0 1.5 1.5 0 0 1-.43-1.05 1.46 1.46 0 0 1 .44-1.06 1.48 1.48 0 0 1 1-.43A1.47 1.47 0 0 1 19 17.49a1.5 1.5 0 0 1-.46 1.05M13 12H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m-2 6a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2Z" })
), gM = h(N5), Q5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.5 12.5a1 1 0 0 0-1-1h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1m5 5a2 2 0 0 0-1.18.39l-1.75-.8 1.91-.88a2 2 0 0 0 1 .29 2 2 0 1 0-2-2l-1.89.87A2 2 0 1 0 13.5 19a1.9 1.9 0 0 0 .92-.24l2.1 1a2 2 0 1 0 2-2.23Zm-8 2h-5a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3a1 1 0 0 0 2 0V8.44a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.1 0 1 1 0 0 0-.26-.06H5.5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h5a1 1 0 0 0 0-2Zm2-14.59 2.59 2.59H13.5a1 1 0 0 1-1-1Zm-5 10.59a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm0-6h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2" })
), iM = h(Q5), K5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.5 20h-5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0L11.56 2H5.5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h5a1 1 0 0 0 0-2m2-14.59L15.09 8H13.5a1 1 0 0 1-1-1ZM7.5 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm13.63 5.86a1 1 0 0 0-.84-.2 2.77 2.77 0 0 1-2.2-.47 1 1 0 0 0-1.18 0 2.78 2.78 0 0 1-2.2.47 1 1 0 0 0-1.21 1V17a4.6 4.6 0 0 0 1.84 3.69l1.56 1.11a1 1 0 0 0 1.2 0l1.56-1.16A4.6 4.6 0 0 0 21.5 17v-2.37a1 1 0 0 0-.37-.77M19.5 17a2.62 2.62 0 0 1-1 2.09l-1 .72-1-.72a2.62 2.62 0 0 1-1-2.09v-1.28a4.7 4.7 0 0 0 2-.55 4.7 4.7 0 0 0 2 .55Zm-9-.95h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2m1-4h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2" })
), dM = h(K5), j5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 20.29-18-18a1 1 0 0 0-1.42 1.42L4 5.41V19a3 3 0 0 0 3 3h10a3 3 0 0 0 2.39-1.2l.9.91a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M17 20H7a1 1 0 0 1-1-1V7.41l11.93 11.93A1 1 0 0 1 17 20M8.66 4H12v3a3 3 0 0 0 3 3h3v3.34a1 1 0 1 0 2 0v-4.4a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09L13.06 2h-4.4a1 1 0 0 0 0 2M14 5.41 16.59 8H15a1 1 0 0 1-1-1Z" })
), pM = h(j5), J5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 12H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m5.41 7 1.3-1.29a1 1 0 0 0-1.42-1.42L18 17.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l1.3 1.29-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM12 20H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v3a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.1 0 1.1 1.1 0 0 0-.31-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6a1 1 0 0 0 0-2m1-14.59L15.59 8H14a1 1 0 0 1-1-1ZM8 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm4 8H8a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2" })
), fM = h(J5), Y5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.71 12.29a1 1 0 0 0-1.42 0L12 13.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l1.3 1.29-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 15l1.3-1.29a1 1 0 0 0 0-1.42M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.31-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Z" })
), EM = h(Y5), X5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 20H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v2a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2m0-14.59L15.59 8H14a1 1 0 0 1-1-1ZM8 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm6 4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m6.71 5.29-2-2a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2 2a1 1 0 0 0 1.42 1.42l.29-.3V21a1 1 0 0 0 2 0v-2.59l.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M12 18a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2Z" })
), xM = h(X5), _5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.71 11.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2 2a1 1 0 0 0 1.42 1.42l.29-.3V17a1 1 0 0 0 2 0v-2.59l.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.31-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Z" })
), AM = h(_5), z5 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09L13.06 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H14ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v5a1 1 0 0 0 1 1h5Z" })
), MM = h(z5), al = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 19H6a3 3 0 0 1-3-3V8a1 1 0 0 0-2 0v8a5 5 0 0 0 5 5h12a1 1 0 0 0 0-2m-4-8h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m9-1.06a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09a.9.9 0 0 0-.33-.11H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V9.94m-6-3.53L19.59 9H18a1 1 0 0 1-1-1ZM21 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7v3a3 3 0 0 0 3 3h3ZM10 9h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2" })
), HM = h(al), tl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M23 9.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19h-.09a.9.9 0 0 0-.33-.11H8a3 3 0 0 0-3 3v1H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-1h1a3 3 0 0 0 3-3V9.94m-6-3.53L19.59 9H18a1 1 0 0 1-1-1ZM17 18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1v5a3 3 0 0 0 3 3h9Zm4-4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7v3a3 3 0 0 0 3 3h3Z" })
), CM = h(tl), el = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2a1 1 0 0 0-1 1v2h-2V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v2H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0v-1h8v1a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1M6 17H4v-2h2Zm0-4H4v-2h2Zm0-4H4V7h2Zm10 9H8v-5h8Zm0-7H8V6h8Zm4 6h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2V7h2Z" })
), uM = h(el), ll = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.22 6h-6.56a1 1 0 0 0 0 2h6.56a.78.78 0 0 1 .78.78v.78h-3.78a1 1 0 1 0 0 2h2.37l-.7.69a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.88-1.88a2.5 2.5 0 0 0 .54-.8v-.1A2.6 2.6 0 0 0 22 9.82v-1A2.79 2.79 0 0 0 19.22 6M3.71 2.29a1 1 0 0 0-1.42 1.42l2.85 2.84A2.73 2.73 0 0 0 4 8.78v1a2.65 2.65 0 0 0 .24 1.1v.06a2.6 2.6 0 0 0 .54.81l5.41 5.4V21a1 1 0 0 0 .47.85 1 1 0 0 0 .53.15 1 1 0 0 0 .45-.11l3.56-1.78a1 1 0 0 0 .55-.89v-2l4.51 4.52a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM6 8.78a.76.76 0 0 1 .5-.72L6.59 8l1.56 1.56H6Zm8.07 7.29a1 1 0 0 0-.29.71v1.82l-1.56.78v-2.6a1 1 0 0 0-.29-.71l-4.52-4.51h2.74l4.22 4.22Z" })
), VM = h(ll), rl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v1.17a3 3 0 0 0 .25 1.2v.06a2.8 2.8 0 0 0 .59.86L9 14.41V21a1 1 0 0 0 .47.85A1 1 0 0 0 10 22a1 1 0 0 0 .45-.11l4-2A1 1 0 0 0 15 19v-4.59l6.12-6.12a2.8 2.8 0 0 0 .59-.86v-.06a3 3 0 0 0 .29-1.2V5a3 3 0 0 0-3-3m-5.71 11.29A1 1 0 0 0 13 14v4.38l-2 1V14a1 1 0 0 0-.29-.71L5.41 8h13.18ZM20 6H4V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), SM = h(rl), hl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m8.468 8.395-.002.001-.003.002Zm9.954-.187a1.2 1.2 0 0 0-.23-.175 1 1 0 0 0-1.4.411 5.8 5.8 0 0 1-1.398 1.778 8.7 8.7 0 0 0 .134-1.51 8.71 8.71 0 0 0-4.4-7.582 1 1 0 0 0-1.492.806 7.02 7.02 0 0 1-2.471 4.942l-.23.187a8.5 8.5 0 0 0-1.988 1.863 8.983 8.983 0 0 0 3.656 13.908 1 1 0 0 0 1.377-.926 1 1 0 0 0-.05-.312 7 7 0 0 1-.19-2.581 9 9 0 0 0 4.313 4.016 1 1 0 0 0 .715.038 8.995 8.995 0 0 0 3.654-14.863m-3.905 12.831a6.96 6.96 0 0 1-3.577-4.402 9 9 0 0 1-.18-.964 1 1 0 0 0-.799-.845 1 1 0 0 0-.191-.018 1 1 0 0 0-.867.5 8.96 8.96 0 0 0-1.205 4.718 6.985 6.985 0 0 1-1.176-9.868 6.6 6.6 0 0 1 1.562-1.458 1 1 0 0 0 .075-.055s.296-.245.306-.25a8.97 8.97 0 0 0 2.9-4.633 6.736 6.736 0 0 1 1.385 8.088 1 1 0 0 0 1.184 1.418 7.86 7.86 0 0 0 3.862-2.688 7 7 0 0 1-3.279 10.457" })
), LM = h(hl), ol = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.93 11.67a.4.4 0 0 0 0-.1A7.4 7.4 0 0 0 15 7.62V4h1a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2h1v3.62a7.4 7.4 0 0 0-3.89 4 .4.4 0 0 0 0 .1 7.5 7.5 0 1 0 13.86 0Zm-8.62-2.41a1 1 0 0 0 .69-.95V4h2v4.31a1 1 0 0 0 .69.95A5.43 5.43 0 0 1 16.23 11H7.77a5.43 5.43 0 0 1 2.54-1.74M12 20a5.51 5.51 0 0 1-5.5-5.5 5.3 5.3 0 0 1 .22-1.5h10.56a5.3 5.3 0 0 1 .22 1.5A5.51 5.51 0 0 1 12 20m2-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4-1a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), ZM = h(ol), nl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.11 17.49 15 8.73V4h1a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2h1v4.73l-5.11 8.76A3 3 0 0 0 6.48 22h11a3 3 0 0 0 2.59-4.51Zm-9.25-8A1 1 0 0 0 11 9V4h2v5a1 1 0 0 0 .14.5L14 11h-4Zm7.52 10a1 1 0 0 1-.86.5h-11a1 1 0 0 1-.86-.5 1 1 0 0 1 0-1L8.83 13h6.35l3.2 5.5a1 1 0 0 1 0 1ZM10 15a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 1a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), BM = h(nl), wl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.21 5.7a1 1 0 0 0 .24 0l1.94-.49A1 1 0 0 0 16.12 4a1 1 0 0 0-1.21-.73L13 3.73a1 1 0 0 0 .24 2ZM9.51 9h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2ZM7.39 7.15h.24l1.94-.48a1 1 0 0 0-.48-1.97l-1.94.48a1 1 0 0 0 .24 2ZM4 10.51a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1m16.62-8.3a1 1 0 0 0-.86-.21l-1 .24a1 1 0 0 0-.73 1.21 1 1 0 0 0 1 .76A1 1 0 0 0 21 4V3a1 1 0 0 0-.38-.79M20 7a1 1 0 0 0-1 1v1.14a1 1 0 0 0 .51 1.86H20a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m0 6H4a1 1 0 0 0-1 1v3a1 1 0 0 0 .76 1l16 4a1 1 0 0 0 .24 0 1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1m-1 6.72-14-3.5V15h14Z" })
), FM = h(wl), vl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2M10.93 9h1.5a1 1 0 0 0 0-2h-1.5a1 1 0 0 0 0 2m4.5-1a1 1 0 0 0 1 1H17a1 1 0 0 0 .92-.62 1 1 0 0 0-.21-1.09l-.66-.65a1 1 0 0 0-1.41 0 1 1 0 0 0-.19 1.15 2 2 0 0 0-.02.21m-3.78-3.23.35-.36.81.81a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41l-1.06-1.06a.9.9 0 0 0-.26-.19 1 1 0 0 0-1.61-.27l-1.06 1.06a1 1 0 0 0 1.42 1.42M17 15H7a1 1 0 0 0-.92.62 1 1 0 0 0 .21 1.09l5 5a1 1 0 0 0 1.42 0l5-5a1 1 0 0 0 .21-1.09A1 1 0 0 0 17 15m-5 4.59L9.41 17h5.18ZM7.05 9a1 1 0 0 0 .71-.29L8.82 7.6A1 1 0 0 0 7.4 6.18L6.34 7.24a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.34" })
), RM = h(vl), ml = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.94 12.24a1 1 0 0 0-1.21.76l-.49 1.94A1 1 0 0 0 4 16.12a1 1 0 0 0 1.21-.73l.49-1.94a1 1 0 0 0-.76-1.21m17 7.52-4-16A1 1 0 0 0 17 3h-3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h7a1 1 0 0 0 .79-.38 1 1 0 0 0 .21-.86ZM15 19V5h1.22l3.5 14ZM6.4 6.42a1 1 0 0 0-1.22.73L4.7 9.09a1 1 0 0 0 .73 1.21h.24a1 1 0 0 0 1-.76l.48-1.94a1 1 0 0 0-.75-1.18M7.51 5h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2M4.24 19a1 1 0 0 0-2-.24l-.24 1a1 1 0 0 0 .18.86A1 1 0 0 0 3 21h1a1 1 0 0 0 .24-2M10 6.51a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m0 6a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m0 6a1 1 0 0 0-.86.49H8a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1v-.49a1 1 0 0 0-1-1" })
), UM = h(ml), cl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.6 15.18a1 1 0 0 0-1.42 1.42l1.06 1.06a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm-3.79-5.4-1.06 1.06a.9.9 0 0 0-.19.26 1 1 0 0 0-.27 1.61l1.06 1.06a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L4.41 12l.81-.81a1 1 0 0 0-1.41-1.41m4.19.79a1 1 0 0 0-1 1v1.5a1 1 0 0 0 2 0v-1.5a1 1 0 0 0-1-1m13.71.72-5-5a1 1 0 0 0-1.09-.21A1 1 0 0 0 15 7v10a1 1 0 0 0 .62.92.84.84 0 0 0 .38.08 1 1 0 0 0 .71-.29l5-5a1 1 0 0 0 0-1.42M17 14.59V9.41L19.59 12ZM12 2a1 1 0 0 0-1 1v18a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1M8.38 6.08a1 1 0 0 0-1.09.21L6.64 7a1 1 0 0 0 0 1.41 1 1 0 0 0 .7.3 1 1 0 0 0 .45-.11A1 1 0 0 0 9 7.57V7a1 1 0 0 0-.62-.92" })
), $M = h(cl), sl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.68 6.88a4.4 4.4 0 0 0-3.31-.32 4.37 4.37 0 0 0-8.73 0 4.48 4.48 0 0 0-3.31.29 4.37 4.37 0 0 0 .61 8 4.4 4.4 0 0 0-.8 2.5 5 5 0 0 0 .07.75 4.34 4.34 0 0 0 4.29 3.63 5 5 0 0 0 .64 0A4.42 4.42 0 0 0 12 20a4.42 4.42 0 0 0 2.86 1.69 5 5 0 0 0 .64 0 4.36 4.36 0 0 0 3.56-6.87 4.36 4.36 0 0 0 .62-8Zm-9.34-1.94a2.4 2.4 0 0 1 3.32 0 2.43 2.43 0 0 1 .52 2.66l-.26.59-.66.58A4 4 0 0 0 12 8.55a4 4 0 0 0-1.61.34L9.83 7.6a2.39 2.39 0 0 1 .51-2.66m-6.1 6.84A2.37 2.37 0 0 1 7.94 9l.49.43.35.8A3.92 3.92 0 0 0 8 12.55 3 3 0 0 0 8 13h-.55l-.84.08a2.37 2.37 0 0 1-2.37-1.3m6.6 6.08a2.38 2.38 0 0 1-4.66-.08 3 3 0 0 1 0-.42 2.33 2.33 0 0 1 1.17-2l.51-.36.91-.1a4 4 0 0 0 2.38 1.57ZM12 14.55a2 2 0 1 1 2-2 2 2 0 0 1-2 2m5.82 3.22a2.36 2.36 0 0 1-2.68 1.94 2.39 2.39 0 0 1-2-1.85l-.14-.6.21-.92a4 4 0 0 0 2.2-1.76l.5.3H16l.66.39a2.38 2.38 0 0 1 1.16 2.5m1.94-6a2.39 2.39 0 0 1-2.13 1.33h-.24l-.64-.1-.75-.41a4 4 0 0 0-1-2.64l.43-.37.63-.58a2.37 2.37 0 0 1 3.7 2.82Z" })
), yM = h(sl), gl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 20H5a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h3a1 1 0 0 0 0-2M3 9a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1m16-7h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3m-3 10a1 1 0 0 0-1-1h-2V9a1 1 0 0 0-2 0v2H9a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 1-1m5 3a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 0 0 2h3a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1" })
), kM = h(gl), il = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 9a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1m5 11H5a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h3a1 1 0 0 0 0-2m9-7a1 1 0 0 0 0-2h-1.14A4 4 0 0 0 13 8.14V7a1 1 0 0 0-2 0v1.14A4 4 0 0 0 8.14 11H7a1 1 0 0 0 0 2h1.14A4 4 0 0 0 11 15.86V17a1 1 0 0 0 2 0v-1.14A4 4 0 0 0 15.86 13Zm-5 1a2 2 0 1 1 2-2 2 2 0 0 1-2 2m9 1a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 0 0 2h3a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1M19 2h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3" })
), bM = h(il), dl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 2H3a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V4h4a1 1 0 0 0 0-2m0 18H4v-4a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2M21 2h-5a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1m0 13a1 1 0 0 0-1 1v4h-4a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1" })
), TM = h(dl), pl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.29 10.79 11 14.09l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0-1.42-1.42M19 5.5h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), PM = h(pl), fl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m13.29 13.79-.29.3V11.5a1 1 0 0 0-2 0v2.59l-.29-.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2-2a1 1 0 0 0-1.42-1.42M19 5.5h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), DM = h(fl), El = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.92 16.12a.8.8 0 0 0-.09-.18 2 2 0 0 0-.12-.15l-.15-.12-.18-.09a.6.6 0 0 0-.19-.06 1 1 0 0 0-.9.27l-.12.15a.8.8 0 0 0-.09.18.6.6 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 .08.38 1.2 1.2 0 0 0 .21.33 1 1 0 0 0 1.09.22 1.5 1.5 0 0 0 .33-.22 1.5 1.5 0 0 0 .22-.33 1 1 0 0 0 .05-.38 1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.08-.18M12 10.5a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m7-5h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), qM = h(El), xl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 9.84a2.92 2.92 0 0 0-3.43 4.65l2.72 2.72a1 1 0 0 0 1.42 0l2.72-2.72A2.92 2.92 0 0 0 12 9.84m2 3.23-2 2-2-2a.92.92 0 0 1 0-1.3.92.92 0 0 1 1.3 0 1 1 0 0 0 1.42 0 .92.92 0 0 1 1.3 1.3Zm5-7.57h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), IM = h(xl), Al = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 13.5a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m7-8h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Zm-7.29-7.71a1 1 0 0 0-1.09-.21.9.9 0 0 0-.33.21 1.05 1.05 0 0 0-.29.71 1 1 0 0 0 .29.7 1 1 0 0 0 1.42 0 1 1 0 0 0 .29-.7 1 1 0 0 0-.08-.38.9.9 0 0 0-.21-.33" })
), WM = h(Al), Ml = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4 4h4.56a1 1 0 0 1 .95.68l.54 1.64A1 1 0 0 0 11 7h7a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3h-6.28l-.32-1a3 3 0 0 0-2.84-2H4a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h6a1 1 0 0 0 0-2H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m17 11.18V14a3 3 0 0 0-6 0v1.18A3 3 0 0 0 13 18v2a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3v-2a3 3 0 0 0-2-2.82M17 14a1 1 0 0 1 2 0v1h-2Zm4 6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Z" })
), GM = h(Ml), Hl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 12.5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m5-7h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), OM = h(Hl), Cl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 12.5h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m5-7h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), NM = h(Cl), ul = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 18h-6.18A3 3 0 0 0 13 16.18V14h3.67A2.34 2.34 0 0 0 19 11.67V6.33A2.34 2.34 0 0 0 16.67 4h-4l-.13-.41A2.34 2.34 0 0 0 10.37 2h-3A2.34 2.34 0 0 0 5 4.33v7.34A2.34 2.34 0 0 0 7.33 14H11v2.18A3 3 0 0 0 9.18 18H3a1 1 0 0 0 0 2h6.18a3 3 0 0 0 5.64 0H21a1 1 0 0 0 0-2M7.33 12a.33.33 0 0 1-.33-.33V4.33A.33.33 0 0 1 7.33 4h3a.33.33 0 0 1 .32.23l.36 1.09A1 1 0 0 0 12 6h4.67a.33.33 0 0 1 .33.33v5.34a.33.33 0 0 1-.33.33ZM12 20a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), QM = h(ul), Vl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.78 10.37A1 1 0 0 0 22 10h-2V9a3 3 0 0 0-3-3h-6.28l-.32-1a3 3 0 0 0-2.84-2H4a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14.4a3 3 0 0 0 2.92-2.35L23 11.22a1 1 0 0 0-.22-.85M5.37 18.22a1 1 0 0 1-1 .78H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3.56a1 1 0 0 1 1 .68l.54 1.64A1 1 0 0 0 10 8h7a1 1 0 0 1 1 1v1H8a1 1 0 0 0-1 .78Zm14 0a1 1 0 0 1-1 .78H7.21a1.4 1.4 0 0 0 .11-.35L8.8 12h12Z" })
), KM = h(Vl), Sl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 12.5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m5-7h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), jM = h(Sl), Ll = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.57 16.3a.6.6 0 0 0-.15-.13l-.17-.09-.19-.08a1 1 0 0 0-.9.28 1 1 0 0 0-.22.32 1 1 0 0 0-.07.39 1 1 0 0 0 .29.7 1 1 0 0 0 .32.22 1 1 0 0 0 .39.07 1 1 0 0 0 .38-.07 1 1 0 0 0 .32-.22 1 1 0 0 0 .3-.7 1 1 0 0 0-.08-.39.9.9 0 0 0-.22-.3m-.7-7.3a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.73 1 1 1 0 0 1 1.87.5 1 1 0 0 1-1 1 1 1 0 1 0 0 2 3 3 0 0 0 0-6M19 5.5h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), JM = h(Ll), Zl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 20.29-1.6-1.6-16.4-16.4a1 1 0 0 0-1.42 1.42l1.4 1.39A3 3 0 0 0 3 7v11a3 3 0 0 0 3 3h12a3 3 0 0 0 1.29-.3l1 1a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41M6 19a1 1 0 0 1-1-1V7a1 1 0 0 1 .12-.46L17.59 19Zm4.62-13a1 1 0 0 1 .89.67l.54 1.64A1 1 0 0 0 13 9h5a1 1 0 0 1 1 1v4.34a1 1 0 1 0 2 0V10a3 3 0 0 0-3-3h-4.28l-.32-1a3 3 0 0 0-2.68-2 1 1 0 0 0-.1 2" })
), YM = h(Zl), Bl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.71 10.79a1 1 0 0 0-1.42 0L12 12.09l-1.29-1.3a1 1 0 0 0-1.42 1.42l1.3 1.29-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-1.3-1.29 1.3-1.29a1 1 0 0 0 0-1.42M19 5.5h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), XM = h(Bl), Fl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.71 10.79a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2 2a1 1 0 0 0 1.42 1.42l.29-.3v2.59a1 1 0 0 0 2 0v-2.59l.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM19 5.5h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), _M = h(Fl), Rl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 5.5h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1Z" })
), zM = h(Rl), Ul = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 20h-1V3a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-.86.5L4.43 20H3a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2h-.26l3.5-6H18v6h-1a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-3-8h-6.59l4.66-8H18Z" })
), aH = h(Ul), $l = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.84 5.56a4.08 4.08 0 0 0-1.14-2.25 4.08 4.08 0 0 0-2.25-1.14 13.7 13.7 0 0 0-5.29.24 1 1 0 0 0-.2.06 14.44 14.44 0 0 0-6.69 3.8A14.6 14.6 0 0 0 2.45 13c0 .06 0 .12-.05.19a13.7 13.7 0 0 0-.24 5.3 4.1 4.1 0 0 0 1.14 2.2 4.08 4.08 0 0 0 2.25 1.14 13 13 0 0 0 2.08.17 13.8 13.8 0 0 0 3.26-.41h.14a14.54 14.54 0 0 0 10.52-10.5c0-.06 0-.12.05-.19a13.7 13.7 0 0 0 .24-5.34M16.37 4a10.4 10.4 0 0 1 1.76.14 2 2 0 0 1 .24.07L17 5.59l-1.54-1.54c.3-.05.61-.05.91-.05m-8.7 3.67a12.7 12.7 0 0 1 5.4-3.19L15.59 7l-2.15 2.15-.73-.73a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l.73.73L10.56 12l-.73-.73a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42l.73.73L7 15.59l-2.51-2.51a12.7 12.7 0 0 1 3.18-5.41m-3.46 10.7a2 2 0 0 1-.07-.24A11.4 11.4 0 0 1 4 15.46L5.59 17Zm1.66 1.49a2 2 0 0 1-.24-.07L7 18.41 8.54 20a11.4 11.4 0 0 1-2.67-.14m10.46-3.53a12.7 12.7 0 0 1-5.41 3.18L8.41 17l2.15-2.15.73.73a1 1 0 1 0 1.42-1.41l-.71-.73L13.44 12l.73.73a1 1 0 0 0 .71.29 1 1 0 0 0 .7-1.71l-.73-.73L17 8.41l2.51 2.51a12.7 12.7 0 0 1-3.18 5.41M20 8.54 18.41 7l1.38-1.37a2 2 0 0 1 .07.24A11.4 11.4 0 0 1 20 8.54" })
), tH = h($l), yl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.84 5.56a4.08 4.08 0 0 0-1.14-2.25 4.08 4.08 0 0 0-2.25-1.14A14.45 14.45 0 0 0 2.16 18.44a4.08 4.08 0 0 0 1.14 2.25 4.08 4.08 0 0 0 2.25 1.14 13 13 0 0 0 2.08.17 14.37 14.37 0 0 0 10.11-4.26 14.23 14.23 0 0 0 4.1-12.18M4.21 18.37a2 2 0 0 1-.07-.24A12.21 12.21 0 0 1 7.67 7.67 12.4 12.4 0 0 1 16.37 4a10.4 10.4 0 0 1 1.76.14 2 2 0 0 1 .24.07l-4.93 4.94-.73-.73a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l.73.73L10.56 12l-.73-.73a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42l.73.73Zm12.12-2a12.24 12.24 0 0 1-10.46 3.49 2 2 0 0 1-.24-.07l4.93-4.94.73.73a1 1 0 1 0 1.42-1.41l-.71-.73L13.44 12l.73.73a1 1 0 0 0 .71.29 1 1 0 0 0 .7-1.71l-.73-.73 4.94-4.93a2 2 0 0 1 .07.24 12.21 12.21 0 0 1-3.53 10.44Z" })
), eH = h(yl), kl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.07 6.11a9.85 9.85 0 0 0-4.3-3.36A10 10 0 0 0 2 12v.56A9.94 9.94 0 0 0 3.33 17a10 10 0 0 0 5.89 4.65A10.1 10.1 0 0 0 12 22a9.5 9.5 0 0 0 1.88-.18 10 10 0 0 0 8-8.41A9.5 9.5 0 0 0 22 12a9.83 9.83 0 0 0-1.93-5.89m-2 .77L17 9.74l-1.62.44L13 8.49V6.64l2.49-1.81a7.8 7.8 0 0 1 2.62 2.05ZM14 11.67 13.22 14h-2.45L10 11.67l2-1.43ZM12 4a8 8 0 0 1 1.11.09l-1.11.8-1.11-.8A8 8 0 0 1 12 4M4.88 8.37l.4 1.32-1.13.79a7.9 7.9 0 0 1 .73-2.11m1.37 9.17 1.38.05.37 1.33a8.3 8.3 0 0 1-1.75-1.38M8 15.6l-3.15-.11A7.8 7.8 0 0 1 4.07 13l2.49-1.74 1.44.62.89 2.76Zm.86-5.53-1.56-.7-.91-3A8 8 0 0 1 8.5 4.83L11 6.64v1.85ZM13 19.93a8.1 8.1 0 0 1-2.63-.12l-.83-2.92.83-.89h3.07l.67 1Zm2.41-.7.46-1.23 1.36.07a7.8 7.8 0 0 1-1.85 1.16Zm3.46-3.12L15.76 16l-.71-1.1.89-2.76 1.51-.41 2.36 2a7.8 7.8 0 0 1-.97 2.38Zm.05-5.83L19.4 9a7.4 7.4 0 0 1 .53 2.13Z" })
), lH = h(kl), bl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.7 7.57a1 1 0 0 0-.93-.26 3.2 3.2 0 0 1-.66.08 3 3 0 0 1-3-3 3 3 0 0 1 .08-.65A1 1 0 0 0 16 2.53a4.93 4.93 0 0 0-3.83 4.21 6.2 6.2 0 0 0-1.67-.24 6 6 0 0 0-5.94 5.13 3.5 3.5 0 0 0-.46 6.58 1.1 1.1 0 0 0 .4.08 1 1 0 0 0 .4-1.92A1.48 1.48 0 0 1 4 15a1.5 1.5 0 0 1 1.5-1.5 1 1 0 0 0 1-1 4 4 0 0 1 4-4 3.9 3.9 0 0 1 2.18.66 4 4 0 0 1 1.57 2 1 1 0 0 0 .78.67 2.32 2.32 0 0 1 .97 4.28 1 1 0 0 0 1.1 1.68 4.32 4.32 0 0 0 1.9-3.62 4.2 4.2 0 0 0-.49-2A4.94 4.94 0 0 0 22 8.5a1 1 0 0 0-.3-.93m-4.59 2.82a2.6 2.6 0 0 1-.42 0A4.6 4.6 0 0 0 16 10a6 6 0 0 0-1.82-2.28v-.37a3 3 0 0 1 1.05-2.28 5 5 0 0 0 4.23 4.23 3 3 0 0 1-2.35 1.09m-6 3.94a1 1 0 0 0-1.12 0C9.84 14.41 7.5 16 7.5 18.5a3 3 0 0 0 6 0c0-2.5-2.35-4.1-2.44-4.17Zm-.61 5.17a1 1 0 0 1-1-1 3 3 0 0 1 1-2 3 3 0 0 1 1 2 1 1 0 0 1-1 1" })
), rH = h(bl), Tl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.94 6.56h3.58l-.79.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l2.5-2.5a1 1 0 0 0 0-1.41l-2.5-2.5a1 1 0 0 0-1.41 1.41l.79.79h-3.58a1 1 0 0 0 0 2m4.5 6.44c-.22 0-.45-.07-.67-.12a9.4 9.4 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.2 12.2 0 0 1-2.66-2 12.2 12.2 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10 10 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2-.76 3 3 0 0 0 1-2.25v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.34.75 1.06 1.06 0 0 1-.82.25A17 17 0 0 1 4.07 5.22a1.1 1.1 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79q.06.41.15.81a11 11 0 0 0 .46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.5 14.5 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .57-.52l.62-1.4a14 14 0 0 0 1.58.46q.4.09.81.15a1 1 0 0 1 .79 1Z" })
), hH = h(Tl), Pl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.67 9.69 14 5.84a2.67 2.67 0 0 0-4 2.31L6 5.84a2.67 2.67 0 0 0-4 2.31v7.7a2.63 2.63 0 0 0 1.33 2.3 2.6 2.6 0 0 0 1.34.37A2.7 2.7 0 0 0 6 18.16l4-2.31a2.65 2.65 0 0 0 1.33 2.31 2.66 2.66 0 0 0 2.67 0l6.67-3.85a2.67 2.67 0 0 0 0-4.62M10 13.54l-5 2.88a.67.67 0 0 1-1-.57v-7.7a.67.67 0 0 1 1-.57l5 2.88Zm9.67-1L13 16.43a.69.69 0 0 1-.67 0 .66.66 0 0 1-.33-.58v-7.7a.66.66 0 0 1 .33-.58.8.8 0 0 1 .34-.09.63.63 0 0 1 .33.09l6.67 3.85a.67.67 0 0 1 0 1.16Z" })
), oH = h(Pl), Dl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.36 15.33a1 1 0 0 0-.13 1.4 1 1 0 0 0 1.41.13 3.76 3.76 0 0 1 4.72 0 1 1 0 0 0 1.41-.13 1 1 0 0 0-.13-1.4 5.81 5.81 0 0 0-7.28 0M9 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m3-9a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m3-11a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), nH = h(Dl), ql = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 18h-2v-3a1 1 0 0 0-1-1h-5v-2.71l1.13.59a1 1 0 0 0 1.45-1.05l-.4-2.37 1.72-1.69a1 1 0 0 0 .26-1 1 1 0 0 0-.81-.68L14 4.72l-1.1-2.16a1 1 0 0 0-1.8 0L10 4.72l-2.39.35a1 1 0 0 0-.81.68 1 1 0 0 0 .26 1l1.76 1.71-.4 2.37a1 1 0 0 0 1.45 1.05l1.13-.59V14H6a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-1h4v1a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1H7v-2h10v2h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-1h4v1a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m-9-9.37a1 1 0 0 0-.47.12l-.8.42.15-.9a1 1 0 0 0-.29-.88l-.65-.64.9-.13a1 1 0 0 0 .76-.54l.4-.82.4.82a1 1 0 0 0 .76.54l.9.13-.65.64a1 1 0 0 0-.29.88l.15.9-.8-.42a1 1 0 0 0-.47-.12" })
), wH = h(ql), Il = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 7h-.35A3.45 3.45 0 0 0 18 5.5a3.49 3.49 0 0 0-6-2.44A3.49 3.49 0 0 0 6 5.5 3.45 3.45 0 0 0 6.35 7H6a3 3 0 0 0-3 3v2a1 1 0 0 0 1 1h1v6a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-6h1a1 1 0 0 0 1-1v-2a3 3 0 0 0-3-3m-7 13H8a1 1 0 0 1-1-1v-6h4Zm0-9H5v-1a1 1 0 0 1 1-1h5Zm0-4H9.5A1.5 1.5 0 1 1 11 5.5Zm2-1.5A1.5 1.5 0 1 1 14.5 7H13ZM17 19a1 1 0 0 1-1 1h-3v-7h4Zm2-8h-6V9h5a1 1 0 0 1 1 1Z" })
), vH = h(Il), Wl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.07 20.503a1 1 0 0 0-1.18-.983c-1.31.24-2.963.276-3.402-.958a5.7 5.7 0 0 0-1.837-2.415 1 1 0 0 1-.167-.11 1 1 0 0 0-.93-.645h-.005a1 1 0 0 0-1 .995c-.004.815.81 1.338 1.141 1.514a4.4 4.4 0 0 1 .924 1.36c.365 1.023 1.423 2.576 4.466 2.376l.003.098.004.268a1 1 0 0 0 2 0l-.005-.318c-.005-.19-.012-.464-.012-1.182M20.737 5.377q.049-.187.09-.42a6.3 6.3 0 0 0-.408-3.293 1 1 0 0 0-.615-.58c-.356-.12-1.67-.357-4.184 1.25a13.9 13.9 0 0 0-6.354 0C6.762.75 5.455.966 5.102 1.079a1 1 0 0 0-.631.584 6.3 6.3 0 0 0-.404 3.357q.037.191.079.354a6.27 6.27 0 0 0-1.256 3.83 8 8 0 0 0 .043.921c.334 4.603 3.334 5.984 5.424 6.459a5 5 0 0 0-.118.4 1 1 0 0 0 1.942.479 1.68 1.68 0 0 1 .468-.878 1 1 0 0 0-.546-1.745c-3.454-.395-4.954-1.802-5.18-4.899a7 7 0 0 1-.033-.738 4.26 4.26 0 0 1 .92-2.713 3 3 0 0 1 .195-.231 1 1 0 0 0 .188-1.025 3.4 3.4 0 0 1-.155-.555 4.1 4.1 0 0 1 .079-1.616 7.5 7.5 0 0 1 2.415 1.18 1 1 0 0 0 .827.133 11.8 11.8 0 0 1 6.173.001 1 1 0 0 0 .83-.138 7.6 7.6 0 0 1 2.406-1.19 4 4 0 0 1 .087 1.578 3.2 3.2 0 0 1-.169.607 1 1 0 0 0 .188 1.025c.078.087.155.18.224.268A4.12 4.12 0 0 1 20 9.203a7 7 0 0 1-.038.777c-.22 3.056-1.725 4.464-5.195 4.86a1 1 0 0 0-.546 1.746 1.63 1.63 0 0 1 .466.908 3 3 0 0 1 .093.82v2.333c-.01.648-.01 1.133-.01 1.356a1 1 0 1 0 2 0c0-.217 0-.692.01-1.34v-2.35a4.9 4.9 0 0 0-.155-1.311 4 4 0 0 0-.116-.416 6.51 6.51 0 0 0 5.445-6.424A9 9 0 0 0 22 9.203a6.13 6.13 0 0 0-1.263-3.826" })
), mH = h(Wl), Gl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2.247a10 10 0 0 0-3.162 19.487c.5.088.687-.212.687-.475 0-.237-.012-1.025-.012-1.862-2.513.462-3.163-.613-3.363-1.175a3.64 3.64 0 0 0-1.025-1.413c-.35-.187-.85-.65-.013-.662a2 2 0 0 1 1.538 1.025 2.137 2.137 0 0 0 2.912.825 2.1 2.1 0 0 1 .638-1.338c-2.225-.25-4.55-1.112-4.55-4.937a3.9 3.9 0 0 1 1.025-2.688 3.6 3.6 0 0 1 .1-2.65s.837-.262 2.75 1.025a9.43 9.43 0 0 1 5 0c1.912-1.3 2.75-1.025 2.75-1.025a3.6 3.6 0 0 1 .1 2.65 3.87 3.87 0 0 1 1.025 2.688c0 3.837-2.338 4.687-4.562 4.937a2.37 2.37 0 0 1 .674 1.85c0 1.338-.012 2.413-.012 2.75 0 .263.187.575.687.475A10.005 10.005 0 0 0 12 2.247" })
), cH = h(Gl), Ol = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.94 12.865-1.066-3.28.001.005v-.005l-2.115-6.51a.83.83 0 0 0-.799-.57.82.82 0 0 0-.788.576l-2.007 6.178H8.834L6.824 3.08a.82.82 0 0 0-.788-.575H6.03a.84.84 0 0 0-.796.575L3.127 9.584l-.002.006.001-.005-1.069 3.28a1.195 1.195 0 0 0 .435 1.34l9.229 6.705.004.003.012.008-.011-.008.002.001.001.001.045.028.006.004.004.002.003.001h.002l.005.003.025.01.023.01h.001l.004.002.005.002h.002l.006.002h.003q.016.005.034.009l.013.003h.002l.005.002.007.001h.007a1 1 0 0 0 .066.006h.001a1 1 0 0 0 .067-.005h.007l.007-.002.004-.001h.002l.014-.004.034-.008h.002l.006-.003h.002l.005-.002.004-.001h.001l.025-.011.023-.01.005-.002h.002l.003-.002.004-.002.007-.004.044-.027.004-.003.005-.003 9.23-6.706a1.195 1.195 0 0 0 .434-1.339Zm-3.973-9.18 1.81 5.574h-3.62Zm-11.937 0L7.843 9.26h-3.62Zm-2.984 9.757a.255.255 0 0 1-.092-.285l.794-2.438 5.822 7.464Zm1.494-3.24h3.61l2.573 7.927Zm7.165 10.696-.006-.005-.011-.01-.02-.018.002.001.002.002.043.037.002.002Zm.293-1.894-1.514-4.665-1.344-4.138h5.72Zm.31 1.88-.01.008-.002.001-.005.005-.012.009.002-.002.043-.036.001-.002.002-.002ZM15.851 10.2h3.61l-.74.947-5.447 6.98Zm5.1 3.241-6.523 4.74 5.824-7.463.791 2.437a.255.255 0 0 1-.092.286" })
), sH = h(Ol), Nl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m19.71 16.29-14-14a1 1 0 0 0-1.42 1.42L6.59 6H5a1 1 0 0 0-.9.57 1 1 0 0 0 .12 1L11 16.1V20H6.75a1 1 0 0 0 0 2h10.5a1 1 0 0 0 0-2H13v-3.9l1.64-2 3.65 3.65a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.46M7.08 8h1.51l1.89 1.89H8.59ZM12 14.15l-1.81-2.26h2.29l.74.74ZM14.66 8h2.26l-.63.79a1 1 0 0 0 .15 1.4 1 1 0 0 0 .63.22 1 1 0 0 0 .78-.37l1.93-2.42a1 1 0 0 0 .12-1A1 1 0 0 0 19 6h-4.34a1 1 0 0 0 0 2" })
), gH = h(Nl), Ql = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.78 3.62a1 1 0 0 0 .12-1.05A1 1 0 0 0 21 2H3a1 1 0 0 0-.9.57 1 1 0 0 0 .12 1.05L11 14.6V20H5.25a1 1 0 0 0 0 2h13.5a1 1 0 0 0 0-2H13v-5.4ZM5.08 4h13.84l-2.4 3h-9ZM12 12.65 9.08 9h5.84Z" })
), iH = h(Ql), Kl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 20h-5v-5.06A9 9 0 0 0 21 6a8.7 8.7 0 0 0-.67-3.39 1 1 0 0 0-.22-.32L20 2.21a1 1 0 0 0-.21-.13 1 1 0 0 0-.28-.08H4.5a1 1 0 0 0-.29.06A2 2 0 0 0 4 2.2l-.12.09a1 1 0 0 0-.22.32A8.7 8.7 0 0 0 3 6a9 9 0 0 0 8 8.94V20H6a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2M5 6a7 7 0 0 1 .29-2h13.42A7 7 0 0 1 19 6 7 7 0 0 1 5 6" })
), dH = h(Kl), jl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 3a3 3 0 0 0-2.23-1H7.23a3 3 0 0 0-3 3.33l1.56 14a3 3 0 0 0 3 2.67h6.42a3 3 0 0 0 3-2.67l1.56-14A3 3 0 0 0 19 3m-2.8 16.11a1 1 0 0 1-1 .89H8.79a1 1 0 0 1-1-.89L6.78 10h10.44ZM17.44 8H6.56l-.32-2.89a1 1 0 0 1 .25-.78A1 1 0 0 1 7.23 4h9.54a1 1 0 0 1 .74.33 1 1 0 0 1 .25.78ZM14 18a1 1 0 0 0 1-1v-4a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1m-4 0a1 1 0 0 0 1-1v-4a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1" })
), pH = h(jl), Jl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.75 2.33A1 1 0 0 0 19 2H5a1 1 0 0 0-.75.33 1 1 0 0 0-.25.78l1.8 16.22a3 3 0 0 0 3 2.67h6.42a3 3 0 0 0 3-2.67L20 3.11a1 1 0 0 0-.25-.78M16.2 19.11a1 1 0 0 1-1 .89H8.79a1 1 0 0 1-1-.89L6.78 10h10.44ZM17.44 8H6.56l-.44-4h11.76Z" })
), fH = h(Jl), Yl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.41 8.64v-.05a10 10 0 0 0-18.78 0s0 0 0 .05a9.86 9.86 0 0 0 0 6.72v.05a10 10 0 0 0 18.78 0s0 0 0-.05a9.86 9.86 0 0 0 0-6.72M4.26 14a7.8 7.8 0 0 1 0-4h1.86a16.7 16.7 0 0 0 0 4Zm.82 2h1.4a12 12 0 0 0 1 2.57A8 8 0 0 1 5.08 16m1.4-8h-1.4a8 8 0 0 1 2.37-2.57A12 12 0 0 0 6.48 8M11 19.7A6.34 6.34 0 0 1 8.57 16H11Zm0-5.7H8.14a14.4 14.4 0 0 1 0-4H11Zm0-6H8.57A6.34 6.34 0 0 1 11 4.3Zm7.92 0h-1.4a12 12 0 0 0-1-2.57A8 8 0 0 1 18.92 8M13 4.3A6.34 6.34 0 0 1 15.43 8H13Zm0 15.4V16h2.43A6.34 6.34 0 0 1 13 19.7m2.86-5.7H13v-4h2.86a14.4 14.4 0 0 1 0 4m.69 4.57a12 12 0 0 0 1-2.57h1.4a8 8 0 0 1-2.4 2.57M19.74 14h-1.86a16 16 0 0 0 .12-2 16 16 0 0 0-.12-2h1.86a7.8 7.8 0 0 1 0 4" })
), EH = h(Yl), Xl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 11h8a1 1 0 0 0 .77-.37A1 1 0 0 0 17 9.8l-1-5a1 1 0 0 0-1-.8H9a1 1 0 0 0-1 .8l-1 5a1 1 0 0 0 .21.83A1 1 0 0 0 8 11m1.82-5h4.36l.6 3H9.22ZM22 13.8a1 1 0 0 0-1-.8h-6a1 1 0 0 0-1 .8l-1 5a1 1 0 0 0 .21.83A1 1 0 0 0 14 20h8a1 1 0 0 0 .77-.37 1 1 0 0 0 .23-.83ZM15.22 18l.6-3h4.36l.6 3ZM9 13H3a1 1 0 0 0-1 .8l-1 5a1 1 0 0 0 .21.83A1 1 0 0 0 2 20h8a1 1 0 0 0 .77-.37 1 1 0 0 0 .23-.83l-1-5a1 1 0 0 0-1-.8m-5.78 5 .6-3h4.36l.6 3Z" })
), xH = h(Xl), _l = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-2-4a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m5-12a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), AH = h(_l), zl = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 14.44a.6.6 0 0 0 0-.13.6.6 0 0 1 0-.12l-.05-.12-6-10.29a1 1 0 0 0-.95-.49H9a1 1 0 0 0-.5.13l-.11.08a1 1 0 0 0-.09.08.6.6 0 0 0-.1.12s0 0-.06.08l-6 10.33a1 1 0 0 0 0 1l3 5.08a1 1 0 0 0 .11.15v.06a1.1 1.1 0 0 0 .44.26.8.8 0 0 0 .22 0H18a1 1 0 0 0 .86-.49l3-5.14.05-.12a.6.6 0 0 1 0-.12.5.5 0 0 0 0-.13.5.5 0 0 0 0-.13.6.6 0 0 0 .09-.09M6 17.73l-1.79-3.1L9 6.27l.87 1.5 1 1.66L7 15.91Zm6-6.32 1.26 2.16h-2.54Zm5.43 7.3H7.7l1.84-3.14h9.72Zm-1.86-5.14-4.83-8.28h3.69l4.83 8.28Z" })
), MH = h(zl), a8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.423 13.888-6.09-10.55H8.668l6.09 10.55ZM8.09 4.338 2 14.888l3.334 5.774 6.089-10.55Zm1.733 10.55-3.333 5.774h12.178L22 14.887Z" })
), HH = h(a8), t8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.992 7.69a2 2 0 0 0 0 4l.015-.001v.501a.5.5 0 0 1-.5.5 1 1 0 0 0 0 2 2.5 2.5 0 0 0 2.5-2.5v-2.5a1 1 0 0 0-.03-.15 1.994 1.994 0 0 0-1.985-1.85m3-6.688a9.787 9.787 0 0 0-1 19.523v1.477a1 1 0 0 0 1.238.97 12.535 12.535 0 0 0 9.467-10.974 9.734 9.734 0 0 0-9.706-10.996m7.717 10.78a10.55 10.55 0 0 1-6.718 8.86v-1.066a1 1 0 0 0-1-1 7.787 7.787 0 1 1 7.788-7.787 8 8 0 0 1-.07.993M14.992 7.69a2 2 0 1 0 0 4l.015-.001v.501a.5.5 0 0 1-.5.5 1 1 0 0 0 0 2 2.5 2.5 0 0 0 2.5-2.5v-2.5a1 1 0 0 0-.03-.15 1.994 1.994 0 0 0-1.985-1.85" })
), CH = h(t8), e8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.444 9.055a8.5 8.5 0 0 0-2.173-4.334 8.4 8.4 0 0 0-1.622-1.357 8.5 8.5 0 0 0-3.64-1.31A4 4 0 0 1 12.528 2h-1.135c-.012.029-.038.018-.06.02a9 9 0 0 0-.87.114 8.45 8.45 0 0 0-5.177 3.104 8.36 8.36 0 0 0-1.84 4.709 8.6 8.6 0 0 0 .186 2.529 8.2 8.2 0 0 0 .624 1.79l.073.146a8.6 8.6 0 0 0 1.784 2.396 8.53 8.53 0 0 0 5.763 2.333c.1.001.127.026.126.128q-.004 1.31-.002 2.621.001.049.005.11l.063-.026a18 18 0 0 0 4.49-2.966q.4-.365.769-.762.157-.173.315-.342c.163-.175.304-.37.458-.553a9 9 0 0 0 .494-.663 11 11 0 0 0 .918-1.575q.2-.418.37-.847l.01-.016a10.3 10.3 0 0 0 .6-2.44q.054-.436.075-.877a8 8 0 0 0-.123-1.878m-9.19 2.82a2.5 2.5 0 0 1-.84 1.877l-.084.08a2.7 2.7 0 0 1-.933.481 4 4 0 0 1-.448.085.21.21 0 0 1-.235-.152l.001-.968c.006-.095-.032-.197.044-.28a.27.27 0 0 1 .138-.085 1.8 1.8 0 0 0 .494-.169 1.13 1.13 0 0 0 .538-.731l.036-.151-2.042-.003a.7.7 0 0 1-.174-.018.41.41 0 0 1-.307-.386q-.002-1.543.002-3.087a.47.47 0 0 1 .138-.436.4.4 0 0 1 .257-.102h3.001a.416.416 0 0 1 .4.527.4.4 0 0 1 .016.153c0 1.121.007 2.243-.002 3.364m5.303.004a2.56 2.56 0 0 1-1.556 2.328q-.035.016-.069.035l-.038.01-.021.013a5 5 0 0 1-.59.129.216.216 0 0 1-.269-.217l-.003-.322.006-.578q-.002-.063-.003-.127c0-.147.057-.21.241-.252a1.3 1.3 0 0 0 .634-.297 1.26 1.26 0 0 0 .377-.74l-1.885-.003h-.206a.42.42 0 0 1-.432-.44q0-1.525.002-3.049l-.001-.03a.43.43 0 0 1 .203-.45.4.4 0 0 1 .213-.059h2.982a.416.416 0 0 1 .399.527.4.4 0 0 1 .017.153z" })
), uH = h(e8), l8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.919 10.653a503 503 0 0 1-4.023-2.323l-.003-.002L4.64 1.253a1.68 1.68 0 0 0-1.408-.16l-.076.03a1.4 1.4 0 0 0-.173.07 1.52 1.52 0 0 0-.738 1.364v18.986a1.44 1.44 0 0 0 .692 1.27 1 1 0 0 0 .155.064 1 1 0 0 0 .087.035 1.4 1.4 0 0 0 .446.083 1.7 1.7 0 0 0 .831-.232l12.438-7.182 4.021-2.322a1.53 1.53 0 0 0 .842-1.334 1.49 1.49 0 0 0-.837-1.272M4.244 19.839V4.102l7.94 7.859Zm5.018-2.162 4.344-4.31 1.15 1.139zm4.342-7.125L9.206 6.2l5.554 3.207Zm2.947 2.917-1.526-1.51 1.528-1.516c.72.419 1.843 1.07 2.616 1.515Z" })
), VH = h(l8), r8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.602 10.004a1 1 0 0 0-.984-.822H12.2a1 1 0 0 0-1 1v3.868a1 1 0 0 0 1 1h3.962a3.65 3.65 0 0 1-1.131 1.187 5.06 5.06 0 0 1-2.831.785 4.935 4.935 0 0 1-4.646-3.437v-.002a4.9 4.9 0 0 1 0-3.167v-.002A4.94 4.94 0 0 1 12.2 6.978a4.38 4.38 0 0 1 3.131 1.217 1 1 0 0 0 1.399-.015l2.868-2.868a1 1 0 0 0-.025-1.439A10.62 10.62 0 0 0 12.2 1a10.95 10.95 0 0 0-9.829 6.059l-.001.002A10.9 10.9 0 0 0 1.2 12a11.1 11.1 0 0 0 1.17 4.94l.001.001A10.95 10.95 0 0 0 12.2 23a10.53 10.53 0 0 0 7.295-2.687l.001-.001a10.79 10.79 0 0 0 3.304-8.084 12.5 12.5 0 0 0-.198-2.224M12.2 3a8.7 8.7 0 0 1 5.209 1.673l-1.454 1.453A6.46 6.46 0 0 0 12.2 4.978a6.89 6.89 0 0 0-5.99 3.55L5.142 7.7l-.585-.454A8.95 8.95 0 0 1 12.2 3M3.68 14.903a9.03 9.03 0 0 1 0-5.806l1.782 1.382a6.85 6.85 0 0 0 0 3.042ZM12.2 21a8.95 8.95 0 0 1-7.644-4.246l.379-.294 1.276-.99a6.89 6.89 0 0 0 5.989 3.552 7.3 7.3 0 0 0 3.306-.75l1.691 1.313A8.9 8.9 0 0 1 12.2 21m6.526-2.76-.183-.143-1.377-1.069a5.6 5.6 0 0 0 1.4-2.796 1 1 0 0 0-.984-1.182H13.2v-1.868h7.549q.051.518.051 1.046a9.05 9.05 0 0 1-2.074 6.011" })
), SH = h(r8), h8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.49 10.19-1-.55-9-5h-.11a1 1 0 0 0-.19-.06h-.37a1 1 0 0 0-.2.06h-.11l-9 5a1 1 0 0 0 0 1.74L4 12.76v4.74a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-4.74l2-1.12v2.86a1 1 0 0 0 2 0v-3.44a1 1 0 0 0-.51-.87M16 17.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3.63l4.51 2.5.15.06h.09a1 1 0 0 0 .25 0 1 1 0 0 0 .25 0h.09a.5.5 0 0 0 .15-.06l4.51-2.5Zm-5-3.14L4.06 10.5 11 6.64l6.94 3.86Z" })
), LH = h(h8), o8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6 13H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1m-1 8H3v-6h2ZM22 9h-4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1m-1 12h-2V11h2ZM14 1h-4a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1m-1 20h-2V3h2Z" })
), ZH = h(o8), n8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M11 20H4v-4h7Zm0-6H4v-4h7Zm9 6h-7v-4h7Zm0-6h-7v-4h7Zm0-6H4V4h16Z" })
), BH = h(n8), w8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M8 20H4V4h4Zm6 0h-4V4h4Zm6 0h-4V4h4Z" })
), FH = h(w8), v8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.21 10.54a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41 3.08 3.08 0 0 0-4.24 0 1 1 0 1 0 1.41 1.41 1 1 0 0 1 1.42 0M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m3-11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 4H9a1 1 0 0 0 0 2 3 3 0 0 0 6 0 1 1 0 0 0 0-2m-3 3a1 1 0 0 1-1-1h2a1 1 0 0 1-1 1" })
), RH = h(v8), m8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m5.62-10.87a3.08 3.08 0 0 0-4.24 0 1 1 0 0 0 1.41 1.41 1 1 0 0 1 1.42 0 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41M9 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m6 2H9a1 1 0 0 0 0 2 3 3 0 0 0 6 0 1 1 0 0 0 0-2m-3 3a1 1 0 0 1-1-1h2a1 1 0 0 1-1 1" })
), UH = h(m8), c8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m3-9a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m3-7H9a1 1 0 0 0-1 1 4 4 0 0 0 8 0 1 1 0 0 0-1-1m-3 3a2 2 0 0 1-1.73-1h3.46A2 2 0 0 1 12 16m3-7a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), $H = h(c8), s8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 11h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), yH = h(s8), g8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 13.17V13a8 8 0 0 0-2.42-5.74 7.84 7.84 0 0 0-3.18-1.88h-.05A8.2 8.2 0 0 0 11.76 5 8.21 8.21 0 0 0 4 13.17 3 3 0 0 0 5 19h14a3 3 0 0 0 1-5.83M19 17H5a1 1 0 0 1 0-2h2a1 1 0 0 0 0-2H6a6.41 6.41 0 0 1 3-5.15V11a1 1 0 0 0 2 0V7.09a7 7 0 0 1 .82-.09H12a5.6 5.6 0 0 1 1 .1V11a1 1 0 0 0 2 0V7.82a6.7 6.7 0 0 1 1.18.87A6 6 0 0 1 18 13h-1a1 1 0 0 0 0 2h2a1 1 0 0 1 0 2" })
), kH = h(g8), i8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 14.86v-.05a2.6 2.6 0 0 0-.1-.57l-1.64-9.73a3 3 0 0 0-3-2.51H6.69a3 3 0 0 0-2.95 2.51l-1.62 9.71a2.6 2.6 0 0 0-.1.57v.05C2 14.91 2 15 2 15v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4.14M5.71 4.83a1 1 0 0 1 1-.83h10.6a1 1 0 0 1 1 .83l1.2 7.22A2.6 2.6 0 0 0 19 12H5a2.6 2.6 0 0 0-.49.05ZM20 19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3.92l.08-.46A1 1 0 0 1 5 14h14a1 1 0 0 1 .92.62l.08.46Zm-3-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), bH = h(i8), d8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.293 20.293a1 1 0 1 0 1.414 0 1 1 0 0 0-1.414 0m-3-3a1 1 0 1 0 1.414 0 1 1 0 0 0-1.414 0m4-1a1 1 0 1 0 1.414 0 1 1 0 0 0-1.414 0M16.15 2.002a7.067 7.067 0 0 0-7.284 7.063v.016l-1.77 3.758A1 1 0 0 0 8 14.267h.866v1.8A1.935 1.935 0 0 0 10.8 18h.867v1.8a1 1 0 0 0 2 0v-1.814A.994.994 0 0 0 13.6 16l-.833.02a1 1 0 0 0-.1-.02 1 1 0 0 0-.128.026l-1.673.04v-2.8a1 1 0 0 0-1-1h-.289l1.205-2.558a1 1 0 0 0 .095-.468l-.01-.174a5.03 5.03 0 0 1 1.537-3.635 5.1 5.1 0 0 1 3.686-1.429A5.24 5.24 0 0 1 21 9.322l-1.833 6.987a1 1 0 0 0 .006.533l.932 3.235a1 1 0 0 0 .961.723 1 1 0 0 0 .278-.04 1 1 0 0 0 .683-1.237l-.856-2.97 1.796-6.763A1 1 0 0 0 23 9.533v-.212a7.25 7.25 0 0 0-6.85-7.318Z" })
), TH = h(d8), p8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.23 2.003a7.37 7.37 0 0 0-5.453 2.114A7.44 7.44 0 0 0 5.5 9.465l-1.844 2.998a1 1 0 0 0-.156.52v.04a1 1 0 0 0 .07.347l1.44 3.873a1 1 0 0 0 .043.099A2.98 2.98 0 0 0 7.736 19H8.5v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 .321-.053l3.7-1.256a1 1 0 0 0 .018.12l1 3.466A1 1 0 0 0 18.5 22a1 1 0 0 0 .277-.04 1 1 0 0 0 .684-1.237l-.924-3.2 1.93-7.267A1 1 0 0 0 20.5 10v-.228a7.7 7.7 0 0 0-7.27-7.769M11.5 17H7.736a1 1 0 0 1-.874-.513L5.938 14H11.5Zm5.523-1.591L13.5 16.605V13.72l4.345-1.448Zm1.412-5.389a1 1 0 0 0-.251.031L12.337 12H6.29l1.074-1.747a1 1 0 0 0 .148-.562L7.5 9.5a5.46 5.46 0 0 1 1.67-3.947 5.52 5.52 0 0 1 4-1.55 5.685 5.685 0 0 1 5.33 5.77Z" })
), PH = h(p8), f8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.23 2.003a7.37 7.37 0 0 0-5.453 2.114A7.44 7.44 0 0 0 5.5 9.5v.03l-1.904 4.044A1 1 0 0 0 4.5 15h1v2a2 2 0 0 0 2 2h1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0 0-2h-3v-3a1 1 0 0 0-1-1h-.424l1.34-2.844a1 1 0 0 0 .095-.465L7.5 9.5a5.46 5.46 0 0 1 1.67-3.947 5.53 5.53 0 0 1 4-1.55 5.685 5.685 0 0 1 5.33 5.77l-1.967 7.504a1 1 0 0 0 .006.534l1 3.466A1 1 0 0 0 18.5 22a1 1 0 0 0 .277-.04 1 1 0 0 0 .684-1.237l-.924-3.2 1.93-7.267A1 1 0 0 0 20.5 10v-.228a7.7 7.7 0 0 0-7.27-7.769" })
), DH = h(f8), E8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.07 5.936a9.95 9.95 0 0 0-9.39-2.671 1 1 0 0 0 .44 1.95A8.02 8.02 0 0 1 20 13h-.34a1 1 0 0 0 0 2H20v.34a1 1 0 1 0 2 0V13a9.89 9.89 0 0 0-2.93-7.064M3.706 2.293a1 1 0 0 0-1.414 1.414l2.435 2.435A9.96 9.96 0 0 0 2 13v7a1 1 0 0 0 1 1h3a3.003 3.003 0 0 0 3-3v-2a3.003 3.003 0 0 0-3-3H4a7.96 7.96 0 0 1 2.145-5.441L15 16.414V18a3.003 3.003 0 0 0 3 3h1.586l.707.707a1 1 0 0 0 1.414-1.414ZM6 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4v-4Z" })
), qH = h(E8), x8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 13.18V11a8 8 0 0 0-16 0v2.18A3 3 0 0 0 2 16v2a3 3 0 0 0 3 3h3a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6v-2a6 6 0 0 1 12 0v2h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3a3 3 0 0 0 3-3v-2a3 3 0 0 0-2-2.82M7 15v4H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm13 3a1 1 0 0 1-1 1h-2v-4h2a1 1 0 0 1 1 1Z" })
), IH = h(x8), A8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 3A10 10 0 0 0 2 13v7a1 1 0 0 0 1 1h3a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3H4a8 8 0 0 1 16 0h-2a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h3a1 1 0 0 0 1-1v-7A10 10 0 0 0 12 3M6 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4v-4Zm14 4h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2Z" })
), WH = h(A8), M8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.16 4.61A6.27 6.27 0 0 0 12 4a6.27 6.27 0 0 0-8.16 9.48l7.45 7.45a1 1 0 0 0 1.42 0l7.45-7.45a6.27 6.27 0 0 0 0-8.87m-1.41 7.46L12 18.81l-6.75-6.74a4.28 4.28 0 0 1 3-7.3 4.25 4.25 0 0 1 3 1.25 1 1 0 0 0 1.42 0 4.27 4.27 0 0 1 6 6.05Z" })
), GH = h(M8), H8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.16 4.61A6.27 6.27 0 0 0 12 4a6.27 6.27 0 0 0-8.16 9.48l7.45 7.46a1 1 0 0 0 1.42 0l7.45-7.46a6.27 6.27 0 0 0 0-8.87m-1.41 7.45L12 18.81l-6.75-6.75a4.26 4.26 0 0 1 5.54-6.45l-1.71 4a1 1 0 0 0 0 .83 1 1 0 0 0 .65.53l2.77.7-1.4 2.89a1 1 0 0 0 .46 1.34 1 1 0 0 0 .44.1 1 1 0 0 0 .9-.56l2-4a1 1 0 0 0 0-.86 1.05 1.05 0 0 0-.67-.55l-2.83-.71 1.45-3.39a4.26 4.26 0 0 1 5.92 6.13Z" })
), OH = h(H8), C8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 11h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m6.16-6A6.29 6.29 0 0 0 12 4.41a6.27 6.27 0 0 0-8.16 9.48l6 6.05a3 3 0 0 0 4.24 0l6-6.05A6.27 6.27 0 0 0 20.16 5m-1.41 7.46-6 6a1 1 0 0 1-1.42 0l-6-6a4.29 4.29 0 0 1 0-6 4.27 4.27 0 0 1 6 0 1 1 0 0 0 1.42 0 4.27 4.27 0 0 1 6 0 4.29 4.29 0 0 1 0 6.02Z" })
), NH = h(C8), u8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11h-3.94a.8.8 0 0 0-.21 0h-.17a1 1 0 0 0-.15.1 2 2 0 0 0-.16.12 1 1 0 0 0-.09.13 1.3 1.3 0 0 0-.12.2l-1.6 4.41-4.17-11.3a1 1 0 0 0-1.88 0L6.2 11H3a1 1 0 0 0 0 2h4.3a1 1 0 0 0 .16-.1 2 2 0 0 0 .16-.12l.09-.13a1 1 0 0 0 .12-.2l1.62-4.53 4.16 11.42a1 1 0 0 0 .94.66 1 1 0 0 0 .94-.66l2.3-6.34H21a1 1 0 0 0 0-2" })
), QH = h(u8), V8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.16 5A6.29 6.29 0 0 0 12 4.41a6.27 6.27 0 0 0-8.16 9.48l6 6.05a3 3 0 0 0 4.24 0l6-6.05A6.27 6.27 0 0 0 20.16 5m-1.41 7.46-6 6a1 1 0 0 1-1.42 0l-6-6a4.29 4.29 0 0 1 0-6 4.27 4.27 0 0 1 6 0 1 1 0 0 0 1.42 0 4.27 4.27 0 0 1 6 6" })
), KH = h(V8), S8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.16 5A6.29 6.29 0 0 0 12 4.36a6.27 6.27 0 0 0-8.16 9.48l6.21 6.22a2.78 2.78 0 0 0 3.9 0l6.21-6.22a6.27 6.27 0 0 0 0-8.84m-1.41 7.46-6.21 6.21a.76.76 0 0 1-1.08 0l-6.21-6.24a4.29 4.29 0 0 1 0-6 4.27 4.27 0 0 1 6 0 1 1 0 0 0 1.42 0 4.27 4.27 0 0 1 6 0 4.29 4.29 0 0 1 .08 6Z" })
), jH = h(S8), L8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 10.41h-2.5a1 1 0 0 0-.71.3L16.55 12l-2.8-3.19a1 1 0 0 0-1.46 0l-1.7 1.7H9a1 1 0 0 0 0 2h2a1 1 0 0 0 .71-.29L13 10.88l2.8 3.19a1 1 0 0 0 .72.34 1 1 0 0 0 .71-.29l1.7-1.71H21a1 1 0 0 0 0-2m-7.39 5.3-1.9 1.9a1 1 0 0 1-1.42 0L5.08 12.4a3.69 3.69 0 0 1 0-5.22 3.69 3.69 0 0 1 5.21 0 1 1 0 0 0 1.42 0 3.78 3.78 0 0 1 5.21 0 4 4 0 0 1 .58.75 1 1 0 0 0 1.72-1 6 6 0 0 0-.88-1.13A5.68 5.68 0 0 0 11 5.17a5.68 5.68 0 0 0-9 4.62 5.62 5.62 0 0 0 1.67 4L8.88 19a3 3 0 0 0 4.24 0L15 17.12a1 1 0 0 0 0-1.41 1 1 0 0 0-1.39 0" })
), JH = h(L8), Z8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.022 2h-2a1 1 0 0 0 0 2v2H7.838a3 3 0 0 0 .184-1 3 3 0 0 0-5.598-1.5 1 1 0 1 0 1.732 1 1 1 0 0 1 .866-.5 1 1 0 0 1 0 2 1 1 0 0 0 0 2 1 1 0 0 1 0 2 1 1 0 0 1-.866-.5 1 1 0 1 0-1.732 1A3 3 0 0 0 8.022 9a3 3 0 0 0-.184-1h1.184v3a1 1 0 0 0 2 0V4a1 1 0 0 0 0-2m3 5h1a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V8a3.003 3.003 0 0 0-3-3h-1a1 1 0 0 0 0 2m-4 9h-1a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3.003 3.003 0 0 0 3 3h1a1 1 0 0 0 0-2m11-1a1 1 0 0 0 0-2h-3v-.5a1 1 0 0 0-2 0v.5h-3a1 1 0 0 0 0 2h5.184a6.7 6.7 0 0 1-1.225 2.527 6.7 6.7 0 0 1-.63-.983 1 1 0 1 0-1.779.912 8.7 8.7 0 0 0 .96 1.468 6.6 6.6 0 0 1-2.426 1.099 1 1 0 0 0 .427 1.954 8.6 8.6 0 0 0 3.445-1.622 8.7 8.7 0 0 0 3.469 1.622 1 1 0 1 0 .43-1.954 6.7 6.7 0 0 1-2.446-1.09A8.74 8.74 0 0 0 20.244 15Z" })
), YH = h(Z8), B8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.5 13.9c0-.2-.2-.4-.4-.4-.1 0-.2 0-.3.1-1.3 1.1-3 1.7-4.8 1.7-1.7 0-3.4-.6-4.8-1.7-.1-.1-.2-.1-.3-.1-.2 0-.4.2-.4.4s.1.3.2.5C8 16 10 16.9 12 16.8c2 .1 3.9-.8 5.2-2.4.2-.2.2-.3.3-.5m2.7 6.9c-.8-.4-1.4-1.2-1.7-2-.1-.2 0-.3.1-.4 2.1-1.5 3.3-3.9 3.3-6.4 0-4.8-4.5-8.6-10-8.6s-10 3.9-10 8.6c0 4.8 4.5 8.6 10 8.6.7 0 1.4-.1 2.1-.2.1 0 .3 0 .4.1 1.6.9 3.4 1.5 5.2 1.5.4.1.7-.2.8-.6v-.1c.1-.2 0-.4-.2-.5m-2.7-.8v.1c0 .1-.1.1-.1.1-1.1-.3-2-.8-2.9-1.5-.1-.1-.3-.1-.5-.1-.7.2-1.4.2-2.1.2-4.6 0-8.3-3.1-8.3-6.9S7.3 5 11.9 5s8.3 3.1 8.3 6.9c-.1 2.3-1.4 4.4-3.4 5.5-.2.1-.3.3-.3.4.3.9.6 1.6 1 2.2" })
), XH = h(B8), F8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.44 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 1 1 11.44 20a1 1 0 1 0 0 2 10 10 0 1 0 0-20m0 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-1V9a1 1 0 0 0-1-1" })
), _H = h(F8), R8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 1 1 4 12a1 1 0 0 0-2 0A10 10 0 1 0 12 2m0 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-1V9a1 1 0 0 0-1-1" })
), zH = h(R8), U8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20 8-6-5.26a3 3 0 0 0-4 0L4 8a3 3 0 0 0-1 2.26V19a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8.75A3 3 0 0 0 20 8m-6 12h-4v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm5-1a1 1 0 0 1-1 1h-2v-5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1v-8.75a1 1 0 0 1 .34-.75l6-5.25a1 1 0 0 1 1.32 0l6 5.25a1 1 0 0 1 .34.75Z" })
), aC = h(U8), $8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.66 10.25-9-8a1 1 0 0 0-1.32 0l-9 8a1 1 0 0 0-.27 1.11A1 1 0 0 0 3 12h1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9h1a1 1 0 0 0 .93-.64 1 1 0 0 0-.27-1.11M13 20h-2v-3a1 1 0 0 1 2 0Zm5 0h-3v-3a3 3 0 0 0-6 0v3H6v-8h12ZM5.63 10 12 4.34 18.37 10Z" })
), tC = h($8), y8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 10h-2V7a1 1 0 0 0-1-1h-5V3a1 1 0 0 0-2 0v3H6a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8v3a1 1 0 0 0 2 0v-3h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M7 8h10v2H7Zm13 8H4v-4h16Z" })
), eC = h(y8), k8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 10h-5V7a1 1 0 0 0-1-1H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 2 0v-3h17a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M4 8h10v2H4Zm16 8H4v-4h16Z" })
), lC = h(k8), b8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2a1 1 0 0 0-1 1v3H9a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h17v3a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1m-1 14H4v-4h16Zm0-6H10V8h10Z" })
), rC = h(b8), T8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 5h-1V3a1 1 0 0 0-2 0v2h-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1v2a1 1 0 0 0 2 0v-2h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1m-1 12h-2V7h2ZM11 4H9V3a1 1 0 0 0-2 0v1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2v1a1 1 0 0 0 2 0v-1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 14H6V6h4Z" })
), hC = h(T8), P8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 4H6V3a1 1 0 0 0-2 0v18a1 1 0 0 0 2 0v-1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 14H6V6h4Zm9-13h-3V3a1 1 0 0 0-2 0v18a1 1 0 0 0 2 0v-2h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1m-1 12h-2V7h2Z" })
), oC = h(P8), D8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2a1 1 0 0 0-1 1v1h-5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5v1a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1m-1 16h-4V6h4ZM9 2a1 1 0 0 0-1 1v2H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1M8 17H6V7h2Z" })
), nC = h(D8), q8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 6a1 1 0 0 0-1 1v4h-4V7a1 1 0 0 0-2 0v10a1 1 0 0 0 2 0v-4h4v4a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m4-4H5a3.003 3.003 0 0 0-3 3v14a3.003 3.003 0 0 0 3 3h14a3.003 3.003 0 0 0 3-3V5a3.003 3.003 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), wC = h(q8), I8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 7a1 1 0 0 0-1 1v3h-4V8a1 1 0 0 0-2 0v8a1 1 0 0 0 2 0v-3h4v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1m-3-5a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8" })
), vC = h(I8), W8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.5 16.5h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m0-4h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m-5 4h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m0-4h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m14-6h-3v-4a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v4h-3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1m-1 14h-17v-12h3a1 1 0 0 0 1-1v-4h9v4a1 1 0 0 0 1 1h3Zm-4-8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm-3-5.5H13v-.5a1 1 0 0 0-2 0V7h-.5a1 1 0 0 0 0 2h.5v.5a1 1 0 0 0 2 0V9h.5a1 1 0 0 0 0-2m4 9.5h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2" })
), mC = h(W8), G8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.992 21.002h-1v-1.667a5 5 0 0 0-.3-1.678 1 1 0 0 0-.036-.084 5 5 0 0 0-.664-1.237l-1.4-1.867a3.02 3.02 0 0 1-.6-1.801v-1.01a3.02 3.02 0 0 1 .878-2.12l.657-.658a4.95 4.95 0 0 0 1.397-2.839c0-.013.008-.025.008-.04l-.003-.013a5 5 0 0 0 .063-.643V3.002h1a1 1 0 0 0 0-2h-14a1 1 0 0 0 0 2h1v2.343a5 5 0 0 0 .063.643l-.003.014c0 .014.007.026.008.04A4.95 4.95 0 0 0 7.456 8.88l.657.657a3.02 3.02 0 0 1 .879 2.121v1.01a3.02 3.02 0 0 1-.6 1.8l-1.4 1.868a5 5 0 0 0-.665 1.237 1 1 0 0 0-.036.084 5 5 0 0 0-.3 1.678v1.667h-1a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2m-11-16v-2h8v2Zm.878 2.464a3 3 0 0 1-.377-.464h6.997a3 3 0 0 1-.377.464l-.657.657a4.96 4.96 0 0 0-1.422 2.879H10.95a4.96 4.96 0 0 0-1.422-2.879Zm1.122 8.202a5.04 5.04 0 0 0 .988-2.666h2.023a5.03 5.03 0 0 0 .989 2.666l1 1.334h-6Zm6 5.334h-8v-1.667a3 3 0 0 1 .027-.333h7.945a3 3 0 0 1 .028.333Z" })
), cC = h(G8), O8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.664 10.252-9-8a1 1 0 0 0-1.328 0l-9 8a1 1 0 0 0 1.328 1.496L4 11.449V21a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9.551l.336.299a1 1 0 0 0 1.328-1.496M9.184 20a2.982 2.982 0 0 1 5.632 0Zm1.316-5.5A1.5 1.5 0 1 1 12 16a1.5 1.5 0 0 1-1.5-1.5M18 20h-1.101a5 5 0 0 0-2.259-3.228 3.47 3.47 0 0 0 .86-2.272 3.5 3.5 0 0 0-7 0 3.47 3.47 0 0 0 .86 2.272A5 5 0 0 0 7.1 20H6V9.671l6-5.333 6 5.333Z" })
), sC = h(O8), N8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.952 8h6.986l-.177 2h-4.77a1 1 0 0 0 0 2h4.593l-.264 2.977-2.329.528-2.328-.529-.096-1.064a1 1 0 1 0-1.992.177l.16 1.79a1 1 0 0 0 .775.887l3.26.74a1 1 0 0 0 .443 0l3.26-.74a1 1 0 0 0 .775-.888l.432-4.868.002-.01-.001-.004.346-3.908A1 1 0 0 0 16.031 6H7.952a1 1 0 0 0 0 2m12.702-5.674A1 1 0 0 0 19.916 2H4.066a1 1 0 0 0-.996 1.09l1.444 16.194a1 1 0 0 0 .727.874l6.473 1.805a1 1 0 0 0 .537 0l6.49-1.812a1 1 0 0 0 .728-.874l1.443-16.188a1 1 0 0 0-.258-.763M17.538 18.41l-5.556 1.551-5.538-1.545L5.16 4h13.664Z" })
), gC = h(N8), Q8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m3.195 2 1.602 17.994L11.99 22l7.212-2.013L20.805 2Zm14.281 4.123-.534 5.994.002.033-.002.074-.38 4.19-.041.373L12 18.037l-.004.004-4.512-1.258-.306-3.465H9.39l.157 1.762 2.453.665H12l2.461-.674.26-2.869H9.577l-.044-.485-.101-1.136-.052-.61h5.538l.202-2.232H6.682l-.044-.485-.1-1.137-.053-.61h11.044Zm0 0" })
), iC = h(Q8), K8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.468 2.325A1 1 0 0 0 20.73 2H3.27a1 1 0 0 0-.996 1.089l1.52 17a1 1 0 0 0 .728.874l7.2 2a1 1 0 0 0 .268.037 1 1 0 0 0 .267-.036l7.22-2a1 1 0 0 0 .729-.875l1.52-17a1 1 0 0 0-.258-.764m-3.193 16.896-6.284 1.741-6.266-1.74L4.363 4h15.274ZM7.82 13h6.895l-.327 3.271-2.568.917-3.164-1.13a1 1 0 1 0-.673 1.884l3.5 1.25a1 1 0 0 0 .673 0l3.5-1.25a1 1 0 0 0 .659-.842l.5-5a1 1 0 0 0-.995-1.1H8.725l-.3-3h7.895a1 1 0 0 0 0-2h-9a1 1 0 0 0-.995 1.1l.5 5a1 1 0 0 0 .995.9" })
), dC = h(K8), j8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m3.183 2 1.604 18 7.202 2 7.222-2.002L20.818 2Zm14.142 5.887H8.877l.202 2.261h8.045l-.606 6.778L12 18.178l-.01.004-4.522-1.256-.31-3.466h2.216l.157 1.76 2.46.664h.001l2.463-.665.256-2.863H7.06L6.464 5.68h11.059Z" })
), pC = h(j8), J8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m9-2h-1.07A8 8 0 0 0 13 4.07V3a1 1 0 0 0-2 0v1.07A8 8 0 0 0 4.07 11H3a1 1 0 0 0 0 2h1.07A8 8 0 0 0 11 19.93V21a1 1 0 0 0 2 0v-1.07A8 8 0 0 0 19.93 13H21a1 1 0 0 0 0-2m-9 7a6 6 0 1 1 6-6 6 6 0 0 1-6 6" })
), fC = h(J8), Y8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.6 10.9c.1.1.2.1.4.1h7c.6 0 1-.4 1-1 0-.2 0-.3-.1-.4l-3.5-7c-.3-.5-.9-.7-1.4-.4-.1.1-.3.2-.4.4l-3.5 7c-.2.4 0 1 .5 1.3m3.9-5.7L19.4 9h-3.8zM6.5 2C4 2 2 4 2 6.5S4 11 6.5 11 11 9 11 6.5 9 2 6.5 2m0 7C5.1 9 4 7.9 4 6.5S5.1 4 6.5 4 9 5.1 9 6.5 7.9 9 6.5 9m4.2 4.3c-.4-.4-1-.4-1.4 0l-2.8 2.8-2.8-2.8c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l2.8 2.8-2.8 2.8c-.4.4-.4 1 0 1.4s1 .4 1.4 0l2.8-2.8 2.8 2.8c.4.4 1 .4 1.4 0s.4-1 0-1.4l-2.8-2.8 2.8-2.8c.4-.4.4-1 0-1.4M21 13h-7c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1h7c.6 0 1-.4 1-1v-7c0-.6-.4-1-1-1m-1 7h-5v-5h5z" })
), EC = h(Y8), X8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.9 9.6c-.2-.5-.8-.7-1.3-.5l-2.9 1.4-2.1-2.1-2.1-2.1 1.4-2.9c.2-.5 0-1.1-.5-1.3s-1.1 0-1.3.5l-1.5 3.1-6.4 1c-.4.1-.7.4-.8.8L2 19.1c-.1.3 0 .7.3.9L4 21.7c.2.2.5.3.7.3h.2l11.6-2.4c.4-.1.7-.4.8-.8l1-6.4 3.1-1.5c.5-.2.7-.8.5-1.3m-6.5 8.2-9.8 2 3.7-3.7c1.5.7 3.3.1 4-1.4s.1-3.3-1.4-4c-1.1-.5-2.5-.3-3.4.6s-1.1 2.3-.6 3.4l-3.7 3.7 2-9.8 5.8-1 2.2 2.2 2.2 2.2zm-5.8-4.4c0-.3.1-.5.3-.7.4-.4 1-.4 1.4 0s.4 1 0 1.4-1 .4-1.4 0c-.2-.2-.3-.5-.3-.7" })
), xC = h(X8), _8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 20.29-.93-.93-.09-.1-.06-.07-.5-.5-.13-.07-5.18-5.2-.09-.08-3.2-3.21-.1-.13-7.72-7.71a1 1 0 0 0-1.42 1.42l1 1A3 3 0 0 0 3 6v12a3 3 0 0 0 3 3h12a2.9 2.9 0 0 0 1.27-.31s0 0 .05 0l.95 1a1 1 0 0 0 1.42 0 1 1 0 0 0 .02-1.4M5 6.41l3.24 3.24a2.8 2.8 0 0 0-.67.48L5 12.71ZM6 19a1 1 0 0 1-1-1v-2.46l4-4a.81.81 0 0 1 1.1 0L17.59 19ZM9.66 5H18a1 1 0 0 1 1 1v5.94a1 1 0 1 0-1.42 1.42l1.74 1.74a1 1 0 0 0 1.42 0 1 1 0 0 0 .29-.72V6a3 3 0 0 0-3-3H9.66a1 1 0 0 0 0 2" })
), AC = h(_8), z8 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.54 2.46A5 5 0 1 0 22 6a5 5 0 0 0-1.46-3.54M14 6a3 3 0 0 1 3-3 3 3 0 0 1 1.29.3l-4 4A3 3 0 0 1 14 6m5.12 2.12a3.08 3.08 0 0 1-3.4.57l4-4A3 3 0 0 1 20 6a3 3 0 0 1-.88 2.12M19 13a1 1 0 0 0-1 1v.39l-1.48-1.49a2.87 2.87 0 0 0-3.93 0l-.7.71-2.48-2.49a2.87 2.87 0 0 0-3.93 0L4 12.61V7a1 1 0 0 1 1-1h4a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 .95-.17h.09A3 3 0 0 0 20 19.44a1.4 1.4 0 0 0 0-.22V14a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.89a.79.79 0 0 1 1.09 0l3.19 3.18L15.46 20Zm13-1a1 1 0 0 1-.18.54L13.3 15l.71-.7a.79.79 0 0 1 1.09 0l2.9 2.91Z" })
), MC = h(z8), a7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 14.54 19.21 12a1 1 0 0 0-1.42 0L15 14.84 12.21 12a1 1 0 0 0-1.42 0L8.5 14.34 6.21 12a1 1 0 0 0-1.42 0l-2.5 2.5a1 1 0 0 0-.21.33 1 1 0 0 0-.08.38V19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-3.75a1 1 0 0 0-.08-.38 1 1 0 0 0-.21-.33M20 19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3.34l1.5-1.5 2.29 2.3a1 1 0 0 0 1.42 0l2.29-2.3L14.29 17a1 1 0 0 0 1.42 0l2.79-2.8 1.5 1.5ZM19 2H5a3 3 0 0 0-3 3v5.26a1.2 1.2 0 0 0 0 .27v.1a1 1 0 0 0 1.66.31L5.5 9.16l2.29 2.3a1 1 0 0 0 1.42 0l2.29-2.3L14.29 12a1 1 0 0 0 1.42 0l2.79-2.8 1.77 1.78a1 1 0 0 0 1.66-.31.3.3 0 0 0 0-.09.9.9 0 0 0 .06-.28V5A3 3 0 0 0 19 2m1 5.84L19.21 7a1 1 0 0 0-1.42 0L15 9.84 12.21 7a1 1 0 0 0-1.42 0L8.5 9.34 6.21 7a1 1 0 0 0-1.42 0L4 7.84V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), HC = h(a7), t7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 2.3a1 1 0 0 0-1.41 0l-3.38 3.3-1.22-1.2a1 1 0 0 0-1.4 1.43l1.92 1.88a1 1 0 0 0 1.4 0l4.08-4a1 1 0 0 0 .01-1.41M19 9a1 1 0 0 0-1 1v4.39l-1.48-1.48a2.77 2.77 0 0 0-3.93 0l-.7.7-2.48-2.49a2.79 2.79 0 0 0-3.93 0L4 12.6V7a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-9a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0l3.17 3.17 4.29 4.3Zm13-1a.9.9 0 0 1-.18.53L13.31 15l.7-.7a.78.78 0 0 1 1.1 0L18 17.22Z" })
), CC = h(t7), e7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.71 6.29a1 1 0 0 0-1.42 0L20 7.59V2a1 1 0 0 0-2 0v5.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l3 3a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l3-3a1 1 0 0 0 0-1.42M19 13a1 1 0 0 0-1 1v.38l-1.48-1.48a2.79 2.79 0 0 0-3.93 0l-.7.7-2.48-2.48a2.85 2.85 0 0 0-3.93 0L4 12.6V7a1 1 0 0 1 1-1h8a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0l3.17 3.17 4.3 4.3Zm13-1a.9.9 0 0 1-.18.53L13.31 15l.7-.7a.77.77 0 0 1 1.1 0L18 17.21Z" })
), uC = h(e7), l7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.737 3.751-2.42-2.42a1 1 0 0 0-1.414 0l-4.58 4.58a1 1 0 0 0-.293.707v2.42a1 1 0 0 0 1 1h2.42a1 1 0 0 0 .707-.293l4.58-4.58a1 1 0 0 0 0-1.414m-5.7 4.287H15.03V7.032l3.58-3.58 1.006 1.006ZM19 11a1 1 0 0 0-1 1v2.392l-1.48-1.48a2.78 2.78 0 0 0-3.929 0l-.698.697-2.486-2.486a2.777 2.777 0 0 0-3.924 0L4 12.606V7a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H5a3.003 3.003 0 0 0-3 3v12a3.003 3.003 0 0 0 3 3h12a3.003 3.003 0 0 0 3-3v-7a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.566l2.897-2.897a.8.8 0 0 1 1.096 0l3.168 3.167c.009.01.012.022.02.03L15.448 20Zm13-1a.97.97 0 0 1-.179.537l-4.514-4.514.698-.698a.78.78 0 0 1 1.1 0L18 17.22Z" })
), VC = h(l7), r7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 5.18V4a3 3 0 0 0-6 0v1.18A3 3 0 0 0 12 8v2a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3V8a3 3 0 0 0-2-2.82M16 4a1 1 0 0 1 2 0v1h-2Zm4 6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Zm-1 5a1 1 0 0 0-1 1v3a.9.9 0 0 1-.18.53l-8.41-8.41a2.86 2.86 0 0 0-3.93 0L4 12.6V7a1 1 0 0 1 1-1h5a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0L15.46 20Z" })
), SC = h(r7), h7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 4.008h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2M19 8a1 1 0 0 0-1 1v5.392l-1.48-1.48a2.78 2.78 0 0 0-3.929 0l-.698.697-2.486-2.486a2.777 2.777 0 0 0-3.924 0L4 12.606V7a1 1 0 0 1 1-1h8a1 1 0 0 0 0-2H5a3.003 3.003 0 0 0-3 3v12a3.003 3.003 0 0 0 3 3h12a3.003 3.003 0 0 0 3-3V9a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.566l2.897-2.897a.8.8 0 0 1 1.096 0l3.168 3.167c.009.01.012.022.02.03L15.448 20Zm13-1a.97.97 0 0 1-.179.537l-4.514-4.514.698-.698a.78.78 0 0 1 1.1 0L18 17.22Z" })
), LC = h(h7), o7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 10a1 1 0 0 0-1 1v3.38l-1.48-1.48a2.79 2.79 0 0 0-3.93 0l-.7.71-2.48-2.49a2.79 2.79 0 0 0-3.93 0L4 12.61V7a1 1 0 0 1 1-1h8a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12.22A2.79 2.79 0 0 0 4.78 22h12.44a2.9 2.9 0 0 0 .8-.12 2.74 2.74 0 0 0 2-2.65V11A1 1 0 0 0 19 10M5 20a1 1 0 0 1-1-1v-3.57l2.89-2.89a.78.78 0 0 1 1.1 0L15.46 20Zm13-1a1 1 0 0 1-.18.54L13.3 15l.71-.7a.77.77 0 0 1 1.1 0L18 17.21Zm3-15h-1V3a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0V6h1a1 1 0 0 0 0-2" })
), ZC = h(o7), n7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 13a1 1 0 0 0-1 1v.39l-1.48-1.48a2.77 2.77 0 0 0-3.93 0l-.7.7-2.48-2.49a2.86 2.86 0 0 0-3.93 0L4 12.6V7a1 1 0 0 1 1-1h8a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0l3.17 3.17 4.29 4.3Zm13-1a1 1 0 0 1-.18.53L13.31 15l.7-.7a.78.78 0 0 1 1.1 0L18 17.22Zm1-17a3 3 0 0 0-2.6 1.5 1 1 0 0 0 .37 1.37 1 1 0 0 0 1.36-.37A1 1 0 0 1 20 5a1 1 0 0 1-1 1 1 1 0 0 0 0 2 3 3 0 0 0 0-6m.38 7.08A1 1 0 0 0 18.8 9l-.18.06-.18.09-.15.13A1 1 0 0 0 18 10a1 1 0 0 0 .29.71 1 1 0 0 0 1.42 0A1 1 0 0 0 20 10a1 1 0 0 0-.62-.92" })
), BC = h(n7), w7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.5 1.5a1 1 0 0 0-1 1 5 5 0 1 0 .3 7.75 1 1 0 0 0-1.32-1.51 3 3 0 1 1 .25-4.25H18.5a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-.99m-3 12a1 1 0 0 0-1 1v.39L16 13.41a2.77 2.77 0 0 0-3.93 0l-.7.7-2.46-2.49a2.79 2.79 0 0 0-3.93 0L3.5 13.1V7.5a1 1 0 0 1 1-1h5a1 1 0 0 0 0-2h-5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1m-14 7a1 1 0 0 1-1-1v-3.57L6.4 13a.79.79 0 0 1 1.09 0l3.17 3.17L15 20.5Zm13-1a1 1 0 0 1-.18.53l-4.51-4.51.7-.7a.78.78 0 0 1 1.1 0l2.89 2.9Z" })
), FC = h(w7), v7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 11H2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1m-5.56 9 1.93-1.93a.3.3 0 0 1 .5 0L11.79 20ZM12 17.38l-.72-.71a2.41 2.41 0 0 0-3.33 0L4.61 20H3v-7h9ZM2 4.11a1 1 0 0 0 .86-.49A1.05 1.05 0 0 0 3.05 3 1 1 0 0 0 2 2a1 1 0 0 0-1 1v.1a1 1 0 0 0 1 1.01M9.91 4h.19a1 1 0 0 0 0-2h-.19a1 1 0 0 0 0 2M2 8.78a1 1 0 0 0 1-1v-.22a1 1 0 1 0-2 0v.22a1 1 0 0 0 1 1M14.09 2h-.19a1 1 0 0 0 0 2h.19a1 1 0 0 0 0-2M5.91 4h.19a1 1 0 0 0 0-2h-.19a1 1 0 0 0 0 2M22 6.4a1 1 0 0 0-1 1v.21a1 1 0 0 0 2 0V7.4a1 1 0 0 0-1-1M17.12 20h-.24a1 1 0 1 0 0 2h.24a1 1 0 0 0 0-2M21.9 2a1 1 0 0 0-.9 1 1 1 0 0 0 .1.42 1 1 0 0 0 1.9-.31V3a1.09 1.09 0 0 0-1.1-1m.1 8.9a1 1 0 0 0-1 1v.22a1 1 0 0 0 2 0v-.22a1 1 0 0 0-1-1M18.09 2h-.19a1 1 0 0 0 0 2h.19a1 1 0 0 0 0-2M22 20a.9.9 0 0 0-.44.11A1 1 0 0 0 21 21a1 1 0 0 0 1 1 1.09 1.09 0 0 0 1-1.1 1 1 0 0 0-1-.9m0-4.56a1 1 0 0 0-1 1v.22a1 1 0 1 0 2 0v-.26a1 1 0 0 0-1-1Z" })
), RC = h(v7), m7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 8.1a1 1 0 0 0 1-1v-.19a1 1 0 0 0-2 0v.19a1 1 0 0 0 1 1m0-4a1 1 0 0 0 .42-.1 1 1 0 0 0-.32-2H3a1.09 1.09 0 0 0-1 1.1 1 1 0 0 0 1 .95Zm17.39-.19A1 1 0 0 0 22 3a1 1 0 0 0-1-1h-.1a1 1 0 0 0-.51 1.86Zm-8.5.09h.22a1 1 0 0 0 0-2h-.22a1 1 0 0 0 0 2m-4.5 0h.21a1 1 0 0 0 0-2h-.21a1 1 0 0 0 0 2M21 20a1 1 0 0 0-.42.1 1 1 0 0 0 .32 1.9h.1a1.09 1.09 0 0 0 1-1.1 1 1 0 0 0-1-.9m-7-9a1 1 0 0 0-1-1H3.27A1 1 0 0 0 3 10a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10.1a1 1 0 0 0 .9-1.42Zm-2 9H5.52l3.91-3.9a.33.33 0 0 1 .47 0l2.1 2.09Zm0-4.63-.68-.69a2.35 2.35 0 0 0-3.31 0l-4 4V12h8Zm9 0a1 1 0 0 0-1 1v.21a1 1 0 0 0 2 0v-.18a1 1 0 0 0-1-1Zm0-9a1 1 0 0 0-1 1v.23a1 1 0 1 0 2 0v-.21a1 1 0 0 0-1-1Zm0 4.5a1 1 0 0 0-1 1v.22a1 1 0 0 0 2 0v-.22a1 1 0 0 0-1-.98ZM17.1 20h-.2a1 1 0 1 0 0 2h.2a1 1 0 0 0 0-2m-.49-16a1 1 0 0 0 0-2h-.21a1 1 0 1 0 0 2Z" })
), UC = h(m7), c7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 13a1 1 0 0 0-1 1v.39l-1.48-1.48a2.79 2.79 0 0 0-3.93 0l-.7.7-2.48-2.49a2.87 2.87 0 0 0-3.93 0L4 12.61V7a1 1 0 0 1 1-1h4a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.89a.79.79 0 0 1 1.09 0l3.17 3.17L15.45 20Zm13-1a1 1 0 0 1-.18.54L13.31 15l.7-.69a.77.77 0 0 1 1.1 0L18 17.22Zm3.71-8.71L20 8.57a4.31 4.31 0 1 0-6.72.79 4.27 4.27 0 0 0 3 1.26 4.34 4.34 0 0 0 2.29-.62l1.72 1.73a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.44M18 8a2.32 2.32 0 1 1 0-3.27A2.32 2.32 0 0 1 18 8" })
), $C = h(c7), s7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 7a2 2 0 0 0-1.18.39l-1.75-.8L19 5.71A2 2 0 0 0 20 6a2 2 0 1 0-2-2l-1.89.87A2 2 0 1 0 15 8.5a1.9 1.9 0 0 0 .92-.24l2.1 1A2 2 0 1 0 20 7m-1 6a1 1 0 0 0-1 1v.39l-1.48-1.48a2.77 2.77 0 0 0-3.93 0l-.7.7-2.48-2.49a2.79 2.79 0 0 0-3.93 0L4 12.6V7a1 1 0 0 1 1-1h5a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0l3.17 3.17 4.29 4.3Zm13-1a.9.9 0 0 1-.18.53L13.31 15l.7-.7a.78.78 0 0 1 1.1 0L18 17.22Z" })
), yC = h(s7), g7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.13 2.36a1 1 0 0 0-.84-.2 2.7 2.7 0 0 1-2.2-.47 1 1 0 0 0-1.18 0 2.7 2.7 0 0 1-2.2.47 1 1 0 0 0-.84.2 1 1 0 0 0-.37.78v3.31a4.63 4.63 0 0 0 1.84 3.7l1.57 1.16a1 1 0 0 0 1.18 0l1.57-1.16a4.63 4.63 0 0 0 1.84-3.7V3.14a1 1 0 0 0-.37-.78M20.5 6.45a2.62 2.62 0 0 1-1 2.09l-1 .72-1-.72a2.62 2.62 0 0 1-1-2.09V4.22a4.8 4.8 0 0 0 2-.54 4.8 4.8 0 0 0 2 .54Zm-2 7.05a1 1 0 0 0-1 1v.39L16 13.41a2.77 2.77 0 0 0-3.93 0l-.7.7-2.46-2.49a2.85 2.85 0 0 0-3.93 0L3.5 13.1V7.5a1 1 0 0 1 1-1h7a1 1 0 0 0 0-2h-7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1m-14 7a1 1 0 0 1-1-1v-3.57L6.4 13a.79.79 0 0 1 1.09 0l3.17 3.17L15 20.5Zm13-1a1 1 0 0 1-.18.53l-4.51-4.51.7-.7a.78.78 0 0 1 1.1 0l2.89 2.9Z" })
), kC = h(g7), i7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.5 4H10a1 1 0 0 0 0 2h9.5a1 1 0 0 1 1 1v6.76l-1.88-1.88a3 3 0 0 0-1.14-.71 1 1 0 1 0-.64 1.9.8.8 0 0 1 .36.23l3.31 3.29a.7.7 0 0 0 0 .15 1 1 0 0 0 0 .15 1 1 0 0 0 .13.18.5.5 0 0 0 .09.11 1 1 0 0 0 .2.14.6.6 0 0 0 .11.06.9.9 0 0 0 .37.08 1 1 0 0 0 1-1V7a3 3 0 0 0-2.91-3M3.21 2.29a1 1 0 0 0-1.42 1.42L3.18 5.1A3 3 0 0 0 2.5 7v10a3 3 0 0 0 3 3h12.59l1.7 1.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM4.5 7a1 1 0 0 1 .12-.46l2.72 2.71a3 3 0 0 0-1 .63L4.5 11.76Zm1 11a1 1 0 0 1-1-1v-2.42l3.3-3.29a1 1 0 0 1 1.4 0L15.91 18Z" })
), bC = h(i7), d7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 10a1 1 0 0 0-1 1v3.39l-1.48-1.48a2.77 2.77 0 0 0-3.93 0l-.7.7-2.48-2.49a2.79 2.79 0 0 0-3.93 0L4 12.6V7a1 1 0 0 1 1-1h8a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0l3.17 3.17 4.29 4.3Zm13-1a.9.9 0 0 1-.18.53L13.31 15l.7-.7a.78.78 0 0 1 1.1 0L18 17.22Zm2.41-14 1.3-1.29a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0L19 3.59 17.71 2.3a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41L17.59 5l-1.3 1.3a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0L19 6.42l1.29 1.29a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41Z" })
), TC = h(d7), p7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 13a1 1 0 0 0-1 1v.38l-1.48-1.48a2.79 2.79 0 0 0-3.93 0l-.7.7-2.48-2.48a2.85 2.85 0 0 0-3.93 0L4 12.6V7a1 1 0 0 1 1-1h7a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0l3.17 3.17 4.3 4.3Zm13-1a.9.9 0 0 1-.18.53L13.31 15l.7-.7a.77.77 0 0 1 1.1 0L18 17.21Zm4.71-14.71-3-3a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-3 3a1 1 0 0 0 1.42 1.42L18 4.41V10a1 1 0 0 0 2 0V4.41l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42" })
), PC = h(p7), f7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 .49-.05l.3-.07h.12l.37-.14.13-.07c.1-.06.21-.11.31-.18a4 4 0 0 0 .38-.32l.07-.09a3 3 0 0 0 .27-.32l.09-.13a2.3 2.3 0 0 0 .18-.35 1 1 0 0 0 .07-.15c.05-.12.08-.25.12-.38v-.15a2.6 2.6 0 0 0 .1-.6V5a3 3 0 0 0-3-3M5 20a1 1 0 0 1-1-1v-4.31l3.29-3.3a1 1 0 0 1 1.42 0l8.6 8.61Zm15-1a1 1 0 0 1-.07.36 1 1 0 0 1-.08.14 1 1 0 0 1-.09.12l-5.35-5.35.88-.88a1 1 0 0 1 1.42 0l3.29 3.3Zm0-5.14L18.12 12a3.08 3.08 0 0 0-4.24 0l-.88.88L10.12 10a3.08 3.08 0 0 0-4.24 0L4 11.86V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), DC = h(f7), E7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3M5 18a1 1 0 0 1-1-1v-2.42l3.3-3.29a1 1 0 0 1 1.4 0L15.41 18Zm15-1a1 1 0 0 1-1 1h-.77l-3.81-3.83.88-.88a1 1 0 0 1 1.4 0l3.3 3.29Zm0-3.24-1.88-1.87a3.06 3.06 0 0 0-4.24 0l-.88.88-2.88-2.88a3.06 3.06 0 0 0-4.24 0L4 11.76V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), qC = h(E7), x7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 15V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3M4 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4.36l-1.08-1.09a2.56 2.56 0 0 0-1.81-.75 2.58 2.58 0 0 0-1.81.75l-.91.91-.81-.81a2.93 2.93 0 0 0-4.11 0L4 9.85Zm.12 10.45A.94.94 0 0 1 4 15v-2.33l2.88-2.88a.91.91 0 0 1 1.29 0l.83.81Zm8.6-5.76a.52.52 0 0 1 .39-.17.52.52 0 0 1 .39.17l2.5 2.49V15a1 1 0 0 1-1 1H6.4ZM21 6a1 1 0 0 0-1 1v10a3 3 0 0 1-3 3H7a1 1 0 0 0 0 2h10a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1" })
), IC = h(x7), A7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m-9.71 1.71a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1 1 0 0 0-1.42-1.42L13 12.59V3a1 1 0 0 0-2 0v9.59l-2.29-2.3a1 1 0 1 0-1.42 1.42Z" })
), WC = h(A7), M7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.056 2h-14a3.003 3.003 0 0 0-3 3v14a3.003 3.003 0 0 0 3 3h14a3.003 3.003 0 0 0 3-3V5a3.003 3.003 0 0 0-3-3m-14 2h14a1 1 0 0 1 1 1v8H17.59a2 2 0 0 0-1.664.89L14.52 16H9.59l-1.406-2.11A2 2 0 0 0 6.52 13H4.056V5a1 1 0 0 1 1-1m14 16h-14a1 1 0 0 1-1-1v-4H6.52l1.406 2.11A2 2 0 0 0 9.59 18h4.93a2 2 0 0 0 1.664-.89L17.59 15h2.465v4a1 1 0 0 1-1 1" })
), GC = h(M7), H7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.55 9a1.1 1.1 0 0 0 .39.07h4a1 1 0 0 0 0-2h-1.59l3.29-3.29a1 1 0 1 0-1.41-1.41l-3.29 3.28V4.06a1 1 0 1 0-2 0v4a1.1 1.1 0 0 0 .07.39 1 1 0 0 0 .54.55m3.89 4c-.22 0-.45-.07-.67-.12a9.4 9.4 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.2 12.2 0 0 1-2.66-2 12.2 12.2 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10 10 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2-.76 3 3 0 0 0 1-2.25v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.34.75 1.06 1.06 0 0 1-.82.25A17 17 0 0 1 4.07 5.22a1.1 1.1 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79q.06.41.15.81a11 11 0 0 0 .46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.5 14.5 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .57-.52l.62-1.4a14 14 0 0 0 1.58.46q.4.09.81.15a1 1 0 0 1 .79 1Z" })
), OC = h(H7), C7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8m0-8.5a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m0-4a1.25 1.25 0 1 0 1.25 1.25A1.25 1.25 0 0 0 12 7.5" })
), NC = h(C7), u7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 10a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m0-4a1.25 1.25 0 1 0 1.25 1.25A1.25 1.25 0 0 0 12 6" })
), QC = h(u7), V7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 9.52A2.48 2.48 0 1 0 14.48 12 2.48 2.48 0 0 0 12 9.52m9.93-2.45a6.5 6.5 0 0 0-.42-2.26 4 4 0 0 0-2.32-2.32 6.5 6.5 0 0 0-2.26-.42C15.64 2 15.26 2 12 2s-3.64 0-4.93.07a6.5 6.5 0 0 0-2.26.42 4 4 0 0 0-2.32 2.32 6.5 6.5 0 0 0-.42 2.26C2 8.36 2 8.74 2 12s0 3.64.07 4.93a6.9 6.9 0 0 0 .42 2.27 3.9 3.9 0 0 0 .91 1.4 3.9 3.9 0 0 0 1.41.91 6.5 6.5 0 0 0 2.26.42C8.36 22 8.74 22 12 22s3.64 0 4.93-.07a6.5 6.5 0 0 0 2.26-.42 3.9 3.9 0 0 0 1.41-.91 3.9 3.9 0 0 0 .91-1.4 6.6 6.6 0 0 0 .42-2.27C22 15.64 22 15.26 22 12s0-3.64-.07-4.93m-2.54 8a5.7 5.7 0 0 1-.39 1.8A3.86 3.86 0 0 1 16.87 19a5.7 5.7 0 0 1-1.81.35H8.94A5.7 5.7 0 0 1 7.13 19a3.5 3.5 0 0 1-1.31-.86A3.5 3.5 0 0 1 5 16.87a5.5 5.5 0 0 1-.34-1.81V8.94A5.5 5.5 0 0 1 5 7.13a3.5 3.5 0 0 1 .86-1.31A3.6 3.6 0 0 1 7.13 5a5.7 5.7 0 0 1 1.81-.35h6.12a5.7 5.7 0 0 1 1.81.35 3.5 3.5 0 0 1 1.31.86A3.5 3.5 0 0 1 19 7.13a5.7 5.7 0 0 1 .35 1.81V12c0 2.06.07 2.27.04 3.06Zm-1.6-7.44a2.38 2.38 0 0 0-1.41-1.41A4 4 0 0 0 15 6H9a4 4 0 0 0-1.38.26 2.38 2.38 0 0 0-1.41 1.36A4.3 4.3 0 0 0 6 9v6a4.3 4.3 0 0 0 .26 1.38 2.38 2.38 0 0 0 1.41 1.41 4.3 4.3 0 0 0 1.33.26h6a4 4 0 0 0 1.38-.26 2.38 2.38 0 0 0 1.41-1.41 4 4 0 0 0 .26-1.38V9a3.8 3.8 0 0 0-.26-1.38ZM12 15.82A3.81 3.81 0 0 1 8.19 12 3.82 3.82 0 1 1 12 15.82m4-6.89a.9.9 0 0 1 0-1.79.9.9 0 0 1 0 1.79" })
), KC = h(V7), S7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.34 5.46a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2m4.6 2.42a7.6 7.6 0 0 0-.46-2.43 4.9 4.9 0 0 0-1.16-1.77 4.7 4.7 0 0 0-1.77-1.15 7.3 7.3 0 0 0-2.43-.47C15.06 2 14.72 2 12 2s-3.06 0-4.12.06a7.3 7.3 0 0 0-2.43.47 4.8 4.8 0 0 0-1.77 1.15 4.7 4.7 0 0 0-1.15 1.77 7.3 7.3 0 0 0-.47 2.43C2 8.94 2 9.28 2 12s0 3.06.06 4.12a7.3 7.3 0 0 0 .47 2.43 4.7 4.7 0 0 0 1.15 1.77 4.8 4.8 0 0 0 1.77 1.15 7.3 7.3 0 0 0 2.43.47C8.94 22 9.28 22 12 22s3.06 0 4.12-.06a7.3 7.3 0 0 0 2.43-.47 4.7 4.7 0 0 0 1.77-1.15 4.85 4.85 0 0 0 1.16-1.77 7.6 7.6 0 0 0 .46-2.43c0-1.06.06-1.4.06-4.12s0-3.06-.06-4.12M20.14 16a5.6 5.6 0 0 1-.34 1.86 3.06 3.06 0 0 1-.75 1.15 3.2 3.2 0 0 1-1.15.75 5.6 5.6 0 0 1-1.86.34c-1 .05-1.37.06-4 .06s-3 0-4-.06a5.7 5.7 0 0 1-1.94-.3 3.3 3.3 0 0 1-1.1-.75 3 3 0 0 1-.74-1.15 5.5 5.5 0 0 1-.4-1.9c0-1-.06-1.37-.06-4s0-3 .06-4a5.5 5.5 0 0 1 .35-1.9A3 3 0 0 1 5 5a3.1 3.1 0 0 1 1.1-.8A5.7 5.7 0 0 1 8 3.86c1 0 1.37-.06 4-.06s3 0 4 .06a5.6 5.6 0 0 1 1.86.34 3.06 3.06 0 0 1 1.19.8 3.1 3.1 0 0 1 .75 1.1 5.6 5.6 0 0 1 .34 1.9c.05 1 .06 1.37.06 4s-.01 3-.06 4M12 6.87A5.13 5.13 0 1 0 17.14 12 5.12 5.12 0 0 0 12 6.87m0 8.46A3.33 3.33 0 1 1 15.33 12 3.33 3.33 0 0 1 12 15.33" })
), jC = h(S7), L7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.991 15a1 1 0 0 0 1-1V6a1 1 0 1 0-2 0v8a1 1 0 0 0 1 1m4 0a1 1 0 0 0 1-1V6a1 1 0 1 0-2 0v8a1 1 0 0 0 1 1m-8-2a1 1 0 0 0 1-1V8a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1m14-12h-16a3.003 3.003 0 0 0-3 3v16a3.003 3.003 0 0 0 3 3h16a3.003 3.003 0 0 0 3-3V4a3.003 3.003 0 0 0-3-3m1 19a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-3.643-4.591A8.82 8.82 0 0 1 11.99 17a9 9 0 0 1-5.356-1.591 1 1 0 1 0-1.287 1.53A10.8 10.8 0 0 0 11.99 19a10.8 10.8 0 0 0 6.644-2.06 1 1 0 0 0-1.287-1.531M17.99 7a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1" })
), JC = h(L7), Z7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.5 2h-15A2.5 2.5 0 0 0 2 4.5v15A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 19.5 2m-4.83 3.67a.66.66 0 0 1 .67-.67.68.68 0 0 1 .66.66v8.9a.67.67 0 0 1-1.33 0Zm-3.34-.34a.67.67 0 0 1 .67-.67.67.67 0 0 1 .67.67V15a.67.67 0 0 1-1.34 0ZM8 5.67a.67.67 0 0 1 1.33 0v8.9a.66.66 0 0 1-.67.66.68.68 0 0 1-.66-.66ZM4.67 7A.67.67 0 0 1 6 7v6a.67.67 0 0 1-.67.66.67.67 0 0 1-.66-.66ZM19.1 17.17a11.3 11.3 0 0 1-7.1 2.16 11.3 11.3 0 0 1-7.1-2.16.67.67 0 0 1 .87-1A10.2 10.2 0 0 0 12 18a10.15 10.15 0 0 0 6.23-1.84.67.67 0 0 1 .87 1Zm.23-4.17A.67.67 0 0 1 18 13V7a.67.67 0 0 1 .67-.66.66.66 0 0 1 .66.66Z" })
), YC = h(Z7), B7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 16H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m-4-6h2a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m12 2h-3V3a1 1 0 0 0-.5-.87 1 1 0 0 0-1 0l-3 1.72-3-1.72a1 1 0 0 0-1 0l-3 1.72-3-1.72a1 1 0 0 0-1 0A1 1 0 0 0 2 3v16a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1V4.73l2 1.14a1.08 1.08 0 0 0 1 0l3-1.72 3 1.72a1.08 1.08 0 0 0 1 0l2-1.14V19a3 3 0 0 0 .18 1Zm15-1a1 1 0 0 1-2 0v-5h2Zm-7-7H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" })
), XC = h(B7), F7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 6h-6a1 1 0 0 0 0 2h1.52l-3.2 8H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-1.52l3.2-8H17a1 1 0 0 0 0-2" })
), _C = h(F7), R7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.85 15.69a1 1 0 0 0-1.41 0l-2.06 2.06a1 1 0 0 0 .45 1.67l.26.07-.8.8a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2-2a1 1 0 0 0 .26-1 1 1 0 0 0-.71-.71l-.26-.06.83-.84a1 1 0 0 0 .02-1.41m-10.94 3.8.26-.07a1 1 0 0 0 .45-1.67l-2.06-2.06a1 1 0 0 0-1.41 1.41l.83.84-.26.06a1 1 0 0 0-.71.71 1 1 0 0 0 .26 1l2 2a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM21 4a1 1 0 0 0-1 1h-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3H4a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0h3v2a3 3 0 0 0 2 2.83V13a2 2 0 0 0 2 2v6a1 1 0 0 0 2 0v-6a2 2 0 0 0 2-2v-1.17A3 3 0 0 0 17 9V7h3a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1m-6 5a1 1 0 0 1-1 1 1 1 0 0 0-1 1v2h-2v-2a1 1 0 0 0-1-1 1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Zm-3-3a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1" })
), zC = h(R7), U7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.478 14.883a4.06 4.06 0 0 1-2.187-.398 1.44 1.44 0 0 1-.536-1.01.22.22 0 0 0-.226-.22 47 47 0 0 0-.95 0 .21.21 0 0 0-.231.186 2.34 2.34 0 0 0 .753 1.844 4 4 0 0 0 2.228.839 8 8 0 0 0 2.533-.108 3.13 3.13 0 0 0 1.678-.904 2.34 2.34 0 0 0 .396-2.231 1.87 1.87 0 0 0-1.23-1.095c-1.28-.45-2.664-.415-3.97-.757-.227-.07-.504-.148-.605-.388a.855.855 0 0 1 .284-.955 2.56 2.56 0 0 1 1.35-.336 4.1 4.1 0 0 1 1.883.27 1.44 1.44 0 0 1 .687.992.243.243 0 0 0 .228.236c.314.006.628.001.943.002a.23.23 0 0 0 .247-.168 2.43 2.43 0 0 0-1.187-2.106 5.9 5.9 0 0 0-3.218-.493 3.5 3.5 0 0 0-2.176.875 2.17 2.17 0 0 0-.434 2.262 1.93 1.93 0 0 0 1.218 1.062c1.277.461 2.676.313 3.964.721.252.085.544.216.621.495a.99.99 0 0 1-.27.946 2.97 2.97 0 0 1-1.793.439m5.819-8.445q-3.738-2.114-7.479-4.225a1.68 1.68 0 0 0-1.637 0L3.73 6.421a1.54 1.54 0 0 0-.805 1.342v8.475a1.55 1.55 0 0 0 .836 1.355c.713.388 1.406.816 2.133 1.179a3.06 3.06 0 0 0 2.738.075 2.13 2.13 0 0 0 .995-1.921c.005-2.797 0-5.594.002-8.39a.22.22 0 0 0-.207-.255 42 42 0 0 0-.953 0 .21.21 0 0 0-.228.213c-.004 2.779.001 5.558-.002 8.338a.94.94 0 0 1-.61.883 1.53 1.53 0 0 1-1.24-.166l-1.982-1.12a.24.24 0 0 1-.135-.235V7.807a.26.26 0 0 1 .157-.26q3.713-2.092 7.425-4.187a.26.26 0 0 1 .292 0l7.426 4.186a.26.26 0 0 1 .156.26v8.388a.24.24 0 0 1-.134.238q-3.656 2.068-7.317 4.13c-.116.064-.254.169-.39.09-.64-.362-1.27-.738-1.908-1.103a.21.21 0 0 0-.23-.014 5 5 0 0 1-.882.412c-.138.056-.308.072-.403.2a1.3 1.3 0 0 0 .432.31l2.236 1.293a1.63 1.63 0 0 0 1.655.046q3.726-2.1 7.452-4.204a1.56 1.56 0 0 0 .836-1.354V7.763a1.54 1.54 0 0 0-.778-1.325" })
), au = h(U7), $7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.12 16.88a3 3 0 0 0-3.4-.58l-1.15-1.14a24 24 0 0 0 5.21-8.86 3.19 3.19 0 0 0-4.08-4.08 24 24 0 0 0-8.86 5.21L7.7 6.28a3 3 0 1 0-4.82.84A3 3 0 0 0 5 8a3 3 0 0 0 1.28-.3l1.15 1.14a24 24 0 0 0-5.21 8.86A3.24 3.24 0 0 0 3 21a3.17 3.17 0 0 0 2.22 1 3.7 3.7 0 0 0 1.08-.17 24 24 0 0 0 8.86-5.21l1.14 1.15a3 3 0 1 0 4.82-.84ZM5.71 5.7a1 1 0 0 1-1.42-1.41A1 1 0 0 1 5.71 5.7m12.6-1.57a1.6 1.6 0 0 1 .47-.08 1.16 1.16 0 0 1 .83.34 1.23 1.23 0 0 1 .26 1.3 22 22 0 0 1-2.13 4.64l-4.07-4.07a22 22 0 0 1 4.64-2.13M5.69 19.87a1.2 1.2 0 0 1-1.56-1.56 22 22 0 0 1 2.13-4.64l4.07 4.07a22 22 0 0 1-4.64 2.13M12 16.59 7.41 12a21 21 0 0 1 1.43-1.74l4.91 4.91A21 21 0 0 1 12 16.59m3.15-2.84-4.9-4.91A21 21 0 0 1 12 7.41l4.6 4.6a21 21 0 0 1-1.44 1.74Zm4.55 6a1 1 0 1 1-1.42-1.41 1 1 0 0 1 1.41 0 1 1 0 0 1 .02 1.37Z" })
), tu = h($7), y7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 6.53-1.42-1.41 1.42-1.41a1 1 0 1 0-1.42-1.42L9.75 12.83a5 5 0 1 0 1.42 1.42l4.88-4.89 1.41 1.42a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42L17.46 8l1.42-1.42L20.29 8a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.47M7 20a3 3 0 1 1 3-3 3 3 0 0 1-3 3" })
), eu = h(y7), k7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21 4.41.71-.7a1 1 0 1 0-1.42-1.42l-1.4 1.41-2.83 2.83-6.31 6.3a5 5 0 1 0 1.42 1.42l5.59-5.6 2.12 2.13a1 1 0 1 0 1.41-1.42l-2.12-2.12 1.42-1.41.7.7a1 1 0 1 0 1.42-1.41ZM7 20a3 3 0 1 1 3-3 3 3 0 0 1-3 3" })
), lu = h(k7), b7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.71 9.29a1 1 0 0 0-1.42 0 1 1 0 0 0-.21.33 1 1 0 0 0 .21 1.09 1.2 1.2 0 0 0 .33.21A.84.84 0 0 0 6 11a1 1 0 0 0 .92-1.38 1 1 0 0 0-.21-.33M10 11a1 1 0 0 0 .92-1.38 1 1 0 0 0-.21-.33 1 1 0 0 0-.9-.29.6.6 0 0 0-.19.06l-.18.09-.15.12A1.05 1.05 0 0 0 9 10a1 1 0 0 0 1 1m-3.62 2.08a1 1 0 0 0-.76 0A1 1 0 0 0 5 14a1 1 0 0 0 1.38.92 1.2 1.2 0 0 0 .33-.21A1 1 0 0 0 7 14a1 1 0 0 0-.29-.71.9.9 0 0 0-.33-.21M14 13h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m.71-3.71a1 1 0 0 0-1.42 0 1 1 0 0 0-.21.33A1 1 0 1 0 15 10a.84.84 0 0 0-.08-.38 1 1 0 0 0-.21-.33m3.85 3.88a.8.8 0 0 0-.18-.09 1 1 0 0 0-.76 0 1.2 1.2 0 0 0-.33.21A1.05 1.05 0 0 0 17 14a1 1 0 1 0 2 0 1.05 1.05 0 0 0-.29-.71ZM20 5H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-2.29-6.71A1 1 0 0 0 17 10a1 1 0 1 0 1.92-.38 1 1 0 0 0-.21-.33" })
), ru = h(b7), T7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.71 10.29a1.2 1.2 0 0 0-.33-.21 1 1 0 0 0-1.09.21 1 1 0 0 0-.21.33 1 1 0 0 0 .21 1.09 1.2 1.2 0 0 0 .33.21 1 1 0 0 0 1.3-1.3 1 1 0 0 0-.21-.33m2.58-2.58A1 1 0 0 0 10 8a.84.84 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21 1.2 1.2 0 0 0 .21-.33.94.94 0 0 0 0-.76 1.2 1.2 0 0 0-.21-.33 1 1 0 0 0-1.42 0 1.2 1.2 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.33M6.71 6.29A1 1 0 0 0 5 7a1 1 0 0 0 .08.38 1.2 1.2 0 0 0 .21.33A1 1 0 0 0 6 8a.84.84 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21 1.2 1.2 0 0 0 .21-.33.94.94 0 0 0 0-.76 1.2 1.2 0 0 0-.21-.33m6.58 12L12 19.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l2-2a1 1 0 0 0-1.42-1.42m5.42-12A1 1 0 0 0 17 7a.84.84 0 0 0 .08.38 1.2 1.2 0 0 0 .21.33 1 1 0 0 0 1.42 0 1.2 1.2 0 0 0 .21-.33A.84.84 0 0 0 19 7a1 1 0 0 0-.08-.38 1.2 1.2 0 0 0-.21-.33M14 10h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m6-8H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-2.29-2.71a1 1 0 0 0-.33-.21.92.92 0 0 0-.76 0 1.2 1.2 0 0 0-.33.21A1.05 1.05 0 0 0 17 11a1 1 0 1 0 1.92-.38 1 1 0 0 0-.21-.33m-5.09-4.21a1.2 1.2 0 0 0-.33.21A1.05 1.05 0 0 0 13 7a1 1 0 0 0 .08.38 1.2 1.2 0 0 0 .21.33A1 1 0 0 0 14 8a.84.84 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21 1.2 1.2 0 0 0 .21-.33A.84.84 0 0 0 15 7a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21" })
), hu = h(T7), P7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.71 10.29A1 1 0 0 0 5 11a1 1 0 1 0 1.92-.38 1 1 0 0 0-.21-.33m2.58-2.58A1 1 0 0 0 10 8a1 1 0 0 0 .71-.29 1.2 1.2 0 0 0 .21-.33A1 1 0 0 0 11 7a1.05 1.05 0 0 0-.29-.71l-.15-.12-.18-.09a.6.6 0 0 0-.19-.08 1 1 0 0 0-.9.27 1 1 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.35M6.56 6.17a.8.8 0 0 0-.18-.09L6.2 6a1 1 0 0 0-.91.27 1 1 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.33 1.2 1.2 0 0 0 .33.21A.84.84 0 0 0 6 8a1 1 0 0 0 .71-.29 1.2 1.2 0 0 0 .21-.33A1 1 0 0 0 7 7a1.05 1.05 0 0 0-.29-.71Zm6.15 12.12a1 1 0 0 0-1.42 0l-2 2a1 1 0 0 0 1.42 1.42l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm6-8a1 1 0 0 0-1.42 0 1 1 0 0 0-.21.33 1 1 0 0 0 1.3 1.3 1.2 1.2 0 0 0 .33-.21A1 1 0 0 0 19 11a.84.84 0 0 0-.08-.38 1 1 0 0 0-.21-.33M14 10h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m6-8H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-3.38-6.92a.9.9 0 0 0-.33.21A1.05 1.05 0 0 0 17 7a1 1 0 0 0 .08.38 1.2 1.2 0 0 0 .21.33A1 1 0 0 0 18 8a1 1 0 0 0 .71-.29 1.2 1.2 0 0 0 .21-.33A1 1 0 0 0 19 7a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21m-3.06.09-.18-.09L14.2 6a1 1 0 0 0-.58.06.9.9 0 0 0-.33.21 1 1 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.33A1 1 0 0 0 14 8a1 1 0 0 0 .71-.29 1.2 1.2 0 0 0 .21-.33A1 1 0 0 0 15 7a1.05 1.05 0 0 0-.29-.71Z" })
), ou = h(P7), D7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.21 13.29a.9.9 0 0 0-.33-.21 1 1 0 0 0-.76 0 .9.9 0 0 0-.54.54 1 1 0 1 0 1.84 0 1 1 0 0 0-.21-.33M13.5 11h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m-4 0h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m-3-2h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2M20 5H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-6-3H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m3.5-4h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m.71 4.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 .9.9 0 0 0-.33.21 1 1 0 0 0-.21.33 1 1 0 1 0 1.92.38.84.84 0 0 0-.08-.38 1 1 0 0 0-.21-.33" })
), nu = h(D7), q7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 8a2 2 0 0 0-2 2 2 2 0 0 0 1 1.72V15a1 1 0 0 0 2 0v-3.28A2 2 0 0 0 14 10a2 2 0 0 0-2-2m0-6a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), wu = h(q7), I7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 11.72V15a1 1 0 0 0 2 0v-3.28A2 2 0 0 0 14 10a2 2 0 0 0-4 0 2 2 0 0 0 1 1.72M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 18H4V4h16Z" })
), vu = h(I7), W7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM12 8a2 2 0 0 0-2 2 2 2 0 0 0 1 1.72V15a1 1 0 0 0 2 0v-3.28A2 2 0 0 0 14 10a2 2 0 0 0-2-2" })
), mu = h(W7), G7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 10a1 1 0 1 0-1 1 1 1 0 0 0 1-1m4.5 4.06a1 1 0 0 0-1.37.36 1.3 1.3 0 0 1-2.26 0 1 1 0 0 0-1.37-.36 1 1 0 0 0-.37 1.36 3.31 3.31 0 0 0 5.74 0 1 1 0 0 0-.37-1.36M15 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18A8 8 0 0 1 9 4.57 3 3 0 0 0 9 5a3 3 0 0 0 3 3 1 1 0 0 0 0-2 1 1 0 0 1 0-2 8 8 0 0 1 0 16" })
), cu = h(G7), O7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 12a1 1 0 1 0 1-1 1 1 0 0 0-1 1m6.71-.71-5-5A1 1 0 0 0 16 6H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h11a1 1 0 0 0 .71-.29l5-5a1 1 0 0 0 0-1.42M15.59 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10.59l4 4Z" })
), su = h(O7), N7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 11.29-5-5A1 1 0 0 0 16 6H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h11a1 1 0 0 0 .71-.29l5-5a1 1 0 0 0 0-1.42M15.59 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10.59l4 4Z" })
), gu = h(N7), Q7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 2.78A1 1 0 0 0 17 2H7a1 1 0 0 0-1 .78l-2 9a1 1 0 0 0 .2.85A1 1 0 0 0 5 13h3.94A8 8 0 0 1 9 14a8.92 8.92 0 0 1-2.57 6.3 1 1 0 0 0 .71 1.7h9.72a1 1 0 0 0 .71-1.7A8.92 8.92 0 0 1 15 14a8 8 0 0 1 .06-1H16v2a1 1 0 0 0 2 0v-2h1a1 1 0 0 0 .78-.37 1 1 0 0 0 .2-.85ZM9.22 20A10.9 10.9 0 0 0 11 14c0-.33 0-.67-.05-1h2.1c0 .33-.05.67-.05 1a10.9 10.9 0 0 0 1.78 6Zm-3-9L7.8 4h8.4l1.55 7Z" })
), iu = h(Q7), K7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.056 12h-2a1 1 0 0 0 0 2v2H17.87a3 3 0 0 0 .185-1 3 3 0 0 0-5.598-1.5 1 1 0 1 0 1.732 1 1 1 0 0 1 .866-.5 1 1 0 0 1 0 2 1 1 0 0 0 0 2 1 1 0 1 1 0 2 1 1 0 0 1-.866-.5 1 1 0 1 0-1.732 1 3 3 0 0 0 5.598-1.5 3 3 0 0 0-.185-1h1.185v3a1 1 0 0 0 2 0v-7a1 1 0 1 0 0-2m-11.97-.757a1 1 0 1 0 1.94-.486l-1.757-7.03a2.28 2.28 0 0 0-4.425 0l-1.758 7.03a1 1 0 1 0 1.94.486L5.585 9h2.94ZM6.086 7l.697-2.787a.292.292 0 0 1 .546 0L8.026 7Zm7.97 0h1a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V8a3.003 3.003 0 0 0-3-3h-1a1 1 0 0 0 0 2m-4 9h-1a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3.003 3.003 0 0 0 3 3h1a1 1 0 0 0 0-2" })
), du = h(K7), j7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.5 10H10a3 3 0 0 0 1.07-5.8 4 4 0 0 0-7.48 1A2.5 2.5 0 0 0 4.5 10m0-3a1 1 0 0 0 1-1 2 2 0 0 1 3.89-.64 1 1 0 0 0 .78.66A1 1 0 0 1 11 7a1 1 0 0 1-1 1H4.5a.5.5 0 0 1 0-1M21 16h-1V9a3 3 0 0 0-3-3h-1a1 1 0 0 0 0 2h1a1 1 0 0 1 1 1v7H6v-3a1 1 0 0 0-2 0v3H3a1 1 0 0 0-1 1v2a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-2a1 1 0 0 0-1-1m-1 3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1h16Z" })
), pu = h(j7), J7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 18h-6.18A3 3 0 0 0 13 16.18V13h7a1 1 0 0 0 0-2h-1V5a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v6H4a1 1 0 0 0 0 2h7v3.18A3 3 0 0 0 9.18 18H3a1 1 0 0 0 0 2h6.18a3 3 0 0 0 5.64 0H21a1 1 0 0 0 0-2M7 11V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6Zm5 9a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), fu = h(J7), Y7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 14h-1V7a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v7H3a1 1 0 0 0-1 1v2a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-2a1 1 0 0 0-1-1M6 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7H6Zm14 10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1h16Z" })
), Eu = h(Y7), X7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.16 12.21a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-.79-.79.79-.79a1 1 0 1 0-1.42-1.42l-1.5 1.5a1 1 0 0 0 0 1.42Zm-5.08 0 1.5-1.5a1 1 0 0 0 0-1.42l-1.5-1.5a1 1 0 0 0-1.42 1.42l.8.79-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29m5.28 2a3.76 3.76 0 0 1-4.72 0 1 1 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1 1 0 1 0-1.28-1.54M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), xu = h(X7), _7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.26 5 12 4l7 4-3.15 1.83a1 1 0 0 0-.37 1.36 1 1 0 0 0 1.37.37l4.65-2.69a1 1 0 0 0 0-1.74l-9-5.2a1 1 0 0 0-1 0l-2.24 1.3a1 1 0 0 0-.37 1.37 1 1 0 0 0 1.37.4M3.71 2.29a1 1 0 0 0-1.42 1.42L4.54 6l-2 1.17a1 1 0 0 0 0 1.74l9 5.2a1 1 0 0 0 1 0l.1-.06 1.07 1.07-1.67 1-8.54-4.99a1 1 0 1 0-1 1.74l9 5.2a1 1 0 0 0 .5.13 1 1 0 0 0 .5-.13l2.63-1.52 1.07 1.07L12 20l-8.5-4.87a1 1 0 0 0-1 1.74l9 5.2a1 1 0 0 0 1 0l5.17-3 2.62 2.63a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM5 8l1-.58 2.75 2.75Zm15.5 3.13-2.12 1.22a1 1 0 0 0 1 1.74l2.12-1.22a1 1 0 1 0-1-1.74" })
), Au = h(_7), z7 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m2.5 8.86 9 5.2a1 1 0 0 0 1 0l9-5.2A1 1 0 0 0 22 8a1 1 0 0 0-.5-.87l-9-5.19a1 1 0 0 0-1 0l-9 5.19A1 1 0 0 0 2 8a1 1 0 0 0 .5.86M12 4l7 4-7 4-7-4Zm8.5 7.17L12 16l-8.5-4.87a1 1 0 0 0-1.37.37 1 1 0 0 0 .37 1.36l9 5.2a1 1 0 0 0 1 0l9-5.2a1 1 0 0 0 .37-1.36 1 1 0 0 0-1.37-.37Zm0 4L12 20l-8.5-4.87a1 1 0 0 0-1.37.37 1 1 0 0 0 .37 1.36l9 5.2a1 1 0 0 0 1 0l9-5.2a1 1 0 0 0 .37-1.36 1 1 0 0 0-1.37-.37Z" })
), Mu = h(z7), a6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H9a1 1 0 0 0-1 1v4H6a1 1 0 0 0-1 1v4H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2h4a1 1 0 0 0 1-1v-2h4a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M10 20H4v-6h6Zm5-3h-3v-4a1 1 0 0 0-1-1H7V9h8Zm5-3h-3V8a1 1 0 0 0-1-1h-6V4h10Z" })
), Hu = h(a6), t6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20.49 13.94-.34.2a1 1 0 0 0-.35 1.37 1 1 0 0 0 .86.49 1 1 0 0 0 .51-.14l.34-.2a1 1 0 0 0-1-1.72Zm-8.84-7.58.35-.21 7 4-1.76 1a1 1 0 0 0 .5 1.87 1 1 0 0 0 .5-.13L21.5 11a1 1 0 0 0 0-1.74l-9-5.19a1 1 0 0 0-1 0l-.85.49a1 1 0 0 0 1 1.74ZM3.71 2.29a1 1 0 0 0-1.42 1.42l3.64 3.63-3.43 2a1 1 0 0 0 0 1.74l9 5.2a1.1 1.1 0 0 0 .5.13 1.1 1.1 0 0 0 .5-.13l1.5-.88 1.45 1.46-3.44 2-8.51-4.93a1 1 0 0 0-1 1.74l9 5.2a1 1 0 0 0 1 0l4.41-2.55 3.38 3.39a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm8.29 12-7-4.1 2.4-1.38 5.12 5.13Z" })
), Cu = h(t6), e6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m2.5 10.56 9 5.2a1 1 0 0 0 1 0l9-5.2a1 1 0 0 0 0-1.73l-9-5.2a1 1 0 0 0-1 0l-9 5.2a1 1 0 0 0 0 1.73M12 5.65l7 4-7 4.05-7-4.01Zm8.5 7.79L12 18.35l-8.5-4.91a1 1 0 0 0-1.37.36 1 1 0 0 0 .37 1.37l9 5.2a1 1 0 0 0 1 0l9-5.2a1 1 0 0 0 .37-1.37 1 1 0 0 0-1.37-.36" })
), uu = h(e6), l6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 11H5.41l2.3-2.29a1 1 0 1 0-1.42-1.42l-4 4a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.41 13H17a1 1 0 0 0 0-2m4-7a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1" })
), Vu = h(l6), r6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11H9.41l2.3-2.29a1 1 0 1 0-1.42-1.42l-4 4a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L9.41 13H21a1 1 0 0 0 0-2M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1" })
), Su = h(r6), h6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 5a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1m4 2h8a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2M5.77 9.69a1 1 0 0 0-1.41-.13l-2 1.67a1 1 0 0 0 0 1.54l2 1.67a1 1 0 0 0 1.41-.13 1 1 0 0 0-.13-1.41L4.56 12l1.08-.9a1 1 0 0 0 .13-1.41M21 9h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2m0 4h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2m0 4h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2" })
), Lu = h(h6), o6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m0 4h10a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18.77-1.31a1 1 0 0 0-1.41-.12l-2 1.66a1 1 0 0 0 0 1.54l2 1.66a1 1 0 0 0 .64.24 1 1 0 0 0 .77-.36 1 1 0 0 0-.13-1.41l-1.08-.9 1.08-.9a1 1 0 0 0 .13-1.41M21 17H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2M3 15h10a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2" })
), Zu = h(o6), n6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.42 17.62a1 1 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42l1.3 1.29H3.5a1 1 0 0 0 0 2h14.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76M8.5 10v4a1 1 0 0 0 2 0V4h2v10a1 1 0 0 0 2 0V4h1a1 1 0 0 0 0-2h-7a4 4 0 0 0 0 8m0-6v4a2 2 0 0 1 0-4" })
), Bu = h(n6), w6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 5h-7V4a1 1 0 0 0-2 0v1H4a1 1 0 0 0 0 2h11.882a14.5 14.5 0 0 1-3.94 7.952A14.4 14.4 0 0 1 8.663 9.67a1 1 0 0 0-1.889.66 16.4 16.4 0 0 0 3.68 5.958 14.3 14.3 0 0 1-5.768 2.735A1 1 0 0 0 4.899 21a1 1 0 0 0 .215-.023 16.3 16.3 0 0 0 6.831-3.319 16.4 16.4 0 0 0 6.842 3.319 1 1 0 0 0 .426-1.954 14.4 14.4 0 0 1-5.79-2.733A16.48 16.48 0 0 0 17.893 7H20a1 1 0 0 0 0-2" })
), Fu = h(w6), v6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.97 19.757 15.35 5.272A2.996 2.996 0 0 0 12.437 3h-.877a2.996 2.996 0 0 0-2.91 2.272L5.03 19.757a1 1 0 0 0 1.94.486L8.28 15h7.44l1.31 5.243a1 1 0 0 0 1.94-.486M8.78 13l1.811-7.242a1 1 0 0 1 .97-.758h.878a1 1 0 0 1 .97.758L15.219 13Z" })
), Ru = h(v6), m6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.022 3h-5a1 1 0 0 0 0 2h1.5v6h-4.95a4.95 4.95 0 0 0 1.026-3 5 5 0 0 0-9.33-2.5 1 1 0 1 0 1.731 1A3 3 0 1 1 7.598 11a1 1 0 0 0 0 2 3 3 0 1 1-2.599 4.5 1 1 0 0 0-1.731 1 5 5 0 0 0 9.33-2.5 4.95 4.95 0 0 0-1.026-3h4.95v7a1 1 0 0 0 2 0V5h1.5a1 1 0 0 0 0-2" })
), Uu = h(m6), c6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.472 11.997a4.87 4.87 0 0 0-4-2.204 5.6 5.6 0 0 0-.131-1.024 1 1 0 1 0-1.945.462 3.6 3.6 0 0 1 .082.601 13.6 13.6 0 0 0-3.257.822c.023-1.204.077-2.407.197-3.607l.038-.382A33 33 0 0 0 14.938 6l.12-.03a1 1 0 1 0-.48-1.94l-.122.03c-.922.23-1.856.404-2.794.55l.151-1.51a1 1 0 0 0-1.99-.2l-.196 1.96c-.934.083-1.87.14-2.809.14a1 1 0 0 0 0 2c.87 0 1.74-.046 2.607-.114a47 47 0 0 0-.203 4.698c-.134.073-.27.142-.403.22a16.4 16.4 0 0 0-1.949 1.31l-.022.018a13.7 13.7 0 0 0-2.649 2.7 3.004 3.004 0 0 0 2.947 4.72 9.7 9.7 0 0 0 2.837-1.014.996.996 0 0 0 1.822-.703c-.025-.145-.036-.291-.058-.437a14 14 0 0 0 1.314-1.155 13.2 13.2 0 0 0 2.101-2.73c.023-.039.042-.078.065-.118q.178-.315.332-.635.079-.167.151-.333a10 10 0 0 0 .329-.838q.046-.144.09-.287c.05-.169.101-.337.141-.504l.005-.018A3.02 3.02 0 0 1 18.741 13c1.019 1.767-.963 4.977-4.417 7.154a1 1 0 1 0 1.067 1.692c4.499-2.836 6.683-7.069 5.08-9.849M6.796 18.583a1.005 1.005 0 0 1-.98-1.574 11.9 11.9 0 0 1 2.291-2.323l.027-.021a14 14 0 0 1 1.144-.793c.06 1.195.173 2.386.326 3.574a8.2 8.2 0 0 1-2.808 1.137M14.126 12a8 8 0 0 1-.316.78q-.085.18-.18.358-.145.278-.311.554-.127.21-.265.418a11.5 11.5 0 0 1-1.408 1.719c-.07.07-.143.133-.214.2q-.163-1.597-.211-3.202a12.5 12.5 0 0 1 2.94-.933z" })
), $u = h(c6), s6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 11.05v-.33l-.09-.6-.09-.39c0-.17-.08-.34-.13-.51s-.08-.27-.13-.4a2 2 0 0 1-.07-.24s0 0 0-.05a10.1 10.1 0 0 0-5.9-5.9s0 0-.05 0l-.23-.07-.42-.13c-.15 0-.31-.08-.46-.12l-.46-.1-.46-.07c-.16 0-.31 0-.48-.06s-.35 0-.52 0L12 2h-.91c-.17 0-.32 0-.48.06l-.46.07-.46.1c-.15 0-.31.07-.46.12l-.42.13-.23.07h-.05a10.1 10.1 0 0 0-5.9 5.9s0 0 0 .05a2 2 0 0 1-.07.24c0 .13-.09.26-.13.4s-.09.34-.13.51l-.09.39-.09.6v2.56l.09.6.09.39c0 .17.08.34.13.51s.08.27.13.4a2 2 0 0 1 .07.24.4.4 0 0 1 0 .07 10 10 0 0 0 5.89 5.88s0 0 .05 0l.24.07.4.13.51.13.39.09.6.09h.33c.31 0 .63.05.95.05s.64 0 .95-.05h.33l.6-.09.39-.09.51-.13.4-.13.24-.07h.05a10 10 0 0 0 5.89-5.88.4.4 0 0 1 0-.07c0-.08.05-.16.07-.24s.09-.26.13-.4.09-.34.13-.51l.09-.39.09-.6v-.33c0-.31.05-.63.05-.95s.09-.56.09-.87m-6.3-6.16a8 8 0 0 1 3.46 3.46l-2.86 1a5.14 5.14 0 0 0-1.64-1.64Zm-5.36-.7c.21-.05.41-.08.61-.11h.24a8.2 8.2 0 0 1 1.72 0h.24c.2 0 .4.06.61.11h.06l-1 2.86A4.5 4.5 0 0 0 12 7a4.4 4.4 0 0 0-.73.06l-1-2.86Zm-1.94.7 1 2.86a5.14 5.14 0 0 0-1.65 1.64l-2.86-1a8 8 0 0 1 3.46-3.5Zm-4.21 8.82a4 4 0 0 1-.1-.6v-.25a7.4 7.4 0 0 1 0-1.72v-.25a4 4 0 0 1 .1-.6s0 0 0-.06l2.86 1a4.5 4.5 0 0 0 0 1.46l-2.86 1zm4.16 5.4a8 8 0 0 1-3.46-3.46l2.86-1a5.14 5.14 0 0 0 1.64 1.64Zm5.36.7c-.21.05-.41.08-.61.11h-.24a8.2 8.2 0 0 1-1.72 0h-.24c-.2 0-.4-.06-.61-.11h-.06l1-2.86a4.5 4.5 0 0 0 1.46 0l1 2.86Zm-.67-5c-.17.06-.34.1-.5.14a2.7 2.7 0 0 1-1 0c-.16 0-.33-.08-.5-.14A3 3 0 0 1 9.2 13a3 3 0 0 1-.14-.51 2.6 2.6 0 0 1 0-1 3 3 0 0 1 .13-.49A3 3 0 0 1 11 9.2c.17-.06.34-.1.5-.14a2.7 2.7 0 0 1 1 0c.16 0 .33.08.5.14a3 3 0 0 1 1.8 1.8 3 3 0 0 1 .14.51 2.6 2.6 0 0 1 0 1 3 3 0 0 1-.14.51A3 3 0 0 1 13 14.8Zm2.61 4.31-1-2.86a5.14 5.14 0 0 0 1.64-1.64l2.86 1a8 8 0 0 1-3.5 3.49ZM20 12.86v.25a4 4 0 0 1-.1.6s0 0 0 .06l-2.86-1a4.5 4.5 0 0 0 0-1.46l2.86-1v.06a4 4 0 0 1 .1.6v.25a7.4 7.4 0 0 1 0 1.72Z" })
), yu = h(s6), g6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.09 2.82a8 8 0 0 0-6.68-1.66 8 8 0 0 0-6.27 6.32 8.07 8.07 0 0 0 1.72 6.65A4.54 4.54 0 0 1 7 17v3a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3v-2.81A5.17 5.17 0 0 1 18.22 14a8 8 0 0 0-1.13-11.2ZM15 20a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1h6Zm1.67-7.24A7.13 7.13 0 0 0 15 17h-2v-3a1 1 0 0 0-2 0v3H9a6.5 6.5 0 0 0-1.6-4.16 6 6 0 0 1 3.39-9.72A6 6 0 0 1 18 9a5.9 5.9 0 0 1-1.33 3.76" })
), ku = h(g6), i6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.45 12.46a7 7 0 0 0-1-9.83 7.09 7.09 0 0 0-5.92-1.4 7 7 0 0 0-4 11.15 4.76 4.76 0 0 1 1.08 2.86v.29a2 2 0 0 0-.61 1.4v2a2 2 0 0 0 2 2v1a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1a2 2 0 0 0 2-2v-2a2 2 0 0 0-.57-1.4v-.43a4.26 4.26 0 0 1 1.02-2.64M9 18.93v-2h6v2Zm6.89-7.72a6.18 6.18 0 0 0-1.46 3.72H9.56a6.67 6.67 0 0 0-1.5-3.78 5 5 0 0 1 2.84-8A5 5 0 0 1 17 8.07a4.92 4.92 0 0 1-1.11 3.14" })
), bu = h(i6), d6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 3.29a1 1 0 0 0-1.42 0l-18 18a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l18-18a1 1 0 0 0 0-1.42" })
), Tu = h(d6), p6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.29 9.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2 2a1 1 0 0 0 1.42 1.42l.29-.3v5.18l-.29-.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2-2a1 1 0 0 0-1.42-1.42l-.29.3V9.41ZM11 8h10a1 1 0 0 0 0-2H11a1 1 0 0 0 0 2m10 3H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m0 5H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2" })
), Pu = h(p6), f6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.78 9.46a.38.38 0 0 0-.38.38v1.67L12 9.65a.4.4 0 0 0-.33-.19.38.38 0 0 0-.38.38v2.84a.38.38 0 0 0 .38.38.38.38 0 0 0 .38-.38V11l1.39 1.91a.27.27 0 0 0 .15.11.3.3 0 0 0 .14 0A.33.33 0 0 0 14 13l.1-.07a.4.4 0 0 0 .11-.27V9.84a.38.38 0 0 0-.43-.38M9.2 12.27H8.14V9.84a.38.38 0 0 0-.38-.38.38.38 0 0 0-.38.38v2.84a.38.38 0 0 0 .38.38H9.2a.39.39 0 0 0 .39-.38.39.39 0 0 0-.39-.41m1.11-2.81a.39.39 0 0 0-.39.38v2.84a.39.39 0 0 0 .39.38.38.38 0 0 0 .38-.38V9.84a.38.38 0 0 0-.38-.38M17.91 2H6.09A4.1 4.1 0 0 0 2 6.09v11.82A4.1 4.1 0 0 0 6.09 22h11.82A4.1 4.1 0 0 0 22 17.91V6.09A4.1 4.1 0 0 0 17.91 2m.31 12.28a2 2 0 0 1-.13.17 5.5 5.5 0 0 1-.8.8c-2 1.87-5.36 4.11-5.81 3.76s.64-1.76-.53-2a1 1 0 0 1-.25 0c-3.44-.48-6-2.89-6-5.78 0-3.25 3.29-5.88 7.34-5.88s7.34 2.63 7.34 5.88a5 5 0 0 1-1.16 3.05m-1.71-4.81H15a.38.38 0 0 0-.38.38v2.84a.38.38 0 0 0 .38.38h1.48a.38.38 0 0 0 .38-.38.38.38 0 0 0-.38-.38h-1.03v-.6h1.06a.39.39 0 0 0 .38-.39.38.38 0 0 0-.38-.38h-1.06v-.61h1.06a.38.38 0 0 0 .38-.38.38.38 0 0 0-.38-.48" })
), Du = h(f6), E6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m12.11 15.39-3.88 3.88a2.47 2.47 0 0 1-3.5 0 2.46 2.46 0 0 1 0-3.5l3.88-3.88a1 1 0 1 0-1.42-1.42l-3.88 3.89a4.48 4.48 0 0 0 6.33 6.33l3.89-3.88a1 1 0 0 0-1.42-1.42m-3.28-.22a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l4.92-4.92a1 1 0 1 0-1.42-1.42l-4.92 4.92a1 1 0 0 0 0 1.42M21 18h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m-4.19-4.47 3.88-3.89a4.48 4.48 0 0 0-6.33-6.33l-3.89 3.88a1 1 0 1 0 1.42 1.42l3.88-3.88a2.47 2.47 0 0 1 3.5 0 2.46 2.46 0 0 1 0 3.5l-3.88 3.88a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0" })
), qu = h(E6), x6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m12.11 15.39-3.88 3.88a2.52 2.52 0 0 1-3.5 0 2.47 2.47 0 0 1 0-3.5l3.88-3.88a1 1 0 1 0-1.42-1.42l-3.88 3.89a4.48 4.48 0 0 0 6.33 6.33l3.89-3.88a1 1 0 0 0-1.42-1.42m8.58-12.08a4.49 4.49 0 0 0-6.33 0l-3.89 3.88a1 1 0 1 0 1.42 1.42l3.88-3.88a2.52 2.52 0 0 1 3.5 0 2.47 2.47 0 0 1 0 3.5l-3.88 3.88a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3.88-3.89a4.49 4.49 0 0 0 0-6.33M8.83 15.17a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l4.92-4.92a1 1 0 1 0-1.42-1.42l-4.92 4.92a1 1 0 0 0 0 1.42" })
), Iu = h(x6), A6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.76 10.59a1 1 0 0 0 .26-2l-1.76-.44a1 1 0 1 0-.52 1.93l1.76.47a.8.8 0 0 0 .26.04M8.62 5a1 1 0 0 0 1 .74.8.8 0 0 0 .26 0 1 1 0 0 0 .7-1.22l-.47-1.76a1 1 0 1 0-1.93.52Zm4.83 10A1 1 0 0 0 12 15l-3.5 3.56a2.21 2.21 0 0 1-3.06 0 2.15 2.15 0 0 1 0-3.06L9 12a1 1 0 1 0-1.41-1.41L4 14.08A4.17 4.17 0 1 0 9.92 20l3.53-3.53a1 1 0 0 0 0-1.47M5.18 6.59a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41L5.3 3.89A1 1 0 0 0 3.89 5.3Zm16.08 7.33-1.76-.47a1 1 0 1 0-.5 1.93l1.76.47h.26a1 1 0 0 0 .26-2ZM15.38 19a1 1 0 0 0-1.23-.7 1 1 0 0 0-.7 1.22l.47 1.76a1 1 0 0 0 1 .74 1.2 1.2 0 0 0 .26 0 1 1 0 0 0 .71-1.23Zm3.44-1.57a1 1 0 0 0-1.41 1.41l1.29 1.29a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41ZM21.2 7a4.16 4.16 0 0 0-7.12-3l-3.53 3.56A1 1 0 1 0 12 9l3.5-3.56a2.21 2.21 0 0 1 3.06 0 2.15 2.15 0 0 1 0 3.06L15 12a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0L20 9.92A4.2 4.2 0 0 0 21.2 7" })
), Wu = h(A6), M6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 12a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2H9a1 1 0 0 0-1 1m2 3H7a3 3 0 0 1 0-6h3a1 1 0 0 0 0-2H7a5 5 0 0 0 0 10h3a1 1 0 0 0 0-2m7-8h-3a1 1 0 0 0 0 2h3a3 3 0 0 1 0 6h-3a1 1 0 0 0 0 2h3a5 5 0 0 0 0-10" })
), Gu = h(M6), H6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m10 17.55-1.77 1.72a2.47 2.47 0 0 1-3.5-3.5l4.54-4.55a2.46 2.46 0 0 1 3.39-.09l.12.1a1 1 0 0 0 1.4-1.43 3 3 0 0 0-.18-.21 4.46 4.46 0 0 0-6.09.22l-4.6 4.55a4.48 4.48 0 0 0 6.33 6.33L11.37 19A1 1 0 0 0 10 17.55M20.69 3.31a4.49 4.49 0 0 0-6.33 0L12.63 5A1 1 0 0 0 14 6.45l1.73-1.72a2.47 2.47 0 0 1 3.5 3.5l-4.54 4.55a2.46 2.46 0 0 1-3.39.09l-.12-.1a1 1 0 0 0-1.4 1.43 3 3 0 0 0 .23.21 4.47 4.47 0 0 0 6.09-.22l4.55-4.55a4.49 4.49 0 0 0 .04-6.33" })
), Ou = h(H6), C6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.5 8.999a5.4 5.4 0 0 0-2.565.645A1 1 0 0 0 14 8.999h-4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-5.5a1 1 0 1 1 2 0v5.5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-7.5a5.507 5.507 0 0 0-5.5-5.5m3.5 12h-2v-4.5a3 3 0 1 0-6 0v4.5h-2v-10h2v.703a1 1 0 0 0 1.781.625A3.483 3.483 0 0 1 21 14.5Zm-14-12H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1m-1 12H4v-10h2ZM5.015 1.542a3.233 3.233 0 1 0-.057 6.457h.028a3.233 3.233 0 1 0 .029-6.457m-.029 4.457h-.028a1.222 1.222 0 0 1-1.37-1.228c0-.747.56-1.229 1.427-1.229A1.234 1.234 0 0 1 6.41 4.771c0 .746-.56 1.228-1.425 1.228" })
), Nu = h(C6), u6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.47 2H3.53a1.45 1.45 0 0 0-1.47 1.43v17.14A1.45 1.45 0 0 0 3.53 22h16.94a1.45 1.45 0 0 0 1.47-1.43V3.43A1.45 1.45 0 0 0 20.47 2M8.09 18.74h-3v-9h3ZM6.59 8.48a1.56 1.56 0 1 1 0-3.12 1.57 1.57 0 1 1 0 3.12m12.32 10.26h-3v-4.83c0-1.21-.43-2-1.52-2A1.65 1.65 0 0 0 12.85 13a2 2 0 0 0-.1.73v5h-3v-9h3V11a3 3 0 0 1 2.71-1.5c2 0 3.45 1.29 3.45 4.06Z" })
), Qu = h(u6), V6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.7 17.6c-.1-.2-.2-.4-.2-.6 0-.4-.2-.7-.5-1-.1-.1-.3-.2-.4-.2.6-1.8-.3-3.6-1.3-4.9-.8-1.2-2-2.1-1.9-3.7 0-1.9.2-5.4-3.3-5.1-3.6.2-2.6 3.9-2.7 5.2 0 1.1-.5 2.2-1.3 3.1-.2.2-.4.5-.5.7-1 1.2-1.5 2.8-1.5 4.3-.2.2-.4.4-.5.6-.1.1-.2.2-.2.3-.1.1-.3.2-.5.3-.4.1-.7.3-.9.7-.1.3-.2.7-.1 1.1.1.2.1.4 0 .7-.2.4-.2.9 0 1.4.3.4.8.5 1.5.6.5 0 1.1.2 1.6.4.5.3 1.1.5 1.7.5.3 0 .7-.1 1-.2.3-.2.5-.4.6-.7.4 0 1-.2 1.7-.2.6 0 1.2.2 2 .1 0 .1 0 .2.1.3.2.5.7.9 1.3 1h.2c.8-.1 1.6-.5 2.1-1.1.4-.4.9-.7 1.4-.9.6-.3 1-.5 1.1-1 .1-.7-.1-1.1-.5-1.7M12.8 4.8c.6.1 1.1.6 1 1.2q0 .45-.3.9h-.1c-.2-.1-.3-.1-.4-.2.1-.1.1-.3.2-.5 0-.4-.2-.7-.4-.7-.3 0-.5.3-.5.7v.1c-.1-.1-.3-.1-.4-.2V6c-.1-.5.3-1.1.9-1.2m-.3 2c.1.1.3.2.4.2s.3.1.4.2c.2.1.4.2.4.5s-.3.6-.9.8c-.2.1-.3.1-.4.2-.3.2-.6.3-1 .3-.3 0-.6-.2-.8-.4-.1-.1-.2-.2-.4-.3-.1-.1-.3-.3-.4-.6 0-.1.1-.2.2-.3.3-.2.4-.3.5-.4l.1-.1c.2-.3.6-.5 1-.5.3.1.6.2.9.4M10.4 5c.4 0 .7.4.8 1.1v.2c-.1 0-.3.1-.4.2v-.2c0-.3-.2-.6-.4-.5-.2 0-.3.3-.3.6 0 .2.1.3.2.4 0 0-.1.1-.2.1-.2-.2-.4-.5-.4-.8 0-.6.3-1.1.7-1.1m-1 16.1c-.7.3-1.6.2-2.2-.2-.6-.3-1.1-.4-1.8-.4-.5-.1-1-.1-1.1-.3s-.1-.5.1-1q.15-.45 0-.9c-.1-.3-.1-.5 0-.8s.3-.4.6-.5.5-.2.7-.4c.1-.1.2-.2.3-.4.3-.4.5-.6.8-.6.6.1 1.1 1 1.5 1.9.2.3.4.7.7 1 .4.5.9 1.2.9 1.6 0 .5-.2.8-.5 1m4.9-2.2c0 .1 0 .1-.1.2-1.2.9-2.8 1-4.1.3l-.6-.9c.9-.1.7-1.3-1.2-2.5-2-1.3-.6-3.7.1-4.8.1-.1.1 0-.3.8-.3.6-.9 2.1-.1 3.2 0-.8.2-1.6.5-2.4.7-1.3 1.2-2.8 1.5-4.3.1.1.1.1.2.1.1.1.2.2.3.2.2.3.6.4.9.4h.1c.4 0 .8-.1 1.1-.4.1-.1.2-.2.4-.2q.45-.15.9-.6c.4 1.3.8 2.5 1.4 3.6.4.8.7 1.6.9 2.5.3 0 .7.1 1 .3.8.4 1.1.7 1 1.2H18c0-.3-.2-.6-.9-.9s-1.3-.3-1.5.4c-.1 0-.2.1-.3.1-.8.4-.8 1.5-.9 2.6.1.4 0 .7-.1 1.1m4.6.6c-.6.2-1.1.6-1.5 1.1-.4.6-1.1 1-1.9.9-.4 0-.8-.3-.9-.7-.1-.6-.1-1.2.2-1.8.1-.4.2-.7.3-1.1.1-1.2.1-1.9.6-2.2 0 .5.3.8.7 1 .5 0 1-.1 1.4-.5h.2c.3 0 .5 0 .7.2s.3.5.3.7c0 .3.2.6.3.9.5.5.5.8.5.9-.1.2-.5.4-.9.6m-9-12c-.1 0-.1 0-.1.1 0 0 0 .1.1.1s.1.1.1.1c.3.4.8.6 1.4.7.5-.1 1-.2 1.5-.6l.6-.3c.1 0 .1-.1.1-.1 0-.1 0-.1-.1-.1-.2.1-.5.2-.7.3-.4.3-.9.5-1.4.5s-.9-.3-1.2-.6c-.1 0-.2-.1-.3-.1" })
), Ku = h(V6), S6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 12a1 1 0 0 0-1 1 7.01 7.01 0 0 1-7 7v-8.865l5.217-1.159a1 1 0 0 0-.434-1.952L10 9.087V7.135l5.217-1.159a1 1 0 1 0-.434-1.952L10 5.087V3a1 1 0 0 0-2 0v2.531l-2.217.493a1 1 0 1 0 .434 1.952L8 7.58V9.53l-2.217.493a1 1 0 1 0 .434 1.952L8 11.58V21a1 1 0 0 0 1 1h1a9.01 9.01 0 0 0 9-9 1 1 0 0 0-1-1" })
), ju = h(S6), L6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 20H4v-.1c0-.5.4-.9.9-.9 1.4 0 2.6-.9 3-2.2.4-1.6-.5-3.3-2.1-3.7-1.3-.4-2.7.2-3.4 1.4-.3.5-.1 1.1.4 1.4s1.1.1 1.4-.4.9-.6 1.4-.3c.1.1.2.1.2.2.2.3.2.6.2.9-.2.4-.6.7-1 .7-1.7 0-3 1.3-3 2.9V21c0 .6.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1M7 9H6V3c0-.6-.4-1-1-1s-1 .4-1 1v1H3c-.6 0-1 .4-1 1s.4 1 1 1h1v3H3c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1m4-3h10c.6 0 1-.4 1-1s-.4-1-1-1H11c-.6 0-1 .4-1 1s.4 1 1 1m10 14H11c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1m0-11H11c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1m0 6H11c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1" })
), Ju = h(L6), Z6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 20H4v-.1c0-.5.4-.9.9-.9 1.4 0 2.6-.9 3-2.2.4-1.6-.5-3.3-2.1-3.7-1.3-.4-2.7.2-3.4 1.4-.3.5-.1 1.1.4 1.4s1.1.1 1.4-.4.9-.6 1.4-.3c.1.1.2.1.2.2.2.3.2.6.2.9-.2.4-.6.7-1 .7-1.7 0-3 1.3-3 2.9V21c0 .6.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1m4-13h10c.6 0 1-.4 1-1s-.4-1-1-1H11c-.6 0-1 .4-1 1s.4 1 1 1M7 9H6V3c0-.6-.4-1-1-1s-1 .4-1 1v1H3c-.6 0-1 .4-1 1s.4 1 1 1h1v3H3c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1m14 7H11c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1" })
), Yu = h(Z6), B6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3.5 6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 2h14a1 1 0 0 0 0-2h-14a1 1 0 0 0 0 2m0 3a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4 5a1 1 0 1 0 1 1 1 1 0 0 0-1-1m10-5h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m0 5h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" })
), Xu = h(B6), F6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3.71 16.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21 1 1 0 0 0-.21.33 1 1 0 0 0 .21 1.09 1.2 1.2 0 0 0 .33.21.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .21-1.09 1 1 0 0 0-.21-.33M7 8h14a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m-3.29 3.29a1 1 0 0 0-1.09-.21 1.2 1.2 0 0 0-.33.21 1 1 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.33 1.2 1.2 0 0 0 .33.21.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21 1.2 1.2 0 0 0 .21-.33.94.94 0 0 0 0-.76 1 1 0 0 0-.21-.33M21 11H7a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2M3.71 6.29a1 1 0 0 0-.33-.21 1 1 0 0 0-1.09.21 1.2 1.2 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.33 1.2 1.2 0 0 0 .33.21 1 1 0 0 0 1.09-.21 1.2 1.2 0 0 0 .21-.33.94.94 0 0 0 0-.76 1.2 1.2 0 0 0-.21-.33M21 16H7a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" })
), _u = h(F6), R6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.68 17.65-7-14a3 3 0 0 0-5.36 0l-7 14a3 3 0 0 0 3.9 4.08l5.37-2.4a1.06 1.06 0 0 1 .82 0l5.37 2.4a3 3 0 0 0 3.9-4.08m-2 2a1 1 0 0 1-1.13.22l-5.37-2.39a3 3 0 0 0-2.44 0L5.41 19.9a1 1 0 0 1-1.3-1.35l7-14a1 1 0 0 1 1.78 0l7 14a1 1 0 0 1-.17 1.13Z" })
), zu = h(R6), U6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.15 2.86a2.89 2.89 0 0 0-3-.71L4 6.88a2.9 2.9 0 0 0-.12 5.47l5.24 2a.93.93 0 0 1 .53.52l2 5.25A2.87 2.87 0 0 0 14.36 22h.07a2.88 2.88 0 0 0 2.69-2l4.73-14.17a2.89 2.89 0 0 0-.7-2.97M20 5.2l-4.78 14.18a.88.88 0 0 1-.84.62.92.92 0 0 1-.87-.58l-2-5.25a2.9 2.9 0 0 0-1.67-1.68l-5.25-2A.9.9 0 0 1 4 9.62a.88.88 0 0 1 .62-.84L18.8 4.05A.91.91 0 0 1 20 5.2" })
), aV = h(U6), $6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 10.8a2 2 0 1 0-2-2 2 2 0 0 0 2 2m-.71 6.91a1 1 0 0 0 1.42 0l4.09-4.1a6.79 6.79 0 1 0-9.6 0ZM7.23 8.34a4.81 4.81 0 0 1 2.13-3.55 4.81 4.81 0 0 1 5.28 0 4.82 4.82 0 0 1 .75 7.41L12 15.59 8.61 12.2a4.77 4.77 0 0 1-1.38-3.86M19 20H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" })
), tV = h($6), y6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 4.48a8.45 8.45 0 0 0-12 12l5.27 5.28a1 1 0 0 0 1.42 0L18 16.43a8.45 8.45 0 0 0 0-11.95M16.57 15 12 19.59 7.43 15a6.46 6.46 0 1 1 9.14 0M9 7.41a4.32 4.32 0 0 0 0 6.1 4.31 4.31 0 0 0 7.36-3 4.24 4.24 0 0 0-1.26-3.05A4.3 4.3 0 0 0 9 7.41m4.69 4.68a2.33 2.33 0 1 1 .67-1.63 2.33 2.33 0 0 1-.72 1.63Z" })
), eV = h(y6), k6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2h-6a1 1 0 0 0 0 2h5v5a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1m0 12a1 1 0 0 0-1 1v5h-5a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m-9-8a3 3 0 0 0-3 3v1a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2V9a3 3 0 0 0-3-3m-1 3a1 1 0 0 1 2 0v1h-2Zm4 7H9v-4h6ZM3 10a1 1 0 0 0 1-1V4h5a1 1 0 0 0 0-2H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m6 10H4v-5a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2" })
), lV = h(k6), b6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 13a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m5-4V7A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3M9 7a3 3 0 0 1 6 0v2H9Zm9 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z" })
), rV = h(b6), T6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 13a1.49 1.49 0 0 0-1 2.61V17a1 1 0 0 0 2 0v-1.39A1.49 1.49 0 0 0 12 13m5-4H9V7a3 3 0 0 1 5.12-2.13 3.1 3.1 0 0 1 .78 1.38 1 1 0 1 0 1.94-.5 5.1 5.1 0 0 0-1.31-2.29A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3m1 10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z" })
), hV = h(T6), P6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.84 5.38a2 2 0 0 1 2.57.21A2 2 0 0 1 14 7v3a1 1 0 0 0 1 1h1a1 1 0 0 1 1 1v.34a1 1 0 0 0 2 0V12a3 3 0 0 0-3-3V7a4 4 0 0 0-1.17-2.83 4.06 4.06 0 0 0-5.19-.39 1 1 0 1 0 1.2 1.6m10.87 14.91-18-18a1 1 0 0 0-1.42 1.42L7.62 9A3 3 0 0 0 5 12v6a3 3 0 0 0 3 3h8a3 3 0 0 0 2.39-1.2l1.9 1.91a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M16 19H8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1.59l2.07 2.07A1 1 0 0 0 11 14v2a1 1 0 0 0 2 0v-1.59l3.93 3.93A1 1 0 0 1 16 19" })
), oV = h(P6), D6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 9V7A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3M9 7a3 3 0 0 1 6 0v2H9Zm9 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z" })
), nV = h(D6), q6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3.003 3.003 0 0 0-3 3v14a3.003 3.003 0 0 0 3 3h14a3.003 3.003 0 0 0 3-3V5a3.003 3.003 0 0 0-3-3m-2 6c-1.66 0-2.856 2.177-4.124 4.482C11.384 15.195 9.841 18 7 18a1 1 0 0 1 0-2c1.66 0 2.856-2.177 4.124-4.482C12.616 8.805 14.159 6 17 6a1 1 0 0 1 0 2" })
), wV = h(q6), I6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 6c-2.8 0-4.4 2.8-5.9 5.5C9.9 13.8 8.7 16 7 16c-.6 0-1 .4-1 1s.4 1 1 1c2.8 0 4.4-2.8 5.9-5.5C14.1 10.2 15.3 8 17 8c.6 0 1-.4 1-1s-.4-1-1-1m2-4H5C3.3 2 2 3.3 2 5v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3m1 17c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h14c.6 0 1 .4 1 1z" })
), vV = h(I6), W6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M2 13.5v2a1 1 0 0 0 1 1h10a3 3 0 0 0 6 0h2a1 1 0 0 0 1-1v-8a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v7H4v-1a1 1 0 0 0-2 0m13 3a1 1 0 1 1 1 1 1 1 0 0 1-1-1m-7-6h12v4h-1.78a3 3 0 0 0-4.44 0H8Zm0-3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1H8Z" })
), mV = h(W6), G6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 13h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2m8 7h-1V9h1a1 1 0 0 0 0-2h-1.09A6 6 0 0 0 6.09 7H5a1 1 0 0 0 0 2h1v11H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2M12 4a4 4 0 0 1 3.86 3H8.14A4 4 0 0 1 12 4m4 16H8v-2h8Zm0-4H8V9h8Z" })
), cV = h(G6), O6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 12h2a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2m9-6h-5V4h1a1 1 0 0 0 0-2h-2a1 1 0 0 0-1 1v3H7a4 4 0 0 0-4 4v6a1 1 0 0 0 1 1h6v4a1 1 0 0 0 2 0v-4h8a1 1 0 0 0 1-1v-6a4 4 0 0 0-4-4m-4 4v5H5v-5a2 2 0 0 1 2-2h6.56a3.9 3.9 0 0 0-.56 2m6 5h-4v-5a2 2 0 0 1 4 0Z" })
), sV = h(O6), N6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.46 9.63A8.5 8.5 0 0 0 7.3 3.36a8.56 8.56 0 0 0-3.76 6.27A8.46 8.46 0 0 0 6 16.46l5.3 5.31a1 1 0 0 0 1.42 0L18 16.46a8.46 8.46 0 0 0 2.46-6.83m-3.86 5.42-4.6 4.6-4.6-4.6a6.49 6.49 0 0 1-1.87-5.22A6.57 6.57 0 0 1 8.42 5a6.47 6.47 0 0 1 7.16 0 6.57 6.57 0 0 1 2.89 4.81 6.49 6.49 0 0 1-1.87 5.24M12 6a4.5 4.5 0 1 0 4.5 4.5A4.51 4.51 0 0 0 12 6m0 7a2.5 2.5 0 1 1 2.5-2.5A2.5 2.5 0 0 1 12 13" })
), gV = h(N6), Q6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.46 9.63A8.5 8.5 0 1 0 6 16.46l5.3 5.31a1 1 0 0 0 1.42 0L18 16.46a8.46 8.46 0 0 0 2.46-6.83m-3.86 5.42-4.6 4.6-4.6-4.6a6.49 6.49 0 0 1-1.87-5.22A6.57 6.57 0 0 1 8.42 5a6.47 6.47 0 0 1 7.16 0 6.57 6.57 0 0 1 2.89 4.81 6.49 6.49 0 0 1-1.87 5.24m-2.81-8.8a1 1 0 0 0-1.42 0L8.79 9.83a1 1 0 0 0-.29.7V13a1 1 0 0 0 1 1h2.42a1 1 0 0 0 .71-.29l3.58-3.58a1 1 0 0 0 0-1.41ZM11.51 12h-1v-1l2.58-2.58 1 1Z" })
), iV = h(Q6), K6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 10a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m8.46-.32A8.5 8.5 0 0 0 7.3 3.36a8.56 8.56 0 0 0-3.76 6.27A8.46 8.46 0 0 0 6 16.46l5.3 5.31a1 1 0 0 0 1.42 0L18 16.46a8.46 8.46 0 0 0 2.46-6.83Zm-3.86 5.37-4.6 4.6-4.6-4.6a6.49 6.49 0 0 1-1.87-5.22A6.57 6.57 0 0 1 8.42 5a6.47 6.47 0 0 1 7.16 0 6.57 6.57 0 0 1 2.89 4.81 6.49 6.49 0 0 1-1.87 5.24m-3.68-7.48a.6.6 0 0 0-.09-.17l-.12-.15A1 1 0 0 0 11.8 7h-.18l-.18.09-.15.13-.12.15a.6.6 0 0 0-.09.17.6.6 0 0 0-.06.19A1.2 1.2 0 0 0 11 8a.9.9 0 0 0 .08.39 1.1 1.1 0 0 0 .21.32 1.1 1.1 0 0 0 .33.22 1.07 1.07 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.22 1.1 1.1 0 0 0 .21-.32A1 1 0 0 0 13 8a1 1 0 0 0 0-.19.6.6 0 0 0-.08-.24" })
), dV = h(K6), j6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 9.45h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m6.46.18A8.5 8.5 0 1 0 6 16.46l5.3 5.31a1 1 0 0 0 1.42 0L18 16.46a8.46 8.46 0 0 0 2.46-6.83m-3.86 5.42-4.6 4.6-4.6-4.6a6.49 6.49 0 0 1-1.87-5.22A6.57 6.57 0 0 1 8.42 5a6.47 6.47 0 0 1 7.16 0 6.57 6.57 0 0 1 2.89 4.81 6.49 6.49 0 0 1-1.87 5.24" })
), pV = h(j6), J6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 9.45h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m6.46.18A8.5 8.5 0 1 0 6 16.46l5.3 5.31a1 1 0 0 0 1.42 0L18 16.46a8.46 8.46 0 0 0 2.46-6.83m-3.86 5.42-4.6 4.6-4.6-4.6a6.49 6.49 0 0 1-1.87-5.22A6.57 6.57 0 0 1 8.42 5a6.47 6.47 0 0 1 7.16 0 6.57 6.57 0 0 1 2.89 4.81 6.49 6.49 0 0 1-1.87 5.24" })
), fV = h(J6), Y6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m12.44 13.11-.17-.11a1 1 0 0 0-1.09.22.9.9 0 0 0-.22.32 1 1 0 0 0-.08.39 1 1 0 0 0 .08.38 1.07 1.07 0 0 0 .54.54 1 1 0 0 0 .38.08 1.1 1.1 0 0 0 .39-.08 1 1 0 0 0 .32-.22 1 1 0 0 0 0-1.41ZM11.88 6A2.75 2.75 0 0 0 9.5 7.32a1 1 0 1 0 1.73 1 .77.77 0 0 1 .65-.32.75.75 0 1 1 0 1.5 1 1 0 1 0 0 2 2.75 2.75 0 1 0 0-5.5m8.58 3.68A8.5 8.5 0 0 0 7.3 3.36a8.56 8.56 0 0 0-3.76 6.27A8.46 8.46 0 0 0 6 16.46l5.3 5.31a1 1 0 0 0 1.42 0L18 16.46a8.46 8.46 0 0 0 2.46-6.83Zm-3.86 5.37-4.6 4.6-4.6-4.6a6.49 6.49 0 0 1-1.87-5.22A6.57 6.57 0 0 1 8.42 5a6.47 6.47 0 0 1 7.16 0 6.57 6.57 0 0 1 2.89 4.81 6.49 6.49 0 0 1-1.87 5.24" })
), EV = h(Y6), X6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.41 6.53a2.24 2.24 0 0 1-1.82-.39 1 1 0 0 0-1.18 0 2.24 2.24 0 0 1-1.82.39 1 1 0 0 0-.84.2 1 1 0 0 0-.37.78v2.9A4.14 4.14 0 0 0 10 13.74l1.37 1a1 1 0 0 0 1.18 0l1.37-1a4.14 4.14 0 0 0 1.66-3.33v-2.9a1 1 0 0 0-.37-.78 1 1 0 0 0-.8-.2m-.79 3.88a2.15 2.15 0 0 1-.85 1.73l-.77.57-.77-.57a2.15 2.15 0 0 1-.85-1.73V8.57A4.2 4.2 0 0 0 12 8.12a4.2 4.2 0 0 0 1.62.45Zm6.84-.78A8.5 8.5 0 0 0 7.3 3.36a8.56 8.56 0 0 0-3.76 6.27A8.46 8.46 0 0 0 6 16.46l5.3 5.31a1 1 0 0 0 1.42 0L18 16.46a8.46 8.46 0 0 0 2.46-6.83m-3.86 5.42-4.6 4.6-4.6-4.6a6.49 6.49 0 0 1-1.87-5.22A6.57 6.57 0 0 1 8.42 5a6.47 6.47 0 0 1 7.16 0 6.57 6.57 0 0 1 2.89 4.81 6.49 6.49 0 0 1-1.87 5.24" })
), xV = h(X6), _6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.63 5.49a6 6 0 0 1 7.21 7.2 1 1 0 0 0 .74 1.21 1 1 0 0 0 .23 0 1 1 0 0 0 1-.76 8 8 0 0 0-9.61-9.62 1 1 0 0 0 .46 2Zm11.08 14.58-4.27-4.27L3.71 2.07a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41L5.5 6.69A8 8 0 0 0 6.34 17l4.95 4.95a1 1 0 0 0 1.42 0l4-4 3.56 3.56a1 1 0 0 0 1.42-1.41Zm-9.59-6.76a2 2 0 0 1-1.53-.57 2 2 0 0 1-.59-1.53Zm-.12 6.5-4.24-4.24a6 6 0 0 1-.82-7.44L8.41 9.6a4 4 0 0 0 .76 4.55A4 4 0 0 0 12 15.33a3.9 3.9 0 0 0 1.73-.41l1.58 1.58Z" })
), AV = h(_6), z6 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a8 8 0 0 0-8 8c0 5.4 7.05 11.5 7.35 11.76a1 1 0 0 0 1.3 0C13 21.5 20 15.4 20 10a8 8 0 0 0-8-8m0 17.65c-2.13-2-6-6.31-6-9.65a6 6 0 0 1 12 0c0 3.34-3.87 7.66-6 9.65M12 6a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2" })
), MV = h(z6), ar = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 11.9V17a1 1 0 0 0 2 0v-5.1a5 5 0 1 0-2 0M12 4a3 3 0 1 1-3 3 3 3 0 0 1 3-3m4.21 10.42a1 1 0 1 0-.42 2C18.06 16.87 19 17.68 19 18c0 .58-2.45 2-7 2s-7-1.42-7-2c0-.32.94-1.13 3.21-1.62a1 1 0 1 0-.42-2C4.75 15.08 3 16.39 3 18c0 2.63 4.53 4 9 4s9-1.37 9-4c0-1.61-1.75-2.92-4.79-3.58" })
), HV = h(ar), tr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.37 12.79a1 1 0 0 0-.74 1.86C17.09 15.23 18 16.13 18 17c0 1.42-2.46 3-6 3s-6-1.58-6-3c0-.87.91-1.77 2.37-2.35a1 1 0 0 0-.74-1.86C5.36 13.69 4 15.26 4 17c0 2.8 3.51 5 8 5s8-2.2 8-5c0-1.74-1.36-3.31-3.63-4.21M11 9.86V17a1 1 0 0 0 2 0V9.86a4 4 0 1 0-2 0M12 4a2 2 0 1 1-2 2 2 2 0 0 1 2-2" })
), CV = h(tr), er = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.32 5.05-6-2h-.07a.7.7 0 0 0-.14 0h-.43L9 5 3.32 3.05a1 1 0 0 0-.9.14A1 1 0 0 0 2 4v14a1 1 0 0 0 .68.95l6 2a1 1 0 0 0 .62 0l5.7-1.9L20.68 21a1.2 1.2 0 0 0 .32 0 .94.94 0 0 0 .58-.19A1 1 0 0 0 22 20V6a1 1 0 0 0-.68-.95M8 18.61l-4-1.33V5.39l4 1.33Zm6-1.33-4 1.33V6.72l4-1.33Zm6 1.33-4-1.33V5.39l4 1.33Z" })
), uV = h(er), lr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.42 4.12a1 1 0 0 0-.54-.54 1 1 0 0 0-.38-.08h-4a1 1 0 0 0 0 2h1.59l-2.4 2.4a7 7 0 1 0 1.41 1.41l2.4-2.4V8.5a1 1 0 0 0 2 0v-4a1 1 0 0 0-.08-.38M14 17a5 5 0 1 1 0-7 5 5 0 0 1 0 7" })
), VV = h(lr), rr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.265 5.274a6.7 6.7 0 0 0-3.273.855 6.728 6.728 0 1 0 0 11.745 6.726 6.726 0 1 0 3.273-12.6m-5.028 11.183a4.7 4.7 0 0 1-1.518.273 4.728 4.728 0 0 1 0-9.456 4.7 4.7 0 0 1 1.518.273 6.687 6.687 0 0 0 0 8.91m1.755-1.057a4.695 4.695 0 0 1 0-6.796 4.695 4.695 0 0 1 0 6.796m3.273 1.33a4.7 4.7 0 0 1-1.519-.273 6.687 6.687 0 0 0 0-8.91 4.7 4.7 0 0 1 1.519-.273 4.728 4.728 0 0 1 0 9.456" })
), SV = h(rr), hr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5.41 4H7a1 1 0 0 0 0-2H3a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 2 3v4a1 1 0 0 0 2 0V5.41l5.79 5.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM21 16a1 1 0 0 0-1 1v1.59l-5.79-5.8a1 1 0 0 0-1.42 1.42l5.8 5.79H17a1 1 0 0 0 0 2h4a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 21v-4a1 1 0 0 0-1-1" })
), LV = h(hr), or = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.38 5.76a1 1 0 0 0-.47-.61l-5.2-3a1 1 0 0 0-1.37.36L12 6.57 9.66 2.51a1 1 0 0 0-1.37-.36l-5.2 3a1 1 0 0 0-.47.61 1 1 0 0 0 .1.75l4 6.83A5.9 5.9 0 0 0 6 16a6 6 0 1 0 11.34-2.72l3.9-6.76a1 1 0 0 0 .14-.76M5 6.38l3.46-2L11.68 10A5.94 5.94 0 0 0 8 11.58ZM12 20a4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 1 1 0 8m4-8.45a5.9 5.9 0 0 0-1.86-1.15l-.98-1.83 2.42-4.19 3.46 2Z" })
), ZV = h(or), nr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 6h-2V4h2a1 1 0 0 0 0-2H9a5 5 0 0 0-5 5v14a1 1 0 0 0 2 0V7a3 3 0 0 1 3-3h4v2h-2a3 3 0 0 0-3 3v4.93a3 3 0 0 0 1.34 2.5L11 17.54V18a2 2 0 0 0 2 2v1a1 1 0 0 0 2 0v-1a2 2 0 0 0 2-2v-.46l1.66-1.11a3 3 0 0 0 1.34-2.5V9a3 3 0 0 0-3-3m-1 5h2v1h-1a1 1 0 0 0 0 2h1a1 1 0 0 1-.44.76l-2.1 1.41A1 1 0 0 0 15 17v1h-2v-1a1 1 0 0 0-.45-.83l-2.1-1.41a1 1 0 0 1-.45-.83V9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h-2a1 1 0 0 0 0 2" })
), BV = h(nr), wr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 18H4V4h16ZM7 14.79h2v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2v-2a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1m1-4h2a1 1 0 0 0 1-1v-2h2v2a1 1 0 0 0 1 1h2v2h-2a1 1 0 0 0-1 1v2h-2v-2a1 1 0 0 0-1-1H8Z" })
), FV = h(wr), vr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM17 9h-2V7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-1 4h-2a1 1 0 0 0-1 1v2h-2v-2a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V8h2v2a1 1 0 0 0 1 1h2Z" })
), RV = h(vr), mr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.21 6.417H22V4.083h-7.48l-2.486 9.167h-.068L9.503 4.083H2v2.334h.768a.9.9 0 0 1 .732.694v9.83a.84.84 0 0 1-.732.642H2v2.334h6v-2.334H6.5V7.25h.088l3.457 12.667h2.712L16.26 7.25h.073v10.333h-1.5v2.334H22v-2.334h-.791a.84.84 0 0 1-.709-.641v-9.83a.9.9 0 0 1 .71-.695" })
), UV = h(mr), cr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 17h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2m9-11h-2V5a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3M9 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1H9Zm11 14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7h16Zm0-9H4V9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), $V = h(cr), sr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 10h2a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m14-6h-8V3a1 1 0 0 0-2 0v1H3a1 1 0 0 0-1 1v10a3 3 0 0 0 3 3h4.59l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.29-2.3V21a1 1 0 0 0 2 0v-1.59l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L14.41 18H19a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1m-1 11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6h16ZM7 14h6a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2" })
), yV = h(sr), gr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.991 2.002a1 1 0 0 0-1 1v.637a9.04 9.04 0 0 1-7 3.363h-6a3.003 3.003 0 0 0-3 3v2a3.003 3.003 0 0 0 3 3h.484l-2.403 5.606a1 1 0 0 0 .92 1.394h4a1 1 0 0 0 .918-.606l2.724-6.356a9.03 9.03 0 0 1 6.357 3.325v.637a1 1 0 0 0 2 0v-16a1 1 0 0 0-1-1m-14 11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1v4Zm2.341 7H6.508l2.142-5h1.825Zm10.66-4.478a11.05 11.05 0 0 0-7-2.522h-3v-4h3a11.05 11.05 0 0 0 7-2.522Z" })
), kV = h(gr), ir = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2m6 3H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m0-5h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), bV = h(ir), dr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.21 10.54a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41 3.08 3.08 0 0 0-4.24 0 1 1 0 1 0 1.41 1.41 1 1 0 0 1 1.42 0M15 14H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m2.62-4.87a3.08 3.08 0 0 0-4.24 0 1 1 0 0 0 1.41 1.41 1 1 0 0 1 1.42 0 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), TV = h(dr), pr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m6 3H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m0-5a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), PV = h(pr), fr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20.34 9.32-14-7a3 3 0 0 0-4.08 3.9l2.4 5.37a1.06 1.06 0 0 1 0 .82l-2.4 5.37A3 3 0 0 0 5 22a3.14 3.14 0 0 0 1.35-.32l14-7a3 3 0 0 0 0-5.36Zm-.89 3.57-14 7a1 1 0 0 1-1.35-1.3l2.39-5.37a2 2 0 0 0 .08-.22h6.89a1 1 0 0 0 0-2H6.57a2 2 0 0 0-.08-.22L4.1 5.41a1 1 0 0 1 1.35-1.3l14 7a1 1 0 0 1 0 1.78" })
), DV = h(fr), Er = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.71 14.29a1 1 0 0 0-1.09-.21.9.9 0 0 0-.54.54 1 1 0 1 0 1.84 0 1.2 1.2 0 0 0-.21-.33m8 0a1.047 1.047 0 0 0-1.42 0 1.2 1.2 0 0 0-.21.33.99.99 0 0 0 .21 1.09 1.2 1.2 0 0 0 .33.21.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21.99.99 0 0 0 .21-1.09 1.2 1.2 0 0 0-.21-.33m2.6 4.605a4.97 4.97 0 0 0 1.784-4.817l-1.5-8A5 5 0 0 0 14.68 2H9.319a5 5 0 0 0-4.913 4.078l-1.5 8a4.97 4.97 0 0 0 1.785 4.817l-1.398 1.398a1 1 0 1 0 1.414 1.414l1.87-1.87A5 5 0 0 0 7.818 20h8.362a5 5 0 0 0 1.243-.162l1.869 1.869a1 1 0 0 0 1.414-1.414ZM6.37 6.447A3 3 0 0 1 9.32 4h5.362a3 3 0 0 1 2.948 2.447l.347 1.85a7.955 7.955 0 0 1-11.952 0Zm12.117 10.469A2.99 2.99 0 0 1 16.181 18H7.819a3 3 0 0 1-2.948-3.553l.711-3.792a9.954 9.954 0 0 0 12.836 0l.71 3.792a2.99 2.99 0 0 1-.64 2.469" })
), qV = h(Er), xr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.5 3.73a2 2 0 0 1 2.95-.14A2 2 0 0 1 14 5v3.41a1 1 0 0 0 2 0V5a4 4 0 0 0-7-2.53 1 1 0 1 0 1.5 1.26m8.22 9.54h.2a1 1 0 0 0 1-.81A8 8 0 0 0 20 11a1 1 0 0 0-2 0 5.5 5.5 0 0 1-.11 1.1 1 1 0 0 0 .83 1.17m3 6.06-18-18a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41L8 8.48V11a4 4 0 0 0 6 3.46l1.46 1.46A6 6 0 0 1 6 11a1 1 0 0 0-2 0 8 8 0 0 0 7 7.93V21H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2.07a7.87 7.87 0 0 0 3.85-1.59l3.4 3.4a1 1 0 0 0 1.42-1.41ZM12 13a2 2 0 0 1-2-2v-.52l2.45 2.46A1.7 1.7 0 0 1 12 13" })
), IV = h(xr), Ar = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 15a4 4 0 0 0 4-4V5a4 4 0 0 0-8 0v6a4 4 0 0 0 4 4M10 5a2 2 0 0 1 4 0v6a2 2 0 0 1-4 0Zm10 6a1 1 0 0 0-2 0 6 6 0 0 1-12 0 1 1 0 0 0-2 0 8 8 0 0 0 7 7.93V21H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2.07A8 8 0 0 0 20 11" })
), WV = h(Ar), Mr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 21.005h-5.184a3 3 0 0 0 .143-.591A8.04 8.04 0 0 0 20 13.005a7.95 7.95 0 0 0-2.127-5.422l.637-.638a1 1 0 0 0 .241-.39l.708-2.122a1 1 0 0 0-.241-1.024l-2.122-2.121a1 1 0 0 0-1.024-.242l-2.12.707a1 1 0 0 0-.391.242L7.198 8.358a1 1 0 0 0 0 1.414l-1.416 1.415a1 1 0 0 0 0 1.415l2.122 2.12a1 1 0 0 0 1.414 0l1.414-1.413.002.002a1 1 0 0 0 1.414 0l4.31-4.312A5.96 5.96 0 0 1 18 13.005a6.05 6.05 0 0 1-3.455 5.431 2.976 2.976 0 0 0-5.124.063 7 7 0 0 1-1.12-.554.99.99 0 0 0 .699-.94 1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h1.331a8.8 8.8 0 0 0 3.717 2.473 3 3 0 0 0 .136.527H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2M8.611 12.602l-.708-.707.708-.708.707.708Zm8.318-6.904L11.44 11.19 9.32 9.065l5.489-5.489 1.311-.437 1.247 1.247ZM12 21.005a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), GV = h(Mr), Hr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M2 22h9.5v-9.5H2zm0-10.5h9.5V2H2zM12.5 2v9.5H22V2zm0 20H22v-9.5h-9.5z" })
), OV = h(Hr), Cr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m4-9H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2" })
), NV = h(Cr), ur = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.18 4h2.1a1 1 0 0 0 0-2h-2.1a1 1 0 0 0 0 2M3 11.28a1 1 0 0 0 1-1v-2.1a1 1 0 0 0-2 0v2.1a1 1 0 0 0 1 1M14.46 4a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1h-1a1 1 0 0 0 0 2M21 7.54h-4.54a1 1 0 1 0-2 0H8.54a1 1 0 0 0-1 1v5.92a1 1 0 1 0 0 2V21a1 1 0 0 0 1 1H21a1 1 0 0 0 1-1V8.54a1 1 0 0 0-1-1M20 20H9.54V9.54H20ZM4 2H3a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0 1 1 0 0 0 0-2m0 12.46a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2" })
), QV = h(ur), Vr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 13h6a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 18H4V4h16Z" })
), KV = h(Vr), Sr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm-4-8H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2" })
), jV = h(Sr), Lr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 11H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" })
), JV = h(Lr), Zr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6 7.49a1 1 0 0 0 1-1V5.9l2.88 2.88a3 3 0 0 0 4.24 0l4.59-4.59a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0l-4.58 4.58a1 1 0 0 1-1.42 0L8.41 4.49H9a1 1 0 0 0 0-2H6a1 1 0 0 0-.92.61 1.1 1.1 0 0 0-.08.39v3a1 1 0 0 0 1 1m15.94 7.36a16.27 16.27 0 0 0-19.88 0 2.7 2.7 0 0 0-1 2 2.66 2.66 0 0 0 .78 2.07l1.76 1.8a2.68 2.68 0 0 0 3.46.28l.47-.32a8 8 0 0 1 1-.55 1.85 1.85 0 0 0 1-2.3l-.09-.24a10.5 10.5 0 0 1 5.22 0l-.09.24a1.85 1.85 0 0 0 1 2.3 8 8 0 0 1 1 .55l.47.32a2.58 2.58 0 0 0 1.54.5 2.72 2.72 0 0 0 1.92-.79l1.81-1.82a2.66 2.66 0 0 0 .69-2.06 2.69 2.69 0 0 0-1.06-1.98m-1.14 2.64L19 19.3a.68.68 0 0 1-.86.1c-.19-.14-.38-.27-.59-.4a12 12 0 0 0-1.09-.61l.4-1.09a1 1 0 0 0-.6-1.28 12.42 12.42 0 0 0-8.5 0 1 1 0 0 0-.6 1.28l.4 1.1a10 10 0 0 0-1.1.6l-.58.4a.66.66 0 0 1-.88-.1l-1.8-1.81A.67.67 0 0 1 3 17a.76.76 0 0 1 .28-.53 14.29 14.29 0 0 1 17.44 0A.76.76 0 0 1 21 17a.67.67 0 0 1-.2.49" })
), YV = h(Zr), Br = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 2H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1h10Zm0-3H7V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Z" })
), XV = h(Br), Fr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m12.71 16.29-.15-.12a.8.8 0 0 0-.18-.09L12.2 16a1 1 0 0 0-.91.27 1.2 1.2 0 0 0-.21.33 1 1 0 0 0 1.3 1.31 1.5 1.5 0 0 0 .33-.22 1 1 0 0 0 .21-1.09 1 1 0 0 0-.21-.31M16 2H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Z" })
), _V = h(Fr), Rr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.88 14.12 9.73 14l-.18-.1-.18-.05a1 1 0 0 0-.9.27.8.8 0 0 0-.22.33.94.94 0 0 0 0 .76 1.07 1.07 0 0 0 .54.54 1 1 0 0 0 .38.08 1.1 1.1 0 0 0 .39-.08.9.9 0 0 0 .32-.22 1 1 0 0 0 .22-.32 1 1 0 0 0 .07-.38.84.84 0 0 0-.08-.38.9.9 0 0 0-.21-.33M3.51 8.76a1 1 0 0 0 .71-.3l4.24-4.24a1 1 0 0 0 0-1.41 1 1 0 0 0-1.41 0L2.81 7.05a1 1 0 0 0 0 1.41 1 1 0 0 0 .7.3m17.68 6.78a1 1 0 0 0-1.41 0l-4.24 4.24a1 1 0 0 0 .7 1.71 1 1 0 0 0 .71-.3L21.19 17a1 1 0 0 0 0-1.46m.17-5.66a3 3 0 0 0-.87-2.12l-4.25-4.25a3.08 3.08 0 0 0-4.24 0L3.51 12a3 3 0 0 0 0 4.24l4.25 4.25a3 3 0 0 0 4.24 0L20.49 12a3 3 0 0 0 .87-2.12m-2.29.71-8.48 8.48a1 1 0 0 1-1.42 0l-4.24-4.24a1 1 0 0 1 0-1.42l8.48-8.48a1 1 0 0 1 1.42 0l4.24 4.24a1 1 0 0 1 0 1.42" })
), zV = h(Rr), Ur = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.48 13.13a.7.7 0 0 0-.05-.2 1 1 0 0 0-.08-.17 1 1 0 0 0-.1-.16l-.16-.13-.09-.09-14.72-8.5a1 1 0 0 0-1 1.74l11.49 6.63H3.5a1 1 0 0 0-1 1v4a3 3 0 0 0 3 3h13a3 3 0 0 0 3-3v-4s-.02-.08-.02-.12m-2 4.12a1 1 0 0 1-1 1H5.5a1 1 0 0 1-1-1v-3h15Zm-3 0a1 1 0 1 0-1-1 1 1 0 0 0 1.02 1Z" })
), aS = h(Ur), $r = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m5.86-1.55L4.71 2.29a1 1 0 0 0-1.42 1.42L4.59 5H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14.59l2.7 2.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Zm-.74 2.09 1.34 1.34A1 1 0 0 1 12 13a1 1 0 0 1-1-1 1 1 0 0 1 .12-.46M4 17a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.59l3.1 3.1A3 3 0 0 0 9 12a3 3 0 0 0 3 3 3 3 0 0 0 1.9-.69L16.59 17ZM20 5h-7.34a1 1 0 0 0 0 2H20a1 1 0 0 1 1 1v7.34a1 1 0 1 0 2 0V8a3 3 0 0 0-3-3m-1 7a1 1 0 1 0-1 1 1 1 0 0 0 1-1" })
), tS = h($r), yr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 1H4a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3M8 21H4a1 1 0 0 1-1-1v-1.18A3 3 0 0 0 4 19h4Zm0-4H4a1 1 0 0 1-1-1v-1.18A3 3 0 0 0 4 15h4Zm0-4H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4Zm6 8h-4v-6h4Zm0-8h-4V3h4Zm7 7a1 1 0 0 1-1 1h-4v-2h4a3 3 0 0 0 1-.18Zm0-4a1 1 0 0 1-1 1h-4v-2h4a3 3 0 0 0 1-.18Zm0-4a1 1 0 0 1-1 1h-4V3h4a1 1 0 0 1 1 1Zm-3-5a1 1 0 1 0 1 1 1 1 0 0 0-1-1M6 9a1 1 0 1 0-1-1 1 1 0 0 0 1 1" })
), eS = h(yr), kr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m2-6H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-9-7a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), lS = h(kr), br = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m10.46 6 .54-.59V9a1 1 0 0 0 2 0V5.41l.54.55A1 1 0 0 0 15 6a1 1 0 0 0 0-1.42l-2.29-2.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21L9 4.54A1 1 0 0 0 10.46 6M12 12a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m-7-1a1 1 0 1 0 1-1 1 1 0 0 0-1 1m14 0a1 1 0 1 0-1 1 1 1 0 0 0 1-1m1-7h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h4a1 1 0 0 0 0-2H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3" })
), rS = h(br), Tr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 17H2a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2m0 4H2a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2M6 7a1 1 0 1 0 1 1 1 1 0 0 0-1-1m14-6H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-9-7a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m6-2a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), hS = h(Tr), Pr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 12a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m-.71-6.29a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21L15 7.46A1 1 0 1 0 13.54 6l-.54.59V3a1 1 0 0 0-2 0v3.59L10.46 6A1 1 0 0 0 9 7.46ZM19 15a1 1 0 1 0-1 1 1 1 0 0 0 1-1m1-7h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3M5 15a1 1 0 1 0 1-1 1 1 0 0 0-1 1" })
), oS = h(Pr), Dr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 2H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M7 20v-2a2 2 0 0 1 2 2Zm10 0h-2a2 2 0 0 1 2-2Zm0-4a4 4 0 0 0-4 4h-2a4 4 0 0 0-4-4V8h10Zm4-6h-2V7a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3H3V4h18Zm-9 5a3 3 0 1 0-3-3 3 3 0 0 0 3 3m0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1" })
), nS = h(Dr), qr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 7h-3V6a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3m-9-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm-6 4a1 1 0 0 1 1-1h1a2 2 0 0 1-2 2Zm1 9a1 1 0 0 1-1-1v-1a2 2 0 0 1 2 2Zm15-1a1 1 0 0 1-1 1h-1a2 2 0 0 1 2-2Zm0-3a4 4 0 0 0-4 4H8a4 4 0 0 0-4-4v-2a4 4 0 0 0 4-4h8a4 4 0 0 0 4 4Zm0-4a2 2 0 0 1-2-2h1a1 1 0 0 1 1 1Zm-8 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), wS = h(qr), Ir = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 11a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m7-9h-3V5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3m-9-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4ZM4 9a1 1 0 0 1 1-1h1a2 2 0 0 1-2 2Zm1 11a1 1 0 0 1-1-1v-1a2 2 0 0 1 2 2Zm15-1a1 1 0 0 1-1 1h-1a2 2 0 0 1 2-2Zm0-3a4 4 0 0 0-4 4H8a4 4 0 0 0-4-4v-4a4 4 0 0 0 4-4h8a4 4 0 0 0 4 4Zm0-6a2 2 0 0 1-2-2h1a1 1 0 0 1 1 1Z" })
), vS = h(Ir), Wr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 19a1 1 0 0 0 .38-.08 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .12-.16.6.6 0 0 0 .09-.17.6.6 0 0 0 .08-.18 1.4 1.4 0 0 0 0-.2 1 1 0 0 0-.08-.38.9.9 0 0 0-.54-.54A1 1 0 0 0 8.8 17l-.18.06a.6.6 0 0 0-.17.09 1 1 0 0 0-.16.12 1 1 0 0 0-.21.33A1 1 0 0 0 8 18a1 1 0 0 0 1 1m-3.71-.29a1.2 1.2 0 0 0 .33.21A1 1 0 0 0 6 19h.19a.6.6 0 0 0 .19-.06.8.8 0 0 0 .18-.09l.15-.12a1.2 1.2 0 0 0 .21-.33A.84.84 0 0 0 7 18a1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.06-.18.6.6 0 0 0-.09-.17 1 1 0 0 0-.12-.16 1 1 0 0 0-1.09-.21 1 1 0 0 0-.33.21 1 1 0 0 0-.12.16.6.6 0 0 0-.09.17.6.6 0 0 0-.1.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 .08.38 1.2 1.2 0 0 0 .21.33M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3h16Zm0-5H4v-4h4a1 1 0 0 0 .71-.29L10 8.46l2.8 3.2a1 1 0 0 0 .72.34 1 1 0 0 0 .71-.29L15.91 10H20Zm0-6h-4.5a1 1 0 0 0-.71.29l-1.24 1.25-2.8-3.2a1 1 0 0 0-1.46 0L7.59 8H4V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), mS = h(Wr), Gr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2.64l-.58 1a2 2 0 0 0 0 2 2 2 0 0 0 1.75 1h6.46A2 2 0 0 0 17 21a2 2 0 0 0 0-2l-.59-1H19a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3M8.77 20 10 18h4l1.2 2ZM20 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1h16Zm0-3H4V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), cS = h(Gr), Or = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 0 0-2.14.24h-.12a10 10 0 0 0-.1 19.44h.14A9.6 9.6 0 0 0 12 22a10 10 0 0 0 0-20m-2 17.74a8 8 0 0 1 0-15.48 8 8 0 0 1 0 15.48m4.53-.16a10 10 0 0 0 0-15.16 8 8 0 0 1 0 15.16" })
), sS = h(Or), Nr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.64 13a1 1 0 0 0-1.05-.14 8.05 8.05 0 0 1-3.37.73 8.15 8.15 0 0 1-8.14-8.1 8.6 8.6 0 0 1 .25-2A1 1 0 0 0 8 2.36a10.14 10.14 0 1 0 14 11.69 1 1 0 0 0-.36-1.05m-9.5 6.69A8.14 8.14 0 0 1 7.08 5.22v.27a10.15 10.15 0 0 0 10.14 10.14 9.8 9.8 0 0 0 2.1-.22 8.11 8.11 0 0 1-7.18 4.32Z" })
), gS = h(Nr), Qr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 19H8a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2m9-4h-1.16A8.2 8.2 0 0 0 20 12.05a1 1 0 0 0-.34-.93 1 1 0 0 0-1-.19 6 6 0 0 1-1.92.32 6.06 6.06 0 0 1-6.06-6 7 7 0 0 1 .1-1 1 1 0 0 0-.35-.92 1 1 0 0 0-1-.18A8.06 8.06 0 0 0 4 10.68 8 8 0 0 0 5.27 15H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2m-3.72 0H7.83a6 6 0 0 1 .88-9.36 8.06 8.06 0 0 0 8.05 7.61 7 7 0 0 0 .79 0A6.1 6.1 0 0 1 16.28 15M16 19h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2" })
), iS = h(Qr), Kr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 10a4 4 0 1 0-4-4 4 4 0 0 0 4 4m0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2m-1.15 8.47a1 1 0 0 0-1.7 0l-1 1.63-3.29-5.6a1 1 0 0 0-1.72 0l-7 12A1 1 0 0 0 3 22h18a1 1 0 0 0 .85-1.53ZM10.45 20H4.74L10 11l2.94 5-1.25 2Zm2.35 0 1.49-2.37.71-1.06 1-1.68L19.2 20Z" })
), dS = h(Kr), jr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.85 17.47-5-8a1 1 0 0 0-1.7 0l-1 1.63-3.29-5.6a1 1 0 0 0-1.72 0l-7 12A1 1 0 0 0 3 19h18a1 1 0 0 0 .85-1.53M10.45 17H4.74L10 8l2.93 5Zm2.35 0 2.2-3.43 1-1.68L19.2 17Z" })
), pS = h(jr), Jr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a7 7 0 0 0-7 7v6a7 7 0 0 0 14 0V9a7 7 0 0 0-7-7m5 13a5 5 0 0 1-10 0V9a5 5 0 0 1 4-4.9V12a1 1 0 0 0 2 0V4.1A5 5 0 0 1 17 9Z" })
), fS = h(Jr), Yr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 6a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m0-4a7 7 0 0 0-7 7v6a7 7 0 0 0 14 0V9a7 7 0 0 0-7-7m5 13a5 5 0 0 1-10 0V9a5 5 0 0 1 10 0Z" })
), ES = h(Yr), Xr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a7 7 0 0 0-7 7v6a7 7 0 0 0 14 0V9a7 7 0 0 0-7-7M7 9a5 5 0 0 1 4-4.9V10H7Zm10 6a5 5 0 0 1-10 0v-3h10Zm0-5h-4V4.1A5 5 0 0 1 17 9Z" })
), xS = h(Xr), _r = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m13.41 12 6.3-6.29a1 1 0 1 0-1.42-1.42L12 10.59l-6.29-6.3a1 1 0 0 0-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l6.29-6.3 6.29 6.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), AS = h(_r), zr = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.12 2.21a1 1 0 0 0-.86-.21l-8 2a1 1 0 0 0-.76 1v10.35A3.45 3.45 0 0 0 8 15a3.5 3.5 0 1 0 3.5 3.5v-7.72L18.74 9h.07l.19-.15.15-.1a1 1 0 0 0 .13-.15.8.8 0 0 0 .1-.15.6.6 0 0 0 .06-.18.6.6 0 0 0 0-.19.2.2 0 0 0 0-.08V3a1 1 0 0 0-.32-.79M8 20a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 8 20m9.5-12.78-6 1.5V5.78l6-1.5Z" })
), MS = h(zr), a9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 7.33a1 1 0 0 0 1-1v-.55l6-1.5v2.94L14.7 8.3a1 1 0 0 0 .24 2h.24L20.24 9h.07l.19-.09.15-.1a1 1 0 0 0 .13-.15.8.8 0 0 0 .1-.15.6.6 0 0 0 .06-.18.7.7 0 0 0 0-.19A.24.24 0 0 0 21 8V3a1 1 0 0 0-1.24-1l-8 2A1 1 0 0 0 11 5v1.33a1 1 0 0 0 1 1m9.71 13-9-9-9-9a1 1 0 0 0-1.42 1.38l8.71 8.7v2.94A3.45 3.45 0 0 0 9.5 15a3.5 3.5 0 1 0 3.5 3.5v-4.09l7.29 7.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM9.5 20a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9.5 20" })
), HS = h(a9), t9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.65 2.24a1 1 0 0 0-.8-.23l-13 2A1 1 0 0 0 7 5v10.35A3.45 3.45 0 0 0 5.5 15 3.5 3.5 0 1 0 9 18.5v-7.64l11-1.69v4.18a3.45 3.45 0 0 0-1.5-.35 3.5 3.5 0 1 0 3.5 3.5V3a1 1 0 0 0-.35-.76M5.5 20A1.5 1.5 0 1 1 7 18.5 1.5 1.5 0 0 1 5.5 20m13-2a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5M20 7.14 9 8.83v-3l11-1.66Z" })
), CS = h(t9), e9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6h-1a3 3 0 0 0-3 3v8a1 1 0 0 0 2 0v-4h3v4a1 1 0 0 0 2 0V9a3 3 0 0 0-3-3m1 5h-3V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1ZM8 6a1 1 0 0 0-1 1v5.76L3.89 6.55A1 1 0 0 0 2 7v10a1 1 0 0 0 2 0v-5.76l3.11 6.21A1 1 0 0 0 8 18a1 1 0 0 0 .23 0A1 1 0 0 0 9 17V7a1 1 0 0 0-1-1m4-2a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1" })
), uS = h(e9), l9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20.17 9.23-14-5.78a3 3 0 0 0-4 3.7L3.71 12l-1.58 4.85A3 3 0 0 0 2.94 20a3 3 0 0 0 2 .8 3 3 0 0 0 1.15-.23l14.05-5.78a3 3 0 0 0 0-5.54ZM5.36 18.7a1 1 0 0 1-1.06-.19 1 1 0 0 1-.27-1L5.49 13h13.73Zm.13-7.7L4 6.53a1 1 0 0 1 .27-1A1 1 0 0 1 5 5.22a1 1 0 0 1 .39.08L19.22 11Z" })
), VS = h(l9), r9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.41 8.65v-.06a10 10 0 0 0-18.78-.06.9.9 0 0 0-.08.24A9.9 9.9 0 0 0 2 12a10 10 0 1 0 19.41-3.35M12 4a8 8 0 0 1 6.92 4h-1.2a3 3 0 0 0-4.62.22A3.2 3.2 0 0 0 12 8a3.2 3.2 0 0 0-1.1.22A3 3 0 0 0 6.28 8h-1.2A8 8 0 0 1 12 4m4.5 6a1 1 0 1 1-1-1 1 1 0 0 1 1 1m-7 0a1 1 0 1 1-1-1 1 1 0 0 1 1 1M12 20a8 8 0 0 1-8-8 8.2 8.2 0 0 1 .26-2H5.5a3 3 0 0 0 6 .18 1 1 0 0 1 1 0 3 3 0 0 0 6-.18h1.24a8.2 8.2 0 0 1 .26 2 8 8 0 0 1-8 8m2.36-5.77a3.76 3.76 0 0 1-4.72 0 1 1 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1 1 0 1 0-1.28-1.54" })
), SS = h(r9), h9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 11h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m0 4h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m-6-6h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2m10-6H7a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v10a3 3 0 0 0 3 3h13a4 4 0 0 0 4-4V4a1 1 0 0 0-1-1M6 18a1 1 0 0 1-2 0V9h2Zm14-1a2 2 0 0 1-2 2H7.82A3 3 0 0 0 8 18V5h12Zm-9-4h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m0 4h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2" })
), LS = h(h9), o9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m19.44 5.34-.06-.07a10 10 0 0 0-14.76 0l-.06.07A10 10 0 1 0 22 12a9.93 9.93 0 0 0-2.56-6.66M12 4a7.87 7.87 0 0 1 3.86 1H8.14A7.87 7.87 0 0 1 12 4M5.76 7h12.48a8 8 0 0 1 1.69 4H4.07a8 8 0 0 1 1.69-4M12 20a8 8 0 0 1-7.93-7h15.86A8 8 0 0 1 12 20M8 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1m6 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3 9.93a1 1 0 0 0 .49.13 1 1 0 0 0 .87-.51A3 3 0 0 1 15 16a1 1 0 0 0 0-2 5 5 0 0 0-4.37 2.57 1 1 0 0 0 .37 1.36" })
), ZS = h(o9), n9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 20h-1.24L15.37 4.2A3 3 0 0 0 12.48 2h-1a3 3 0 0 0-2.85 2.2L4.24 20H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2M10.56 4.73a1 1 0 0 1 1-.73h1a1 1 0 0 1 1 .73L14.35 8h-4.7ZM9.09 10h5.82L16 14H8ZM6.32 20l1.11-4h9.14l1.11 4Z" })
), BS = h(n9), w9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 6a1 1 0 0 0-1 1v10a3 3 0 0 1-3 3H7a1 1 0 0 0 0 2h10a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1m-3 9V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3M10 4h2v4.86l-.36-.3a1 1 0 0 0-1.28 0l-.36.3ZM4 15V5a1 1 0 0 1 1-1h3v7a1 1 0 0 0 1.65.76L11 10.63l1.35 1.13A1 1 0 0 0 13 12a1.1 1.1 0 0 0 .42-.09A1 1 0 0 0 14 11V4h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1" })
), FS = h(w9), v9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2m0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m4-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1m-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2Z" })
), RS = h(v9), m9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 10h-2V8a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1m-6 1v1H9V9h3v1h-1a1 1 0 0 0-1 1m5 4h-3v-3h3Zm6 3.28V5.72A2 2 0 1 0 18.28 3H5.72A2 2 0 1 0 3 5.72v12.56A2 2 0 1 0 5.72 21h12.56A2 2 0 1 0 21 18.28m-2 0a1.9 1.9 0 0 0-.72.72H5.72a1.9 1.9 0 0 0-.72-.72V5.72A1.9 1.9 0 0 0 5.72 5h12.56a1.9 1.9 0 0 0 .72.72Z" })
), US = h(m9), c9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 18.28v-6.56A2 2 0 1 0 18.28 9H15V5.72A2 2 0 1 0 12.28 3H5.72A2 2 0 1 0 3 5.72v6.56A2 2 0 1 0 5.72 15H9v3.28A2 2 0 1 0 11.72 21h6.56A2 2 0 1 0 21 18.28M8 10a2 2 0 0 0 1 1.72V13H5.72a1.9 1.9 0 0 0-.72-.72V5.72A1.9 1.9 0 0 0 5.72 5h6.56a1.9 1.9 0 0 0 .72.72V9h-1.28A2 2 0 0 0 8 10m5 1v1.28a1.9 1.9 0 0 0-.72.72H11v-1.28a1.9 1.9 0 0 0 .72-.72Zm6 7.28a1.9 1.9 0 0 0-.72.72h-6.56a1.9 1.9 0 0 0-.72-.72V15h1.28A2 2 0 1 0 15 12.28V11h3.28a1.9 1.9 0 0 0 .72.72Z" })
), $S = h(c9), s9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 7.57-5.27-5.28a1.05 1.05 0 0 0-.71-.29H8.27a1.05 1.05 0 0 0-.71.29L2.29 7.57a1 1 0 0 0-.29.7v7.46a1 1 0 0 0 .29.7l5.27 5.28a1.05 1.05 0 0 0 .71.29h7.46a1.05 1.05 0 0 0 .71-.29l5.27-5.28a1 1 0 0 0 .29-.7V8.27a1 1 0 0 0-.29-.7M20 15.31 15.31 20H8.69L4 15.31V8.69L8.69 4h6.62L20 8.69Z" })
), yS = h(s9), g9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m5 10c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5 2.2 5 5" })
), kS = h(g9), i9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.97 5c-3.643 0-3.643 5.123-3.643 6.858 0 1.953 0 7.142 3.66 7.142 3.655 0 3.655-5.162 3.655-7.105C15.642 7.32 14.406 5 11.97 5m.017 12c-1.101 0-1.66-1.73-1.66-5.195 0-2.191.285-4.805 1.644-4.805 1.454 0 1.67 3.067 1.67 4.895 0 3.388-.556 5.105-1.654 5.105m.001-16C5.937 1 1.71 5.482 1.71 11.9 1.71 17.356 5.557 23 11.995 23c6.434 0 10.278-5.644 10.278-11.101C22.273 5.482 18.044 1 11.988 1m.007 20C6.81 21 3.71 16.373 3.71 11.9 3.71 6.577 7.037 3 11.988 3c4.956 0 8.285 3.577 8.285 8.899 0 4.474-3.096 9.101-8.278 9.101" })
), bS = h(i9), d9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.996 2c-5.462 0-9.278 3.958-9.278 9.899C2.718 17.189 6.43 22 12.004 22c5.567 0 9.278-4.819 9.278-10.101 0-5.94-3.824-9.899-9.286-9.899m0 18.384c-3.397 0-3.77-5.013-3.77-8.71V11.6c0-3.996.598-8.23 3.748-8.23s3.786 4.361 3.786 8.357c0 3.696-.367 8.657-3.764 8.657" })
), TS = h(d9), p9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.44 13c-.22 0-.45-.07-.67-.12a9.4 9.4 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.2 12.2 0 0 1-2.66-2 12.2 12.2 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10 10 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2-.76 3 3 0 0 0 1-2.25v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.34.75 1.06 1.06 0 0 1-.82.25A17 17 0 0 1 4.07 5.22a1.1 1.1 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79q.06.41.15.81a11 11 0 0 0 .46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.5 14.5 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .57-.52l.62-1.4a14 14 0 0 0 1.58.46q.4.09.81.15a1 1 0 0 1 .79 1Zm1.92-16.32a1 1 0 0 0-.54-.54 1 1 0 0 0-.38-.08h-4a1 1 0 1 0 0 2h1.58l-3.29 3.3a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l3.3-3.29v1.58a1 1 0 0 0 2 0v-4a1 1 0 0 0-.08-.38" })
), PS = h(p9), f9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-9 2h4v3.13l-1.45-1a1 1 0 0 0-1.1 0l-1.45 1Zm10 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v5a1 1 0 0 0 .53.88 1 1 0 0 0 1-.05L12 8.2l2.45 1.63A1 1 0 0 0 16 9V4h3a1 1 0 0 1 1 1Z" })
), DS = h(f9), E9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 13a1.49 1.49 0 0 0-1 2.61V17a1 1 0 0 0 2 0v-1.39A1.49 1.49 0 0 0 12 13m5-4V7A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3M9 7a3 3 0 0 1 6 0v2H9Zm9 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z" })
), qS = h(E9), x9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.885 13.993c1.75-.901 2.282-3.35 2.282-3.35s-2.305-.99-4.055-.085a4.2 4.2 0 0 0-1.698 1.822 9 9 0 0 0 .06-.99 7 7 0 0 0 1.582-4.726C16.712 3.901 13.71 2 13.71 2s-2.442 2.583-2.095 5.35a6.82 6.82 0 0 0 2.518 4.03 9 9 0 0 1-.076 1.01 4.4 4.4 0 0 0-1.9-2.058c-1.774-.853-4.049.203-4.049.203s.603 2.432 2.376 3.284a4.72 4.72 0 0 0 3.258.076 9.4 9.4 0 0 1-1.458 2.9 4.4 4.4 0 0 0-2.012-1.98c-1.813-.763-4.028.404-4.028.404s.72 2.402 2.536 3.162a3.74 3.74 0 0 0 1.735.243 9.42 9.42 0 0 1-5.845 2.032.672.672 0 0 0 0 1.344 10.79 10.79 0 0 0 7.968-3.527 4.95 4.95 0 0 0 3.336 1.194c1.96-.207 3.34-2.299 3.34-2.299s-1.792-1.753-3.75-1.543a3.5 3.5 0 0 0-1.36.456 10.7 10.7 0 0 0 .895-2.275 5.15 5.15 0 0 0 3.786-.013" })
), IS = h(x9), A9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 3c-1.6-.8-2.7-1-5.2-1H6v12.1h5.8c2.3 0 4-.1 5.5-1.1 1.6-1.1 2.6-3 2.5-5 .1-2.1-1-4-2.8-5m-4.6 8.6H8.9v-7h3.3c3 0 4.5 1 4.5 3.4.1 2.6-1.8 3.6-4.3 3.6M6 22h2.9v-5.3H6z" })
), WS = h(A9), M9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 1h-8a3 3 0 0 0-3 3H6a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h6a1 1 0 0 1 1 1v1a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2v-1a3 3 0 0 0-3-3H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3m-3 16v4h-2v-4Zm4-11a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Z" })
), GS = h(M9), H9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.42 15.54a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0m0-8.49a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0m4.95 10a1 1 0 1 0 1 1 1 1 0 0 0-1-1.05Zm-6-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1.05Zm6-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1.05Zm3.54 2.05a1 1 0 1 0 1.41 0 1 1 0 0 0-1.41-.05Zm6.3 0a11 11 0 1 0-7.85 15.74 3.87 3.87 0 0 0 2.5-1.65 4.2 4.2 0 0 0 .61-3.19 5.7 5.7 0 0 1-.1-1 5 5 0 0 1 3-4.56 3.84 3.84 0 0 0 2.06-2.25 4 4 0 0 0-.22-3.11Zm-1.7 2.44a1.9 1.9 0 0 1-1 1.09A7 7 0 0 0 15.37 17a7.3 7.3 0 0 0 .14 1.4 2.16 2.16 0 0 1-.31 1.65 1.8 1.8 0 0 1-1.21.8 8.7 8.7 0 0 1-1.62.15 9 9 0 0 1-9-9.28A9.05 9.05 0 0 1 11.85 3h.51a9 9 0 0 1 8.06 5 2 2 0 0 1 .09 1.52ZM12.37 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), OS = h(H9), C9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 10h-4V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v5H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1M7 20H4V10h3Zm5 0H9V4h3Zm5 0h-3v-8h3Zm4-16h-1V3a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0V6h1a1 1 0 0 0 0-2" })
), NS = h(C9), u9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.46 5.83A1 1 0 0 0 20.7 5h-.11A37.5 37.5 0 0 0 3.41 5H3.3a1 1 0 0 0-.76.8 35.5 35.5 0 0 0 0 12.34 1 1 0 0 0 .76.8h.11A37.6 37.6 0 0 0 12 20a37.6 37.6 0 0 0 8.59-1h.11a1 1 0 0 0 .76-.8 35.5 35.5 0 0 0 0-12.37M19.6 17.17a35.4 35.4 0 0 1-15.2 0 33.2 33.2 0 0 1 0-10.34 35.4 35.4 0 0 1 15.2 0 33.2 33.2 0 0 1 0 10.34" })
), QS = h(u9), V9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.54 5.16a1 1 0 0 0-1-.07A21.3 21.3 0 0 1 12 6.73a21.3 21.3 0 0 1-8.58-1.64 1 1 0 0 0-1 .07A1 1 0 0 0 2 6v12a1 1 0 0 0 .46.84 1 1 0 0 0 1 .07A21.3 21.3 0 0 1 12 17.27a21.3 21.3 0 0 1 8.58 1.64A1.1 1.1 0 0 0 21 19a1 1 0 0 0 .54-.16A1 1 0 0 0 22 18V6a1 1 0 0 0-.46-.84M20 16.52a24.8 24.8 0 0 0-8-1.25 24.8 24.8 0 0 0-8 1.25v-9a24.8 24.8 0 0 0 8 1.25 24.8 24.8 0 0 0 8-1.25Z" })
), KS = h(V9), S9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.27 12a21.1 21.1 0 0 1 1.64-8.58 1 1 0 0 0-.07-1A1 1 0 0 0 18 2H6a1 1 0 0 0-.84.46 1 1 0 0 0-.07 1A21.1 21.1 0 0 1 6.73 12a21.1 21.1 0 0 1-1.64 8.58 1 1 0 0 0 .07 1A1 1 0 0 0 6 22h12a1 1 0 0 0 .84-.46 1 1 0 0 0 .07-1A21.1 21.1 0 0 1 17.27 12m-.75 8h-9a24.8 24.8 0 0 0 1.25-8 24.8 24.8 0 0 0-1.29-8h9a24.8 24.8 0 0 0-1.25 8 24.8 24.8 0 0 0 1.29 8" })
), jS = h(S9), L9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m18.08 12.42-6.18 6.19a4.25 4.25 0 0 1-6-6l8-8a2.57 2.57 0 0 1 3.54 0 2.52 2.52 0 0 1 0 3.54l-6.9 6.89A.75.75 0 1 1 9.42 14l5.13-5.12a1 1 0 0 0-1.42-1.42L8 12.6a2.74 2.74 0 0 0 0 3.89 2.82 2.82 0 0 0 3.89 0l6.89-6.9a4.5 4.5 0 0 0-6.36-6.36l-8 8A6.25 6.25 0 0 0 13.31 20l6.19-6.18a1 1 0 1 0-1.42-1.42Z" })
), JS = h(L9), Z9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 13.5H3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m8-5H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), YS = h(Z9), B9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 14h2a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m6 2H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m6-14H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-5 2v3.29l-1.51-.84a1 1 0 0 0-1 0L10 7.29V4Zm6 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v5a1 1 0 0 0 .5.86 1 1 0 0 0 1 0L12 8.47l2.51 1.4A1 1 0 0 0 15 10a1 1 0 0 0 1-1V4h3a1 1 0 0 1 1 1Z" })
), XS = h(B9), F9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 7h-3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0v-2h2a3 3 0 0 0 3-3v-1a3 3 0 0 0-3-3m1 4a1 1 0 0 1-1 1h-2V9h2a1 1 0 0 1 1 1Zm-2-9a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), _S = h(F9), R9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 6H9a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0v-3h2a4 4 0 0 0 0-8m0 6h-2V8h2a2 2 0 0 1 0 4m7-10H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), zS = h(R9), U9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 7.54h-4.54V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12.46a1 1 0 0 0 1 1h4.54V21a1 1 0 0 0 1 1H21a1 1 0 0 0 1-1V8.54a1 1 0 0 0-1-1M20 20H9.54v-4.54a1 1 0 0 0-1-1H4V4h10.46v4.54a1 1 0 0 0 1 1H20Z" })
), aL = h(U9), $9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4 14.46a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2M8.18 4h2.1a1 1 0 0 0 0-2h-2.1a1 1 0 0 0 0 2m6.28 0a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1h-1a1 1 0 0 0 0 2M4 2H3a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0 1 1 0 0 0 0-2m-1 9.28a1 1 0 0 0 1-1v-2.1a1 1 0 0 0-2 0v2.1a1 1 0 0 0 1 1M15.82 20h-2.1a1 1 0 1 0 0 2h2.1a1 1 0 0 0 0-2M21 7.54h-1a1 1 0 0 0 0 2 1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m0 5.18a1 1 0 0 0-1 1v2.1a1 1 0 0 0 2 0v-2.1a1 1 0 0 0-1-1m-4.54-5.18a1 1 0 1 0-2 0H8.54a1 1 0 0 0-1 1v5.92a1 1 0 1 0 0 2 1 1 0 0 0 2 0h5.92a1 1 0 0 0 1-1V9.54a1 1 0 1 0 0-2m-2 6.92H9.54V9.54h4.92ZM21 19a1 1 0 0 0-1 1 1 1 0 0 0 0 2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1M9.54 20a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2" })
), tL = h($9), y9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 7a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1m2-5a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m2-13a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1" })
), eL = h(y9), k9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 2a3 3 0 0 0-3 3v14a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-2 0V5a1 1 0 0 1 2 0ZM8 2a3 3 0 0 0-3 3v14a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-2 0V5a1 1 0 0 1 2 0Z" })
), lL = h(k9), b9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.437 7.104a4 4 0 0 0-.573-.523 4.72 4.72 0 0 0-1.157-3.74C17.623 1.619 15.775 1 13.214 1H7.001a1.89 1.89 0 0 0-1.864 1.592l-2.59 16.406a1.533 1.533 0 0 0 1.516 1.785h2.664l-.082.52A1.467 1.467 0 0 0 8.093 23h3.235a1.76 1.76 0 0 0 1.75-1.47l.641-4.031.011-.055h.299c4.032 0 6.55-1.993 7.285-5.762a5.15 5.15 0 0 0-.877-4.578m-12.595 6.6-.714 4.535-.086.544H4.606L7.097 3h6.117c1.936 0 3.318.404 3.993 1.164a2.97 2.97 0 0 1 .607 2.733l-.018.113c-.012.076-.023.15-.044.246a5.85 5.85 0 0 1-2.005 3.67 6.68 6.68 0 0 1-4.217 1.183H9.707a1.88 1.88 0 0 0-1.865 1.595m11.51-2.405c-.552 2.828-2.243 4.145-5.323 4.145h-.484a1.76 1.76 0 0 0-1.75 1.473l-.65 4.074L8.717 21l.478-3.034.612-3.853h1.719c.157 0 .295-.023.448-.029.359-.012.717-.026 1.053-.068.205-.025.393-.072.59-.108.273-.05.545-.1.801-.171.19-.053.368-.122.55-.186.238-.085.474-.174.697-.279q.25-.12.486-.257a7 7 0 0 0 .613-.392q.214-.153.415-.32a7 7 0 0 0 .537-.52c.113-.12.228-.237.333-.367a7 7 0 0 0 .48-.693c.076-.122.161-.235.232-.363a8.3 8.3 0 0 0 .52-1.154q.015-.034.03-.068.007-.014.014-.032a4.3 4.3 0 0 1 .026 2.193" })
), rL = h(b9), T9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 7.24a1 1 0 0 0-.29-.71l-4.24-4.24a1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29l-2.83 2.83L2.29 16.05a1 1 0 0 0-.29.71V21a1 1 0 0 0 1 1h4.24a1 1 0 0 0 .76-.29l10.87-10.93L21.71 8a1.2 1.2 0 0 0 .22-.33 1 1 0 0 0 0-.24.7.7 0 0 0 0-.14ZM6.83 20H4v-2.83l9.93-9.93 2.83 2.83ZM18.17 8.66l-2.83-2.83 1.42-1.41 2.82 2.82Z" })
), hL = h(T9), P9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.59 9.17-9-6.54a1 1 0 0 0-1.18 0l-9 6.54a1 1 0 0 0-.36 1.12l3.44 10.58a1 1 0 0 0 1 .69h11.07a1 1 0 0 0 1-.69L22 10.29a1 1 0 0 0-.41-1.12m-4.75 10.39H7.16l-3-9.2L12 4.68l7.82 5.68Z" })
), oL = h(P9), D9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.758 10.758a3 3 0 1 0-3-3 3.003 3.003 0 0 0 3 3m0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1m8.484 6.484a3 3 0 1 0 3 3 3.003 3.003 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m3.465-12.949a1 1 0 0 0-1.414 0l-14 14a1 1 0 1 0 1.414 1.414l14-14a1 1 0 0 0 0-1.414" })
), nL = h(D9), q9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.44 13c-.22 0-.45-.07-.67-.12a9.4 9.4 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.2 12.2 0 0 1-2.66-2 12.2 12.2 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10 10 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2-.76 3 3 0 0 0 1-2.25v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.34.75 1.06 1.06 0 0 1-.82.25A17 17 0 0 1 4.07 5.22a1.1 1.1 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79q.06.41.15.81a11 11 0 0 0 .46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.5 14.5 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .57-.52l.62-1.4a14 14 0 0 0 1.58.46q.4.09.81.15a1 1 0 0 1 .79 1Z" })
), wL = h(q9), I9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.44 13c-.22 0-.45-.07-.67-.12a9.4 9.4 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.2 12.2 0 0 1-2.66-2 12.2 12.2 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10 10 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2-.76 3 3 0 0 0 1-2.25v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.34.75 1 1 0 0 1-.82.25A17 17 0 0 1 4.07 5.22a1.1 1.1 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79q.06.41.15.81a11 11 0 0 0 .46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.5 14.5 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .57-.52l.62-1.4a14 14 0 0 0 1.58.46q.4.09.81.15a1 1 0 0 1 .79 1ZM19 10a1 1 0 0 0 1-1V5a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1m-4 0a1 1 0 0 0 1-1V5a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1" })
), vL = h(I9), W9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.91 13.1a1 1 0 0 0 .85.47A1 1 0 0 0 6.61 12a17 17 0 0 1-2.47-6.85 1 1 0 0 1 .24-.81A1 1 0 0 1 5.13 4h3a1 1 0 0 1 1 .8c0 .23.08.44.13.67v.13a10.3 10.3 0 0 0 .47 1.54l-1.39.66a1 1 0 0 0-.52.57 1 1 0 0 0 0 .77c.1.21.2.42.32.64a1 1 0 0 0 1.37.37 1 1 0 0 0 .5-.94l.57-.21a2 2 0 0 0 1.05-2.48 9 9 0 0 1-.39-1.3v-.1c0-.2-.08-.4-.11-.58A3 3 0 0 0 8.16 2h-3a3 3 0 0 0-2.28 1 3 3 0 0 0-.72 2.39 19.05 19.05 0 0 0 2.75 7.71m14.61-.21-.6-.11h-.08a9 9 0 0 1-1.33-.39 2 2 0 0 0-2.47 1l-.21.46a12.4 12.4 0 0 1-1.92-1.37l8.8-8.79a1 1 0 1 0-1.42-1.42l-18 18a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.59-4.6a19.1 19.1 0 0 0 10.29 4.73 3 3 0 0 0 .4 0 3 3 0 0 0 2-.75 3 3 0 0 0 1-2.25v-3a3 3 0 0 0-2.47-2.93m.48 6a1 1 0 0 1-.34.75 1 1 0 0 1-.81.24 17.07 17.07 0 0 1-9.14-4.18l1.77-1.77a14.7 14.7 0 0 0 3.38 2.21 1 1 0 0 0 .77 0 1 1 0 0 0 .57-.52l.62-1.41a12 12 0 0 0 1.6.47h.11l.69.13a1 1 0 0 1 .78 1Z" })
), mL = h(W9), G9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m19.85 5.56 1.79-1.79a1 1 0 1 0-1.41-1.41l-1.79 1.79-1.8-1.79a1 1 0 0 0-1.41 1.41L17 5.56l-1.79 1.8a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0L18.44 7l1.79 1.79a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41ZM19.44 13c-.22 0-.45-.07-.67-.12a9.4 9.4 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.2 12.2 0 0 1-2.66-2 12.2 12.2 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10 10 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2-.76 3 3 0 0 0 1-2.25v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.34.75 1.06 1.06 0 0 1-.82.25A17 17 0 0 1 4.07 5.22a1.1 1.1 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79q.06.41.15.81a11 11 0 0 0 .46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.5 14.5 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .57-.52l.62-1.4a14 14 0 0 0 1.58.46q.4.09.81.15a1 1 0 0 1 .79 1Z" })
), cL = h(G9), O9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.41 13c-.22 0-.45-.07-.67-.12a10 10 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.46a13.2 13.2 0 0 1-2.67-2 13.2 13.2 0 0 1-2-2.67l.46-.21a2 2 0 0 0 1-2.48 10.5 10.5 0 0 1-.39-1.32c-.05-.22-.09-.45-.12-.67a3 3 0 0 0-3-2.49H5a3 3 0 0 0-2.24 1 3 3 0 0 0-.73 2.4 19.07 19.07 0 0 0 5.41 11 19.07 19.07 0 0 0 11 5.41 2.6 2.6 0 0 0 .39 0 3 3 0 0 0 2-.76 3 3 0 0 0 1-2.24v-3A3 3 0 0 0 19.41 13m.49 6a1 1 0 0 1-.33.74 1 1 0 0 1-.82.25 17.16 17.16 0 0 1-9.87-4.84A17.16 17.16 0 0 1 4 5.25a1 1 0 0 1 .25-.82A1 1 0 0 1 5 4.1h3a1 1 0 0 1 1 .78c0 .27.09.55.15.82a11 11 0 0 0 .46 1.54l-1.4.66a1 1 0 0 0-.52.56 1 1 0 0 0 0 .76 14.5 14.5 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .56-.52l.63-1.4a12 12 0 0 0 1.58.46c.26.06.54.11.81.15a1 1 0 0 1 .78 1ZM14 2h-.7a1 1 0 0 0 .17 2H14a6 6 0 0 1 6 6v.53a1 1 0 0 0 .91 1.08h.08a1 1 0 0 0 1-.91V10A8 8 0 0 0 14 2m2 8a1 1 0 0 0 2 0 4 4 0 0 0-4-4 1 1 0 0 0 0 2 2 2 0 0 1 2 2" })
), sL = h(O9), N9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.44 13c-.22 0-.45-.07-.67-.12a9.4 9.4 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.2 12.2 0 0 1-2.66-2 12.2 12.2 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10 10 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2-.76 3 3 0 0 0 1-2.25v-3a3 3 0 0 0-2.47-2.9m.5 6a1 1 0 0 1-.34.75 1.05 1.05 0 0 1-.82.25A17 17 0 0 1 4.07 5.22a1.1 1.1 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79q.06.41.15.81a11 11 0 0 0 .46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.5 14.5 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .57-.52l.62-1.4a14 14 0 0 0 1.58.46q.4.09.81.15a1 1 0 0 1 .79 1Z" })
), gL = h(N9), Q9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 4a1 1 0 0 0 .71-1.7 1 1 0 0 0-1.42 0 1 1 0 0 0-.21.32A.84.84 0 0 0 19 3a1 1 0 0 0 1 1m0 9a1 1 0 0 0-1 1v.39l-1.48-1.48a2.77 2.77 0 0 0-3.93 0l-.7.7-2.48-2.49a2.86 2.86 0 0 0-3.93 0L5 12.6V7a1 1 0 0 1 1-1h10a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1M6 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0l3.17 3.17 4.29 4.3Zm13-1a1 1 0 0 1-.18.53L14.31 15l.7-.7a.78.78 0 0 1 1.1 0L19 17.22Zm1-14a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1" })
), iL = h(Q9), K9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.51 12.48a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-4.48a1 1 0 1 0 1 1 1 1 0 0 0-1-1M12 10a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m8.5-1.43a3 3 0 0 0-2.3-.29 2.9 2.9 0 0 0-1.09.56L5.51 2.13a1 1 0 0 0-1 0A1 1 0 0 0 4 3v13.17A2.94 2.94 0 0 0 2 19a3 3 0 0 0 2.92 3h.58a18.57 18.57 0 0 0 16.11-9.41 3 3 0 0 0-1.1-4.02ZM6 4.73l9.89 5.71A12.57 12.57 0 0 1 6 16Zm13.87 6.88A16.58 16.58 0 0 1 5 20a1 1 0 0 1-1-1 1 1 0 0 1 .3-.72A1 1 0 0 1 5 18h.51a14.5 14.5 0 0 0 12.62-7.37.9.9 0 0 1 .58-.44 1 1 0 0 1 .75.09 1 1 0 0 1 .42 1.33Z" })
), dL = h(K9), j9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.12 16.23a5 5 0 0 0-2.3-3L16.71 12l-.48-5.47a1 1 0 0 0-.49-.78l-3-1.72a1 1 0 0 0-1 0 1 1 0 0 0-.52.84l-.15 3.9-1.75-1-2.86-3.85a1 1 0 0 0-1.78.41l-.87 4.61a3 3 0 0 0 1.39 3.29l14.06 8.11a1 1 0 0 0 1.36-.34 4.9 4.9 0 0 0 .5-3.77M19.24 18 6.2 10.5a1 1 0 0 1-.44-1.13l.46-2.44 1.66 2.2a1 1 0 0 0 .3.27l3.35 1.94a1 1 0 0 0 1.5-.83l.16-3.9 1.09.63.48 5.47a1 1 0 0 0 .5.78L17.82 15a2.9 2.9 0 0 1 1.36 1.78 2.74 2.74 0 0 1 .06 1.22" })
), pL = h(j9), J9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 5.08a3.08 3.08 0 0 0-5.26-2.18l-2.81 2.81-6.49-2.16a1 1 0 0 0-1 .24L4.06 6.15a1 1 0 0 0 .29 1.61l5.18 2.35-2.6 2.6-1.71-.86a1 1 0 0 0-1.16.15l-1.77 1.81a1 1 0 0 0 0 1.41l6.49 6.49a1 1 0 0 0 1.41 0L12 19.94a1 1 0 0 0 .19-1.16l-.86-1.71 2.6-2.6 2.35 5.18a1 1 0 0 0 1.61.29l2.36-2.36a1 1 0 0 0 .24-1l-2.16-6.49 2.77-2.83a3.05 3.05 0 0 0 .9-2.18m-2.32.77-3.24 3.24a1 1 0 0 0-.24 1l2.16 6.48-.9.9-2.35-5.17a1 1 0 0 0-.73-.57 1 1 0 0 0-.89.28l-4.12 4.16a1 1 0 0 0-.19 1.15L10 19l-.56.56-5.03-5.04L5 14l1.71.86a1 1 0 0 0 1.15-.19L12 10.51a1 1 0 0 0-.29-1.62L6.5 6.54l.9-.9 6.48 2.16a1 1 0 0 0 1-.24l3.24-3.24a1.07 1.07 0 0 1 1.53 0 1 1 0 0 1 .32.76 1.06 1.06 0 0 1-.29.77" })
), fL = h(J9), Y9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M23 9.32a1.06 1.06 0 0 0-.1-.76 4.93 4.93 0 0 0-6.75-1.8L14 8 9 5.65a1 1 0 0 0-.92 0l-3 1.73a1 1 0 0 0-.5.84 1 1 0 0 0 .46.87l3.3 2.08-1.74 1-4.78.58a1 1 0 0 0-.53 1.75l3.54 3.06a3 3 0 0 0 3.55.44L22.5 9.93a1 1 0 0 0 .5-.61m-15.53 7a1 1 0 0 1-1.2-.18l-1.9-1.63 2.73-.33a1 1 0 0 0 .38-.13l3.36-1.93a1 1 0 0 0 .5-.85 1 1 0 0 0-.47-.86l-3.3-2.09 1.1-.63 5 2.32a1 1 0 0 0 .92 0l2.56-1.48a3 3 0 0 1 3.36.29Z" })
), EL = h(Y9), X9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.75 12a1 1 0 0 0-.55-.89l-6.12-3.06v-4a3.08 3.08 0 1 0-6.16 0v4L2.8 11.11a1 1 0 0 0-.55.89v3.33a1 1 0 0 0 .43.83 1 1 0 0 0 .92.11l5.32-2V18l-1.82.6a1 1 0 0 0-.68.95V22a1 1 0 0 0 .3.71 1 1 0 0 0 .7.29h9.17a1 1 0 0 0 1-1v-2.5a1 1 0 0 0-.68-.95L15.08 18v-3.72l5.32 2a1 1 0 0 0 .92-.11 1 1 0 0 0 .43-.83Zm-7.31-.1a1 1 0 0 0-.93.11 1 1 0 0 0-.43.82v5.84a1 1 0 0 0 .69.95l1.81.6V21H8.41v-.78l1.81-.6a1 1 0 0 0 .69-.95v-5.84a1 1 0 0 0-.43-.82 1 1 0 0 0-.93-.11l-5.31 2v-1.28l6.11-3.06a1 1 0 0 0 .56-.89V4.08a1.08 1.08 0 1 1 2.16 0v4.59a1 1 0 0 0 .56.89l6.11 3.06v1.27Z" })
), xL = h(X9), _9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m16 10.27-5-2.89a2 2 0 0 0-3 1.73v5.78a2 2 0 0 0 1 1.73 2 2 0 0 0 2 0l5-2.89a2 2 0 0 0 0-3.46M15 12l-5 2.89V9.11zM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), AL = h(_9), z9 = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.54 9 8.88 3.46a3.42 3.42 0 0 0-5.13 3v11.12A3.42 3.42 0 0 0 7.17 21a3.43 3.43 0 0 0 1.71-.46L18.54 15a3.42 3.42 0 0 0 0-5.92Zm-1 4.19-9.66 5.62a1.44 1.44 0 0 1-1.42 0 1.42 1.42 0 0 1-.71-1.23V6.42a1.42 1.42 0 0 1 .71-1.23A1.5 1.5 0 0 1 7.17 5a1.54 1.54 0 0 1 .71.19l9.66 5.58a1.42 1.42 0 0 1 0 2.46Z" })
), ML = h(z9), ah = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6h-3V3a1 1 0 0 0-2 0v3h-4V3a1 1 0 0 0-2 0v3H5a1 1 0 0 0 0 2h1v5a1 1 0 0 0 .29.71L9 16.41V21a1 1 0 0 0 2 0v-4h2v4a1 1 0 0 0 2 0v-4.59l2.71-2.7A1 1 0 0 0 18 13V8h1a1 1 0 0 0 0-2m-3 6.59L13.59 15h-3.18L8 12.59V8h8ZM11 13h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2" })
), HL = h(ah), th = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m4-9h-3V8a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2" })
), CL = h(th), eh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 13h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2h-2V9a1 1 0 0 0-2 0v2H9a1 1 0 0 0 0 2M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 18H4V4h16Z" })
), uL = h(eh), lh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2" })
), VL = h(lh), rh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.79 7.13a1 1 0 0 0-.79-.38H8v-.5a2 2 0 0 1 1.46-1.92 1.5 1.5 0 0 0 1 .42h1a1.5 1.5 0 0 0 0-3h-1a1.49 1.49 0 0 0-1.17.57A4 4 0 0 0 6 6.25v.5H5a1 1 0 0 0-.79.38A1 1 0 0 0 4 8l.62 2.49a3 3 0 0 0 2.48 2.22l.78 7H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2h-.88l.78-7a3 3 0 0 0 2.45-2.23L20 8a1 1 0 0 0-.21-.87M14.1 19.75H9.9l-.78-7h5.76ZM17.41 10a1 1 0 0 1-1 .76H7.56a1 1 0 0 1-1-.76l-.28-1.25h11.44Z" })
), SL = h(rh), hh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.87 11.5-4.5-7.79a1 1 0 0 0-.87-.5h-9a1 1 0 0 0-.87.5l-4.5 7.79a1 1 0 0 0 0 1l4.5 7.79a1 1 0 0 0 .87.5h9a1 1 0 0 0 .87-.5l4.5-7.79a1 1 0 0 0 0-1m-6 7.29H8.08L4.15 12l3.93-6.79h7.84L19.85 12Z" })
), LL = h(hh), oh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.5 5.5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1 .5.5 0 0 1-1 0 1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1 .5.5 0 0 1-1 0 1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1 .5.5 0 0 1-1 0 1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1 .5.5 0 0 1 0 1 1 1 0 0 0-1 1v3a1 1 0 0 0 1 1 .5.5 0 0 1 0 1 1 1 0 0 0-1 1v3a1 1 0 0 0 1 1 .5.5 0 0 1 0 1 1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1 .5.5 0 0 1 1 0 1 1 0 0 0 1 1h3a1 1 0 0 0 1-1 .5.5 0 0 1 1 0 1 1 0 0 0 1 1h3a1 1 0 0 0 1-1 .5.5 0 0 1 1 0 1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1 .5.5 0 0 1 0-1 1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1 .5.5 0 0 1 0-1 1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1 .5.5 0 0 1 0-1m-1-1.79a2.5 2.5 0 0 0 0 4.58v1.42a2.5 2.5 0 0 0 0 4.58v1.42a2.5 2.5 0 0 0 0 4.58v1.21h-1.21a2.5 2.5 0 0 0-4.58 0h-1.42a2.5 2.5 0 0 0-4.58 0H8.29a2.5 2.5 0 0 0-4.58 0H2.5v-1.21a2.5 2.5 0 0 0 0-4.58v-1.42a2.5 2.5 0 0 0 0-4.58V8.29a2.5 2.5 0 0 0 0-4.58V2.5h1.21a2.5 2.5 0 0 0 4.58 0h1.42a2.5 2.5 0 0 0 4.58 0h1.42a2.5 2.5 0 0 0 4.58 0h1.21ZM12 5a7 7 0 0 0 0 14 6.93 6.93 0 0 0 3.5-.94 1 1 0 1 0-1-1.73A5 5 0 1 1 17 12v.5a.83.83 0 0 1-.83.83.84.84 0 0 1-.84-.83V9.67a1 1 0 0 0-1.78-.6 3.25 3.25 0 0 0-1.55-.4 3.33 3.33 0 0 0 0 6.66 3.28 3.28 0 0 0 2.17-.82 2.84 2.84 0 0 0 4.83-2V12a7 7 0 0 0-7-7m0 8.33A1.33 1.33 0 1 1 13.33 12 1.32 1.32 0 0 1 12 13.33" })
), ZL = h(oh), nh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 11h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1M6 12h5a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2m16-8H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-1 14H3V6h18ZM6 16h5a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2" })
), BL = h(nh), wh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 15h-5.18a3 3 0 0 0 .18-1v-1h2.5a1 1 0 0 0 0-2H11v-1a1.95 1.95 0 0 1 3.63-1 1 1 0 0 0 1.74-1A4 4 0 0 0 9 10v1H8a1 1 0 0 0 0 2h1v1a1 1 0 0 1-1 1 1 1 0 0 0 0 2h8a1 1 0 0 0 0-2M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1m0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9" })
), FL = h(wh), vh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 20H8a4.92 4.92 0 0 0 1-3v-3h6a1 1 0 0 0 0-2H9V8.89a4.89 4.89 0 0 1 9.13-2.44 1 1 0 0 0 1.37.36 1 1 0 0 0 .37-1.36A6.9 6.9 0 0 0 7 8.89V12H4a1 1 0 0 0 0 2h3v3a3 3 0 0 1-3 3 1 1 0 0 0 0 2h16a1 1 0 0 0 0-2" })
), RL = h(vh), mh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m10.21 6.21.79-.8V10a1 1 0 0 0 2 0V5.41l.79.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.5-2.5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.5 2.5a1 1 0 0 0 1.42 1.42M18 7.56A1 1 0 1 0 16.56 9a6.45 6.45 0 1 1-9.12 0A1 1 0 1 0 6 7.56a8.46 8.46 0 1 0 12 0" })
), UL = h(mh), ch = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-2 14h-6v-4h6Zm0-6h-7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8h10ZM5 6V4h14v2Z" })
), $L = h(ch), sh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.29 11.71a1 1 0 0 0 1.42 0l4-4a1 1 0 1 0-1.42-1.42L11 9.59l-1.29-1.3a1 1 0 0 0-1.42 1.42ZM21 14h-1V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Z" })
), yL = h(sh), gh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.41 13h2.42a1 1 0 0 0 .71-.29l3.58-3.58a1 1 0 0 0 0-1.41l-2.42-2.4a1 1 0 0 0-1.41 0L8.71 8.9a1 1 0 0 0-.3.7V12a1 1 0 0 0 1 1m1-3L13 7.44l1 1L11.42 11h-1ZM21 14h-1V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Z" })
), kL = h(gh), ih = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 14h-1V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v11H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Zm-9-2a1 1 0 0 0 .83-.45l1.33-2 1.13 1.14a1 1 0 0 0 .81.29 1 1 0 0 0 .73-.45l2-3a1 1 0 0 0-1.66-1.1l-1.33 2-1.13-1.14A1 1 0 0 0 10.9 7a1 1 0 0 0-.73.45l-2 3a1 1 0 0 0 .28 1.38A.94.94 0 0 0 9 12" })
), bL = h(ih), dh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.17 10.55a1 1 0 0 0 .73.45 1 1 0 0 0 .81-.29l1.13-1.14 1.33 2A1 1 0 0 0 15 12a.94.94 0 0 0 .55-.17 1 1 0 0 0 .28-1.38l-2-3A1 1 0 0 0 13.1 7a1 1 0 0 0-.81.29l-1.13 1.14-1.33-2a1 1 0 1 0-1.66 1.1ZM21 14h-1V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Z" })
), TL = h(dh), ph = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 10h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2m11 4h-1V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Z" })
), PL = h(ph), fh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 14h-1V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Zm-8.39-1.74a1.73 1.73 0 0 0 1.76 0l3-1.74a1.76 1.76 0 0 0 0-3l-3-1.74a1.73 1.73 0 0 0-1.76 0 1.71 1.71 0 0 0-.87 1.52v3.48a1.71 1.71 0 0 0 .87 1.48m1.13-4.58L13 9l-2.28 1.32Z" })
), DL = h(fh), Eh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 14h-1V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Zm-8-4h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1V7a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2" })
), qL = h(Eh), xh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.29 11.71a1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 9l1.3-1.29a1 1 0 1 0-1.42-1.42L12 7.59l-1.29-1.3a1 1 0 0 0-1.42 1.42L10.59 9l-1.3 1.29a1 1 0 0 0 0 1.42M21 14h-1V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Z" })
), IL = h(xh), Ah = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 14h-1V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Z" })
), WL = h(Ah), Mh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m13.41 12 3.3-3.29a1 1 0 1 0-1.42-1.42l-4 4a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM8 7a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1" })
), GL = h(Mh), Hh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m14.71 5.78-9.48-9.46A1 1 0 0 0 11.5 2h-6a1 1 0 0 0-.71.29l-2.5 2.49a1 1 0 0 0-.29.71v6a1.05 1.05 0 0 0 .29.71l9.49 9.5a1.05 1.05 0 0 0 .71.29 1 1 0 0 0 .71-.29l8.51-8.51a1 1 0 0 0 .29-.71 1.05 1.05 0 0 0-.29-.7m-9.22 7.81L4 11.09V5.9L5.9 4h5.18l8.5 8.49Z" })
), OL = h(Hh), Ch = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 10a1 1 0 1 0 1 1 1 1 0 0 0-1-1M3.71 2.29a1 1 0 0 0-1.42 1.42L4.62 6A3 3 0 0 0 2 9v6a3 3 0 0 0 3 3h1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1.59l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM6 15v1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1.59l6 6H7a1 1 0 0 0-1 1m10 5H8v-4h6.59L16 17.41Zm3-14h-1V3a1 1 0 0 0-1-1H8.66a1 1 0 0 0 0 2H16v2h-3.34a1 1 0 0 0 0 2H19a1 1 0 0 1 1 1v6a.4.4 0 0 1 0 .11 1 1 0 0 0 .78 1.18h.2a1 1 0 0 0 1-.8A3 3 0 0 0 22 15V9a3 3 0 0 0-3-3" })
), NL = h(Ch), uh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 10a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12-4h-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3h1a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3M8 4h8v2H8Zm8 16H8v-4h8Zm4-5a1 1 0 0 1-1 1h-1v-1a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), QL = h(uh), Vh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.992 14.502a1 1 0 0 0-1 1v1.782a7.97 7.97 0 0 1-2-5.282 7 7 0 0 1 .052-.88 1 1 0 1 0-1.985-.24 9 9 0 0 0-.067 1.12 9.96 9.96 0 0 0 2.417 6.5H2.992a1 1 0 1 0 0 2h4a.98.98 0 0 0 .794-.422q.018-.02.037-.043c.007-.01.007-.022.013-.032a1 1 0 0 0 .106-.258 1 1 0 0 0 .032-.156c.003-.03.018-.057.018-.089v-4a1 1 0 0 0-1-1m1.5-8.5H6.709a7.97 7.97 0 0 1 5.283-2 7 7 0 0 1 .88.053 1 1 0 0 0 .24-1.987 9 9 0 0 0-1.12-.066 9.96 9.96 0 0 0-6.5 2.417V3.002a1 1 0 0 0-2 0v4a1 1 0 0 0 .039.195 1 1 0 0 0 .141.346l.012.017a1 1 0 0 0 .244.246c.011.008.017.02.028.028.014.01.03.013.045.021a1 1 0 0 0 .18.084 1 1 0 0 0 .261.053c.018 0 .032.01.05.01h4a1 1 0 0 0 0-2m11.96 10.804a1 1 0 0 0-.141-.345l-.011-.017a1 1 0 0 0-.245-.246c-.011-.008-.016-.02-.028-.028-.01-.007-.023-.007-.034-.014a1.2 1.2 0 0 0-.41-.136c-.032-.003-.059-.018-.091-.018h-4a1 1 0 0 0 0 2h1.782a7.97 7.97 0 0 1-5.282 2 7 7 0 0 1-.88-.054 1 1 0 0 0-.24 1.987 9 9 0 0 0 1.12.067 9.96 9.96 0 0 0 6.5-2.417v1.417a1 1 0 0 0 2 0v-4a1 1 0 0 0-.04-.195Zm.54-11.304a1 1 0 0 0 0-2h-4a1 1 0 0 0-.192.039l-.007.001a1 1 0 0 0-.34.14l-.02.013a1 1 0 0 0-.245.244c-.008.01-.02.016-.028.027-.007.01-.007.023-.014.034a1.2 1.2 0 0 0-.136.413c-.003.03-.018.057-.018.089v4a1 1 0 1 0 2 0V6.719a7.98 7.98 0 0 1 2 5.283 7 7 0 0 1-.053.88 1 1 0 0 0 .872 1.113 1 1 0 0 0 .122.007 1 1 0 0 0 .991-.88 9 9 0 0 0 .068-1.12 9.96 9.96 0 0 0-2.417-6.5Z" })
), KL = h(Vh), Sh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 9h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-1 4h-2v-2h2Zm8 0a1 1 0 0 0 0-2h-2V9h2a1 1 0 0 0 0-2h-2.18A3 3 0 0 0 17 5.18V3a1 1 0 0 0-2 0v2h-2V3a1 1 0 0 0-2 0v2H9V3a1 1 0 0 0-2 0v2.18A3 3 0 0 0 5.18 7H3a1 1 0 0 0 0 2h2v2H3a1 1 0 0 0 0 2h2v2H3a1 1 0 0 0 0 2h2.18A3 3 0 0 0 7 18.82V21a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 2 0v-2.18A3 3 0 0 0 18.82 17H21a1 1 0 0 0 0-2h-2v-2Zm-4 3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Z" })
), jL = h(Sh), Lh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m22 3-3 15.1-9.1 3-7.9-3 .8-4.1h3.4l-.4 1.7 4.8 1.8 5.5-1.8.8-3.8H3.2l.7-3.4h13.6l.5-2.1H4.3L5 3z" })
), JL = h(Lh), Zh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.54 6.29 19 4.75l-1.41-1.41a1 1 0 0 0-1.42 1.42l1 1-.83 2.49a3 3 0 0 0 .73 3.07l2.95 3V19a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H14V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-3h1a1 1 0 0 1 1 1v2a3 3 0 0 0 6 0V9.83a5 5 0 0 0-1.46-3.54M12 19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7h8Zm0-9H4V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Zm8 1.42-1.54-1.54a1 1 0 0 1-.24-1l.51-1.54.39.4A3 3 0 0 1 20 9.83Z" })
), YL = h(Zh), Bh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 22H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1a4 4 0 0 1 7.3-2.18A3.86 3.86 0 0 1 14 6h3a1 1 0 0 1 1 1v3a4 4 0 0 1 2.18 7.3A3.86 3.86 0 0 1 18 18v3a1 1 0 0 1-1 1M5 8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11v-3.18a1 1 0 0 1 .42-.82 1 1 0 0 1 .91-.13 1.77 1.77 0 0 0 1.74-.23 2 2 0 0 0 .93-1.37 2 2 0 0 0-.48-1.59 1.89 1.89 0 0 0-2.17-.55 1 1 0 0 1-.91-.13 1 1 0 0 1-.42-.82V8h-3.2a1 1 0 0 1-1-1.33 1.77 1.77 0 0 0-.23-1.74 1.94 1.94 0 0 0-3-.43A2 2 0 0 0 8 6a1.9 1.9 0 0 0 .13.67A1 1 0 0 1 7.18 8Z" })
), XL = h(Bh), Fh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 21H4a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h4a1 1 0 0 0 0-2m14-6a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 0 0 2h4a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1M20 1h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 1 1v4a1 1 0 0 0 2 0V4a3 3 0 0 0-3-3M2 9a1 1 0 0 0 1-1V4a1 1 0 0 1 1-1h4a1 1 0 0 0 0-2H4a3 3 0 0 0-3 3v4a1 1 0 0 0 1 1m8-4H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1M9 9H7V7h2Zm5 2h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1m1-4h2v2h-2Zm-5 6H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-1 4H7v-2h2Zm5-1a1 1 0 0 0 1-1 1 1 0 0 0 0-2h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m4-3a1 1 0 0 0-1 1v3a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-4 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), _L = h(Fh), Rh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 15.29a2 2 0 0 0-.12.15.8.8 0 0 0-.09.18.6.6 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2.84.84 0 0 0 .08.38.9.9 0 0 0 .54.54.94.94 0 0 0 .76 0 .9.9 0 0 0 .54-.54A1 1 0 0 0 13 16a1 1 0 0 0-.29-.71 1 1 0 0 0-1.42 0M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m0-13a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.73 1A1 1 0 0 1 12 9a1 1 0 0 1 0 2 1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-.18A3 3 0 0 0 12 7" })
), zL = h(Rh), Uh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.333 9.5A3.5 3.5 0 0 0 8.8 7.75a1 1 0 0 0 1.733 1A1.5 1.5 0 0 1 11.833 8a1.5 1.5 0 1 1 0 3h-.003a1 1 0 0 0-.19.039 1 1 0 0 0-.198.04 1 1 0 0 0-.155.105 1 1 0 0 0-.162.11 1 1 0 0 0-.117.174 1 1 0 0 0-.097.144 1 1 0 0 0-.043.212 1 1 0 0 0-.035.176v1l.002.011v.491a1 1 0 0 0 1 .998h.003a1 1 0 0 0 .998-1.002l-.002-.662A3.49 3.49 0 0 0 15.333 9.5m-4.203 6.79a1 1 0 0 0 .7 1.71 1.04 1.04 0 0 0 .71-.29 1.015 1.015 0 0 0 0-1.42 1.034 1.034 0 0 0-1.41 0" })
), aZ = h(Uh), $h = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 12a1 1 0 0 0 0 2 5 5 0 0 1 5 5 1 1 0 0 0 2 0 7 7 0 0 0-7-7m0-8a1 1 0 0 0 0 2 13 13 0 0 1 13 13 1 1 0 0 0 2 0A15 15 0 0 0 5 4m0 4a1 1 0 0 0 0 2 9 9 0 0 1 9 9 1 1 0 0 0 2 0A11 11 0 0 0 5 8" })
), tZ = h($h), yh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 7.75C9 5 6.42 3.24 6.31 3.17a1 1 0 0 0-1.12 0C5.08 3.25 2.5 5 2.5 7.75a3.25 3.25 0 0 0 6.5 0M5.75 9A1.25 1.25 0 0 1 4.5 7.75 3.66 3.66 0 0 1 5.75 5.3 3.6 3.6 0 0 1 7 7.75 1.25 1.25 0 0 1 5.75 9m6.06 1.17a1 1 0 0 0-1.12 0c-.17.12-4.19 2.9-4.19 7.08a4.75 4.75 0 0 0 9.5 0c0-4.25-4-6.97-4.19-7.08M11.25 20a2.75 2.75 0 0 1-2.75-2.75c0-2.31 1.81-4.17 2.76-5 .94.79 2.74 2.63 2.74 5A2.75 2.75 0 0 1 11.25 20m6.81-17.83a1 1 0 0 0-1.12 0c-.14.1-3.44 2.38-3.44 5.83a4 4 0 0 0 8 0c0-3.49-3.3-5.74-3.44-5.83M17.5 10a2 2 0 0 1-2-2 5.44 5.44 0 0 1 2-3.72 5.4 5.4 0 0 1 2 3.72 2 2 0 0 1-2 2" })
), eZ = h(yh), kh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.5 8c0-3.49-3.3-5.74-3.44-5.83a1 1 0 0 0-1.12 0C5.8 2.27 2.5 4.55 2.5 8a4 4 0 0 0 8 0m-4 2a2 2 0 0 1-2-2 5.44 5.44 0 0 1 2-3.72A5.4 5.4 0 0 1 8.5 8a2 2 0 0 1-2 2m11.56-7.83a1 1 0 0 0-1.12 0c-.14.1-3.44 2.38-3.44 5.83a4 4 0 0 0 8 0c0-3.49-3.3-5.74-3.44-5.83M17.5 10a2 2 0 0 1-2-2 5.44 5.44 0 0 1 2-3.72 5.4 5.4 0 0 1 2 3.72 2 2 0 0 1-2 2m-4.44 2.17a1 1 0 0 0-1.12 0c-.14.1-3.44 2.38-3.44 5.83a4 4 0 0 0 8 0c0-3.49-3.3-5.74-3.44-5.83M12.5 20a2 2 0 0 1-2-2 5.44 5.44 0 0 1 2-3.72 5.4 5.4 0 0 1 2 3.72 2 2 0 0 1-2 2" })
), lZ = h(kh), bh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.103 10.438a1.786 1.786 0 1 0 2.44.654 1.786 1.786 0 0 0-2.44-.654m8.005 1.938q-.176-.201-.371-.403.136-.144.264-.287c1.605-1.804 2.283-3.614 1.655-4.701-.602-1.043-2.393-1.354-4.636-.918q-.331.065-.659.146-.063-.216-.133-.43C14.467 3.49 13.238 1.999 11.982 2c-1.204 0-2.368 1.397-3.111 3.558q-.11.32-.203.644-.219-.054-.44-.1c-2.366-.485-4.271-.165-4.898.924-.601 1.043.027 2.75 1.528 4.472q.224.255.46.5-.279.286-.525.571c-1.465 1.698-2.057 3.376-1.457 4.415.62 1.074 2.498 1.425 4.785.975q.278-.055.553-.124.1.351.221.697C9.635 20.649 10.792 22 11.992 22c1.24 0 2.482-1.453 3.235-3.659q.089-.262.169-.541.355.088.715.156c2.203.417 3.952.09 4.551-.95.619-1.075-.02-2.877-1.554-4.63M4.07 7.452c.386-.67 1.943-.932 3.986-.512q.196.04.399.09a20.5 20.5 0 0 0-.422 2.678A21 21 0 0 0 5.93 11.4q-.219-.227-.427-.465C4.216 9.461 3.708 8.081 4.07 7.452m3.887 5.728c-.51-.387-.985-.783-1.416-1.181.43-.396.905-.79 1.415-1.176q-.028.589-.027 1.179 0 .59.028 1.178m0 3.94a7.2 7.2 0 0 1-2.64.094 1.77 1.77 0 0 1-1.241-.657c-.365-.63.111-1.978 1.364-3.43q.236-.273.488-.532a20.5 20.5 0 0 0 2.107 1.7 21 21 0 0 0 .426 2.712q-.25.063-.505.114m7.1-8.039q-.503-.317-1.018-.613-.508-.292-1.027-.563c.593-.249 1.176-.462 1.739-.635a18 18 0 0 1 .306 1.811M9.68 5.835c.636-1.85 1.578-2.98 2.304-2.98.773-.001 1.777 1.218 2.434 3.197q.064.194.12.39a20.5 20.5 0 0 0-2.526.97 20 20 0 0 0-2.52-.981q.087-.3.188-.596m-.4 1.424a18 18 0 0 1 1.73.642q-1.052.542-2.048 1.181c.08-.638.187-1.249.318-1.823m-.317 7.66q.497.319 1.009.613.522.3 1.057.576a18 18 0 0 1-1.744.665 19 19 0 0 1-.322-1.853m5.456 3.146a7.2 7.2 0 0 1-1.238 2.333 1.77 1.77 0 0 1-1.188.748c-.729 0-1.658-1.085-2.29-2.896q-.112-.321-.206-.648a20 20 0 0 0 2.53-1.01 21 21 0 0 0 2.547.979q-.072.249-.155.494m.362-1.324c-.569-.176-1.16-.393-1.762-.646q.509-.267 1.025-.565.53-.306 1.032-.627a18 18 0 0 1-.295 1.838m.447-4.743q0 .911-.057 1.82-.741.502-1.554.972-.81.467-1.597.856-.827-.396-1.622-.854-.79-.455-1.544-.969-.07-.91-.07-1.822 0-.911.068-1.821a24 24 0 0 1 3.158-1.823q.816.397 1.603.851.79.454 1.55.959.065.914.065 1.831m.956-5.093c1.922-.373 3.37-.122 3.733.507.387.67-.167 2.148-1.554 3.706q-.115.129-.238.259a20 20 0 0 0-2.144-1.688 20 20 0 0 0-.405-2.649q.31-.076.608-.135m-.13 3.885a18 18 0 0 1 1.462 1.188 18 18 0 0 1-1.457 1.208q.023-.594.023-1.188 0-.604-.028-1.208m3.869 5.789c-.364.631-1.768.894-3.653.538q-.324-.061-.664-.146a20 20 0 0 0 .387-2.682 20 20 0 0 0 2.137-1.715q.177.183.336.364a7.2 7.2 0 0 1 1.403 2.238 1.77 1.77 0 0 1 .054 1.403" })
), rZ = h(bh), Th = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 8h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2m-2 4h8a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2m0 4h8a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2M20 2H4a1 1 0 0 0-1 1v18a1 1 0 0 0 1.6.8l2.07-1.55 2.06 1.55a1 1 0 0 0 1.2 0L12 20.25l2.07 1.55a1 1 0 0 0 1.2 0l2.06-1.55 2.07 1.55a1 1 0 0 0 1.05.09A1 1 0 0 0 21 21V3a1 1 0 0 0-1-1m-1 17-1.07-.8a1 1 0 0 0-1.2 0l-2.06 1.55-2.07-1.55a1 1 0 0 0-1.2 0l-2.07 1.55-2.06-1.55a1 1 0 0 0-1.2 0L5 19V4h14Z" })
), hZ = h(Th), Ph = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 12H7a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m-1-2h4a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2m1 6H7a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m12-4h-3V3a1 1 0 0 0-.5-.87 1 1 0 0 0-1 0l-3 1.72-3-1.72a1 1 0 0 0-1 0l-3 1.72-3-1.72a1 1 0 0 0-1 0A1 1 0 0 0 2 3v16a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1V4.73l2 1.14a1.08 1.08 0 0 0 1 0l3-1.72 3 1.72a1.08 1.08 0 0 0 1 0l2-1.14V19a3 3 0 0 0 .18 1Zm15-1a1 1 0 0 1-2 0v-5h2Zm-6.44-2.83a.8.8 0 0 0-.18-.09.6.6 0 0 0-.19-.06 1 1 0 0 0-.9.27A1.05 1.05 0 0 0 12 17a1 1 0 0 0 .07.38 1.2 1.2 0 0 0 .22.33 1.2 1.2 0 0 0 .33.21.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21A1 1 0 0 0 14 17a1.05 1.05 0 0 0-.29-.71 2 2 0 0 0-.15-.12m.14-3.88a1 1 0 0 0-1.62.33A1 1 0 0 0 13 14a1 1 0 0 0 1-1 1 1 0 0 0-.08-.38.9.9 0 0 0-.22-.33" })
), oZ = h(Ph), Dh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6m0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4" })
), nZ = h(Dh), qh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.41 16.867a3.38 3.38 0 0 1-2.368.633 3.37 3.37 0 0 1-2.365-.632 1 1 0 0 0-1.416 1.414 5.1 5.1 0 0 0 3.781 1.218 5.12 5.12 0 0 0 3.782-1.217 1 1 0 1 0-1.414-1.416M9.2 15.002a1 1 0 1 0-1-1 1 1 0 0 0 1 1m6-2a1 1 0 1 0 1 1 1 1 0 0 0-1-1M23 11.78a3.772 3.772 0 0 0-6.794-2.264 16.5 16.5 0 0 0-3.05-.479l.856-5.705 2.087.71a2.997 2.997 0 0 0 5.994-.064v-.023a3.03 3.03 0 0 0-3-2.955 2.98 2.98 0 0 0-2.332 1.155l-3.239-1.101a1 1 0 0 0-1.311.798l-1.077 7.175a16.7 16.7 0 0 0-3.34.489 3.768 3.768 0 0 0-6.225 4.234A4.86 4.86 0 0 0 1 16c0 3.925 4.832 7 11 7s11-3.075 11-7a4.86 4.86 0 0 0-.569-2.249 3.8 3.8 0 0 0 .569-1.97M19.093 3a1 1 0 1 1-1 1 1.017 1.017 0 0 1 1-1M4.78 10a1.76 1.76 0 0 1 .882.25 10 10 0 0 0-2.648 1.673C3.01 11.876 3 11.828 3 11.78A1.783 1.783 0 0 1 4.78 10M12 21c-4.879 0-9-2.29-9-5s4.121-5 9-5 9 2.29 9 5-4.121 5-9 5m8.986-9.077a10 10 0 0 0-2.648-1.673 1.76 1.76 0 0 1 .882-.25A1.783 1.783 0 0 1 21 11.78c0 .048-.01.096-.014.143" })
), wZ = h(qh), Ih = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11a1 1 0 0 0-1 1 8.05 8.05 0 1 1-2.22-5.5h-2.4a1 1 0 0 0 0 2h4.53a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v1.77A10 10 0 1 0 22 12a1 1 0 0 0-1-1" })
), vZ = h(Ih), Wh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.91 15.51h-4.53a1 1 0 0 0 0 2h2.4A8 8 0 0 1 4 12a1 1 0 0 0-2 0 10 10 0 0 0 16.88 7.23V21a1 1 0 0 0 2 0v-4.5a1 1 0 0 0-.97-.99M15 12a3 3 0 1 0-3 3 3 3 0 0 0 3-3m-4 0a1 1 0 1 1 1 1 1 1 0 0 1-1-1m1-10a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 0 1 20 12a1 1 0 0 0 2 0A10 10 0 0 0 12 2" })
), mZ = h(Wh), Gh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m.5-13h-3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0v-2h2a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0v-1a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2v-1a3 3 0 0 0-3-3m1 4a1 1 0 0 1-1 1h-2V9h2a1 1 0 0 1 1 1Z" })
), cZ = h(Gh), Oh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5.5 17.5H4v-11h7.8l-.8.79a1 1 0 0 0 1.41 1.42l2.5-2.5a1 1 0 0 0 0-1.42l-2.5-2.5a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42l.79.79H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h2.5a1 1 0 0 0 0-2M21 4.5h-2.5a1 1 0 0 0 0 2H20v11h-8.37l.79-.79a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0l-2.5 2.5a1 1 0 0 0 0 1.42l2.5 2.5a1 1 0 0 0 1.41-1.42l-.79-.79H21a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1" })
), sZ = h(Oh), Nh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.84 11.63a3 3 0 0 0 2.16-.88l2.83-2.83a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0l-2.86 2.82a1 1 0 0 1-1.42 0l3.54-3.53a1 1 0 1 0-1.42-1.42l-3.53 3.54a1 1 0 0 1 0-1.41l2.83-2.83a1 1 0 1 0-1.42-1.42L13.3 5.09a3 3 0 0 0 0 4.24L12 10.62l-8.27-8.3-.1-.06a.7.7 0 0 0-.17-.11l-.18-.07L3.16 2h-.27a.6.6 0 0 0-.18 0 .7.7 0 0 0-.17.09l-.16.1h-.07l-.06.1a1 1 0 0 0-.11.17 1 1 0 0 0-.07.19s0 .07 0 .11a11 11 0 0 0 3.11 9.34l2.64 2.63-5.41 5.4a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l6.07-5.98 2.83-2.83 2-2a3 3 0 0 0 2.11.89m-7.65 1.82-2.63-2.64A9.06 9.06 0 0 1 4 5.4l6.61 6.6Zm6.24.57A1 1 0 0 0 14 15.44l6.3 6.3a1 1 0 0 0 .7.26 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42Z" })
), gZ = h(Nh), Qh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3.64 9.56a1 1 0 1 0-1.28 1.54l1.08.9-1.08.9a1 1 0 0 0-.13 1.41 1 1 0 0 0 1.41.13l2-1.67a1 1 0 0 0 0-1.54ZM9 5a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1m4 2h8a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2m8 10h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2m0-8h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2m0 4h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2" })
), iZ = h(Qh), Kh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.5 17H5.91l1.3-1.29a1 1 0 0 0-1.42-1.42l-3 3a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.91 19H20.5a1 1 0 0 0 0-2m-9-7v4a1 1 0 0 0 2 0V4h2v10a1 1 0 0 0 2 0V4h1a1 1 0 0 0 0-2h-7a4 4 0 0 0 0 8m0-6v4a2 2 0 0 1 0-4" })
), dZ = h(Kh), jh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 15a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-7-1a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m20 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m-5-7h-4V5.72A2 2 0 0 0 14 4a2 2 0 0 0-4 0 2 2 0 0 0 1 1.72V7H7a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3m-3.28 2-.5 2h-2.44l-.5-2ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h1.22L9 12.24a1 1 0 0 0 1 .76h4a1 1 0 0 0 1-.76L15.78 9H17a1 1 0 0 1 1 1Zm-3-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), pZ = h(jh), Jh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.601 2.062a1 1 0 0 0-.713-.713A11.25 11.25 0 0 0 10.47 4.972L9.354 6.296 6.75 5.668a2.78 2.78 0 0 0-3.387 1.357l-2.2 3.9a1 1 0 0 0 .661 1.469l3.073.659a13.4 13.4 0 0 0-.555 2.434 1 1 0 0 0 .284.836l3.1 3.1a1 1 0 0 0 .708.293 1 1 0 0 0 .086-.004 12 12 0 0 0 2.492-.49l.644 3.004a1 1 0 0 0 1.469.661l3.905-2.202a3.035 3.035 0 0 0 1.375-3.304l-.668-2.76 1.237-1.137A11.2 11.2 0 0 0 22.6 2.062ZM3.572 10.723l1.556-2.76a.826.826 0 0 1 1.07-.375l1.718.416-.65.772a13 13 0 0 0-1.59 2.398Zm12.47 8.222-2.715 1.532-.43-2.005a11.3 11.3 0 0 0 2.414-1.62l.743-.683.404 1.664a1.04 1.04 0 0 1-.416 1.112m1.615-6.965-3.685 3.386a9.77 9.77 0 0 1-5.17 2.304l-2.405-2.404a10.93 10.93 0 0 1 2.401-5.206l1.679-1.993a1 1 0 0 0 .078-.092L11.99 6.27a9.28 9.28 0 0 1 8.81-3.12 9.22 9.22 0 0 1-3.143 8.829Zm-.923-6.164a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5" })
), fZ = h(Jh), Yh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6.5h-6V4h4.62a1 1 0 0 0 0-2H6.38a1 1 0 1 0 0 2H11v2.5H5a3 3 0 0 0-3 3V19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9.5a3 3 0 0 0-3-3M11 20H5a1 1 0 0 1-1-1v-3.75h7a.5.5 0 0 0 0 .13v4.5a.5.5 0 0 0 0 .12m9-1a1 1 0 0 1-1 1h-6a.5.5 0 0 0 0-.12v-4.5a.5.5 0 0 0 0-.13h7Zm0-5.75H4V9.5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), EZ = h(Yh), Xh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 6C6.3 6 2 8.15 2 11c0 2.45 3.19 4.38 7.71 4.88l-.42.41a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2-2a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-2-2a1 1 0 0 0-1.42 1.42l.12.11C6 13.34 4 12 4 11c0-1.22 3.12-3 8-3s8 1.78 8 3c0 .83-1.45 2-4.21 2.6a1 1 0 0 0-.79 1.19 1 1 0 0 0 1.19.77c3.65-.8 5.81-2.5 5.81-4.56 0-2.85-4.3-5-10-5" })
), xZ = h(Xh), _h = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M2.88 16.88a3 3 0 1 0 4.24 4.24 3 3 0 0 0 0-4.24 3.08 3.08 0 0 0-4.24 0m2.83 2.83a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42 1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.42M5 12a1 1 0 0 0 0 2 5 5 0 0 1 5 5 1 1 0 0 0 2 0 7 7 0 0 0-7-7m0-4a1 1 0 0 0 0 2 9 9 0 0 1 9 9 1 1 0 0 0 2 0A11 11 0 0 0 5 8" })
), AZ = h(_h), zh = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 14a1 1 0 0 0 0 2 3 3 0 0 1 3 3 1 1 0 0 0 2 0 5 5 0 0 0-5-5m-.71 4.29a1 1 0 1 0 1.42 0 1 1 0 0 0-1.42 0M19 4H5a3 3 0 0 0-3 3 1 1 0 0 0 2 0 1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4a1 1 0 0 0 0 2h4a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3M3 10a1 1 0 0 0 0 2 7 7 0 0 1 7 7 1 1 0 0 0 2 0 9 9 0 0 0-9-9" })
), MZ = h(zh), ao = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M2.88 16.88a3 3 0 0 0 0 4.24 3 3 0 0 0 4.24 0 3 3 0 0 0-4.24-4.24m2.83 2.83a1 1 0 0 1-1.42-1.42 1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.42M5 12a1 1 0 0 0 0 2 5 5 0 0 1 5 5 1 1 0 0 0 2 0 7 7 0 0 0-7-7m0-4a1 1 0 0 0 0 2 9 9 0 0 1 9 9 1 1 0 0 0 2 0 11.08 11.08 0 0 0-3.22-7.78A11.08 11.08 0 0 0 5 8m10.61.39A15.1 15.1 0 0 0 5 4a1 1 0 0 0 0 2 13 13 0 0 1 13 13 1 1 0 0 0 2 0 15.1 15.1 0 0 0-4.39-10.61" })
), HZ = h(ao), to = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V10h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 6h-2V7a1 1 0 0 0-2 0v1h-2V7a1 1 0 0 0-2 0v1h-2V7a1 1 0 0 0-2 0v1H7a1 1 0 0 0 0 2h1v2H7a1 1 0 0 0 0 2h1v2H7a1 1 0 0 0 0 2h1v2H4V4h16Z" })
), CZ = h(to), eo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.61 7.05 17 1.39a1 1 0 0 0-.71-.29 1 1 0 0 0-.7.29L1.39 15.54a1 1 0 0 0 0 1.41l5.66 5.66a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29l2.83-2.83 8.49-8.49 2.83-2.83a1 1 0 0 0 0-1.41m-3.54 2.12-.71-.71a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42l.71.71L16.24 12l-2.12-2.12a1 1 0 0 0-1.41 1.41l2.12 2.12-1.42 1.42-.7-.71a1 1 0 1 0-1.42 1.42l.71.7-1.41 1.42-2.13-2.12a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.41l2.12 2.12-1.41 1.42-4.25-4.25L16.24 3.51l4.25 4.25Z" })
), uZ = h(eo), lo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 7h-2.21a5.5 5.5 0 0 0-1-2H18a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2h3.5a3.5 3.5 0 0 1 3.15 2H7a1 1 0 0 0 0 2h7a3.5 3.5 0 0 1-3.45 3H7a.7.7 0 0 0-.14 0 .7.7 0 0 0-.2 0 .7.7 0 0 0-.19.1l-.12.07a.8.8 0 0 0-.14.17 1 1 0 0 0-.09.14.6.6 0 0 0 0 .18A.65.65 0 0 0 6 13a.7.7 0 0 0 0 .14.7.7 0 0 0 0 .2.7.7 0 0 0 .1.19s0 .08.07.12l6 7a1 1 0 0 0 1.52-1.3L9.18 14h1.32A5.5 5.5 0 0 0 16 9h2a1 1 0 0 0 0-2" })
), VZ = h(lo), ro = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 0 0-3.41 19.39h.06a9.8 9.8 0 0 0 6.7 0h.06A10 10 0 0 0 12 2m2 17.74a7.8 7.8 0 0 1-4 0V16h4Zm2-.82V11a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2v3h-4v-3a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2v7.92a8 8 0 1 1 8 0" })
), SZ = h(ro), ho = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 0 0-3.41 19.39h.06a9.8 9.8 0 0 0 6.7 0h.06A10 10 0 0 0 12 2m2 17.74a7.8 7.8 0 0 1-4 0v-3.13a3.79 3.79 0 0 1 4 0Zm2-.82V11a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2v3.39a6 6 0 0 0-4 0V11a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2v7.92a8 8 0 1 1 8 0" })
), LZ = h(ho), oo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m9 11.71.29-.3.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29.3-.29a1 1 0 0 0-1.46-1.42l-.29.3-.25-.3a1 1 0 1 0-1.46 1.42l.3.29-.3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0Zm-.6 3.62a1 1 0 0 0-.13 1.4 1 1 0 0 0 1.41.13 3.76 3.76 0 0 1 4.72 0 1 1 0 0 0 1.41-.13 1 1 0 0 0-.13-1.4 5.81 5.81 0 0 0-7.32 0ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m5-11.71a1 1 0 0 0-1.42 0l-.29.3-.29-.3a1 1 0 0 0-1.42 1.42l.3.29-.3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l.29-.3.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29.3-.29a1 1 0 0 0 0-1.42" })
), ZZ = h(oo), no = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m9.08 12.21 1.5-1.5a1 1 0 0 0 0-1.42l-1.5-1.5a1 1 0 0 0-1.42 1.42l.8.79-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29m-.72 3.12a1 1 0 0 0-.13 1.4 1 1 0 0 0 1.41.13 3.76 3.76 0 0 1 4.72 0 1 1 0 0 0 1.41-.13 1 1 0 0 0-.13-1.4 5.81 5.81 0 0 0-7.28 0m8.22-7.54a1 1 0 0 0-1.42 0l-1.5 1.5a1 1 0 0 0 0 1.42l1.5 1.5a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-.79-.79.79-.79a1 1 0 0 0 0-1.42M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), BZ = h(no), wo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.36 15.33a1 1 0 0 0-.13 1.4 1 1 0 0 0 1.41.13 3.76 3.76 0 0 1 4.72 0 1 1 0 0 0 .64.23 1 1 0 0 0 .64-1.76 5.81 5.81 0 0 0-7.28 0m.85-4.79a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41 3.08 3.08 0 0 0-4.24 0 1 1 0 1 0 1.41 1.41 1 1 0 0 1 1.42 0M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m5.62-10.87a3.08 3.08 0 0 0-4.24 0 1 1 0 0 0 1.41 1.41 1 1 0 0 1 1.42 0 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41" })
), FZ = h(wo), vo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 15h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m2-7V5a1 1 0 0 0-1-1h-1V3h1a1 1 0 0 0 0-2h-4.764a4.59 4.59 0 0 0-4.13 2.553 1 1 0 0 0 1.789.894A2.6 2.6 0 0 1 10.235 3H12v1h-1a1 1 0 0 0-1 1v3a3.003 3.003 0 0 0-3 3v9a3.003 3.003 0 0 0 3 3h6a3.003 3.003 0 0 0 3-3v-9a3.003 3.003 0 0 0-3-3m-4-2h2v2h-2Zm5 14a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z" })
), RZ = h(vo), mo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 12a3 3 0 1 0 3 3 3.003 3.003 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m5.8-8.4L16 5.5V3h1a1 1 0 0 0 0-2H8.657a4.97 4.97 0 0 0-3.535 1.464l-.829.829a1 1 0 1 0 1.414 1.414l.829-.829A3.02 3.02 0 0 1 8.656 3H10v2.5L7.2 7.6A3.02 3.02 0 0 0 6 10v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10a3.02 3.02 0 0 0-1.2-2.4M12 3h2v2h-2Zm6 18H8V10a1 1 0 0 1 .4-.8L11.334 7h3.333L17.6 9.2a1 1 0 0 1 .4.8Z" })
), UZ = h(mo), co = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20.71 9.29-6-6a1 1 0 0 0-.32-.21A1.1 1.1 0 0 0 14 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a1 1 0 0 0-.29-.71M9 5h4v2H9Zm6 14H9v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Zm4-1a1 1 0 0 1-1 1h-1v-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6.41l4 4Z" })
), $Z = h(co), so = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 16a1 1 0 0 0-1 1v1.59L13.41 12l2.13-2.12a1 1 0 0 0-1.42-1.42L12 10.59 5.41 4H7a1 1 0 0 0 0-2H3a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 2 3v4a1 1 0 0 0 2 0V5.41L10.59 12l-2.13 2.12a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29L12 13.41 18.59 20H17a1 1 0 0 0 0 2h4a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 21v-4a1 1 0 0 0-1-1" })
), yZ = h(so), go = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.92 2.62a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-4a1 1 0 0 0 0 2h1.59L12 10.59 9.88 8.46a1 1 0 0 0-1.42 1.42L10.59 12 4 18.59V17a1 1 0 0 0-2 0v4a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 3 22h4a1 1 0 0 0 0-2H5.41L12 13.41l2.12 2.13a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42L13.41 12 20 5.41V7a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38" })
), kZ = h(go), io = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 .49-.05l.3-.07h.12l.37-.14.13-.07c.1-.06.21-.11.31-.18a4 4 0 0 0 .38-.32l.07-.09a3 3 0 0 0 .27-.32l.09-.13a2.3 2.3 0 0 0 .18-.35 1 1 0 0 0 .07-.15c.05-.12.08-.25.12-.38v-.15a2.6 2.6 0 0 0 .1-.6V5a3 3 0 0 0-3-3M5 20a1 1 0 0 1-1-1v-4.31l3.29-3.3a1 1 0 0 1 1.42 0l8.6 8.61Zm15-1a1 1 0 0 1-.07.36 1 1 0 0 1-.08.14 1 1 0 0 1-.09.12l-5.35-5.35.88-.88a1 1 0 0 1 1.42 0l3.29 3.3Zm0-5.14L18.12 12a3.08 3.08 0 0 0-4.24 0l-.88.88L10.12 10a3.08 3.08 0 0 0-4.24 0L4 11.86V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM13.5 6A1.5 1.5 0 1 0 15 7.5 1.5 1.5 0 0 0 13.5 6" })
), bZ = h(io), po = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 14a1 1 0 1 0-1-1 1 1 0 0 0 1 1m5 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-5 4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m5 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1M7 14a1 1 0 1 0-1-1 1 1 0 0 0 1 1M19 4h-1V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16Zm0-11H4V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM7 18a1 1 0 1 0-1-1 1 1 0 0 0 1 1" })
), TZ = h(po), fo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 10.12-7.83-7.83a1 1 0 0 0-1.7.57L11.45 8l-2 2-.33-.19A1 1 0 0 0 8 11.44l-1.15 1.17-.33-.19a1 1 0 0 0-1.11 1.63l-1.17 1.16-.32-.21a1 1 0 0 0-1.37.37 1 1 0 0 0 .25 1.26l-.51.51a.9.9 0 0 0-.21.33 1 1 0 0 0-.08.38V21a1 1 0 0 0 1 1h3.13a1 1 0 0 0 .38-.08.9.9 0 0 0 .33-.21L8.54 20l.33.19a1 1 0 0 0 1.37-.36 1 1 0 0 0-.24-1.27l1.17-1.16.33.19a1 1 0 0 0 .49.13 1 1 0 0 0 .6-1.72l1.17-1.16.33.19a1 1 0 0 0 .49.13 1 1 0 0 0 .62-1.77l.79-.79 5.15-.73a1 1 0 0 0 .81-.68 1 1 0 0 0-.24-1.07M5.72 20H4v-1.72l.57-.57L6.75 19Zm2.49-2.5L6 16.25l1.14-1.14 2.17 1.25Zm2.61-2.6-2.18-1.26 1.15-1.14L12 13.75Zm2.61-2.61L11.25 11l1.14-1.14 1.72 1.72Zm2.45-1.74-2.43-2.43.43-3 5 5Z" })
), PZ = h(fo), Eo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.71 6.29a1 1 0 0 0-1.42 1.42L7.59 12l-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l5-5a1 1 0 0 0 0-1.42ZM16.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42l-5 5a1 1 0 0 0 0 1.42l5 5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), DZ = h(Eo), xo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 9.71a1 1 0 0 0 1.42 0l5-5a1 1 0 1 0-1.42-1.42L12 7.59l-4.29-4.3a1 1 0 0 0-1.42 1.42Zm1.42 4.58a1 1 0 0 0-1.42 0l-5 5a1 1 0 0 0 1.42 1.42l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), qZ = h(xo), Ao = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.07 16.83 19 14.71a3.08 3.08 0 0 0-3.4-.57l-.9-.9a7 7 0 1 0-1.41 1.41l.89.89a3 3 0 0 0 .53 3.46l2.12 2.12a3 3 0 0 0 4.24 0 3 3 0 0 0 0-4.29m-8.48-4.24a5 5 0 1 1 0-7.08 5 5 0 0 1 0 7.08m7.07 7.07a1 1 0 0 1-1.42 0l-2.12-2.12a1 1 0 0 1 0-1.42 1 1 0 0 1 1.42 0l2.12 2.12a1 1 0 0 1 0 1.42" })
), IZ = h(Ao), Mo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 20.29 18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.39M11 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7m4-8H7a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2" })
), WZ = h(Mo), Ho = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 10h-3V7a1 1 0 0 0-2 0v3H7a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2m6.71 10.29L18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.39M11 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7" })
), GZ = h(Ho), Co = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 20.29 18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.39M11 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7" })
), OZ = h(Co), uo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 2H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1h10Zm-5-5a3 3 0 0 1 2.82 2H9.18A3 3 0 0 1 12 14m-1-3a1 1 0 1 1 1 1 1 1 0 0 1-1-1m6 5h-.1a5 5 0 0 0-2.42-3.32A3 3 0 0 0 15 11a3 3 0 0 0-6 0 3 3 0 0 0 .52 1.68A5 5 0 0 0 7.1 16H7V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1ZM12 5a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), NZ = h(uo), Vo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 17a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12 0a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2a3 3 0 0 0 .78 2A3 3 0 0 0 4 11v2a3 3 0 0 0 .78 2A3 3 0 0 0 4 17v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2v-2a3 3 0 0 0-.78-2A3 3 0 0 0 20 7Zm-2 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm0-6a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm0-6a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z" })
), QZ = h(Vo), So = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 13a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m15-9a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v4a3 3 0 0 0 .78 2A3 3 0 0 0 2 12v4a3 3 0 0 0 3 3h6v2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2h-8v-2h6a3 3 0 0 0 3-3v-4a3 3 0 0 0-.78-2A3 3 0 0 0 22 8Zm-2 12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm0-8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm-9-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1M7 5a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), KZ = h(So), Lo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 6h3a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2m8 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m0 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1m5 9h-6.18A3 3 0 0 0 13 17.18V15h4a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2A3 3 0 0 0 20 6V4a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2a3 3 0 0 0 .78 2A3 3 0 0 0 4 10v2a3 3 0 0 0 3 3h4v2.18A3 3 0 0 0 9.18 19H3a1 1 0 0 0 0 2h6.18a3 3 0 0 0 5.64 0H21a1 1 0 0 0 0-2M6 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1Zm1 9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1Zm5 8a1 1 0 1 1 1-1 1 1 0 0 1-1 1m-1-11H8a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2" })
), jZ = h(Lo), Zo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 6a1 1 0 1 0-1-1 1 1 0 0 0 1 1m13 13h-6.18A3 3 0 0 0 13 17.18V15h4a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2A3 3 0 0 0 20 6V4a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2a3 3 0 0 0 .78 2A3 3 0 0 0 4 10v2a3 3 0 0 0 3 3h4v2.18A3 3 0 0 0 9.18 19H3a1 1 0 0 0 0 2h6.18a3 3 0 0 0 5.64 0H21a1 1 0 0 0 0-2M6 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1Zm1 9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1Zm5 8a1 1 0 1 1 1-1 1 1 0 0 1-1 1M8 10a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), JZ = h(Zo), Bo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 17a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-6 0H6a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2m9 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-6 0H6a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2m9-6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m0 6a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4-6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v2a3 3 0 0 0 .78 2A3 3 0 0 0 2 11v2a3 3 0 0 0 .78 2A3 3 0 0 0 2 17v2a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2v-2a3 3 0 0 0-.78-2A3 3 0 0 0 22 7Zm-2 14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm0-6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm0-6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm-5-2a1 1 0 1 0 1 1 1 1 0 0 0-1-1M9 5H6a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2" })
), YZ = h(Bo), Fo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 17a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 0H9a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m0-6H9a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m4 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8-3a3 3 0 0 0-3-3h-1a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3H4a3 3 0 0 0-3 3v2a3 3 0 0 0 .78 2A3 3 0 0 0 1 14v2a3 3 0 0 0 3 3h1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h1a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2ZM5 17H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1a3 3 0 0 0 .78 2A3 3 0 0 0 5 17m0-6H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1a3 3 0 0 0 .78 2A3 3 0 0 0 5 11m12 8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Zm0-6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Zm0-6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Zm4 9a1 1 0 0 1-1 1h-1a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2h1a1 1 0 0 1 1 1Zm0-6a1 1 0 0 1-1 1h-1a3 3 0 0 0-.78-2A3 3 0 0 0 19 7h1a1 1 0 0 1 1 1Zm-6-5a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-4 0H9a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2" })
), XZ = h(Fo), Ro = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5.5 9h4a1 1 0 0 0 0-2h-4a3 3 0 0 0 0 6h2a1 1 0 0 1 0 2h-4a1 1 0 0 0 0 2h4a3 3 0 0 0 0-6h-2a1 1 0 0 1 0-2m15.92-1.38a1 1 0 0 0-.54-.54 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21L17 10.09l-2.79-2.8a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.54.54 1 1 0 0 0-.08.38v8a1 1 0 0 0 2 0v-5.59l1.79 1.8a1 1 0 0 0 1.42 0l1.79-1.8V16a1 1 0 0 0 2 0V8a1 1 0 0 0-.08-.38" })
), _Z = h(Ro), Uo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.9 12.66a1 1 0 0 1 0-1.32l1.28-1.44a1 1 0 0 0 .12-1.17l-2-3.46a1 1 0 0 0-1.07-.48l-1.88.38a1 1 0 0 1-1.15-.66l-.61-1.83a1 1 0 0 0-.95-.68h-4a1 1 0 0 0-1 .68l-.56 1.83a1 1 0 0 1-1.15.66L5 4.79a1 1 0 0 0-1 .48L2 8.73a1 1 0 0 0 .1 1.17l1.27 1.44a1 1 0 0 1 0 1.32L2.1 14.1a1 1 0 0 0-.1 1.17l2 3.46a1 1 0 0 0 1.07.48l1.88-.38a1 1 0 0 1 1.15.66l.61 1.83a1 1 0 0 0 1 .68h4a1 1 0 0 0 .95-.68l.61-1.83a1 1 0 0 1 1.15-.66l1.88.38a1 1 0 0 0 1.07-.48l2-3.46a1 1 0 0 0-.12-1.17ZM18.41 14l.8.9-1.28 2.22-1.18-.24a3 3 0 0 0-3.45 2L12.92 20h-2.56L10 18.86a3 3 0 0 0-3.45-2l-1.18.24-1.3-2.21.8-.9a3 3 0 0 0 0-4l-.8-.9 1.28-2.2 1.18.24a3 3 0 0 0 3.45-2L10.36 4h2.56l.38 1.14a3 3 0 0 0 3.45 2l1.18-.24 1.28 2.22-.8.9a3 3 0 0 0 0 3.98m-6.77-6a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2" })
), zZ = h(Uo), $o = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 14a4 4 0 0 0-3.08 1.48l-5.1-2.35a3.64 3.64 0 0 0 0-2.26l5.1-2.35A4 4 0 1 0 14 6a4 4 0 0 0 .07.71L8.79 9.14a4 4 0 1 0 0 5.72l5.28 2.43A4 4 0 0 0 14 18a4 4 0 1 0 4-4m0-10a2 2 0 1 1-2 2 2 2 0 0 1 2-2M6 14a2 2 0 1 1 2-2 2 2 0 0 1-2 2m12 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2" })
), aB = h($o), yo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.707 11.293-8-8A1 1 0 0 0 12 4v3.545A11.015 11.015 0 0 0 2 18.5V20a1 1 0 0 0 1.784.62 11.46 11.46 0 0 1 7.887-4.049c.05-.006.175-.016.329-.026V20a1 1 0 0 0 1.707.707l8-8a1 1 0 0 0 0-1.414M14 17.586V15.5a1 1 0 0 0-1-1c-.255 0-1.296.05-1.562.085a14 14 0 0 0-7.386 2.948A9.013 9.013 0 0 1 13 9.5a1 1 0 0 0 1-1V6.414L19.586 12Z" })
), tB = h(yo), ko = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.63 3.65a1 1 0 0 0-.84-.2 8 8 0 0 1-6.22-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27 1 1 0 0 0-.84.2 1 1 0 0 0-.37.78v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78M18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39Zm-4.46-2.29-2.69 2.7-.89-.9a1 1 0 0 0-1.42 1.42l1.6 1.6a1 1 0 0 0 1.42 0L15 11a1 1 0 0 0-1.42-1.42Z" })
), eB = h(ko), bo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.92 15a.6.6 0 0 0-.09-.17l-.12-.15a1 1 0 0 0-1.42 0 .6.6 0 0 0-.12.15.6.6 0 0 0-.09.17.7.7 0 0 0-.06.19 1 1 0 0 0 0 .19.9.9 0 0 0 .08.39 1 1 0 0 0 1.3.54 1.2 1.2 0 0 0 .33-.22 1 1 0 0 0 .21-.32 1 1 0 0 0 .08-.39 1 1 0 0 0 0-.19.7.7 0 0 0-.1-.19M12 7.36a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m7.63-3.71a1 1 0 0 0-.84-.2 8 8 0 0 1-6.22-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27 1 1 0 0 0-.84.2 1 1 0 0 0-.37.78v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78M18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39Z" })
), lB = h(bo), To = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 11h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m5.63-7.35a1 1 0 0 0-.835-.203 7.98 7.98 0 0 1-6.223-1.267 1 1 0 0 0-1.144 0 7.98 7.98 0 0 1-6.223 1.267A1 1 0 0 0 4 4.427v7.456a9.02 9.02 0 0 0 3.769 7.324l3.65 2.607a1 1 0 0 0 1.162 0l3.65-2.607A9.02 9.02 0 0 0 20 11.883V4.426a1 1 0 0 0-.37-.776M18 11.883a7.02 7.02 0 0 1-2.93 5.696L12 19.771 8.93 17.58A7.02 7.02 0 0 1 6 11.883v-6.3a9.96 9.96 0 0 0 6-1.391 9.96 9.96 0 0 0 6 1.391Z" })
), rB = h(To), Po = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 14.66a1 1 0 0 0-.29.7 1 1 0 0 0 .08.39 1 1 0 0 0 1.92-.39 1 1 0 0 0-.29-.7 1 1 0 0 0-1.42 0m8.34-11a1 1 0 0 0-.84-.2 8 8 0 0 1-6.22-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.26 1 1 0 0 0-.84.2 1 1 0 0 0-.37.78v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78ZM18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39Zm-6-4.52a3 3 0 0 0-2.6 1.5 1 1 0 0 0 1.73 1 1 1 0 1 1 .87 1.5 1 1 0 0 0 0 2 3 3 0 1 0 0-6" })
), hB = h(Po), Do = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 20.29-16-16-2-2a1 1 0 0 0-1.42 1.42L4 5.41v6.47a9 9 0 0 0 3.77 7.32l3.65 2.61a1 1 0 0 0 1.16 0l3.65-2.61a8 8 0 0 0 .86-.7l3.2 3.21a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42m-6.64-2.71L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88V7.41l9.67 9.68c-.19.17-.39.33-.6.49m-5-12.51A10 10 0 0 0 12 4.19a9.82 9.82 0 0 0 6 1.39v6.3a7 7 0 0 1-.1 1.18 1 1 0 0 0 .83 1.15h.16a1 1 0 0 0 1-.84 10 10 0 0 0 .12-1.5V4.43a1 1 0 0 0-.37-.77 1 1 0 0 0-.83-.21 7.9 7.9 0 0 1-6.23-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-2 1 1 1 0 1 0 .64 1.9Z" })
), oB = h(Do), qo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.63 3.65a1 1 0 0 0-.84-.2 8 8 0 0 1-6.22-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27 1 1 0 0 0-.84.2 1 1 0 0 0-.37.78v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78M18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39Z" })
), nB = h(qo), Io = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3.62 17.28a1 1 0 0 0 1.86-.74l-1.12-2.82L11 12.25V17a1 1 0 0 0 2 0v-4.75l6.64 1.47-1.12 2.82a1 1 0 0 0 .56 1.3 1 1 0 0 0 .37.07 1 1 0 0 0 .93-.63l1.55-3.91a1 1 0 0 0-.05-.84 1 1 0 0 0-.66-.51L18 11.31V7a1 1 0 0 0-1-1h-2V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3H7a1 1 0 0 0-1 1v4.31L2.78 12a1 1 0 0 0-.66.51 1 1 0 0 0-.05.84ZM11 4h2v2h-2ZM8 8h8v2.86L12.22 10h-.44L8 10.86Zm12.71 11.28a4.4 4.4 0 0 0-1 .45 2.08 2.08 0 0 1-2.1 0 4.62 4.62 0 0 0-4.54 0 2.14 2.14 0 0 1-2.12 0 4.64 4.64 0 0 0-4.54 0 2.08 2.08 0 0 1-2.1 0 4.4 4.4 0 0 0-1-.45A1 1 0 0 0 2 20a1 1 0 0 0 .67 1.24 2.1 2.1 0 0 1 .57.25 4 4 0 0 0 2 .55 4.14 4.14 0 0 0 2.08-.56 2.65 2.65 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.65 2.65 0 0 1 2.56 0 4 4 0 0 0 4.1 0 2.1 2.1 0 0 1 .57-.25A1 1 0 0 0 22 20a1 1 0 0 0-1.29-.72" })
), wB = h(Io), Wo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 5H2a1 1 0 0 0-1 1v4a3 3 0 0 0 2 2.82V22a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-9.18A3 3 0 0 0 23 10V6a1 1 0 0 0-1-1m-7 2h2v3a1 1 0 0 1-2 0Zm-4 0h2v3a1 1 0 0 1-2 0ZM7 7h2v3a1 1 0 0 1-2 0Zm-3 4a1 1 0 0 1-1-1V7h2v3a1 1 0 0 1-1 1m10 10h-4v-2a2 2 0 0 1 4 0Zm5 0h-3v-2a4 4 0 0 0-8 0v2H5v-8.18a3.2 3.2 0 0 0 1-.6 3 3 0 0 0 4 0 3 3 0 0 0 4 0 3 3 0 0 0 4 0 3.2 3.2 0 0 0 1 .6Zm2-11a1 1 0 0 1-2 0V7h2ZM4.3 3H20a1 1 0 0 0 0-2H4.3a1 1 0 0 0 0 2" })
), vB = h(Wo), Go = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 7h-3V6a4 4 0 0 0-8 0v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1m-9-1a2 2 0 0 1 4 0v1h-4Zm8 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h2v1a1 1 0 0 0 2 0V9h4v1a1 1 0 0 0 2 0V9h2Z" })
), mB = h(Go), Oo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 18a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1m-4 0a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1m9-12h-1.38l-1.73-3.45a1 1 0 1 0-1.78.9L15.38 6H8.62l1.27-2.55a1 1 0 0 0-1.78-.9L6.38 6H5a3 3 0 0 0-.92 5.84l.74 7.46a3 3 0 0 0 3 2.7h8.38a3 3 0 0 0 3-2.7l.74-7.46A3 3 0 0 0 19 6m-1.81 13.1a1 1 0 0 1-1 .9H7.81a1 1 0 0 1-1-.9L6.1 12h11.8ZM19 10H5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2" })
), cB = h(Oo), No = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.5 15a3 3 0 0 0-1.9-2.78l1.87-7a1 1 0 0 0-.18-.87A1 1 0 0 0 20.5 4H6.8l-.33-1.26A1 1 0 0 0 5.5 2h-2v2h1.23l2.48 9.26a1 1 0 0 0 1 .74H18.5a1 1 0 0 1 0 2h-13a1 1 0 0 0 0 2h1.18a3 3 0 1 0 5.64 0h2.36a3 3 0 1 0 5.82 1 2.94 2.94 0 0 0-.4-1.47A3 3 0 0 0 21.5 15m-3.91-3H9L7.34 6H19.2ZM9.5 20a1 1 0 1 1 1-1 1 1 0 0 1-1 1m8 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), sB = h(No), Qo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 19a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 8.5 19M19 16H7a1 1 0 0 1 0-2h8.491a3.01 3.01 0 0 0 2.885-2.176l1.585-5.55A1 1 0 0 0 19 5H6.74A3.01 3.01 0 0 0 3.92 3H3a1 1 0 0 0 0 2h.921a1.005 1.005 0 0 1 .962.725l.155.545v.005l1.641 5.742A3 3 0 0 0 7 18h12a1 1 0 0 0 0-2m-1.326-9-1.22 4.274a1.005 1.005 0 0 1-.963.726H8.754l-.255-.892L7.326 7ZM16.5 19a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5" })
), gB = h(Qo), Ko = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 7.38-5.09-5.09a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42L17 5.54 11.58 11l-1-1a3 3 0 0 0-4.25 0l-3.45 3.42A3 3 0 0 0 2 15.55V19a3 3 0 0 0 3 3h3.45a3 3 0 0 0 2.13-.88L14 17.69a3 3 0 0 0 0-4.25l-1-1L18.46 7l1.83 1.83a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.45m-9.11 8.89-3.44 3.44a1 1 0 0 1-.71.29H5a1 1 0 0 1-1-1v-3.45a1 1 0 0 1 .29-.71l3.44-3.44a1 1 0 0 1 1.41 0l1 1-.89.9a1 1 0 0 0 0 1.41A1 1 0 0 0 10 15a1 1 0 0 0 .7-.29l.9-.89 1 1a1 1 0 0 1 0 1.45" })
), iB = h(Ko), jo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m10.71 11.29-2.5-2.5a1 1 0 1 0-1.42 1.42l.8.79H3a1 1 0 0 0 0 2h4.59l-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.5-2.5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33M21 11h-4.59l.8-.79a1 1 0 0 0-1.42-1.42l-2.5 2.5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2.5 2.5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.8-.79H21a1 1 0 0 0 0-2" })
), dB = h(jo), Jo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 10a1 1 0 0 0 1-1V5.41L8.56 10A1 1 0 0 0 10 10a1 1 0 0 0 0-1.41L5.41 4H9a1 1 0 0 0 0-2H3a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 2 3v6a1 1 0 0 0 1 1m12.3 4a1 1 0 0 0-1.41 1.41l6.27 6.28a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42ZM9 20H5.41l16.3-16.29a1 1 0 1 0-1.42-1.42L4 18.59V15a1 1 0 0 0-2 0v6a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 3 22h6a1 1 0 0 0 0-2" })
), pB = h(Jo), Yo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 11a1 1 0 0 1 0-.16c0-.28-.08-.56-.13-.84A9.5 9.5 0 0 0 21 7.62a10 10 0 0 0-7-5.41l-.84-.13h-.53L12 2h-1.16l-.84.2A10 10 0 0 0 2.21 10c-.05.28-.09.56-.13.84a1 1 0 0 1 0 .16v2a1 1 0 0 1 0 .16c0 .28.08.56.13.84A9.5 9.5 0 0 0 3 16.38a10 10 0 0 0 7 5.41l.84.13.16.08h1.01c.34 0 .68 0 1-.05h.16l.83-.15a10 10 0 0 0 7.79-7.8c.05-.28.09-.56.13-.84A1 1 0 0 1 22 13c0-.33.05-.67.05-1s-.05-.68-.05-1m-8.84-6.9.5.07A8 8 0 0 1 18.24 7h-6.82Zm-2.74.08.4-.06L7.38 10 5.7 7.08a8 8 0 0 1 4.67-2.91ZM4.59 15a8 8 0 0 1-.42-1.37c0-.22-.08-.45-.1-.68a.5.5 0 0 1 0-.12 8.2 8.2 0 0 1 0-1.62.5.5 0 0 1 0-.12c0-.23.06-.46.1-.68a8 8 0 0 1 .38-1.31L8 15Zm6.3 4.91-.5-.07A8 8 0 0 1 5.76 17h6.82ZM10.27 15l-1.73-3 1.73-3h3.46l1.73 3-1.73 3Zm3.36 4.83-.4.06L16.62 14l1.68 2.92a8 8 0 0 1-4.67 2.91m6.33-7a.5.5 0 0 1 0 .12c0 .23-.06.46-.1.68a8 8 0 0 1-.38 1.27L16 9h3.37a8 8 0 0 1 .42 1.37c0 .22.08.45.1.68a.5.5 0 0 1 0 .12 8.2 8.2 0 0 1 0 1.62Z" })
), fB = h(Yo), Xo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.07 4.93A10 10 0 1 0 4.93 19.07 10 10 0 1 0 19.07 4.93M18.23 7h-5.47l2.35-2.35A8.14 8.14 0 0 1 18.23 7M9 4.6a8.15 8.15 0 0 1 3.87-.54L9 7.93ZM7 5.77v5.47L5.19 9.43l-.54-.54A8.14 8.14 0 0 1 7 5.77M4.6 15a8.1 8.1 0 0 1-.54-3.87L7.93 15Zm1.17 2h5.47l-2.35 2.35A8.14 8.14 0 0 1 5.77 17M15 19.4a8.1 8.1 0 0 1-3.87.54L15 16.07Zm0-6.16L13.24 15h-2.49L9 13.24v-2.48L10.76 9h2.48L15 10.76Zm2 5v-5.48l2.35 2.35A8.14 8.14 0 0 1 17 18.23ZM16.07 9h3.33a8.1 8.1 0 0 1 .54 3.87Z" })
), EB = h(Xo), _o = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m6 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m.27 3.2a1 1 0 0 0-1.2 0l-.74.55-.73-.55a1 1 0 0 0-1.2 0l-.73.55-.74-.55a1 1 0 0 0-1.2 0l-1.33 1a1 1 0 1 0 1.2 1.6l.73-.55.74.55.12.06a.8.8 0 0 0 .22.08h.12a1 1 0 0 0 .25 0h.1a1.1 1.1 0 0 0 .34-.16l.73-.55.73.55a1 1 0 0 0 1 .11l.1-.05a.4.4 0 0 0 .11-.06l.74-.55.73.55a1 1 0 0 0 .6.2 1 1 0 0 0 .8-.4 1 1 0 0 0-.2-1.4ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), xB = h(_o), zo = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 16h-5.59l3.3-3.29a1 1 0 0 0 0-1.42L10.41 8H16a1 1 0 0 0 0-2H8a1 1 0 0 0-.92.62 1 1 0 0 0 .21 1.09l4.3 4.29-4.3 4.29a1 1 0 0 0-.21 1.09A1 1 0 0 0 8 18h8a1 1 0 0 0 0-2" })
), AB = h(zo), an = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.78 11.88-2-2.5A1 1 0 0 0 19 9h-6V3a1 1 0 0 0-2 0v1H5a1 1 0 0 0-.78.38l-2 2.5a1 1 0 0 0 0 1.24l2 2.5A1 1 0 0 0 5 11h6v9H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-4h6a1 1 0 0 0 .78-.38l2-2.5a1 1 0 0 0 0-1.24M11 9H5.48l-1.2-1.5L5.48 6H11Zm7.52 5H13v-3h5.52l1.2 1.5Z" })
), MB = h(an), tn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.5 15.1a1 1 0 0 0-1.34.45A8 8 0 1 1 12 4a7.93 7.93 0 0 1 7.16 4.45 1 1 0 0 0 1.8-.9 10 10 0 1 0 0 8.9 1 1 0 0 0-.46-1.35M21 11h-9.59l2.3-2.29a1 1 0 1 0-1.42-1.42l-4 4a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L11.41 13H21a1 1 0 0 0 0-2" })
), HB = h(tn), en = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 5h-3V3a1 1 0 0 0-2 0v2H6a1 1 0 0 0-.78.38l-2 2.5a1 1 0 0 0 0 1.24l2 2.5A1 1 0 0 0 6 12h5v8H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-8h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1m-1 5H6.48l-1.2-1.5L6.48 7H15Z" })
), CB = h(en), ln = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m12.59 13-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H3a1 1 0 0 0 0 2ZM12 2a10 10 0 0 0-9 5.55 1 1 0 0 0 1.8.9A8 8 0 1 1 12 20a7.93 7.93 0 0 1-7.16-4.45 1 1 0 0 0-1.8.9A10 10 0 1 0 12 2" })
), uB = h(ln), rn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 6v5a1 1 0 0 0 1 1h3v8H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-8h5a1 1 0 0 0 .78-.37l2-2.5a1 1 0 0 0 0-1.25l-2-2.5A1 1 0 0 0 18 5h-5V3a1 1 0 0 0-2 0v2H8a1 1 0 0 0-1 1m2 1h8.52l1.2 1.5-1.2 1.5H9Z" })
), VB = h(rn), hn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 9h-4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1m-1 12h-2V11h2Zm9-20h-4a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1m-1 20h-2V3h2ZM6 15H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m-1 6H3v-4h2Z" })
), SB = h(hn), on = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 14a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m-5 4a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1M20 2a1 1 0 0 0-1 1v18a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1m-5 7a1 1 0 0 0-1 1v11a1 1 0 0 0 2 0V10a1 1 0 0 0-1-1" })
), LB = h(on), nn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6 15a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m4-3a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m8-8a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1" })
), ZB = h(nn), wn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 12a1 1 0 0 0-1-1h-7.59l2.3-2.29a1 1 0 1 0-1.42-1.42l-4 4a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L11.41 13H19a1 1 0 0 0 1-1M17 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-3a1 1 0 0 0-2 0v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3" })
), BB = h(wn), vn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4 12a1 1 0 0 0 1 1h7.59l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H5a1 1 0 0 0-1 1M17 2H7a3 3 0 0 0-3 3v3a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3" })
), FB = h(vn), mn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m6 0a1 1 0 1 0-1-1 1 1 0 0 0 1 1m1 3a1 1 0 0 0-2 0h-1a1 1 0 0 0-2 0h-1a1 1 0 0 0-2 0 1 1 0 0 0 0 2 1 1 0 0 0 2 0h1a1 1 0 0 0 2 0h1a1 1 0 0 0 2 0 1 1 0 0 0 0-2M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), RB = h(mn), cn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.66 12.21a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l1.5-1.5a1 1 0 0 0 0-1.42l-1.5-1.5a1 1 0 0 0-1.42 1.42l.8.79-.8.79a1 1 0 0 0 0 1.42m7.5 0a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-.79-.79.79-.79a1 1 0 1 0-1.42-1.42l-1.5 1.5a1 1 0 0 0 0 1.42Zm.11 2a1 1 0 0 0-1.2 0l-.74.55-.73-.55a1 1 0 0 0-1.2 0l-.73.55-.74-.55a1 1 0 0 0-1.2 0l-1.33 1a1 1 0 1 0 1.2 1.6l.73-.55.74.55a.7.7 0 0 0 .12.06.8.8 0 0 0 .22.08h.48a1.1 1.1 0 0 0 .33-.16l.73-.55.73.55a1 1 0 0 0 1 .11l.1-.05a.4.4 0 0 0 .11-.06l.74-.55.73.55a1 1 0 0 0 .6.2 1 1 0 0 0 .8-.4 1 1 0 0 0-.2-1.4ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), UB = h(cn), sn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 3.5H7A3.5 3.5 0 0 0 3.5 7v10A3.5 3.5 0 0 0 7 20.5h10a3.5 3.5 0 0 0 3.5-3.5V7A3.5 3.5 0 0 0 17 3.5m-6.5 2h3v3h-3Zm-2 13H7A1.5 1.5 0 0 1 5.5 17v-1.5h3Zm5 0h-3v-3h3Zm5-1.5a1.5 1.5 0 0 1-1.5 1.5h-1.5v-3h3Zm0-3.5h-13V7A1.5 1.5 0 0 1 7 5.5h1.5v4a1 1 0 0 0 1 1h9Zm0-5h-3v-3H17A1.5 1.5 0 0 1 18.5 7Z" })
), $B = h(sn), gn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 15h-2v-3a1 1 0 0 0-1-1h-6V9h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2v2H5a1 1 0 0 0-1 1v3H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6v-2h12v2h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M7 17v4H3v-4Zm3-10V3h4v4Zm11 14h-4v-4h4Z" })
), yB = h(gn), dn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3m1 15a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0Zm14.68-8.35L14 5.66a2.6 2.6 0 0 0-2.64 0A2.74 2.74 0 0 0 10 8v8a2.74 2.74 0 0 0 1.37 2.38 2.57 2.57 0 0 0 2.64 0l6.67-4a2.75 2.75 0 0 0 0-4.7Zm-1 3-6.66 4a.61.61 0 0 1-.63 0A.72.72 0 0 1 12 16V8a.72.72 0 0 1 .36-.64.64.64 0 0 1 .31-.08.63.63 0 0 1 .32.09l6.66 4a.76.76 0 0 1 0 1.28Z" })
), kB = h(dn), pn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.5 7a1 1 0 0 0-1 1v1.69l-4-2.31a2 2 0 0 0-3 1.73v5.78a2 2 0 0 0 1 1.73 2 2 0 0 0 2 0l4-2.31V16a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1m-1 5-5 2.89V9.11l5 2.88ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), bB = h(pn), fn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 3a3 3 0 0 0-3 3v2.84L7 3.47a3.21 3.21 0 0 0-3.29 0A3.38 3.38 0 0 0 2 6.42v11.16a3.38 3.38 0 0 0 1.72 3 3.24 3.24 0 0 0 1.61.42A3.3 3.3 0 0 0 7 20.53l9-5.37V18a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3m-3.68 10.23L6 18.81a1.23 1.23 0 0 1-1.28 0A1.4 1.4 0 0 1 4 17.58V6.42a1.4 1.4 0 0 1 .71-1.25A1.3 1.3 0 0 1 5.33 5a1.23 1.23 0 0 1 .67.19l9.33 5.58a1.45 1.45 0 0 1 0 2.46ZM20 18a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0Z" })
), TB = h(fn), En = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.14 11.813a5 5 0 0 0-1.292-.593c-.28-.085-.59-.168-.91-.247-.28-.078-.612-.158-1.022-.248a9.3 9.3 0 0 1-1.436-.424 1.5 1.5 0 0 1-.616-.447.84.84 0 0 1-.16-.566.97.97 0 0 1 .205-.597 1.6 1.6 0 0 1 .7-.475A4 4 0 0 1 12.031 8a3.8 3.8 0 0 1 1.106.146 2.1 2.1 0 0 1 .663.322 1.2 1.2 0 0 1 .325.343 1 1 0 1 0 1.761-.948 3.15 3.15 0 0 0-.837-.958 4 4 0 0 0-1.319-.669A5.8 5.8 0 0 0 12.032 6a6 6 0 0 0-2.145.35A3.55 3.55 0 0 0 8.31 7.492a2.98 2.98 0 0 0-.604 1.797 2.84 2.84 0 0 0 .58 1.792 3.5 3.5 0 0 0 1.438 1.072 11 11 0 0 0 1.307.408c.008.003.014.01.022.012.192.058.498.135.94.23.173.038.335.079.497.12.016.004.039.009.054.014l.018.002c.248.064.487.129.706.196a3 3 0 0 1 .763.344 1.1 1.1 0 0 1 .363.368 1.2 1.2 0 0 1 .118.585 1.15 1.15 0 0 1-.214.732 1.76 1.76 0 0 1-.802.585 3.8 3.8 0 0 1-1.487.252 3.7 3.7 0 0 1-1.703-.344 1.76 1.76 0 0 1-.616-.547 1 1 0 0 1-.202-.503 1 1 0 0 0-2 0 2.94 2.94 0 0 0 .556 1.64 3.8 3.8 0 0 0 1.342 1.187 5.6 5.6 0 0 0 2.623.567 5.7 5.7 0 0 0 2.254-.405 3.7 3.7 0 0 0 1.665-1.273 3.15 3.15 0 0 0 .584-1.926 3.1 3.1 0 0 0-.375-1.53 3.2 3.2 0 0 0-.997-1.053m7.221 1.878A10.49 10.49 0 0 0 10.31 1.64a6.499 6.499 0 0 0-8.67 8.67A10.49 10.49 0 0 0 13.69 22.36a6.499 6.499 0 0 0 8.67-8.67M16.5 21a4.5 4.5 0 0 1-2.17-.558 1 1 0 0 0-.677-.106A8.492 8.492 0 0 1 3.5 12a8.6 8.6 0 0 1 .164-1.654 1 1 0 0 0-.106-.677A4.5 4.5 0 0 1 9.67 3.558a1 1 0 0 0 .678.106A8.492 8.492 0 0 1 20.5 12a8.6 8.6 0 0 1-.164 1.654 1 1 0 0 0 .106.677A4.5 4.5 0 0 1 16.5 21" })
), PB = h(En), xn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.435 14.156a9.6 9.6 0 0 0 .211-2.027 9.477 9.477 0 0 0-9.54-9.422 9 9 0 0 0-1.625.141A5.536 5.536 0 0 0 2 7.466a5.43 5.43 0 0 0 .753 2.756 10 10 0 0 0-.189 1.884 9.34 9.34 0 0 0 9.54 9.258 8.6 8.6 0 0 0 1.743-.166 5.6 5.6 0 0 0 2.616.802 5.433 5.433 0 0 0 4.97-7.844m-4.995 1.837a3.63 3.63 0 0 1-1.625 1.225 6.3 6.3 0 0 1-2.52.447 6.2 6.2 0 0 1-2.898-.612 3.7 3.7 0 0 1-1.32-1.178 2.57 2.57 0 0 1-.494-1.413.88.88 0 0 1 .307-.684 1.1 1.1 0 0 1 .776-.282.94.94 0 0 1 .637.212 1.8 1.8 0 0 1 .447.659 3.4 3.4 0 0 0 .495.873 1.8 1.8 0 0 0 .73.564 3 3 0 0 0 1.249.236 2.92 2.92 0 0 0 1.72-.447 1.33 1.33 0 0 0 .66-1.131 1.14 1.14 0 0 0-.354-.871 2.2 2.2 0 0 0-.92-.52c-.376-.117-.895-.235-1.53-.376a14 14 0 0 1-2.144-.636 3.35 3.35 0 0 1-1.366-1.013 2.47 2.47 0 0 1-.495-1.578 2.63 2.63 0 0 1 .542-1.602 3.4 3.4 0 0 1 1.53-1.084 6.7 6.7 0 0 1 2.38-.376 6.4 6.4 0 0 1 1.885.258 4.1 4.1 0 0 1 1.318.66 2.9 2.9 0 0 1 .778.872 1.8 1.8 0 0 1 .236.87.96.96 0 0 1-.307.708 1 1 0 0 1-.753.306.97.97 0 0 1-.636-.189 2.4 2.4 0 0 1-.471-.611 2.9 2.9 0 0 0-.778-.967 2.38 2.38 0 0 0-1.46-.353 2.7 2.7 0 0 0-1.508.377 1.08 1.08 0 0 0-.565.896.96.96 0 0 0 .188.565 1.4 1.4 0 0 0 .542.4 2.7 2.7 0 0 0 .683.26c.236.07.613.164 1.154.282.66.142 1.273.306 1.815.471a5.4 5.4 0 0 1 1.389.636 2.86 2.86 0 0 1 .895.942 2.8 2.8 0 0 1 .33 1.39 2.9 2.9 0 0 1-.542 1.814" })
), DB = h(xn), An = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M23 9.5A3.504 3.504 0 0 0 19.5 6a3.46 3.46 0 0 0-1.5.351V4.5a3.495 3.495 0 0 0-6-2.442A3.487 3.487 0 0 0 6.351 6H4.5a3.495 3.495 0 0 0-2.442 6A3.487 3.487 0 0 0 6 17.649V19.5a3.495 3.495 0 0 0 6 2.442A3.487 3.487 0 0 0 17.649 18H19.5a3.495 3.495 0 0 0 2.442-6A3.49 3.49 0 0 0 23 9.5m-10-5a1.5 1.5 0 0 1 3 0v5a1.5 1.5 0 0 1-3 0Zm-7 10A1.5 1.5 0 1 1 4.5 13H6Zm5 5a1.5 1.5 0 0 1-3 0v-5a1.5 1.5 0 0 1 3 0ZM9.5 11h-5a1.5 1.5 0 0 1 0-3h5a1.5 1.5 0 0 1 0 3M11 6H9.5A1.5 1.5 0 1 1 11 4.5Zm1 6.058L11.942 12l.058-.058.058.058zM14.5 21a1.5 1.5 0 0 1-1.5-1.5V18h1.5a1.5 1.5 0 0 1 0 3m5-5h-5a1.5 1.5 0 0 1 0-3h5a1.5 1.5 0 0 1 0 3m0-5H18V9.5a1.5 1.5 0 1 1 1.5 1.5" })
), qB = h(An), Mn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M2 14.67a2 2 0 1 0 4 0v-2H4a2 2 0 0 0-2 2m12.64-3.34a2 2 0 0 0 2-2V4a2 2 0 1 0-4 0v5.33a2 2 0 0 0 2.02 2Zm7.32-2a2 2 0 1 0-4 0v2h2a2 2 0 0 0 2.04-2ZM9.34 12.67a2 2 0 0 0-2 2V20a2 2 0 1 0 4 0v-5.33a2 2 0 0 0-2-2M14.66 18h-2v2a2 2 0 1 0 2-2M20 12.67h-5.34a2 2 0 0 0 0 4H20a2 2 0 0 0 0-4M9.34 7.33H4a2 2 0 1 0 0 4h5.34a2 2 0 0 0 0-4m0-5.33a2 2 0 0 0 0 4h2V4a2 2 0 0 0-2-2" })
), IB = h(Mn), Hn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11h-1.184a2.982 2.982 0 0 0-5.632 0H9.816a2.982 2.982 0 0 0-5.632 0H3a1 1 0 0 0 0 2h1.184a2.982 2.982 0 0 0 5.632 0h4.368a2.982 2.982 0 0 0 5.632 0H21a1 1 0 0 0 0-2M7 13a1 1 0 1 1 1-1 1 1 0 0 1-1 1m10 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), WB = h(Hn), Cn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11h-3.184a2.982 2.982 0 0 0-5.632 0H3a1 1 0 0 0 0 2h9.184a2.982 2.982 0 0 0 5.632 0H21a1 1 0 0 0 0-2m-6 2a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), GB = h(Cn), un = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 8.18V3a1 1 0 0 0-2 0v5.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-7.18a3 3 0 0 0 0-5.64M19 12a1 1 0 1 1 1-1 1 1 0 0 1-1 1m-6 2.18V3a1 1 0 0 0-2 0v11.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-1.18a3 3 0 0 0 0-5.64M12 18a1 1 0 1 1 1-1 1 1 0 0 1-1 1M6 6.18V3a1 1 0 0 0-2 0v3.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-9.18a3 3 0 0 0 0-5.64M5 10a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), OB = h(un), Vn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 6H6V3a1 1 0 0 0-2 0v3H3a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-2 4a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V11a1 1 0 0 0-1-1m7 8a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m9-8h-1V3a1 1 0 0 0-2 0v7h-1a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m-5 0h-1V3a1 1 0 0 0-2 0v11h-1a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2" })
), NB = h(Vn), Sn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.36 14.23a3.76 3.76 0 0 1-4.72 0 1 1 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1 1 0 1 0-1.28-1.54m-5.15-3.69a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41 3.08 3.08 0 0 0-4.24 0 1 1 0 1 0 1.41 1.41 1 1 0 0 1 1.42 0m8.41-1.41a3.08 3.08 0 0 0-4.24 0 1 1 0 0 0 1.41 1.41 1 1 0 0 1 1.42 0 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), QB = h(Sn), Ln = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.36 14.23a3.76 3.76 0 0 1-4.72 0 1 1 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1 1 0 1 0-1.28-1.54M9 11.71l.29-.3.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29.3-.29a1 1 0 0 0-1.46-1.42l-.29.3-.25-.3a1 1 0 1 0-1.46 1.42l.3.29-.3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m5-11.71a1 1 0 0 0-1.42 0l-.29.3-.29-.3a1 1 0 0 0-1.42 1.42l.3.29-.3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l.29-.3.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29.3-.29a1 1 0 0 0 0-1.42" })
), KB = h(Ln), Zn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m5.16 1.21a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-.79-.79.79-.79a1 1 0 1 0-1.42-1.42l-1.5 1.5a1 1 0 0 0 0 1.42ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m2.36-5.77a3.76 3.76 0 0 1-4.72 0 1 1 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1 1 0 1 0-1.28-1.54" })
), jB = h(Zn), Bn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.42 12.21a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l1.5-1.5a1 1 0 0 0 0-1.42l-1.5-1.5a1 1 0 1 0-1.42 1.42l.79.79-.79.79a1 1 0 0 0 0 1.42m5.94 2a3.76 3.76 0 0 1-4.72 0 1 1 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1 1 0 1 0-1.28-1.54M15 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), JB = h(Bn), Fn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m5.36 3.23a3.76 3.76 0 0 1-4.72 0 1 1 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1 1 0 1 0-1.28-1.54M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m5.62-10.87a3.08 3.08 0 0 0-4.24 0 1 1 0 0 0 1.41 1.41 1 1 0 0 1 1.42 0 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41" })
), YB = h(Fn), Rn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.36 14.23a3.76 3.76 0 0 1-4.72 0 1 1 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1 1 0 1 0-1.28-1.54M10.5 10A1.5 1.5 0 1 0 9 11.5a1.5 1.5 0 0 0 1.5-1.5M15 9h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), XB = h(Rn), Un = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.36 14.23a3.76 3.76 0 0 1-4.72 0 1 1 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1 1 0 1 0-1.28-1.54M9 11a1 1 0 1 0-1-1 1 1 0 0 0 1 1m6-2a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), _B = h(Un), $n = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.951 15.614a4.72 4.72 0 0 1-2.981-2.173 1 1 0 1 0-1.657 1.121 7.7 7.7 0 0 0 2.403 2.335q-.202.037-.442.075a1.37 1.37 0 0 0-1.076 1.207 6 6 0 0 0-2.014-.004 4.64 4.64 0 0 0-1.958.956 3.5 3.5 0 0 1-2.104.87h-.26a3.5 3.5 0 0 1-2.106-.872 4.6 4.6 0 0 0-1.929-.95 6.4 6.4 0 0 0-2.04.005 1.37 1.37 0 0 0-1.062-1.21 13 13 0 0 1-.435-.075A6.9 6.9 0 0 0 6.085 15.4a7 7 0 0 0 .635-.868 1 1 0 0 0-1.696-1.06 5 5 0 0 1-.448.616 4.25 4.25 0 0 1-2.553 1.528 1.224 1.224 0 0 0-1.032 1.236 1.3 1.3 0 0 0 .115.533c.316.716 1.156 1.168 2.785 1.474l.03.13c.03.118.058.239.093.348a1.29 1.29 0 0 0 1.278.945 2.6 2.6 0 0 0 .603-.087 4.7 4.7 0 0 1 1.588-.046 3 3 0 0 1 1.123.618 5.4 5.4 0 0 0 3.255 1.235h.261a5.45 5.45 0 0 0 3.274-1.248 2.9 2.9 0 0 1 1.131-.61 3.5 3.5 0 0 1 .624-.052 4.3 4.3 0 0 1 .955.106 4 4 0 0 0 .616.064 1.256 1.256 0 0 0 1.245-.923q.055-.183.094-.355l.032-.124c1.624-.305 2.467-.754 2.767-1.44a1.2 1.2 0 0 0 .127-.48 1.244 1.244 0 0 0-1.036-1.326m-18.15-4.466a1.005 1.005 0 0 0 1.057-.484 3.1 3.1 0 0 0 1.275.338 1.8 1.8 0 0 0 1.265-.499 1 1 0 0 0 .317-.79l-.036-.602a9.9 9.9 0 0 1 .156-3.561 4.26 4.26 0 0 1 3.966-2.544l.388-.004a4.26 4.26 0 0 1 3.96 2.547 9.9 9.9 0 0 1 .156 3.564l-.01.163-.027.444a1.03 1.03 0 0 0 .312.778 1.8 1.8 0 0 0 1.254.503 3.3 3.3 0 0 0 1.241-.365 1 1 0 0 0 .916.598h.018a1 1 0 0 0 .982-1.017 1.64 1.64 0 0 0-1.185-1.451 1.91 1.91 0 0 0-1.477.01 9.5 9.5 0 0 0-.354-4.042 6.24 6.24 0 0 0-5.796-3.732l-.393.004a6.22 6.22 0 0 0-5.777 3.73 9.6 9.6 0 0 0-.352 4.094l-.111-.052a1.91 1.91 0 0 0-2.537 1.199 1 1 0 0 0 .793 1.171" })
), zB = h($n), yn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.798 16.987c-2.867-.472-4.151-3.401-4.204-3.526l-.006-.011a1.07 1.07 0 0 1-.102-.898c.192-.454.83-.656 1.251-.79.106-.033.205-.065.283-.096.763-.3.918-.613.914-.822a.66.66 0 0 0-.5-.543l-.007-.002a1 1 0 0 0-.356-.069.8.8 0 0 0-.313.063 2.5 2.5 0 0 1-.955.266.82.82 0 0 1-.53-.178l.032-.53.004-.065a10.1 10.1 0 0 0-.24-4.035 5.25 5.25 0 0 0-4.874-3.14l-.402.005a5.24 5.24 0 0 0-4.864 3.137 10.1 10.1 0 0 0-.242 4.031q.02.299.036.598a.85.85 0 0 1-.584.178 2.45 2.45 0 0 1-1.014-.268.6.6 0 0 0-.245-.049.83.83 0 0 0-.81.533c-.082.43.532.743.906.89.08.032.178.063.283.096.422.134 1.06.336 1.252.79a1.07 1.07 0 0 1-.102.898l-.006.011a7 7 0 0 1-1.069 1.663A5.22 5.22 0 0 1 2.2 16.987a.24.24 0 0 0-.2.25.4.4 0 0 0 .03.13c.177.411 1.059.75 2.553.981.14.022.198.25.28.622.032.15.066.305.113.465a.293.293 0 0 0 .32.228 2.5 2.5 0 0 0 .424-.06 5.5 5.5 0 0 1 1.12-.127 5 5 0 0 1 .809.068 3.9 3.9 0 0 1 1.535.784 4.44 4.44 0 0 0 2.69 1.06q.05 0 .1-.004c.04.002.095.004.151.004a4.45 4.45 0 0 0 2.692-1.06 3.9 3.9 0 0 1 1.533-.784 5 5 0 0 1 .808-.068 5.6 5.6 0 0 1 1.12.119 2.4 2.4 0 0 0 .425.053h.024a.28.28 0 0 0 .295-.22 7 7 0 0 0 .114-.462c.081-.371.14-.598.28-.62 1.494-.23 2.377-.57 2.551-.978a.4.4 0 0 0 .032-.13.24.24 0 0 0-.2-.25" })
), aF = h(yn), kn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.973 6.68a6 6 0 0 0-.098-1.073 4.4 4.4 0 0 0-.406-1.246 4.3 4.3 0 0 0-.832-1.11 4.1 4.1 0 0 0-1.816-1.036 7.4 7.4 0 0 0-1.92-.205L16.898 2H7.099v.01a11 11 0 0 0-1.101.05 5.2 5.2 0 0 0-1.176.264A4.26 4.26 0 0 0 2.219 5.17a7.3 7.3 0 0 0-.205 1.905l-.006 9.838a9.5 9.5 0 0 0 .09 1.333 4.6 4.6 0 0 0 .41 1.345 4.3 4.3 0 0 0 1.201 1.454 3.9 3.9 0 0 0 1.203.651 6.5 6.5 0 0 0 1.976.29c.42.003.839.014 1.258.012 3.047-.013 6.094.022 9.14-.019a7 7 0 0 0 1.2-.127 4.06 4.06 0 0 0 2.007-.977 4.16 4.16 0 0 0 1.326-2.212 8 8 0 0 0 .173-1.75v-.117c0-.046-.017-9.984-.019-10.115m-2.676 9.25c-.128.3-.774.548-1.868.717-.102.016-.146.182-.205.454q-.035.166-.083.337a.204.204 0 0 1-.216.162h-.018a2 2 0 0 1-.31-.04 4 4 0 0 0-.821-.086 3.6 3.6 0 0 0-.592.05 2.8 2.8 0 0 0-1.123.574 3.26 3.26 0 0 1-1.97.776l-.112-.003-.073.003a3.25 3.25 0 0 1-1.97-.776 2.84 2.84 0 0 0-1.123-.574 3.6 3.6 0 0 0-.592-.05 4 4 0 0 0-.82.093 2 2 0 0 1-.311.044.214.214 0 0 1-.234-.167q-.05-.175-.083-.34c-.06-.273-.103-.44-.205-.456-1.094-.168-1.74-.417-1.869-.718a.3.3 0 0 1-.023-.095.176.176 0 0 1 .147-.183 3.82 3.82 0 0 0 2.296-1.365A5.2 5.2 0 0 0 7.9 13.07l.004-.008a.79.79 0 0 0 .075-.658c-.14-.332-.607-.48-.916-.578a3 3 0 0 1-.207-.07c-.274-.108-.724-.337-.664-.652a.61.61 0 0 1 .593-.39.4.4 0 0 1 .18.036 1.8 1.8 0 0 0 .742.196.62.62 0 0 0 .428-.131q-.012-.219-.027-.438a7.4 7.4 0 0 1 .177-2.951 3.84 3.84 0 0 1 3.562-2.298l.295-.002a3.84 3.84 0 0 1 3.568 2.298 7.4 7.4 0 0 1 .176 2.955l-.003.047-.023.389a.6.6 0 0 0 .388.13 1.9 1.9 0 0 0 .7-.195.55.55 0 0 1 .228-.046.7.7 0 0 1 .261.05l.004.002a.485.485 0 0 1 .367.398c.003.153-.11.381-.669.602-.057.022-.13.046-.207.07-.31.098-.776.246-.916.578a.78.78 0 0 0 .074.657l.004.009a4.52 4.52 0 0 0 3.079 2.582.176.176 0 0 1 .146.183.3.3 0 0 1-.023.096" })
), tF = h(kn), bn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11h-1.59l1.3-1.29a1 1 0 0 0-1.42-1.42L16.59 11h-2.18l2.3-2.29a1 1 0 1 0-1.42-1.42L13 9.59V7.41l2.71-2.7a1 1 0 1 0-1.42-1.42L13 4.59V3a1 1 0 0 0-2 0v1.59l-1.29-1.3a1 1 0 0 0-1.42 1.42L11 7.41v2.18l-2.29-2.3a1 1 0 1 0-1.42 1.42L9.59 11H7.41l-2.7-2.71a1 1 0 0 0-1.42 1.42L4.59 11H3a1 1 0 0 0 0 2h1.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L7.41 13h2.18l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.29-2.3v2.18l-2.71 2.7a1 1 0 0 0 1.42 1.42l1.29-1.3V21a1 1 0 0 0 2 0v-1.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13 16.59v-2.18l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L14.41 13h2.18l2.7 2.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L19.41 13H21a1 1 0 0 0 0-2" })
), eF = h(bn), Tn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M4.93 17.66a1 1 0 1 0 1.41 0 1 1 0 0 0-1.41 0M19.07 6.34a1 1 0 1 0-1.41 0 1 1 0 0 0 1.41 0m-12.73 0a1 1 0 1 0-1.41 0 1 1 0 0 0 1.41 0m11.32 11.32a1 1 0 1 0 1.41 0 1 1 0 0 0-1.41 0M21 11h-1.59l1.3-1.29a1 1 0 0 0-1.42-1.42L16.59 11h-2.18l2.3-2.29a1 1 0 1 0-1.42-1.42L13 9.59V7.41l2.71-2.7a1 1 0 1 0-1.42-1.42L13 4.59V3a1 1 0 0 0-2 0v1.59l-1.29-1.3a1 1 0 0 0-1.42 1.42L11 7.41v2.18l-2.29-2.3a1 1 0 1 0-1.42 1.42L9.59 11H7.41l-2.7-2.71a1 1 0 0 0-1.42 1.42L4.59 11H3a1 1 0 0 0 0 2h1.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L7.41 13h2.18l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.29-2.3v2.18l-2.71 2.7a1 1 0 0 0 1.42 1.42l1.29-1.3V21a1 1 0 0 0 2 0v-1.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13 16.59v-2.18l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L14.41 13h2.18l2.7 2.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L19.41 13H21a1 1 0 0 0 0-2" })
), lF = h(Tn), Pn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.16 16.13-2-1.15.89-.24a1 1 0 1 0-.52-1.93l-2.82.76L14 12l2.71-1.57 2.82.76h.26a1 1 0 0 0 .26-2L19.16 9l2-1.15a1 1 0 0 0-1-1.74L18 7.37l.3-1.11a1 1 0 1 0-1.93-.52l-.82 3L13 10.27V7.14l2.07-2.07a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0l-.65.65V2a1 1 0 0 0-2 0v2.47l-.81-.81a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41L11 7.3v3L8.43 8.78l-.82-3a1 1 0 1 0-1.93.52L6 7.37 3.84 6.13a1 1 0 0 0-1 1.74l2 1.13-.84.26a1 1 0 0 0 .26 2h.26l2.82-.76L10 12l-2.71 1.57-2.82-.76A1 1 0 1 0 4 14.74l.89.24-2 1.15a1 1 0 0 0 1 1.74L6 16.63l-.3 1.11A1 1 0 0 0 6.39 19a1.2 1.2 0 0 0 .26 0 1 1 0 0 0 1-.74l.82-3L11 13.73v3.13l-2.07 2.07a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l.65-.65V22a1 1 0 0 0 2 0v-2.47l.81.81a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41L13 16.7v-3l2.57 1.49.82 3a1 1 0 0 0 1 .74 1.2 1.2 0 0 0 .26 0 1 1 0 0 0 .71-1.23L18 16.63l2.14 1.24a1 1 0 1 0 1-1.74Z" })
), rF = h(Pn), Dn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.5 17H5.914l.293-.293a1 1 0 0 0-1.414-1.414l-2 2a1.004 1.004 0 0 0 0 1.414l2 2a1 1 0 0 0 1.414-1.414L5.914 19H8.5a1 1 0 0 0 0-2m12.707.293-2-2a1 1 0 0 0-1.414 1.414l.293.293H15.5a1 1 0 0 0 0 2h2.586l-.293.293a1 1 0 1 0 1.414 1.414l2-2a1.004 1.004 0 0 0 0-1.414m-.567-7.521A3.47 3.47 0 0 0 21.5 7.5a3.5 3.5 0 0 0-7 0 3.47 3.47 0 0 0 .86 2.272A4.99 4.99 0 0 0 13 14a1 1 0 0 0 2 0 3 3 0 0 1 6 0 1 1 0 0 0 2 0 4.99 4.99 0 0 0-2.36-4.228M18 9a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 18 9m-9.36.772A3.47 3.47 0 0 0 9.5 7.5a3.5 3.5 0 0 0-7 0 3.47 3.47 0 0 0 .86 2.272A4.99 4.99 0 0 0 1 14a1 1 0 0 0 2 0 3 3 0 0 1 6 0 1 1 0 0 0 2 0 4.99 4.99 0 0 0-2.36-4.228M6 9a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 6 9" })
), hF = h(Dn), qn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m6.29 14.29-.29.3V7a1 1 0 0 0-2 0v7.59l-.29-.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2-2a1 1 0 0 0-1.42-1.42M11 8h10a1 1 0 0 0 0-2H11a1 1 0 0 0 0 2m10 3H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m0 5H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2" })
), oF = h(qn), In = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5.71 6.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2 2a1 1 0 0 0 1.42 1.42l.29-.3V17a1 1 0 0 0 2 0V9.41l.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM11 8h10a1 1 0 0 0 0-2H11a1 1 0 0 0 0 2m10 8H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m0-5H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2" })
), nF = h(In), Wn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.29 14.29 12 18.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l5 5a1 1 0 0 0 1.42 0l5-5a1 1 0 0 0-1.42-1.42M7.71 9.71 12 5.41l4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-5-5a1 1 0 0 0-1.42 0l-5 5a1 1 0 0 0 1.42 1.42" })
), wF = h(Wn), Gn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 10.21a1 1 0 0 0 1.42 0l3-3a1 1 0 1 0-1.42-1.42L12 8.09l-2.29-2.3a1 1 0 0 0-1.42 1.42Zm1.42 4.58a1 1 0 0 0-1.42 0l-3 3a1 1 0 0 0 1.42 1.42l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), vF = h(Gn), On = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 9a1 1 0 0 0-1 1v3H4v-3a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1" })
), mF = h(On), Nn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.06 12.28a5.7 5.7 0 0 0-1.67-4L14 2.81a2.83 2.83 0 0 0-4 0L4.61 8.23a5.7 5.7 0 0 0-1.67 4A5.7 5.7 0 0 0 8.66 18a6.9 6.9 0 0 1-1.23 2.37A1 1 0 0 0 8.24 22h7.52a1 1 0 0 0 .78-1.63A6.8 6.8 0 0 1 15.31 18a5.69 5.69 0 0 0 5.75-5.71ZM18 14.91a3.78 3.78 0 0 1-3.66.95 1 1 0 0 0-.17 0h-.2a1.4 1.4 0 0 0-.22.06h-.15a.7.7 0 0 0-.13.11.8.8 0 0 0-.17.14.6.6 0 0 1-.06.11 3 3 0 0 0-.12.23 1 1 0 0 0 0 .18v.18a8.8 8.8 0 0 0 .82 3.13h-3.88a8.6 8.6 0 0 0 .88-3v-.19a1 1 0 0 0 0-.18 1.1 1.1 0 0 0-.13-.24.5.5 0 0 0-.06-.1.5.5 0 0 0-.16-.14 1 1 0 0 0-.13-.11h-.14a1 1 0 0 0-.23-.07H9.9a1 1 0 0 0-.18 0A3.81 3.81 0 0 1 6 14.91a3.75 3.75 0 0 1-1.09-2.63A3.7 3.7 0 0 1 6 9.65l5.4-5.42a.81.81 0 0 1 1.13 0L18 9.65a3.7 3.7 0 0 1 1.09 2.63A3.78 3.78 0 0 1 18 14.91" })
), cF = h(Nn), Qn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.06 20.1a2 2 0 0 1-.65-.48 2.47 2.47 0 0 1-.67-1.14 4.2 4.2 0 0 0-1.31-2.06 3.57 3.57 0 0 0-1-3.28 3.28 3.28 0 0 0-4.59-.35 3.29 3.29 0 0 0 .35 4.6 3.87 3.87 0 0 0 2.21 1.12h.36a2.85 2.85 0 0 0 1.53-.44 2.05 2.05 0 0 1 .51.93A4.46 4.46 0 0 0 9 21a4.3 4.3 0 0 0 1.2.88 1 1 0 0 0 .44.1 1 1 0 0 0 .44-1.9Zm-4.74-3.77a.86.86 0 0 1-.7.19A1.8 1.8 0 0 1 4.56 16c-.57-.56-.73-1.39-.36-1.77a.82.82 0 0 1 .56-.2 1.8 1.8 0 0 1 1.24.53 1.8 1.8 0 0 1 .55 1.06.86.86 0 0 1-.23.71m15-6.12a2.2 2.2 0 0 1-.91-.59 2.47 2.47 0 0 1-.67-1.14 4.2 4.2 0 0 0-1.31-2.06 3.57 3.57 0 0 0-1.05-3.28 3.28 3.28 0 0 0-4.59-.35 3.29 3.29 0 0 0 .35 4.6 3.87 3.87 0 0 0 2.26 1.12h.36a2.85 2.85 0 0 0 1.53-.44 2.05 2.05 0 0 1 .51.93 4.54 4.54 0 0 0 1.2 2 4.36 4.36 0 0 0 1.7 1.08 1.3 1.3 0 0 0 .32.05 1 1 0 0 0 .95-.68 1 1 0 0 0-.65-1.24m-5-3.88a.86.86 0 0 1-.7.19A1.8 1.8 0 0 1 14.56 6c-.57-.56-.73-1.39-.36-1.77a.82.82 0 0 1 .56-.2 1.8 1.8 0 0 1 1.24.53 1.8 1.8 0 0 1 .55 1.06.86.86 0 0 1-.23.71m5.39 14.12a4.45 4.45 0 0 0-3.23-3.23 3.2 3.2 0 0 1-1.39-.82 2.93 2.93 0 0 1-.8-1.38A4.65 4.65 0 0 0 13 11.77a2.9 2.9 0 0 1-1.38-.8 3 3 0 0 1-.81-1.39 4.7 4.7 0 0 0-1-1.86 3.9 3.9 0 0 0 .19-1.5 4.75 4.75 0 0 0-1.4-2.8A4.78 4.78 0 0 0 5.78 2 3.43 3.43 0 0 0 3 3a3.43 3.43 0 0 0-1 2.78 4.75 4.75 0 0 0 1.4 2.8A4.78 4.78 0 0 0 6.22 10h.43a3.4 3.4 0 0 0 2-.6 2.6 2.6 0 0 1 .31.71 5.12 5.12 0 0 0 3.6 3.59 2.61 2.61 0 0 1 1.83 1.84 5.11 5.11 0 0 0 3.6 3.6 2.57 2.57 0 0 1 1.8 1.86 3 3 0 0 0 .16.46 1 1 0 0 0 .88.54 1.2 1.2 0 0 0 .44-.1 1 1 0 0 0 .48-1.33s-.03-.1-.04-.12M7.64 7.64c-.64.63-1.92.41-2.81-.47A2.78 2.78 0 0 1 4 5.56a1.47 1.47 0 0 1 .35-1.2 1.4 1.4 0 0 1 1-.36 2.7 2.7 0 0 1 1.83.83A2.78 2.78 0 0 1 8 6.44a1.47 1.47 0 0 1-.36 1.2" })
), sF = h(Qn), Kn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 3a7 7 0 0 0 0 14 5 5 0 0 0 0-10 3 3 0 0 0 0 6 1 1 0 0 0 0-2 1 1 0 0 1 0-2 3 3 0 0 1 0 6 5 5 0 0 1 0-10 7 7 0 0 1 0 14 9 9 0 0 1-9-9 1 1 0 0 0-2 0 11 11 0 0 0 11 11 9 9 0 0 0 0-18" })
), gF = h(Kn), jn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.804 15a1 1 0 0 0-1.366-.366l-1.732 1a1 1 0 0 0 1 1.732l1.732-1A1 1 0 0 0 6.804 15M3.706 8.366l1.732 1a1 1 0 1 0 1-1.732l-1.732-1a1 1 0 0 0-1 1.732M6 12a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1m11.196-3a1 1 0 0 0 1.366.366l1.732-1a1 1 0 1 0-1-1.732l-1.732 1A1 1 0 0 0 17.196 9M15 6.804a1 1 0 0 0 1.366-.366l1-1.732a1 1 0 1 0-1.732-1l-1 1.732A1 1 0 0 0 15 6.804m5.294 8.83-1.732-1a1 1 0 1 0-1 1.732l1.732 1a1 1 0 0 0 1-1.732m-3.928 1.928a1 1 0 1 0-1.732 1l1 1.732a1 1 0 1 0 1.732-1ZM21 11h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m-9 7a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m-3-.804a1 1 0 0 0-1.366.366l-1 1.732a1 1 0 0 0 1.732 1l1-1.732A1 1 0 0 0 9 17.196M12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1" })
), iF = h(jn), Jn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M5.1 16c-.3-.5-.9-.6-1.4-.4-.5.3-.6.9-.4 1.4.3.5.9.6 1.4.4.5-.3.6-.9.4-1.4m-.4-9.4c-.5-.2-1.1-.1-1.4.4-.2.5-.1 1.1.4 1.4.5.2 1.1.1 1.4-.4.2-.5.1-1.1-.4-1.4m15.6 1.8c.5-.3.6-.9.4-1.4-.3-.5-.9-.6-1.4-.4-.5.3-.6.9-.4 1.4.3.5.9.6 1.4.4M4 12c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1m3.2 6.8c-.5.1-.9.7-.7 1.2.1.5.7.9 1.2.7.5-.1.9-.7.7-1.2-.1-.5-.6-.8-1.2-.7M21 11c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m-.7 4.6c-.5-.3-1.1-.1-1.4.4s-.1 1.1.4 1.4 1.1.1 1.4-.4c.2-.5.1-1.1-.4-1.4M17 3.3c-.5-.3-1.1-.1-1.4.4s-.1 1.1.4 1.4 1.1.1 1.4-.4c.2-.5.1-1.1-.4-1.4m-.2 15.5c-.5-.1-1.1.2-1.2.7s.2 1.1.7 1.2 1.1-.2 1.2-.7-.2-1-.7-1.2M12 20c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m0-18c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1" })
), dF = h(Jn), Yn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 18H4V4h16Z" })
), pF = h(Yn), Xn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 2H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5m3 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3Z" })
), fF = h(Xn), _n = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 18H4V4h16Z" })
), EF = h(_n), zn = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 14H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m-5.92-1.79 1.5-1.5a1 1 0 0 0 0-1.42l-1.5-1.5a1 1 0 0 0-1.42 1.42l.8.79-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m4.58-12.21a1 1 0 0 0-1.42 0l-1.5 1.5a1 1 0 0 0 0 1.42l1.5 1.5a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-.79-.79.79-.79a1 1 0 0 0 0-1.42" })
), xF = h(zn), aw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 9.67a1 1 0 0 0-.86-.67l-5.69-.83L12.9 3a1 1 0 0 0-1.8 0L8.55 8.16 2.86 9a1 1 0 0 0-.81.68 1 1 0 0 0 .25 1l4.13 4-1 5.68a1 1 0 0 0 1.47 1.08l5.1-2.67 5.1 2.67a.93.93 0 0 0 .46.12 1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1l-1-5.68 4.13-4A1 1 0 0 0 22 9.67M11 17l-3.23 1.7.72-4.2a1 1 0 0 0-.29-.88l-3-3 4.21-.61a1 1 0 0 0 .76-.55L11 7.73Zm4.8-3.38a1 1 0 0 0-.29.88l.72 4.2L13 17V7.73l.88 1.79a1 1 0 0 0 .76.55l4.21.61Z" })
), AF = h(aw), tw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 9.67a1 1 0 0 0-.86-.67l-5.69-.83L12.9 3a1 1 0 0 0-1.8 0L8.55 8.16 2.86 9a1 1 0 0 0-.81.68 1 1 0 0 0 .25 1l4.13 4-1 5.68a1 1 0 0 0 .4 1 1 1 0 0 0 1.05.07L12 18.76l5.1 2.68a.93.93 0 0 0 .46.12 1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1l-1-5.68 4.13-4A1 1 0 0 0 22 9.67m-6.15 4a1 1 0 0 0-.29.89l.72 4.19-3.76-2a1 1 0 0 0-.94 0l-3.76 2 .72-4.19a1 1 0 0 0-.29-.89l-3-3 4.21-.61a1 1 0 0 0 .76-.55L12 5.7l1.88 3.82a1 1 0 0 0 .76.55l4.21.61Z" })
), MF = h(tw), ew = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 3a3 3 0 0 0-3 3v12a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3m1 15a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0ZM12.63 5.63a2.6 2.6 0 0 0-2.64 0l-6.67 4a2.75 2.75 0 0 0 0 4.7l6.67 4a2.57 2.57 0 0 0 2.64 0A2.74 2.74 0 0 0 14 16V8a2.74 2.74 0 0 0-1.37-2.37M12 16a.72.72 0 0 1-.36.64.61.61 0 0 1-.63 0l-6.66-4a.76.76 0 0 1 0-1.28l6.66-4a.63.63 0 0 1 .32-.09.64.64 0 0 1 .31.08A.72.72 0 0 1 12 8Z" })
), HF = h(ew), lw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.5 7.38a2 2 0 0 0-2 0l-4 2.31V8a1 1 0 0 0-2 0v8a1 1 0 0 0 2 0v-1.69l4 2.31a2 2 0 0 0 2 0 2 2 0 0 0 1-1.73V9.11a2 2 0 0 0-1-1.73m-1 7.51L9.5 12l5-2.89ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), CF = h(lw), rw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.28 3.43a3.23 3.23 0 0 0-3.29 0L8 8.84V6a3 3 0 0 0-6 0v12a3 3 0 0 0 6 0v-2.84l9 5.37a3.3 3.3 0 0 0 1.68.47 3.24 3.24 0 0 0 1.61-.43 3.38 3.38 0 0 0 1.72-3V6.42a3.38 3.38 0 0 0-1.73-2.99M6 18a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0Zm14-.42a1.4 1.4 0 0 1-.71 1.25 1.23 1.23 0 0 1-1.28 0l-9.33-5.6a1.45 1.45 0 0 1 0-2.46L18 5.19a1.23 1.23 0 0 1 .67-.19 1.3 1.3 0 0 1 .62.17A1.4 1.4 0 0 1 20 6.42Z" })
), uF = h(rw), hw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.71 7.29a1 1 0 1 0-1.42 1.42l3.3 3.29-3.3 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 0-1.42ZM16 7a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1" })
), VF = h(hw), ow = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 8a2.993 2.993 0 0 0-1 5.816V15.5a4.5 4.5 0 0 1-9 0v-1.02l3.124-2.498A4.98 4.98 0 0 0 14 8.078V3a1 1 0 0 0-1-1h-2a1 1 0 0 0 0 2h1v4.078a2.99 2.99 0 0 1-1.125 2.342L8 12.72l-2.874-2.3A2.99 2.99 0 0 1 4 8.078V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0-1 1v5.078a4.97 4.97 0 0 0 1.876 3.904L7 14.48v1.02a6.5 6.5 0 0 0 13 0v-1.684A2.993 2.993 0 0 0 19 8m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), SF = h(ow), nw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 8a2.993 2.993 0 0 0-1 5.816V15.5a4.5 4.5 0 0 1-9 0v-.59A6.004 6.004 0 0 0 14 9V3a1 1 0 0 0-1-1h-2a1 1 0 0 0 0 2h1v5a4 4 0 0 1-8 0V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0-1 1v6a6.004 6.004 0 0 0 5 5.91v.59a6.5 6.5 0 0 0 13 0v-1.684A2.993 2.993 0 0 0 19 8m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), LF = h(nw), ww = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 8H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1m-1 6h-4v-4h4ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), ZF = h(ww), vw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.6 5.63a1 1 0 0 0 .36 2 6 6 0 0 1 1-.09 6 6 0 0 1 6 6 6 6 0 0 1-.09 1 1 1 0 0 0 .8 1.16h.18a1 1 0 0 0 1-.82A7.5 7.5 0 0 0 20 13.5a8 8 0 0 0-1.7-4.91l.91-.9a1 1 0 0 0-1.42-1.42l-.9.91A8 8 0 0 0 12 5.5a7.5 7.5 0 0 0-1.4.13M10 4.5h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2m3.49 9.08v-.16l1.34-1.33a1 1 0 1 0-1.42-1.42L12.08 12h-.16L5.71 5.79a1 1 0 0 0-1.42 1.42l.48.48.91.91A8 8 0 0 0 16.9 19.82l1.39 1.39a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM12 19.5A6 6 0 0 1 7.11 10l3.4 3.39v.08A1.5 1.5 0 0 0 12 15h.08l3.39 3.4A6 6 0 0 1 12 19.5" })
), BF = h(vw), mw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m18.3 8.59.91-.9a1 1 0 0 0-1.42-1.42l-.9.91a8 8 0 0 0-9.79 0l-.91-.92a1 1 0 0 0-1.42 1.43l.92.91A7.92 7.92 0 0 0 4 13.5a8 8 0 1 0 14.3-4.91M12 19.5a6 6 0 1 1 6-6 6 6 0 0 1-6 6m-2-15h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2m3 6a1 1 0 0 0-2 0v1.89a1.5 1.5 0 1 0 2 0Z" })
), FF = h(mw), cw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 2H2a1 1 0 0 0-1 1v4a3 3 0 0 0 2 2.82V21a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9.82A3 3 0 0 0 23 7V3a1 1 0 0 0-1-1m-7 2h2v3a1 1 0 0 1-2 0Zm-4 0h2v3a1 1 0 0 1-2 0ZM7 4h2v3a1 1 0 0 1-2 0ZM4 8a1 1 0 0 1-1-1V4h2v3a1 1 0 0 1-1 1m10 12h-4v-4a2 2 0 0 1 4 0Zm5 0h-3v-4a4 4 0 0 0-8 0v4H5V9.82a3.2 3.2 0 0 0 1-.6 3 3 0 0 0 4 0 3 3 0 0 0 4 0 3 3 0 0 0 4 0 3.2 3.2 0 0 0 1 .6Zm2-13a1 1 0 0 1-2 0V4h2Z" })
), RF = h(cw), sw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.7 4h9.623l1.661 4.154A1.995 1.995 0 0 1 16 8a1 1 0 0 0-2 0 1.8 1.8 0 0 1-.134.709 1 1 0 0 0 .543 1.305 1 1 0 0 0 .174.035A3.99 3.99 0 0 0 18 12v1.3a1 1 0 0 0 2 0v-1.856a3.99 3.99 0 0 0 1.996-3.405q.002-.014.003-.028L22 8a1 1 0 0 0-.035-.171 1 1 0 0 0-.036-.2l-2-5A1 1 0 0 0 19 2H8.7a1 1 0 1 0 0 2m14.007 17.293-2.933-2.933a1 1 0 0 0-.154-.154l-9.95-9.95a1 1 0 0 0-.206-.206L5.182 3.768a1 1 0 0 0-.128-.128L2.707 1.293a1 1 0 0 0-1.414 1.414l1.964 1.964-1.178 2.94-.007.017a1 1 0 0 0-.035.189A1 1 0 0 0 2 8l.001.012.003.024A3.99 3.99 0 0 0 4 11.444V21a1 1 0 0 0 1 1h14a.99.99 0 0 0 .93-.656l1.363 1.363a1 1 0 0 0 1.414-1.414M4.016 8.153l.778-1.945L7.67 9.084A1.97 1.97 0 0 1 6 10a1.996 1.996 0 0 1-1.984-1.846ZM9 15v5H6v-8a3.96 3.96 0 0 0 3.102-1.484L12.586 14H10a1 1 0 0 0-1 1m4 5h-2v-4h2Zm5 0h-3v-3.586l3 3Z" })
), UF = h(sw), gw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 7.82a1 1 0 0 0 0-.19l-2-5A1 1 0 0 0 19 2H5a1 1 0 0 0-.93.63l-2 5a1 1 0 0 0 0 .19A.6.6 0 0 0 2 8a4 4 0 0 0 2 3.4V21a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9.56A4 4 0 0 0 22 8a.6.6 0 0 0 0-.18M13 20h-2v-4h2Zm5 0h-3v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5H6v-8a4 4 0 0 0 3-1.38 4 4 0 0 0 6 0A4 4 0 0 0 18 12Zm0-10a2 2 0 0 1-2-2 1 1 0 0 0-2 0 2 2 0 0 1-4 0 1 1 0 0 0-2 0 2 2 0 0 1-4 .15L5.68 4h12.64L20 8.15A2 2 0 0 1 18 10" })
), $F = h(gw), iw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 12a1 1 0 1 0 1 1 1 1 0 0 0-1-1m9.71-2.36a10 10 0 0 0-19.4 0 9.75 9.75 0 0 0 0 4.72 10 10 0 0 0 7.3 7.34 9.7 9.7 0 0 0 4.7 0 10 10 0 0 0 7.31-7.31 9.75 9.75 0 0 0 0-4.72ZM12 4a8 8 0 0 1 7.41 5H4.59A8 8 0 0 1 12 4m-8 8a8 8 0 0 1 .07-1H6v2H4.07A8 8 0 0 1 4 12m5 7.41A8 8 0 0 1 4.59 15H7a2 2 0 0 1 2 2Zm4 .52a8 8 0 0 1-1 .07 8 8 0 0 1-1-.07V18h2Zm.14-3.93h-2.28A4 4 0 0 0 8 13.14V11h8v2.14A4 4 0 0 0 13.14 16M15 19.41V17a2 2 0 0 1 2-2h2.41A8 8 0 0 1 15 19.41M19.93 13H18v-2h1.93a8 8 0 0 1 .07 1 8 8 0 0 1-.07 1" })
), yF = h(iw), dw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 4.5h3a1 1 0 0 0 0-2h-3a1 1 0 0 0 0 2m3 2H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1.55l5.11 2.56-2.58 1.29A3 3 0 0 0 5 15.5a3 3 0 1 0 3 3 2 2 0 0 0 0-.36l3.94-2 4.06 2.1a2 2 0 0 0 0 .26 3 3 0 1 0 3-3 3 3 0 0 0-2.15.92l-2.72-1.36 5.11-2.56H21a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-16 13a1 1 0 1 1 1-1 1 1 0 0 1-1 1m14-2a1 1 0 1 1-1 1 1 1 0 0 1 1-1m-7.1-3.56L9 12.5h5.75ZM20 10.5H4v-2h16Z" })
), kF = h(dw), pw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 16H3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2M3 8h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m18 3H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2" })
), bF = h(pw), fw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 17h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m6 0V9a3 3 0 0 0-3-3h-5V4h4a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2h4v2H6a3 3 0 0 0-3 3v8a3 3 0 0 0 1.2 2.39l-.91.9a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L6.41 20h11.18l1.7 1.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.91-.9A3 3 0 0 0 21 17M5 9a1 1 0 0 1 1-1h5v4H5Zm14 8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3h14Zm0-5h-6V8h5a1 1 0 0 1 1 1ZM8 17h1a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2" })
), TF = h(fw), Ew = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 17a1 1 0 0 0 1-1 1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.06-.18.8.8 0 0 0-.09-.18l-.12-.15a1.2 1.2 0 0 0-.33-.21 1 1 0 0 0-.76 0 1.2 1.2 0 0 0-.33.21l-.12.15a.8.8 0 0 0-.09.18.6.6 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 1 1Zm2-15H6a3 3 0 0 0-3 3v12a3 3 0 0 0 1.2 2.39l-.91.9a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L6.41 20h11.18l1.7 1.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.91-.9A3 3 0 0 0 21 17V5a3 3 0 0 0-3-3M5 8h6v4H5Zm14 9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3h14Zm0-5h-6V8h6Zm0-6H5V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1ZM8 17a1 1 0 0 0 1-1 1.4 1.4 0 0 0 0-.2.6.6 0 0 0-.06-.18.8.8 0 0 0-.09-.18l-.12-.15a1.2 1.2 0 0 0-.33-.21 1 1 0 0 0-.76 0 1.2 1.2 0 0 0-.33.21l-.12.15a.8.8 0 0 0-.09.18.6.6 0 0 0-.1.18 1.4 1.4 0 0 0 0 .2 1 1 0 0 0 .29.7A1 1 0 0 0 8 17" })
), PF = h(Ew), xw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6h-3V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3m-9-1h4v1h-4Zm10 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5h4v1a1 1 0 0 0 2 0v-1h4v1a1 1 0 0 0 2 0v-1h4Zm0-7H4V9a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), DF = h(xw), Aw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 6.5h-3v-1a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3m-9-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm10 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5.05h3v1.05a1 1 0 0 0 2 0v-1.05h6v1.05a1 1 0 0 0 2 0v-1.05h3Zm0-7H4v-2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), qF = h(Aw), Mw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m5.64 17-.71.71a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l.71-.71A1 1 0 0 0 5.64 17M5 12a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1m7-7a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1M5.64 7.05a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.41 1.41Zm12 .29a1 1 0 0 0 .7-.29l.71-.71a1 1 0 1 0-1.41-1.41l-.64.71a1 1 0 0 0 0 1.41 1 1 0 0 0 .66.29ZM21 11h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m-9 8a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1m6.36-2A1 1 0 0 0 17 18.36l.71.71a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41ZM12 6.5a5.5 5.5 0 1 0 5.5 5.5A5.51 5.51 0 0 0 12 6.5m0 9a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5" })
), IF = h(Mw), Hw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.66 8.34a1 1 0 0 0 .7-.29l.71-.71a1 1 0 1 0-1.41-1.41l-.66.71a1 1 0 0 0 0 1.41 1 1 0 0 0 .66.29M12 6a1 1 0 0 0 1-1V4a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1m-8 6H3a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m1.64-3.95a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.41 1.41ZM21 12h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m-10 7H8a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2m7-4h-.88a5.4 5.4 0 0 0 .38-2 5.5 5.5 0 0 0-11 0 5.4 5.4 0 0 0 .38 2H6a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2m-3.15 0h-5.7a3.44 3.44 0 0 1-.65-2 3.5 3.5 0 0 1 7 0 3.44 3.44 0 0 1-.65 2M16 19h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2" })
), WF = h(Hw), Cw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8M10 9a1 1 0 1 0-1 1 1 1 0 0 0 1-1m5-1a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3 3a3.39 3.39 0 0 0-3.25 3.5A3.39 3.39 0 0 0 12 18a3.39 3.39 0 0 0 3.25-3.5A3.39 3.39 0 0 0 12 11m0 5a1.39 1.39 0 0 1-1.25-1.5A1.39 1.39 0 0 1 12 13a1.39 1.39 0 0 1 1.25 1.5A1.39 1.39 0 0 1 12 16" })
), GF = h(Cw), uw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7 16a1 1 0 1 0 1 1 1 1 0 0 0-1-1m12.06-4 1.23-1.23a3 3 0 0 0 0-4.24l-2.83-2.82a3 3 0 0 0-4.24 0L12 4.94A3 3 0 0 0 9 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a3 3 0 0 0-2.94-3M10 19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Zm2-11.24 2.64-2.64a1 1 0 0 1 1.41 0L18.88 8a1 1 0 0 1 0 1.41L16 12.29l-4 3.95ZM20 19a1 1 0 0 1-1 1h-7.18a3.1 3.1 0 0 0 .17-.92L17.07 14H19a1 1 0 0 1 1 1Z" })
), OF = h(uw), Vw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.878 5.928a.297.297 0 0 1 .314.335l.003.276c.001.593-.002 1.185.002 1.777.004.434.08.517.5.57a15 15 0 0 0 3.148-.046 5 5 0 0 0 1.573-.374.507.507 0 0 0 .344-.603 6.83 6.83 0 0 0-5.343-5.71 6.6 6.6 0 0 0-3.648.242 6.7 6.7 0 0 0-2.694 1.752A6.27 6.27 0 0 0 5.23 8.432a11.2 11.2 0 0 0 1.526 5.517 1.34 1.34 0 0 0 1.33.748c.653-.016 1.307-.004 1.96-.004v-.003h2.084c.25 0 .447.06.445.372-.005.726 0 1.45-.003 2.176-.002.22-.064.432-.326.434-.264.002-.327-.209-.33-.43-.005-.347 0-.694 0-1.041 0-.451-.073-.557-.523-.64a7.7 7.7 0 0 0-2.348-.02 2.6 2.6 0 0 0-.8.196c-.212.1-.296.245-.193.467.107.231.206.467.333.688a44 44 0 0 0 3.426 4.956c.154.199.273.203.431.01.349-.426.715-.839 1.06-1.268a34 34 0 0 0 3.577-5.26 14.2 14.2 0 0 0 1.494-3.871 1.203 1.203 0 0 0-1.012-1.635 7 7 0 0 0-1.67-.162c-.909-.006-1.818-.003-2.727-.002-.245 0-.427-.07-.427-.358 0-1.01-.002-2.022.002-3.033 0-.216.104-.349.339-.34" })
), NF = h(Vw), Sw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 9.28a2 2 0 1 0-2-2 2 2 0 0 0 2 2M2.71 13.92a3 3 0 0 1 .57.25 4.06 4.06 0 0 0 4.1 0 2.62 2.62 0 0 1 2.56 0l.21.1a4.14 4.14 0 0 0 3.87-.13 2.62 2.62 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 4 4 0 0 0 2-.56 3 3 0 0 1 .57-.25 1 1 0 1 0-.52-1.89 4.8 4.8 0 0 0-1 .44 2.1 2.1 0 0 1-2.1 0 4.62 4.62 0 0 0-4.54 0 3 3 0 0 1-.29.12L14.34 11a.8.8 0 0 0 .09-.15 1 1 0 0 0 .12-.16 1.3 1.3 0 0 0 0-.19 1 1 0 0 0 0-.19 1 1 0 0 0 0-.18 1 1 0 0 0 0-.19 2 2 0 0 0-.1-.17.7.7 0 0 0-.1-.16l-3.07-3.33a1.1 1.1 0 0 0-.28-.22.8.8 0 0 0-.21 0 .5.5 0 0 0-.17 0A.9.9 0 0 0 10.2 6L6.66 7.32a1 1 0 0 0-.6 1.28 1 1 0 0 0 1.28.6l2.93-1.07 2 2.12-1.9 1.9a4.62 4.62 0 0 0-3.94.28 2.1 2.1 0 0 1-2.1 0 4.8 4.8 0 0 0-1-.44 1 1 0 1 0-.58 1.91Zm18 3.09a4.8 4.8 0 0 0-1 .44 2.1 2.1 0 0 1-2.1 0 4.62 4.62 0 0 0-4.54 0 2.11 2.11 0 0 1-2.12 0 4.62 4.62 0 0 0-4.54 0 2.1 2.1 0 0 1-2.1 0 4.8 4.8 0 0 0-1-.44 1 1 0 1 0-.58 1.91 3 3 0 0 1 .57.25 4.06 4.06 0 0 0 4.1 0 2.62 2.62 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.62 2.62 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 4 4 0 0 0 2-.56 3 3 0 0 1 .57-.25 1 1 0 1 0-.58-1.92Z" })
), QF = h(Sw), Lw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.29 15.71A1 1 0 0 0 13 15a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21 1 1 0 0 0-.33.21A1.05 1.05 0 0 0 11 15a1 1 0 0 0 .29.71m8.62-.2h-4.53a1 1 0 0 0 0 2h2.4A8 8 0 0 1 4 12a1 1 0 0 0-2 0 10 10 0 0 0 16.88 7.23V21a1 1 0 0 0 2 0v-4.5a1 1 0 0 0-.97-.99M12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 0 1 20 12a1 1 0 0 0 2 0A10 10 0 0 0 12 2m0 11a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1" })
), KF = h(Lw), Zw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.88 15.5h-4.5a1 1 0 0 0 0 2h2.4A8 8 0 0 1 12 20a8.1 8.1 0 0 1-3.12-.63l-1.49 1.49A9.8 9.8 0 0 0 12 22a10 10 0 0 0 6.88-2.77V21a1 1 0 0 0 2 0v-4.5a1 1 0 0 0-1-1m-1.57-8.4 1.43-1.43 2-2a1 1 0 1 0-1.42-1.42l-2 2A9.9 9.9 0 0 0 12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4a7.93 7.93 0 0 1 10.67-.81l-11.2 11.2A7.93 7.93 0 0 1 4 12a1 1 0 0 0-2 0 9.9 9.9 0 0 0 2.27 6.32l-2 2a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2-2 1.43-1.43Zm1.06 1.78A8.1 8.1 0 0 1 20 12a1 1 0 0 0 2 0 9.8 9.8 0 0 0-1.14-4.61Z" })
), jF = h(Zw), Bw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19.91 15.51h-4.53a1 1 0 0 0 0 2h2.4A8 8 0 0 1 4 12a1 1 0 0 0-2 0 10 10 0 0 0 16.88 7.23V21a1 1 0 0 0 2 0v-4.5a1 1 0 0 0-.97-.99M12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 0 1 20 12a1 1 0 0 0 2 0A10 10 0 0 0 12 2" })
), JF = h(Bw), Fw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.71 2.29a1 1 0 0 0-1.42 0l-2.12 2.12-.71-.7a1 1 0 0 0-1.41 0l-1.41 1.41-.71-.71a1 1 0 0 0-1.42 0l-7.77 7.78-.74-.7a1 1 0 0 0-1.38 1.41l3.53 3.54-1.73 1.74-.71-.72a1 1 0 0 0-1.42 1.42l2.83 2.83a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-.71-.7 1.74-1.74 3.53 3.53a1 1 0 0 0 .71.3 1 1 0 0 0 .7-1.71l-.7-.71 7.78-7.77a1 1 0 0 0 0-1.42l-.71-.71L20.29 8a1 1 0 0 0 0-1.41l-.7-.71 2.12-2.12a1 1 0 0 0 0-1.47M7.57 15l-1.42-1.39 1.41-1.42L9 13.61Zm2.82 2.83L9 16.44 10.39 15l1.42 1.42ZM13.22 15 9 10.78l4.24-4.24.71.7 3.53 3.54Zm4.24-7-1.41-1.46.71-.71.7.7.7.7Z" })
), YF = h(Fw), Rw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m20.71 16.1-1.64-1.64a.94.94 0 0 1-.22-1.07 5.8 5.8 0 0 0 .54-2.39.4.4 0 0 0 0-.1 5.74 5.74 0 0 0-1.06-3.34 14.2 14.2 0 0 0-5.17-4.42 7 7 0 0 0-8 1.31l-.67.67a7 7 0 0 0-1.31 8.05l.1.17a3 3 0 0 0-.84 2.06A3 3 0 0 0 7 17.94c.18.14.34.29.52.42a5.6 5.6 0 0 0 1.22.64h.09c.18.07.37.13.57.19h.15a5 5 0 0 0 .95.15h.62c.21 0 .41 0 .62-.06h.17a5.5 5.5 0 0 0 1.42-.45 1 1 0 0 1 1.07.21l1.46 1.46a3.4 3.4 0 0 0 2.39 1 2.85 2.85 0 0 0 2-.85l.38-.38a3 3 0 0 0 .08-4.17m-15.3.32a1 1 0 1 1 1-1 1 1 0 0 1-1 1m3.1.14-.26-.2a3 3 0 0 0 .16-.94 3 3 0 0 0-3-3h-.38l-.09-.16a5 5 0 0 1 .93-5.75l.67-.67A5 5 0 0 1 12.28 5a12 12 0 0 1 4.26 3.57Zm10.78 2.37-.37.38c-.42.42-1.07.34-1.61-.2l-1.46-1.45a3 3 0 0 0-3.34-.61 3.4 3.4 0 0 1-1 .31 3 3 0 0 1-.58.05h-.44l6.87-6.87a3.8 3.8 0 0 1-.34 2 3 3 0 0 0 .61 3.34l1.64 1.65a1 1 0 0 1 .02 1.4" })
), XF = h(Rw), Uw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M8 20H4v-4h4Zm0-6H4v-4h4Zm0-6H4V4h4Zm6 12h-4v-4h4Zm0-6h-4v-4h4Zm0-6h-4V4h4Zm6 12h-4v-4h4Zm0-6h-4v-4h4Zm0-6h-4V4h4Z" })
), _F = h(Uw), $w = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-5.29-2.71a1 1 0 0 0-.91-.29l-.18.06a.8.8 0 0 0-.18.09l-.15.12a1 1 0 0 0-.21.33 1 1 0 0 0 .21 1.09 1.5 1.5 0 0 0 .33.22 1 1 0 0 0 1.09-.22A1 1 0 0 0 13 17a.84.84 0 0 0-.08-.38 1.2 1.2 0 0 0-.21-.33" })
), zF = h($w), yw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.54 3.46a5 5 0 1 0 0 7.08 5 5 0 0 0 0-7.08m-5.66 1.42A3 3 0 0 1 17 4a3 3 0 0 1 1.28.3l-4 4a3 3 0 0 1 .6-3.42m4.24 4.24a3 3 0 0 1-3.4.58l4-4a3 3 0 0 1-.6 3.42M8 10a5.93 5.93 0 0 0-4.21 1.73A6 6 0 0 0 8 22a6 6 0 0 0 4.14-1.66l.12-.08a1 1 0 0 1 .07-.11A6 6 0 0 0 8 10m-2.83 8.83A4 4 0 0 1 4.56 14L10 19.44a4 4 0 0 1-4.83-.61m6.27-.83L6 12.56A4 4 0 0 1 8 12a4 4 0 0 1 3.44 6" })
), aR = h(yw), kw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 5a10 10 0 0 0-8.66 15 1 1 0 0 0 1.74-1A7.9 7.9 0 0 1 4 15a8 8 0 1 1 14.93 4 1 1 0 0 0 .37 1.37 1 1 0 0 0 1.36-.37A10 10 0 0 0 12 5m2.84 5.76-1.55 1.54A2.9 2.9 0 0 0 12 12a3 3 0 1 0 3 3 2.9 2.9 0 0 0-.3-1.28l1.55-1.54a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0M12 16a1 1 0 0 1 0-2 1 1 0 0 1 .7.28 1 1 0 0 1 .3.72 1 1 0 0 1-1 1" })
), tR = h(kw), bw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m15.29 10.29-2.78 2.78A2 2 0 0 0 12 13a2 2 0 0 0-2 2 2 2 0 0 0 .07.51l-.78.78a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l.78-.78A2 2 0 0 0 12 17a2 2 0 0 0 2-2 2 2 0 0 0-.07-.51l2.78-2.78a1 1 0 0 0-1.42-1.42M12 4A10 10 0 0 0 2 14a9.9 9.9 0 0 0 1.69 5.56 1 1 0 0 0 1.66-1.12 8 8 0 1 1 13.3 0 1 1 0 0 0 .27 1.39 1 1 0 0 0 .56.17 1 1 0 0 0 .83-.44A9.9 9.9 0 0 0 22 14 10 10 0 0 0 12 4" })
), eR = h(bw), Tw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M7.5 6A1.5 1.5 0 1 0 9 7.5 1.5 1.5 0 0 0 7.5 6m13.62 4.71-8.41-8.42A1 1 0 0 0 12 2H3a1 1 0 0 0-1 1v9a1 1 0 0 0 .29.71l8.42 8.41a3 3 0 0 0 4.24 0L21.12 15a3 3 0 0 0 0-4.24Zm-1.41 2.82-6.18 6.17a1 1 0 0 1-1.41 0L4 11.59V4h7.59l8.12 8.12a1 1 0 0 1 .29.71 1 1 0 0 1-.29.7" })
), lR = h(Tw), Pw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.12 10.71-8.41-8.42A1 1 0 0 0 12 2H3a1 1 0 0 0-1 1v9a1 1 0 0 0 .29.71l8.42 8.41a3 3 0 0 0 4.24 0L21.12 15a3 3 0 0 0 0-4.24Zm-1.41 2.82-6.18 6.17a1 1 0 0 1-1.41 0L4 11.59V4h7.59l8.12 8.12a1 1 0 0 1 .29.71 1 1 0 0 1-.29.7" })
), rR = h(Pw), Dw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.5 7a4 4 0 1 0 4 4 4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2m1-10h-2a7 7 0 0 0-7 7v3h-1a1 1 0 0 0 0 2h1v2h-4a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-1h12a7 7 0 0 0 7-7v-2a7 7 0 0 0-7-7m5 9a5 5 0 0 1-5 5h-7v-7a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5Z" })
), hR = h(Dw), qw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17.38 14.58a1 1 0 0 0-.58-.06.6.6 0 0 0-.18.06.8.8 0 0 0-.18.09l-.15.12a1.05 1.05 0 0 0-.29.71 1 1 0 0 0 .29.71 1.2 1.2 0 0 0 .33.22 1 1 0 0 0 1.09-.22 1.2 1.2 0 0 0 .21-.33.84.84 0 0 0 .08-.38 1.05 1.05 0 0 0-.29-.71.9.9 0 0 0-.33-.21m2.62-3.9V7.5a3 3 0 0 0-3-3h-.78l-.77-2.32a1 1 0 0 0-.95-.68h-5a1 1 0 0 0-.95.68L7.78 4.5H7a3 3 0 0 0-3 3v3.18a3 3 0 0 0-2 2.82v6a1 1 0 0 0 1 1h1v1a1 1 0 0 0 2 0v-1h12v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 1-1v-6a3 3 0 0 0-2-2.82M10.22 3.5h3.56l.33 1H9.89ZM6 7.5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3H6Zm14 11H4v-5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM6.62 14.58a1 1 0 0 0-.33.21 1.05 1.05 0 0 0-.29.71 1 1 0 0 0 1.38.93 1.2 1.2 0 0 0 .33-.22A1 1 0 0 0 8 15.5a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21M13 14.5h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2" })
), oR = h(qw), Iw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.56 2.17a1 1 0 0 0-1.12 0c-.3.2-7.19 5-7.19 12.08a7.75 7.75 0 0 0 15.5 0c0-7.2-6.9-11.89-7.19-12.08M12 20a5.76 5.76 0 0 1-5.75-5.75c0-5 4.21-8.77 5.75-10 1.55 1.21 5.75 5 5.75 10A5.76 5.76 0 0 1 12 20" })
), nR = h(Iw), Ww = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.265 2.428a2.05 2.05 0 0 0-2.078-.324L2.266 9.339a2.043 2.043 0 0 0 .104 3.818l3.625 1.261 2.02 6.682a1 1 0 0 0 .119.252c.008.012.019.02.027.033a1 1 0 0 0 .211.215l.07.05a1 1 0 0 0 .31.136l.013.001.006.003a1 1 0 0 0 .203.02l.018-.003a1 1 0 0 0 .301-.052q.033-.014.064-.03a1 1 0 0 0 .205-.114l.152-.129 2.702-2.983 4.03 3.122a2.02 2.02 0 0 0 1.241.427 2.054 2.054 0 0 0 2.008-1.633l3.263-16.017a2.03 2.03 0 0 0-.693-1.97M9.37 14.736a1 1 0 0 0-.272.506l-.31 1.504-.784-2.593 4.065-2.117Zm8.302 5.304-4.763-3.69a1 1 0 0 0-1.353.12l-.866.955.306-1.487 7.083-7.083a1 1 0 0 0-1.169-1.593L6.745 12.554 3.02 11.191 20.999 4Z" })
), wR = h(Ww), Gw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.994 2a10 10 0 1 0 10 10 10 10 0 0 0-10-10m3.18 15.152a.705.705 0 0 1-1.002.352l-2.715-2.11-1.742 1.608a.3.3 0 0 1-.285.039l.334-2.989.01.009.007-.059s4.885-4.448 5.084-4.637c.202-.189.135-.23.135-.23.012-.23-.361 0-.361 0l-6.473 4.164-2.695-.918s-.414-.148-.453-.475c-.041-.324.466-.5.466-.5l10.717-4.258s.881-.392.881.258Z" })
), vR = h(Gw), Ow = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.9 7.59-1-3.87a3 3 0 0 0-3.71-2.12l-1.93.52a1 1 0 0 0-.71 1.23l.26 1L4.19 7.16a1 1 0 0 0-.71 1.22l.26 1-1 .26a1 1 0 0 0 .25 2 1 1 0 0 0 .26 0l1-.27.26 1a1 1 0 0 0 .46.6 1 1 0 0 0 .5.14.8.8 0 0 0 .26 0L9 12.08v.42a2.9 2.9 0 0 0 .3 1.28l-5 5a1 1 0 0 0 1.41 1.42l5-5 .28.11v6.19a1 1 0 0 0 2 0v-6.18a3 3 0 0 0 .29-.12l5 5a1 1 0 1 0 1.41-1.42l-5-5A3.1 3.1 0 0 0 15 12.5v-2l1.35-.36.25 1a1 1 0 0 0 1 .74h.26l1.93-.52a3 3 0 0 0 2.11-3.77M13 12.5a1 1 0 0 1-.28.69 1 1 0 0 1-.69.28 1 1 0 0 1-.7-.29 1 1 0 0 1-.29-.7v-1L13 11Zm-6.81-1.74-.52-1.93 9.66-2.59.26 1 .26 1Zm13.68-1.9a1 1 0 0 1-.61.47l-1 .26-.78-2.9L17 4.76l-.26-1 1-.26a1 1 0 0 1 1.23.71l1 3.87a1 1 0 0 1-.1.78" })
), mR = h(Ow), Nw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 15a2 2 0 1 0 2 2 2 2 0 0 0-2-2m4.5-2V5.5a4.5 4.5 0 0 0-9 0V13a6 6 0 0 0 3.21 9.83A7 7 0 0 0 12 23a6 6 0 0 0 4.5-10m-2 7.07a4 4 0 0 1-5.32-6 1 1 0 0 0 .3-.71V5.5a2.5 2.5 0 0 1 5 0v7.94a1 1 0 0 0 .3.71 4 4 0 0 1-.28 6Z" })
), cR = h(Nw), Qw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 15.28V10.5a1 1 0 0 0-2 0v4.78A2 2 0 0 0 10 17a2 2 0 0 0 4 0 2 2 0 0 0-1-1.72M16.5 13V5.5a4.5 4.5 0 0 0-9 0V13a6 6 0 0 0 3.21 9.83A7 7 0 0 0 12 23a6 6 0 0 0 4.5-10m-2 7.07a4 4 0 0 1-5.32-6 1 1 0 0 0 .3-.71V5.5a2.5 2.5 0 0 1 5 0v7.94a1 1 0 0 0 .3.71 4 4 0 0 1-.28 6Z" })
), sR = h(Qw), Kw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14 5.5a4.5 4.5 0 0 0-9 0V13a6 6 0 0 0 3.21 9.83 7 7 0 0 0 1.28.17A6 6 0 0 0 14 13Zm-2 14.61a4 4 0 0 1-5.32-6 1 1 0 0 0 .3-.71V5.5a2.5 2.5 0 0 1 5 0v7.94a1 1 0 0 0 .3.71 4 4 0 0 1-.28 6Zm-1.5-4.83V5.5a1 1 0 0 0-2 0v9.78a2 2 0 0 0-1 1.72 2 2 0 0 0 4 0 2 2 0 0 0-1-1.72m9-12.78h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2" })
), gR = h(Kw), jw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.5 15.28V5.5a1 1 0 0 0-2 0v9.78a2 2 0 0 0-1 1.72 2 2 0 0 0 4 0 2 2 0 0 0-1-1.72m9-12.78H19V2a1 1 0 0 0-2 0v.5h-.5a1 1 0 0 0 0 2h.5V5a1 1 0 0 0 2 0v-.5h.5a1 1 0 0 0 0-2m-5.5 3a4.5 4.5 0 0 0-9 0V13a6 6 0 0 0 3.21 9.83 7 7 0 0 0 1.28.17A6 6 0 0 0 14 13Zm-2 14.61a4 4 0 0 1-6.42-2.2 4 4 0 0 1 1.1-3.76 1 1 0 0 0 .3-.71V5.5a2.5 2.5 0 0 1 5 0v7.94a1 1 0 0 0 .3.71 4 4 0 0 1-.28 6Z" })
), iR = h(jw), Jw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.5 13V5.5a4.5 4.5 0 0 0-9 0V13a6 6 0 0 0 3.21 9.83A7 7 0 0 0 12 23a6 6 0 0 0 4.5-10m-2 7.07a4 4 0 0 1-5.32-6 1 1 0 0 0 .3-.71V5.5a2.5 2.5 0 0 1 5 0v7.94a1 1 0 0 0 .3.71 4 4 0 0 1-.28 6ZM13 15.28V12.5a1 1 0 0 0-2 0v2.78A2 2 0 0 0 10 17a2 2 0 0 0 4 0 2 2 0 0 0-1-1.72" })
), dR = h(Jw), Yw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 15.28V8.5a1 1 0 0 0-2 0v6.78A2 2 0 0 0 10 17a2 2 0 0 0 4 0 2 2 0 0 0-1-1.72M16.5 13V5.5a4.5 4.5 0 0 0-9 0V13a6 6 0 0 0 3.21 9.83A7 7 0 0 0 12 23a6 6 0 0 0 4.5-10m-2 7.07a4 4 0 0 1-5.32-6 1 1 0 0 0 .3-.71V5.5a2.5 2.5 0 0 1 5 0v7.94a1 1 0 0 0 .3.71 4 4 0 0 1-.28 6Z" })
), pR = h(Yw), Xw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13 15.28V5.5a1 1 0 0 0-2 0v9.78A2 2 0 0 0 10 17a2 2 0 0 0 4 0 2 2 0 0 0-1-1.72M16.5 13V5.5a4.5 4.5 0 0 0-9 0V13a6 6 0 0 0 3.21 9.83A7 7 0 0 0 12 23a6 6 0 0 0 4.5-10m-2 7.07a4 4 0 0 1-6.42-2.2 4 4 0 0 1 1.1-3.76 1 1 0 0 0 .3-.71V5.5a2.5 2.5 0 0 1 5 0v7.94a1 1 0 0 0 .3.71 4 4 0 0 1-.28 6Z" })
), fR = h(Xw), _w = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 0 0-7.35 16.76l.09.1a10 10 0 0 0 14.52 0l.09-.1A10 10 0 0 0 12 2M5.61 16.79a7.93 7.93 0 0 1 0-9.58 6 6 0 0 1 0 9.58M12 20a7.9 7.9 0 0 1-5-1.77A8 8 0 0 0 7 5.77a7.95 7.95 0 0 1 10 0 8 8 0 0 0 0 12.46A7.9 7.9 0 0 1 12 20m6.39-3.21a6 6 0 0 1 0-9.58 7.93 7.93 0 0 1 0 9.58" })
), ER = h(_w), zw = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 6a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h5v11a1 1 0 0 0 2 0V7h5a1 1 0 0 0 1-1m5 5h-6a1 1 0 0 0 0 2h2v5a1 1 0 0 0 2 0v-5h2a1 1 0 0 0 0-2" })
), xR = h(zw), av = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 11H3a1 1 0 0 0 0 2h2v5a1 1 0 0 0 2 0v-5h2a1 1 0 0 0 0-2m12-6H9a1 1 0 0 0 0 2h5v11a1 1 0 0 0 2 0V7h5a1 1 0 0 0 0-2" })
), AR = h(av), tv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15 13H9a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2m2-7H7a1 1 0 0 0 0 2h4v2a1 1 0 0 0 2 0V8h4a1 1 0 0 0 0-2" })
), MR = h(tv), ev = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 6H7a1 1 0 0 0 0 2h4v9a1 1 0 0 0 2 0V8h4a1 1 0 0 0 0-2" })
), HR = h(ev), lv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m-9 16H5v-6h6Zm0-8H5V5h6Zm8 8h-6v-6h6Zm0-8h-6V5h6Z" })
), CR = h(lv), rv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m22.71 21.29-1-1-6-6-6-6-6-6-1-1a1 1 0 0 0-1.42 1.42l.71.7V21a1 1 0 0 0 1 1h17.59l.7.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M4 5.41 6.59 8H4ZM8 20H4v-4h4Zm0-6H4v-4h4Zm2-2.59L12.59 14H10ZM14 20h-4v-4h4Zm2 0v-2.59L18.59 20ZM8.67 4H14v5a1 1 0 0 0 1 1h5v5.33a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1H8.67a1 1 0 0 0 0 2M16 4h4v4h-4Z" })
), uR = h(rv), hv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M11 20H4v-7h7Zm0-9H4V4h7Zm9 9h-7v-7h7Zm0-9h-7V4h7Z" })
), VR = h(hv), ov = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m16.29 6.29-7 7a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l7-7a1 1 0 1 0-1.42-1.42m4.25-2.83a5 5 0 0 0-7.08 0l-8.17 8.23a1 1 0 0 0-.29.7v5.19l-2.71 2.71a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L6.42 19h5.19a1 1 0 0 0 .7-.29l8.23-8.17a5 5 0 0 0 0-7.08m-1.42 5.66L11.2 17H7v-4.2l7.88-7.92a3 3 0 0 1 4.24 4.24" })
), SR = h(ov), nv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2H6.27a3 3 0 0 0-2.95 2.46l-1.27 7A3 3 0 0 0 5 15h4.56L9 16.43A4.13 4.13 0 0 0 12.89 22a1 1 0 0 0 .91-.59L16.65 15H19a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-4 11.79-2.72 6.12a2.13 2.13 0 0 1-1.38-2.78l.53-1.43A2 2 0 0 0 9.56 13H5a1 1 0 0 1-.77-.36 1 1 0 0 1-.23-.82l1.27-7a1 1 0 0 1 1-.82H15ZM20 12a1 1 0 0 1-1 1h-2V4h2a1 1 0 0 1 1 1Z" })
), LR = h(nv), wv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.3 10.08A3 3 0 0 0 19 9h-4.56L15 7.57A4.13 4.13 0 0 0 11.11 2a1 1 0 0 0-.91.59L7.35 9H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12.73a3 3 0 0 0 2.95-2.46l1.27-7a3 3 0 0 0-.65-2.46M7 20H5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2Zm13-7.82-1.27 7a1 1 0 0 1-1 .82H9v-9.79l2.72-6.12a2.11 2.11 0 0 1 1.38 2.78l-.53 1.43a2 2 0 0 0 1.87 2.7H19a1 1 0 0 1 .77.36 1 1 0 0 1 .23.82" })
), ZR = h(wv), vv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.58 16.5h-1.26l.86-1.5a1 1 0 1 0-1.73-1l-1.73 3a1 1 0 0 0 .86 1.5h1.27L9 20a1 1 0 0 0 1.74 1l1.73-3a1 1 0 0 0 0-1 1 1 0 0 0-.89-.5M21.7 7.57a1 1 0 0 0-.93-.26 3.2 3.2 0 0 1-.66.08 3 3 0 0 1-3-3 3 3 0 0 1 .08-.65A1 1 0 0 0 16 2.53a4.93 4.93 0 0 0-3.83 4.21 6.2 6.2 0 0 0-1.67-.24 6 6 0 0 0-5.94 5.13 3.49 3.49 0 0 0-.34 6.62 1 1 0 1 0 .72-1.86 1.5 1.5 0 0 1 .56-2.89 1 1 0 0 0 1-1 4 4 0 0 1 4-4 3.9 3.9 0 0 1 2.18.66 4 4 0 0 1 1.57 2 1 1 0 0 0 .78.67 2.33 2.33 0 0 1 .25 4.53 1 1 0 0 0 .27 2 .8.8 0 0 0 .27 0A4.33 4.33 0 0 0 19 14.17a4.2 4.2 0 0 0-.49-2A4.94 4.94 0 0 0 22 8.5a1 1 0 0 0-.3-.93m-4.59 2.82a2.6 2.6 0 0 1-.42 0A4.6 4.6 0 0 0 16 10a6 6 0 0 0-1.82-2.28v-.37a3 3 0 0 1 1.05-2.28 5 5 0 0 0 4.23 4.23 3 3 0 0 1-2.35 1.09" })
), BR = h(vv), mv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.58 16.5h-1.26l.86-1.5a1 1 0 1 0-1.73-1l-1.73 3a1 1 0 0 0 .86 1.5h1.27L9 20a1 1 0 0 0 1.74 1l1.73-3a1 1 0 0 0 0-1 1 1 0 0 0-.89-.5m9.42-9h-.8a4.3 4.3 0 0 0-.52-1.27l.56-.56a1 1 0 0 0-1.41-1.41l-.56.56A4.3 4.3 0 0 0 17 4.3v-.8a1 1 0 0 0-2 0v.8a4.3 4.3 0 0 0-1.27.52l-.56-.56a1 1 0 0 0-1.41 1.41l.56.57c-.09.15-.16.32-.24.48a5.9 5.9 0 0 0-1.58-.22 6 6 0 0 0-5.94 5.13 3.49 3.49 0 0 0-.34 6.62 1 1 0 1 0 .72-1.86 1.5 1.5 0 0 1 .56-2.89 1 1 0 0 0 1-1 4 4 0 0 1 7.78-1.29 1 1 0 0 0 .78.67 2.33 2.33 0 0 1 .25 4.53 1 1 0 0 0 .27 2 .8.8 0 0 0 .27 0 4.3 4.3 0 0 0 2.85-5.72l.13.13a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41l-.56-.56a4.3 4.3 0 0 0 .52-1.35h.8a1 1 0 0 0 0-2m-3.34 2.65a2.3 2.3 0 0 1-.6.41A4.2 4.2 0 0 0 16 10a6.1 6.1 0 0 0-2.09-2.49 2.4 2.4 0 0 1 .46-.7 2.43 2.43 0 0 1 3.3 0 2.37 2.37 0 0 1 0 3.3Z" })
), FR = h(mv), cv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.5 15h-2.27l1.45-2.5a1 1 0 1 0-1.74-1l-2.31 4a1 1 0 0 0 0 1 1 1 0 0 0 .87.5h2.27l-1.45 2.5a1 1 0 0 0 1.74 1l2.31-4a1 1 0 0 0 0-1 1 1 0 0 0-.87-.5m4.92-7.79a7 7 0 0 0-13.36 1.9A4 4 0 0 0 6 17a1 1 0 0 0 0-2 2 2 0 0 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.66A3 3 0 0 1 17 15a1 1 0 0 0 0 2 5 5 0 0 0 1.42-9.79" })
), RR = h(cv), sv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9 10a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m12 1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1 1 1 0 0 1 0 2 1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1 1 1 0 0 1 0-2m-1-1.82a3 3 0 0 0 0 5.64V17H10a1 1 0 0 0-2 0H4v-2.18a3 3 0 0 0 0-5.64V7h4a1 1 0 0 0 2 0h10Z" })
), UR = h(sv), gv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.71 8.29a1 1 0 0 0-1.42 0L12 10.59l-2.29-2.3a1 1 0 0 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 12l2.3-2.29a1 1 0 0 0 0-1.42m3.36-3.36A10 10 0 1 0 4.93 19.07 10 10 0 1 0 19.07 4.93m-1.41 12.73A8 8 0 1 1 20 12a7.95 7.95 0 0 1-2.34 5.66" })
), $R = h(gv), iv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.71 8.29a1 1 0 0 0-1.42 0L12 10.59l-2.29-2.3a1 1 0 0 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 12l2.3-2.29a1 1 0 0 0 0-1.42M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), yR = h(iv), dv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m13.41 12 4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), kR = h(dv), pv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 8.5a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 8 8.5m0 5A1.5 1.5 0 1 1 9.5 12 1.5 1.5 0 0 1 8 13.5M16 5H8a7 7 0 0 0 0 14h8a7 7 0 0 0 0-14m0 12H8A5 5 0 0 1 8 7h8a5 5 0 0 1 0 10" })
), bR = h(pv), fv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 8.5a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 16 8.5m0 5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5M16 5H8a7 7 0 0 0 0 14h8a7 7 0 0 0 0-14m0 12H8A5 5 0 0 1 8 7h8a5 5 0 0 1 0 10" })
), TR = h(fv), Ev = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.26 20.357a7.52 7.52 0 0 1-1.76-4.905v-7.46c0-3.308-2.243-6-5-6h-9c-2.757 0-5 2.692-5 6s2.243 6 5 6h3v1.46a9.53 9.53 0 0 0 2.24 6.206 1 1 0 0 0 .76.35h9a1 1 0 0 0 .76-1.651M6.5 11.993c-1.654 0-3-1.795-3-4s1.346-4 3-4 3 1.794 3 4-1.346 4-3 4m6.479 8.014a7.58 7.58 0 0 1-1.479-4.555v-7c0-.028-.014-.052-.016-.08.007-.126.016-.251.016-.38a6.68 6.68 0 0 0-1.284-4H15.5c1.654 0 3 1.795 3 4v7.46a9.7 9.7 0 0 0 1.118 4.555ZM6.5 6.743a1.146 1.146 0 0 0-1 1.25 1.146 1.146 0 0 0 1 1.25 1.146 1.146 0 0 0 1-1.25 1.146 1.146 0 0 0-1-1.25" })
), PR = h(Ev), xv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 20H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2M8.71 7.71 11 5.41V17a1 1 0 0 0 2 0V5.41l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-4-4a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-4 4a1 1 0 1 0 1.42 1.42" })
), DR = h(xv), Av = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.71 6.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-4 4a1 1 0 1 0 1.42 1.42L11 9.41V21a1 1 0 0 0 2 0V9.41l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM19 2H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" })
), qR = h(Av), Mv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 21H8a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m1-4H6a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2m7-15a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h14a1 1 0 0 0 1-1m3 3H6a1 1 0 0 0 0 2h15a1 1 0 0 0 0-2m-2 4h-9a1 1 0 0 0 0 2h9a1 1 0 0 0 0-2m-5 4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2" })
), IR = h(Mv), Hv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 9H7a1 1 0 0 0 0 2h.5v3a1 1 0 0 0 2 0v-3h.5a1 1 0 0 0 0-2m7.38.08a1 1 0 0 0-1.09.21L15 10.59l-1.29-1.3a1 1 0 0 0-1.09-.21A1 1 0 0 0 12 10v4a1 1 0 0 0 2 0v-1.59l.29.3a1 1 0 0 0 1.42 0l.29-.3V14a1 1 0 0 0 2 0v-4a1 1 0 0 0-.62-.92M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), WR = h(Hv), Cv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.5 7h-6a1 1 0 0 0 0 2h2v7a1 1 0 0 0 2 0V9h2a1 1 0 0 0 0-2m11.92.62a1 1 0 0 0-.54-.54 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21L17 10.09l-2.79-2.8a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.54.54 1 1 0 0 0-.08.38v8a1 1 0 0 0 2 0v-5.59l1.79 1.8a1 1 0 0 0 1.42 0l1.79-1.8V16a1 1 0 0 0 2 0V8a1 1 0 0 0-.08-.38" })
), GR = h(Cv), uv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 5h-1V4a1 1 0 0 0-2 0v1H6V4a1 1 0 0 0-2 0v1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1v7a1 1 0 0 0 2 0v-7h12v7a1 1 0 0 0 2 0v-7h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1M4 9.52V7h2.52ZM5.34 11l4-4h3.33l-4 4Zm6.15 0 4-4h3.18l-4 4ZM20 11h-2.51L20 8.49Z" })
), OR = h(uv), Vv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 5.5A1.5 1.5 0 1 0 13.5 7 1.5 1.5 0 0 0 12 5.5m10 3h-.54a6 6 0 0 0 1.54-4 1 1 0 0 0-1-1h-4.18a3 3 0 0 0-2.82-2H9a3 3 0 0 0-2.82 2H2a1 1 0 0 0-1 1 6 6 0 0 0 1.54 4H2a1 1 0 0 0-1 1 6 6 0 0 0 1.54 4H2a1 1 0 0 0-1 1 6 6 0 0 0 5.16 5.93A3 3 0 0 0 9 22.5h6a3 3 0 0 0 2.84-2.07A6 6 0 0 0 23 14.5a1 1 0 0 0-1-1h-.54a6 6 0 0 0 1.54-4 1 1 0 0 0-1-1M6 18.37a4 4 0 0 1-2.87-2.87H6Zm0-5a4 4 0 0 1-2.87-2.87H6Zm0-5a4.1 4.1 0 0 1-1.83-1 4.1 4.1 0 0 1-1-1.83H6ZM16 19.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Zm3.83-2.17a4.1 4.1 0 0 1-1.83 1V15.5h2.87a4.1 4.1 0 0 1-1.04 1.83m0-5a4.1 4.1 0 0 1-1.83 1V10.5h2.87a4.1 4.1 0 0 1-1.04 1.83m0-5a4.1 4.1 0 0 1-1.83 1V5.5h2.87a4.1 4.1 0 0 1-1.04 1.83M12 15.5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5m0-5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5" })
), NR = h(Vv), Sv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 2H10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.5-4a1.5 1.5 0 0 0-1 .39 1.5 1.5 0 1 0 0 2.22 1.5 1.5 0 1 0 1-2.61M16 17a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2H3v-1a1 1 0 0 1 1-1 1 1 0 0 0 0-2 3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1M6 18h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2" })
), QR = h(Sv), Lv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 18a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1M20 6h-4V5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H4a1 1 0 0 0 0 2h1v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8h1a1 1 0 0 0 0-2M10 5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm7 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8h10Zm-3-1a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1" })
), KR = h(Lv), Zv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 6h-4V5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H4a1 1 0 0 0 0 2h1v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8h1a1 1 0 0 0 0-2M10 5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4Zm7 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8h10Z" })
), jR = h(Zv), Bv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.5 5a4.86 4.86 0 0 0-2.5.69A6 6 0 0 0 2.5 8v4a6 6 0 0 0 5 5.91V21a1 1 0 0 0 2 0v-3.09a6.1 6.1 0 0 0 2.78-1.26 5 5 0 0 0 3.22 2.25V21a1 1 0 0 0 2 0v-2.1a5 5 0 0 0 4-4.9v-4a5 5 0 0 0-5-5m-5 5v4a5 5 0 0 0 .06.57 4 4 0 0 1-2.06 1.3V13a1 1 0 0 0-2 0v2.86a4 4 0 0 1-3-3.86V8a4 4 0 0 1 6.83-2.84 3.94 3.94 0 0 1 1.06 2A5 5 0 0 0 11.5 10m8 4a3 3 0 0 1-2 2.82V13a1 1 0 0 0-2 0v3.82a3 3 0 0 1-2-2.82v-4a3 3 0 0 1 6 0Z" })
), JR = h(Bv), Fv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.87 19.29-9-15.58a1 1 0 0 0-1.74 0l-9 15.58a1 1 0 0 0 0 1 1 1 0 0 0 .87.5h18a1 1 0 0 0 .87-.5 1 1 0 0 0 0-1m-17.14-.5L12 6.21l7.27 12.58Z" })
), YR = h(Fv), Rv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 4h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v3a4 4 0 0 0 4 4h1.54A6 6 0 0 0 11 13.91V16h-1a3 3 0 0 0-3 3v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a3 3 0 0 0-3-3h-1v-2.09A6 6 0 0 0 16.46 12H18a4 4 0 0 0 4-4V5a1 1 0 0 0-1-1M6 10a2 2 0 0 1-2-2V6h2v2a6 6 0 0 0 .35 2Zm8 8a1 1 0 0 1 1 1v1H9v-1a1 1 0 0 1 1-1Zm2-10a4 4 0 0 1-8 0V4h8Zm4 0a2 2 0 0 1-2 2h-.35A6 6 0 0 0 18 8V6h2Z" })
), XR = h(Rv), Uv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.12 2.88a3.08 3.08 0 0 0-4.24 0l-2.42 2.41a3 3 0 0 0-.57 3.41l-2.15 2.15-2-2a3 3 0 0 0-5 1.17l-2.66 8a3 3 0 0 0 .72 3.07A3 3 0 0 0 5 22a2.9 2.9 0 0 0 1-.16l8-2.66a3 3 0 0 0 1.17-5l-2-2 2.15-2.15a3 3 0 0 0 3.41-.57l2.41-2.42a3 3 0 0 0-.02-4.16M13.7 15.63a1 1 0 0 1-.4 1.65L5.32 20a1 1 0 0 1-1-.25 1 1 0 0 1-.25-1l2.67-8a1 1 0 0 1 .7-.75 1 1 0 0 1 .23 0 1 1 0 0 1 .7.29l2 2-.87.86a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l.86-.87Zm6-9.92-2.41 2.41a1 1 0 0 1-1.7-.71 1 1 0 0 1 .29-.7l2.41-2.42a1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.42Z" })
), _R = h(Uv), $v = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 16h-2.18a3 3 0 0 0 .18-1v-5a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v5a3 3 0 0 0 .18 1H7a1 1 0 0 1-1-1V5a3 3 0 0 0-3-3H2a1 1 0 0 0 0 2h1a1 1 0 0 1 1 1v10a3 3 0 0 0 2.22 2.88 3 3 0 1 0 5.6.12h3.36a3 3 0 1 0 5.64 0H22a1 1 0 0 0 0-2M9 20a1 1 0 1 1 1-1 1 1 0 0 1-1 1m2-4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1Zm7 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), zR = h($v), yv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M1 12.5v5a1 1 0 0 0 1 1h1a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h1a1 1 0 0 0 1-1v-12a3 3 0 0 0-3-3h-9a3 3 0 0 0-3 3v2H6a3 3 0 0 0-2.4 1.2l-2.4 3.2a.6.6 0 0 0-.07.14l-.06.11a1 1 0 0 0-.07.35m16 6a1 1 0 1 1 1 1 1 1 0 0 1-1-1m-7-13a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v11h-.78a3 3 0 0 0-4.44 0H10Zm-2 6H4l1.2-1.6a1 1 0 0 1 .8-.4h2Zm-3 7a1 1 0 1 1 1 1 1 1 0 0 1-1-1m-2-5h5v2.78a3 3 0 0 0-4.22.22H3Z" })
), aU = h(yv), kv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m17.434 20.508-.962-2.853a1 1 0 0 0-1.38-.583 3.8 3.8 0 0 1-1.208.249.94.94 0 0 1-.66-.165 1.2 1.2 0 0 1-.239-.808V12h3.017a1 1 0 0 0 1-1V7.095a1 1 0 0 0-1-1H13V2a1 1 0 0 0-1-1H9.07a1.15 1.15 0 0 0-1.137 1.04 5.09 5.09 0 0 1-3.28 4.558 1 1 0 0 0-.662.94v3.585a1 1 0 0 0 1 1h1.025v4.535a6.4 6.4 0 0 0 1.886 4.478A6.9 6.9 0 0 0 12.877 23h.163c1.546-.026 3.618-.648 4.273-1.608a1 1 0 0 0 .12-.883m-4.427.49a4.87 4.87 0 0 1-3.702-1.288 4.37 4.37 0 0 1-1.29-3.052v-5.535a1 1 0 0 0-1-1H5.992V8.206A6.95 6.95 0 0 0 9.81 3H11v4.095a1 1 0 0 0 1 1h3.002V10h-3.017a1 1 0 0 0-1 1v5.365a3.08 3.08 0 0 0 .857 2.235 2.77 2.77 0 0 0 2.096.72 6 6 0 0 0 .947-.113l.425 1.26a5.9 5.9 0 0 1-2.303.531" })
), tU = h(kv), bv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M2 2v20h20V2Zm11.57 15.85a3.4 3.4 0 0 1-3.75-3.33v-4.08H8.56V8.83A3.83 3.83 0 0 0 11 5.47a.09.09 0 0 1 .09-.09h1.82v3.17h2.5v1.89h-2.49v3.89a1.11 1.11 0 0 0 1.2 1.23 3 3 0 0 0 1-.22l.6 1.78a3.34 3.34 0 0 1-2.15.73" })
), eU = h(bv), Tv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.79 18a4.7 4.7 0 0 1-1.62.35 1.75 1.75 0 0 1-1.92-2v-6.23h4v-3h-4V2h-2.92a.15.15 0 0 0-.14.15 6.11 6.11 0 0 1-3.94 5.39v2.58h2v6.54c0 2.23 1.65 5.41 6 5.34 1.47 0 3.11-.64 3.47-1.17Z" })
), lU = h(Tv), Pv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11.62 7.92A1 1 0 0 0 12 8h6a1 1 0 0 1 1 1v5.34a1 1 0 1 0 2 0V9a3 3 0 0 0-3-3h-3.59l2.3-2.29a1 1 0 1 0-1.42-1.42l-4 4a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .54.54m10.09 12.37-18-18a1 1 0 0 0-1.42 1.42l2.54 2.53A3 3 0 0 0 3 9v8a3 3 0 0 0 3 3v1a1 1 0 0 0 2 0v-1h8v1a1 1 0 0 0 2 0v-1a3 3 0 0 0 .53-.06l1.76 1.77a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M6 18a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h.59l10 10Z" })
), rU = h(Pv), Dv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 6h-3.59l2.3-2.29a1 1 0 1 0-1.42-1.42L12 5.54l-1.17-2a1 1 0 1 0-1.74 1L10 6H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3v1a1 1 0 0 0 2 0v-1h8v1a1 1 0 0 0 2 0v-1a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3m1 11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Z" })
), hU = h(Dv), qv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.991 3.95a1 1 0 0 0-1.51-.86 7.5 7.5 0 0 1-1.874.794 5.15 5.15 0 0 0-3.374-1.242 5.23 5.23 0 0 0-5.223 5.063 11.03 11.03 0 0 1-6.814-3.924 1.01 1.01 0 0 0-.857-.365 1 1 0 0 0-.785.5 5.28 5.28 0 0 0-.242 4.769l-.002.001a1.04 1.04 0 0 0-.496.89 3 3 0 0 0 .027.439 5.19 5.19 0 0 0 1.568 3.312 1 1 0 0 0-.066.77 5.2 5.2 0 0 0 2.362 2.922 7.47 7.47 0 0 1-3.59.448A1 1 0 0 0 1.45 19.3a12.94 12.94 0 0 0 7.01 2.061 12.79 12.79 0 0 0 12.465-9.363 12.8 12.8 0 0 0 .535-3.646l-.001-.2a5.77 5.77 0 0 0 1.532-4.202m-3.306 3.212a1 1 0 0 0-.234.702c.01.165.009.331.009.488a10.8 10.8 0 0 1-.454 3.08 10.685 10.685 0 0 1-10.546 7.93 11 11 0 0 1-2.55-.301 9.5 9.5 0 0 0 2.942-1.564 1 1 0 0 0-.602-1.786 3.2 3.2 0 0 1-2.214-.935q.224-.042.445-.105a1 1 0 0 0-.08-1.943 3.2 3.2 0 0 1-2.25-1.726 5 5 0 0 0 .545.046 1.02 1.02 0 0 0 .984-.696 1 1 0 0 0-.4-1.137 3.2 3.2 0 0 1-1.425-2.673q0-.1.006-.198a13 13 0 0 0 8.21 3.48 1.02 1.02 0 0 0 .817-.36 1 1 0 0 0 .206-.867 3.2 3.2 0 0 1-.087-.729 3.23 3.23 0 0 1 3.226-3.226 3.18 3.18 0 0 1 2.345 1.02.99.99 0 0 0 .921.298 9 9 0 0 0 1.212-.322 6.7 6.7 0 0 1-1.026 1.524" })
), oU = h(qv), Iv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 5.8a8.5 8.5 0 0 1-2.36.64 4.13 4.13 0 0 0 1.81-2.27 8.2 8.2 0 0 1-2.61 1 4.1 4.1 0 0 0-7 3.74 11.64 11.64 0 0 1-8.45-4.29 4.16 4.16 0 0 0-.55 2.07 4.09 4.09 0 0 0 1.82 3.41 4.05 4.05 0 0 1-1.86-.51v.05a4.1 4.1 0 0 0 3.3 4 4 4 0 0 1-1.1.17 5 5 0 0 1-.77-.07 4.11 4.11 0 0 0 3.83 2.84A8.22 8.22 0 0 1 3 18.34a8 8 0 0 1-1-.06 11.57 11.57 0 0 0 6.29 1.85A11.59 11.59 0 0 0 20 8.45v-.53a8.4 8.4 0 0 0 2-2.12" })
), nU = h(Iv), Wv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11.24a.2.2 0 0 1 0-.08v-.19c0-.23-.06-.46-.1-.69a.8.8 0 0 1 0-.16c-.05-.25-.12-.49-.19-.73a8.91 8.91 0 0 0-5.86-5.87h-.08c-.22-.07-.45-.13-.68-.18h-.18a5 5 0 0 0-.55-.08h-.24V3a1 1 0 0 0-2 0v.06a9 9 0 0 0-1 .18 5 5 0 0 0-.62.16h-.13c-.25.08-.48.17-.72.26a8.93 8.93 0 0 0-5.23 5.62.3.3 0 0 0 0 .08 6 6 0 0 0-.19.72v.16q-.08.36-.12.75s0 .07 0 .11v.9a1 1 0 0 0 1 1h7v6a1 1 0 0 1-2 0 1 1 0 0 0-2 0 3 3 0 0 0 6 0v-6h7a1 1 0 0 0 1-1c-.11-.26-.11-.51-.11-.76M8 11H5.08v-.11c0-.04 0-.28.08-.41s0-.13 0-.19.08-.32.13-.48v-.08A7 7 0 0 1 9.1 5.64 16.1 16.1 0 0 0 8 11m2 0c.19-3.91 1.44-6 2-6s1.79 2.09 2 6Zm6 0a16.1 16.1 0 0 0-1.1-5.36 7 7 0 0 1 3.73 4.12 5 5 0 0 1 .15.53 1 1 0 0 0 0 .15c0 .14.06.29.08.43s0 .07 0 .11Z" })
), wU = h(Wv), Gv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m14.66 13.56-4.19 1.5A1 1 0 0 0 10.8 17a1 1 0 0 0 .34-.06l4.2-1.5a1 1 0 1 0-.68-1.88m-4-3a1 1 0 0 0 0-1.41 3.08 3.08 0 0 0-4.24 0 1 1 0 1 0 1.41 1.41 1 1 0 0 1 1.42 0 1 1 0 0 0 1.41 0m7-1.41a3.08 3.08 0 0 0-4.24 0 1 1 0 0 0 1.41 1.41 1 1 0 0 1 1.42 0 1 1 0 0 0 1.41 0 1 1 0 0 0-.04-1.43ZM12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8" })
), vU = h(Gv), Ov = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 15.5a5 5 0 0 0 5-5v-5a1 1 0 0 0-2 0v5a3 3 0 0 1-6 0v-5a1 1 0 0 0-2 0v5a5 5 0 0 0 5 5m5 2H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2" })
), mU = h(Ov), Nv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 10a1 1 0 0 0 1-1V6a1 1 0 0 0-.684-.948l-9-3a1 1 0 0 0-.632 0l-9 3A1 1 0 0 0 2 6v3a1 1 0 0 0 1 1h1v7.184A2.995 2.995 0 0 0 2 20v2a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a2.995 2.995 0 0 0-2-2.816V10Zm-1 11H4v-1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM6 17v-7h2v7Zm4 0v-7h4v7Zm6 0v-7h2v7ZM4 8V6.72l8-2.666 8 2.667V8Z" })
), cU = h(Nv), Qv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 13a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m5-4H9V7a3 3 0 0 1 5.12-2.13 3.1 3.1 0 0 1 .78 1.38 1 1 0 1 0 1.94-.5 5.1 5.1 0 0 0-1.31-2.29A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3m1 10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z" })
), sU = h(Qv), Kv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 9H9V7a3 3 0 0 1 5.12-2.13 3.1 3.1 0 0 1 .78 1.38 1 1 0 1 0 1.94-.5 5.1 5.1 0 0 0-1.31-2.29A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3m1 10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z" })
), gU = h(Kv), jv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M9.71 6.71 11 5.41V17a1 1 0 0 0 2 0V5.41l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-3-3a1 1 0 0 0-1.42 0l-3 3a1 1 0 0 0 1.42 1.42M18 9h-2a1 1 0 0 0 0 2h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3" })
), iU = h(jv), Jv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.71 7.71 11 5.41V15a1 1 0 0 0 2 0V5.41l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-4-4a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-4 4a1 1 0 1 0 1.42 1.42M21 12a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6a1 1 0 0 0-2 0v6a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1" })
), dU = h(Jv), Yv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 9h4a1 1 0 0 0 0-2h-2V6a1 1 0 0 0-2 0v1a3 3 0 0 0 0 6h2a1 1 0 0 1 0 2H9a1 1 0 0 0 0 2h2v1a1 1 0 0 0 2 0v-1a3 3 0 0 0 0-6h-2a1 1 0 0 1 0-2m1-8a11 11 0 1 0 11 11A11 11 0 0 0 12 1m0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9" })
), pU = h(Yv), Xv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 9h4a1 1 0 0 0 0-2h-2V6a1 1 0 0 0-2 0v1a3 3 0 0 0 0 6h2a1 1 0 0 1 0 2H9a1 1 0 0 0 0 2h2v1a1 1 0 0 0 2 0v-1a3 3 0 0 0 0-6h-2a1 1 0 0 1 0-2m8-7H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), fU = h(Xv), _v = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.64 15.772a3.47 3.47 0 0 0 .86-2.272 3.5 3.5 0 0 0-7 0 3.47 3.47 0 0 0 .86 2.272A4.99 4.99 0 0 0 13 20a1 1 0 0 0 2 0 3 3 0 0 1 6 0 1 1 0 0 0 2 0 4.99 4.99 0 0 0-2.36-4.228M18 15a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 18 15M6.793 7.707l2 2a1 1 0 0 0 1.414-1.414L9.914 8h4.172l-.293.293a1 1 0 1 0 1.414 1.414l2-2a1.004 1.004 0 0 0 0-1.414l-2-2a1 1 0 0 0-1.414 1.414l.293.293H9.914l.293-.293a1 1 0 0 0-1.414-1.414l-2 2a1.004 1.004 0 0 0 0 1.414m1.847 8.065A3.47 3.47 0 0 0 9.5 13.5a3.5 3.5 0 0 0-7 0 3.47 3.47 0 0 0 .86 2.272A4.99 4.99 0 0 0 1 20a1 1 0 0 0 2 0 3 3 0 0 1 6 0 1 1 0 0 0 2 0 4.99 4.99 0 0 0-2.36-4.228M6 15a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 6 15" })
), EU = h(_v), zv = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.3 12.22A4.92 4.92 0 0 0 15 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 2 19.5a1 1 0 0 0 2 0 6 6 0 0 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28M10 11.5a3 3 0 1 1 3-3 3 3 0 0 1-3 3m11.71-2.37a1 1 0 0 0-1.42 0l-2 2-.62-.63a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l1.34 1.34a1 1 0 0 0 1.41 0l2.67-2.67a1 1 0 0 0 .04-1.45" })
), xU = h(zv), am = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 0 0-7.35 16.76 10 10 0 0 0 14.7 0A10 10 0 0 0 12 2m0 18a8 8 0 0 1-5.55-2.25 6 6 0 0 1 11.1 0A8 8 0 0 1 12 20m-2-10a2 2 0 1 1 2 2 2 2 0 0 1-2-2m8.91 6A8 8 0 0 0 15 12.62a4 4 0 1 0-6 0A8 8 0 0 0 5.09 16 7.9 7.9 0 0 1 4 12a8 8 0 0 1 16 0 7.9 7.9 0 0 1-1.09 4" })
), AU = h(am), tm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.55 12.22a4.92 4.92 0 0 0 1.7-3.72 5 5 0 0 0-10 0A4.92 4.92 0 0 0 8 12.22a8 8 0 0 0-4.7 7.28 1 1 0 0 0 2 0 6 6 0 0 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.75-7.28m-3.3-.72a3 3 0 1 1 3-3 3 3 0 0 1-3 3m8.5-5a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1M19 11.79a1.05 1.05 0 0 0-.29.71 1 1 0 0 0 .29.71 1.2 1.2 0 0 0 .33.21.94.94 0 0 0 .76 0 .9.9 0 0 0 .54-.54.84.84 0 0 0 .08-.38 1 1 0 0 0-1.71-.71" })
), MU = h(tm), em = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.49 10.86a3.09 3.09 0 1 0-5 0 4.7 4.7 0 0 0-1.12 1A1 1 0 1 0 10 13.12a2.62 2.62 0 0 1 2.05-1 2.62 2.62 0 0 1 2.05 1 1 1 0 0 0 .78.37 1 1 0 0 0 .78-1.62 4.7 4.7 0 0 0-1.17-1.01M12 10.13A1.09 1.09 0 1 1 13.09 9 1.09 1.09 0 0 1 12 10.13m8.46-.5A8.5 8.5 0 0 0 7.3 3.36a8.56 8.56 0 0 0-3.76 6.27A8.46 8.46 0 0 0 6 16.46l5.3 5.31a1 1 0 0 0 1.42 0L18 16.46a8.46 8.46 0 0 0 2.46-6.83m-3.86 5.42-4.6 4.6-4.6-4.6a6.49 6.49 0 0 1-1.87-5.22A6.57 6.57 0 0 1 8.42 5a6.47 6.47 0 0 1 7.16 0 6.57 6.57 0 0 1 2.89 4.81 6.49 6.49 0 0 1-1.87 5.24" })
), HU = h(em), lm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m15.899 13.229-.005-.002c-.063-.027-.124-.058-.188-.083A5.99 5.99 0 0 0 18 8.434a5 5 0 0 0-.045-.63 1 1 0 0 0 .038-.122l.281-2.397a3.006 3.006 0 0 0-2.442-3.302l-.79-.143a16.9 16.9 0 0 0-6.083 0l-.791.143a3.006 3.006 0 0 0-2.442 3.302l.28 2.397a1 1 0 0 0 .039.122 5 5 0 0 0-.045.63 5.99 5.99 0 0 0 2.294 4.71c-.064.025-.125.056-.188.083l-.005.002a9.95 9.95 0 0 0-6.035 8.097 1 1 0 0 0 1.988.217 7.95 7.95 0 0 1 4.216-6.185l3.023 3.023a1 1 0 0 0 1.414 0l3.023-3.023a7.95 7.95 0 0 1 4.216 6.185 1 1 0 0 0 .992.892 1 1 0 0 0 .11-.006 1 1 0 0 0 .886-1.103 9.95 9.95 0 0 0-6.036-8.097ZM7.712 5.051a1 1 0 0 1 .814-1.1l.79-.143a14.9 14.9 0 0 1 5.368 0l.79.143a1 1 0 0 1 .814 1.1l-.178 1.514H7.89ZM12 16.261l-1.65-1.651a7.85 7.85 0 0 1 3.3 0Zm0-3.826a4.005 4.005 0 0 1-3.998-3.87h7.996A4.005 4.005 0 0 1 12 12.435" })
), CU = h(lm), rm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 10.5h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-7.7 1.72A4.92 4.92 0 0 0 15 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 2 19.5a1 1 0 0 0 2 0 6 6 0 0 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28M10 11.5a3 3 0 1 1 3-3 3 3 0 0 1-3 3" })
), uU = h(rm), hm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.174 12.916q-.026-.013-.053-.024c-.138-.062-.274-.127-.415-.183a6 6 0 1 0-7.412 0c-.14.056-.277.121-.415.183l-.054.024a9.95 9.95 0 0 0-5.76 7.976 1 1 0 1 0 1.99.216A7.95 7.95 0 0 1 8.04 15.05l3.252 3.251a1 1 0 0 0 1.414 0l3.252-3.251a7.95 7.95 0 0 1 3.987 6.058 1 1 0 0 0 .992.892 1 1 0 0 0 .11-.006 1 1 0 0 0 .886-1.102 9.95 9.95 0 0 0-5.76-7.976ZM8.041 7.594a3.977 3.977 0 0 1 7.918 0ZM12 16.18l-1.937-1.937a7.83 7.83 0 0 1 3.874 0ZM12 12a4 4 0 0 1-3.664-2.406h7.328A4 4 0 0 1 12 12" })
), VU = h(hm), om = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 10.5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m-7.7 1.72A4.92 4.92 0 0 0 15 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 2 19.5a1 1 0 0 0 2 0 6 6 0 0 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28M10 11.5a3 3 0 1 1 3-3 3 3 0 0 1-3 3" })
), SU = h(om), nm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.81 12.28a3.73 3.73 0 0 0 1-2.5 3.78 3.78 0 0 0-7.56 0 3.73 3.73 0 0 0 1 2.5A5.94 5.94 0 0 0 6 16.89a1 1 0 0 0 2 .22 4 4 0 0 1 7.94 0A1 1 0 0 0 17 18h.11a1 1 0 0 0 .88-1.1 5.94 5.94 0 0 0-3.18-4.62M12 11.56a1.78 1.78 0 1 1 1.78-1.78A1.78 1.78 0 0 1 12 11.56M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" })
), LU = h(nm), wm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M13.3 12.22A4.92 4.92 0 0 0 15 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 2 19.5a1 1 0 0 0 2 0 6 6 0 0 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28M10 11.5a3 3 0 1 1 3-3 3 3 0 0 1-3 3m10.91.5.8-.79a1 1 0 0 0-1.42-1.42l-.79.8-.79-.8a1 1 0 0 0-1.42 1.42l.8.79-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l.79-.8.79.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), ZU = h(wm), vm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.71 12.71a6 6 0 1 0-7.42 0 10 10 0 0 0-6.22 8.18 1 1 0 0 0 2 .22 8 8 0 0 1 15.9 0 1 1 0 0 0 1 .89h.11a1 1 0 0 0 .88-1.1 10 10 0 0 0-6.25-8.19M12 12a4 4 0 1 1 4-4 4 4 0 0 1-4 4" })
), BU = h(vm), mm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.3 12.22A4.92 4.92 0 0 0 14 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 1 19.5a1 1 0 0 0 2 0 6 6 0 0 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28M9 11.5a3 3 0 1 1 3-3 3 3 0 0 1-3 3m9.74.32A5 5 0 0 0 15 3.5a1 1 0 0 0 0 2 3 3 0 0 1 3 3 3 3 0 0 1-1.5 2.59 1 1 0 0 0-.5.84 1 1 0 0 0 .45.86l.39.26.13.07a7 7 0 0 1 4 6.38 1 1 0 0 0 2 0 9 9 0 0 0-4.23-7.68" })
), FU = h(mm), cm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.53 14.13a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.41l6.18 6.18a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41Zm1.23-2.49a3 3 0 0 0 2.12-.88l2.83-2.83a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0l-2.83 2.83a1 1 0 0 1-1.41 0l3.54-3.54a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0l-3.53 3.53a1 1 0 0 1 0-1.41l2.82-2.83a1 1 0 1 0-1.41-1.41l-2.83 2.83a3 3 0 0 0 0 4.24L12 10.59l-1.56-1.54a4.16 4.16 0 0 0-.74-5C8.26 2.61 4.53 1 2.77 2.79S2.6 8.27 4 9.72A4.36 4.36 0 0 0 6.94 11h.14A3.9 3.9 0 0 0 9 10.46L10.57 12l-8.28 8.28a1 1 0 1 0 1.42 1.41l9-9 1.92-1.92a3 3 0 0 0 2.13.87m-8.33-3.2A1.93 1.93 0 0 1 7 9a2.26 2.26 0 0 1-1.54-.7C4.38 7.22 3.62 4.77 4.19 4.2a1 1 0 0 1 .66-.2 5.87 5.87 0 0 1 3.44 1.47 2.12 2.12 0 0 1 .14 2.97" })
), RU = h(cm), sm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 2a1 1 0 0 0-1 1v5.46l-1 .67V3a1 1 0 0 0-2 0v6.13l-1-.67V3a1 1 0 0 0-2 0v6a1 1 0 0 0 .45.83L15 11.54V21a1 1 0 0 0 2 0v-9.46l2.55-1.71A1 1 0 0 0 20 9V3a1 1 0 0 0-1-1M9 2a5 5 0 0 0-5 5v6a1 1 0 0 0 1 1h3v7a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1M8 12H6V7a3 3 0 0 1 2-2.83Z" })
), UU = h(sm), gm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16 7H8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m-1 8H9V9h6Zm6 3.28V5.72A2 2 0 1 0 18.28 3H5.72A2 2 0 1 0 3 5.72v12.56A2 2 0 1 0 5.72 21h12.56A2 2 0 1 0 21 18.28m-2 0a1.9 1.9 0 0 0-.72.72H5.72a1.9 1.9 0 0 0-.72-.72V5.72A1.9 1.9 0 0 0 5.72 5h12.56a1.9 1.9 0 0 0 .72.72Z" })
), $U = h(gm), im = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 16.18V7.82A3 3 0 1 0 16.18 4H7.82A3 3 0 1 0 4 7.82v8.36A3 3 0 1 0 7.82 20h8.36A3 3 0 1 0 20 16.18M19 4a1 1 0 1 1-1 1 1 1 0 0 1 1-1M5 4a1 1 0 1 1-1 1 1 1 0 0 1 1-1m0 16a1 1 0 1 1 1-1 1 1 0 0 1-1 1m11.18-2H7.82A3 3 0 0 0 6 16.18V7.82A3 3 0 0 0 7.82 6h8.36A3 3 0 0 0 18 7.82v8.36A3 3 0 0 0 16.18 18M19 20a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), yU = h(im), dm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 9a7 7 0 1 0-8 6.92V18h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1v-2.08A7 7 0 0 0 19 9m-7 5a5 5 0 1 1 5-5 5 5 0 0 1-5 5" })
), kU = h(dm), pm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 20h-3V9a1 1 0 0 0-1-1h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v17H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-9 0H8V4h4Zm4 0h-2V10h2Z" })
), bU = h(pm), fm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 11h-3V6a1 1 0 0 0-1-1h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v8H3a1 1 0 0 0 0 2h3v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2h3a1 1 0 0 0 1-1v-5h3a1 1 0 0 0 0-2m-9 9H8V4h4Zm4-3h-2V7h2Z" })
), TU = h(fm), Em = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0 0 2h3v17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5h3a1 1 0 0 0 1-1V4h3a1 1 0 0 0 0-2m-9 18H8V4h4Zm4-6h-2V4h2Z" })
), PU = h(Em), xm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 18h-1v-5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-3 0H6v-4h12ZM3 10h18a1 1 0 0 0 0-2h-2V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3H3a1 1 0 0 0 0 2m4-4h10v2H7Z" })
), DU = h(xm), Am = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 15h-1v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2H3a1 1 0 0 0 0 2h1v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2h1a1 1 0 0 0 0-2m-3 3H6v-4h12ZM3 8h2v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8h2a1 1 0 0 0 0-2h-2V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1H3a1 1 0 0 0 0 2m4-2h10v2H7Z" })
), qU = h(Am), Mm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 6h1v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m3 0h12v4H6Zm15 8H3a1 1 0 0 0 0 2h2v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3h2a1 1 0 0 0 0-2m-4 4H7v-2h10Z" })
), IU = h(Mm), Hm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.21 17.29a1.047 1.047 0 0 0-1.42 0 1 1 0 0 0-.21.33.94.94 0 0 0 0 .76 1.2 1.2 0 0 0 .21.33A1 1 0 0 0 10.5 18a1 1 0 0 0-.08-.38 1.2 1.2 0 0 0-.21-.33M9.5 9a3.01 3.01 0 0 0-2.598 1.5 1 1 0 1 0 1.73 1A1 1 0 1 1 9.5 13a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-.184A2.993 2.993 0 0 0 9.5 9m12.025-2.85a1 1 0 0 0-.972-.045l-3.564 1.782A3 3 0 0 0 14 5H5a3.003 3.003 0 0 0-3 3v6a3.003 3.003 0 0 0 3 3h1a1 1 0 0 0 0-2H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-.5a1 1 0 0 0 0 2h.5a3 3 0 0 0 2.989-2.888l3.564 1.782A1 1 0 0 0 22 15V7a1 1 0 0 0-.475-.85M20 13.381l-3-1.5v-1.764l3-1.5Z" })
), WU = h(Hm), Cm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m7.71 6.29-4-4a1 1 0 0 0-1.42 1.42L4.62 6A3 3 0 0 0 2 9v6a3 3 0 0 0 3 3h9a3 3 0 0 0 1.9-.69l4.39 4.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM14 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1.59l7.87 7.88A1 1 0 0 1 14 16m7.53-8.85a1 1 0 0 0-1 0L17 8.89A3 3 0 0 0 14 6h-1.34a1 1 0 0 0 0 2H14a1 1 0 0 1 1 1v1.5a2 2 0 0 0 0 .19.7.7 0 0 0 .05.2s.05.06.07.1a1 1 0 0 0 .15.21s.1.06.15.1l.17.11a.9.9 0 0 0 .23 0 .7.7 0 0 0 .14 0 2 2 0 0 0 .19 0 .7.7 0 0 0 .2-.05L20 9.62v5.72a1 1 0 1 0 2 0V8a1 1 0 0 0-.47-.85" })
), GU = h(Cm), um = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21.53 7.15a1 1 0 0 0-1 0L17 8.89A3 3 0 0 0 14 6H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h9a3 3 0 0 0 3-2.89l3.56 1.78A1 1 0 0 0 21 17a1 1 0 0 0 .53-.15A1 1 0 0 0 22 16V8a1 1 0 0 0-.47-.85M15 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1Zm5-.62-3-1.5v-1.76l3-1.5Z" })
), OU = h(um), Vm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10.17 5.236a8 8 0 0 1 .83-.158v1.27a1 1 0 1 0 2 0V5.071a6.95 6.95 0 0 1 3.95 1.98v.001l.001.001a7 7 0 0 1 1.97 3.949H18a1 1 0 0 0 0 2h.922a8 8 0 0 1-.16.827 1 1 0 0 0 .718 1.217 1 1 0 0 0 .25.032 1 1 0 0 0 .968-.75 10 10 0 0 0 .236-1.326H22a1 1 0 0 0 0-2h-1.06a8.93 8.93 0 0 0-1.912-4.614l.75-.75a1 1 0 0 0-1.414-1.414l-.753.753A8.9 8.9 0 0 0 13 3.067V1.999a1 1 0 1 0-2 0v1.066a9.5 9.5 0 0 0-1.33.236 1 1 0 0 0 .5 1.936ZM14 9.002a1 1 0 1 0 1-1 1 1 0 0 0-1 1m4.377 7.963-.007-.011-.012-.008L2.707 1.295a1 1 0 0 0-1.414 1.414l3.679 3.679a8.93 8.93 0 0 0-1.913 4.614H2a1 1 0 0 0 0 2h1.06a8.95 8.95 0 0 0 1.911 4.615l-.75.75a1 1 0 1 0 1.415 1.413l.75-.75A8.95 8.95 0 0 0 11 20.94v1.063a1 1 0 0 0 2 0V20.94a8.95 8.95 0 0 0 4.614-1.909l3.679 3.679a1 1 0 0 0 1.414-1.414ZM13 18.92v-1.917a1 1 0 0 0-2 0v1.917a7 7 0 0 1-3.945-1.96l-.005-.007-.007-.005a7 7 0 0 1-1.963-3.945H6a1 1 0 0 0 0-2h-.921a6.94 6.94 0 0 1 1.32-3.187L8.253 9.67a1.5 1.5 0 0 0 2.08 2.08l5.853 5.853A6.96 6.96 0 0 1 13 18.919Zm-4-4.917a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), NU = h(Vm), Sm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.85 2 9.09 9.77l-4.9-3.86L2.05 7v10l2.15 1.09 4.93-3.85L16.87 22 22 19.93V4ZM4.37 14.3V9.65l2.44 2.43Zm12.33 1.29L12.05 12l4.65-3.59Z" })
), QU = h(Sm), Lm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.744 13.53a5.5 5.5 0 0 0-.978-.837 7.87 7.87 0 0 0 2.859-4.471 1 1 0 1 0-1.95-.444 5.86 5.86 0 0 1-3.02 3.903V8.002a1 1 0 0 0-.044-.216 1 1 0 0 0-.035-.171 1 1 0 0 0-.167-.25c-.018-.02-.027-.048-.046-.068a1 1 0 0 0-.246-.167c-.026-.014-.045-.037-.072-.048a1 1 0 0 0-.236-.049 1 1 0 0 0-.152-.031L11.003 7H11a.995.995 0 0 0-.35 1.929v4.89a11.3 11.3 0 0 1-3.01-5.984 1 1 0 1 0-1.972.334 13.33 13.33 0 0 0 5.4 8.644 1 1 0 0 0 .128.064 1 1 0 0 0 .108.054 1 1 0 0 0 .35.071 1 1 0 0 0 .424-.102c.01-.005.021-.002.031-.007a1 1 0 0 0 .24-.176c.015-.014.024-.03.038-.045a1 1 0 0 0 .16-.237 1 1 0 0 0 .037-.087 1 1 0 0 0 .07-.346v-2.126a3.55 3.55 0 0 1 1.616 1.005l1.647 1.797a1 1 0 1 0 1.474-1.352ZM15.073 1H8.938C2.78 1 1 2.778 1 8.927v6.136C1 21.22 2.778 23 8.927 23h6.136C21.22 23 23 21.222 23 15.073V8.938C23 2.78 21.222 1 15.073 1M21 15.073c0 5.04-.888 5.927-5.937 5.927H8.927C3.887 21 3 20.112 3 15.063V8.927C3 3.887 3.888 3 8.938 3h6.135C20.113 3 21 3.888 21 8.938Z" })
), KU = h(Lm), Zm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M15.073 2H8.938C3.332 2 2 3.333 2 8.927v6.136C2 20.667 3.323 22 8.927 22h6.136C20.667 22 22 20.677 22 15.073V8.938C22 3.332 20.677 2 15.073 2m3.073 14.27h-1.459c-.552 0-.718-.447-1.708-1.437-.864-.833-1.229-.937-1.448-.937-.302 0-.385.083-.385.5v1.312c0 .355-.115.563-1.042.563a5.7 5.7 0 0 1-4.448-2.667 11.6 11.6 0 0 1-2.302-4.833c0-.219.083-.417.5-.417h1.459c.375 0 .51.167.656.552.708 2.084 1.916 3.896 2.406 3.896.188 0 .27-.083.27-.552v-2.146c-.062-.979-.582-1.062-.582-1.416a.36.36 0 0 1 .374-.334h2.292c.313 0 .417.156.417.531v2.896c0 .313.135.417.229.417.188 0 .333-.104.677-.448a12 12 0 0 0 1.792-2.98.63.63 0 0 1 .635-.416h1.459c.437 0 .53.219.437.531a18.2 18.2 0 0 1-1.958 3.365c-.157.24-.22.365 0 .646.145.219.656.646 1 1.052a6.5 6.5 0 0 1 1.229 1.708c.125.406-.084.615-.5.615" })
), jU = h(Zm), Bm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 4H4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-5-8a3 3 0 0 0-2.82 4h-2.36A3 3 0 1 0 8 15h8a3 3 0 0 0 0-6m-8 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m8 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1" })
), JU = h(Bm), Fm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18 8a4 4 0 0 0-4 4 3.9 3.9 0 0 0 .56 2H9.44a3.9 3.9 0 0 0 .56-2 4 4 0 1 0-4 4h12a4 4 0 0 0 0-8M6 14a2 2 0 1 1 2-2 2 2 0 0 1-2 2m12 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2" })
), YU = h(Fm), Rm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20.59 6.9a1 1 0 0 0-.07-.1A10 10 0 0 0 7.6 3h-.07a10 10 0 0 0-1 17.19l.33.2.1.07A9.93 9.93 0 0 0 12 22h.21a10 10 0 0 0 8.38-15.1M19 8.06a7.6 7.6 0 0 1 .65 1.46 10 10 0 0 0-3-.49.8.8 0 0 0-.31 0 9.8 9.8 0 0 0-3.58.73 7.9 7.9 0 0 1-1.84-1.6 8.16 8.16 0 0 1 8.08-.1M12 4a7.86 7.86 0 0 1 4 1.07A8 8 0 0 0 15 5a10 10 0 0 0-5.2 1.47 8 8 0 0 1-.64-1.94A7.9 7.9 0 0 1 12 4M6 6.71a8.3 8.3 0 0 1 1.33-1.19A9.9 9.9 0 0 0 12 11.61a7.9 7.9 0 0 1-.77 2.88A8 8 0 0 1 6 7zM4 12a8.1 8.1 0 0 1 .36-2.37 10 10 0 0 0 5.7 6.56 7.84 7.84 0 0 1-2.93 2.14A8 8 0 0 1 4 12m7.86 8a7.8 7.8 0 0 1-2.61-.49 9.94 9.94 0 0 0 3.23-3.22A10 10 0 0 0 14 11.41a7.7 7.7 0 0 1 1.78-.36A8 8 0 0 1 11.86 20m4.22-1.12A9.94 9.94 0 0 0 18 13a10.7 10.7 0 0 0-.18-1.88 8.3 8.3 0 0 1 2.17.7V12a8 8 0 0 1-3.91 6.87Z" })
), XU = h(Rm), Um = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.83 9.17a1 1 0 1 0-1.42 1.42A2 2 0 0 1 18 12a2 2 0 0 1-.71 1.53 1 1 0 0 0-.13 1.41 1 1 0 0 0 1.41.12A4 4 0 0 0 20 12a4.06 4.06 0 0 0-1.17-2.83m-4.4-5.07a1 1 0 0 0-1 .12L8.65 8H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.65l4.73 3.78A1 1 0 0 0 14 20a.9.9 0 0 0 .43-.1A1 1 0 0 0 15 19V5a1 1 0 0 0-.57-.9M13 16.92l-3.38-2.7A1 1 0 0 0 9 14H6v-4h3a1 1 0 0 0 .62-.22L13 7.08Z" })
), _U = h(Um), $m = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.43 4.1a1 1 0 0 0-1 .12L6.65 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.65l4.73 3.78A1 1 0 0 0 12 20a.9.9 0 0 0 .43-.1A1 1 0 0 0 13 19V5a1 1 0 0 0-.57-.9M11 16.92l-3.38-2.7A1 1 0 0 0 7 14H4v-4h3a1 1 0 0 0 .62-.22L11 7.08ZM19.91 12l1.8-1.79a1 1 0 0 0-1.42-1.42l-1.79 1.8-1.79-1.8a1 1 0 0 0-1.42 1.42l1.8 1.79-1.8 1.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.79-1.8 1.79 1.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" })
), zU = h($m), ym = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.93 4.1a1 1 0 0 0-1 .12L11.15 8H7.5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.65l4.73 3.78a1 1 0 0 0 .62.22.9.9 0 0 0 .43-.1 1 1 0 0 0 .57-.9V5a1 1 0 0 0-.57-.9M15.5 16.92l-3.38-2.7a1 1 0 0 0-.62-.22h-3v-4h3a1 1 0 0 0 .62-.22l3.38-2.7Z" })
), a$ = h(ym), km = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.43 4.1a1 1 0 0 0-1 .12L6.65 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.65l4.73 3.78A1 1 0 0 0 12 20a.9.9 0 0 0 .43-.1A1 1 0 0 0 13 19V5a1 1 0 0 0-.57-.9M11 16.92l-3.38-2.7A1 1 0 0 0 7 14H4v-4h3a1 1 0 0 0 .62-.22L11 7.08Zm4.14-12.83a1 1 0 1 0-.28 2 6 6 0 0 1 0 11.86 1 1 0 0 0 .14 2h.14a8 8 0 0 0 0-15.82Zm-.46 9.78a1 1 0 0 0 .32 2 1.1 1.1 0 0 0 .32-.05 4 4 0 0 0 0-7.54 1 1 0 0 0-.64 1.9 2 2 0 0 1 0 3.74Z" })
), t$ = h(km), bm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12.43 4.1a1 1 0 0 0-1 .12L6.65 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.65l4.73 3.78A1 1 0 0 0 12 20a.9.9 0 0 0 .43-.1A1 1 0 0 0 13 19V5a1 1 0 0 0-.57-.9M11 16.92l-3.38-2.7A1 1 0 0 0 7 14H4v-4h3a1 1 0 0 0 .62-.22L11 7.08Zm8.66-10.58a1 1 0 0 0-1.42 1.42 6 6 0 0 1-.38 8.84 1 1 0 0 0 .64 1.76 1 1 0 0 0 .64-.23 8 8 0 0 0 .52-11.79m-2.83 2.83a1 1 0 1 0-1.42 1.42A2 2 0 0 1 16 12a2 2 0 0 1-.71 1.53 1 1 0 0 0-.13 1.41 1 1 0 0 0 1.41.12A4 4 0 0 0 18 12a4.06 4.06 0 0 0-1.17-2.83" })
), e$ = h(bm), Tm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22.867 3.374a1 1 0 0 0-.866-.502l-4.97-.004h-3.652a1 1 0 0 0-.817.425l-.559.796-.564-.798a1 1 0 0 0-.816-.423H6.968l-4.973.026A1 1 0 0 0 1.137 4.4l10.02 17.106a1 1 0 0 0 .863.494 1 1 0 0 0 .864-.496l9.98-17.128a1 1 0 0 0 .003-1.002M10.105 4.868l1.085 1.533a1 1 0 0 0 .816.423h.001a1 1 0 0 0 .817-.425L13.9 4.87l1.363-.002-3.244 5.454-3.275-5.454Zm1.912 14.15L3.74 4.885l2.67-.015 4.754 7.918a1 1 0 0 0 .857.485h.006a1 1 0 0 0 .857-.489l4.708-7.916 2.67.003Z" })
), l$ = h(Tm), Pm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.03 2.443h-3.643L12.013 6.4 9.63 2.444l-2.646-.001H.831L12.03 21.558 23.168 2.443Zm-6.005 15.15L4.322 4.443h2.824l4.885 8.406 4.847-8.407h2.81Z" })
), r$ = h(Pm), Dm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 9a1 1 0 0 0 0-2h-1V5h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h3v2H3a1 1 0 0 0 0 2h1v2H3a1 1 0 0 0 0 2h3v2H3a1 1 0 0 0 0 2h1v2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2h-3v-2h3a1 1 0 0 0 0-2h-1v-2h1a1 1 0 0 0 0-2h-3V9ZM8 5h4v2H8Zm8 4v2h-4V9ZM6 9h4v2H6Zm6 4v2H8v-2Zm-2 6H6v-2h4Zm6 0h-4v-2h4Zm2-4h-4v-2h4Zm-4-8V5h4v2Z" })
), h$ = h(Dm), qm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 7h-1V6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3M5 5h10a1 1 0 0 1 1 1v1H5a1 1 0 0 1 0-2m15 10h-1a1 1 0 0 1 0-2h1Zm0-4h-1a3 3 0 0 0 0 6h1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.83A3 3 0 0 0 5 9h14a1 1 0 0 1 1 1Z" })
), o$ = h(qm), Im = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m17 8.61-1-5.77A1 1 0 0 0 15 2H9a1 1 0 0 0-1 .84L7 8.61a6 6 0 0 0 0 6.78l1 5.77A1 1 0 0 0 9 22h6a1 1 0 0 0 1-.84l1-5.77a6 6 0 0 0 0-6.78M9.85 4h4.3l.44 2.59a6 6 0 0 0-5.18 0Zm4.3 16h-4.3l-.44-2.59a6 6 0 0 0 5.18 0ZM12 16a4 4 0 1 1 4-4 4 4 0 0 1-4 4" })
), n$ = h(Im), Wm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 6.78V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v3.78A3 3 0 0 0 6 9v6a3 3 0 0 0 1 2.22V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.78A3 3 0 0 0 18 15V9a3 3 0 0 0-1-2.22M9 4h6v2H9Zm6 16H9v-2h6Zm1-5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z" })
), w$ = h(Wm), Gm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 20.29-18-18a1 1 0 0 0-1.42 1.42l4 4a12.46 12.46 0 0 0-2 6.57A7.76 7.76 0 0 0 12 22a7.64 7.64 0 0 0 5.87-2.71l2.42 2.42a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M12 20a5.76 5.76 0 0 1-5.75-5.75 10.3 10.3 0 0 1 1.47-5.11l8.74 8.73A5.67 5.67 0 0 1 12 20M10.85 5.24c.45-.42.85-.75 1.15-1 1.43 1.12 5.13 4.43 5.68 8.88a1 1 0 0 0 1 .88h.12a1 1 0 0 0 .87-1.11c-.78-6.43-6.85-10.55-7.1-10.72a1 1 0 0 0-1.12 0 19 19 0 0 0-1.96 1.61 1 1 0 0 0 1.36 1.46" })
), v$ = h(Gm), Om = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.08 7a1 1 0 0 0-1.08.92l-.35 4.55a2.67 2.67 0 0 1-1.2-.77 1 1 0 0 0-1.5 0 2.65 2.65 0 0 1-3.9 0 1 1 0 0 0-1.5 0 2.7 2.7 0 0 1-1.2.77L7 7.92A1 1 0 0 0 5.92 7 1 1 0 0 0 5 8.08l.86 11.15a3 3 0 0 0 3 2.77h6.3a3 3 0 0 0 3-2.77L19 8.08A1 1 0 0 0 18.08 7m-1.94 12.08a1 1 0 0 1-1 .92H8.85a1 1 0 0 1-1-.92L7.5 14.5a4.8 4.8 0 0 0 1.8-.79 4.66 4.66 0 0 0 5.4 0 4.8 4.8 0 0 0 1.8.79ZM12 10a3.26 3.26 0 0 0 3.25-3.25c0-2.75-2.58-4.51-2.69-4.58a1 1 0 0 0-1.12 0c-.11.08-2.69 1.83-2.69 4.58A3.26 3.26 0 0 0 12 10m0-5.7a3.6 3.6 0 0 1 1.25 2.45 1.25 1.25 0 0 1-2.5 0A3.66 3.66 0 0 1 12 4.3" })
), m$ = h(Om), Nm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M2.72 7.65a2.6 2.6 0 0 1 .56.24 4 4 0 0 0 4.1 0 2.6 2.6 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.6 2.6 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 3.9 3.9 0 0 0 2-.56 2.6 2.6 0 0 1 .56-.24 1 1 0 0 0-.56-1.92 4.5 4.5 0 0 0-1 .45 2.08 2.08 0 0 1-2.1 0 4.64 4.64 0 0 0-4.54 0 2.11 2.11 0 0 1-2.12 0 4.64 4.64 0 0 0-4.54 0 2.08 2.08 0 0 1-2.1 0 4.5 4.5 0 0 0-1-.45 1 1 0 1 0-.56 1.92Zm18 8.08a4.5 4.5 0 0 0-1 .45 2.08 2.08 0 0 1-2.1 0 4.64 4.64 0 0 0-4.54 0 2.11 2.11 0 0 1-2.12 0 4.64 4.64 0 0 0-4.54 0 2.08 2.08 0 0 1-2.1 0 4.5 4.5 0 0 0-1-.45 1 1 0 1 0-.56 1.92 2.6 2.6 0 0 1 .56.24 4 4 0 0 0 4.1 0 2.6 2.6 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.6 2.6 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 3.9 3.9 0 0 0 2-.56 2.6 2.6 0 0 1 .56-.24 1 1 0 0 0-.56-1.92Zm0-5a4.5 4.5 0 0 0-1 .45 2.08 2.08 0 0 1-2.1 0 4.64 4.64 0 0 0-4.54 0 2.11 2.11 0 0 1-2.12 0 4.64 4.64 0 0 0-4.54 0 2.08 2.08 0 0 1-2.1 0 4.5 4.5 0 0 0-1-.45 1 1 0 0 0-1.32.68 1 1 0 0 0 .68 1.24 2.6 2.6 0 0 1 .56.24 4 4 0 0 0 4.1 0 2.6 2.6 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.6 2.6 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 3.9 3.9 0 0 0 2-.56 2.6 2.6 0 0 1 .56-.24 1 1 0 0 0-.56-1.92Z" })
), c$ = h(Nm), Qm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M11 20H4V10h7Zm9 0h-7V10h7Zm0-12H4V4h16Z" })
), s$ = h(Qm), Km = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-7 18H4v-7h10Zm0-9H4V4h10Zm6 9h-4V4h4Z" })
), g$ = h(Km), jm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M8 20H4V4h4Zm12 0H10V4h10Z" })
), i$ = h(jm), Jm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-7 18H4V4h10Zm6 0h-4V4h4Z" })
), d$ = h(Jm), Ym = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 13a3 3 0 1 0-3-3 3 3 0 0 0 3 3m0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1m9.59 9.16A10 10 0 0 0 19 13.89a8 8 0 1 0-14 0 9.9 9.9 0 0 0-2.6 4.27 3 3 0 0 0 .47 2.63A3 3 0 0 0 5.3 22h13.4a3 3 0 0 0 2.42-1.21 3 3 0 0 0 .47-2.63M12 4a6 6 0 1 1-6 6 6 6 0 0 1 6-6m7.52 15.59a1 1 0 0 1-.82.41H5.3a1 1 0 0 1-.82-.41 1 1 0 0 1-.15-.87 7.85 7.85 0 0 1 1.88-3.22 8 8 0 0 0 11.58 0 7.85 7.85 0 0 1 1.88 3.22 1 1 0 0 1-.15.87" })
), p$ = h(Ym), Xm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M19 4h-1.45A3.1 3.1 0 0 0 17 3a3 3 0 0 0-2.25-1H9.27A3 3 0 0 0 7 3a3.1 3.1 0 0 0-.57 1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m-10.48.34A1 1 0 0 1 9.27 4h5.46a1 1 0 0 1 .75.34 1 1 0 0 1 .25.78l-.5 4a1 1 0 0 1-1 .88h-1.64l1.14-2.4a1 1 0 0 0-1.8-.86L10.37 10h-.6a1 1 0 0 1-1-.88l-.5-4a1 1 0 0 1 .25-.78M20 19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.37l.42 3.37a3 3 0 0 0 3 2.63h4.46a3 3 0 0 0 3-2.63L17.63 6H19a1 1 0 0 1 1 1Zm-6-3h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2" })
), f$ = h(Xm), _m = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 6.55a13 13 0 0 0-.1-1.29 4.3 4.3 0 0 0-.37-1.08 3.7 3.7 0 0 0-.71-1 3.9 3.9 0 0 0-1-.71 4.3 4.3 0 0 0-1.08-.36A10 10 0 0 0 17.46 2H6.55a13 13 0 0 0-1.29.1 4.3 4.3 0 0 0-1.08.37 3.7 3.7 0 0 0-1 .71 3.9 3.9 0 0 0-.71 1 4.3 4.3 0 0 0-.36 1.08A10 10 0 0 0 2 6.54v10.91a13 13 0 0 0 .1 1.29 4.3 4.3 0 0 0 .37 1.08 3.7 3.7 0 0 0 .71 1 3.9 3.9 0 0 0 1 .71 4.3 4.3 0 0 0 1.08.36 10 10 0 0 0 1.28.11h10.91a13 13 0 0 0 1.29-.1 4.3 4.3 0 0 0 1.08-.37 3.7 3.7 0 0 0 1-.71 3.9 3.9 0 0 0 .71-1 4.3 4.3 0 0 0 .36-1.08 10 10 0 0 0 .11-1.28V6.55M12.23 19a7.1 7.1 0 0 1-3.43-.9l-3.8 1 1-3.72a7.1 7.1 0 0 1-1-3.58 7.18 7.18 0 1 1 7.23 7.2m0-13.13A6 6 0 0 0 7.18 15l.14.23-.6 2.19L9 16.8l.22.13a6 6 0 0 0 3 .83 6 6 0 0 0 6-6 6 6 0 0 0-6-6Zm3.5 8.52a1.82 1.82 0 0 1-1.21.85 2.3 2.3 0 0 1-1.12-.07 9 9 0 0 1-1-.38 8 8 0 0 1-3.06-2.7 3.5 3.5 0 0 1-.73-1.85 2 2 0 0 1 .63-1.5.65.65 0 0 1 .48-.22H10c.11 0 .26 0 .4.31s.51 1.24.56 1.33a.34.34 0 0 1 0 .31 1.1 1.1 0 0 1-.18.3c-.09.11-.19.24-.27.32s-.18.18-.08.36a5.6 5.6 0 0 0 1 1.24 5 5 0 0 0 1.44.89c.18.09.29.08.39 0s.45-.52.57-.7.24-.15.4-.09 1.05.49 1.23.58.29.13.34.21a1.56 1.56 0 0 1-.07.78Z" })
), E$ = h(_m), zm = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M16.6 14c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.6.8-.8 1c-.1.2-.3.2-.5.1-.7-.3-1.4-.7-2-1.2-.5-.5-1-1.1-1.4-1.7-.1-.2 0-.4.1-.5s.2-.3.4-.4c.1-.1.2-.3.2-.4.1-.1.1-.3 0-.4S9.7 8.5 9.5 8c-.1-.7-.3-.7-.5-.7h-.5c-.2 0-.5.2-.6.3Q7 8.5 7 9.7c.1.9.4 1.8 1 2.6 1.1 1.6 2.5 2.9 4.2 3.7.5.2.9.4 1.4.5.5.2 1 .2 1.6.1.7-.1 1.3-.6 1.7-1.2.2-.4.2-.8.1-1.2zm2.5-9.1C15.2 1 8.9 1 5 4.9c-3.2 3.2-3.8 8.1-1.6 12L2 22l5.3-1.4c1.5.8 3.1 1.2 4.7 1.2 5.5 0 9.9-4.4 9.9-9.9.1-2.6-1-5.1-2.8-7m-2.7 14c-1.3.8-2.8 1.3-4.4 1.3-1.5 0-2.9-.4-4.2-1.1l-.3-.2-3.1.8.8-3-.2-.3c-2.4-4-1.2-9 2.7-11.5S16.6 3.7 19 7.5c2.4 3.9 1.3 9-2.6 11.4" })
), x$ = h(zm), ac = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2h-2.3l-.16.07-.17.11a.8.8 0 0 0-.13.13 1 1 0 0 0-.1.16.7.7 0 0 0-.08.18v.09L17.38 6h-1.14l-3.12-3.11a3.06 3.06 0 0 0-4.24 0L5.76 6H3a1 1 0 0 0-.87.5 1 1 0 0 0 0 1l4 7-.77 1.5A2 2 0 0 0 5 16a3 3 0 1 0 3 3 3 3 0 0 0-.85-2.08l1-2 1.38-.14 3.94 5.91A2.93 2.93 0 0 0 16 22a3.2 3.2 0 0 0 1.13-.21 3 3 0 0 0 1.87-3.3L18 13l1.79-9H21a1 1 0 0 0 0-2M5 20a1 1 0 1 1 1-1 1 1 0 0 1-1 1m5.3-15.71a1 1 0 0 1 1.4 0L13.41 6H8.59Zm-2.75 8.65L4.72 8H17l-.82 4.08Zm8.81 7a1 1 0 0 1-1.2-.38l-3.34-5 4.37-.43.81 4.69a1 1 0 0 1-.64 1.11Z" })
), A$ = h(ac), tc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M20 16.18V16a3 3 0 0 0-2-2.82V7h1a1 1 0 0 0 0-2H7a3 3 0 0 0-3-3H3a1 1 0 0 0 0 2h1a1 1 0 0 1 1 1v7.42A5 5 0 1 0 12 17a4.9 4.9 0 0 0-.42-2H17a1 1 0 0 1 1 1v.18a3 3 0 1 0 2 0M7 20a3 3 0 1 1 3-3 3 3 0 0 1-3 3m9-7h-6a4.93 4.93 0 0 0-3-1v-1h9Zm0-4H7V7h9Zm3 11a1 1 0 1 1 1-1 1 1 0 0 1-1 1M7 16a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), M$ = h(tc), ec = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 6.5a2 2 0 1 0-2-2 2 2 0 0 0 2 2m7.5 14h-1v-5a1 1 0 0 0-1-1h-5v-2h5a1 1 0 0 0 0-2h-5v-2a1 1 0 0 0-2 0v7a1 1 0 0 0 1 1h5v5a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2m-6.8-1.6a4 4 0 0 1-7.2-2.4 4 4 0 0 1 2.4-3.66A1 1 0 1 0 7.1 11a6 6 0 1 0 7.2 9.1 1 1 0 0 0-1.6-1.2" })
), H$ = h(ec), lc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8.9 17a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-3 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m6 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1M15 8.5a1 1 0 0 1 1.73 0 1 1 0 0 0 1.36.37 1 1 0 0 0 .41-1.37 3 3 0 0 0-5.2 0 1 1 0 0 0 1.7 1m7-3a7 7 0 0 0-12.12 0 1 1 0 0 0 .37 1.37 1 1 0 0 0 .45.13 1 1 0 0 0 .87-.5 5 5 0 0 1 8.66 0 1 1 0 0 0 1.37.37A1 1 0 0 0 22 5.5M17.9 14h-1v-3a1 1 0 1 0-2 0v3h-10a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h13a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3m1 5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1Z" })
), C$ = h(lc), rc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M6.92 5.51 3.71 2.29a1 1 0 0 0-1.42 1.42L4.56 6A15.2 15.2 0 0 0 1.4 8.39a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3 1 1 0 0 0 .7-.29 13 13 0 0 1 3.24-2.35L7.54 9a10.8 10.8 0 0 0-3.32 2.27 1 1 0 1 0 1.42 1.4 8.8 8.8 0 0 1 3.45-2.12l1.62 1.61a7.07 7.07 0 0 0-3.66 1.94 1 1 0 1 0 1.42 1.4A5 5 0 0 1 12 14a4 4 0 0 1 .63.05l7.66 7.66a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM12 16a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1M22.61 8.39A15 15 0 0 0 10.29 4.1a1 1 0 1 0 .22 2A13.07 13.07 0 0 1 21.2 9.81a1 1 0 0 0 1.41-1.42m-4.25 4.24a1 1 0 0 0 1.42-1.4 10.75 10.75 0 0 0-4.84-2.82 1 1 0 1 0-.52 1.92 8.94 8.94 0 0 1 3.94 2.3" })
), u$ = h(rc), hc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 15a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1m0-8a7.06 7.06 0 0 0-4.95 2.05 1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0 5 5 0 0 1 7.08 0 1 1 0 0 0 .7.3 1 1 0 0 0 .76-1.71A7.06 7.06 0 0 0 12 11m0-4a11.08 11.08 0 0 0-7.78 3.22 1 1 0 0 0 1.42 1.42 9 9 0 0 1 12.72 0 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42A11.08 11.08 0 0 0 12 7m10.61.39a15 15 0 0 0-21.22 0 1 1 0 0 0 1.42 1.42 13 13 0 0 1 18.38 0 1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42" })
), V$ = h(hc), oc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 19H7a1 1 0 0 0 0 2h5a1.013 1.013 0 0 1 1 1 1 1 0 0 0 2 0 3.003 3.003 0 0 0-3-3m2-10a1 1 0 1 0-1-1 1 1 0 0 0 1 1m4 0h2a3.003 3.003 0 0 0 3-3 1 1 0 0 0-2 0 1.013 1.013 0 0 1-1 1h-2a1 1 0 0 0 0 2m2 6h-2.161a8 8 0 0 0 1.146-2.95 1 1 0 0 0-1.305-1.117 6 6 0 0 1-1.92.317A6.06 6.06 0 0 1 9.7 5.2a7 7 0 0 1 .098-1.049A1 1 0 0 0 8.49 3.053 8.032 8.032 0 0 0 4.266 15H3a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2H6.83a6.028 6.028 0 0 1 .882-9.36 8.065 8.065 0 0 0 8.048 7.61 8 8 0 0 0 .789-.04A6 6 0 0 1 15.277 15H12a1 1 0 0 0 0 2h8a1 1 0 0 1 0 2 1 1 0 0 0 0 2 3 3 0 0 0 0-6M2.62 19.08a1.2 1.2 0 0 0-.33.21A1.03 1.03 0 0 0 2 20a.99.99 0 0 0 1.38.92 1.2 1.2 0 0 0 .33-.21A1 1 0 0 0 4 20a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21" })
), S$ = h(oc), nc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M11 4.5a1 1 0 0 0 1-1v-1a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1m-7 7a1 1 0 0 0-1-1H2a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1m.636 4.95-.707.707a1 1 0 1 0 1.414 1.414l.707-.707a1 1 0 1 0-1.414-1.414m0-9.9A1 1 0 0 0 6.05 5.136l-.707-.707a1 1 0 0 0-1.414 1.414Zm12.021.293a1 1 0 0 0 .707-.293l.707-.707a1 1 0 1 0-1.414-1.414l-.707.707a1 1 0 0 0 .707 1.707M13 12a1 1 0 0 0 1 1h5a3.003 3.003 0 0 0 3-3 1 1 0 0 0-2 0 1.013 1.013 0 0 1-1 1h-5a1 1 0 0 0-1 1m7 3h-5a1 1 0 0 0 0 2h5a1 1 0 0 1 0 2 1 1 0 0 0 0 2 3 3 0 0 0 0-6M9 19a1 1 0 1 0 1 1 1 1 0 0 0-1-1m6 0h-2a1 1 0 0 0 0 2h2a1.013 1.013 0 0 1 1 1 1 1 0 0 0 2 0 3.003 3.003 0 0 0-3-3m-4-4a3.5 3.5 0 0 1 0-7 3.4 3.4 0 0 1 2.188.774 1 1 0 1 0 1.265-1.548A5.4 5.4 0 0 0 11 6a5.5 5.5 0 0 0 0 11 1 1 0 0 0 0-2" })
), L$ = h(nc), wc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3.5 9a1 1 0 1 0-1-1 1 1 0 0 0 1 1m4 0h7a3 3 0 0 0 0-6 3.06 3.06 0 0 0-1.5.4 1 1 0 0 0-.37 1.37 1 1 0 0 0 1.37.36 1.1 1.1 0 0 1 .5-.13 1 1 0 0 1 0 2h-7a1 1 0 0 0 0 2m-4 4h7a1 1 0 0 0 0-2h-7a1 1 0 0 0 0 2m17-4a1 1 0 1 0-1-1 1 1 0 0 0 1 1m-2 2h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 0 2 1 1 0 0 0 0 2 3 3 0 0 0 0-6m-6 4h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 0 2 1.1 1.1 0 0 1-.5-.13 1 1 0 1 0-1 1.73 3.06 3.06 0 0 0 1.5.4 3 3 0 0 0 0-6m-8 0h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2" })
), Z$ = h(wc), vc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M8 20H4V4h4Zm12 0H10v-7h10Zm0-9H10V4h10Z" })
), B$ = h(vc), mc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 18H4V10h16Zm0-12H4V4h16Z" })
), F$ = h(mc), cc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M8 20H4V10h4Zm6 0h-4V10h4Zm6 0h-4V10h4Zm0-12H4V4h16Z" })
), R$ = h(cc), sc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M10 5a1 1 0 1 0 1 1 1 1 0 0 0-1-1M6 5a1 1 0 1 0 1 1 1 1 0 0 0-1-1m8 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1m6-4H4a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3m1 19a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9h18Zm0-11H3V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Z" })
), U$ = h(sc), gc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M22 2 11.2 3.6v8l10.8-.1zM10.2 12.5 2 12.4v6.8l8.1 1.1zM2 4.8v6.8h8.1V3.7zm9.1 7.7v7.9L22 22v-9.4z" })
), $$ = h(gc), ic = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.08 5 10 4.33l-3-.25V3a1 1 0 0 0-2 0v18a1 1 0 0 0 2 0v-7.08l3-.25 8.08-.67a1 1 0 0 0 .92-1V6a1 1 0 0 0-.92-1M9 11.75l-2 .16V6.09l2 .16Zm4-.34-2 .17V6.42l2 .17Zm4-.33-2 .17v-4.5l2 .17Z" })
), y$ = h(ic), dc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M17 15a1.73 1.73 0 0 1-.86-.23 3.11 3.11 0 0 0-3.27 0 1.73 1.73 0 0 1-1.73 0 3.11 3.11 0 0 0-3.27 0A1.74 1.74 0 0 1 7 15a1 1 0 0 0 0 2 3.7 3.7 0 0 0 1.9-.52 1.13 1.13 0 0 1 1.2 0 3.75 3.75 0 0 0 3.8 0 1.13 1.13 0 0 1 1.2 0A3.7 3.7 0 0 0 17 17a1 1 0 0 0 0-2m0 4a1.73 1.73 0 0 1-.86-.23 3.11 3.11 0 0 0-3.27 0 1.73 1.73 0 0 1-1.73 0 3.11 3.11 0 0 0-3.27 0A1.74 1.74 0 0 1 7 19a1 1 0 0 0 0 2 3.7 3.7 0 0 0 1.9-.52 1.13 1.13 0 0 1 1.2 0 3.75 3.75 0 0 0 3.8 0 1.13 1.13 0 0 1 1.2 0A3.7 3.7 0 0 0 17 21a1 1 0 0 0 0-2m1.42-11.79a7 7 0 0 0-13.36 1.9A4 4 0 0 0 2 13a4 4 0 0 0 1.34 3 1 1 0 0 0 .66.25 1 1 0 0 0 .75-.35 1 1 0 0 0-.09-1.41A1.93 1.93 0 0 1 4 13a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.66A3 3 0 0 1 20 12a2.93 2.93 0 0 1-.74 2 1 1 0 1 0 1.48 1.33A4.9 4.9 0 0 0 22 12a5 5 0 0 0-3.58-4.79" })
), k$ = h(dc), pc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2M3.01 12a8.96 8.96 0 0 1 .778-3.66l4.289 11.751A8.99 8.99 0 0 1 3.009 12M12 20.99a9 9 0 0 1-2.54-.366l2.698-7.839 2.763 7.572a1 1 0 0 0 .065.123 9 9 0 0 1-2.986.51m1.239-13.207c.541-.028 1.03-.085 1.03-.085a.372.372 0 0 0-.058-.741s-1.457.114-2.397.114c-.883 0-2.368-.114-2.368-.114a.372.372 0 0 0-.057.741s.459.057.943.085l1.401 3.838-1.968 5.901-3.274-9.739c.542-.028 1.03-.085 1.03-.085a.372.372 0 0 0-.058-.741s-1.456.114-2.396.114c-.169 0-.368-.004-.579-.01A8.988 8.988 0 0 1 18.071 5.37q-.057-.006-.116-.008a1.557 1.557 0 0 0-1.51 1.596 4.2 4.2 0 0 0 .883 2.109 4.74 4.74 0 0 1 .741 2.48 10.9 10.9 0 0 1-.684 2.906l-.897 2.996Zm3.281 11.987 2.746-7.94a8.5 8.5 0 0 0 .684-3.22 7 7 0 0 0-.06-.925 8.99 8.99 0 0 1-3.37 12.085" })
), b$ = h(pc), fc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3.667 12a8.33 8.33 0 0 0 4.697 7.5L4.388 8.607A8.3 8.3 0 0 0 3.667 12m8.48.729-2.501 7.265a8.34 8.34 0 0 0 5.121-.133 1 1 0 0 1-.06-.115zm5.479-1.15a4.4 4.4 0 0 0-.687-2.298 3.9 3.9 0 0 1-.819-1.954 1.443 1.443 0 0 1 1.4-1.48q.055.002.107.008a8.33 8.33 0 0 0-12.59 1.568c.196.006.38.01.537.01.871 0 2.22-.106 2.22-.106a.345.345 0 0 1 .054.687s-.452.052-.954.079l3.035 9.026 1.824-5.47-1.299-3.556c-.449-.027-.874-.08-.874-.08a.345.345 0 0 1 .053-.686s1.376.106 2.195.106c.871 0 2.221-.106 2.221-.106a.344.344 0 0 1 .053.687s-.452.052-.953.079l3.011 8.958.86-2.725c.336-.88.54-1.806.606-2.746m1.743-2.72a7.9 7.9 0 0 1-.634 2.985l-2.545 7.359a8.334 8.334 0 0 0 3.123-11.2q.056.426.056.856M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m3.659 18.662a9.39 9.39 0 0 1-8.914-.867 9.43 9.43 0 0 1-3.407-4.136 9.39 9.39 0 0 1 .867-8.914 9.43 9.43 0 0 1 4.136-3.406 9.39 9.39 0 0 1 8.914.866 9.43 9.43 0 0 1 3.407 4.136 9.39 9.39 0 0 1-.867 8.914 9.43 9.43 0 0 1-4.136 3.407" })
), T$ = h(fc), Ec = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m6 8H3a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m9.5-5H3a1 1 0 0 0 0 2h15.5a1.5 1.5 0 0 1 0 3h-3.09l.3-.29a1 1 0 0 0-1.42-1.42l-2 2a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2 2a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29h3.09a3.5 3.5 0 0 0 0-7" })
), P$ = h(Ec), xc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "m21.71 15.58-4.52-4.51a7 7 0 0 0 .14-1.4A7.67 7.67 0 0 0 6.42 2.72a1 1 0 0 0-.57.74 1 1 0 0 0 .28.88l4.35 4.34-1.8 1.8-4.34-4.35a1 1 0 0 0-.88-.27 1 1 0 0 0-.74.56 7.67 7.67 0 0 0 7 10.91 7 7 0 0 0 1.4-.14l4.51 4.52a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-4.9-4.9a1 1 0 0 0-.95-.26 6 6 0 0 1-1.48.2A5.67 5.67 0 0 1 4 9.67a6 6 0 0 1 .08-1L8 12.6a1 1 0 0 0 1.42 0l3.18-3.21a1 1 0 0 0 0-1.39L8.71 4.08a6 6 0 0 1 1-.08 5.67 5.67 0 0 1 5.66 5.67 6 6 0 0 1-.2 1.48 1 1 0 0 0 .26.95l4.9 4.9a1 1 0 0 0 1.42-1.42Z" })
), D$ = h(xc), Ac = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M14.71 7.29a1 1 0 0 0-1.42 0L11 9.59l-2.29-2.3a1 1 0 1 0-1.42 1.42L9.59 11l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L12.41 11l2.3-2.29a1 1 0 0 0 0-1.42M7 18a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3 1 1 0 0 0 0-2 5 5 0 0 0-5 5v8a5 5 0 0 0 5 5 1 1 0 0 0 0-2M18 7v6a1 1 0 0 0 2 0V7a5 5 0 0 0-5-5 1 1 0 0 0 0 2 3 3 0 0 1 3 3m3 11h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2" })
), q$ = h(Ac), Mc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M8 19a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3 1 1 0 0 0 0-2 5 5 0 0 0-5 5v8a5 5 0 0 0 5 5 1 1 0 0 0 0-2m7.71-3.29a1 1 0 0 0 0-1.42L13.41 12l2.3-2.29a1 1 0 0 0-1.42-1.42L12 10.59l-2.29-2.3a1 1 0 0 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0M16 3a1 1 0 0 0 0 2 3 3 0 0 1 3 3v8a3 3 0 0 1-3 3 1 1 0 0 0 0 2 5 5 0 0 0 5-5V8a5 5 0 0 0-5-5" })
), I$ = h(Mc), Hc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1m0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9m2.83-14.55L12 10.7 9.17 6.45a1 1 0 0 0-1.39-.28 1 1 0 0 0-.28 1.38l2.11 3.17H9a1 1 0 0 0 0 2h2l.05.08v.92H9a1 1 0 0 0 0 2h2V18a1 1 0 0 0 2 0v-2.28h2a1 1 0 0 0 0-2h-2v-.92l.05-.08H15a1 1 0 0 0 0-2h-.61l2.11-3.17a1 1 0 0 0-.28-1.38 1 1 0 0 0-1.39.28" })
), W$ = h(Hc), Cc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M18.55 2.17a1 1 0 0 0-1.38.28L12 10.2 6.83 2.45a1 1 0 0 0-1.66 1.1l5 7.45H7a1 1 0 0 0 0 2h4v2H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2h-4v-2h4a1 1 0 0 0 0-2h-3.13l5-7.45a1 1 0 0 0-.32-1.38" })
), G$ = h(Cc), uc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M12 15.5a1 1 0 1 0 1 1 1 1 0 0 0-1-1M12 2a6 6 0 0 0-.562.029A9.993 9.993 0 0 0 12 22a6 6 0 0 0 .562-.028A9.993 9.993 0 0 0 12 2m0 18A7.989 7.989 0 0 1 6.71 6.015 5.484 5.484 0 0 0 12 13a3.5 3.5 0 0 1 0 7m5.29-2.015A5.484 5.484 0 0 0 12 11a3.5 3.5 0 0 1 0-7 7.989 7.989 0 0 1 5.29 13.985M12 6.5a1 1 0 1 0 1 1 1 1 0 0 0-1-1" })
), O$ = h(uc), Vc = ({ size: a = 24, color: e = "currentColor", ...l }, r) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    height: a,
    width: a,
    fill: e,
    ref: r,
    ...l
  },
  /* @__PURE__ */ t.createElement("path", { d: "M23 9.71a8.5 8.5 0 0 0-.91-4.13 2.92 2.92 0 0 0-1.72-1A78 78 0 0 0 12 4.27a79 79 0 0 0-8.34.3 2.87 2.87 0 0 0-1.46.74c-.9.83-1 2.25-1.1 3.45a48 48 0 0 0 0 6.48 9.6 9.6 0 0 0 .3 2 3.14 3.14 0 0 0 .71 1.36 2.86 2.86 0 0 0 1.49.78 45 45 0 0 0 6.5.33c3.5.05 6.57 0 10.2-.28a2.9 2.9 0 0 0 1.53-.78 2.5 2.5 0 0 0 .61-1 10.6 10.6 0 0 0 .52-3.4c.04-.56.04-3.94.04-4.54M9.74 14.85V8.66l5.92 3.11c-1.66.92-3.85 1.96-5.92 3.08" })
), N$ = h(Vc);
export {
  Lc as Uil0Plus,
  Zc as Uil10Plus,
  Bc as Uil12Plus,
  Fc as Uil13Plus,
  Rc as Uil16Plus,
  Uc as Uil17Plus,
  $c as Uil18Plus,
  yc as Uil21Plus,
  kc as Uil3Plus,
  bc as Uil500px,
  Tc as Uil6Plus,
  Pc as UilAbacus,
  Dc as UilAccessibleIconAlt,
  Gc as UilAdjust,
  qc as UilAdjustAlt,
  Ic as UilAdjustCircle,
  Wc as UilAdjustHalf,
  Nc as UilAdobe,
  Oc as UilAdobeAlt,
  Qc as UilAirplay,
  hs as UilAlign,
  Kc as UilAlignAlt,
  _c as UilAlignCenter,
  jc as UilAlignCenterAlt,
  Jc as UilAlignCenterH,
  Yc as UilAlignCenterJustify,
  Xc as UilAlignCenterV,
  zc as UilAlignJustify,
  ts as UilAlignLeft,
  as as UilAlignLeftJustify,
  es as UilAlignLetterRight,
  rs as UilAlignRight,
  ls as UilAlignRightJustify,
  os as UilAmazon,
  ns as UilAmbulance,
  ws as UilAnalysis,
  vs as UilAnalytics,
  ms as UilAnchor,
  gs as UilAndroid,
  cs as UilAndroidAlt,
  ss as UilAndroidPhoneSlash,
  is as UilAngleDoubleDown,
  ds as UilAngleDoubleLeft,
  ps as UilAngleDoubleRight,
  fs as UilAngleDoubleUp,
  Es as UilAngleDown,
  As as UilAngleLeft,
  xs as UilAngleLeftB,
  Hs as UilAngleRight,
  Ms as UilAngleRightB,
  Cs as UilAngleUp,
  us as UilAngry,
  Vs as UilAnkh,
  Ls as UilAnnoyed,
  Ss as UilAnnoyedAlt,
  Bs as UilApple,
  Zs as UilAppleAlt,
  Fs as UilApps,
  Us as UilArchive,
  Rs as UilArchiveAlt,
  $s as UilArchway,
  tg as UilArrow,
  ys as UilArrowBreak,
  ks as UilArrowCircleDown,
  bs as UilArrowCircleLeft,
  Ts as UilArrowCircleRight,
  Ps as UilArrowCircleUp,
  Ds as UilArrowCompressH,
  Ws as UilArrowDown,
  qs as UilArrowDownLeft,
  Is as UilArrowDownRight,
  Gs as UilArrowFromRight,
  Os as UilArrowFromTop,
  Ns as UilArrowGrowth,
  Qs as UilArrowLeft,
  Ks as UilArrowRandom,
  js as UilArrowResizeDiagonal,
  Js as UilArrowRight,
  Ys as UilArrowToBottom,
  Xs as UilArrowToRight,
  ag as UilArrowUp,
  _s as UilArrowUpLeft,
  zs as UilArrowUpRight,
  lg as UilArrowsH,
  eg as UilArrowsHAlt,
  rg as UilArrowsLeftDown,
  hg as UilArrowsMaximize,
  og as UilArrowsMerge,
  vg as UilArrowsResize,
  ng as UilArrowsResizeH,
  wg as UilArrowsResizeV,
  mg as UilArrowsRightDown,
  cg as UilArrowsShrinkH,
  sg as UilArrowsShrinkV,
  gg as UilArrowsUpRight,
  dg as UilArrowsV,
  ig as UilArrowsVAlt,
  pg as UilAssistiveListeningSystems,
  fg as UilAsterisk,
  Eg as UilAt,
  xg as UilAtom,
  Ag as UilAutoFlash,
  Hg as UilAward,
  Mg as UilAwardAlt,
  Cg as UilBabyCarriage,
  ug as UilBackpack,
  Vg as UilBackspace,
  Sg as UilBackward,
  Bg as UilBag,
  Lg as UilBagAlt,
  Zg as UilBagSlash,
  Fg as UilBalanceScale,
  Rg as UilBan,
  Ug as UilBandAid,
  $g as UilBars,
  yg as UilBaseballBall,
  bg as UilBasketball,
  kg as UilBasketballHoop,
  Tg as UilBath,
  Pg as UilBatteryBolt,
  Dg as UilBatteryEmpty,
  Ig as UilBed,
  qg as UilBedDouble,
  Gg as UilBehance,
  Wg as UilBehanceAlt,
  Qg as UilBell,
  Og as UilBellSchool,
  Ng as UilBellSlash,
  Kg as UilBill,
  jg as UilBing,
  _g as UilBitcoin,
  Jg as UilBitcoinAlt,
  Yg as UilBitcoinCircle,
  Xg as UilBitcoinSign,
  zg as UilBlackBerry,
  ti as UilBlogger,
  ai as UilBloggerAlt,
  ei as UilBluetoothB,
  li as UilBold,
  oi as UilBolt,
  ri as UilBoltAlt,
  hi as UilBoltSlash,
  ci as UilBook,
  ni as UilBookAlt,
  wi as UilBookMedical,
  vi as UilBookOpen,
  mi as UilBookReader,
  gi as UilBookmark,
  si as UilBookmarkFull,
  ii as UilBooks,
  di as UilBoombox,
  pi as UilBorderAlt,
  fi as UilBorderBottom,
  Ei as UilBorderClear,
  xi as UilBorderHorizontal,
  Ai as UilBorderInner,
  Mi as UilBorderLeft,
  Hi as UilBorderOut,
  Ci as UilBorderRight,
  ui as UilBorderTop,
  Vi as UilBorderVertical,
  Si as UilBowlingBall,
  Li as UilBox,
  Zi as UilBracketsCurly,
  Bi as UilBrain,
  Ri as UilBriefcase,
  Fi as UilBriefcaseAlt,
  Ui as UilBright,
  Pi as UilBrightness,
  $i as UilBrightnessEmpty,
  yi as UilBrightnessHalf,
  ki as UilBrightnessLow,
  bi as UilBrightnessMinus,
  Ti as UilBrightnessPlus,
  Di as UilBringBottom,
  qi as UilBringFront,
  Ii as UilBrowser,
  Wi as UilBrushAlt,
  Gi as UilBug,
  Oi as UilBuilding,
  Ni as UilBullseye,
  ji as UilBus,
  Qi as UilBusAlt,
  Ki as UilBusSchool,
  Yi as UilCalculator,
  Ji as UilCalculatorAlt,
  Xi as UilCalendarAlt,
  _i as UilCalendarSlash,
  zi as UilCalender,
  ad as UilCalling,
  rd as UilCamera,
  td as UilCameraChange,
  ed as UilCameraPlus,
  ld as UilCameraSlash,
  hd as UilCancel,
  od as UilCapsule,
  nd as UilCapture,
  cd as UilCar,
  wd as UilCarSideview,
  vd as UilCarSlash,
  md as UilCarWash,
  sd as UilCardAtm,
  gd as UilCaretRight,
  id as UilCell,
  dd as UilCelsius,
  fd as UilChannel,
  pd as UilChannelAdd,
  Sd as UilChart,
  xd as UilChartBar,
  Ed as UilChartBarAlt,
  Ad as UilChartDown,
  Hd as UilChartGrowth,
  Md as UilChartGrowthAlt,
  Cd as UilChartLine,
  Vd as UilChartPie,
  ud as UilChartPieAlt,
  Bd as UilChat,
  Ld as UilChatBubbleUser,
  Zd as UilChatInfo,
  Ud as UilCheck,
  Fd as UilCheckCircle,
  Rd as UilCheckSquare,
  yd as UilCircle,
  $d as UilCircleLayer,
  kd as UilCircuit,
  bd as UilClapperBoard,
  Td as UilClinicMedical,
  Id as UilClipboard,
  Pd as UilClipboardAlt,
  Dd as UilClipboardBlank,
  qd as UilClipboardNotes,
  Jd as UilClock,
  Wd as UilClockEight,
  Gd as UilClockFive,
  Od as UilClockNine,
  Nd as UilClockSeven,
  Qd as UilClockTen,
  Kd as UilClockThree,
  jd as UilClockTwo,
  Xd as UilClosedCaptioning,
  Yd as UilClosedCaptioningSlash,
  Pp as UilCloud,
  _d as UilCloudBlock,
  zd as UilCloudBookmark,
  ap as UilCloudCheck,
  tp as UilCloudComputing,
  ep as UilCloudDataConnection,
  lp as UilCloudDatabaseTree,
  rp as UilCloudDownload,
  hp as UilCloudDrizzle,
  op as UilCloudExclamation,
  np as UilCloudHail,
  wp as UilCloudHeart,
  vp as UilCloudInfo,
  mp as UilCloudLock,
  cp as UilCloudMeatball,
  pp as UilCloudMoon,
  sp as UilCloudMoonHail,
  gp as UilCloudMoonMeatball,
  ip as UilCloudMoonRain,
  dp as UilCloudMoonShowers,
  fp as UilCloudQuestion,
  xp as UilCloudRain,
  Ep as UilCloudRainSun,
  Ap as UilCloudRedo,
  Mp as UilCloudShare,
  Hp as UilCloudShield,
  Vp as UilCloudShowers,
  Cp as UilCloudShowersAlt,
  up as UilCloudShowersHeavy,
  Sp as UilCloudSlash,
  Up as UilCloudSun,
  Lp as UilCloudSunHail,
  Zp as UilCloudSunMeatball,
  Fp as UilCloudSunRain,
  Bp as UilCloudSunRainAlt,
  Rp as UilCloudSunTear,
  $p as UilCloudTimes,
  yp as UilCloudUnlock,
  kp as UilCloudUpload,
  bp as UilCloudWifi,
  Tp as UilCloudWind,
  Dp as UilClouds,
  qp as UilClub,
  Ip as UilCodeBranch,
  Wp as UilCoffee,
  Gp as UilCog,
  Op as UilCoins,
  Np as UilColumns,
  Of as UilComment,
  Qp as UilCommentAdd,
  Ef as UilCommentAlt,
  Kp as UilCommentAltBlock,
  jp as UilCommentAltChartLines,
  Jp as UilCommentAltCheck,
  Yp as UilCommentAltDots,
  Xp as UilCommentAltDownload,
  _p as UilCommentAltEdit,
  zp as UilCommentAltExclamation,
  af as UilCommentAltHeart,
  tf as UilCommentAltImage,
  ef as UilCommentAltInfo,
  lf as UilCommentAltLines,
  rf as UilCommentAltLock,
  hf as UilCommentAltMedical,
  of as UilCommentAltMessage,
  nf as UilCommentAltNotes,
  wf as UilCommentAltPlus,
  vf as UilCommentAltQuestion,
  mf as UilCommentAltRedo,
  cf as UilCommentAltSearch,
  sf as UilCommentAltShare,
  gf as UilCommentAltShield,
  df as UilCommentAltSlash,
  pf as UilCommentAltUpload,
  ff as UilCommentAltVerify,
  xf as UilCommentBlock,
  Af as UilCommentChartLine,
  Mf as UilCommentCheck,
  Hf as UilCommentDots,
  Cf as UilCommentDownload,
  uf as UilCommentEdit,
  Vf as UilCommentExclamation,
  Sf as UilCommentHeart,
  Lf as UilCommentImage,
  Bf as UilCommentInfo,
  Zf as UilCommentInfoAlt,
  Ff as UilCommentLines,
  Rf as UilCommentLock,
  Uf as UilCommentMedical,
  $f as UilCommentMessage,
  yf as UilCommentNotes,
  kf as UilCommentPlus,
  bf as UilCommentQuestion,
  Tf as UilCommentRedo,
  Pf as UilCommentSearch,
  Df as UilCommentShare,
  qf as UilCommentShield,
  If as UilCommentSlash,
  Wf as UilCommentUpload,
  Gf as UilCommentVerify,
  Qf as UilComments,
  Nf as UilCommentsAlt,
  Kf as UilCompactDisc,
  jf as UilComparison,
  Jf as UilCompass,
  eE as UilCompress,
  Xf as UilCompressAlt,
  Yf as UilCompressAltLeft,
  _f as UilCompressArrows,
  zf as UilCompressLines,
  aE as UilCompressPoint,
  tE as UilCompressV,
  lE as UilConfused,
  rE as UilConstructor,
  nE as UilCopy,
  hE as UilCopyAlt,
  oE as UilCopyLandscape,
  wE as UilCopyright,
  vE as UilCornerDownLeft,
  cE as UilCornerDownRight,
  mE as UilCornerDownRightAlt,
  sE as UilCornerLeftDown,
  gE as UilCornerRightDown,
  dE as UilCornerUpLeft,
  iE as UilCornerUpLeftAlt,
  fE as UilCornerUpRight,
  pE as UilCornerUpRightAlt,
  EE as UilCoronavirus,
  xE as UilCreateDashboard,
  AE as UilCreativeCommonsPd,
  HE as UilCreditCard,
  ME as UilCreditCardSearch,
  CE as UilCrockery,
  SE as UilCropAlt,
  uE as UilCropAltRotateLeft,
  VE as UilCropAltRotateRight,
  ZE as UilCrosshair,
  LE as UilCrosshairAlt,
  BE as UilCrosshairs,
  FE as UilCss3Simple,
  RE as UilCube,
  UE as UilDashboard,
  $E as UilDataSharing,
  kE as UilDatabase,
  yE as UilDatabaseAlt,
  bE as UilDesert,
  IE as UilDesktop,
  PE as UilDesktopAlt,
  TE as UilDesktopAltSlash,
  DE as UilDesktopCloudAlt,
  qE as UilDesktopSlash,
  GE as UilDialpad,
  WE as UilDialpadAlt,
  OE as UilDiamond,
  QE as UilDiary,
  NE as UilDiaryAlt,
  KE as UilDiceFive,
  jE as UilDiceFour,
  JE as UilDiceOne,
  YE as UilDiceSix,
  XE as UilDiceThree,
  _E as UilDiceTwo,
  zE as UilDirection,
  ax as UilDirections,
  tx as UilDiscord,
  ex as UilDizzyMeh,
  lx as UilDna,
  rx as UilDocker,
  hx as UilDocumentInfo,
  ox as UilDocumentLayoutCenter,
  nx as UilDocumentLayoutLeft,
  wx as UilDocumentLayoutRight,
  vx as UilDollarAlt,
  cx as UilDollarSign,
  mx as UilDollarSignAlt,
  sx as UilDownloadAlt,
  gx as UilDraggabledots,
  ix as UilDribbble,
  dx as UilDrill,
  px as UilDropbox,
  fx as UilDumbbell,
  Ex as UilEar,
  Ax as UilEdit,
  xx as UilEditAlt,
  Mx as UilElipsisDoubleVAlt,
  Hx as UilEllipsisH,
  Cx as UilEllipsisV,
  ux as UilEmoji,
  Vx as UilEnglishToChinese,
  Sx as UilEnter,
  _x as UilEnvelope,
  Lx as UilEnvelopeAdd,
  Zx as UilEnvelopeAlt,
  Bx as UilEnvelopeBlock,
  Fx as UilEnvelopeBookmark,
  Rx as UilEnvelopeCheck,
  $x as UilEnvelopeDownload,
  Ux as UilEnvelopeDownloadAlt,
  yx as UilEnvelopeEdit,
  kx as UilEnvelopeExclamation,
  bx as UilEnvelopeHeart,
  Tx as UilEnvelopeInfo,
  Px as UilEnvelopeLock,
  Dx as UilEnvelopeMinus,
  qx as UilEnvelopeOpen,
  Ix as UilEnvelopeQuestion,
  Wx as UilEnvelopeReceive,
  Gx as UilEnvelopeRedo,
  Ox as UilEnvelopeSearch,
  Nx as UilEnvelopeSend,
  Qx as UilEnvelopeShare,
  Kx as UilEnvelopeShield,
  jx as UilEnvelopeStar,
  Jx as UilEnvelopeTimes,
  Xx as UilEnvelopeUpload,
  Yx as UilEnvelopeUploadAlt,
  zx as UilEnvelopes,
  aA as UilEqualCircle,
  tA as UilEstate,
  lA as UilEuro,
  eA as UilEuroCircle,
  hA as UilExchange,
  rA as UilExchangeAlt,
  vA as UilExclamation,
  oA as UilExclamationCircle,
  nA as UilExclamationOctagon,
  wA as UilExclamationTriangle,
  mA as UilExclude,
  cA as UilExit,
  sA as UilExpandAlt,
  iA as UilExpandArrows,
  gA as UilExpandArrowsAlt,
  dA as UilExpandFromCorner,
  pA as UilExpandLeft,
  fA as UilExpandRight,
  EA as UilExport,
  xA as UilExposureAlt,
  AA as UilExposureIncrease,
  MA as UilExternalLinkAlt,
  CA as UilEye,
  HA as UilEyeSlash,
  LA as UilFacebook,
  uA as UilFacebookF,
  SA as UilFacebookMessenger,
  VA as UilFacebookMessengerAlt,
  ZA as UilFahrenheit,
  FA as UilFastMail,
  BA as UilFastMailAlt,
  RA as UilFavorite,
  UA as UilFeedback,
  $A as UilFidgetSpinner,
  MM as UilFile,
  yA as UilFileAlt,
  kA as UilFileBlank,
  bA as UilFileBlockAlt,
  TA as UilFileBookmarkAlt,
  DA as UilFileCheck,
  PA as UilFileCheckAlt,
  IA as UilFileContract,
  qA as UilFileContractDollar,
  WA as UilFileCopyAlt,
  OA as UilFileDownload,
  GA as UilFileDownloadAlt,
  NA as UilFileEditAlt,
  KA as UilFileExclamation,
  QA as UilFileExclamationAlt,
  jA as UilFileExport,
  JA as UilFileGraph,
  YA as UilFileHeart,
  XA as UilFileImport,
  _A as UilFileInfoAlt,
  aM as UilFileLandscape,
  zA as UilFileLandscapeAlt,
  tM as UilFileLanscapeSlash,
  eM as UilFileLockAlt,
  rM as UilFileMedical,
  lM as UilFileMedicalAlt,
  oM as UilFileMinus,
  hM as UilFileMinusAlt,
  nM as UilFileNetwork,
  vM as UilFilePlus,
  wM as UilFilePlusAlt,
  cM as UilFileQuestion,
  mM as UilFileQuestionAlt,
  sM as UilFileRedoAlt,
  gM as UilFileSearchAlt,
  iM as UilFileShareAlt,
  dM as UilFileShieldAlt,
  pM as UilFileSlash,
  EM as UilFileTimes,
  fM as UilFileTimesAlt,
  AM as UilFileUpload,
  xM as UilFileUploadAlt,
  CM as UilFilesLandscapes,
  HM as UilFilesLandscapesAlt,
  uM as UilFilm,
  SM as UilFilter,
  VM as UilFilterSlash,
  LM as UilFire,
  BM as UilFlask,
  ZM as UilFlaskPotion,
  RM as UilFlipH,
  FM as UilFlipHAlt,
  $M as UilFlipV,
  UM as UilFlipVAlt,
  yM as UilFlower,
  TM as UilFocus,
  kM as UilFocusAdd,
  bM as UilFocusTarget,
  zM as UilFolder,
  PM as UilFolderCheck,
  DM as UilFolderDownload,
  qM as UilFolderExclamation,
  IM as UilFolderHeart,
  WM as UilFolderInfo,
  GM as UilFolderLock,
  OM as UilFolderMedical,
  NM as UilFolderMinus,
  QM as UilFolderNetwork,
  KM as UilFolderOpen,
  jM as UilFolderPlus,
  JM as UilFolderQuestion,
  YM as UilFolderSlash,
  XM as UilFolderTimes,
  _M as UilFolderUpload,
  aH as UilFont,
  lH as UilFootball,
  tH as UilFootballAmerican,
  eH as UilFootballBall,
  rH as UilForecastcloudMoonTear,
  hH as UilForwadedCall,
  oH as UilForward,
  nH as UilFrown,
  wH as UilGameStructure,
  vH as UilGift,
  cH as UilGithub,
  mH as UilGithubAlt,
  sH as UilGitlab,
  fH as UilGlass,
  dH as UilGlassMartini,
  iH as UilGlassMartiniAlt,
  gH as UilGlassMartiniAltSlash,
  pH as UilGlassTea,
  EH as UilGlobe,
  xH as UilGold,
  AH as UilGolfBall,
  SH as UilGoogle,
  HH as UilGoogleDrive,
  MH as UilGoogleDriveAlt,
  uH as UilGoogleHangouts,
  CH as UilGoogleHangoutsAlt,
  VH as UilGooglePlay,
  LH as UilGraduationCap,
  ZH as UilGraphBar,
  BH as UilGrid,
  FH as UilGrids,
  $H as UilGrin,
  UH as UilGrinTongueWink,
  RH as UilGrinTongueWinkAlt,
  yH as UilGripHorizontalLine,
  kH as UilHardHat,
  bH as UilHdd,
  DH as UilHeadSide,
  TH as UilHeadSideCough,
  PH as UilHeadSideMask,
  qH as UilHeadphoneSlash,
  WH as UilHeadphones,
  IH as UilHeadphonesAlt,
  jH as UilHeart,
  GH as UilHeartAlt,
  OH as UilHeartBreak,
  NH as UilHeartMedical,
  QH as UilHeartRate,
  KH as UilHeartSign,
  JH as UilHeartbeat,
  YH as UilHindiToChinese,
  XH as UilHipchat,
  zH as UilHistory,
  _H as UilHistoryAlt,
  tC as UilHome,
  aC as UilHomeAlt,
  eC as UilHorizontalAlignCenter,
  lC as UilHorizontalAlignLeft,
  rC as UilHorizontalAlignRight,
  hC as UilHorizontalDistributionCenter,
  oC as UilHorizontalDistributionLeft,
  nC as UilHorizontalDistributionRight,
  mC as UilHospital,
  wC as UilHospitalSquareSign,
  vC as UilHospitalSymbol,
  cC as UilHourglass,
  sC as UilHouseUser,
  iC as UilHtml3,
  gC as UilHtml3Alt,
  pC as UilHtml5,
  dC as UilHtml5Alt,
  fC as UilHunting,
  EC as UilIcons,
  xC as UilIllustration,
  qC as UilImage,
  AC as UilImageAltSlash,
  MC as UilImageBlock,
  HC as UilImageBroken,
  CC as UilImageCheck,
  uC as UilImageDownload,
  VC as UilImageEdit,
  SC as UilImageLock,
  LC as UilImageMinus,
  ZC as UilImagePlus,
  BC as UilImageQuestion,
  FC as UilImageRedo,
  RC as UilImageResizeLandscape,
  UC as UilImageResizeSquare,
  $C as UilImageSearch,
  yC as UilImageShare,
  kC as UilImageShield,
  bC as UilImageSlash,
  TC as UilImageTimes,
  PC as UilImageUpload,
  DC as UilImageV,
  IC as UilImages,
  WC as UilImport,
  GC as UilInbox,
  OC as UilIncomingCall,
  QC as UilInfo,
  NC as UilInfoCircle,
  jC as UilInstagram,
  KC as UilInstagramAlt,
  YC as UilIntercom,
  JC as UilIntercomAlt,
  XC as UilInvoice,
  _C as UilItalic,
  zC as UilJackhammer,
  au as UilJavaScript,
  tu as UilKayak,
  lu as UilKeySkeleton,
  eu as UilKeySkeletonAlt,
  nu as UilKeyboard,
  ru as UilKeyboardAlt,
  hu as UilKeyboardHide,
  ou as UilKeyboardShow,
  wu as UilKeyholeCircle,
  mu as UilKeyholeSquare,
  vu as UilKeyholeSquareFull,
  cu as UilKid,
  gu as UilLabel,
  su as UilLabelAlt,
  iu as UilLamp,
  du as UilLanguage,
  Eu as UilLaptop,
  pu as UilLaptopCloud,
  fu as UilLaptopConnection,
  xu as UilLaughing,
  Mu as UilLayerGroup,
  Au as UilLayerGroupSlash,
  uu as UilLayers,
  Hu as UilLayersAlt,
  Cu as UilLayersSlash,
  Vu as UilLeftArrowFromLeft,
  Su as UilLeftArrowToLeft,
  Zu as UilLeftIndent,
  Lu as UilLeftIndentAlt,
  Bu as UilLeftToRightTextDirection,
  Fu as UilLetterChineseA,
  Ru as UilLetterEnglishA,
  Uu as UilLetterHindiA,
  $u as UilLetterJapaneseA,
  yu as UilLifeRing,
  bu as UilLightbulb,
  ku as UilLightbulbAlt,
  Du as UilLine,
  Tu as UilLineAlt,
  Pu as UilLineSpacing,
  Ou as UilLink,
  qu as UilLinkAdd,
  Iu as UilLinkAlt,
  Wu as UilLinkBroken,
  Gu as UilLinkH,
  Qu as UilLinkedin,
  Nu as UilLinkedinAlt,
  Ku as UilLinux,
  ju as UilLiraSign,
  Yu as UilListOl,
  Ju as UilListOlAlt,
  Xu as UilListUiAlt,
  _u as UilListUl,
  aV as UilLocationArrow,
  zu as UilLocationArrowAlt,
  tV as UilLocationPinAlt,
  eV as UilLocationPoint,
  nV as UilLock,
  lV as UilLockAccess,
  rV as UilLockAlt,
  hV as UilLockOpenAlt,
  oV as UilLockSlash,
  vV as UilLottiefiles,
  wV as UilLottiefilesAlt,
  mV as UilLuggageCart,
  sV as UilMailbox,
  cV as UilMailboxAlt,
  uV as UilMap,
  MV as UilMapMarker,
  gV as UilMapMarkerAlt,
  iV as UilMapMarkerEdit,
  dV as UilMapMarkerInfo,
  pV as UilMapMarkerMinus,
  fV as UilMapMarkerPlus,
  EV as UilMapMarkerQuestion,
  xV as UilMapMarkerShield,
  AV as UilMapMarkerSlash,
  CV as UilMapPin,
  HV as UilMapPinAlt,
  VV as UilMars,
  SV as UilMasterCard,
  LV as UilMaximizeLeft,
  ZV as UilMedal,
  BV as UilMedicalDrip,
  RV as UilMedicalSquare,
  FV as UilMedicalSquareFull,
  UV as UilMediumM,
  $V as UilMedkit,
  yV as UilMeetingBoard,
  kV as UilMegaphone,
  PV as UilMeh,
  bV as UilMehAlt,
  TV as UilMehClosedEye,
  DV as UilMessage,
  qV as UilMetro,
  WV as UilMicrophone,
  IV as UilMicrophoneSlash,
  GV as UilMicroscope,
  OV as UilMicrosoft,
  JV as UilMinus,
  NV as UilMinusCircle,
  QV as UilMinusPath,
  jV as UilMinusSquare,
  KV as UilMinusSquareFull,
  YV as UilMissedCall,
  _V as UilMobileAndroid,
  XV as UilMobileAndroidAlt,
  zV as UilMobileVibrate,
  aS as UilModem,
  lS as UilMoneyBill,
  tS as UilMoneyBillSlash,
  eS as UilMoneyBillStack,
  rS as UilMoneyInsert,
  hS as UilMoneyStack,
  oS as UilMoneyWithdraw,
  nS as UilMoneyWithdrawal,
  vS as UilMoneybag,
  wS as UilMoneybagAlt,
  cS as UilMonitor,
  mS as UilMonitorHeartRate,
  gS as UilMoon,
  sS as UilMoonEclipse,
  iS as UilMoonset,
  pS as UilMountains,
  dS as UilMountainsSun,
  xS as UilMouse,
  ES as UilMouseAlt,
  fS as UilMouseAlt2,
  AS as UilMultiply,
  CS as UilMusic,
  MS as UilMusicNote,
  HS as UilMusicTuneSlash,
  uS as UilNA,
  VS as UilNavigator,
  SS as UilNerd,
  LS as UilNewspaper,
  ZS as UilNinja,
  BS as UilNoEntry,
  FS as UilNotebooks,
  RS as UilNotes,
  US as UilObjectGroup,
  $S as UilObjectUngroup,
  yS as UilOctagon,
  kS as UilOkta,
  TS as UilOpera,
  bS as UilOperaAlt,
  PS as UilOutgoingCall,
  DS as UilPackage,
  qS as UilPadlock,
  IS as UilPagelines,
  WS as UilPagerduty,
  GS as UilPaintTool,
  OS as UilPalette,
  NS as UilPanelAdd,
  KS as UilPanoramaH,
  QS as UilPanoramaHAlt,
  jS as UilPanoramaV,
  JS as UilPaperclip,
  YS as UilParagraph,
  XS as UilParcel,
  _S as UilParkingCircle,
  zS as UilParkingSquare,
  tL as UilPathfinder,
  aL as UilPathfinderUnite,
  lL as UilPause,
  eL as UilPauseCircle,
  rL as UilPaypal,
  hL as UilPen,
  oL as UilPentagon,
  nL as UilPercentage,
  gL as UilPhone,
  wL as UilPhoneAlt,
  vL as UilPhonePause,
  mL as UilPhoneSlash,
  cL as UilPhoneTimes,
  sL as UilPhoneVolume,
  iL as UilPicture,
  dL as UilPizzaSlice,
  xL as UilPlane,
  pL as UilPlaneArrival,
  fL as UilPlaneDeparture,
  EL as UilPlaneFly,
  ML as UilPlay,
  AL as UilPlayCircle,
  HL as UilPlug,
  VL as UilPlus,
  CL as UilPlusCircle,
  uL as UilPlusSquare,
  SL as UilPodium,
  LL as UilPolygon,
  ZL as UilPostStamp,
  BL as UilPostcard,
  RL as UilPound,
  FL as UilPoundCircle,
  UL as UilPower,
  $L as UilPrescriptionBottle,
  WL as UilPresentation,
  yL as UilPresentationCheck,
  kL as UilPresentationEdit,
  bL as UilPresentationLine,
  TL as UilPresentationLinesAlt,
  PL as UilPresentationMinus,
  DL as UilPresentationPlay,
  qL as UilPresentationPlus,
  IL as UilPresentationTimes,
  GL as UilPrevious,
  OL as UilPricetagAlt,
  QL as UilPrint,
  NL as UilPrintSlash,
  KL as UilProcess,
  jL as UilProcessor,
  JL as UilProgrammingLanguage,
  YL as UilPump,
  XL as UilPuzzlePiece,
  _L as UilQrcodeScan,
  aZ as UilQuestion,
  zL as UilQuestionCircle,
  tZ as UilRainbow,
  lZ as UilRaindrops,
  eZ as UilRaindropsAlt,
  rZ as UilReact,
  oZ as UilReceipt,
  hZ as UilReceiptAlt,
  nZ as UilRecordAudio,
  wZ as UilRedditAlienAlt,
  vZ as UilRedo,
  mZ as UilRefresh,
  cZ as UilRegistered,
  sZ as UilRepeat,
  gZ as UilRestaurant,
  iZ as UilRightIndentAlt,
  dZ as UilRightToLeftTextDirection,
  pZ as UilRobot,
  fZ as UilRocket,
  EZ as UilRopeWay,
  xZ as UilRotate360,
  HZ as UilRss,
  AZ as UilRssAlt,
  MZ as UilRssInterface,
  uZ as UilRuler,
  CZ as UilRulerCombined,
  VZ as UilRupeeSign,
  FZ as UilSad,
  SZ as UilSadCry,
  LZ as UilSadCrying,
  ZZ as UilSadDizzy,
  BZ as UilSadSquint,
  UZ as UilSanitizer,
  RZ as UilSanitizerAlt,
  $Z as UilSave,
  yZ as UilScalingLeft,
  kZ as UilScalingRight,
  bZ as UilScenery,
  TZ as UilSchedule,
  PZ as UilScrew,
  qZ as UilScroll,
  DZ as UilScrollH,
  OZ as UilSearch,
  IZ as UilSearchAlt,
  WZ as UilSearchMinus,
  GZ as UilSearchPlus,
  NZ as UilSelfie,
  YZ as UilServer,
  QZ as UilServerAlt,
  KZ as UilServerConnection,
  JZ as UilServerNetwork,
  jZ as UilServerNetworkAlt,
  XZ as UilServers,
  _Z as UilServicemark,
  zZ as UilSetting,
  tB as UilShare,
  aB as UilShareAlt,
  nB as UilShield,
  eB as UilShieldCheck,
  lB as UilShieldExclamation,
  rB as UilShieldPlus,
  hB as UilShieldQuestion,
  oB as UilShieldSlash,
  wB as UilShip,
  vB as UilShop,
  mB as UilShoppingBag,
  cB as UilShoppingBasket,
  gB as UilShoppingCart,
  sB as UilShoppingCartAlt,
  iB as UilShovel,
  dB as UilShrink,
  pB as UilShuffle,
  EB as UilShutter,
  fB as UilShutterAlt,
  xB as UilSick,
  AB as UilSigma,
  MB as UilSignAlt,
  HB as UilSignInAlt,
  CB as UilSignLeft,
  uB as UilSignOutAlt,
  VB as UilSignRight,
  ZB as UilSignal,
  LB as UilSignalAlt,
  SB as UilSignalAlt3,
  BB as UilSignin,
  FB as UilSignout,
  RB as UilSilence,
  UB as UilSilentSquint,
  $B as UilSimCard,
  yB as UilSitemap,
  TB as UilSkipForward,
  kB as UilSkipForwardAlt,
  bB as UilSkipForwardCircle,
  DB as UilSkype,
  PB as UilSkypeAlt,
  IB as UilSlack,
  qB as UilSlackAlt,
  GB as UilSliderH,
  WB as UilSliderHRange,
  NB as UilSlidersV,
  OB as UilSlidersVAlt,
  _B as UilSmile,
  QB as UilSmileBeam,
  KB as UilSmileDizzy,
  JB as UilSmileSquintWink,
  jB as UilSmileSquintWinkAlt,
  XB as UilSmileWink,
  YB as UilSmileWinkAlt,
  zB as UilSnapchatAlt,
  aF as UilSnapchatGhost,
  tF as UilSnapchatSquare,
  eF as UilSnowFlake,
  rF as UilSnowflake,
  lF as UilSnowflakeAlt,
  hF as UilSocialDistancing,
  wF as UilSort,
  oF as UilSortAmountDown,
  nF as UilSortAmountUp,
  vF as UilSorting,
  mF as UilSpaceKey,
  cF as UilSpade,
  sF as UilSperms,
  gF as UilSpin,
  dF as UilSpinner,
  iF as UilSpinnerAlt,
  EF as UilSquare,
  pF as UilSquareFull,
  fF as UilSquareShape,
  xF as UilSquint,
  MF as UilStar,
  AF as UilStarHalfAlt,
  uF as UilStepBackward,
  HF as UilStepBackwardAlt,
  CF as UilStepBackwardCircle,
  VF as UilStepForward,
  LF as UilStethoscope,
  SF as UilStethoscopeAlt,
  ZF as UilStopCircle,
  FF as UilStopwatch,
  BF as UilStopwatchSlash,
  $F as UilStore,
  RF as UilStoreAlt,
  UF as UilStoreSlash,
  yF as UilStreering,
  kF as UilStretcher,
  bF as UilSubject,
  PF as UilSubway,
  TF as UilSubwayAlt,
  qF as UilSuitcase,
  DF as UilSuitcaseAlt,
  IF as UilSun,
  WF as UilSunset,
  GF as UilSurprise,
  OF as UilSwatchbook,
  NF as UilSwiggy,
  QF as UilSwimmer,
  JF as UilSync,
  KF as UilSyncExclamation,
  jF as UilSyncSlash,
  YF as UilSyringe,
  _F as UilTable,
  XF as UilTableTennis,
  zF as UilTablet,
  aR as UilTablets,
  eR as UilTachometerFast,
  tR as UilTachometerFastAlt,
  rR as UilTag,
  lR as UilTagAlt,
  hR as UilTape,
  oR as UilTaxi,
  nR as UilTear,
  vR as UilTelegram,
  wR as UilTelegramAlt,
  mR as UilTelescope,
  fR as UilTemperature,
  cR as UilTemperatureEmpty,
  sR as UilTemperatureHalf,
  gR as UilTemperatureMinus,
  iR as UilTemperaturePlus,
  dR as UilTemperatureQuarter,
  pR as UilTemperatureThreeQuarter,
  ER as UilTennisBall,
  HR as UilText,
  xR as UilTextFields,
  AR as UilTextSize,
  MR as UilTextStrikeThrough,
  VR as UilTh,
  CR as UilThLarge,
  uR as UilThSlash,
  SR as UilThermometer,
  LR as UilThumbsDown,
  ZR as UilThumbsUp,
  RR as UilThunderstorm,
  BR as UilThunderstormMoon,
  FR as UilThunderstormSun,
  UR as UilTicket,
  kR as UilTimes,
  $R as UilTimesCircle,
  yR as UilTimesSquare,
  bR as UilToggleOff,
  TR as UilToggleOn,
  PR as UilToiletPaper,
  DR as UilTopArrowFromTop,
  qR as UilTopArrowToTop,
  IR as UilTornado,
  GR as UilTrademark,
  WR as UilTrademarkCircle,
  OR as UilTrafficBarrier,
  NR as UilTrafficLight,
  QR as UilTransaction,
  jR as UilTrash,
  KR as UilTrashAlt,
  JR as UilTrees,
  YR as UilTriangle,
  XR as UilTrophy,
  _R as UilTrowel,
  aU as UilTruck,
  zR as UilTruckLoading,
  lU as UilTumblr,
  tU as UilTumblrAlt,
  eU as UilTumblrSquare,
  hU as UilTvRetro,
  rU as UilTvRetroSlash,
  nU as UilTwitter,
  oU as UilTwitterAlt,
  wU as UilUmbrella,
  vU as UilUnamused,
  mU as UilUnderline,
  cU as UilUniversity,
  gU as UilUnlock,
  sU as UilUnlockAlt,
  dU as UilUpload,
  iU as UilUploadAlt,
  pU as UilUsdCircle,
  fU as UilUsdSquare,
  BU as UilUser,
  EU as UilUserArrows,
  xU as UilUserCheck,
  AU as UilUserCircle,
  MU as UilUserExclamation,
  HU as UilUserLocation,
  CU as UilUserMd,
  uU as UilUserMinus,
  VU as UilUserNurse,
  SU as UilUserPlus,
  LU as UilUserSquare,
  ZU as UilUserTimes,
  FU as UilUsersAlt,
  UU as UilUtensils,
  RU as UilUtensilsAlt,
  yU as UilVectorSquare,
  $U as UilVectorSquareAlt,
  kU as UilVenus,
  bU as UilVerticalAlignBottom,
  TU as UilVerticalAlignCenter,
  PU as UilVerticalAlignTop,
  DU as UilVerticalDistributeBottom,
  qU as UilVerticalDistributionCenter,
  IU as UilVerticalDistributionTop,
  OU as UilVideo,
  WU as UilVideoQuestion,
  GU as UilVideoSlash,
  NU as UilVirusSlash,
  QU as UilVisualStudio,
  jU as UilVk,
  KU as UilVkAlt,
  YU as UilVoicemail,
  JU as UilVoicemailRectangle,
  XU as UilVolleyball,
  e$ as UilVolume,
  _U as UilVolumeDown,
  zU as UilVolumeMute,
  a$ as UilVolumeOff,
  t$ as UilVolumeUp,
  r$ as UilVuejs,
  l$ as UilVuejsAlt,
  h$ as UilWall,
  o$ as UilWallet,
  w$ as UilWatch,
  n$ as UilWatchAlt,
  c$ as UilWater,
  v$ as UilWaterDropSlash,
  m$ as UilWaterGlass,
  g$ as UilWebGrid,
  s$ as UilWebGridAlt,
  d$ as UilWebSection,
  i$ as UilWebSectionAlt,
  p$ as UilWebcam,
  f$ as UilWeight,
  x$ as UilWhatsapp,
  E$ as UilWhatsappAlt,
  A$ as UilWheelBarrow,
  H$ as UilWheelchair,
  M$ as UilWheelchairAlt,
  V$ as UilWifi,
  C$ as UilWifiRouter,
  u$ as UilWifiSlash,
  Z$ as UilWind,
  S$ as UilWindMoon,
  L$ as UilWindSun,
  U$ as UilWindow,
  B$ as UilWindowGrid,
  F$ as UilWindowMaximize,
  R$ as UilWindowSection,
  $$ as UilWindows,
  y$ as UilWindsock,
  k$ as UilWindy,
  T$ as UilWordpress,
  b$ as UilWordpressSimple,
  P$ as UilWrapText,
  D$ as UilWrench,
  I$ as UilX,
  q$ as UilXAdd,
  G$ as UilYen,
  W$ as UilYenCircle,
  O$ as UilYinYang,
  N$ as UilYoutube
};
